webpackJsonp(["main"],{

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./projects_dropdown/components/app.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__breakpoints__ = __webpack_require__("./breakpoints.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_hub__ = __webpack_require__("./projects_dropdown/event_hub.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_shared_components_loading_icon_vue__ = __webpack_require__("./vue_shared/components/loading_icon.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_shared_components_loading_icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__vue_shared_components_loading_icon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__projects_list_frequent_vue__ = __webpack_require__("./projects_dropdown/components/projects_list_frequent.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__projects_list_frequent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__projects_list_frequent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__projects_list_search_vue__ = __webpack_require__("./projects_dropdown/components/projects_list_search.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__projects_list_search_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__projects_list_search_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__search_vue__ = __webpack_require__("./projects_dropdown/components/search.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__search_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__search_vue__);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    search: __WEBPACK_IMPORTED_MODULE_5__search_vue___default.a,
    loadingIcon: __WEBPACK_IMPORTED_MODULE_2__vue_shared_components_loading_icon_vue___default.a,
    projectsListFrequent: __WEBPACK_IMPORTED_MODULE_3__projects_list_frequent_vue___default.a,
    projectsListSearch: __WEBPACK_IMPORTED_MODULE_4__projects_list_search_vue___default.a
  },
  props: {
    currentProject: {
      type: Object,
      required: true
    },
    store: {
      type: Object,
      required: true
    },
    service: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      isLoadingProjects: false,
      isFrequentsListVisible: false,
      isSearchListVisible: false,
      isLocalStorageFailed: false,
      isSearchFailed: false,
      searchQuery: ''
    };
  },

  computed: {
    frequentProjects: function frequentProjects() {
      return this.store.getFrequentProjects();
    },
    searchProjects: function searchProjects() {
      return this.store.getSearchedProjects();
    }
  },
  methods: {
    toggleFrequentProjectsList: function toggleFrequentProjectsList(state) {
      this.isLoadingProjects = !state;
      this.isSearchListVisible = !state;
      this.isFrequentsListVisible = state;
    },
    toggleSearchProjectsList: function toggleSearchProjectsList(state) {
      this.isLoadingProjects = !state;
      this.isFrequentsListVisible = !state;
      this.isSearchListVisible = state;
    },
    toggleLoader: function toggleLoader(state) {
      this.isFrequentsListVisible = !state;
      this.isSearchListVisible = !state;
      this.isLoadingProjects = state;
    },
    fetchFrequentProjects: function fetchFrequentProjects() {
      var screenSize = __WEBPACK_IMPORTED_MODULE_0__breakpoints__["a" /* default */].getBreakpointSize();
      if (this.searchQuery && screenSize !== 'sm' && screenSize !== 'xs') {
        this.toggleSearchProjectsList(true);
      } else {
        this.toggleLoader(true);
        this.isLocalStorageFailed = false;
        var projects = this.service.getFrequentProjects();
        if (projects) {
          this.toggleFrequentProjectsList(true);
          this.store.setFrequentProjects(projects);
        } else {
          this.isLocalStorageFailed = true;
          this.toggleFrequentProjectsList(true);
          this.store.setFrequentProjects([]);
        }
      }
    },
    fetchSearchedProjects: function fetchSearchedProjects(searchQuery) {
      var _this = this;

      this.searchQuery = searchQuery;
      this.toggleLoader(true);
      this.service.getSearchedProjects(this.searchQuery).then(function (res) {
        return res.json();
      }).then(function (results) {
        _this.toggleSearchProjectsList(true);
        _this.store.setSearchedProjects(results);
      }).catch(function () {
        _this.isSearchFailed = true;
        _this.toggleSearchProjectsList(true);
      });
    },
    logCurrentProjectAccess: function logCurrentProjectAccess() {
      this.service.logProjectAccess(this.currentProject);
    },
    handleSearchClear: function handleSearchClear() {
      this.searchQuery = '';
      this.toggleFrequentProjectsList(true);
      this.store.clearSearchedProjects();
    },
    handleSearchFailure: function handleSearchFailure() {
      this.isSearchFailed = true;
      this.toggleSearchProjectsList(true);
    }
  },
  created: function created() {
    if (this.currentProject.id) {
      this.logCurrentProjectAccess();
    }

    __WEBPACK_IMPORTED_MODULE_1__event_hub__["a" /* default */].$on('dropdownOpen', this.fetchFrequentProjects);
    __WEBPACK_IMPORTED_MODULE_1__event_hub__["a" /* default */].$on('searchProjects', this.fetchSearchedProjects);
    __WEBPACK_IMPORTED_MODULE_1__event_hub__["a" /* default */].$on('searchCleared', this.handleSearchClear);
    __WEBPACK_IMPORTED_MODULE_1__event_hub__["a" /* default */].$on('searchFailed', this.handleSearchFailure);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__event_hub__["a" /* default */].$off('dropdownOpen', this.fetchFrequentProjects);
    __WEBPACK_IMPORTED_MODULE_1__event_hub__["a" /* default */].$off('searchProjects', this.fetchSearchedProjects);
    __WEBPACK_IMPORTED_MODULE_1__event_hub__["a" /* default */].$off('searchCleared', this.handleSearchClear);
    __WEBPACK_IMPORTED_MODULE_1__event_hub__["a" /* default */].$off('searchFailed', this.handleSearchFailure);
  }
});

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./projects_dropdown/components/projects_list_frequent.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__("./locale/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__projects_list_item_vue__ = __webpack_require__("./projects_dropdown/components/projects_list_item.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__projects_list_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__projects_list_item_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    projectsListItem: __WEBPACK_IMPORTED_MODULE_1__projects_list_item_vue___default.a
  },
  props: {
    projects: {
      type: Array,
      required: true
    },
    localStorageFailed: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    isListEmpty: function isListEmpty() {
      return this.projects.length === 0;
    },
    listEmptyMessage: function listEmptyMessage() {
      return this.localStorageFailed ? Object(__WEBPACK_IMPORTED_MODULE_0__locale__["s__"])('ProjectsDropdown|This feature requires browser localStorage support') : Object(__WEBPACK_IMPORTED_MODULE_0__locale__["s__"])('ProjectsDropdown|Projects you visit often will appear here');
    }
  }
});

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./projects_dropdown/components/projects_list_item.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_shared_components_identicon_vue__ = __webpack_require__("./vue_shared/components/identicon.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_shared_components_identicon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__vue_shared_components_identicon_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    identicon: __WEBPACK_IMPORTED_MODULE_0__vue_shared_components_identicon_vue___default.a
  },
  props: {
    matcher: {
      type: String,
      required: false
    },
    projectId: {
      type: Number,
      required: true
    },
    projectName: {
      type: String,
      required: true
    },
    namespace: {
      type: String,
      required: true
    },
    webUrl: {
      type: String,
      required: true
    },
    avatarUrl: {
      required: true,
      validator: function validator(value) {
        return value === null || typeof value === 'string';
      }
    }
  },
  computed: {
    hasAvatar: function hasAvatar() {
      return this.avatarUrl !== null;
    },
    highlightedProjectName: function highlightedProjectName() {
      if (this.matcher) {
        var matcherRegEx = new RegExp(this.matcher, 'gi');
        var matches = this.projectName.match(matcherRegEx);

        if (matches && matches.length > 0) {
          return this.projectName.replace(matches[0], '<b>' + matches[0] + '</b>');
        }
      }
      return this.projectName;
    }
  }
});

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./projects_dropdown/components/projects_list_search.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__("./locale/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__projects_list_item_vue__ = __webpack_require__("./projects_dropdown/components/projects_list_item.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__projects_list_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__projects_list_item_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    projectsListItem: __WEBPACK_IMPORTED_MODULE_1__projects_list_item_vue___default.a
  },
  props: {
    matcher: {
      type: String,
      required: true
    },
    projects: {
      type: Array,
      required: true
    },
    searchFailed: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    isListEmpty: function isListEmpty() {
      return this.projects.length === 0;
    },
    listEmptyMessage: function listEmptyMessage() {
      return this.searchFailed ? Object(__WEBPACK_IMPORTED_MODULE_0__locale__["s__"])('ProjectsDropdown|Something went wrong on our end.') : Object(__WEBPACK_IMPORTED_MODULE_0__locale__["s__"])('ProjectsDropdown|Sorry, no projects matched your search');
    }
  }
});

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./projects_dropdown/components/search.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_hub__ = __webpack_require__("./projects_dropdown/event_hub.js");




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      searchQuery: ''
    };
  },

  watch: {
    searchQuery: function searchQuery() {
      this.handleInput();
    }
  },
  methods: {
    setFocus: function setFocus() {
      this.$refs.search.focus();
    },
    emitSearchEvents: function emitSearchEvents() {
      if (this.searchQuery) {
        __WEBPACK_IMPORTED_MODULE_1__event_hub__["a" /* default */].$emit('searchProjects', this.searchQuery);
      } else {
        __WEBPACK_IMPORTED_MODULE_1__event_hub__["a" /* default */].$emit('searchCleared');
      }
    },

    /**
     * Callback function within _.debounce is intentionally
     * kept as ES5 `function() {}` instead of ES6 `() => {}`
     * as it otherwise messes up function context
     * and component reference is no longer accessible via `this`
     */
    // eslint-disable-next-line func-names
    handleInput: __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.debounce(function () {
      this.emitSearchEvents();
    }, 500)
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__event_hub__["a" /* default */].$on('dropdownOpen', this.setFocus);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__event_hub__["a" /* default */].$off('dropdownOpen', this.setFocus);
  }
});

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/identicon.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    entityId: {
      type: Number,
      required: true
    },
    entityName: {
      type: String,
      required: true
    },
    sizeClass: {
      type: String,
      required: false,
      default: 's40'
    }
  },
  computed: {
    /**
     * This method is based on app/helpers/application_helper.rb#project_identicon
     */
    identiconStyles: function identiconStyles() {
      var allowedColors = ['#FFEBEE', '#F3E5F5', '#E8EAF6', '#E3F2FD', '#E0F2F1', '#FBE9E7', '#EEEEEE'];

      var backgroundColor = allowedColors[this.entityId % 7];

      return 'background-color: ' + backgroundColor + '; color: #555;';
    },
    identiconTitle: function identiconTitle() {
      return this.entityName.charAt(0).toUpperCase();
    }
  }
});

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/loading_icon.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    label: {
      type: String,
      required: false,
      default: 'Loading'
    },

    size: {
      type: String,
      required: false,
      default: '1'
    },

    inline: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    rootElementType: function rootElementType() {
      return this.inline ? 'span' : 'div';
    },
    cssClass: function cssClass() {
      return 'fa-' + this.size + 'x';
    }
  }
});

/***/ }),

/***/ "../../../node_modules/clipboard/lib/clipboard-action.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__("../../../node_modules/select/src/select.js")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('select'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.select);
        global.clipboardAction = mod.exports;
    }
})(this, function (module, _select) {
    'use strict';

    var _select2 = _interopRequireDefault(_select);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    var ClipboardAction = function () {
        /**
         * @param {Object} options
         */
        function ClipboardAction(options) {
            _classCallCheck(this, ClipboardAction);

            this.resolveOptions(options);
            this.initSelection();
        }

        /**
         * Defines base properties passed from constructor.
         * @param {Object} options
         */


        _createClass(ClipboardAction, [{
            key: 'resolveOptions',
            value: function resolveOptions() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                this.action = options.action;
                this.emitter = options.emitter;
                this.target = options.target;
                this.text = options.text;
                this.trigger = options.trigger;

                this.selectedText = '';
            }
        }, {
            key: 'initSelection',
            value: function initSelection() {
                if (this.text) {
                    this.selectFake();
                } else if (this.target) {
                    this.selectTarget();
                }
            }
        }, {
            key: 'selectFake',
            value: function selectFake() {
                var _this = this;

                var isRTL = document.documentElement.getAttribute('dir') == 'rtl';

                this.removeFake();

                this.fakeHandlerCallback = function () {
                    return _this.removeFake();
                };
                this.fakeHandler = document.body.addEventListener('click', this.fakeHandlerCallback) || true;

                this.fakeElem = document.createElement('textarea');
                // Prevent zooming on iOS
                this.fakeElem.style.fontSize = '12pt';
                // Reset box model
                this.fakeElem.style.border = '0';
                this.fakeElem.style.padding = '0';
                this.fakeElem.style.margin = '0';
                // Move element out of screen horizontally
                this.fakeElem.style.position = 'absolute';
                this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
                // Move element to the same position vertically
                var yPosition = window.pageYOffset || document.documentElement.scrollTop;
                this.fakeElem.style.top = yPosition + 'px';

                this.fakeElem.setAttribute('readonly', '');
                this.fakeElem.value = this.text;

                document.body.appendChild(this.fakeElem);

                this.selectedText = (0, _select2.default)(this.fakeElem);
                this.copyText();
            }
        }, {
            key: 'removeFake',
            value: function removeFake() {
                if (this.fakeHandler) {
                    document.body.removeEventListener('click', this.fakeHandlerCallback);
                    this.fakeHandler = null;
                    this.fakeHandlerCallback = null;
                }

                if (this.fakeElem) {
                    document.body.removeChild(this.fakeElem);
                    this.fakeElem = null;
                }
            }
        }, {
            key: 'selectTarget',
            value: function selectTarget() {
                this.selectedText = (0, _select2.default)(this.target);
                this.copyText();
            }
        }, {
            key: 'copyText',
            value: function copyText() {
                var succeeded = void 0;

                try {
                    succeeded = document.execCommand(this.action);
                } catch (err) {
                    succeeded = false;
                }

                this.handleResult(succeeded);
            }
        }, {
            key: 'handleResult',
            value: function handleResult(succeeded) {
                this.emitter.emit(succeeded ? 'success' : 'error', {
                    action: this.action,
                    text: this.selectedText,
                    trigger: this.trigger,
                    clearSelection: this.clearSelection.bind(this)
                });
            }
        }, {
            key: 'clearSelection',
            value: function clearSelection() {
                if (this.target) {
                    this.target.blur();
                }

                window.getSelection().removeAllRanges();
            }
        }, {
            key: 'destroy',
            value: function destroy() {
                this.removeFake();
            }
        }, {
            key: 'action',
            set: function set() {
                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';

                this._action = action;

                if (this._action !== 'copy' && this._action !== 'cut') {
                    throw new Error('Invalid "action" value, use either "copy" or "cut"');
                }
            },
            get: function get() {
                return this._action;
            }
        }, {
            key: 'target',
            set: function set(target) {
                if (target !== undefined) {
                    if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
                        if (this.action === 'copy' && target.hasAttribute('disabled')) {
                            throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                        }

                        if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
                            throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                        }

                        this._target = target;
                    } else {
                        throw new Error('Invalid "target" value, use a valid Element');
                    }
                }
            },
            get: function get() {
                return this._target;
            }
        }]);

        return ClipboardAction;
    }();

    module.exports = ClipboardAction;
});

/***/ }),

/***/ "../../../node_modules/clipboard/lib/clipboard.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__("../../../node_modules/clipboard/lib/clipboard-action.js"), __webpack_require__("../../../node_modules/tiny-emitter/index.js"), __webpack_require__("../../../node_modules/good-listener/src/listen.js")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('./clipboard-action'), require('tiny-emitter'), require('good-listener'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.clipboardAction, global.tinyEmitter, global.goodListener);
        global.clipboard = mod.exports;
    }
})(this, function (module, _clipboardAction, _tinyEmitter, _goodListener) {
    'use strict';

    var _clipboardAction2 = _interopRequireDefault(_clipboardAction);

    var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);

    var _goodListener2 = _interopRequireDefault(_goodListener);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var Clipboard = function (_Emitter) {
        _inherits(Clipboard, _Emitter);

        /**
         * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
         * @param {Object} options
         */
        function Clipboard(trigger, options) {
            _classCallCheck(this, Clipboard);

            var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this));

            _this.resolveOptions(options);
            _this.listenClick(trigger);
            return _this;
        }

        /**
         * Defines if attributes would be resolved using internal setter functions
         * or custom functions that were passed in the constructor.
         * @param {Object} options
         */


        _createClass(Clipboard, [{
            key: 'resolveOptions',
            value: function resolveOptions() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
                this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
                this.text = typeof options.text === 'function' ? options.text : this.defaultText;
            }
        }, {
            key: 'listenClick',
            value: function listenClick(trigger) {
                var _this2 = this;

                this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {
                    return _this2.onClick(e);
                });
            }
        }, {
            key: 'onClick',
            value: function onClick(e) {
                var trigger = e.delegateTarget || e.currentTarget;

                if (this.clipboardAction) {
                    this.clipboardAction = null;
                }

                this.clipboardAction = new _clipboardAction2.default({
                    action: this.action(trigger),
                    target: this.target(trigger),
                    text: this.text(trigger),
                    trigger: trigger,
                    emitter: this
                });
            }
        }, {
            key: 'defaultAction',
            value: function defaultAction(trigger) {
                return getAttributeValue('action', trigger);
            }
        }, {
            key: 'defaultTarget',
            value: function defaultTarget(trigger) {
                var selector = getAttributeValue('target', trigger);

                if (selector) {
                    return document.querySelector(selector);
                }
            }
        }, {
            key: 'defaultText',
            value: function defaultText(trigger) {
                return getAttributeValue('text', trigger);
            }
        }, {
            key: 'destroy',
            value: function destroy() {
                this.listener.destroy();

                if (this.clipboardAction) {
                    this.clipboardAction.destroy();
                    this.clipboardAction = null;
                }
            }
        }], [{
            key: 'isSupported',
            value: function isSupported() {
                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];

                var actions = typeof action === 'string' ? [action] : action;
                var support = !!document.queryCommandSupported;

                actions.forEach(function (action) {
                    support = support && !!document.queryCommandSupported(action);
                });

                return support;
            }
        }]);

        return Clipboard;
    }(_tinyEmitter2.default);

    /**
     * Helper function to retrieve attribute value.
     * @param {String} suffix
     * @param {Element} element
     */
    function getAttributeValue(suffix, element) {
        var attribute = 'data-clipboard-' + suffix;

        if (!element.hasAttribute(attribute)) {
            return;
        }

        return element.getAttribute(attribute);
    }

    module.exports = Clipboard;
});

/***/ }),

/***/ "../../../node_modules/deckar01-task_list/dist/task_list.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["TaskList"] = factory();
	else
		root["TaskList"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var NodeArray, TaskList, closest, createEvent,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

NodeArray = function(nodeList) {
  return Array.prototype.slice.apply(nodeList);
};

closest = function(el, className) {
  while (el && !el.classList.contains(className)) {
    el = el.parentNode;
  }
  return el;
};

createEvent = function(eventName, detail) {
  var event;
  if (typeof Event === 'function') {
    event = new Event(eventName, {
      bubbles: true,
      cancelable: true
    });
    event.detail = detail;
  } else {
    event = document.createEvent('CustomEvent');
    event.initCustomEvent(eventName, true, true, detail);
  }
  return event;
};

TaskList = (function() {
  function TaskList(el1) {
    this.el = el1;
    this.container = closest(this.el, 'js-task-list-container');
    this.field = this.container.querySelector('.js-task-list-field');
    this.container.addEventListener('change', (function(_this) {
      return function(event) {
        if (event.target.classList.contains('task-list-item-checkbox')) {
          return _this.updateTaskList(event.target);
        }
      };
    })(this));
    this.enable();
  }

  TaskList.prototype.enable = function() {
    var event;
    if (this.container.querySelectorAll('.js-task-list-field').length > 0) {
      NodeArray(this.container.querySelectorAll('.task-list-item')).forEach(function(item) {
        return item.classList.add('enabled');
      });
      NodeArray(this.container.querySelectorAll('.task-list-item-checkbox')).forEach(function(checkbox) {
        return checkbox.disabled = false;
      });
      this.container.classList.add('is-task-list-enabled');
      event = createEvent('tasklist:enabled');
      return this.container.dispatchEvent(event);
    }
  };

  TaskList.prototype.disable = function() {
    var event;
    NodeArray(this.container.querySelectorAll('.task-list-item')).forEach(function(item) {
      return item.classList.remove('enabled');
    });
    NodeArray(this.container.querySelectorAll('.task-list-item-checkbox')).forEach(function(checkbox) {
      return checkbox.disabled = true;
    });
    this.container.classList.remove('is-task-list-enabled');
    event = createEvent('tasklist:disabled');
    return this.container.dispatchEvent(event);
  };

  TaskList.prototype.updateTaskList = function(item) {
    var changeEvent, changedEvent, checkboxes, index;
    checkboxes = this.container.querySelectorAll('.task-list-item-checkbox');
    index = 1 + NodeArray(checkboxes).indexOf(item);
    changeEvent = createEvent('tasklist:change', {
      index: index,
      checked: item.checked
    });
    this.field.dispatchEvent(changeEvent);
    if (!changeEvent.defaultPrevented) {
      this.field.value = TaskList.updateSource(this.field.value, index, item.checked);
      changeEvent = createEvent('change');
      this.field.dispatchEvent(changeEvent);
      changedEvent = createEvent('tasklist:changed', {
        index: index,
        checked: item.checked
      });
      return this.field.dispatchEvent(changedEvent);
    }
  };

  TaskList.incomplete = "[ ]";

  TaskList.complete = "[x]";

  TaskList.escapePattern = function(str) {
    return str.replace(/([\[\]])/g, "\\$1").replace(/\s/, "\\s").replace("x", "[xX]");
  };

  TaskList.incompletePattern = RegExp("" + (TaskList.escapePattern(TaskList.incomplete)));

  TaskList.completePattern = RegExp("" + (TaskList.escapePattern(TaskList.complete)));

  TaskList.itemPattern = RegExp("^(?:\\s*(?:>\\s*)*(?:[-+*]|(?:\\d+\\.)))\\s*(" + (TaskList.escapePattern(TaskList.complete)) + "|" + (TaskList.escapePattern(TaskList.incomplete)) + ")\\s+(?!\\(.*?\\))(?=(?:\\[.*?\\]\\s*(?:\\[.*?\\]|\\(.*?\\))\\s*)*(?:[^\\[]|$))");

  TaskList.startFencesPattern = /^`{3}.*$/;

  TaskList.endFencesPattern = /^`{3}$/;

  TaskList.itemsInParasPattern = RegExp("^(" + (TaskList.escapePattern(TaskList.complete)) + "|" + (TaskList.escapePattern(TaskList.incomplete)) + ").+$", "g");

  TaskList.updateSource = function(source, itemIndex, checked) {
    var clean, inCodeBlock, index, line, result;
    clean = source.replace(/\r/g, '').replace(this.itemsInParasPattern, '').split("\n");
    index = 0;
    inCodeBlock = false;
    result = (function() {
      var i, len, ref, results;
      ref = source.split("\n");
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        line = ref[i];
        if (inCodeBlock) {
          if (line.match(this.endFencesPattern)) {
            inCodeBlock = false;
          }
        } else if (line.match(this.startFencesPattern)) {
          inCodeBlock = true;
        } else if (indexOf.call(clean, line) >= 0 && line.match(this.itemPattern)) {
          index += 1;
          if (index === itemIndex) {
            line = checked ? line.replace(this.incompletePattern, this.complete) : line.replace(this.completePattern, this.incomplete);
          }
        }
        results.push(line);
      }
      return results;
    }).call(this);
    return result.join("\n");
  };

  return TaskList;

})();

if (typeof jQuery !== 'undefined') {
  jQuery.fn.taskList = function(method) {
    return this.each(function(index, el) {
      var taskList;
      taskList = jQuery(el).data('task-list');
      if (!taskList) {
        taskList = new TaskList(el);
        jQuery(el).data('task-list', taskList);
        if (!method || method === 'enable') {
          return;
        }
      }
      return taskList[method || 'enable']();
    });
  };
}

module.exports = TaskList;


/***/ })
/******/ ]);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "../../../node_modules/delegate/src/closest.js":
/***/ (function(module, exports) {

var DOCUMENT_NODE_TYPE = 9;

/**
 * A polyfill for Element.matches()
 */
if (typeof Element !== 'undefined' && !Element.prototype.matches) {
    var proto = Element.prototype;

    proto.matches = proto.matchesSelector ||
                    proto.mozMatchesSelector ||
                    proto.msMatchesSelector ||
                    proto.oMatchesSelector ||
                    proto.webkitMatchesSelector;
}

/**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */
function closest (element, selector) {
    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
        if (element.matches(selector)) return element;
        element = element.parentNode;
    }
}

module.exports = closest;


/***/ }),

/***/ "../../../node_modules/delegate/src/delegate.js":
/***/ (function(module, exports, __webpack_require__) {

var closest = __webpack_require__("../../../node_modules/delegate/src/closest.js");

/**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function delegate(element, selector, type, callback, useCapture) {
    var listenerFn = listener.apply(this, arguments);

    element.addEventListener(type, listenerFn, useCapture);

    return {
        destroy: function() {
            element.removeEventListener(type, listenerFn, useCapture);
        }
    }
}

/**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */
function listener(element, selector, type, callback) {
    return function(e) {
        e.delegateTarget = closest(e.target, selector);

        if (e.delegateTarget) {
            callback.call(element, e);
        }
    }
}

module.exports = delegate;


/***/ }),

/***/ "../../../node_modules/document-register-element/build/document-register-element.node.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*!

Copyright (C) 2014-2016 by Andrea Giammarchi - @WebReflection

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/
// global window Object
// optional polyfill info
//    'auto' used by default, everything is feature detected
//    'force' use the polyfill even if not fully needed
function installCustomElements(window, polyfill) {'use strict';

  // DO NOT USE THIS FILE DIRECTLY, IT WON'T WORK
  // THIS IS A PROJECT BASED ON A BUILD SYSTEM
  // THIS FILE IS JUST WRAPPED UP RESULTING IN
  // build/document-register-element.node.js

  var
    document = window.document,
    Object = window.Object
  ;

  var htmlClass = (function (info) {
    // (C) Andrea Giammarchi - @WebReflection - MIT Style
    var
      catchClass = /^[A-Z]+[a-z]/,
      filterBy = function (re) {
        var arr = [], tag;
        for (tag in register) {
          if (re.test(tag)) arr.push(tag);
        }
        return arr;
      },
      add = function (Class, tag) {
        tag = tag.toLowerCase();
        if (!(tag in register)) {
          register[Class] = (register[Class] || []).concat(tag);
          register[tag] = (register[tag.toUpperCase()] = Class);
        }
      },
      register = (Object.create || Object)(null),
      htmlClass = {},
      i, section, tags, Class
    ;
    for (section in info) {
      for (Class in info[section]) {
        tags = info[section][Class];
        register[Class] = tags;
        for (i = 0; i < tags.length; i++) {
          register[tags[i].toLowerCase()] =
          register[tags[i].toUpperCase()] = Class;
        }
      }
    }
    htmlClass.get = function get(tagOrClass) {
      return typeof tagOrClass === 'string' ?
        (register[tagOrClass] || (catchClass.test(tagOrClass) ? [] : '')) :
        filterBy(tagOrClass);
    };
    htmlClass.set = function set(tag, Class) {
      return (catchClass.test(tag) ?
        add(tag, Class) :
        add(Class, tag)
      ), htmlClass;
    };
    return htmlClass;
  }({
    "collections": {
      "HTMLAllCollection": [
        "all"
      ],
      "HTMLCollection": [
        "forms"
      ],
      "HTMLFormControlsCollection": [
        "elements"
      ],
      "HTMLOptionsCollection": [
        "options"
      ]
    },
    "elements": {
      "Element": [
        "element"
      ],
      "HTMLAnchorElement": [
        "a"
      ],
      "HTMLAppletElement": [
        "applet"
      ],
      "HTMLAreaElement": [
        "area"
      ],
      "HTMLAttachmentElement": [
        "attachment"
      ],
      "HTMLAudioElement": [
        "audio"
      ],
      "HTMLBRElement": [
        "br"
      ],
      "HTMLBaseElement": [
        "base"
      ],
      "HTMLBodyElement": [
        "body"
      ],
      "HTMLButtonElement": [
        "button"
      ],
      "HTMLCanvasElement": [
        "canvas"
      ],
      "HTMLContentElement": [
        "content"
      ],
      "HTMLDListElement": [
        "dl"
      ],
      "HTMLDataElement": [
        "data"
      ],
      "HTMLDataListElement": [
        "datalist"
      ],
      "HTMLDetailsElement": [
        "details"
      ],
      "HTMLDialogElement": [
        "dialog"
      ],
      "HTMLDirectoryElement": [
        "dir"
      ],
      "HTMLDivElement": [
        "div"
      ],
      "HTMLDocument": [
        "document"
      ],
      "HTMLElement": [
        "element",
        "abbr",
        "address",
        "article",
        "aside",
        "b",
        "bdi",
        "bdo",
        "cite",
        "code",
        "command",
        "dd",
        "dfn",
        "dt",
        "em",
        "figcaption",
        "figure",
        "footer",
        "header",
        "i",
        "kbd",
        "mark",
        "nav",
        "noscript",
        "rp",
        "rt",
        "ruby",
        "s",
        "samp",
        "section",
        "small",
        "strong",
        "sub",
        "summary",
        "sup",
        "u",
        "var",
        "wbr"
      ],
      "HTMLEmbedElement": [
        "embed"
      ],
      "HTMLFieldSetElement": [
        "fieldset"
      ],
      "HTMLFontElement": [
        "font"
      ],
      "HTMLFormElement": [
        "form"
      ],
      "HTMLFrameElement": [
        "frame"
      ],
      "HTMLFrameSetElement": [
        "frameset"
      ],
      "HTMLHRElement": [
        "hr"
      ],
      "HTMLHeadElement": [
        "head"
      ],
      "HTMLHeadingElement": [
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6"
      ],
      "HTMLHtmlElement": [
        "html"
      ],
      "HTMLIFrameElement": [
        "iframe"
      ],
      "HTMLImageElement": [
        "img"
      ],
      "HTMLInputElement": [
        "input"
      ],
      "HTMLKeygenElement": [
        "keygen"
      ],
      "HTMLLIElement": [
        "li"
      ],
      "HTMLLabelElement": [
        "label"
      ],
      "HTMLLegendElement": [
        "legend"
      ],
      "HTMLLinkElement": [
        "link"
      ],
      "HTMLMapElement": [
        "map"
      ],
      "HTMLMarqueeElement": [
        "marquee"
      ],
      "HTMLMediaElement": [
        "media"
      ],
      "HTMLMenuElement": [
        "menu"
      ],
      "HTMLMenuItemElement": [
        "menuitem"
      ],
      "HTMLMetaElement": [
        "meta"
      ],
      "HTMLMeterElement": [
        "meter"
      ],
      "HTMLModElement": [
        "del",
        "ins"
      ],
      "HTMLOListElement": [
        "ol"
      ],
      "HTMLObjectElement": [
        "object"
      ],
      "HTMLOptGroupElement": [
        "optgroup"
      ],
      "HTMLOptionElement": [
        "option"
      ],
      "HTMLOutputElement": [
        "output"
      ],
      "HTMLParagraphElement": [
        "p"
      ],
      "HTMLParamElement": [
        "param"
      ],
      "HTMLPictureElement": [
        "picture"
      ],
      "HTMLPreElement": [
        "pre"
      ],
      "HTMLProgressElement": [
        "progress"
      ],
      "HTMLQuoteElement": [
        "blockquote",
        "q",
        "quote"
      ],
      "HTMLScriptElement": [
        "script"
      ],
      "HTMLSelectElement": [
        "select"
      ],
      "HTMLShadowElement": [
        "shadow"
      ],
      "HTMLSlotElement": [
        "slot"
      ],
      "HTMLSourceElement": [
        "source"
      ],
      "HTMLSpanElement": [
        "span"
      ],
      "HTMLStyleElement": [
        "style"
      ],
      "HTMLTableCaptionElement": [
        "caption"
      ],
      "HTMLTableCellElement": [
        "td",
        "th"
      ],
      "HTMLTableColElement": [
        "col",
        "colgroup"
      ],
      "HTMLTableElement": [
        "table"
      ],
      "HTMLTableRowElement": [
        "tr"
      ],
      "HTMLTableSectionElement": [
        "thead",
        "tbody",
        "tfoot"
      ],
      "HTMLTemplateElement": [
        "template"
      ],
      "HTMLTextAreaElement": [
        "textarea"
      ],
      "HTMLTimeElement": [
        "time"
      ],
      "HTMLTitleElement": [
        "title"
      ],
      "HTMLTrackElement": [
        "track"
      ],
      "HTMLUListElement": [
        "ul"
      ],
      "HTMLUnknownElement": [
        "unknown",
        "vhgroupv",
        "vkeygen"
      ],
      "HTMLVideoElement": [
        "video"
      ]
    },
    "nodes": {
      "Attr": [
        "node"
      ],
      "Audio": [
        "audio"
      ],
      "CDATASection": [
        "node"
      ],
      "CharacterData": [
        "node"
      ],
      "Comment": [
        "#comment"
      ],
      "Document": [
        "#document"
      ],
      "DocumentFragment": [
        "#document-fragment"
      ],
      "DocumentType": [
        "node"
      ],
      "HTMLDocument": [
        "#document"
      ],
      "Image": [
        "img"
      ],
      "Option": [
        "option"
      ],
      "ProcessingInstruction": [
        "node"
      ],
      "ShadowRoot": [
        "#shadow-root"
      ],
      "Text": [
        "#text"
      ],
      "XMLDocument": [
        "xml"
      ]
    }
  }));
  
  
    
  // passed at runtime, configurable
  // via nodejs module
  if (!polyfill) polyfill = 'auto';
  
  var
    // V0 polyfill entry
    REGISTER_ELEMENT = 'registerElement',
  
    // IE < 11 only + old WebKit for attributes + feature detection
    EXPANDO_UID = '__' + REGISTER_ELEMENT + (window.Math.random() * 10e4 >> 0),
  
    // shortcuts and costants
    ADD_EVENT_LISTENER = 'addEventListener',
    ATTACHED = 'attached',
    CALLBACK = 'Callback',
    DETACHED = 'detached',
    EXTENDS = 'extends',
  
    ATTRIBUTE_CHANGED_CALLBACK = 'attributeChanged' + CALLBACK,
    ATTACHED_CALLBACK = ATTACHED + CALLBACK,
    CONNECTED_CALLBACK = 'connected' + CALLBACK,
    DISCONNECTED_CALLBACK = 'disconnected' + CALLBACK,
    CREATED_CALLBACK = 'created' + CALLBACK,
    DETACHED_CALLBACK = DETACHED + CALLBACK,
  
    ADDITION = 'ADDITION',
    MODIFICATION = 'MODIFICATION',
    REMOVAL = 'REMOVAL',
  
    DOM_ATTR_MODIFIED = 'DOMAttrModified',
    DOM_CONTENT_LOADED = 'DOMContentLoaded',
    DOM_SUBTREE_MODIFIED = 'DOMSubtreeModified',
  
    PREFIX_TAG = '<',
    PREFIX_IS = '=',
  
    // valid and invalid node names
    validName = /^[A-Z][A-Z0-9]*(?:-[A-Z0-9]+)+$/,
    invalidNames = [
      'ANNOTATION-XML',
      'COLOR-PROFILE',
      'FONT-FACE',
      'FONT-FACE-SRC',
      'FONT-FACE-URI',
      'FONT-FACE-FORMAT',
      'FONT-FACE-NAME',
      'MISSING-GLYPH'
    ],
  
    // registered types and their prototypes
    types = [],
    protos = [],
  
    // to query subnodes
    query = '',
  
    // html shortcut used to feature detect
    documentElement = document.documentElement,
  
    // ES5 inline helpers || basic patches
    indexOf = types.indexOf || function (v) {
      for(var i = this.length; i-- && this[i] !== v;){}
      return i;
    },
  
    // other helpers / shortcuts
    OP = Object.prototype,
    hOP = OP.hasOwnProperty,
    iPO = OP.isPrototypeOf,
  
    defineProperty = Object.defineProperty,
    empty = [],
    gOPD = Object.getOwnPropertyDescriptor,
    gOPN = Object.getOwnPropertyNames,
    gPO = Object.getPrototypeOf,
    sPO = Object.setPrototypeOf,
  
    // jshint proto: true
    hasProto = !!Object.__proto__,
  
    // V1 helpers
    fixGetClass = false,
    DRECEV1 = '__dreCEv1',
    customElements = window.customElements,
    usableCustomElements = polyfill !== 'force' && !!(
      customElements &&
      customElements.define &&
      customElements.get &&
      customElements.whenDefined
    ),
    Dict = Object.create || Object,
    Map = window.Map || function Map() {
      var K = [], V = [], i;
      return {
        get: function (k) {
          return V[indexOf.call(K, k)];
        },
        set: function (k, v) {
          i = indexOf.call(K, k);
          if (i < 0) V[K.push(k) - 1] = v;
          else V[i] = v;
        }
      };
    },
    Promise = window.Promise || function (fn) {
      var
        notify = [],
        done = false,
        p = {
          'catch': function () {
            return p;
          },
          'then': function (cb) {
            notify.push(cb);
            if (done) setTimeout(resolve, 1);
            return p;
          }
        }
      ;
      function resolve(value) {
        done = true;
        while (notify.length) notify.shift()(value);
      }
      fn(resolve);
      return p;
    },
    justCreated = false,
    constructors = Dict(null),
    waitingList = Dict(null),
    nodeNames = new Map(),
    secondArgument = String,
  
    // used to create unique instances
    create = Object.create || function Bridge(proto) {
      // silly broken polyfill probably ever used but short enough to work
      return proto ? ((Bridge.prototype = proto), new Bridge()) : this;
    },
  
    // will set the prototype if possible
    // or copy over all properties
    setPrototype = sPO || (
      hasProto ?
        function (o, p) {
          o.__proto__ = p;
          return o;
        } : (
      (gOPN && gOPD) ?
        (function(){
          function setProperties(o, p) {
            for (var
              key,
              names = gOPN(p),
              i = 0, length = names.length;
              i < length; i++
            ) {
              key = names[i];
              if (!hOP.call(o, key)) {
                defineProperty(o, key, gOPD(p, key));
              }
            }
          }
          return function (o, p) {
            do {
              setProperties(o, p);
            } while ((p = gPO(p)) && !iPO.call(p, o));
            return o;
          };
        }()) :
        function (o, p) {
          for (var key in p) {
            o[key] = p[key];
          }
          return o;
        }
    )),
  
    // DOM shortcuts and helpers, if any
  
    MutationObserver = window.MutationObserver ||
                       window.WebKitMutationObserver,
  
    HTMLElementPrototype = (
      window.HTMLElement ||
      window.Element ||
      window.Node
    ).prototype,
  
    IE8 = !iPO.call(HTMLElementPrototype, documentElement),
  
    safeProperty = IE8 ? function (o, k, d) {
      o[k] = d.value;
      return o;
    } : defineProperty,
  
    isValidNode = IE8 ?
      function (node) {
        return node.nodeType === 1;
      } :
      function (node) {
        return iPO.call(HTMLElementPrototype, node);
      },
  
    targets = IE8 && [],
  
    attachShadow = HTMLElementPrototype.attachShadow,
    cloneNode = HTMLElementPrototype.cloneNode,
    dispatchEvent = HTMLElementPrototype.dispatchEvent,
    getAttribute = HTMLElementPrototype.getAttribute,
    hasAttribute = HTMLElementPrototype.hasAttribute,
    removeAttribute = HTMLElementPrototype.removeAttribute,
    setAttribute = HTMLElementPrototype.setAttribute,
  
    // replaced later on
    createElement = document.createElement,
    patchedCreateElement = createElement,
  
    // shared observer for all attributes
    attributesObserver = MutationObserver && {
      attributes: true,
      characterData: true,
      attributeOldValue: true
    },
  
    // useful to detect only if there's no MutationObserver
    DOMAttrModified = MutationObserver || function(e) {
      doesNotSupportDOMAttrModified = false;
      documentElement.removeEventListener(
        DOM_ATTR_MODIFIED,
        DOMAttrModified
      );
    },
  
    // will both be used to make DOMNodeInserted asynchronous
    asapQueue,
    asapTimer = 0,
  
    // internal flags
    setListener = false,
    doesNotSupportDOMAttrModified = true,
    dropDomContentLoaded = true,
  
    // needed for the innerHTML helper
    notFromInnerHTMLHelper = true,
  
    // optionally defined later on
    onSubtreeModified,
    callDOMAttrModified,
    getAttributesMirror,
    observer,
    observe,
  
    // based on setting prototype capability
    // will check proto or the expando attribute
    // in order to setup the node once
    patchIfNotAlready,
    patch
  ;
  
  // only if needed
  if (!(REGISTER_ELEMENT in document)) {
  
    if (sPO || hasProto) {
        patchIfNotAlready = function (node, proto) {
          if (!iPO.call(proto, node)) {
            setupNode(node, proto);
          }
        };
        patch = setupNode;
    } else {
        patchIfNotAlready = function (node, proto) {
          if (!node[EXPANDO_UID]) {
            node[EXPANDO_UID] = Object(true);
            setupNode(node, proto);
          }
        };
        patch = patchIfNotAlready;
    }
  
    if (IE8) {
      doesNotSupportDOMAttrModified = false;
      (function (){
        var
          descriptor = gOPD(HTMLElementPrototype, ADD_EVENT_LISTENER),
          addEventListener = descriptor.value,
          patchedRemoveAttribute = function (name) {
            var e = new CustomEvent(DOM_ATTR_MODIFIED, {bubbles: true});
            e.attrName = name;
            e.prevValue = getAttribute.call(this, name);
            e.newValue = null;
            e[REMOVAL] = e.attrChange = 2;
            removeAttribute.call(this, name);
            dispatchEvent.call(this, e);
          },
          patchedSetAttribute = function (name, value) {
            var
              had = hasAttribute.call(this, name),
              old = had && getAttribute.call(this, name),
              e = new CustomEvent(DOM_ATTR_MODIFIED, {bubbles: true})
            ;
            setAttribute.call(this, name, value);
            e.attrName = name;
            e.prevValue = had ? old : null;
            e.newValue = value;
            if (had) {
              e[MODIFICATION] = e.attrChange = 1;
            } else {
              e[ADDITION] = e.attrChange = 0;
            }
            dispatchEvent.call(this, e);
          },
          onPropertyChange = function (e) {
            // jshint eqnull:true
            var
              node = e.currentTarget,
              superSecret = node[EXPANDO_UID],
              propertyName = e.propertyName,
              event
            ;
            if (superSecret.hasOwnProperty(propertyName)) {
              superSecret = superSecret[propertyName];
              event = new CustomEvent(DOM_ATTR_MODIFIED, {bubbles: true});
              event.attrName = superSecret.name;
              event.prevValue = superSecret.value || null;
              event.newValue = (superSecret.value = node[propertyName] || null);
              if (event.prevValue == null) {
                event[ADDITION] = event.attrChange = 0;
              } else {
                event[MODIFICATION] = event.attrChange = 1;
              }
              dispatchEvent.call(node, event);
            }
          }
        ;
        descriptor.value = function (type, handler, capture) {
          if (
            type === DOM_ATTR_MODIFIED &&
            this[ATTRIBUTE_CHANGED_CALLBACK] &&
            this.setAttribute !== patchedSetAttribute
          ) {
            this[EXPANDO_UID] = {
              className: {
                name: 'class',
                value: this.className
              }
            };
            this.setAttribute = patchedSetAttribute;
            this.removeAttribute = patchedRemoveAttribute;
            addEventListener.call(this, 'propertychange', onPropertyChange);
          }
          addEventListener.call(this, type, handler, capture);
        };
        defineProperty(HTMLElementPrototype, ADD_EVENT_LISTENER, descriptor);
      }());
    } else if (!MutationObserver) {
      documentElement[ADD_EVENT_LISTENER](DOM_ATTR_MODIFIED, DOMAttrModified);
      documentElement.setAttribute(EXPANDO_UID, 1);
      documentElement.removeAttribute(EXPANDO_UID);
      if (doesNotSupportDOMAttrModified) {
        onSubtreeModified = function (e) {
          var
            node = this,
            oldAttributes,
            newAttributes,
            key
          ;
          if (node === e.target) {
            oldAttributes = node[EXPANDO_UID];
            node[EXPANDO_UID] = (newAttributes = getAttributesMirror(node));
            for (key in newAttributes) {
              if (!(key in oldAttributes)) {
                // attribute was added
                return callDOMAttrModified(
                  0,
                  node,
                  key,
                  oldAttributes[key],
                  newAttributes[key],
                  ADDITION
                );
              } else if (newAttributes[key] !== oldAttributes[key]) {
                // attribute was changed
                return callDOMAttrModified(
                  1,
                  node,
                  key,
                  oldAttributes[key],
                  newAttributes[key],
                  MODIFICATION
                );
              }
            }
            // checking if it has been removed
            for (key in oldAttributes) {
              if (!(key in newAttributes)) {
                // attribute removed
                return callDOMAttrModified(
                  2,
                  node,
                  key,
                  oldAttributes[key],
                  newAttributes[key],
                  REMOVAL
                );
              }
            }
          }
        };
        callDOMAttrModified = function (
          attrChange,
          currentTarget,
          attrName,
          prevValue,
          newValue,
          action
        ) {
          var e = {
            attrChange: attrChange,
            currentTarget: currentTarget,
            attrName: attrName,
            prevValue: prevValue,
            newValue: newValue
          };
          e[action] = attrChange;
          onDOMAttrModified(e);
        };
        getAttributesMirror = function (node) {
          for (var
            attr, name,
            result = {},
            attributes = node.attributes,
            i = 0, length = attributes.length;
            i < length; i++
          ) {
            attr = attributes[i];
            name = attr.name;
            if (name !== 'setAttribute') {
              result[name] = attr.value;
            }
          }
          return result;
        };
      }
    }
  
    // set as enumerable, writable and configurable
    document[REGISTER_ELEMENT] = function registerElement(type, options) {
      upperType = type.toUpperCase();
      if (!setListener) {
        // only first time document.registerElement is used
        // we need to set this listener
        // setting it by default might slow down for no reason
        setListener = true;
        if (MutationObserver) {
          observer = (function(attached, detached){
            function checkEmAll(list, callback) {
              for (var i = 0, length = list.length; i < length; callback(list[i++])){}
            }
            return new MutationObserver(function (records) {
              for (var
                current, node, newValue,
                i = 0, length = records.length; i < length; i++
              ) {
                current = records[i];
                if (current.type === 'childList') {
                  checkEmAll(current.addedNodes, attached);
                  checkEmAll(current.removedNodes, detached);
                } else {
                  node = current.target;
                  if (notFromInnerHTMLHelper &&
                      node[ATTRIBUTE_CHANGED_CALLBACK] &&
                      current.attributeName !== 'style') {
                    newValue = getAttribute.call(node, current.attributeName);
                    if (newValue !== current.oldValue) {
                      node[ATTRIBUTE_CHANGED_CALLBACK](
                        current.attributeName,
                        current.oldValue,
                        newValue
                      );
                    }
                  }
                }
              }
            });
          }(executeAction(ATTACHED), executeAction(DETACHED)));
          observe = function (node) {
            observer.observe(
              node,
              {
                childList: true,
                subtree: true
              }
            );
            return node;
          };
          observe(document);
          if (attachShadow) {
            HTMLElementPrototype.attachShadow = function () {
              return observe(attachShadow.apply(this, arguments));
            };
          }
        } else {
          asapQueue = [];
          document[ADD_EVENT_LISTENER]('DOMNodeInserted', onDOMNode(ATTACHED));
          document[ADD_EVENT_LISTENER]('DOMNodeRemoved', onDOMNode(DETACHED));
        }
  
        document[ADD_EVENT_LISTENER](DOM_CONTENT_LOADED, onReadyStateChange);
        document[ADD_EVENT_LISTENER]('readystatechange', onReadyStateChange);
  
        HTMLElementPrototype.cloneNode = function (deep) {
          var
            node = cloneNode.call(this, !!deep),
            i = getTypeIndex(node)
          ;
          if (-1 < i) patch(node, protos[i]);
          if (deep) loopAndSetup(node.querySelectorAll(query));
          return node;
        };
      }
  
      if (-2 < (
        indexOf.call(types, PREFIX_IS + upperType) +
        indexOf.call(types, PREFIX_TAG + upperType)
      )) {
        throwTypeError(type);
      }
  
      if (!validName.test(upperType) || -1 < indexOf.call(invalidNames, upperType)) {
        throw new Error('The type ' + type + ' is invalid');
      }
  
      var
        constructor = function () {
          return extending ?
            document.createElement(nodeName, upperType) :
            document.createElement(nodeName);
        },
        opt = options || OP,
        extending = hOP.call(opt, EXTENDS),
        nodeName = extending ? options[EXTENDS].toUpperCase() : upperType,
        upperType,
        i
      ;
  
      if (extending && -1 < (
        indexOf.call(types, PREFIX_TAG + nodeName)
      )) {
        throwTypeError(nodeName);
      }
  
      i = types.push((extending ? PREFIX_IS : PREFIX_TAG) + upperType) - 1;
  
      query = query.concat(
        query.length ? ',' : '',
        extending ? nodeName + '[is="' + type.toLowerCase() + '"]' : nodeName
      );
  
      constructor.prototype = (
        protos[i] = hOP.call(opt, 'prototype') ?
          opt.prototype :
          create(HTMLElementPrototype)
      );
  
      loopAndVerify(
        document.querySelectorAll(query),
        ATTACHED
      );
  
      return constructor;
    };
  
    document.createElement = (patchedCreateElement = function (localName, typeExtension) {
      var
        is = getIs(typeExtension),
        node = is ?
          createElement.call(document, localName, secondArgument(is)) :
          createElement.call(document, localName),
        name = '' + localName,
        i = indexOf.call(
          types,
          (is ? PREFIX_IS : PREFIX_TAG) +
          (is || name).toUpperCase()
        ),
        setup = -1 < i
      ;
      if (is) {
        node.setAttribute('is', is = is.toLowerCase());
        if (setup) {
          setup = isInQSA(name.toUpperCase(), is);
        }
      }
      notFromInnerHTMLHelper = !document.createElement.innerHTMLHelper;
      if (setup) patch(node, protos[i]);
      return node;
    });
  
  }
  
  function ASAP() {
    var queue = asapQueue.splice(0, asapQueue.length);
    asapTimer = 0;
    while (queue.length) {
      queue.shift().call(
        null, queue.shift()
      );
    }
  }
  
  function loopAndVerify(list, action) {
    for (var i = 0, length = list.length; i < length; i++) {
      verifyAndSetupAndAction(list[i], action);
    }
  }
  
  function loopAndSetup(list) {
    for (var i = 0, length = list.length, node; i < length; i++) {
      node = list[i];
      patch(node, protos[getTypeIndex(node)]);
    }
  }
  
  function executeAction(action) {
    return function (node) {
      if (isValidNode(node)) {
        verifyAndSetupAndAction(node, action);
        loopAndVerify(
          node.querySelectorAll(query),
          action
        );
      }
    };
  }
  
  function getTypeIndex(target) {
    var
      is = getAttribute.call(target, 'is'),
      nodeName = target.nodeName.toUpperCase(),
      i = indexOf.call(
        types,
        is ?
            PREFIX_IS + is.toUpperCase() :
            PREFIX_TAG + nodeName
      )
    ;
    return is && -1 < i && !isInQSA(nodeName, is) ? -1 : i;
  }
  
  function isInQSA(name, type) {
    return -1 < query.indexOf(name + '[is="' + type + '"]');
  }
  
  function onDOMAttrModified(e) {
    var
      node = e.currentTarget,
      attrChange = e.attrChange,
      attrName = e.attrName,
      target = e.target,
      addition = e[ADDITION] || 2,
      removal = e[REMOVAL] || 3
    ;
    if (notFromInnerHTMLHelper &&
        (!target || target === node) &&
        node[ATTRIBUTE_CHANGED_CALLBACK] &&
        attrName !== 'style' && (
          e.prevValue !== e.newValue ||
          // IE9, IE10, and Opera 12 gotcha
          e.newValue === '' && (
            attrChange === addition ||
            attrChange === removal
          )
    )) {
      node[ATTRIBUTE_CHANGED_CALLBACK](
        attrName,
        attrChange === addition ? null : e.prevValue,
        attrChange === removal ? null : e.newValue
      );
    }
  }
  
  function onDOMNode(action) {
    var executor = executeAction(action);
    return function (e) {
      asapQueue.push(executor, e.target);
      if (asapTimer) clearTimeout(asapTimer);
      asapTimer = setTimeout(ASAP, 1);
    };
  }
  
  function onReadyStateChange(e) {
    if (dropDomContentLoaded) {
      dropDomContentLoaded = false;
      e.currentTarget.removeEventListener(DOM_CONTENT_LOADED, onReadyStateChange);
    }
    loopAndVerify(
      (e.target || document).querySelectorAll(query),
      e.detail === DETACHED ? DETACHED : ATTACHED
    );
    if (IE8) purge();
  }
  
  function patchedSetAttribute(name, value) {
    // jshint validthis:true
    var self = this;
    setAttribute.call(self, name, value);
    onSubtreeModified.call(self, {target: self});
  }
  
  function setupNode(node, proto) {
    setPrototype(node, proto);
    if (observer) {
      observer.observe(node, attributesObserver);
    } else {
      if (doesNotSupportDOMAttrModified) {
        node.setAttribute = patchedSetAttribute;
        node[EXPANDO_UID] = getAttributesMirror(node);
        node[ADD_EVENT_LISTENER](DOM_SUBTREE_MODIFIED, onSubtreeModified);
      }
      node[ADD_EVENT_LISTENER](DOM_ATTR_MODIFIED, onDOMAttrModified);
    }
    if (node[CREATED_CALLBACK] && notFromInnerHTMLHelper) {
      node.created = true;
      node[CREATED_CALLBACK]();
      node.created = false;
    }
  }
  
  function purge() {
    for (var
      node,
      i = 0,
      length = targets.length;
      i < length; i++
    ) {
      node = targets[i];
      if (!documentElement.contains(node)) {
        length--;
        targets.splice(i--, 1);
        verifyAndSetupAndAction(node, DETACHED);
      }
    }
  }
  
  function throwTypeError(type) {
    throw new Error('A ' + type + ' type is already registered');
  }
  
  function verifyAndSetupAndAction(node, action) {
    var
      fn,
      i = getTypeIndex(node)
    ;
    if (-1 < i) {
      patchIfNotAlready(node, protos[i]);
      i = 0;
      if (action === ATTACHED && !node[ATTACHED]) {
        node[DETACHED] = false;
        node[ATTACHED] = true;
        i = 1;
        if (IE8 && indexOf.call(targets, node) < 0) {
          targets.push(node);
        }
      } else if (action === DETACHED && !node[DETACHED]) {
        node[ATTACHED] = false;
        node[DETACHED] = true;
        i = 1;
      }
      if (i && (fn = node[action + CALLBACK])) fn.call(node);
    }
  }
  
  
  
  // V1 in da House!
  function CustomElementRegistry() {}
  
  CustomElementRegistry.prototype = {
    constructor: CustomElementRegistry,
    // a workaround for the stubborn WebKit
    define: usableCustomElements ?
      function (name, Class, options) {
        if (options) {
          CERDefine(name, Class, options);
        } else {
          var NAME = name.toUpperCase();
          constructors[NAME] = {
            constructor: Class,
            create: [NAME]
          };
          nodeNames.set(Class, NAME);
          customElements.define(name, Class);
        }
      } :
      CERDefine,
    get: usableCustomElements ?
      function (name) {
        return customElements.get(name) || get(name);
      } :
      get,
    whenDefined: usableCustomElements ?
      function (name) {
        return Promise.race([
          customElements.whenDefined(name),
          whenDefined(name)
        ]);
      } :
      whenDefined
  };
  
  function CERDefine(name, Class, options) {
    var
      is = options && options[EXTENDS] || '',
      CProto = Class.prototype,
      proto = create(CProto),
      attributes = Class.observedAttributes || empty,
      definition = {prototype: proto}
    ;
    // TODO: is this needed at all since it's inherited?
    // defineProperty(proto, 'constructor', {value: Class});
    safeProperty(proto, CREATED_CALLBACK, {
        value: function () {
          if (justCreated) justCreated = false;
          else if (!this[DRECEV1]) {
            this[DRECEV1] = true;
            new Class(this);
            if (CProto[CREATED_CALLBACK])
              CProto[CREATED_CALLBACK].call(this);
            var info = constructors[nodeNames.get(Class)];
            if (!usableCustomElements || info.create.length > 1) {
              notifyAttributes(this);
            }
          }
      }
    });
    safeProperty(proto, ATTRIBUTE_CHANGED_CALLBACK, {
      value: function (name) {
        if (-1 < indexOf.call(attributes, name))
          CProto[ATTRIBUTE_CHANGED_CALLBACK].apply(this, arguments);
      }
    });
    if (CProto[CONNECTED_CALLBACK]) {
      safeProperty(proto, ATTACHED_CALLBACK, {
        value: CProto[CONNECTED_CALLBACK]
      });
    }
    if (CProto[DISCONNECTED_CALLBACK]) {
      safeProperty(proto, DETACHED_CALLBACK, {
        value: CProto[DISCONNECTED_CALLBACK]
      });
    }
    if (is) definition[EXTENDS] = is;
    name = name.toUpperCase();
    constructors[name] = {
      constructor: Class,
      create: is ? [is, secondArgument(name)] : [name]
    };
    nodeNames.set(Class, name);
    document[REGISTER_ELEMENT](name.toLowerCase(), definition);
    whenDefined(name);
    waitingList[name].r();
  }
  
  function get(name) {
    var info = constructors[name.toUpperCase()];
    return info && info.constructor;
  }
  
  function getIs(options) {
    return typeof options === 'string' ?
        options : (options && options.is || '');
  }
  
  function notifyAttributes(self) {
    var
      callback = self[ATTRIBUTE_CHANGED_CALLBACK],
      attributes = callback ? self.attributes : empty,
      i = attributes.length,
      attribute
    ;
    while (i--) {
      attribute =  attributes[i]; // || attributes.item(i);
      callback.call(
        self,
        attribute.name || attribute.nodeName,
        null,
        attribute.value || attribute.nodeValue
      );
    }
  }
  
  function whenDefined(name) {
    name = name.toUpperCase();
    if (!(name in waitingList)) {
      waitingList[name] = {};
      waitingList[name].p = new Promise(function (resolve) {
        waitingList[name].r = resolve;
      });
    }
    return waitingList[name].p;
  }
  
  function polyfillV1() {
    if (customElements) delete window.customElements;
    defineProperty(window, 'customElements', {
      configurable: true,
      value: new CustomElementRegistry()
    });
    defineProperty(window, 'CustomElementRegistry', {
      configurable: true,
      value: CustomElementRegistry
    });
    for (var
      patchClass = function (name) {
        var Class = window[name];
        if (Class) {
          window[name] = function CustomElementsV1(self) {
            var info, isNative;
            if (!self) self = this;
            if (!self[DRECEV1]) {
              justCreated = true;
              info = constructors[nodeNames.get(self.constructor)];
              isNative = usableCustomElements && info.create.length === 1;
              self = isNative ?
                Reflect.construct(Class, empty, info.constructor) :
                document.createElement.apply(document, info.create);
              self[DRECEV1] = true;
              justCreated = false;
              if (!isNative) notifyAttributes(self);
            }
            return self;
          };
          window[name].prototype = Class.prototype;
          try {
            Class.prototype.constructor = window[name];
          } catch(WebKit) {
            fixGetClass = true;
            defineProperty(Class, DRECEV1, {value: window[name]});
          }
        }
      },
      Classes = htmlClass.get(/^HTML[A-Z]*[a-z]/),
      i = Classes.length;
      i--;
      patchClass(Classes[i])
    ) {}
    (document.createElement = function (name, options) {
      var is = getIs(options);
      return is ?
        patchedCreateElement.call(this, name, secondArgument(is)) :
        patchedCreateElement.call(this, name);
    });
  }
  
  // if customElements is not there at all
  if (!customElements || polyfill === 'force') polyfillV1();
  else {
    // if available test extends work as expected
    try {
      (function (DRE, options, name) {
        options[EXTENDS] = 'a';
        DRE.prototype = create(HTMLAnchorElement.prototype);
        DRE.prototype.constructor = DRE;
        window.customElements.define(name, DRE, options);
        if (
          getAttribute.call(document.createElement('a', {is: name}), 'is') !== name ||
          (usableCustomElements && getAttribute.call(new DRE(), 'is') !== name)
        ) {
          throw options;
        }
      }(
        function DRE() {
          return Reflect.construct(HTMLAnchorElement, [], DRE);
        },
        {},
        'document-register-element-a'
      ));
    } catch(o_O) {
      // or force the polyfill if not
      // and keep internal original reference
      polyfillV1();
    }
  }
  
  try {
    createElement.call(document, 'a', 'a');
  } catch(FireFox) {
    secondArgument = function (is) {
      return {is: is};
    };
  }
  
}

module.exports = installCustomElements;
installCustomElements(global);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../../../node_modules/dropzone/dist/dropzone.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery, module) {
/*
 *
 * More info at [www.dropzonejs.com](http://www.dropzonejs.com)
 *
 * Copyright (c) 2012, Matias Meno
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *
 */

(function() {
  var Dropzone, Emitter, camelize, contentLoaded, detectVerticalSquash, drawImageIOSFix, noop, without,
    __slice = [].slice,
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  noop = function() {};

  Emitter = (function() {
    function Emitter() {}

    Emitter.prototype.addEventListener = Emitter.prototype.on;

    Emitter.prototype.on = function(event, fn) {
      this._callbacks = this._callbacks || {};
      if (!this._callbacks[event]) {
        this._callbacks[event] = [];
      }
      this._callbacks[event].push(fn);
      return this;
    };

    Emitter.prototype.emit = function() {
      var args, callback, callbacks, event, _i, _len;
      event = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
      this._callbacks = this._callbacks || {};
      callbacks = this._callbacks[event];
      if (callbacks) {
        for (_i = 0, _len = callbacks.length; _i < _len; _i++) {
          callback = callbacks[_i];
          callback.apply(this, args);
        }
      }
      return this;
    };

    Emitter.prototype.removeListener = Emitter.prototype.off;

    Emitter.prototype.removeAllListeners = Emitter.prototype.off;

    Emitter.prototype.removeEventListener = Emitter.prototype.off;

    Emitter.prototype.off = function(event, fn) {
      var callback, callbacks, i, _i, _len;
      if (!this._callbacks || arguments.length === 0) {
        this._callbacks = {};
        return this;
      }
      callbacks = this._callbacks[event];
      if (!callbacks) {
        return this;
      }
      if (arguments.length === 1) {
        delete this._callbacks[event];
        return this;
      }
      for (i = _i = 0, _len = callbacks.length; _i < _len; i = ++_i) {
        callback = callbacks[i];
        if (callback === fn) {
          callbacks.splice(i, 1);
          break;
        }
      }
      return this;
    };

    return Emitter;

  })();

  Dropzone = (function(_super) {
    var extend, resolveOption;

    __extends(Dropzone, _super);

    Dropzone.prototype.Emitter = Emitter;


    /*
    This is a list of all available events you can register on a dropzone object.
    
    You can register an event handler like this:
    
        dropzone.on("dragEnter", function() { });
     */

    Dropzone.prototype.events = ["drop", "dragstart", "dragend", "dragenter", "dragover", "dragleave", "addedfile", "addedfiles", "removedfile", "thumbnail", "error", "errormultiple", "processing", "processingmultiple", "uploadprogress", "totaluploadprogress", "sending", "sendingmultiple", "success", "successmultiple", "canceled", "canceledmultiple", "complete", "completemultiple", "reset", "maxfilesexceeded", "maxfilesreached", "queuecomplete"];

    Dropzone.prototype.defaultOptions = {
      url: null,
      method: "post",
      withCredentials: false,
      parallelUploads: 2,
      uploadMultiple: false,
      maxFilesize: 256,
      paramName: "file",
      createImageThumbnails: true,
      maxThumbnailFilesize: 10,
      thumbnailWidth: 120,
      thumbnailHeight: 120,
      filesizeBase: 1000,
      maxFiles: null,
      params: {},
      clickable: true,
      ignoreHiddenFiles: true,
      acceptedFiles: null,
      acceptedMimeTypes: null,
      autoProcessQueue: true,
      autoQueue: true,
      addRemoveLinks: false,
      previewsContainer: null,
      hiddenInputContainer: "body",
      capture: null,
      dictDefaultMessage: "Drop files here to upload",
      dictFallbackMessage: "Your browser does not support drag'n'drop file uploads.",
      dictFallbackText: "Please use the fallback form below to upload your files like in the olden days.",
      dictFileTooBig: "File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",
      dictInvalidFileType: "You can't upload files of this type.",
      dictResponseError: "Server responded with {{statusCode}} code.",
      dictCancelUpload: "Cancel upload",
      dictCancelUploadConfirmation: "Are you sure you want to cancel this upload?",
      dictRemoveFile: "Remove file",
      dictRemoveFileConfirmation: null,
      dictMaxFilesExceeded: "You can not upload any more files.",
      accept: function(file, done) {
        return done();
      },
      init: function() {
        return noop;
      },
      forceFallback: false,
      fallback: function() {
        var child, messageElement, span, _i, _len, _ref;
        this.element.className = "" + this.element.className + " dz-browser-not-supported";
        _ref = this.element.getElementsByTagName("div");
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          child = _ref[_i];
          if (/(^| )dz-message($| )/.test(child.className)) {
            messageElement = child;
            child.className = "dz-message";
            continue;
          }
        }
        if (!messageElement) {
          messageElement = Dropzone.createElement("<div class=\"dz-message\"><span></span></div>");
          this.element.appendChild(messageElement);
        }
        span = messageElement.getElementsByTagName("span")[0];
        if (span) {
          if (span.textContent != null) {
            span.textContent = this.options.dictFallbackMessage;
          } else if (span.innerText != null) {
            span.innerText = this.options.dictFallbackMessage;
          }
        }
        return this.element.appendChild(this.getFallbackForm());
      },
      resize: function(file) {
        var info, srcRatio, trgRatio;
        info = {
          srcX: 0,
          srcY: 0,
          srcWidth: file.width,
          srcHeight: file.height
        };
        srcRatio = file.width / file.height;
        info.optWidth = this.options.thumbnailWidth;
        info.optHeight = this.options.thumbnailHeight;
        if ((info.optWidth == null) && (info.optHeight == null)) {
          info.optWidth = info.srcWidth;
          info.optHeight = info.srcHeight;
        } else if (info.optWidth == null) {
          info.optWidth = srcRatio * info.optHeight;
        } else if (info.optHeight == null) {
          info.optHeight = (1 / srcRatio) * info.optWidth;
        }
        trgRatio = info.optWidth / info.optHeight;
        if (file.height < info.optHeight || file.width < info.optWidth) {
          info.trgHeight = info.srcHeight;
          info.trgWidth = info.srcWidth;
        } else {
          if (srcRatio > trgRatio) {
            info.srcHeight = file.height;
            info.srcWidth = info.srcHeight * trgRatio;
          } else {
            info.srcWidth = file.width;
            info.srcHeight = info.srcWidth / trgRatio;
          }
        }
        info.srcX = (file.width - info.srcWidth) / 2;
        info.srcY = (file.height - info.srcHeight) / 2;
        return info;
      },

      /*
      Those functions register themselves to the events on init and handle all
      the user interface specific stuff. Overwriting them won't break the upload
      but can break the way it's displayed.
      You can overwrite them if you don't like the default behavior. If you just
      want to add an additional event handler, register it on the dropzone object
      and don't overwrite those options.
       */
      drop: function(e) {
        return this.element.classList.remove("dz-drag-hover");
      },
      dragstart: noop,
      dragend: function(e) {
        return this.element.classList.remove("dz-drag-hover");
      },
      dragenter: function(e) {
        return this.element.classList.add("dz-drag-hover");
      },
      dragover: function(e) {
        return this.element.classList.add("dz-drag-hover");
      },
      dragleave: function(e) {
        return this.element.classList.remove("dz-drag-hover");
      },
      paste: noop,
      reset: function() {
        return this.element.classList.remove("dz-started");
      },
      addedfile: function(file) {
        var node, removeFileEvent, removeLink, _i, _j, _k, _len, _len1, _len2, _ref, _ref1, _ref2, _results;
        if (this.element === this.previewsContainer) {
          this.element.classList.add("dz-started");
        }
        if (this.previewsContainer) {
          file.previewElement = Dropzone.createElement(this.options.previewTemplate.trim());
          file.previewTemplate = file.previewElement;
          this.previewsContainer.appendChild(file.previewElement);
          _ref = file.previewElement.querySelectorAll("[data-dz-name]");
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            node = _ref[_i];
            node.textContent = file.name;
          }
          _ref1 = file.previewElement.querySelectorAll("[data-dz-size]");
          for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {
            node = _ref1[_j];
            node.innerHTML = this.filesize(file.size);
          }
          if (this.options.addRemoveLinks) {
            file._removeLink = Dropzone.createElement("<a class=\"dz-remove\" href=\"javascript:undefined;\" data-dz-remove>" + this.options.dictRemoveFile + "</a>");
            file.previewElement.appendChild(file._removeLink);
          }
          removeFileEvent = (function(_this) {
            return function(e) {
              e.preventDefault();
              e.stopPropagation();
              if (file.status === Dropzone.UPLOADING) {
                return Dropzone.confirm(_this.options.dictCancelUploadConfirmation, function() {
                  return _this.removeFile(file);
                });
              } else {
                if (_this.options.dictRemoveFileConfirmation) {
                  return Dropzone.confirm(_this.options.dictRemoveFileConfirmation, function() {
                    return _this.removeFile(file);
                  });
                } else {
                  return _this.removeFile(file);
                }
              }
            };
          })(this);
          _ref2 = file.previewElement.querySelectorAll("[data-dz-remove]");
          _results = [];
          for (_k = 0, _len2 = _ref2.length; _k < _len2; _k++) {
            removeLink = _ref2[_k];
            _results.push(removeLink.addEventListener("click", removeFileEvent));
          }
          return _results;
        }
      },
      removedfile: function(file) {
        var _ref;
        if (file.previewElement) {
          if ((_ref = file.previewElement) != null) {
            _ref.parentNode.removeChild(file.previewElement);
          }
        }
        return this._updateMaxFilesReachedClass();
      },
      thumbnail: function(file, dataUrl) {
        var thumbnailElement, _i, _len, _ref;
        if (file.previewElement) {
          file.previewElement.classList.remove("dz-file-preview");
          _ref = file.previewElement.querySelectorAll("[data-dz-thumbnail]");
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            thumbnailElement = _ref[_i];
            thumbnailElement.alt = file.name;
            thumbnailElement.src = dataUrl;
          }
          return setTimeout(((function(_this) {
            return function() {
              return file.previewElement.classList.add("dz-image-preview");
            };
          })(this)), 1);
        }
      },
      error: function(file, message) {
        var node, _i, _len, _ref, _results;
        if (file.previewElement) {
          file.previewElement.classList.add("dz-error");
          if (typeof message !== "String" && message.error) {
            message = message.error;
          }
          _ref = file.previewElement.querySelectorAll("[data-dz-errormessage]");
          _results = [];
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            node = _ref[_i];
            _results.push(node.textContent = message);
          }
          return _results;
        }
      },
      errormultiple: noop,
      processing: function(file) {
        if (file.previewElement) {
          file.previewElement.classList.add("dz-processing");
          if (file._removeLink) {
            return file._removeLink.textContent = this.options.dictCancelUpload;
          }
        }
      },
      processingmultiple: noop,
      uploadprogress: function(file, progress, bytesSent) {
        var node, _i, _len, _ref, _results;
        if (file.previewElement) {
          _ref = file.previewElement.querySelectorAll("[data-dz-uploadprogress]");
          _results = [];
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            node = _ref[_i];
            if (node.nodeName === 'PROGRESS') {
              _results.push(node.value = progress);
            } else {
              _results.push(node.style.width = "" + progress + "%");
            }
          }
          return _results;
        }
      },
      totaluploadprogress: noop,
      sending: noop,
      sendingmultiple: noop,
      success: function(file) {
        if (file.previewElement) {
          return file.previewElement.classList.add("dz-success");
        }
      },
      successmultiple: noop,
      canceled: function(file) {
        return this.emit("error", file, "Upload canceled.");
      },
      canceledmultiple: noop,
      complete: function(file) {
        if (file._removeLink) {
          file._removeLink.textContent = this.options.dictRemoveFile;
        }
        if (file.previewElement) {
          return file.previewElement.classList.add("dz-complete");
        }
      },
      completemultiple: noop,
      maxfilesexceeded: noop,
      maxfilesreached: noop,
      queuecomplete: noop,
      addedfiles: noop,
      previewTemplate: "<div class=\"dz-preview dz-file-preview\">\n  <div class=\"dz-image\"><img data-dz-thumbnail /></div>\n  <div class=\"dz-details\">\n    <div class=\"dz-size\"><span data-dz-size></span></div>\n    <div class=\"dz-filename\"><span data-dz-name></span></div>\n  </div>\n  <div class=\"dz-progress\"><span class=\"dz-upload\" data-dz-uploadprogress></span></div>\n  <div class=\"dz-error-message\"><span data-dz-errormessage></span></div>\n  <div class=\"dz-success-mark\">\n    <svg width=\"54px\" height=\"54px\" viewBox=\"0 0 54 54\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\">\n      <title>Check</title>\n      <defs></defs>\n      <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\">\n        <path d=\"M23.5,31.8431458 L17.5852419,25.9283877 C16.0248253,24.3679711 13.4910294,24.366835 11.9289322,25.9289322 C10.3700136,27.4878508 10.3665912,30.0234455 11.9283877,31.5852419 L20.4147581,40.0716123 C20.5133999,40.1702541 20.6159315,40.2626649 20.7218615,40.3488435 C22.2835669,41.8725651 24.794234,41.8626202 26.3461564,40.3106978 L43.3106978,23.3461564 C44.8771021,21.7797521 44.8758057,19.2483887 43.3137085,17.6862915 C41.7547899,16.1273729 39.2176035,16.1255422 37.6538436,17.6893022 L23.5,31.8431458 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z\" id=\"Oval-2\" stroke-opacity=\"0.198794158\" stroke=\"#747474\" fill-opacity=\"0.816519475\" fill=\"#FFFFFF\" sketch:type=\"MSShapeGroup\"></path>\n      </g>\n    </svg>\n  </div>\n  <div class=\"dz-error-mark\">\n    <svg width=\"54px\" height=\"54px\" viewBox=\"0 0 54 54\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\">\n      <title>Error</title>\n      <defs></defs>\n      <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\">\n        <g id=\"Check-+-Oval-2\" sketch:type=\"MSLayerGroup\" stroke=\"#747474\" stroke-opacity=\"0.198794158\" fill=\"#FFFFFF\" fill-opacity=\"0.816519475\">\n          <path d=\"M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z\" id=\"Oval-2\" sketch:type=\"MSShapeGroup\"></path>\n        </g>\n      </g>\n    </svg>\n  </div>\n</div>"
    };

    extend = function() {
      var key, object, objects, target, val, _i, _len;
      target = arguments[0], objects = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
      for (_i = 0, _len = objects.length; _i < _len; _i++) {
        object = objects[_i];
        for (key in object) {
          val = object[key];
          target[key] = val;
        }
      }
      return target;
    };

    function Dropzone(element, options) {
      var elementOptions, fallback, _ref;
      this.element = element;
      this.version = Dropzone.version;
      this.defaultOptions.previewTemplate = this.defaultOptions.previewTemplate.replace(/\n*/g, "");
      this.clickableElements = [];
      this.listeners = [];
      this.files = [];
      if (typeof this.element === "string") {
        this.element = document.querySelector(this.element);
      }
      if (!(this.element && (this.element.nodeType != null))) {
        throw new Error("Invalid dropzone element.");
      }
      if (this.element.dropzone) {
        throw new Error("Dropzone already attached.");
      }
      Dropzone.instances.push(this);
      this.element.dropzone = this;
      elementOptions = (_ref = Dropzone.optionsForElement(this.element)) != null ? _ref : {};
      this.options = extend({}, this.defaultOptions, elementOptions, options != null ? options : {});
      if (this.options.forceFallback || !Dropzone.isBrowserSupported()) {
        return this.options.fallback.call(this);
      }
      if (this.options.url == null) {
        this.options.url = this.element.getAttribute("action");
      }
      if (!this.options.url) {
        throw new Error("No URL provided.");
      }
      if (this.options.acceptedFiles && this.options.acceptedMimeTypes) {
        throw new Error("You can't provide both 'acceptedFiles' and 'acceptedMimeTypes'. 'acceptedMimeTypes' is deprecated.");
      }
      if (this.options.acceptedMimeTypes) {
        this.options.acceptedFiles = this.options.acceptedMimeTypes;
        delete this.options.acceptedMimeTypes;
      }
      this.options.method = this.options.method.toUpperCase();
      if ((fallback = this.getExistingFallback()) && fallback.parentNode) {
        fallback.parentNode.removeChild(fallback);
      }
      if (this.options.previewsContainer !== false) {
        if (this.options.previewsContainer) {
          this.previewsContainer = Dropzone.getElement(this.options.previewsContainer, "previewsContainer");
        } else {
          this.previewsContainer = this.element;
        }
      }
      if (this.options.clickable) {
        if (this.options.clickable === true) {
          this.clickableElements = [this.element];
        } else {
          this.clickableElements = Dropzone.getElements(this.options.clickable, "clickable");
        }
      }
      this.init();
    }

    Dropzone.prototype.getAcceptedFiles = function() {
      var file, _i, _len, _ref, _results;
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (file.accepted) {
          _results.push(file);
        }
      }
      return _results;
    };

    Dropzone.prototype.getRejectedFiles = function() {
      var file, _i, _len, _ref, _results;
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (!file.accepted) {
          _results.push(file);
        }
      }
      return _results;
    };

    Dropzone.prototype.getFilesWithStatus = function(status) {
      var file, _i, _len, _ref, _results;
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (file.status === status) {
          _results.push(file);
        }
      }
      return _results;
    };

    Dropzone.prototype.getQueuedFiles = function() {
      return this.getFilesWithStatus(Dropzone.QUEUED);
    };

    Dropzone.prototype.getUploadingFiles = function() {
      return this.getFilesWithStatus(Dropzone.UPLOADING);
    };

    Dropzone.prototype.getAddedFiles = function() {
      return this.getFilesWithStatus(Dropzone.ADDED);
    };

    Dropzone.prototype.getActiveFiles = function() {
      var file, _i, _len, _ref, _results;
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (file.status === Dropzone.UPLOADING || file.status === Dropzone.QUEUED) {
          _results.push(file);
        }
      }
      return _results;
    };

    Dropzone.prototype.init = function() {
      var eventName, noPropagation, setupHiddenFileInput, _i, _len, _ref, _ref1;
      if (this.element.tagName === "form") {
        this.element.setAttribute("enctype", "multipart/form-data");
      }
      if (this.element.classList.contains("dropzone") && !this.element.querySelector(".dz-message")) {
        this.element.appendChild(Dropzone.createElement("<div class=\"dz-default dz-message\"><span>" + this.options.dictDefaultMessage + "</span></div>"));
      }
      if (this.clickableElements.length) {
        setupHiddenFileInput = (function(_this) {
          return function() {
            if (_this.hiddenFileInput) {
              _this.hiddenFileInput.parentNode.removeChild(_this.hiddenFileInput);
            }
            _this.hiddenFileInput = document.createElement("input");
            _this.hiddenFileInput.setAttribute("type", "file");
            if ((_this.options.maxFiles == null) || _this.options.maxFiles > 1) {
              _this.hiddenFileInput.setAttribute("multiple", "multiple");
            }
            _this.hiddenFileInput.className = "dz-hidden-input";
            if (_this.options.acceptedFiles != null) {
              _this.hiddenFileInput.setAttribute("accept", _this.options.acceptedFiles);
            }
            if (_this.options.capture != null) {
              _this.hiddenFileInput.setAttribute("capture", _this.options.capture);
            }
            _this.hiddenFileInput.style.visibility = "hidden";
            _this.hiddenFileInput.style.position = "absolute";
            _this.hiddenFileInput.style.top = "0";
            _this.hiddenFileInput.style.left = "0";
            _this.hiddenFileInput.style.height = "0";
            _this.hiddenFileInput.style.width = "0";
            document.querySelector(_this.options.hiddenInputContainer).appendChild(_this.hiddenFileInput);
            return _this.hiddenFileInput.addEventListener("change", function() {
              var file, files, _i, _len;
              files = _this.hiddenFileInput.files;
              if (files.length) {
                for (_i = 0, _len = files.length; _i < _len; _i++) {
                  file = files[_i];
                  _this.addFile(file);
                }
              }
              _this.emit("addedfiles", files);
              return setupHiddenFileInput();
            });
          };
        })(this);
        setupHiddenFileInput();
      }
      this.URL = (_ref = window.URL) != null ? _ref : window.webkitURL;
      _ref1 = this.events;
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        eventName = _ref1[_i];
        this.on(eventName, this.options[eventName]);
      }
      this.on("uploadprogress", (function(_this) {
        return function() {
          return _this.updateTotalUploadProgress();
        };
      })(this));
      this.on("removedfile", (function(_this) {
        return function() {
          return _this.updateTotalUploadProgress();
        };
      })(this));
      this.on("canceled", (function(_this) {
        return function(file) {
          return _this.emit("complete", file);
        };
      })(this));
      this.on("complete", (function(_this) {
        return function(file) {
          if (_this.getAddedFiles().length === 0 && _this.getUploadingFiles().length === 0 && _this.getQueuedFiles().length === 0) {
            return setTimeout((function() {
              return _this.emit("queuecomplete");
            }), 0);
          }
        };
      })(this));
      noPropagation = function(e) {
        e.stopPropagation();
        if (e.preventDefault) {
          return e.preventDefault();
        } else {
          return e.returnValue = false;
        }
      };
      this.listeners = [
        {
          element: this.element,
          events: {
            "dragstart": (function(_this) {
              return function(e) {
                return _this.emit("dragstart", e);
              };
            })(this),
            "dragenter": (function(_this) {
              return function(e) {
                noPropagation(e);
                return _this.emit("dragenter", e);
              };
            })(this),
            "dragover": (function(_this) {
              return function(e) {
                var efct;
                try {
                  efct = e.dataTransfer.effectAllowed;
                } catch (_error) {}
                e.dataTransfer.dropEffect = 'move' === efct || 'linkMove' === efct ? 'move' : 'copy';
                noPropagation(e);
                return _this.emit("dragover", e);
              };
            })(this),
            "dragleave": (function(_this) {
              return function(e) {
                return _this.emit("dragleave", e);
              };
            })(this),
            "drop": (function(_this) {
              return function(e) {
                noPropagation(e);
                return _this.drop(e);
              };
            })(this),
            "dragend": (function(_this) {
              return function(e) {
                return _this.emit("dragend", e);
              };
            })(this)
          }
        }
      ];
      this.clickableElements.forEach((function(_this) {
        return function(clickableElement) {
          return _this.listeners.push({
            element: clickableElement,
            events: {
              "click": function(evt) {
                if ((clickableElement !== _this.element) || (evt.target === _this.element || Dropzone.elementInside(evt.target, _this.element.querySelector(".dz-message")))) {
                  _this.hiddenFileInput.click();
                }
                return true;
              }
            }
          });
        };
      })(this));
      this.enable();
      return this.options.init.call(this);
    };

    Dropzone.prototype.destroy = function() {
      var _ref;
      this.disable();
      this.removeAllFiles(true);
      if ((_ref = this.hiddenFileInput) != null ? _ref.parentNode : void 0) {
        this.hiddenFileInput.parentNode.removeChild(this.hiddenFileInput);
        this.hiddenFileInput = null;
      }
      delete this.element.dropzone;
      return Dropzone.instances.splice(Dropzone.instances.indexOf(this), 1);
    };

    Dropzone.prototype.updateTotalUploadProgress = function() {
      var activeFiles, file, totalBytes, totalBytesSent, totalUploadProgress, _i, _len, _ref;
      totalBytesSent = 0;
      totalBytes = 0;
      activeFiles = this.getActiveFiles();
      if (activeFiles.length) {
        _ref = this.getActiveFiles();
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          file = _ref[_i];
          totalBytesSent += file.upload.bytesSent;
          totalBytes += file.upload.total;
        }
        totalUploadProgress = 100 * totalBytesSent / totalBytes;
      } else {
        totalUploadProgress = 100;
      }
      return this.emit("totaluploadprogress", totalUploadProgress, totalBytes, totalBytesSent);
    };

    Dropzone.prototype._getParamName = function(n) {
      if (typeof this.options.paramName === "function") {
        return this.options.paramName(n);
      } else {
        return "" + this.options.paramName + (this.options.uploadMultiple ? "[" + n + "]" : "");
      }
    };

    Dropzone.prototype.getFallbackForm = function() {
      var existingFallback, fields, fieldsString, form;
      if (existingFallback = this.getExistingFallback()) {
        return existingFallback;
      }
      fieldsString = "<div class=\"dz-fallback\">";
      if (this.options.dictFallbackText) {
        fieldsString += "<p>" + this.options.dictFallbackText + "</p>";
      }
      fieldsString += "<input type=\"file\" name=\"" + (this._getParamName(0)) + "\" " + (this.options.uploadMultiple ? 'multiple="multiple"' : void 0) + " /><input type=\"submit\" value=\"Upload!\"></div>";
      fields = Dropzone.createElement(fieldsString);
      if (this.element.tagName !== "FORM") {
        form = Dropzone.createElement("<form action=\"" + this.options.url + "\" enctype=\"multipart/form-data\" method=\"" + this.options.method + "\"></form>");
        form.appendChild(fields);
      } else {
        this.element.setAttribute("enctype", "multipart/form-data");
        this.element.setAttribute("method", this.options.method);
      }
      return form != null ? form : fields;
    };

    Dropzone.prototype.getExistingFallback = function() {
      var fallback, getFallback, tagName, _i, _len, _ref;
      getFallback = function(elements) {
        var el, _i, _len;
        for (_i = 0, _len = elements.length; _i < _len; _i++) {
          el = elements[_i];
          if (/(^| )fallback($| )/.test(el.className)) {
            return el;
          }
        }
      };
      _ref = ["div", "form"];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        tagName = _ref[_i];
        if (fallback = getFallback(this.element.getElementsByTagName(tagName))) {
          return fallback;
        }
      }
    };

    Dropzone.prototype.setupEventListeners = function() {
      var elementListeners, event, listener, _i, _len, _ref, _results;
      _ref = this.listeners;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        elementListeners = _ref[_i];
        _results.push((function() {
          var _ref1, _results1;
          _ref1 = elementListeners.events;
          _results1 = [];
          for (event in _ref1) {
            listener = _ref1[event];
            _results1.push(elementListeners.element.addEventListener(event, listener, false));
          }
          return _results1;
        })());
      }
      return _results;
    };

    Dropzone.prototype.removeEventListeners = function() {
      var elementListeners, event, listener, _i, _len, _ref, _results;
      _ref = this.listeners;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        elementListeners = _ref[_i];
        _results.push((function() {
          var _ref1, _results1;
          _ref1 = elementListeners.events;
          _results1 = [];
          for (event in _ref1) {
            listener = _ref1[event];
            _results1.push(elementListeners.element.removeEventListener(event, listener, false));
          }
          return _results1;
        })());
      }
      return _results;
    };

    Dropzone.prototype.disable = function() {
      var file, _i, _len, _ref, _results;
      this.clickableElements.forEach(function(element) {
        return element.classList.remove("dz-clickable");
      });
      this.removeEventListeners();
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        _results.push(this.cancelUpload(file));
      }
      return _results;
    };

    Dropzone.prototype.enable = function() {
      this.clickableElements.forEach(function(element) {
        return element.classList.add("dz-clickable");
      });
      return this.setupEventListeners();
    };

    Dropzone.prototype.filesize = function(size) {
      var cutoff, i, selectedSize, selectedUnit, unit, units, _i, _len;
      selectedSize = 0;
      selectedUnit = "b";
      if (size > 0) {
        units = ['TB', 'GB', 'MB', 'KB', 'b'];
        for (i = _i = 0, _len = units.length; _i < _len; i = ++_i) {
          unit = units[i];
          cutoff = Math.pow(this.options.filesizeBase, 4 - i) / 10;
          if (size >= cutoff) {
            selectedSize = size / Math.pow(this.options.filesizeBase, 4 - i);
            selectedUnit = unit;
            break;
          }
        }
        selectedSize = Math.round(10 * selectedSize) / 10;
      }
      return "<strong>" + selectedSize + "</strong> " + selectedUnit;
    };

    Dropzone.prototype._updateMaxFilesReachedClass = function() {
      if ((this.options.maxFiles != null) && this.getAcceptedFiles().length >= this.options.maxFiles) {
        if (this.getAcceptedFiles().length === this.options.maxFiles) {
          this.emit('maxfilesreached', this.files);
        }
        return this.element.classList.add("dz-max-files-reached");
      } else {
        return this.element.classList.remove("dz-max-files-reached");
      }
    };

    Dropzone.prototype.drop = function(e) {
      var files, items;
      if (!e.dataTransfer) {
        return;
      }
      this.emit("drop", e);
      files = e.dataTransfer.files;
      this.emit("addedfiles", files);
      if (files.length) {
        items = e.dataTransfer.items;
        if (items && items.length && (items[0].webkitGetAsEntry != null)) {
          this._addFilesFromItems(items);
        } else {
          this.handleFiles(files);
        }
      }
    };

    Dropzone.prototype.paste = function(e) {
      var items, _ref;
      if ((e != null ? (_ref = e.clipboardData) != null ? _ref.items : void 0 : void 0) == null) {
        return;
      }
      this.emit("paste", e);
      items = e.clipboardData.items;
      if (items.length) {
        return this._addFilesFromItems(items);
      }
    };

    Dropzone.prototype.handleFiles = function(files) {
      var file, _i, _len, _results;
      _results = [];
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        _results.push(this.addFile(file));
      }
      return _results;
    };

    Dropzone.prototype._addFilesFromItems = function(items) {
      var entry, item, _i, _len, _results;
      _results = [];
      for (_i = 0, _len = items.length; _i < _len; _i++) {
        item = items[_i];
        if ((item.webkitGetAsEntry != null) && (entry = item.webkitGetAsEntry())) {
          if (entry.isFile) {
            _results.push(this.addFile(item.getAsFile()));
          } else if (entry.isDirectory) {
            _results.push(this._addFilesFromDirectory(entry, entry.name));
          } else {
            _results.push(void 0);
          }
        } else if (item.getAsFile != null) {
          if ((item.kind == null) || item.kind === "file") {
            _results.push(this.addFile(item.getAsFile()));
          } else {
            _results.push(void 0);
          }
        } else {
          _results.push(void 0);
        }
      }
      return _results;
    };

    Dropzone.prototype._addFilesFromDirectory = function(directory, path) {
      var dirReader, entriesReader;
      dirReader = directory.createReader();
      entriesReader = (function(_this) {
        return function(entries) {
          var entry, _i, _len;
          for (_i = 0, _len = entries.length; _i < _len; _i++) {
            entry = entries[_i];
            if (entry.isFile) {
              entry.file(function(file) {
                if (_this.options.ignoreHiddenFiles && file.name.substring(0, 1) === '.') {
                  return;
                }
                file.fullPath = "" + path + "/" + file.name;
                return _this.addFile(file);
              });
            } else if (entry.isDirectory) {
              _this._addFilesFromDirectory(entry, "" + path + "/" + entry.name);
            }
          }
        };
      })(this);
      return dirReader.readEntries(entriesReader, function(error) {
        return typeof console !== "undefined" && console !== null ? typeof console.log === "function" ? console.log(error) : void 0 : void 0;
      });
    };

    Dropzone.prototype.accept = function(file, done) {
      if (file.size > this.options.maxFilesize * 1024 * 1024) {
        return done(this.options.dictFileTooBig.replace("{{filesize}}", Math.round(file.size / 1024 / 10.24) / 100).replace("{{maxFilesize}}", this.options.maxFilesize));
      } else if (!Dropzone.isValidFile(file, this.options.acceptedFiles)) {
        return done(this.options.dictInvalidFileType);
      } else if ((this.options.maxFiles != null) && this.getAcceptedFiles().length >= this.options.maxFiles) {
        done(this.options.dictMaxFilesExceeded.replace("{{maxFiles}}", this.options.maxFiles));
        return this.emit("maxfilesexceeded", file);
      } else {
        return this.options.accept.call(this, file, done);
      }
    };

    Dropzone.prototype.addFile = function(file) {
      file.upload = {
        progress: 0,
        total: file.size,
        bytesSent: 0
      };
      this.files.push(file);
      file.status = Dropzone.ADDED;
      this.emit("addedfile", file);
      this._enqueueThumbnail(file);
      return this.accept(file, (function(_this) {
        return function(error) {
          if (error) {
            file.accepted = false;
            _this._errorProcessing([file], error);
          } else {
            file.accepted = true;
            if (_this.options.autoQueue) {
              _this.enqueueFile(file);
            }
          }
          return _this._updateMaxFilesReachedClass();
        };
      })(this));
    };

    Dropzone.prototype.enqueueFiles = function(files) {
      var file, _i, _len;
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        this.enqueueFile(file);
      }
      return null;
    };

    Dropzone.prototype.enqueueFile = function(file) {
      if (file.status === Dropzone.ADDED && file.accepted === true) {
        file.status = Dropzone.QUEUED;
        if (this.options.autoProcessQueue) {
          return setTimeout(((function(_this) {
            return function() {
              return _this.processQueue();
            };
          })(this)), 0);
        }
      } else {
        throw new Error("This file can't be queued because it has already been processed or was rejected.");
      }
    };

    Dropzone.prototype._thumbnailQueue = [];

    Dropzone.prototype._processingThumbnail = false;

    Dropzone.prototype._enqueueThumbnail = function(file) {
      if (this.options.createImageThumbnails && file.type.match(/image.*/) && file.size <= this.options.maxThumbnailFilesize * 1024 * 1024) {
        this._thumbnailQueue.push(file);
        return setTimeout(((function(_this) {
          return function() {
            return _this._processThumbnailQueue();
          };
        })(this)), 0);
      }
    };

    Dropzone.prototype._processThumbnailQueue = function() {
      if (this._processingThumbnail || this._thumbnailQueue.length === 0) {
        return;
      }
      this._processingThumbnail = true;
      return this.createThumbnail(this._thumbnailQueue.shift(), (function(_this) {
        return function() {
          _this._processingThumbnail = false;
          return _this._processThumbnailQueue();
        };
      })(this));
    };

    Dropzone.prototype.removeFile = function(file) {
      if (file.status === Dropzone.UPLOADING) {
        this.cancelUpload(file);
      }
      this.files = without(this.files, file);
      this.emit("removedfile", file);
      if (this.files.length === 0) {
        return this.emit("reset");
      }
    };

    Dropzone.prototype.removeAllFiles = function(cancelIfNecessary) {
      var file, _i, _len, _ref;
      if (cancelIfNecessary == null) {
        cancelIfNecessary = false;
      }
      _ref = this.files.slice();
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (file.status !== Dropzone.UPLOADING || cancelIfNecessary) {
          this.removeFile(file);
        }
      }
      return null;
    };

    Dropzone.prototype.createThumbnail = function(file, callback) {
      var fileReader;
      fileReader = new FileReader;
      fileReader.onload = (function(_this) {
        return function() {
          if (file.type === "image/svg+xml") {
            _this.emit("thumbnail", file, fileReader.result);
            if (callback != null) {
              callback();
            }
            return;
          }
          return _this.createThumbnailFromUrl(file, fileReader.result, callback);
        };
      })(this);
      return fileReader.readAsDataURL(file);
    };

    Dropzone.prototype.createThumbnailFromUrl = function(file, imageUrl, callback, crossOrigin) {
      var img;
      img = document.createElement("img");
      if (crossOrigin) {
        img.crossOrigin = crossOrigin;
      }
      img.onload = (function(_this) {
        return function() {
          var canvas, ctx, resizeInfo, thumbnail, _ref, _ref1, _ref2, _ref3;
          file.width = img.width;
          file.height = img.height;
          resizeInfo = _this.options.resize.call(_this, file);
          if (resizeInfo.trgWidth == null) {
            resizeInfo.trgWidth = resizeInfo.optWidth;
          }
          if (resizeInfo.trgHeight == null) {
            resizeInfo.trgHeight = resizeInfo.optHeight;
          }
          canvas = document.createElement("canvas");
          ctx = canvas.getContext("2d");
          canvas.width = resizeInfo.trgWidth;
          canvas.height = resizeInfo.trgHeight;
          drawImageIOSFix(ctx, img, (_ref = resizeInfo.srcX) != null ? _ref : 0, (_ref1 = resizeInfo.srcY) != null ? _ref1 : 0, resizeInfo.srcWidth, resizeInfo.srcHeight, (_ref2 = resizeInfo.trgX) != null ? _ref2 : 0, (_ref3 = resizeInfo.trgY) != null ? _ref3 : 0, resizeInfo.trgWidth, resizeInfo.trgHeight);
          thumbnail = canvas.toDataURL("image/png");
          _this.emit("thumbnail", file, thumbnail);
          if (callback != null) {
            return callback();
          }
        };
      })(this);
      if (callback != null) {
        img.onerror = callback;
      }
      return img.src = imageUrl;
    };

    Dropzone.prototype.processQueue = function() {
      var i, parallelUploads, processingLength, queuedFiles;
      parallelUploads = this.options.parallelUploads;
      processingLength = this.getUploadingFiles().length;
      i = processingLength;
      if (processingLength >= parallelUploads) {
        return;
      }
      queuedFiles = this.getQueuedFiles();
      if (!(queuedFiles.length > 0)) {
        return;
      }
      if (this.options.uploadMultiple) {
        return this.processFiles(queuedFiles.slice(0, parallelUploads - processingLength));
      } else {
        while (i < parallelUploads) {
          if (!queuedFiles.length) {
            return;
          }
          this.processFile(queuedFiles.shift());
          i++;
        }
      }
    };

    Dropzone.prototype.processFile = function(file) {
      return this.processFiles([file]);
    };

    Dropzone.prototype.processFiles = function(files) {
      var file, _i, _len;
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        file.processing = true;
        file.status = Dropzone.UPLOADING;
        this.emit("processing", file);
      }
      if (this.options.uploadMultiple) {
        this.emit("processingmultiple", files);
      }
      return this.uploadFiles(files);
    };

    Dropzone.prototype._getFilesWithXhr = function(xhr) {
      var file, files;
      return files = (function() {
        var _i, _len, _ref, _results;
        _ref = this.files;
        _results = [];
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          file = _ref[_i];
          if (file.xhr === xhr) {
            _results.push(file);
          }
        }
        return _results;
      }).call(this);
    };

    Dropzone.prototype.cancelUpload = function(file) {
      var groupedFile, groupedFiles, _i, _j, _len, _len1, _ref;
      if (file.status === Dropzone.UPLOADING) {
        groupedFiles = this._getFilesWithXhr(file.xhr);
        for (_i = 0, _len = groupedFiles.length; _i < _len; _i++) {
          groupedFile = groupedFiles[_i];
          groupedFile.status = Dropzone.CANCELED;
        }
        file.xhr.abort();
        for (_j = 0, _len1 = groupedFiles.length; _j < _len1; _j++) {
          groupedFile = groupedFiles[_j];
          this.emit("canceled", groupedFile);
        }
        if (this.options.uploadMultiple) {
          this.emit("canceledmultiple", groupedFiles);
        }
      } else if ((_ref = file.status) === Dropzone.ADDED || _ref === Dropzone.QUEUED) {
        file.status = Dropzone.CANCELED;
        this.emit("canceled", file);
        if (this.options.uploadMultiple) {
          this.emit("canceledmultiple", [file]);
        }
      }
      if (this.options.autoProcessQueue) {
        return this.processQueue();
      }
    };

    resolveOption = function() {
      var args, option;
      option = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
      if (typeof option === 'function') {
        return option.apply(this, args);
      }
      return option;
    };

    Dropzone.prototype.uploadFile = function(file) {
      return this.uploadFiles([file]);
    };

    Dropzone.prototype.uploadFiles = function(files) {
      var file, formData, handleError, headerName, headerValue, headers, i, input, inputName, inputType, key, method, option, progressObj, response, updateProgress, url, value, xhr, _i, _j, _k, _l, _len, _len1, _len2, _len3, _m, _ref, _ref1, _ref2, _ref3, _ref4, _ref5;
      xhr = new XMLHttpRequest();
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        file.xhr = xhr;
      }
      method = resolveOption(this.options.method, files);
      url = resolveOption(this.options.url, files);
      xhr.open(method, url, true);
      xhr.withCredentials = !!this.options.withCredentials;
      response = null;
      handleError = (function(_this) {
        return function() {
          var _j, _len1, _results;
          _results = [];
          for (_j = 0, _len1 = files.length; _j < _len1; _j++) {
            file = files[_j];
            _results.push(_this._errorProcessing(files, response || _this.options.dictResponseError.replace("{{statusCode}}", xhr.status), xhr));
          }
          return _results;
        };
      })(this);
      updateProgress = (function(_this) {
        return function(e) {
          var allFilesFinished, progress, _j, _k, _l, _len1, _len2, _len3, _results;
          if (e != null) {
            progress = 100 * e.loaded / e.total;
            for (_j = 0, _len1 = files.length; _j < _len1; _j++) {
              file = files[_j];
              file.upload = {
                progress: progress,
                total: e.total,
                bytesSent: e.loaded
              };
            }
          } else {
            allFilesFinished = true;
            progress = 100;
            for (_k = 0, _len2 = files.length; _k < _len2; _k++) {
              file = files[_k];
              if (!(file.upload.progress === 100 && file.upload.bytesSent === file.upload.total)) {
                allFilesFinished = false;
              }
              file.upload.progress = progress;
              file.upload.bytesSent = file.upload.total;
            }
            if (allFilesFinished) {
              return;
            }
          }
          _results = [];
          for (_l = 0, _len3 = files.length; _l < _len3; _l++) {
            file = files[_l];
            _results.push(_this.emit("uploadprogress", file, progress, file.upload.bytesSent));
          }
          return _results;
        };
      })(this);
      xhr.onload = (function(_this) {
        return function(e) {
          var _ref;
          if (files[0].status === Dropzone.CANCELED) {
            return;
          }
          if (xhr.readyState !== 4) {
            return;
          }
          response = xhr.responseText;
          if (xhr.getResponseHeader("content-type") && ~xhr.getResponseHeader("content-type").indexOf("application/json")) {
            try {
              response = JSON.parse(response);
            } catch (_error) {
              e = _error;
              response = "Invalid JSON response from server.";
            }
          }
          updateProgress();
          if (!((200 <= (_ref = xhr.status) && _ref < 300))) {
            return handleError();
          } else {
            return _this._finished(files, response, e);
          }
        };
      })(this);
      xhr.onerror = (function(_this) {
        return function() {
          if (files[0].status === Dropzone.CANCELED) {
            return;
          }
          return handleError();
        };
      })(this);
      progressObj = (_ref = xhr.upload) != null ? _ref : xhr;
      progressObj.onprogress = updateProgress;
      headers = {
        "Accept": "application/json",
        "Cache-Control": "no-cache",
        "X-Requested-With": "XMLHttpRequest"
      };
      if (this.options.headers) {
        extend(headers, this.options.headers);
      }
      for (headerName in headers) {
        headerValue = headers[headerName];
        if (headerValue) {
          xhr.setRequestHeader(headerName, headerValue);
        }
      }
      formData = new FormData();
      if (this.options.params) {
        _ref1 = this.options.params;
        for (key in _ref1) {
          value = _ref1[key];
          formData.append(key, value);
        }
      }
      for (_j = 0, _len1 = files.length; _j < _len1; _j++) {
        file = files[_j];
        this.emit("sending", file, xhr, formData);
      }
      if (this.options.uploadMultiple) {
        this.emit("sendingmultiple", files, xhr, formData);
      }
      if (this.element.tagName === "FORM") {
        _ref2 = this.element.querySelectorAll("input, textarea, select, button");
        for (_k = 0, _len2 = _ref2.length; _k < _len2; _k++) {
          input = _ref2[_k];
          inputName = input.getAttribute("name");
          inputType = input.getAttribute("type");
          if (input.tagName === "SELECT" && input.hasAttribute("multiple")) {
            _ref3 = input.options;
            for (_l = 0, _len3 = _ref3.length; _l < _len3; _l++) {
              option = _ref3[_l];
              if (option.selected) {
                formData.append(inputName, option.value);
              }
            }
          } else if (!inputType || ((_ref4 = inputType.toLowerCase()) !== "checkbox" && _ref4 !== "radio") || input.checked) {
            formData.append(inputName, input.value);
          }
        }
      }
      for (i = _m = 0, _ref5 = files.length - 1; 0 <= _ref5 ? _m <= _ref5 : _m >= _ref5; i = 0 <= _ref5 ? ++_m : --_m) {
        formData.append(this._getParamName(i), files[i], files[i].name);
      }
      return this.submitRequest(xhr, formData, files);
    };

    Dropzone.prototype.submitRequest = function(xhr, formData, files) {
      return xhr.send(formData);
    };

    Dropzone.prototype._finished = function(files, responseText, e) {
      var file, _i, _len;
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        file.status = Dropzone.SUCCESS;
        this.emit("success", file, responseText, e);
        this.emit("complete", file);
      }
      if (this.options.uploadMultiple) {
        this.emit("successmultiple", files, responseText, e);
        this.emit("completemultiple", files);
      }
      if (this.options.autoProcessQueue) {
        return this.processQueue();
      }
    };

    Dropzone.prototype._errorProcessing = function(files, message, xhr) {
      var file, _i, _len;
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        file.status = Dropzone.ERROR;
        this.emit("error", file, message, xhr);
        this.emit("complete", file);
      }
      if (this.options.uploadMultiple) {
        this.emit("errormultiple", files, message, xhr);
        this.emit("completemultiple", files);
      }
      if (this.options.autoProcessQueue) {
        return this.processQueue();
      }
    };

    return Dropzone;

  })(Emitter);

  Dropzone.version = "4.2.0";

  Dropzone.options = {};

  Dropzone.optionsForElement = function(element) {
    if (element.getAttribute("id")) {
      return Dropzone.options[camelize(element.getAttribute("id"))];
    } else {
      return void 0;
    }
  };

  Dropzone.instances = [];

  Dropzone.forElement = function(element) {
    if (typeof element === "string") {
      element = document.querySelector(element);
    }
    if ((element != null ? element.dropzone : void 0) == null) {
      throw new Error("No Dropzone found for given element. This is probably because you're trying to access it before Dropzone had the time to initialize. Use the `init` option to setup any additional observers on your Dropzone.");
    }
    return element.dropzone;
  };

  Dropzone.autoDiscover = true;

  Dropzone.discover = function() {
    var checkElements, dropzone, dropzones, _i, _len, _results;
    if (document.querySelectorAll) {
      dropzones = document.querySelectorAll(".dropzone");
    } else {
      dropzones = [];
      checkElements = function(elements) {
        var el, _i, _len, _results;
        _results = [];
        for (_i = 0, _len = elements.length; _i < _len; _i++) {
          el = elements[_i];
          if (/(^| )dropzone($| )/.test(el.className)) {
            _results.push(dropzones.push(el));
          } else {
            _results.push(void 0);
          }
        }
        return _results;
      };
      checkElements(document.getElementsByTagName("div"));
      checkElements(document.getElementsByTagName("form"));
    }
    _results = [];
    for (_i = 0, _len = dropzones.length; _i < _len; _i++) {
      dropzone = dropzones[_i];
      if (Dropzone.optionsForElement(dropzone) !== false) {
        _results.push(new Dropzone(dropzone));
      } else {
        _results.push(void 0);
      }
    }
    return _results;
  };

  Dropzone.blacklistedBrowsers = [/opera.*Macintosh.*version\/12/i];

  Dropzone.isBrowserSupported = function() {
    var capableBrowser, regex, _i, _len, _ref;
    capableBrowser = true;
    if (window.File && window.FileReader && window.FileList && window.Blob && window.FormData && document.querySelector) {
      if (!("classList" in document.createElement("a"))) {
        capableBrowser = false;
      } else {
        _ref = Dropzone.blacklistedBrowsers;
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          regex = _ref[_i];
          if (regex.test(navigator.userAgent)) {
            capableBrowser = false;
            continue;
          }
        }
      }
    } else {
      capableBrowser = false;
    }
    return capableBrowser;
  };

  without = function(list, rejectedItem) {
    var item, _i, _len, _results;
    _results = [];
    for (_i = 0, _len = list.length; _i < _len; _i++) {
      item = list[_i];
      if (item !== rejectedItem) {
        _results.push(item);
      }
    }
    return _results;
  };

  camelize = function(str) {
    return str.replace(/[\-_](\w)/g, function(match) {
      return match.charAt(1).toUpperCase();
    });
  };

  Dropzone.createElement = function(string) {
    var div;
    div = document.createElement("div");
    div.innerHTML = string;
    return div.childNodes[0];
  };

  Dropzone.elementInside = function(element, container) {
    if (element === container) {
      return true;
    }
    while (element = element.parentNode) {
      if (element === container) {
        return true;
      }
    }
    return false;
  };

  Dropzone.getElement = function(el, name) {
    var element;
    if (typeof el === "string") {
      element = document.querySelector(el);
    } else if (el.nodeType != null) {
      element = el;
    }
    if (element == null) {
      throw new Error("Invalid `" + name + "` option provided. Please provide a CSS selector or a plain HTML element.");
    }
    return element;
  };

  Dropzone.getElements = function(els, name) {
    var e, el, elements, _i, _j, _len, _len1, _ref;
    if (els instanceof Array) {
      elements = [];
      try {
        for (_i = 0, _len = els.length; _i < _len; _i++) {
          el = els[_i];
          elements.push(this.getElement(el, name));
        }
      } catch (_error) {
        e = _error;
        elements = null;
      }
    } else if (typeof els === "string") {
      elements = [];
      _ref = document.querySelectorAll(els);
      for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {
        el = _ref[_j];
        elements.push(el);
      }
    } else if (els.nodeType != null) {
      elements = [els];
    }
    if (!((elements != null) && elements.length)) {
      throw new Error("Invalid `" + name + "` option provided. Please provide a CSS selector, a plain HTML element or a list of those.");
    }
    return elements;
  };

  Dropzone.confirm = function(question, accepted, rejected) {
    if (window.confirm(question)) {
      return accepted();
    } else if (rejected != null) {
      return rejected();
    }
  };

  Dropzone.isValidFile = function(file, acceptedFiles) {
    var baseMimeType, mimeType, validType, _i, _len;
    if (!acceptedFiles) {
      return true;
    }
    acceptedFiles = acceptedFiles.split(",");
    mimeType = file.type;
    baseMimeType = mimeType.replace(/\/.*$/, "");
    for (_i = 0, _len = acceptedFiles.length; _i < _len; _i++) {
      validType = acceptedFiles[_i];
      validType = validType.trim();
      if (validType.charAt(0) === ".") {
        if (file.name.toLowerCase().indexOf(validType.toLowerCase(), file.name.length - validType.length) !== -1) {
          return true;
        }
      } else if (/\/\*$/.test(validType)) {
        if (baseMimeType === validType.replace(/\/.*$/, "")) {
          return true;
        }
      } else {
        if (mimeType === validType) {
          return true;
        }
      }
    }
    return false;
  };

  if (typeof jQuery !== "undefined" && jQuery !== null) {
    jQuery.fn.dropzone = function(options) {
      return this.each(function() {
        return new Dropzone(this, options);
      });
    };
  }

  if (typeof module !== "undefined" && module !== null) {
    module.exports = Dropzone;
  } else {
    window.Dropzone = Dropzone;
  }

  Dropzone.ADDED = "added";

  Dropzone.QUEUED = "queued";

  Dropzone.ACCEPTED = Dropzone.QUEUED;

  Dropzone.UPLOADING = "uploading";

  Dropzone.PROCESSING = Dropzone.UPLOADING;

  Dropzone.CANCELED = "canceled";

  Dropzone.ERROR = "error";

  Dropzone.SUCCESS = "success";


  /*
  
  Bugfix for iOS 6 and 7
  Source: http://stackoverflow.com/questions/11929099/html5-canvas-drawimage-ratio-bug-ios
  based on the work of https://github.com/stomita/ios-imagefile-megapixel
   */

  detectVerticalSquash = function(img) {
    var alpha, canvas, ctx, data, ey, ih, iw, py, ratio, sy;
    iw = img.naturalWidth;
    ih = img.naturalHeight;
    canvas = document.createElement("canvas");
    canvas.width = 1;
    canvas.height = ih;
    ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    data = ctx.getImageData(0, 0, 1, ih).data;
    sy = 0;
    ey = ih;
    py = ih;
    while (py > sy) {
      alpha = data[(py - 1) * 4 + 3];
      if (alpha === 0) {
        ey = py;
      } else {
        sy = py;
      }
      py = (ey + sy) >> 1;
    }
    ratio = py / ih;
    if (ratio === 0) {
      return 1;
    } else {
      return ratio;
    }
  };

  drawImageIOSFix = function(ctx, img, sx, sy, sw, sh, dx, dy, dw, dh) {
    var vertSquashRatio;
    vertSquashRatio = detectVerticalSquash(img);
    return ctx.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh / vertSquashRatio);
  };


  /*
   * contentloaded.js
   *
   * Author: Diego Perini (diego.perini at gmail.com)
   * Summary: cross-browser wrapper for DOMContentLoaded
   * Updated: 20101020
   * License: MIT
   * Version: 1.2
   *
   * URL:
   * http://javascript.nwbox.com/ContentLoaded/
   * http://javascript.nwbox.com/ContentLoaded/MIT-LICENSE
   */

  contentLoaded = function(win, fn) {
    var add, doc, done, init, poll, pre, rem, root, top;
    done = false;
    top = true;
    doc = win.document;
    root = doc.documentElement;
    add = (doc.addEventListener ? "addEventListener" : "attachEvent");
    rem = (doc.addEventListener ? "removeEventListener" : "detachEvent");
    pre = (doc.addEventListener ? "" : "on");
    init = function(e) {
      if (e.type === "readystatechange" && doc.readyState !== "complete") {
        return;
      }
      (e.type === "load" ? win : doc)[rem](pre + e.type, init, false);
      if (!done && (done = true)) {
        return fn.call(win, e.type || e);
      }
    };
    poll = function() {
      var e;
      try {
        root.doScroll("left");
      } catch (_error) {
        e = _error;
        setTimeout(poll, 50);
        return;
      }
      return init("poll");
    };
    if (doc.readyState !== "complete") {
      if (doc.createEventObject && root.doScroll) {
        try {
          top = !win.frameElement;
        } catch (_error) {}
        if (top) {
          poll();
        }
      }
      doc[add](pre + "DOMContentLoaded", init, false);
      doc[add](pre + "readystatechange", init, false);
      return win[add](pre + "load", init, false);
    }
  };

  Dropzone._autoDiscoverFunction = function() {
    if (Dropzone.autoDiscover) {
      return Dropzone.discover();
    }
  };

  contentLoaded(window, Dropzone._autoDiscoverFunction);

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js"), __webpack_require__("../../../node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "../../../node_modules/good-listener/src/is.js":
/***/ (function(module, exports) {

/**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.node = function(value) {
    return value !== undefined
        && value instanceof HTMLElement
        && value.nodeType === 1;
};

/**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.nodeList = function(value) {
    var type = Object.prototype.toString.call(value);

    return value !== undefined
        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
        && ('length' in value)
        && (value.length === 0 || exports.node(value[0]));
};

/**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.string = function(value) {
    return typeof value === 'string'
        || value instanceof String;
};

/**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.fn = function(value) {
    var type = Object.prototype.toString.call(value);

    return type === '[object Function]';
};


/***/ }),

/***/ "../../../node_modules/good-listener/src/listen.js":
/***/ (function(module, exports, __webpack_require__) {

var is = __webpack_require__("../../../node_modules/good-listener/src/is.js");
var delegate = __webpack_require__("../../../node_modules/delegate/src/delegate.js");

/**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listen(target, type, callback) {
    if (!target && !type && !callback) {
        throw new Error('Missing required arguments');
    }

    if (!is.string(type)) {
        throw new TypeError('Second argument must be a String');
    }

    if (!is.fn(callback)) {
        throw new TypeError('Third argument must be a Function');
    }

    if (is.node(target)) {
        return listenNode(target, type, callback);
    }
    else if (is.nodeList(target)) {
        return listenNodeList(target, type, callback);
    }
    else if (is.string(target)) {
        return listenSelector(target, type, callback);
    }
    else {
        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
    }
}

/**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNode(node, type, callback) {
    node.addEventListener(type, callback);

    return {
        destroy: function() {
            node.removeEventListener(type, callback);
        }
    }
}

/**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNodeList(nodeList, type, callback) {
    Array.prototype.forEach.call(nodeList, function(node) {
        node.addEventListener(type, callback);
    });

    return {
        destroy: function() {
            Array.prototype.forEach.call(nodeList, function(node) {
                node.removeEventListener(type, callback);
            });
        }
    }
}

/**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenSelector(selector, type, callback) {
    return delegate(document.body, selector, type, callback);
}

module.exports = listen;


/***/ }),

/***/ "../../../node_modules/jed/jed.js":
/***/ (function(module, exports, __webpack_require__) {

/**
 * @preserve jed.js https://github.com/SlexAxton/Jed
 */
/*
-----------
A gettext compatible i18n library for modern JavaScript Applications

by Alex Sexton - AlexSexton [at] gmail - @SlexAxton

MIT License

A jQuery Foundation project - requires CLA to contribute -
https://contribute.jquery.org/CLA/



Jed offers the entire applicable GNU gettext spec'd set of
functions, but also offers some nicer wrappers around them.
The api for gettext was written for a language with no function
overloading, so Jed allows a little more of that.

Many thanks to Joshua I. Miller - unrtst@cpan.org - who wrote
gettext.js back in 2008. I was able to vet a lot of my ideas
against his. I also made sure Jed passed against his tests
in order to offer easy upgrades -- jsgettext.berlios.de
*/
(function (root, undef) {

  // Set up some underscore-style functions, if you already have
  // underscore, feel free to delete this section, and use it
  // directly, however, the amount of functions used doesn't
  // warrant having underscore as a full dependency.
  // Underscore 1.3.0 was used to port and is licensed
  // under the MIT License by Jeremy Ashkenas.
  var ArrayProto    = Array.prototype,
      ObjProto      = Object.prototype,
      slice         = ArrayProto.slice,
      hasOwnProp    = ObjProto.hasOwnProperty,
      nativeForEach = ArrayProto.forEach,
      breaker       = {};

  // We're not using the OOP style _ so we don't need the
  // extra level of indirection. This still means that you
  // sub out for real `_` though.
  var _ = {
    forEach : function( obj, iterator, context ) {
      var i, l, key;
      if ( obj === null ) {
        return;
      }

      if ( nativeForEach && obj.forEach === nativeForEach ) {
        obj.forEach( iterator, context );
      }
      else if ( obj.length === +obj.length ) {
        for ( i = 0, l = obj.length; i < l; i++ ) {
          if ( i in obj && iterator.call( context, obj[i], i, obj ) === breaker ) {
            return;
          }
        }
      }
      else {
        for ( key in obj) {
          if ( hasOwnProp.call( obj, key ) ) {
            if ( iterator.call (context, obj[key], key, obj ) === breaker ) {
              return;
            }
          }
        }
      }
    },
    extend : function( obj ) {
      this.forEach( slice.call( arguments, 1 ), function ( source ) {
        for ( var prop in source ) {
          obj[prop] = source[prop];
        }
      });
      return obj;
    }
  };
  // END Miniature underscore impl

  // Jed is a constructor function
  var Jed = function ( options ) {
    // Some minimal defaults
    this.defaults = {
      "locale_data" : {
        "messages" : {
          "" : {
            "domain"       : "messages",
            "lang"         : "en",
            "plural_forms" : "nplurals=2; plural=(n != 1);"
          }
          // There are no default keys, though
        }
      },
      // The default domain if one is missing
      "domain" : "messages",
      // enable debug mode to log untranslated strings to the console
      "debug" : false
    };

    // Mix in the sent options with the default options
    this.options = _.extend( {}, this.defaults, options );
    this.textdomain( this.options.domain );

    if ( options.domain && ! this.options.locale_data[ this.options.domain ] ) {
      throw new Error('Text domain set to non-existent domain: `' + options.domain + '`');
    }
  };

  // The gettext spec sets this character as the default
  // delimiter for context lookups.
  // e.g.: context\u0004key
  // If your translation company uses something different,
  // just change this at any time and it will use that instead.
  Jed.context_delimiter = String.fromCharCode( 4 );

  function getPluralFormFunc ( plural_form_string ) {
    return Jed.PF.compile( plural_form_string || "nplurals=2; plural=(n != 1);");
  }

  function Chain( key, i18n ){
    this._key = key;
    this._i18n = i18n;
  }

  // Create a chainable api for adding args prettily
  _.extend( Chain.prototype, {
    onDomain : function ( domain ) {
      this._domain = domain;
      return this;
    },
    withContext : function ( context ) {
      this._context = context;
      return this;
    },
    ifPlural : function ( num, pkey ) {
      this._val = num;
      this._pkey = pkey;
      return this;
    },
    fetch : function ( sArr ) {
      if ( {}.toString.call( sArr ) != '[object Array]' ) {
        sArr = [].slice.call(arguments, 0);
      }
      return ( sArr && sArr.length ? Jed.sprintf : function(x){ return x; } )(
        this._i18n.dcnpgettext(this._domain, this._context, this._key, this._pkey, this._val),
        sArr
      );
    }
  });

  // Add functions to the Jed prototype.
  // These will be the functions on the object that's returned
  // from creating a `new Jed()`
  // These seem redundant, but they gzip pretty well.
  _.extend( Jed.prototype, {
    // The sexier api start point
    translate : function ( key ) {
      return new Chain( key, this );
    },

    textdomain : function ( domain ) {
      if ( ! domain ) {
        return this._textdomain;
      }
      this._textdomain = domain;
    },

    gettext : function ( key ) {
      return this.dcnpgettext.call( this, undef, undef, key );
    },

    dgettext : function ( domain, key ) {
     return this.dcnpgettext.call( this, domain, undef, key );
    },

    dcgettext : function ( domain , key /*, category */ ) {
      // Ignores the category anyways
      return this.dcnpgettext.call( this, domain, undef, key );
    },

    ngettext : function ( skey, pkey, val ) {
      return this.dcnpgettext.call( this, undef, undef, skey, pkey, val );
    },

    dngettext : function ( domain, skey, pkey, val ) {
      return this.dcnpgettext.call( this, domain, undef, skey, pkey, val );
    },

    dcngettext : function ( domain, skey, pkey, val/*, category */) {
      return this.dcnpgettext.call( this, domain, undef, skey, pkey, val );
    },

    pgettext : function ( context, key ) {
      return this.dcnpgettext.call( this, undef, context, key );
    },

    dpgettext : function ( domain, context, key ) {
      return this.dcnpgettext.call( this, domain, context, key );
    },

    dcpgettext : function ( domain, context, key/*, category */) {
      return this.dcnpgettext.call( this, domain, context, key );
    },

    npgettext : function ( context, skey, pkey, val ) {
      return this.dcnpgettext.call( this, undef, context, skey, pkey, val );
    },

    dnpgettext : function ( domain, context, skey, pkey, val ) {
      return this.dcnpgettext.call( this, domain, context, skey, pkey, val );
    },

    // The most fully qualified gettext function. It has every option.
    // Since it has every option, we can use it from every other method.
    // This is the bread and butter.
    // Technically there should be one more argument in this function for 'Category',
    // but since we never use it, we might as well not waste the bytes to define it.
    dcnpgettext : function ( domain, context, singular_key, plural_key, val ) {
      // Set some defaults

      plural_key = plural_key || singular_key;

      // Use the global domain default if one
      // isn't explicitly passed in
      domain = domain || this._textdomain;

      var fallback;

      // Handle special cases

      // No options found
      if ( ! this.options ) {
        // There's likely something wrong, but we'll return the correct key for english
        // We do this by instantiating a brand new Jed instance with the default set
        // for everything that could be broken.
        fallback = new Jed();
        return fallback.dcnpgettext.call( fallback, undefined, undefined, singular_key, plural_key, val );
      }

      // No translation data provided
      if ( ! this.options.locale_data ) {
        throw new Error('No locale data provided.');
      }

      if ( ! this.options.locale_data[ domain ] ) {
        throw new Error('Domain `' + domain + '` was not found.');
      }

      if ( ! this.options.locale_data[ domain ][ "" ] ) {
        throw new Error('No locale meta information provided.');
      }

      // Make sure we have a truthy key. Otherwise we might start looking
      // into the empty string key, which is the options for the locale
      // data.
      if ( ! singular_key ) {
        throw new Error('No translation key found.');
      }

      var key  = context ? context + Jed.context_delimiter + singular_key : singular_key,
          locale_data = this.options.locale_data,
          dict = locale_data[ domain ],
          defaultConf = (locale_data.messages || this.defaults.locale_data.messages)[""],
          pluralForms = dict[""].plural_forms || dict[""]["Plural-Forms"] || dict[""]["plural-forms"] || defaultConf.plural_forms || defaultConf["Plural-Forms"] || defaultConf["plural-forms"],
          val_list,
          res;

      var val_idx;
      if (val === undefined) {
        // No value passed in; assume singular key lookup.
        val_idx = 0;

      } else {
        // Value has been passed in; use plural-forms calculations.

        // Handle invalid numbers, but try casting strings for good measure
        if ( typeof val != 'number' ) {
          val = parseInt( val, 10 );

          if ( isNaN( val ) ) {
            throw new Error('The number that was passed in is not a number.');
          }
        }

        val_idx = getPluralFormFunc(pluralForms)(val);
      }

      // Throw an error if a domain isn't found
      if ( ! dict ) {
        throw new Error('No domain named `' + domain + '` could be found.');
      }

      val_list = dict[ key ];

      // If there is no match, then revert back to
      // english style singular/plural with the keys passed in.
      if ( ! val_list || val_idx > val_list.length ) {
        if (this.options.missing_key_callback) {
          this.options.missing_key_callback(key, domain);
        }
        res = [ singular_key, plural_key ];

        // collect untranslated strings
        if (this.options.debug===true) {
          console.log(res[ getPluralFormFunc(pluralForms)( val ) ]);
        }
        return res[ getPluralFormFunc()( val ) ];
      }

      res = val_list[ val_idx ];

      // This includes empty strings on purpose
      if ( ! res  ) {
        res = [ singular_key, plural_key ];
        return res[ getPluralFormFunc()( val ) ];
      }
      return res;
    }
  });


  // We add in sprintf capabilities for post translation value interolation
  // This is not internally used, so you can remove it if you have this
  // available somewhere else, or want to use a different system.

  // We _slightly_ modify the normal sprintf behavior to more gracefully handle
  // undefined values.

  /**
   sprintf() for JavaScript 0.7-beta1
   http://www.diveintojavascript.com/projects/javascript-sprintf

   Copyright (c) Alexandru Marasteanu <alexaholic [at) gmail (dot] com>
   All rights reserved.

   Redistribution and use in source and binary forms, with or without
   modification, are permitted provided that the following conditions are met:
       * Redistributions of source code must retain the above copyright
         notice, this list of conditions and the following disclaimer.
       * Redistributions in binary form must reproduce the above copyright
         notice, this list of conditions and the following disclaimer in the
         documentation and/or other materials provided with the distribution.
       * Neither the name of sprintf() for JavaScript nor the
         names of its contributors may be used to endorse or promote products
         derived from this software without specific prior written permission.

   THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
   ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
   WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
   DISCLAIMED. IN NO EVENT SHALL Alexandru Marasteanu BE LIABLE FOR ANY
   DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
   (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
   LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
   ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
   (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
   SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
  */
  var sprintf = (function() {
    function get_type(variable) {
      return Object.prototype.toString.call(variable).slice(8, -1).toLowerCase();
    }
    function str_repeat(input, multiplier) {
      for (var output = []; multiplier > 0; output[--multiplier] = input) {/* do nothing */}
      return output.join('');
    }

    var str_format = function() {
      if (!str_format.cache.hasOwnProperty(arguments[0])) {
        str_format.cache[arguments[0]] = str_format.parse(arguments[0]);
      }
      return str_format.format.call(null, str_format.cache[arguments[0]], arguments);
    };

    str_format.format = function(parse_tree, argv) {
      var cursor = 1, tree_length = parse_tree.length, node_type = '', arg, output = [], i, k, match, pad, pad_character, pad_length;
      for (i = 0; i < tree_length; i++) {
        node_type = get_type(parse_tree[i]);
        if (node_type === 'string') {
          output.push(parse_tree[i]);
        }
        else if (node_type === 'array') {
          match = parse_tree[i]; // convenience purposes only
          if (match[2]) { // keyword argument
            arg = argv[cursor];
            for (k = 0; k < match[2].length; k++) {
              if (!arg.hasOwnProperty(match[2][k])) {
                throw(sprintf('[sprintf] property "%s" does not exist', match[2][k]));
              }
              arg = arg[match[2][k]];
            }
          }
          else if (match[1]) { // positional argument (explicit)
            arg = argv[match[1]];
          }
          else { // positional argument (implicit)
            arg = argv[cursor++];
          }

          if (/[^s]/.test(match[8]) && (get_type(arg) != 'number')) {
            throw(sprintf('[sprintf] expecting number but found %s', get_type(arg)));
          }

          // Jed EDIT
          if ( typeof arg == 'undefined' || arg === null ) {
            arg = '';
          }
          // Jed EDIT

          switch (match[8]) {
            case 'b': arg = arg.toString(2); break;
            case 'c': arg = String.fromCharCode(arg); break;
            case 'd': arg = parseInt(arg, 10); break;
            case 'e': arg = match[7] ? arg.toExponential(match[7]) : arg.toExponential(); break;
            case 'f': arg = match[7] ? parseFloat(arg).toFixed(match[7]) : parseFloat(arg); break;
            case 'o': arg = arg.toString(8); break;
            case 's': arg = ((arg = String(arg)) && match[7] ? arg.substring(0, match[7]) : arg); break;
            case 'u': arg = Math.abs(arg); break;
            case 'x': arg = arg.toString(16); break;
            case 'X': arg = arg.toString(16).toUpperCase(); break;
          }
          arg = (/[def]/.test(match[8]) && match[3] && arg >= 0 ? '+'+ arg : arg);
          pad_character = match[4] ? match[4] == '0' ? '0' : match[4].charAt(1) : ' ';
          pad_length = match[6] - String(arg).length;
          pad = match[6] ? str_repeat(pad_character, pad_length) : '';
          output.push(match[5] ? arg + pad : pad + arg);
        }
      }
      return output.join('');
    };

    str_format.cache = {};

    str_format.parse = function(fmt) {
      var _fmt = fmt, match = [], parse_tree = [], arg_names = 0;
      while (_fmt) {
        if ((match = /^[^\x25]+/.exec(_fmt)) !== null) {
          parse_tree.push(match[0]);
        }
        else if ((match = /^\x25{2}/.exec(_fmt)) !== null) {
          parse_tree.push('%');
        }
        else if ((match = /^\x25(?:([1-9]\d*)\$|\(([^\)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-fosuxX])/.exec(_fmt)) !== null) {
          if (match[2]) {
            arg_names |= 1;
            var field_list = [], replacement_field = match[2], field_match = [];
            if ((field_match = /^([a-z_][a-z_\d]*)/i.exec(replacement_field)) !== null) {
              field_list.push(field_match[1]);
              while ((replacement_field = replacement_field.substring(field_match[0].length)) !== '') {
                if ((field_match = /^\.([a-z_][a-z_\d]*)/i.exec(replacement_field)) !== null) {
                  field_list.push(field_match[1]);
                }
                else if ((field_match = /^\[(\d+)\]/.exec(replacement_field)) !== null) {
                  field_list.push(field_match[1]);
                }
                else {
                  throw('[sprintf] huh?');
                }
              }
            }
            else {
              throw('[sprintf] huh?');
            }
            match[2] = field_list;
          }
          else {
            arg_names |= 2;
          }
          if (arg_names === 3) {
            throw('[sprintf] mixing positional and named placeholders is not (yet) supported');
          }
          parse_tree.push(match);
        }
        else {
          throw('[sprintf] huh?');
        }
        _fmt = _fmt.substring(match[0].length);
      }
      return parse_tree;
    };

    return str_format;
  })();

  var vsprintf = function(fmt, argv) {
    argv.unshift(fmt);
    return sprintf.apply(null, argv);
  };

  Jed.parse_plural = function ( plural_forms, n ) {
    plural_forms = plural_forms.replace(/n/g, n);
    return Jed.parse_expression(plural_forms);
  };

  Jed.sprintf = function ( fmt, args ) {
    if ( {}.toString.call( args ) == '[object Array]' ) {
      return vsprintf( fmt, [].slice.call(args) );
    }
    return sprintf.apply(this, [].slice.call(arguments) );
  };

  Jed.prototype.sprintf = function () {
    return Jed.sprintf.apply(this, arguments);
  };
  // END sprintf Implementation

  // Start the Plural forms section
  // This is a full plural form expression parser. It is used to avoid
  // running 'eval' or 'new Function' directly against the plural
  // forms.
  //
  // This can be important if you get translations done through a 3rd
  // party vendor. I encourage you to use this instead, however, I
  // also will provide a 'precompiler' that you can use at build time
  // to output valid/safe function representations of the plural form
  // expressions. This means you can build this code out for the most
  // part.
  Jed.PF = {};

  Jed.PF.parse = function ( p ) {
    var plural_str = Jed.PF.extractPluralExpr( p );
    return Jed.PF.parser.parse.call(Jed.PF.parser, plural_str);
  };

  Jed.PF.compile = function ( p ) {
    // Handle trues and falses as 0 and 1
    function imply( val ) {
      return (val === true ? 1 : val ? val : 0);
    }

    var ast = Jed.PF.parse( p );
    return function ( n ) {
      return imply( Jed.PF.interpreter( ast )( n ) );
    };
  };

  Jed.PF.interpreter = function ( ast ) {
    return function ( n ) {
      var res;
      switch ( ast.type ) {
        case 'GROUP':
          return Jed.PF.interpreter( ast.expr )( n );
        case 'TERNARY':
          if ( Jed.PF.interpreter( ast.expr )( n ) ) {
            return Jed.PF.interpreter( ast.truthy )( n );
          }
          return Jed.PF.interpreter( ast.falsey )( n );
        case 'OR':
          return Jed.PF.interpreter( ast.left )( n ) || Jed.PF.interpreter( ast.right )( n );
        case 'AND':
          return Jed.PF.interpreter( ast.left )( n ) && Jed.PF.interpreter( ast.right )( n );
        case 'LT':
          return Jed.PF.interpreter( ast.left )( n ) < Jed.PF.interpreter( ast.right )( n );
        case 'GT':
          return Jed.PF.interpreter( ast.left )( n ) > Jed.PF.interpreter( ast.right )( n );
        case 'LTE':
          return Jed.PF.interpreter( ast.left )( n ) <= Jed.PF.interpreter( ast.right )( n );
        case 'GTE':
          return Jed.PF.interpreter( ast.left )( n ) >= Jed.PF.interpreter( ast.right )( n );
        case 'EQ':
          return Jed.PF.interpreter( ast.left )( n ) == Jed.PF.interpreter( ast.right )( n );
        case 'NEQ':
          return Jed.PF.interpreter( ast.left )( n ) != Jed.PF.interpreter( ast.right )( n );
        case 'MOD':
          return Jed.PF.interpreter( ast.left )( n ) % Jed.PF.interpreter( ast.right )( n );
        case 'VAR':
          return n;
        case 'NUM':
          return ast.val;
        default:
          throw new Error("Invalid Token found.");
      }
    };
  };

  Jed.PF.extractPluralExpr = function ( p ) {
    // trim first
    p = p.replace(/^\s\s*/, '').replace(/\s\s*$/, '');

    if (! /;\s*$/.test(p)) {
      p = p.concat(';');
    }

    var nplurals_re = /nplurals\=(\d+);/,
        plural_re = /plural\=(.*);/,
        nplurals_matches = p.match( nplurals_re ),
        res = {},
        plural_matches;

    // Find the nplurals number
    if ( nplurals_matches.length > 1 ) {
      res.nplurals = nplurals_matches[1];
    }
    else {
      throw new Error('nplurals not found in plural_forms string: ' + p );
    }

    // remove that data to get to the formula
    p = p.replace( nplurals_re, "" );
    plural_matches = p.match( plural_re );

    if (!( plural_matches && plural_matches.length > 1 ) ) {
      throw new Error('`plural` expression not found: ' + p);
    }
    return plural_matches[ 1 ];
  };

  /* Jison generated parser */
  Jed.PF.parser = (function(){

var parser = {trace: function trace() { },
yy: {},
symbols_: {"error":2,"expressions":3,"e":4,"EOF":5,"?":6,":":7,"||":8,"&&":9,"<":10,"<=":11,">":12,">=":13,"!=":14,"==":15,"%":16,"(":17,")":18,"n":19,"NUMBER":20,"$accept":0,"$end":1},
terminals_: {2:"error",5:"EOF",6:"?",7:":",8:"||",9:"&&",10:"<",11:"<=",12:">",13:">=",14:"!=",15:"==",16:"%",17:"(",18:")",19:"n",20:"NUMBER"},
productions_: [0,[3,2],[4,5],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,1],[4,1]],
performAction: function anonymous(yytext,yyleng,yylineno,yy,yystate,$$,_$) {

var $0 = $$.length - 1;
switch (yystate) {
case 1: return { type : 'GROUP', expr: $$[$0-1] };
break;
case 2:this.$ = { type: 'TERNARY', expr: $$[$0-4], truthy : $$[$0-2], falsey: $$[$0] };
break;
case 3:this.$ = { type: "OR", left: $$[$0-2], right: $$[$0] };
break;
case 4:this.$ = { type: "AND", left: $$[$0-2], right: $$[$0] };
break;
case 5:this.$ = { type: 'LT', left: $$[$0-2], right: $$[$0] };
break;
case 6:this.$ = { type: 'LTE', left: $$[$0-2], right: $$[$0] };
break;
case 7:this.$ = { type: 'GT', left: $$[$0-2], right: $$[$0] };
break;
case 8:this.$ = { type: 'GTE', left: $$[$0-2], right: $$[$0] };
break;
case 9:this.$ = { type: 'NEQ', left: $$[$0-2], right: $$[$0] };
break;
case 10:this.$ = { type: 'EQ', left: $$[$0-2], right: $$[$0] };
break;
case 11:this.$ = { type: 'MOD', left: $$[$0-2], right: $$[$0] };
break;
case 12:this.$ = { type: 'GROUP', expr: $$[$0-1] };
break;
case 13:this.$ = { type: 'VAR' };
break;
case 14:this.$ = { type: 'NUM', val: Number(yytext) };
break;
}
},
table: [{3:1,4:2,17:[1,3],19:[1,4],20:[1,5]},{1:[3]},{5:[1,6],6:[1,7],8:[1,8],9:[1,9],10:[1,10],11:[1,11],12:[1,12],13:[1,13],14:[1,14],15:[1,15],16:[1,16]},{4:17,17:[1,3],19:[1,4],20:[1,5]},{5:[2,13],6:[2,13],7:[2,13],8:[2,13],9:[2,13],10:[2,13],11:[2,13],12:[2,13],13:[2,13],14:[2,13],15:[2,13],16:[2,13],18:[2,13]},{5:[2,14],6:[2,14],7:[2,14],8:[2,14],9:[2,14],10:[2,14],11:[2,14],12:[2,14],13:[2,14],14:[2,14],15:[2,14],16:[2,14],18:[2,14]},{1:[2,1]},{4:18,17:[1,3],19:[1,4],20:[1,5]},{4:19,17:[1,3],19:[1,4],20:[1,5]},{4:20,17:[1,3],19:[1,4],20:[1,5]},{4:21,17:[1,3],19:[1,4],20:[1,5]},{4:22,17:[1,3],19:[1,4],20:[1,5]},{4:23,17:[1,3],19:[1,4],20:[1,5]},{4:24,17:[1,3],19:[1,4],20:[1,5]},{4:25,17:[1,3],19:[1,4],20:[1,5]},{4:26,17:[1,3],19:[1,4],20:[1,5]},{4:27,17:[1,3],19:[1,4],20:[1,5]},{6:[1,7],8:[1,8],9:[1,9],10:[1,10],11:[1,11],12:[1,12],13:[1,13],14:[1,14],15:[1,15],16:[1,16],18:[1,28]},{6:[1,7],7:[1,29],8:[1,8],9:[1,9],10:[1,10],11:[1,11],12:[1,12],13:[1,13],14:[1,14],15:[1,15],16:[1,16]},{5:[2,3],6:[2,3],7:[2,3],8:[2,3],9:[1,9],10:[1,10],11:[1,11],12:[1,12],13:[1,13],14:[1,14],15:[1,15],16:[1,16],18:[2,3]},{5:[2,4],6:[2,4],7:[2,4],8:[2,4],9:[2,4],10:[1,10],11:[1,11],12:[1,12],13:[1,13],14:[1,14],15:[1,15],16:[1,16],18:[2,4]},{5:[2,5],6:[2,5],7:[2,5],8:[2,5],9:[2,5],10:[2,5],11:[2,5],12:[2,5],13:[2,5],14:[2,5],15:[2,5],16:[1,16],18:[2,5]},{5:[2,6],6:[2,6],7:[2,6],8:[2,6],9:[2,6],10:[2,6],11:[2,6],12:[2,6],13:[2,6],14:[2,6],15:[2,6],16:[1,16],18:[2,6]},{5:[2,7],6:[2,7],7:[2,7],8:[2,7],9:[2,7],10:[2,7],11:[2,7],12:[2,7],13:[2,7],14:[2,7],15:[2,7],16:[1,16],18:[2,7]},{5:[2,8],6:[2,8],7:[2,8],8:[2,8],9:[2,8],10:[2,8],11:[2,8],12:[2,8],13:[2,8],14:[2,8],15:[2,8],16:[1,16],18:[2,8]},{5:[2,9],6:[2,9],7:[2,9],8:[2,9],9:[2,9],10:[2,9],11:[2,9],12:[2,9],13:[2,9],14:[2,9],15:[2,9],16:[1,16],18:[2,9]},{5:[2,10],6:[2,10],7:[2,10],8:[2,10],9:[2,10],10:[2,10],11:[2,10],12:[2,10],13:[2,10],14:[2,10],15:[2,10],16:[1,16],18:[2,10]},{5:[2,11],6:[2,11],7:[2,11],8:[2,11],9:[2,11],10:[2,11],11:[2,11],12:[2,11],13:[2,11],14:[2,11],15:[2,11],16:[2,11],18:[2,11]},{5:[2,12],6:[2,12],7:[2,12],8:[2,12],9:[2,12],10:[2,12],11:[2,12],12:[2,12],13:[2,12],14:[2,12],15:[2,12],16:[2,12],18:[2,12]},{4:30,17:[1,3],19:[1,4],20:[1,5]},{5:[2,2],6:[1,7],7:[2,2],8:[1,8],9:[1,9],10:[1,10],11:[1,11],12:[1,12],13:[1,13],14:[1,14],15:[1,15],16:[1,16],18:[2,2]}],
defaultActions: {6:[2,1]},
parseError: function parseError(str, hash) {
    throw new Error(str);
},
parse: function parse(input) {
    var self = this,
        stack = [0],
        vstack = [null], // semantic value stack
        lstack = [], // location stack
        table = this.table,
        yytext = '',
        yylineno = 0,
        yyleng = 0,
        recovering = 0,
        TERROR = 2,
        EOF = 1;

    //this.reductionCount = this.shiftCount = 0;

    this.lexer.setInput(input);
    this.lexer.yy = this.yy;
    this.yy.lexer = this.lexer;
    if (typeof this.lexer.yylloc == 'undefined')
        this.lexer.yylloc = {};
    var yyloc = this.lexer.yylloc;
    lstack.push(yyloc);

    if (typeof this.yy.parseError === 'function')
        this.parseError = this.yy.parseError;

    function popStack (n) {
        stack.length = stack.length - 2*n;
        vstack.length = vstack.length - n;
        lstack.length = lstack.length - n;
    }

    function lex() {
        var token;
        token = self.lexer.lex() || 1; // $end = 1
        // if token isn't its numeric value, convert
        if (typeof token !== 'number') {
            token = self.symbols_[token] || token;
        }
        return token;
    }

    var symbol, preErrorSymbol, state, action, a, r, yyval={},p,len,newState, expected;
    while (true) {
        // retreive state number from top of stack
        state = stack[stack.length-1];

        // use default actions if available
        if (this.defaultActions[state]) {
            action = this.defaultActions[state];
        } else {
            if (symbol == null)
                symbol = lex();
            // read action for current state and first input
            action = table[state] && table[state][symbol];
        }

        // handle parse error
        _handle_error:
        if (typeof action === 'undefined' || !action.length || !action[0]) {

            if (!recovering) {
                // Report error
                expected = [];
                for (p in table[state]) if (this.terminals_[p] && p > 2) {
                    expected.push("'"+this.terminals_[p]+"'");
                }
                var errStr = '';
                if (this.lexer.showPosition) {
                    errStr = 'Parse error on line '+(yylineno+1)+":\n"+this.lexer.showPosition()+"\nExpecting "+expected.join(', ') + ", got '" + this.terminals_[symbol]+ "'";
                } else {
                    errStr = 'Parse error on line '+(yylineno+1)+": Unexpected " +
                                  (symbol == 1 /*EOF*/ ? "end of input" :
                                              ("'"+(this.terminals_[symbol] || symbol)+"'"));
                }
                this.parseError(errStr,
                    {text: this.lexer.match, token: this.terminals_[symbol] || symbol, line: this.lexer.yylineno, loc: yyloc, expected: expected});
            }

            // just recovered from another error
            if (recovering == 3) {
                if (symbol == EOF) {
                    throw new Error(errStr || 'Parsing halted.');
                }

                // discard current lookahead and grab another
                yyleng = this.lexer.yyleng;
                yytext = this.lexer.yytext;
                yylineno = this.lexer.yylineno;
                yyloc = this.lexer.yylloc;
                symbol = lex();
            }

            // try to recover from error
            while (1) {
                // check for error recovery rule in this state
                if ((TERROR.toString()) in table[state]) {
                    break;
                }
                if (state == 0) {
                    throw new Error(errStr || 'Parsing halted.');
                }
                popStack(1);
                state = stack[stack.length-1];
            }

            preErrorSymbol = symbol; // save the lookahead token
            symbol = TERROR;         // insert generic error symbol as new lookahead
            state = stack[stack.length-1];
            action = table[state] && table[state][TERROR];
            recovering = 3; // allow 3 real symbols to be shifted before reporting a new error
        }

        // this shouldn't happen, unless resolve defaults are off
        if (action[0] instanceof Array && action.length > 1) {
            throw new Error('Parse Error: multiple actions possible at state: '+state+', token: '+symbol);
        }

        switch (action[0]) {

            case 1: // shift
                //this.shiftCount++;

                stack.push(symbol);
                vstack.push(this.lexer.yytext);
                lstack.push(this.lexer.yylloc);
                stack.push(action[1]); // push state
                symbol = null;
                if (!preErrorSymbol) { // normal execution/no error
                    yyleng = this.lexer.yyleng;
                    yytext = this.lexer.yytext;
                    yylineno = this.lexer.yylineno;
                    yyloc = this.lexer.yylloc;
                    if (recovering > 0)
                        recovering--;
                } else { // error just occurred, resume old lookahead f/ before error
                    symbol = preErrorSymbol;
                    preErrorSymbol = null;
                }
                break;

            case 2: // reduce
                //this.reductionCount++;

                len = this.productions_[action[1]][1];

                // perform semantic action
                yyval.$ = vstack[vstack.length-len]; // default to $$ = $1
                // default location, uses first token for firsts, last for lasts
                yyval._$ = {
                    first_line: lstack[lstack.length-(len||1)].first_line,
                    last_line: lstack[lstack.length-1].last_line,
                    first_column: lstack[lstack.length-(len||1)].first_column,
                    last_column: lstack[lstack.length-1].last_column
                };
                r = this.performAction.call(yyval, yytext, yyleng, yylineno, this.yy, action[1], vstack, lstack);

                if (typeof r !== 'undefined') {
                    return r;
                }

                // pop off stack
                if (len) {
                    stack = stack.slice(0,-1*len*2);
                    vstack = vstack.slice(0, -1*len);
                    lstack = lstack.slice(0, -1*len);
                }

                stack.push(this.productions_[action[1]][0]);    // push nonterminal (reduce)
                vstack.push(yyval.$);
                lstack.push(yyval._$);
                // goto new state = table[STATE][NONTERMINAL]
                newState = table[stack[stack.length-2]][stack[stack.length-1]];
                stack.push(newState);
                break;

            case 3: // accept
                return true;
        }

    }

    return true;
}};/* Jison generated lexer */
var lexer = (function(){

var lexer = ({EOF:1,
parseError:function parseError(str, hash) {
        if (this.yy.parseError) {
            this.yy.parseError(str, hash);
        } else {
            throw new Error(str);
        }
    },
setInput:function (input) {
        this._input = input;
        this._more = this._less = this.done = false;
        this.yylineno = this.yyleng = 0;
        this.yytext = this.matched = this.match = '';
        this.conditionStack = ['INITIAL'];
        this.yylloc = {first_line:1,first_column:0,last_line:1,last_column:0};
        return this;
    },
input:function () {
        var ch = this._input[0];
        this.yytext+=ch;
        this.yyleng++;
        this.match+=ch;
        this.matched+=ch;
        var lines = ch.match(/\n/);
        if (lines) this.yylineno++;
        this._input = this._input.slice(1);
        return ch;
    },
unput:function (ch) {
        this._input = ch + this._input;
        return this;
    },
more:function () {
        this._more = true;
        return this;
    },
pastInput:function () {
        var past = this.matched.substr(0, this.matched.length - this.match.length);
        return (past.length > 20 ? '...':'') + past.substr(-20).replace(/\n/g, "");
    },
upcomingInput:function () {
        var next = this.match;
        if (next.length < 20) {
            next += this._input.substr(0, 20-next.length);
        }
        return (next.substr(0,20)+(next.length > 20 ? '...':'')).replace(/\n/g, "");
    },
showPosition:function () {
        var pre = this.pastInput();
        var c = new Array(pre.length + 1).join("-");
        return pre + this.upcomingInput() + "\n" + c+"^";
    },
next:function () {
        if (this.done) {
            return this.EOF;
        }
        if (!this._input) this.done = true;

        var token,
            match,
            col,
            lines;
        if (!this._more) {
            this.yytext = '';
            this.match = '';
        }
        var rules = this._currentRules();
        for (var i=0;i < rules.length; i++) {
            match = this._input.match(this.rules[rules[i]]);
            if (match) {
                lines = match[0].match(/\n.*/g);
                if (lines) this.yylineno += lines.length;
                this.yylloc = {first_line: this.yylloc.last_line,
                               last_line: this.yylineno+1,
                               first_column: this.yylloc.last_column,
                               last_column: lines ? lines[lines.length-1].length-1 : this.yylloc.last_column + match[0].length}
                this.yytext += match[0];
                this.match += match[0];
                this.matches = match;
                this.yyleng = this.yytext.length;
                this._more = false;
                this._input = this._input.slice(match[0].length);
                this.matched += match[0];
                token = this.performAction.call(this, this.yy, this, rules[i],this.conditionStack[this.conditionStack.length-1]);
                if (token) return token;
                else return;
            }
        }
        if (this._input === "") {
            return this.EOF;
        } else {
            this.parseError('Lexical error on line '+(this.yylineno+1)+'. Unrecognized text.\n'+this.showPosition(),
                    {text: "", token: null, line: this.yylineno});
        }
    },
lex:function lex() {
        var r = this.next();
        if (typeof r !== 'undefined') {
            return r;
        } else {
            return this.lex();
        }
    },
begin:function begin(condition) {
        this.conditionStack.push(condition);
    },
popState:function popState() {
        return this.conditionStack.pop();
    },
_currentRules:function _currentRules() {
        return this.conditions[this.conditionStack[this.conditionStack.length-1]].rules;
    },
topState:function () {
        return this.conditionStack[this.conditionStack.length-2];
    },
pushState:function begin(condition) {
        this.begin(condition);
    }});
lexer.performAction = function anonymous(yy,yy_,$avoiding_name_collisions,YY_START) {

var YYSTATE=YY_START;
switch($avoiding_name_collisions) {
case 0:/* skip whitespace */
break;
case 1:return 20
break;
case 2:return 19
break;
case 3:return 8
break;
case 4:return 9
break;
case 5:return 6
break;
case 6:return 7
break;
case 7:return 11
break;
case 8:return 13
break;
case 9:return 10
break;
case 10:return 12
break;
case 11:return 14
break;
case 12:return 15
break;
case 13:return 16
break;
case 14:return 17
break;
case 15:return 18
break;
case 16:return 5
break;
case 17:return 'INVALID'
break;
}
};
lexer.rules = [/^\s+/,/^[0-9]+(\.[0-9]+)?\b/,/^n\b/,/^\|\|/,/^&&/,/^\?/,/^:/,/^<=/,/^>=/,/^</,/^>/,/^!=/,/^==/,/^%/,/^\(/,/^\)/,/^$/,/^./];
lexer.conditions = {"INITIAL":{"rules":[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17],"inclusive":true}};return lexer;})()
parser.lexer = lexer;
return parser;
})();
// End parser

  // Handle node, amd, and global systems
  if (true) {
    if (typeof module !== 'undefined' && module.exports) {
      exports = module.exports = Jed;
    }
    exports.Jed = Jed;
  }
  else {
    if (typeof define === 'function' && define.amd) {
      define(function() {
        return Jed;
      });
    }
    // Leak a global regardless of module system
    root['Jed'] = Jed;
  }

})(this);


/***/ }),

/***/ "../../../node_modules/js-cookie/src/js.cookie.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.1.3
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader = false;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function init (converter) {
		function api (key, value, attributes) {
			var result;
			if (typeof document === 'undefined') {
				return;
			}

			// Write

			if (arguments.length > 1) {
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					var expires = new Date();
					expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
					attributes.expires = expires;
				}

				try {
					result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				if (!converter.write) {
					value = encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
				} else {
					value = converter.write(value, key);
				}

				key = encodeURIComponent(String(key));
				key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
				key = key.replace(/[\(\)]/g, escape);

				return (document.cookie = [
					key, '=', value,
					attributes.expires ? '; expires=' + attributes.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
					attributes.path ? '; path=' + attributes.path : '',
					attributes.domain ? '; domain=' + attributes.domain : '',
					attributes.secure ? '; secure' : ''
				].join(''));
			}

			// Read

			if (!key) {
				result = {};
			}

			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling "get()"
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var rdecode = /(%[0-9A-Z]{2})+/g;
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = parts[0].replace(rdecode, decodeURIComponent);
					cookie = converter.read ?
						converter.read(cookie, name) : converter(cookie, name) ||
						cookie.replace(rdecode, decodeURIComponent);

					if (this.json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					if (key === name) {
						result = cookie;
						break;
					}

					if (!key) {
						result[name] = cookie;
					}
				} catch (e) {}
			}

			return result;
		}

		api.set = api;
		api.get = function (key) {
			return api.call(api, key);
		};
		api.getJSON = function () {
			return api.apply({
				json: true
			}, [].slice.call(arguments));
		};
		api.defaults = {};

		api.remove = function (key, attributes) {
			api(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),

/***/ "../../../node_modules/mousetrap/mousetrap.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*global define:false */
/**
 * Copyright 2013 Craig Campbell
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Mousetrap is a simple keyboard shortcut library for Javascript with
 * no external dependencies
 *
 * @version 1.4.6
 * @url craig.is/killing/mice
 */
(function(window, document, undefined) {

    /**
     * mapping of special keycodes to their corresponding keys
     *
     * everything in this dictionary cannot use keypress events
     * so it has to be here to map to the correct keycodes for
     * keyup/keydown events
     *
     * @type {Object}
     */
    var _MAP = {
            8: 'backspace',
            9: 'tab',
            13: 'enter',
            16: 'shift',
            17: 'ctrl',
            18: 'alt',
            20: 'capslock',
            27: 'esc',
            32: 'space',
            33: 'pageup',
            34: 'pagedown',
            35: 'end',
            36: 'home',
            37: 'left',
            38: 'up',
            39: 'right',
            40: 'down',
            45: 'ins',
            46: 'del',
            91: 'meta',
            93: 'meta',
            224: 'meta'
        },

        /**
         * mapping for special characters so they can support
         *
         * this dictionary is only used incase you want to bind a
         * keyup or keydown event to one of these keys
         *
         * @type {Object}
         */
        _KEYCODE_MAP = {
            106: '*',
            107: '+',
            109: '-',
            110: '.',
            111 : '/',
            186: ';',
            187: '=',
            188: ',',
            189: '-',
            190: '.',
            191: '/',
            192: '`',
            219: '[',
            220: '\\',
            221: ']',
            222: '\''
        },

        /**
         * this is a mapping of keys that require shift on a US keypad
         * back to the non shift equivelents
         *
         * this is so you can use keyup events with these keys
         *
         * note that this will only work reliably on US keyboards
         *
         * @type {Object}
         */
        _SHIFT_MAP = {
            '~': '`',
            '!': '1',
            '@': '2',
            '#': '3',
            '$': '4',
            '%': '5',
            '^': '6',
            '&': '7',
            '*': '8',
            '(': '9',
            ')': '0',
            '_': '-',
            '+': '=',
            ':': ';',
            '\"': '\'',
            '<': ',',
            '>': '.',
            '?': '/',
            '|': '\\'
        },

        /**
         * this is a list of special strings you can use to map
         * to modifier keys when you specify your keyboard shortcuts
         *
         * @type {Object}
         */
        _SPECIAL_ALIASES = {
            'option': 'alt',
            'command': 'meta',
            'return': 'enter',
            'escape': 'esc',
            'mod': /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? 'meta' : 'ctrl'
        },

        /**
         * variable to store the flipped version of _MAP from above
         * needed to check if we should use keypress or not when no action
         * is specified
         *
         * @type {Object|undefined}
         */
        _REVERSE_MAP,

        /**
         * a list of all the callbacks setup via Mousetrap.bind()
         *
         * @type {Object}
         */
        _callbacks = {},

        /**
         * direct map of string combinations to callbacks used for trigger()
         *
         * @type {Object}
         */
        _directMap = {},

        /**
         * keeps track of what level each sequence is at since multiple
         * sequences can start out with the same sequence
         *
         * @type {Object}
         */
        _sequenceLevels = {},

        /**
         * variable to store the setTimeout call
         *
         * @type {null|number}
         */
        _resetTimer,

        /**
         * temporary state where we will ignore the next keyup
         *
         * @type {boolean|string}
         */
        _ignoreNextKeyup = false,

        /**
         * temporary state where we will ignore the next keypress
         *
         * @type {boolean}
         */
        _ignoreNextKeypress = false,

        /**
         * are we currently inside of a sequence?
         * type of action ("keyup" or "keydown" or "keypress") or false
         *
         * @type {boolean|string}
         */
        _nextExpectedAction = false;

    /**
     * loop through the f keys, f1 to f19 and add them to the map
     * programatically
     */
    for (var i = 1; i < 20; ++i) {
        _MAP[111 + i] = 'f' + i;
    }

    /**
     * loop through to map numbers on the numeric keypad
     */
    for (i = 0; i <= 9; ++i) {
        _MAP[i + 96] = i;
    }

    /**
     * cross browser add event method
     *
     * @param {Element|HTMLDocument} object
     * @param {string} type
     * @param {Function} callback
     * @returns void
     */
    function _addEvent(object, type, callback) {
        if (object.addEventListener) {
            object.addEventListener(type, callback, false);
            return;
        }

        object.attachEvent('on' + type, callback);
    }

    /**
     * takes the event and returns the key character
     *
     * @param {Event} e
     * @return {string}
     */
    function _characterFromEvent(e) {

        // for keypress events we should return the character as is
        if (e.type == 'keypress') {
            var character = String.fromCharCode(e.which);

            // if the shift key is not pressed then it is safe to assume
            // that we want the character to be lowercase.  this means if
            // you accidentally have caps lock on then your key bindings
            // will continue to work
            //
            // the only side effect that might not be desired is if you
            // bind something like 'A' cause you want to trigger an
            // event when capital A is pressed caps lock will no longer
            // trigger the event.  shift+a will though.
            if (!e.shiftKey) {
                character = character.toLowerCase();
            }

            return character;
        }

        // for non keypress events the special maps are needed
        if (_MAP[e.which]) {
            return _MAP[e.which];
        }

        if (_KEYCODE_MAP[e.which]) {
            return _KEYCODE_MAP[e.which];
        }

        // if it is not in the special map

        // with keydown and keyup events the character seems to always
        // come in as an uppercase character whether you are pressing shift
        // or not.  we should make sure it is always lowercase for comparisons
        return String.fromCharCode(e.which).toLowerCase();
    }

    /**
     * checks if two arrays are equal
     *
     * @param {Array} modifiers1
     * @param {Array} modifiers2
     * @returns {boolean}
     */
    function _modifiersMatch(modifiers1, modifiers2) {
        return modifiers1.sort().join(',') === modifiers2.sort().join(',');
    }

    /**
     * resets all sequence counters except for the ones passed in
     *
     * @param {Object} doNotReset
     * @returns void
     */
    function _resetSequences(doNotReset) {
        doNotReset = doNotReset || {};

        var activeSequences = false,
            key;

        for (key in _sequenceLevels) {
            if (doNotReset[key]) {
                activeSequences = true;
                continue;
            }
            _sequenceLevels[key] = 0;
        }

        if (!activeSequences) {
            _nextExpectedAction = false;
        }
    }

    /**
     * finds all callbacks that match based on the keycode, modifiers,
     * and action
     *
     * @param {string} character
     * @param {Array} modifiers
     * @param {Event|Object} e
     * @param {string=} sequenceName - name of the sequence we are looking for
     * @param {string=} combination
     * @param {number=} level
     * @returns {Array}
     */
    function _getMatches(character, modifiers, e, sequenceName, combination, level) {
        var i,
            callback,
            matches = [],
            action = e.type;

        // if there are no events related to this keycode
        if (!_callbacks[character]) {
            return [];
        }

        // if a modifier key is coming up on its own we should allow it
        if (action == 'keyup' && _isModifier(character)) {
            modifiers = [character];
        }

        // loop through all callbacks for the key that was pressed
        // and see if any of them match
        for (i = 0; i < _callbacks[character].length; ++i) {
            callback = _callbacks[character][i];

            // if a sequence name is not specified, but this is a sequence at
            // the wrong level then move onto the next match
            if (!sequenceName && callback.seq && _sequenceLevels[callback.seq] != callback.level) {
                continue;
            }

            // if the action we are looking for doesn't match the action we got
            // then we should keep going
            if (action != callback.action) {
                continue;
            }

            // if this is a keypress event and the meta key and control key
            // are not pressed that means that we need to only look at the
            // character, otherwise check the modifiers as well
            //
            // chrome will not fire a keypress if meta or control is down
            // safari will fire a keypress if meta or meta+shift is down
            // firefox will fire a keypress if meta or control is down
            if ((action == 'keypress' && !e.metaKey && !e.ctrlKey) || _modifiersMatch(modifiers, callback.modifiers)) {

                // when you bind a combination or sequence a second time it
                // should overwrite the first one.  if a sequenceName or
                // combination is specified in this call it does just that
                //
                // @todo make deleting its own method?
                var deleteCombo = !sequenceName && callback.combo == combination;
                var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;
                if (deleteCombo || deleteSequence) {
                    _callbacks[character].splice(i, 1);
                }

                matches.push(callback);
            }
        }

        return matches;
    }

    /**
     * takes a key event and figures out what the modifiers are
     *
     * @param {Event} e
     * @returns {Array}
     */
    function _eventModifiers(e) {
        var modifiers = [];

        if (e.shiftKey) {
            modifiers.push('shift');
        }

        if (e.altKey) {
            modifiers.push('alt');
        }

        if (e.ctrlKey) {
            modifiers.push('ctrl');
        }

        if (e.metaKey) {
            modifiers.push('meta');
        }

        return modifiers;
    }

    /**
     * prevents default for this event
     *
     * @param {Event} e
     * @returns void
     */
    function _preventDefault(e) {
        if (e.preventDefault) {
            e.preventDefault();
            return;
        }

        e.returnValue = false;
    }

    /**
     * stops propogation for this event
     *
     * @param {Event} e
     * @returns void
     */
    function _stopPropagation(e) {
        if (e.stopPropagation) {
            e.stopPropagation();
            return;
        }

        e.cancelBubble = true;
    }

    /**
     * actually calls the callback function
     *
     * if your callback function returns false this will use the jquery
     * convention - prevent default and stop propogation on the event
     *
     * @param {Function} callback
     * @param {Event} e
     * @returns void
     */
    function _fireCallback(callback, e, combo, sequence) {

        // if this event should not happen stop here
        if (Mousetrap.stopCallback(e, e.target || e.srcElement, combo, sequence)) {
            return;
        }

        if (callback(e, combo) === false) {
            _preventDefault(e);
            _stopPropagation(e);
        }
    }

    /**
     * handles a character key event
     *
     * @param {string} character
     * @param {Array} modifiers
     * @param {Event} e
     * @returns void
     */
    function _handleKey(character, modifiers, e) {
        var callbacks = _getMatches(character, modifiers, e),
            i,
            doNotReset = {},
            maxLevel = 0,
            processedSequenceCallback = false;

        // Calculate the maxLevel for sequences so we can only execute the longest callback sequence
        for (i = 0; i < callbacks.length; ++i) {
            if (callbacks[i].seq) {
                maxLevel = Math.max(maxLevel, callbacks[i].level);
            }
        }

        // loop through matching callbacks for this key event
        for (i = 0; i < callbacks.length; ++i) {

            // fire for all sequence callbacks
            // this is because if for example you have multiple sequences
            // bound such as "g i" and "g t" they both need to fire the
            // callback for matching g cause otherwise you can only ever
            // match the first one
            if (callbacks[i].seq) {

                // only fire callbacks for the maxLevel to prevent
                // subsequences from also firing
                //
                // for example 'a option b' should not cause 'option b' to fire
                // even though 'option b' is part of the other sequence
                //
                // any sequences that do not match here will be discarded
                // below by the _resetSequences call
                if (callbacks[i].level != maxLevel) {
                    continue;
                }

                processedSequenceCallback = true;

                // keep a list of which sequences were matches for later
                doNotReset[callbacks[i].seq] = 1;
                _fireCallback(callbacks[i].callback, e, callbacks[i].combo, callbacks[i].seq);
                continue;
            }

            // if there were no sequence matches but we are still here
            // that means this is a regular match so we should fire that
            if (!processedSequenceCallback) {
                _fireCallback(callbacks[i].callback, e, callbacks[i].combo);
            }
        }

        // if the key you pressed matches the type of sequence without
        // being a modifier (ie "keyup" or "keypress") then we should
        // reset all sequences that were not matched by this event
        //
        // this is so, for example, if you have the sequence "h a t" and you
        // type "h e a r t" it does not match.  in this case the "e" will
        // cause the sequence to reset
        //
        // modifier keys are ignored because you can have a sequence
        // that contains modifiers such as "enter ctrl+space" and in most
        // cases the modifier key will be pressed before the next key
        //
        // also if you have a sequence such as "ctrl+b a" then pressing the
        // "b" key will trigger a "keypress" and a "keydown"
        //
        // the "keydown" is expected when there is a modifier, but the
        // "keypress" ends up matching the _nextExpectedAction since it occurs
        // after and that causes the sequence to reset
        //
        // we ignore keypresses in a sequence that directly follow a keydown
        // for the same character
        var ignoreThisKeypress = e.type == 'keypress' && _ignoreNextKeypress;
        if (e.type == _nextExpectedAction && !_isModifier(character) && !ignoreThisKeypress) {
            _resetSequences(doNotReset);
        }

        _ignoreNextKeypress = processedSequenceCallback && e.type == 'keydown';
    }

    /**
     * handles a keydown event
     *
     * @param {Event} e
     * @returns void
     */
    function _handleKeyEvent(e) {

        // normalize e.which for key events
        // @see http://stackoverflow.com/questions/4285627/javascript-keycode-vs-charcode-utter-confusion
        if (typeof e.which !== 'number') {
            e.which = e.keyCode;
        }

        var character = _characterFromEvent(e);

        // no character found then stop
        if (!character) {
            return;
        }

        // need to use === for the character check because the character can be 0
        if (e.type == 'keyup' && _ignoreNextKeyup === character) {
            _ignoreNextKeyup = false;
            return;
        }

        Mousetrap.handleKey(character, _eventModifiers(e), e);
    }

    /**
     * determines if the keycode specified is a modifier key or not
     *
     * @param {string} key
     * @returns {boolean}
     */
    function _isModifier(key) {
        return key == 'shift' || key == 'ctrl' || key == 'alt' || key == 'meta';
    }

    /**
     * called to set a 1 second timeout on the specified sequence
     *
     * this is so after each key press in the sequence you have 1 second
     * to press the next key before you have to start over
     *
     * @returns void
     */
    function _resetSequenceTimer() {
        clearTimeout(_resetTimer);
        _resetTimer = setTimeout(_resetSequences, 1000);
    }

    /**
     * reverses the map lookup so that we can look for specific keys
     * to see what can and can't use keypress
     *
     * @return {Object}
     */
    function _getReverseMap() {
        if (!_REVERSE_MAP) {
            _REVERSE_MAP = {};
            for (var key in _MAP) {

                // pull out the numeric keypad from here cause keypress should
                // be able to detect the keys from the character
                if (key > 95 && key < 112) {
                    continue;
                }

                if (_MAP.hasOwnProperty(key)) {
                    _REVERSE_MAP[_MAP[key]] = key;
                }
            }
        }
        return _REVERSE_MAP;
    }

    /**
     * picks the best action based on the key combination
     *
     * @param {string} key - character for key
     * @param {Array} modifiers
     * @param {string=} action passed in
     */
    function _pickBestAction(key, modifiers, action) {

        // if no action was picked in we should try to pick the one
        // that we think would work best for this key
        if (!action) {
            action = _getReverseMap()[key] ? 'keydown' : 'keypress';
        }

        // modifier keys don't work as expected with keypress,
        // switch to keydown
        if (action == 'keypress' && modifiers.length) {
            action = 'keydown';
        }

        return action;
    }

    /**
     * binds a key sequence to an event
     *
     * @param {string} combo - combo specified in bind call
     * @param {Array} keys
     * @param {Function} callback
     * @param {string=} action
     * @returns void
     */
    function _bindSequence(combo, keys, callback, action) {

        // start off by adding a sequence level record for this combination
        // and setting the level to 0
        _sequenceLevels[combo] = 0;

        /**
         * callback to increase the sequence level for this sequence and reset
         * all other sequences that were active
         *
         * @param {string} nextAction
         * @returns {Function}
         */
        function _increaseSequence(nextAction) {
            return function() {
                _nextExpectedAction = nextAction;
                ++_sequenceLevels[combo];
                _resetSequenceTimer();
            };
        }

        /**
         * wraps the specified callback inside of another function in order
         * to reset all sequence counters as soon as this sequence is done
         *
         * @param {Event} e
         * @returns void
         */
        function _callbackAndReset(e) {
            _fireCallback(callback, e, combo);

            // we should ignore the next key up if the action is key down
            // or keypress.  this is so if you finish a sequence and
            // release the key the final key will not trigger a keyup
            if (action !== 'keyup') {
                _ignoreNextKeyup = _characterFromEvent(e);
            }

            // weird race condition if a sequence ends with the key
            // another sequence begins with
            setTimeout(_resetSequences, 10);
        }

        // loop through keys one at a time and bind the appropriate callback
        // function.  for any key leading up to the final one it should
        // increase the sequence. after the final, it should reset all sequences
        //
        // if an action is specified in the original bind call then that will
        // be used throughout.  otherwise we will pass the action that the
        // next key in the sequence should match.  this allows a sequence
        // to mix and match keypress and keydown events depending on which
        // ones are better suited to the key provided
        for (var i = 0; i < keys.length; ++i) {
            var isFinal = i + 1 === keys.length;
            var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence(action || _getKeyInfo(keys[i + 1]).action);
            _bindSingle(keys[i], wrappedCallback, action, combo, i);
        }
    }

    /**
     * Converts from a string key combination to an array
     *
     * @param  {string} combination like "command+shift+l"
     * @return {Array}
     */
    function _keysFromString(combination) {
        if (combination === '+') {
            return ['+'];
        }

        return combination.split('+');
    }

    /**
     * Gets info for a specific key combination
     *
     * @param  {string} combination key combination ("command+s" or "a" or "*")
     * @param  {string=} action
     * @returns {Object}
     */
    function _getKeyInfo(combination, action) {
        var keys,
            key,
            i,
            modifiers = [];

        // take the keys from this pattern and figure out what the actual
        // pattern is all about
        keys = _keysFromString(combination);

        for (i = 0; i < keys.length; ++i) {
            key = keys[i];

            // normalize key names
            if (_SPECIAL_ALIASES[key]) {
                key = _SPECIAL_ALIASES[key];
            }

            // if this is not a keypress event then we should
            // be smart about using shift keys
            // this will only work for US keyboards however
            if (action && action != 'keypress' && _SHIFT_MAP[key]) {
                key = _SHIFT_MAP[key];
                modifiers.push('shift');
            }

            // if this key is a modifier then add it to the list of modifiers
            if (_isModifier(key)) {
                modifiers.push(key);
            }
        }

        // depending on what the key combination is
        // we will try to pick the best event for it
        action = _pickBestAction(key, modifiers, action);

        return {
            key: key,
            modifiers: modifiers,
            action: action
        };
    }

    /**
     * binds a single keyboard combination
     *
     * @param {string} combination
     * @param {Function} callback
     * @param {string=} action
     * @param {string=} sequenceName - name of sequence if part of sequence
     * @param {number=} level - what part of the sequence the command is
     * @returns void
     */
    function _bindSingle(combination, callback, action, sequenceName, level) {

        // store a direct mapped reference for use with Mousetrap.trigger
        _directMap[combination + ':' + action] = callback;

        // make sure multiple spaces in a row become a single space
        combination = combination.replace(/\s+/g, ' ');

        var sequence = combination.split(' '),
            info;

        // if this pattern is a sequence of keys then run through this method
        // to reprocess each pattern one key at a time
        if (sequence.length > 1) {
            _bindSequence(combination, sequence, callback, action);
            return;
        }

        info = _getKeyInfo(combination, action);

        // make sure to initialize array if this is the first time
        // a callback is added for this key
        _callbacks[info.key] = _callbacks[info.key] || [];

        // remove an existing match if there is one
        _getMatches(info.key, info.modifiers, {type: info.action}, sequenceName, combination, level);

        // add this call back to the array
        // if it is a sequence put it at the beginning
        // if not put it at the end
        //
        // this is important because the way these are processed expects
        // the sequence ones to come first
        _callbacks[info.key][sequenceName ? 'unshift' : 'push']({
            callback: callback,
            modifiers: info.modifiers,
            action: info.action,
            seq: sequenceName,
            level: level,
            combo: combination
        });
    }

    /**
     * binds multiple combinations to the same callback
     *
     * @param {Array} combinations
     * @param {Function} callback
     * @param {string|undefined} action
     * @returns void
     */
    function _bindMultiple(combinations, callback, action) {
        for (var i = 0; i < combinations.length; ++i) {
            _bindSingle(combinations[i], callback, action);
        }
    }

    // start!
    _addEvent(document, 'keypress', _handleKeyEvent);
    _addEvent(document, 'keydown', _handleKeyEvent);
    _addEvent(document, 'keyup', _handleKeyEvent);

    var Mousetrap = {

        /**
         * binds an event to mousetrap
         *
         * can be a single key, a combination of keys separated with +,
         * an array of keys, or a sequence of keys separated by spaces
         *
         * be sure to list the modifier keys first to make sure that the
         * correct key ends up getting bound (the last key in the pattern)
         *
         * @param {string|Array} keys
         * @param {Function} callback
         * @param {string=} action - 'keypress', 'keydown', or 'keyup'
         * @returns void
         */
        bind: function(keys, callback, action) {
            keys = keys instanceof Array ? keys : [keys];
            _bindMultiple(keys, callback, action);
            return this;
        },

        /**
         * unbinds an event to mousetrap
         *
         * the unbinding sets the callback function of the specified key combo
         * to an empty function and deletes the corresponding key in the
         * _directMap dict.
         *
         * TODO: actually remove this from the _callbacks dictionary instead
         * of binding an empty function
         *
         * the keycombo+action has to be exactly the same as
         * it was defined in the bind method
         *
         * @param {string|Array} keys
         * @param {string} action
         * @returns void
         */
        unbind: function(keys, action) {
            return Mousetrap.bind(keys, function() {}, action);
        },

        /**
         * triggers an event that has already been bound
         *
         * @param {string} keys
         * @param {string=} action
         * @returns void
         */
        trigger: function(keys, action) {
            if (_directMap[keys + ':' + action]) {
                _directMap[keys + ':' + action]({}, keys);
            }
            return this;
        },

        /**
         * resets the library back to its initial state.  this is useful
         * if you want to clear out the current keyboard shortcuts and bind
         * new ones - for example if you switch to another page
         *
         * @returns void
         */
        reset: function() {
            _callbacks = {};
            _directMap = {};
            return this;
        },

       /**
        * should we stop this event before firing off callbacks
        *
        * @param {Event} e
        * @param {Element} element
        * @return {boolean}
        */
        stopCallback: function(e, element) {

            // if the element has the class "mousetrap" then no need to stop
            if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) {
                return false;
            }

            // stop for input, select, and textarea
            return element.tagName == 'INPUT' || element.tagName == 'SELECT' || element.tagName == 'TEXTAREA' || element.isContentEditable;
        },

        /**
         * exposes _handleKey publicly so it can be overwritten by extensions
         */
        handleKey: _handleKey
    };

    // expose mousetrap to the global object
    window.Mousetrap = Mousetrap;

    // expose mousetrap as an AMD module
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (Mousetrap),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
}) (window, document);


/***/ }),

/***/ "../../../node_modules/mousetrap/plugins/pause/mousetrap-pause.js":
/***/ (function(module, exports) {

/**
 * adds a pause and unpause method to Mousetrap
 * this allows you to enable or disable keyboard shortcuts
 * without having to reset Mousetrap and rebind everything
 */
/* global Mousetrap:true */
Mousetrap = (function(Mousetrap) {
    var self = Mousetrap,
        _originalStopCallback = self.stopCallback,
        enabled = true;

    self.stopCallback = function(e, element, combo) {
        if (!enabled) {
            return true;
        }

        return _originalStopCallback(e, element, combo);
    };

    self.pause = function() {
        enabled = false;
    };

    self.unpause = function() {
        enabled = true;
    };

    return self;
}) (Mousetrap);


/***/ }),

/***/ "../../../node_modules/pikaday/pikaday.js":
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Pikaday
 *
 * Copyright © 2014 David Bushell | BSD & MIT license | https://github.com/dbushell/Pikaday
 */

(function (root, factory)
{
    'use strict';

    var moment;
    if (true) {
        // CommonJS module
        // Load moment.js as an optional dependency
        try { moment = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"moment\""); e.code = 'MODULE_NOT_FOUND'; throw e; }())); } catch (e) {}
        module.exports = factory(moment);
    } else if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(function (req)
        {
            // Load moment.js as an optional dependency
            var id = 'moment';
            try { moment = req(id); } catch (e) {}
            return factory(moment);
        });
    } else {
        root.Pikaday = factory(root.moment);
    }
}(this, function (moment)
{
    'use strict';

    /**
     * feature detection and helper functions
     */
    var hasMoment = typeof moment === 'function',

    hasEventListeners = !!window.addEventListener,

    document = window.document,

    sto = window.setTimeout,

    addEvent = function(el, e, callback, capture)
    {
        if (hasEventListeners) {
            el.addEventListener(e, callback, !!capture);
        } else {
            el.attachEvent('on' + e, callback);
        }
    },

    removeEvent = function(el, e, callback, capture)
    {
        if (hasEventListeners) {
            el.removeEventListener(e, callback, !!capture);
        } else {
            el.detachEvent('on' + e, callback);
        }
    },

    fireEvent = function(el, eventName, data)
    {
        var ev;

        if (document.createEvent) {
            ev = document.createEvent('HTMLEvents');
            ev.initEvent(eventName, true, false);
            ev = extend(ev, data);
            el.dispatchEvent(ev);
        } else if (document.createEventObject) {
            ev = document.createEventObject();
            ev = extend(ev, data);
            el.fireEvent('on' + eventName, ev);
        }
    },

    trim = function(str)
    {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g,'');
    },

    hasClass = function(el, cn)
    {
        return (' ' + el.className + ' ').indexOf(' ' + cn + ' ') !== -1;
    },

    addClass = function(el, cn)
    {
        if (!hasClass(el, cn)) {
            el.className = (el.className === '') ? cn : el.className + ' ' + cn;
        }
    },

    removeClass = function(el, cn)
    {
        el.className = trim((' ' + el.className + ' ').replace(' ' + cn + ' ', ' '));
    },

    isArray = function(obj)
    {
        return (/Array/).test(Object.prototype.toString.call(obj));
    },

    isDate = function(obj)
    {
        return (/Date/).test(Object.prototype.toString.call(obj)) && !isNaN(obj.getTime());
    },

    isWeekend = function(date)
    {
        var day = date.getDay();
        return day === 0 || day === 6;
    },

    isLeapYear = function(year)
    {
        // solution by Matti Virkkunen: http://stackoverflow.com/a/4881951
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    },

    getDaysInMonth = function(year, month)
    {
        return [31, isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
    },

    setToStartOfDay = function(date)
    {
        if (isDate(date)) date.setHours(0,0,0,0);
    },

    compareDates = function(a,b)
    {
        // weak date comparison (use setToStartOfDay(date) to ensure correct result)
        return a.getTime() === b.getTime();
    },

    extend = function(to, from, overwrite)
    {
        var prop, hasProp;
        for (prop in from) {
            hasProp = to[prop] !== undefined;
            if (hasProp && typeof from[prop] === 'object' && from[prop] !== null && from[prop].nodeName === undefined) {
                if (isDate(from[prop])) {
                    if (overwrite) {
                        to[prop] = new Date(from[prop].getTime());
                    }
                }
                else if (isArray(from[prop])) {
                    if (overwrite) {
                        to[prop] = from[prop].slice(0);
                    }
                } else {
                    to[prop] = extend({}, from[prop], overwrite);
                }
            } else if (overwrite || !hasProp) {
                to[prop] = from[prop];
            }
        }
        return to;
    },

    adjustCalendar = function(calendar) {
        if (calendar.month < 0) {
            calendar.year -= Math.ceil(Math.abs(calendar.month)/12);
            calendar.month += 12;
        }
        if (calendar.month > 11) {
            calendar.year += Math.floor(Math.abs(calendar.month)/12);
            calendar.month -= 12;
        }
        return calendar;
    },

    /**
     * defaults and localisation
     */
    defaults = {

        // bind the picker to a form field
        field: null,

        // automatically show/hide the picker on `field` focus (default `true` if `field` is set)
        bound: undefined,

        // position of the datepicker, relative to the field (default to bottom & left)
        // ('bottom' & 'left' keywords are not used, 'top' & 'right' are modifier on the bottom/left position)
        position: 'bottom left',

        // automatically fit in the viewport even if it means repositioning from the position option
        reposition: true,

        // the default output format for `.toString()` and `field` value
        format: 'YYYY-MM-DD',

        // the initial date to view when first opened
        defaultDate: null,

        // make the `defaultDate` the initial selected value
        setDefaultDate: false,

        // first day of week (0: Sunday, 1: Monday etc)
        firstDay: 0,

        // the default flag for moment's strict date parsing
        formatStrict: false,

        // the minimum/earliest date that can be selected
        minDate: null,
        // the maximum/latest date that can be selected
        maxDate: null,

        // number of years either side, or array of upper/lower range
        yearRange: 10,

        // show week numbers at head of row
        showWeekNumber: false,

        // used internally (don't config outside)
        minYear: 0,
        maxYear: 9999,
        minMonth: undefined,
        maxMonth: undefined,

        startRange: null,
        endRange: null,

        isRTL: false,

        // Additional text to append to the year in the calendar title
        yearSuffix: '',

        // Render the month after year in the calendar title
        showMonthAfterYear: false,

        // Render days of the calendar grid that fall in the next or previous month
        showDaysInNextAndPreviousMonths: false,

        // how many months are visible
        numberOfMonths: 1,

        // when numberOfMonths is used, this will help you to choose where the main calendar will be (default `left`, can be set to `right`)
        // only used for the first display or when a selected date is not visible
        mainCalendar: 'left',

        // Specify a DOM element to render the calendar in
        container: undefined,

        // internationalization
        i18n: {
            previousMonth : 'Previous Month',
            nextMonth     : 'Next Month',
            months        : ['January','February','March','April','May','June','July','August','September','October','November','December'],
            weekdays      : ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
            weekdaysShort : ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']
        },

        // Theme Classname
        theme: null,

        // callback function
        onSelect: null,
        onOpen: null,
        onClose: null,
        onDraw: null
    },


    /**
     * templating functions to abstract HTML rendering
     */
    renderDayName = function(opts, day, abbr)
    {
        day += opts.firstDay;
        while (day >= 7) {
            day -= 7;
        }
        return abbr ? opts.i18n.weekdaysShort[day] : opts.i18n.weekdays[day];
    },

    renderDay = function(opts)
    {
        var arr = [];
        var ariaSelected = 'false';
        if (opts.isEmpty) {
            if (opts.showDaysInNextAndPreviousMonths) {
                arr.push('is-outside-current-month');
            } else {
                return '<td class="is-empty"></td>';
            }
        }
        if (opts.isDisabled) {
            arr.push('is-disabled');
        }
        if (opts.isToday) {
            arr.push('is-today');
        }
        if (opts.isSelected) {
            arr.push('is-selected');
            ariaSelected = 'true';
        }
        if (opts.isInRange) {
            arr.push('is-inrange');
        }
        if (opts.isStartRange) {
            arr.push('is-startrange');
        }
        if (opts.isEndRange) {
            arr.push('is-endrange');
        }
        return '<td data-day="' + opts.day + '" class="' + arr.join(' ') + '" aria-selected="' + ariaSelected + '">' +
                 '<button class="pika-button pika-day" type="button" ' +
                    'data-pika-year="' + opts.year + '" data-pika-month="' + opts.month + '" data-pika-day="' + opts.day + '">' +
                        opts.day +
                 '</button>' +
               '</td>';
    },

    renderWeek = function (d, m, y) {
        // Lifted from http://javascript.about.com/library/blweekyear.htm, lightly modified.
        var onejan = new Date(y, 0, 1),
            weekNum = Math.ceil((((new Date(y, m, d) - onejan) / 86400000) + onejan.getDay()+1)/7);
        return '<td class="pika-week">' + weekNum + '</td>';
    },

    renderRow = function(days, isRTL)
    {
        return '<tr>' + (isRTL ? days.reverse() : days).join('') + '</tr>';
    },

    renderBody = function(rows)
    {
        return '<tbody>' + rows.join('') + '</tbody>';
    },

    renderHead = function(opts)
    {
        var i, arr = [];
        if (opts.showWeekNumber) {
            arr.push('<th></th>');
        }
        for (i = 0; i < 7; i++) {
            arr.push('<th scope="col"><abbr title="' + renderDayName(opts, i) + '">' + renderDayName(opts, i, true) + '</abbr></th>');
        }
        return '<thead><tr>' + (opts.isRTL ? arr.reverse() : arr).join('') + '</tr></thead>';
    },

    renderTitle = function(instance, c, year, month, refYear, randId)
    {
        var i, j, arr,
            opts = instance._o,
            isMinYear = year === opts.minYear,
            isMaxYear = year === opts.maxYear,
            html = '<div id="' + randId + '" class="pika-title" role="heading" aria-live="assertive">',
            monthHtml,
            yearHtml,
            prev = true,
            next = true;

        for (arr = [], i = 0; i < 12; i++) {
            arr.push('<option value="' + (year === refYear ? i - c : 12 + i - c) + '"' +
                (i === month ? ' selected="selected"': '') +
                ((isMinYear && i < opts.minMonth) || (isMaxYear && i > opts.maxMonth) ? 'disabled="disabled"' : '') + '>' +
                opts.i18n.months[i] + '</option>');
        }

        monthHtml = '<div class="pika-label">' + opts.i18n.months[month] + '<select class="pika-select pika-select-month" tabindex="-1">' + arr.join('') + '</select></div>';

        if (isArray(opts.yearRange)) {
            i = opts.yearRange[0];
            j = opts.yearRange[1] + 1;
        } else {
            i = year - opts.yearRange;
            j = 1 + year + opts.yearRange;
        }

        for (arr = []; i < j && i <= opts.maxYear; i++) {
            if (i >= opts.minYear) {
                arr.push('<option value="' + i + '"' + (i === year ? ' selected="selected"': '') + '>' + (i) + '</option>');
            }
        }
        yearHtml = '<div class="pika-label">' + year + opts.yearSuffix + '<select class="pika-select pika-select-year" tabindex="-1">' + arr.join('') + '</select></div>';

        if (opts.showMonthAfterYear) {
            html += yearHtml + monthHtml;
        } else {
            html += monthHtml + yearHtml;
        }

        if (isMinYear && (month === 0 || opts.minMonth >= month)) {
            prev = false;
        }

        if (isMaxYear && (month === 11 || opts.maxMonth <= month)) {
            next = false;
        }

        if (c === 0) {
            html += '<button class="pika-prev' + (prev ? '' : ' is-disabled') + '" type="button">' + opts.i18n.previousMonth + '</button>';
        }
        if (c === (instance._o.numberOfMonths - 1) ) {
            html += '<button class="pika-next' + (next ? '' : ' is-disabled') + '" type="button">' + opts.i18n.nextMonth + '</button>';
        }

        return html += '</div>';
    },

    renderTable = function(opts, data, randId)
    {
        return '<table cellpadding="0" cellspacing="0" class="pika-table" role="grid" aria-labelledby="' + randId + '">' + renderHead(opts) + renderBody(data) + '</table>';
    },


    /**
     * Pikaday constructor
     */
    Pikaday = function(options)
    {
        var self = this,
            opts = self.config(options);

        self._onMouseDown = function(e)
        {
            if (!self._v) {
                return;
            }
            e = e || window.event;
            var target = e.target || e.srcElement;
            if (!target) {
                return;
            }

            if (!hasClass(target, 'is-disabled')) {
                if (hasClass(target, 'pika-button') && !hasClass(target, 'is-empty') && !hasClass(target.parentNode, 'is-disabled')) {
                    self.setDate(new Date(target.getAttribute('data-pika-year'), target.getAttribute('data-pika-month'), target.getAttribute('data-pika-day')));
                    if (opts.bound) {
                        sto(function() {
                            self.hide();
                            if (opts.field) {
                                opts.field.blur();
                            }
                        }, 100);
                    }
                }
                else if (hasClass(target, 'pika-prev')) {
                    self.prevMonth();
                }
                else if (hasClass(target, 'pika-next')) {
                    self.nextMonth();
                }
            }
            if (!hasClass(target, 'pika-select')) {
                // if this is touch event prevent mouse events emulation
                if (e.preventDefault) {
                    e.preventDefault();
                } else {
                    e.returnValue = false;
                    return false;
                }
            } else {
                self._c = true;
            }
        };

        self._onChange = function(e)
        {
            e = e || window.event;
            var target = e.target || e.srcElement;
            if (!target) {
                return;
            }
            if (hasClass(target, 'pika-select-month')) {
                self.gotoMonth(target.value);
            }
            else if (hasClass(target, 'pika-select-year')) {
                self.gotoYear(target.value);
            }
        };

        self._onKeyChange = function(e)
        {
            e = e || window.event;

            if (self.isVisible()) {

                switch(e.keyCode){
                    case 13:
                    case 27:
                        opts.field.blur();
                        break;
                    case 37:
                        e.preventDefault();
                        self.adjustDate('subtract', 1);
                        break;
                    case 38:
                        self.adjustDate('subtract', 7);
                        break;
                    case 39:
                        self.adjustDate('add', 1);
                        break;
                    case 40:
                        self.adjustDate('add', 7);
                        break;
                }
            }
        };

        self._onInputChange = function(e)
        {
            var date;

            if (e.firedBy === self) {
                return;
            }
            if (hasMoment) {
                date = moment(opts.field.value, opts.format, opts.formatStrict);
                date = (date && date.isValid()) ? date.toDate() : null;
            }
            else {
                date = new Date(Date.parse(opts.field.value));
            }
            if (isDate(date)) {
              self.setDate(date);
            }
            if (!self._v) {
                self.show();
            }
        };

        self._onInputFocus = function()
        {
            self.show();
        };

        self._onInputClick = function()
        {
            self.show();
        };

        self._onInputBlur = function()
        {
            // IE allows pika div to gain focus; catch blur the input field
            var pEl = document.activeElement;
            do {
                if (hasClass(pEl, 'pika-single')) {
                    return;
                }
            }
            while ((pEl = pEl.parentNode));

            if (!self._c) {
                self._b = sto(function() {
                    self.hide();
                }, 50);
            }
            self._c = false;
        };

        self._onClick = function(e)
        {
            e = e || window.event;
            var target = e.target || e.srcElement,
                pEl = target;
            if (!target) {
                return;
            }
            if (!hasEventListeners && hasClass(target, 'pika-select')) {
                if (!target.onchange) {
                    target.setAttribute('onchange', 'return;');
                    addEvent(target, 'change', self._onChange);
                }
            }
            do {
                if (hasClass(pEl, 'pika-single') || pEl === opts.trigger) {
                    return;
                }
            }
            while ((pEl = pEl.parentNode));
            if (self._v && target !== opts.trigger && pEl !== opts.trigger) {
                self.hide();
            }
        };

        self.el = document.createElement('div');
        self.el.className = 'pika-single' + (opts.isRTL ? ' is-rtl' : '') + (opts.theme ? ' ' + opts.theme : '');

        addEvent(self.el, 'mousedown', self._onMouseDown, true);
        addEvent(self.el, 'touchend', self._onMouseDown, true);
        addEvent(self.el, 'change', self._onChange);
        addEvent(document, 'keydown', self._onKeyChange);

        if (opts.field) {
            if (opts.container) {
                opts.container.appendChild(self.el);
            } else if (opts.bound) {
                document.body.appendChild(self.el);
            } else {
                opts.field.parentNode.insertBefore(self.el, opts.field.nextSibling);
            }
            addEvent(opts.field, 'change', self._onInputChange);

            if (!opts.defaultDate) {
                if (hasMoment && opts.field.value) {
                    opts.defaultDate = moment(opts.field.value, opts.format).toDate();
                } else {
                    opts.defaultDate = new Date(Date.parse(opts.field.value));
                }
                opts.setDefaultDate = true;
            }
        }

        var defDate = opts.defaultDate;

        if (isDate(defDate)) {
            if (opts.setDefaultDate) {
                self.setDate(defDate, true);
            } else {
                self.gotoDate(defDate);
            }
        } else {
            self.gotoDate(new Date());
        }

        if (opts.bound) {
            this.hide();
            self.el.className += ' is-bound';
            addEvent(opts.trigger, 'click', self._onInputClick);
            addEvent(opts.trigger, 'focus', self._onInputFocus);
            addEvent(opts.trigger, 'blur', self._onInputBlur);
        } else {
            this.show();
        }
    };


    /**
     * public Pikaday API
     */
    Pikaday.prototype = {


        /**
         * configure functionality
         */
        config: function(options)
        {
            if (!this._o) {
                this._o = extend({}, defaults, true);
            }

            var opts = extend(this._o, options, true);

            opts.isRTL = !!opts.isRTL;

            opts.field = (opts.field && opts.field.nodeName) ? opts.field : null;

            opts.theme = (typeof opts.theme) === 'string' && opts.theme ? opts.theme : null;

            opts.bound = !!(opts.bound !== undefined ? opts.field && opts.bound : opts.field);

            opts.trigger = (opts.trigger && opts.trigger.nodeName) ? opts.trigger : opts.field;

            opts.disableWeekends = !!opts.disableWeekends;

            opts.disableDayFn = (typeof opts.disableDayFn) === 'function' ? opts.disableDayFn : null;

            var nom = parseInt(opts.numberOfMonths, 10) || 1;
            opts.numberOfMonths = nom > 4 ? 4 : nom;

            if (!isDate(opts.minDate)) {
                opts.minDate = false;
            }
            if (!isDate(opts.maxDate)) {
                opts.maxDate = false;
            }
            if ((opts.minDate && opts.maxDate) && opts.maxDate < opts.minDate) {
                opts.maxDate = opts.minDate = false;
            }
            if (opts.minDate) {
                this.setMinDate(opts.minDate);
            }
            if (opts.maxDate) {
                this.setMaxDate(opts.maxDate);
            }

            if (isArray(opts.yearRange)) {
                var fallback = new Date().getFullYear() - 10;
                opts.yearRange[0] = parseInt(opts.yearRange[0], 10) || fallback;
                opts.yearRange[1] = parseInt(opts.yearRange[1], 10) || fallback;
            } else {
                opts.yearRange = Math.abs(parseInt(opts.yearRange, 10)) || defaults.yearRange;
                if (opts.yearRange > 100) {
                    opts.yearRange = 100;
                }
            }

            return opts;
        },

        /**
         * return a formatted string of the current selection (using Moment.js if available)
         */
        toString: function(format)
        {
            return !isDate(this._d) ? '' : hasMoment ? moment(this._d).format(format || this._o.format) : this._d.toDateString();
        },

        /**
         * return a Moment.js object of the current selection (if available)
         */
        getMoment: function()
        {
            return hasMoment ? moment(this._d) : null;
        },

        /**
         * set the current selection from a Moment.js object (if available)
         */
        setMoment: function(date, preventOnSelect)
        {
            if (hasMoment && moment.isMoment(date)) {
                this.setDate(date.toDate(), preventOnSelect);
            }
        },

        /**
         * return a Date object of the current selection with fallback for the current date
         */
        getDate: function()
        {
            return isDate(this._d) ? new Date(this._d.getTime()) : new Date();
        },

        /**
         * set the current selection
         */
        setDate: function(date, preventOnSelect)
        {
            if (!date) {
                this._d = null;

                if (this._o.field) {
                    this._o.field.value = '';
                    fireEvent(this._o.field, 'change', { firedBy: this });
                }

                return this.draw();
            }
            if (typeof date === 'string') {
                date = new Date(Date.parse(date));
            }
            if (!isDate(date)) {
                return;
            }

            var min = this._o.minDate,
                max = this._o.maxDate;

            if (isDate(min) && date < min) {
                date = min;
            } else if (isDate(max) && date > max) {
                date = max;
            }

            this._d = new Date(date.getTime());
            setToStartOfDay(this._d);
            this.gotoDate(this._d);

            if (this._o.field) {
                this._o.field.value = this.toString();
                fireEvent(this._o.field, 'change', { firedBy: this });
            }
            if (!preventOnSelect && typeof this._o.onSelect === 'function') {
                this._o.onSelect.call(this, this.getDate());
            }
        },

        /**
         * change view to a specific date
         */
        gotoDate: function(date)
        {
            var newCalendar = true;

            if (!isDate(date)) {
                return;
            }

            if (this.calendars) {
                var firstVisibleDate = new Date(this.calendars[0].year, this.calendars[0].month, 1),
                    lastVisibleDate = new Date(this.calendars[this.calendars.length-1].year, this.calendars[this.calendars.length-1].month, 1),
                    visibleDate = date.getTime();
                // get the end of the month
                lastVisibleDate.setMonth(lastVisibleDate.getMonth()+1);
                lastVisibleDate.setDate(lastVisibleDate.getDate()-1);
                newCalendar = (visibleDate < firstVisibleDate.getTime() || lastVisibleDate.getTime() < visibleDate);
            }

            if (newCalendar) {
                this.calendars = [{
                    month: date.getMonth(),
                    year: date.getFullYear()
                }];
                if (this._o.mainCalendar === 'right') {
                    this.calendars[0].month += 1 - this._o.numberOfMonths;
                }
            }

            this.adjustCalendars();
        },

        adjustDate: function(sign, days) {

            var day = this.getDate();
            var difference = parseInt(days)*24*60*60*1000;

            var newDay;

            if (sign === 'add') {
                newDay = new Date(day.valueOf() + difference);
            } else if (sign === 'subtract') {
                newDay = new Date(day.valueOf() - difference);
            }

            if (hasMoment) {
                if (sign === 'add') {
                    newDay = moment(day).add(days, "days").toDate();
                } else if (sign === 'subtract') {
                    newDay = moment(day).subtract(days, "days").toDate();
                }
            }

            this.setDate(newDay);
        },

        adjustCalendars: function() {
            this.calendars[0] = adjustCalendar(this.calendars[0]);
            for (var c = 1; c < this._o.numberOfMonths; c++) {
                this.calendars[c] = adjustCalendar({
                    month: this.calendars[0].month + c,
                    year: this.calendars[0].year
                });
            }
            this.draw();
        },

        gotoToday: function()
        {
            this.gotoDate(new Date());
        },

        /**
         * change view to a specific month (zero-index, e.g. 0: January)
         */
        gotoMonth: function(month)
        {
            if (!isNaN(month)) {
                this.calendars[0].month = parseInt(month, 10);
                this.adjustCalendars();
            }
        },

        nextMonth: function()
        {
            this.calendars[0].month++;
            this.adjustCalendars();
        },

        prevMonth: function()
        {
            this.calendars[0].month--;
            this.adjustCalendars();
        },

        /**
         * change view to a specific full year (e.g. "2012")
         */
        gotoYear: function(year)
        {
            if (!isNaN(year)) {
                this.calendars[0].year = parseInt(year, 10);
                this.adjustCalendars();
            }
        },

        /**
         * change the minDate
         */
        setMinDate: function(value)
        {
            if(value instanceof Date) {
                setToStartOfDay(value);
                this._o.minDate = value;
                this._o.minYear  = value.getFullYear();
                this._o.minMonth = value.getMonth();
            } else {
                this._o.minDate = defaults.minDate;
                this._o.minYear  = defaults.minYear;
                this._o.minMonth = defaults.minMonth;
                this._o.startRange = defaults.startRange;
            }

            this.draw();
        },

        /**
         * change the maxDate
         */
        setMaxDate: function(value)
        {
            if(value instanceof Date) {
                setToStartOfDay(value);
                this._o.maxDate = value;
                this._o.maxYear = value.getFullYear();
                this._o.maxMonth = value.getMonth();
            } else {
                this._o.maxDate = defaults.maxDate;
                this._o.maxYear = defaults.maxYear;
                this._o.maxMonth = defaults.maxMonth;
                this._o.endRange = defaults.endRange;
            }

            this.draw();
        },

        setStartRange: function(value)
        {
            this._o.startRange = value;
        },

        setEndRange: function(value)
        {
            this._o.endRange = value;
        },

        /**
         * refresh the HTML
         */
        draw: function(force)
        {
            if (!this._v && !force) {
                return;
            }
            var opts = this._o,
                minYear = opts.minYear,
                maxYear = opts.maxYear,
                minMonth = opts.minMonth,
                maxMonth = opts.maxMonth,
                html = '',
                randId;

            if (this._y <= minYear) {
                this._y = minYear;
                if (!isNaN(minMonth) && this._m < minMonth) {
                    this._m = minMonth;
                }
            }
            if (this._y >= maxYear) {
                this._y = maxYear;
                if (!isNaN(maxMonth) && this._m > maxMonth) {
                    this._m = maxMonth;
                }
            }

            randId = 'pika-title-' + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 2);

            for (var c = 0; c < opts.numberOfMonths; c++) {
                html += '<div class="pika-lendar">' + renderTitle(this, c, this.calendars[c].year, this.calendars[c].month, this.calendars[0].year, randId) + this.render(this.calendars[c].year, this.calendars[c].month, randId) + '</div>';
            }

            this.el.innerHTML = html;

            if (opts.bound) {
                if(opts.field.type !== 'hidden') {
                    sto(function() {
                        opts.trigger.focus();
                    }, 1);
                }
            }

            if (typeof this._o.onDraw === 'function') {
                this._o.onDraw(this);
            }
            
            if (opts.bound) {
                // let the screen reader user know to use arrow keys
                opts.field.setAttribute('aria-label', 'Use the arrow keys to pick a date');
            }
        },

        adjustPosition: function()
        {
            var field, pEl, width, height, viewportWidth, viewportHeight, scrollTop, left, top, clientRect;

            if (this._o.container) return;

            this.el.style.position = 'absolute';

            field = this._o.trigger;
            pEl = field;
            width = this.el.offsetWidth;
            height = this.el.offsetHeight;
            viewportWidth = window.innerWidth || document.documentElement.clientWidth;
            viewportHeight = window.innerHeight || document.documentElement.clientHeight;
            scrollTop = window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop;

            if (typeof field.getBoundingClientRect === 'function') {
                clientRect = field.getBoundingClientRect();
                left = clientRect.left + window.pageXOffset;
                top = clientRect.bottom + window.pageYOffset;
            } else {
                left = pEl.offsetLeft;
                top  = pEl.offsetTop + pEl.offsetHeight;
                while((pEl = pEl.offsetParent)) {
                    left += pEl.offsetLeft;
                    top  += pEl.offsetTop;
                }
            }

            // default position is bottom & left
            if ((this._o.reposition && left + width > viewportWidth) ||
                (
                    this._o.position.indexOf('right') > -1 &&
                    left - width + field.offsetWidth > 0
                )
            ) {
                left = left - width + field.offsetWidth;
            }
            if ((this._o.reposition && top + height > viewportHeight + scrollTop) ||
                (
                    this._o.position.indexOf('top') > -1 &&
                    top - height - field.offsetHeight > 0
                )
            ) {
                top = top - height - field.offsetHeight;
            }

            this.el.style.left = left + 'px';
            this.el.style.top = top + 'px';
        },

        /**
         * render HTML for a particular month
         */
        render: function(year, month, randId)
        {
            var opts   = this._o,
                now    = new Date(),
                days   = getDaysInMonth(year, month),
                before = new Date(year, month, 1).getDay(),
                data   = [],
                row    = [];
            setToStartOfDay(now);
            if (opts.firstDay > 0) {
                before -= opts.firstDay;
                if (before < 0) {
                    before += 7;
                }
            }
            var previousMonth = month === 0 ? 11 : month - 1,
                nextMonth = month === 11 ? 0 : month + 1,
                yearOfPreviousMonth = month === 0 ? year - 1 : year,
                yearOfNextMonth = month === 11 ? year + 1 : year,
                daysInPreviousMonth = getDaysInMonth(yearOfPreviousMonth, previousMonth);
            var cells = days + before,
                after = cells;
            while(after > 7) {
                after -= 7;
            }
            cells += 7 - after;
            for (var i = 0, r = 0; i < cells; i++)
            {
                var day = new Date(year, month, 1 + (i - before)),
                    isSelected = isDate(this._d) ? compareDates(day, this._d) : false,
                    isToday = compareDates(day, now),
                    isEmpty = i < before || i >= (days + before),
                    dayNumber = 1 + (i - before),
                    monthNumber = month,
                    yearNumber = year,
                    isStartRange = opts.startRange && compareDates(opts.startRange, day),
                    isEndRange = opts.endRange && compareDates(opts.endRange, day),
                    isInRange = opts.startRange && opts.endRange && opts.startRange < day && day < opts.endRange,
                    isDisabled = (opts.minDate && day < opts.minDate) ||
                                 (opts.maxDate && day > opts.maxDate) ||
                                 (opts.disableWeekends && isWeekend(day)) ||
                                 (opts.disableDayFn && opts.disableDayFn(day));

                if (isEmpty) {
                    if (i < before) {
                        dayNumber = daysInPreviousMonth + dayNumber;
                        monthNumber = previousMonth;
                        yearNumber = yearOfPreviousMonth;
                    } else {
                        dayNumber = dayNumber - days;
                        monthNumber = nextMonth;
                        yearNumber = yearOfNextMonth;
                    }
                }

                var dayConfig = {
                        day: dayNumber,
                        month: monthNumber,
                        year: yearNumber,
                        isSelected: isSelected,
                        isToday: isToday,
                        isDisabled: isDisabled,
                        isEmpty: isEmpty,
                        isStartRange: isStartRange,
                        isEndRange: isEndRange,
                        isInRange: isInRange,
                        showDaysInNextAndPreviousMonths: opts.showDaysInNextAndPreviousMonths
                    };

                row.push(renderDay(dayConfig));

                if (++r === 7) {
                    if (opts.showWeekNumber) {
                        row.unshift(renderWeek(i - before, month, year));
                    }
                    data.push(renderRow(row, opts.isRTL));
                    row = [];
                    r = 0;
                }
            }
            return renderTable(opts, data, randId);
        },

        isVisible: function()
        {
            return this._v;
        },

        show: function()
        {
            if (!this.isVisible()) {
                removeClass(this.el, 'is-hidden');
                this._v = true;
                this.draw();
                if (this._o.bound) {
                    addEvent(document, 'click', this._onClick);
                    this.adjustPosition();
                }
                if (typeof this._o.onOpen === 'function') {
                    this._o.onOpen.call(this);
                }
            }
        },

        hide: function()
        {
            var v = this._v;
            if (v !== false) {
                if (this._o.bound) {
                    removeEvent(document, 'click', this._onClick);
                }
                this.el.style.position = 'static'; // reset
                this.el.style.left = 'auto';
                this.el.style.top = 'auto';
                addClass(this.el, 'is-hidden');
                this._v = false;
                if (v !== undefined && typeof this._o.onClose === 'function') {
                    this._o.onClose.call(this);
                }
            }
        },

        /**
         * GAME OVER
         */
        destroy: function()
        {
            this.hide();
            removeEvent(this.el, 'mousedown', this._onMouseDown, true);
            removeEvent(this.el, 'touchend', this._onMouseDown, true);
            removeEvent(this.el, 'change', this._onChange);
            if (this._o.field) {
                removeEvent(this._o.field, 'change', this._onInputChange);
                if (this._o.bound) {
                    removeEvent(this._o.trigger, 'click', this._onInputClick);
                    removeEvent(this._o.trigger, 'focus', this._onInputFocus);
                    removeEvent(this._o.trigger, 'blur', this._onInputBlur);
                }
            }
            if (this.el.parentNode) {
                this.el.parentNode.removeChild(this.el);
            }
        }

    };

    return Pikaday;

}));


/***/ }),

/***/ "../../../node_modules/select/src/select.js":
/***/ (function(module, exports) {

function select(element) {
    var selectedText;

    if (element.nodeName === 'SELECT') {
        element.focus();

        selectedText = element.value;
    }
    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
        var isReadOnly = element.hasAttribute('readonly');

        if (!isReadOnly) {
            element.setAttribute('readonly', '');
        }

        element.select();
        element.setSelectionRange(0, element.value.length);

        if (!isReadOnly) {
            element.removeAttribute('readonly');
        }

        selectedText = element.value;
    }
    else {
        if (element.hasAttribute('contenteditable')) {
            element.focus();
        }

        var selection = window.getSelection();
        var range = document.createRange();

        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);

        selectedText = selection.toString();
    }

    return selectedText;
}

module.exports = select;


/***/ }),

/***/ "../../../node_modules/svg4everybody/dist/svg4everybody.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(root, factory) {
     true ? // AMD. Register as an anonymous module unless amdModuleId is set
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
        return root.svg4everybody = factory();
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == typeof module && module.exports ? // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory() : root.svg4everybody = factory();
}(this, function() {
    /*! svg4everybody v2.1.9 | github.com/jonathantneal/svg4everybody */
    function embed(parent, svg, target) {
        // if the target exists
        if (target) {
            // create a document fragment to hold the contents of the target
            var fragment = document.createDocumentFragment(), viewBox = !svg.hasAttribute("viewBox") && target.getAttribute("viewBox");
            // conditionally set the viewBox on the svg
            viewBox && svg.setAttribute("viewBox", viewBox);
            // copy the contents of the clone into the fragment
            for (// clone the target
            var clone = target.cloneNode(!0); clone.childNodes.length; ) {
                fragment.appendChild(clone.firstChild);
            }
            // append the fragment into the svg
            parent.appendChild(fragment);
        }
    }
    function loadreadystatechange(xhr) {
        // listen to changes in the request
        xhr.onreadystatechange = function() {
            // if the request is ready
            if (4 === xhr.readyState) {
                // get the cached html document
                var cachedDocument = xhr._cachedDocument;
                // ensure the cached html document based on the xhr response
                cachedDocument || (cachedDocument = xhr._cachedDocument = document.implementation.createHTMLDocument(""), 
                cachedDocument.body.innerHTML = xhr.responseText, xhr._cachedTarget = {}), // clear the xhr embeds list and embed each item
                xhr._embeds.splice(0).map(function(item) {
                    // get the cached target
                    var target = xhr._cachedTarget[item.id];
                    // ensure the cached target
                    target || (target = xhr._cachedTarget[item.id] = cachedDocument.getElementById(item.id)), 
                    // embed the target into the svg
                    embed(item.parent, item.svg, target);
                });
            }
        }, // test the ready state change immediately
        xhr.onreadystatechange();
    }
    function svg4everybody(rawopts) {
        function oninterval() {
            // while the index exists in the live <use> collection
            for (// get the cached <use> index
            var index = 0; index < uses.length; ) {
                // get the current <use>
                var use = uses[index], parent = use.parentNode, svg = getSVGAncestor(parent), src = use.getAttribute("xlink:href") || use.getAttribute("href");
                if (!src && opts.attributeName && (src = use.getAttribute(opts.attributeName)), 
                svg && src) {
                    if (polyfill) {
                        if (!opts.validate || opts.validate(src, svg, use)) {
                            // remove the <use> element
                            parent.removeChild(use);
                            // parse the src and get the url and id
                            var srcSplit = src.split("#"), url = srcSplit.shift(), id = srcSplit.join("#");
                            // if the link is external
                            if (url.length) {
                                // get the cached xhr request
                                var xhr = requests[url];
                                // ensure the xhr request exists
                                xhr || (xhr = requests[url] = new XMLHttpRequest(), xhr.open("GET", url), xhr.send(), 
                                xhr._embeds = []), // add the svg and id as an item to the xhr embeds list
                                xhr._embeds.push({
                                    parent: parent,
                                    svg: svg,
                                    id: id
                                }), // prepare the xhr ready state change event
                                loadreadystatechange(xhr);
                            } else {
                                // embed the local id into the svg
                                embed(parent, svg, document.getElementById(id));
                            }
                        } else {
                            // increase the index when the previous value was not "valid"
                            ++index, ++numberOfSvgUseElementsToBypass;
                        }
                    }
                } else {
                    // increase the index when the previous value was not "valid"
                    ++index;
                }
            }
            // continue the interval
            (!uses.length || uses.length - numberOfSvgUseElementsToBypass > 0) && requestAnimationFrame(oninterval, 67);
        }
        var polyfill, opts = Object(rawopts), newerIEUA = /\bTrident\/[567]\b|\bMSIE (?:9|10)\.0\b/, webkitUA = /\bAppleWebKit\/(\d+)\b/, olderEdgeUA = /\bEdge\/12\.(\d+)\b/, edgeUA = /\bEdge\/.(\d+)\b/, inIframe = window.top !== window.self;
        polyfill = "polyfill" in opts ? opts.polyfill : newerIEUA.test(navigator.userAgent) || (navigator.userAgent.match(olderEdgeUA) || [])[1] < 10547 || (navigator.userAgent.match(webkitUA) || [])[1] < 537 || edgeUA.test(navigator.userAgent) && inIframe;
        // create xhr requests object
        var requests = {}, requestAnimationFrame = window.requestAnimationFrame || setTimeout, uses = document.getElementsByTagName("use"), numberOfSvgUseElementsToBypass = 0;
        // conditionally start the interval if the polyfill is active
        polyfill && oninterval();
    }
    function getSVGAncestor(node) {
        for (var svg = node; "svg" !== svg.nodeName.toLowerCase() && (svg = svg.parentNode); ) {}
        return svg;
    }
    return svg4everybody;
});

/***/ }),

/***/ "../../../node_modules/timeago.js/dist/timeago.min.js":
/***/ (function(module, exports) {

!function(t,e){"object"==typeof module&&module.exports?module.exports=e(t):t.timeago=e(t)}("undefined"!=typeof window?window:this,function(){function t(t){return t instanceof Date?t:isNaN(t)?/^\d+$/.test(t)?new Date(e(t)):(t=(t||"").trim().replace(/\.\d+/,"").replace(/-/,"/").replace(/-/,"/").replace(/(\d)T(\d)/,"$1 $2").replace(/Z/," UTC").replace(/([\+\-]\d\d)\:?(\d\d)/," $1$2"),new Date(t)):new Date(e(t))}function e(t){return parseInt(t)}function n(t,n,r){n=d[n]?n:d[r]?r:"en";var i=0,a=t<0?1:0;for(t=Math.abs(t);t>=l[i]&&i<h;i++)t/=l[i];return t=e(t),i*=2,t>(0===i?9:1)&&(i+=1),d[n](t,i)[a].replace("%s",t)}function r(e,n){return n=n?t(n):new Date,(n-t(e))/1e3}function i(t){for(var e=1,n=0,r=Math.abs(t);t>=l[n]&&n<h;n++)t/=l[n],e*=l[n];return r%=e,r=r?e-r:e,Math.ceil(r)}function a(t){return t.dataset.timeago?t.dataset.timeago:t.getAttribute?t.getAttribute(p):t.attr?t.attr(p):void 0}function o(t,e){function o(a,c,f,s){var d=r(c,t);a.innerHTML=n(d,f,e),u["k"+s]=setTimeout(function(){o(a,c,f,s)},Math.min(1e3*i(d),2147483647))}var u={};return e||(e="en"),this.format=function(i,a){return n(r(i,t),a,e)},this.render=function(t,e){void 0===t.length&&(t=[t]);for(var n=0;n<t.length;n++)o(t[n],a(t[n]),e,++c)},this.cancel=function(){for(var t in u)clearTimeout(u[t]);u={}},this.setLocale=function(t){e=t},this}function u(t,e){return new o(t,e)}var c=0,f="second_minute_hour_day_week_month_year".split("_"),s="秒_分钟_小时_天_周_月_年".split("_"),d={en:function(t,e){if(0===e)return["just now","right now"];var n=f[parseInt(e/2)];return t>1&&(n+="s"),[t+" "+n+" ago","in "+t+" "+n]},zh_CN:function(t,e){if(0===e)return["刚刚","片刻后"];var n=s[parseInt(e/2)];return[t+n+"前",t+n+"后"]}},l=[60,60,24,7,365/7/12,12],h=6,p="datetime";return u.register=function(t,e){d[t]=e},u});

/***/ }),

/***/ "../../../node_modules/tiny-emitter/index.js":
/***/ (function(module, exports) {

function E () {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    };

    listener._ = callback
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;


/***/ }),

/***/ "../../../node_modules/vue-loader/lib/component-normalizer.js":
/***/ (function(module, exports) {

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  scopeId,
  cssModules
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  // inject cssModules
  if (cssModules) {
    var computed = Object.create(options.computed || null)
    Object.keys(cssModules).forEach(function (key) {
      var module = cssModules[key]
      computed[key] = function () { return module }
    })
    options.computed = computed
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ "../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-19c49ebb\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/loading_icon.vue":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(this.rootElementType, {
    tag: "component",
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner",
    class: _vm.cssClass,
    attrs: {
      "aria-hidden": "true",
      "aria-label": _vm.label
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ "../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-1c52c0f0\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./projects_dropdown/components/projects_list_item.vue":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "projects-list-item-container"
  }, [_c('a', {
    staticClass: "clearfix",
    attrs: {
      "href": _vm.webUrl
    }
  }, [_c('div', {
    staticClass: "project-item-avatar-container"
  }, [(_vm.hasAvatar) ? _c('img', {
    staticClass: "avatar s32",
    attrs: {
      "src": _vm.avatarUrl
    }
  }) : _c('identicon', {
    attrs: {
      "size-class": "s32",
      "entity-id": _vm.projectId,
      "entity-name": _vm.projectName
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "project-item-metadata-container"
  }, [_c('div', {
    staticClass: "project-title",
    attrs: {
      "title": _vm.projectName
    },
    domProps: {
      "innerHTML": _vm._s(_vm.highlightedProjectName)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "project-namespace",
    attrs: {
      "title": _vm.namespace
    }
  }, [_vm._v("\n        " + _vm._s(_vm.namespace) + "\n      ")])])])])
},staticRenderFns: []}

/***/ }),

/***/ "../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-3040ab43\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./projects_dropdown/components/projects_list_frequent.vue":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects-list-frequent-container"
  }, [_c('ul', {
    staticClass: "list-unstyled"
  }, [(_vm.isListEmpty) ? _c('li', {
    staticClass: "section-empty"
  }, [_vm._v("\n      " + _vm._s(_vm.listEmptyMessage) + "\n    ")]) : _vm._l((_vm.projects), function(project, index) {
    return _c('projects-list-item', {
      key: index,
      attrs: {
        "project-id": project.id,
        "project-name": project.name,
        "namespace": project.namespace,
        "web-url": project.webUrl,
        "avatar-url": project.avatarUrl
      }
    })
  })], 2)])
},staticRenderFns: []}

/***/ }),

/***/ "../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-740ed45d\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./projects_dropdown/components/projects_list_search.vue":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects-list-search-container"
  }, [_c('ul', {
    staticClass: "list-unstyled"
  }, [(_vm.isListEmpty) ? _c('li', {
    staticClass: "section-empty",
    class: {
      'section-failure': _vm.searchFailed
    }
  }, [_vm._v("\n      " + _vm._s(_vm.listEmptyMessage) + "\n    ")]) : _vm._l((_vm.projects), function(project, index) {
    return _c('projects-list-item', {
      key: index,
      attrs: {
        "project-id": project.id,
        "project-name": project.name,
        "namespace": project.namespace,
        "web-url": project.webUrl,
        "avatar-url": project.avatarUrl,
        "matcher": _vm.matcher
      }
    })
  })], 2)])
},staticRenderFns: []}

/***/ }),

/***/ "../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-7f3261a1\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./projects_dropdown/components/search.vue":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-input-container hidden-xs"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    ref: "search",
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "placeholder": _vm.s__('ProjectsDropdown|Search your projects')
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.searchQuery) ? _c('i', {
    staticClass: "search-icon fa fa-fw fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ "../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-c8728b10\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./projects_dropdown/components/app.vue":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('search'), _vm._v(" "), (_vm.isLoadingProjects) ? _c('loading-icon', {
    staticClass: "loading-animation prepend-top-20",
    attrs: {
      "size": "2",
      "label": _vm.s__('ProjectsDropdown|Loading projects')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isFrequentsListVisible) ? _c('div', {
    staticClass: "section-header"
  }, [_vm._v("\n    " + _vm._s(_vm.s__('ProjectsDropdown|Frequently visited')) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.isFrequentsListVisible) ? _c('projects-list-frequent', {
    attrs: {
      "local-storage-failed": _vm.isLocalStorageFailed,
      "projects": _vm.frequentProjects
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSearchListVisible) ? _c('projects-list-search', {
    attrs: {
      "search-failed": _vm.isSearchFailed,
      "matcher": _vm.searchQuery,
      "projects": _vm.searchProjects
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ "../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-cda97d4c\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/identicon.vue":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "avatar identicon",
    class: _vm.sizeClass,
    style: (_vm.identiconStyles)
  }, [_vm._v("\n  " + _vm._s(_vm.identiconTitle) + "\n")])
},staticRenderFns: []}

/***/ }),

/***/ "../../../node_modules/vue-resource/dist/vue-resource.es2015.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.3.4
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING  = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p$1 = Promise$1.prototype;

p$1.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p$1.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p$1.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p$1.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p$1.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p = PromiseObj.prototype;

p.bind = function (context) {
    this.context = context;
    return this;
};

p.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p.finally = function (callback) {

    return this.then(function (value) {
            callback.call(this);
            return value;
        }, function (reason) {
            callback.call(this);
            return Promise.reject(reason);
        }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;

var ref$1 = [];
var slice = ref$1.slice;
var debug = false;
var ntick;

var inBrowser = typeof window !== 'undefined';

var Util = function (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
};

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}



function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

var root = function (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
};

/**
 * Query Parameter Transform.
 */

var query = function (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
};

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^\{\}]+)\}|([^\{\}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:\*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

var template = function (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
};

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

var xdrClient = function (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load') {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            resolve(request.respondWith(xdr.responseText, {status: status}));
        };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
};

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

var cors = function (request, next) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

    next();
};

/**
 * Form data Interceptor.
 */

var form = function (request, next) {

    if (isFormData(request.body)) {

        request.headers.delete('Content-Type');

    } else if (isObject(request.body) && request.emulateJSON) {

        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

    next();
};

/**
 * JSON Interceptor.
 */

var json = function (request, next) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    next(function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    });
};

function isJson(str) {

    var start = str.match(/^\[|^\{(?!\{)/), end = {'[': /]$/, '{': /}$/};

    return start && end[start[0]].test(str);
}

/**
 * JSONP client (Browser).
 */

var jsonpClient = function (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
};

/**
 * JSONP Interceptor.
 */

var jsonp = function (request, next) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

    next();
};

/**
 * Before Interceptor.
 */

var before = function (request, next) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

    next();
};

/**
 * HTTP method override Interceptor.
 */

var method = function (request, next) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

    next();
};

/**
 * Header Interceptor.
 */

var header = function (request, next) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

    next();
};

/**
 * XMLHttp client (Browser).
 */

var xhrClient = function (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

            var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                }
            );

            each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
            });

            resolve(response);
        };

        request.abort = function () { return xhr.abort(); };

        if (request.progress) {
            if (request.method === 'GET') {
                xhr.addEventListener('progress', request.progress);
            } else if (/^(POST|PUT)$/i.test(request.method)) {
                xhr.upload.addEventListener('progress', request.progress);
            }
        }

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
};

/**
 * Http client (Node).
 */

var nodeClient = function (request) {

    var client = __webpack_require__("ignored /var/cache/omnibus/src/gitlab-rails/node_modules/vue-resource/dist got");

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                    status: resp.statusCode,
                    statusText: trim(resp.statusMessage)
                }
            );

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
};

/**
 * Base client.
 */

var Client = function (context) {

    var reqHandlers = [sendRequest], resHandlers = [], handler;

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        return new PromiseObj(function (resolve, reject) {

            function exec() {

                handler = reqHandlers.pop();

                if (isFunction(handler)) {
                    handler.call(context, request, next);
                } else {
                    warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
                    next();
                }
            }

            function next(response) {

                if (isFunction(response)) {

                    resHandlers.unshift(response);

                } else if (isObject(response)) {

                    resHandlers.forEach(function (handler) {
                        response = when(response, function (response) {
                            return handler.call(context, response) || response;
                        }, reject);
                    });

                    when(response, resolve, reject);

                    return;
                }

                exec();
            }

            exec();

        }, context);
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
};

function sendRequest(request, resolve) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    resolve(client(request));
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value){

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name){
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll (){
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl (){
    return Url(this);
};

Request.prototype.getBody = function getBody (){
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),

/***/ "../../../node_modules/webpack/buildin/module.js":
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "../../../vendor/assets/javascripts/Sortable.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**!
 * Sortable
 * @author	RubaXa   <trash@rubaxa.org>
 * @license MIT
 */

(function sortableModule(factory) {
	"use strict";

	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if (typeof module != "undefined" && typeof module.exports != "undefined") {
		module.exports = factory();
	}
	else if (typeof Package !== "undefined") {
		//noinspection JSUnresolvedVariable
		Sortable = factory();  // export for Meteor.js
	}
	else {
		/* jshint sub:true */
		window["Sortable"] = factory();
	}
})(function sortableFactory() {
	"use strict";

	if (typeof window == "undefined" || !window.document) {
		return function sortableError() {
			throw new Error("Sortable.js requires a window with a document");
		};
	}

	var dragEl,
		parentEl,
		ghostEl,
		cloneEl,
		rootEl,
		nextEl,

		scrollEl,
		scrollParentEl,
		scrollCustomFn,

		lastEl,
		lastCSS,
		lastParentCSS,

		oldIndex,
		newIndex,

		activeGroup,
		putSortable,

		autoScroll = {},

		tapEvt,
		touchEvt,

		moved,

		/** @const */
		RSPACE = /\s+/g,

		expando = 'Sortable' + (new Date).getTime(),

		win = window,
		document = win.document,
		parseInt = win.parseInt,

		$ = win.jQuery || win.Zepto,
		Polymer = win.Polymer,

		supportDraggable = !!('draggable' in document.createElement('div')),
		supportCssPointerEvents = (function (el) {
			// false when IE11
			if (!!navigator.userAgent.match(/Trident.*rv[ :]?11\./)) {
				return false;
			}
			el = document.createElement('x');
			el.style.cssText = 'pointer-events:auto';
			return el.style.pointerEvents === 'auto';
		})(),

		_silent = false,

		abs = Math.abs,
		min = Math.min,
		slice = [].slice,

		touchDragOverListeners = [],

		_autoScroll = _throttle(function (/**Event*/evt, /**Object*/options, /**HTMLElement*/rootEl) {
			// Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
			if (rootEl && options.scroll) {
				var el,
					rect,
					sens = options.scrollSensitivity,
					speed = options.scrollSpeed,

					x = evt.clientX,
					y = evt.clientY,

					winWidth = window.innerWidth,
					winHeight = window.innerHeight,

					vx,
					vy,

					scrollOffsetX,
					scrollOffsetY
				;

				// Delect scrollEl
				if (scrollParentEl !== rootEl) {
					scrollEl = options.scroll;
					scrollParentEl = rootEl;
					scrollCustomFn = options.scrollFn;

					if (scrollEl === true) {
						scrollEl = rootEl;

						do {
							if ((scrollEl.offsetWidth < scrollEl.scrollWidth) ||
								(scrollEl.offsetHeight < scrollEl.scrollHeight)
							) {
								break;
							}
							/* jshint boss:true */
						} while (scrollEl = scrollEl.parentNode);
					}
				}

				if (scrollEl) {
					el = scrollEl;
					rect = scrollEl.getBoundingClientRect();
					vx = (abs(rect.right - x) <= sens) - (abs(rect.left - x) <= sens);
					vy = (abs(rect.bottom - y) <= sens) - (abs(rect.top - y) <= sens);
				}


				if (!(vx || vy)) {
					vx = (winWidth - x <= sens) - (x <= sens);
					vy = (winHeight - y <= sens) - (y <= sens);

					/* jshint expr:true */
					(vx || vy) && (el = win);
				}


				if (autoScroll.vx !== vx || autoScroll.vy !== vy || autoScroll.el !== el) {
					autoScroll.el = el;
					autoScroll.vx = vx;
					autoScroll.vy = vy;

					clearInterval(autoScroll.pid);

					if (el) {
						autoScroll.pid = setInterval(function () {
							scrollOffsetY = vy ? vy * speed : 0;
							scrollOffsetX = vx ? vx * speed : 0;

							if ('function' === typeof(scrollCustomFn)) {
								return scrollCustomFn.call(_this, scrollOffsetX, scrollOffsetY, evt);
							}

							if (el === win) {
								win.scrollTo(win.pageXOffset + scrollOffsetX, win.pageYOffset + scrollOffsetY);
							} else {
								el.scrollTop += scrollOffsetY;
								el.scrollLeft += scrollOffsetX;
							}
						}, 24);
					}
				}
			}
		}, 30),

		_prepareGroup = function (options) {
			function toFn(value, pull) {
				if (value === void 0 || value === true) {
					value = group.name;
				}

				if (typeof value === 'function') {
					return value;
				} else {
					return function (to, from) {
						var fromGroup = from.options.group.name;

						return pull
							? value
							: value && (value.join
								? value.indexOf(fromGroup) > -1
								: (fromGroup == value)
							);
					};
				}
			}

			var group = {};
			var originalGroup = options.group;

			if (!originalGroup || typeof originalGroup != 'object') {
				originalGroup = {name: originalGroup};
			}

			group.name = originalGroup.name;
			group.checkPull = toFn(originalGroup.pull, true);
			group.checkPut = toFn(originalGroup.put);

			options.group = group;
		}
	;



	/**
	 * @class  Sortable
	 * @param  {HTMLElement}  el
	 * @param  {Object}       [options]
	 */
	function Sortable(el, options) {
		if (!(el && el.nodeType && el.nodeType === 1)) {
			throw 'Sortable: `el` must be HTMLElement, and not ' + {}.toString.call(el);
		}

		this.el = el; // root element
		this.options = options = _extend({}, options);


		// Export instance
		el[expando] = this;


		// Default options
		var defaults = {
			group: Math.random(),
			sort: true,
			disabled: false,
			store: null,
			handle: null,
			scroll: true,
			scrollSensitivity: 30,
			scrollSpeed: 10,
			draggable: /[uo]l/i.test(el.nodeName) ? 'li' : '>*',
			ghostClass: 'sortable-ghost',
			chosenClass: 'sortable-chosen',
			dragClass: 'sortable-drag',
			ignore: 'a, img',
			filter: null,
			animation: 0,
			setData: function (dataTransfer, dragEl) {
				dataTransfer.setData('Text', dragEl.textContent);
			},
			dropBubble: false,
			dragoverBubble: false,
			dataIdAttr: 'data-id',
			delay: 0,
			forceFallback: false,
			fallbackClass: 'sortable-fallback',
			fallbackOnBody: false,
			fallbackTolerance: 0,
			fallbackOffset: {x: 0, y: 0}
		};


		// Set default options
		for (var name in defaults) {
			!(name in options) && (options[name] = defaults[name]);
		}

		_prepareGroup(options);

		// Bind all private methods
		for (var fn in this) {
			if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
				this[fn] = this[fn].bind(this);
			}
		}

		// Setup drag mode
		this.nativeDraggable = options.forceFallback ? false : supportDraggable;

		// Bind events
		_on(el, 'mousedown', this._onTapStart);
		_on(el, 'touchstart', this._onTapStart);

		if (this.nativeDraggable) {
			_on(el, 'dragover', this);
			_on(el, 'dragenter', this);
		}

		touchDragOverListeners.push(this._onDragOver);

		// Restore sorting
		options.store && this.sort(options.store.get(this));
	}


	Sortable.prototype = /** @lends Sortable.prototype */ {
		constructor: Sortable,

		_onTapStart: function (/** Event|TouchEvent */evt) {
			var _this = this,
				el = this.el,
				options = this.options,
				type = evt.type,
				touch = evt.touches && evt.touches[0],
				target = (touch || evt).target,
				originalTarget = evt.target.shadowRoot && evt.path[0] || target,
				filter = options.filter,
				startIndex;

			// Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.
			if (dragEl) {
				return;
			}

			if (type === 'mousedown' && evt.button !== 0 || options.disabled) {
				return; // only left button or enabled
			}

			if (options.handle && !_closest(originalTarget, options.handle, el)) {
				return;
			}

			target = _closest(target, options.draggable, el);

			if (!target) {
				return;
			}

			// Get the index of the dragged element within its parent
			startIndex = _index(target, options.draggable);

			// Check filter
			if (typeof filter === 'function') {
				if (filter.call(this, evt, target, this)) {
					_dispatchEvent(_this, originalTarget, 'filter', target, el, startIndex);
					evt.preventDefault();
					return; // cancel dnd
				}
			}
			else if (filter) {
				filter = filter.split(',').some(function (criteria) {
					criteria = _closest(originalTarget, criteria.trim(), el);

					if (criteria) {
						_dispatchEvent(_this, criteria, 'filter', target, el, startIndex);
						return true;
					}
				});

				if (filter) {
					evt.preventDefault();
					return; // cancel dnd
				}
			}

			// Prepare `dragstart`
			this._prepareDragStart(evt, touch, target, startIndex);
		},

		_prepareDragStart: function (/** Event */evt, /** Touch */touch, /** HTMLElement */target, /** Number */startIndex) {
			var _this = this,
				el = _this.el,
				options = _this.options,
				ownerDocument = el.ownerDocument,
				dragStartFn;

			if (target && !dragEl && (target.parentNode === el)) {
				tapEvt = evt;

				rootEl = el;
				dragEl = target;
				parentEl = dragEl.parentNode;
				nextEl = dragEl.nextSibling;
				activeGroup = options.group;
				oldIndex = startIndex;

				this._lastX = (touch || evt).clientX;
				this._lastY = (touch || evt).clientY;

				dragEl.style['will-change'] = 'transform';

				dragStartFn = function () {
					// Delayed drag has been triggered
					// we can re-enable the events: touchmove/mousemove
					_this._disableDelayedDrag();

					// Make the element draggable
					dragEl.draggable = _this.nativeDraggable;

					// Chosen item
					_toggleClass(dragEl, options.chosenClass, true);

					// Bind the events: dragstart/dragend
					_this._triggerDragStart(touch);

					// Drag start event
					_dispatchEvent(_this, rootEl, 'choose', dragEl, rootEl, oldIndex);
				};

				// Disable "draggable"
				options.ignore.split(',').forEach(function (criteria) {
					_find(dragEl, criteria.trim(), _disableDraggable);
				});

				_on(ownerDocument, 'mouseup', _this._onDrop);
				_on(ownerDocument, 'touchend', _this._onDrop);
				_on(ownerDocument, 'touchcancel', _this._onDrop);

				if (options.delay) {
					// If the user moves the pointer or let go the click or touch
					// before the delay has been reached:
					// disable the delayed drag
					_on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
					_on(ownerDocument, 'touchend', _this._disableDelayedDrag);
					_on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
					_on(ownerDocument, 'mousemove', _this._disableDelayedDrag);
					_on(ownerDocument, 'touchmove', _this._disableDelayedDrag);

					_this._dragStartTimer = setTimeout(dragStartFn, options.delay);
				} else {
					dragStartFn();
				}
			}
		},

		_disableDelayedDrag: function () {
			var ownerDocument = this.el.ownerDocument;

			clearTimeout(this._dragStartTimer);
			_off(ownerDocument, 'mouseup', this._disableDelayedDrag);
			_off(ownerDocument, 'touchend', this._disableDelayedDrag);
			_off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
			_off(ownerDocument, 'mousemove', this._disableDelayedDrag);
			_off(ownerDocument, 'touchmove', this._disableDelayedDrag);
		},

		_triggerDragStart: function (/** Touch */touch) {
			if (touch) {
				// Touch device support
				tapEvt = {
					target: dragEl,
					clientX: touch.clientX,
					clientY: touch.clientY
				};

				this._onDragStart(tapEvt, 'touch');
			}
			else if (!this.nativeDraggable) {
				this._onDragStart(tapEvt, true);
			}
			else {
				_on(dragEl, 'dragend', this);
				_on(rootEl, 'dragstart', this._onDragStart);
			}

			try {
				if (document.selection) {
					// Timeout neccessary for IE9
					setTimeout(function () {
						document.selection.empty();
					});
				} else {
					window.getSelection().removeAllRanges();
				}
			} catch (err) {
			}
		},

		_dragStarted: function () {
			if (rootEl && dragEl) {
				var options = this.options;

				// Apply effect
				_toggleClass(dragEl, options.ghostClass, true);
				_toggleClass(dragEl, options.dragClass, false);

				Sortable.active = this;

				// Drag start event
				_dispatchEvent(this, rootEl, 'start', dragEl, rootEl, oldIndex);
			}
		},

		_emulateDragOver: function () {
			if (touchEvt) {
				if (this._lastX === touchEvt.clientX && this._lastY === touchEvt.clientY) {
					return;
				}

				this._lastX = touchEvt.clientX;
				this._lastY = touchEvt.clientY;

				if (!supportCssPointerEvents) {
					_css(ghostEl, 'display', 'none');
				}

				var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY),
					parent = target,
					i = touchDragOverListeners.length;

				if (parent) {
					do {
						if (parent[expando]) {
							while (i--) {
								touchDragOverListeners[i]({
									clientX: touchEvt.clientX,
									clientY: touchEvt.clientY,
									target: target,
									rootEl: parent
								});
							}

							break;
						}

						target = parent; // store last element
					}
					/* jshint boss:true */
					while (parent = parent.parentNode);
				}

				if (!supportCssPointerEvents) {
					_css(ghostEl, 'display', '');
				}
			}
		},


		_onTouchMove: function (/**TouchEvent*/evt) {
			if (tapEvt) {
				var	options = this.options,
					fallbackTolerance = options.fallbackTolerance,
					fallbackOffset = options.fallbackOffset,
					touch = evt.touches ? evt.touches[0] : evt,
					dx = (touch.clientX - tapEvt.clientX) + fallbackOffset.x,
					dy = (touch.clientY - tapEvt.clientY) + fallbackOffset.y,
					translate3d = evt.touches ? 'translate3d(' + dx + 'px,' + dy + 'px,0)' : 'translate(' + dx + 'px,' + dy + 'px)';

				// only set the status to dragging, when we are actually dragging
				if (!Sortable.active) {
					if (fallbackTolerance &&
						min(abs(touch.clientX - this._lastX), abs(touch.clientY - this._lastY)) < fallbackTolerance
					) {
						return;
					}

					this._dragStarted();
				}

				// as well as creating the ghost element on the document body
				this._appendGhost();

				moved = true;
				touchEvt = touch;

				_css(ghostEl, 'webkitTransform', translate3d);
				_css(ghostEl, 'mozTransform', translate3d);
				_css(ghostEl, 'msTransform', translate3d);
				_css(ghostEl, 'transform', translate3d);

				evt.preventDefault();
			}
		},

		_appendGhost: function () {
			if (!ghostEl) {
				var rect = dragEl.getBoundingClientRect(),
					css = _css(dragEl),
					options = this.options,
					ghostRect;

				ghostEl = dragEl.cloneNode(true);

				_toggleClass(ghostEl, options.ghostClass, false);
				_toggleClass(ghostEl, options.fallbackClass, true);
				_toggleClass(ghostEl, options.dragClass, true);

				_css(ghostEl, 'top', rect.top - parseInt(css.marginTop, 10));
				_css(ghostEl, 'left', rect.left - parseInt(css.marginLeft, 10));
				_css(ghostEl, 'width', rect.width);
				_css(ghostEl, 'height', rect.height);
				_css(ghostEl, 'opacity', '0.8');
				_css(ghostEl, 'position', 'fixed');
				_css(ghostEl, 'zIndex', '100000');
				_css(ghostEl, 'pointerEvents', 'none');

				options.fallbackOnBody && document.body.appendChild(ghostEl) || rootEl.appendChild(ghostEl);

				// Fixing dimensions.
				ghostRect = ghostEl.getBoundingClientRect();
				_css(ghostEl, 'width', rect.width * 2 - ghostRect.width);
				_css(ghostEl, 'height', rect.height * 2 - ghostRect.height);
			}
		},

		_onDragStart: function (/**Event*/evt, /**boolean*/useFallback) {
			var dataTransfer = evt.dataTransfer,
				options = this.options;

			this._offUpEvents();

			if (activeGroup.checkPull(this, this, dragEl, evt) == 'clone') {
				cloneEl = _clone(dragEl);
				_css(cloneEl, 'display', 'none');
				rootEl.insertBefore(cloneEl, dragEl);
				_dispatchEvent(this, rootEl, 'clone', dragEl);
			}

			_toggleClass(dragEl, options.dragClass, true);

			if (useFallback) {
				if (useFallback === 'touch') {
					// Bind touch events
					_on(document, 'touchmove', this._onTouchMove);
					_on(document, 'touchend', this._onDrop);
					_on(document, 'touchcancel', this._onDrop);
				} else {
					// Old brwoser
					_on(document, 'mousemove', this._onTouchMove);
					_on(document, 'mouseup', this._onDrop);
				}

				this._loopId = setInterval(this._emulateDragOver, 50);
			}
			else {
				if (dataTransfer) {
					dataTransfer.effectAllowed = 'move';
					options.setData && options.setData.call(this, dataTransfer, dragEl);
				}

				_on(document, 'drop', this);
				setTimeout(this._dragStarted, 0);
			}
		},

		_onDragOver: function (/**Event*/evt) {
			var el = this.el,
				target,
				dragRect,
				targetRect,
				revert,
				options = this.options,
				group = options.group,
				activeSortable = Sortable.active,
				isOwner = (activeGroup === group),
				canSort = options.sort;

			if (evt.preventDefault !== void 0) {
				evt.preventDefault();
				!options.dragoverBubble && evt.stopPropagation();
			}

			moved = true;

			if (activeGroup && !options.disabled &&
				(isOwner
					? canSort || (revert = !rootEl.contains(dragEl)) // Reverting item into the original list
					: (
						putSortable === this ||
						activeGroup.checkPull(this, activeSortable, dragEl, evt) && group.checkPut(this, activeSortable, dragEl, evt)
					)
				) &&
				(evt.rootEl === void 0 || evt.rootEl === this.el) // touch fallback
			) {
				// Smart auto-scrolling
				_autoScroll(evt, options, this.el);

				if (_silent) {
					return;
				}

				target = _closest(evt.target, options.draggable, el);
				dragRect = dragEl.getBoundingClientRect();
				putSortable = this;

				if (revert) {
					_cloneHide(true);
					parentEl = rootEl; // actualization

					if (cloneEl || nextEl) {
						rootEl.insertBefore(dragEl, cloneEl || nextEl);
					}
					else if (!canSort) {
						rootEl.appendChild(dragEl);
					}

					return;
				}


				if ((el.children.length === 0) || (el.children[0] === ghostEl) ||
					(el === evt.target) && (target = _ghostIsLast(el, evt))
				) {
					if (target) {
						if (target.animated) {
							return;
						}

						targetRect = target.getBoundingClientRect();
					}

					_cloneHide(isOwner);

					if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt) !== false) {
						if (!dragEl.contains(el)) {
							el.appendChild(dragEl);
							parentEl = el; // actualization
						}

						this._animate(dragRect, dragEl);
						target && this._animate(targetRect, target);
					}
				}
				else if (target && !target.animated && target !== dragEl && (target.parentNode[expando] !== void 0)) {
					if (lastEl !== target) {
						lastEl = target;
						lastCSS = _css(target);
						lastParentCSS = _css(target.parentNode);
					}

					targetRect = target.getBoundingClientRect();

					var width = targetRect.right - targetRect.left,
						height = targetRect.bottom - targetRect.top,
						floating = /left|right|inline/.test(lastCSS.cssFloat + lastCSS.display)
							|| (lastParentCSS.display == 'flex' && lastParentCSS['flex-direction'].indexOf('row') === 0),
						isWide = (target.offsetWidth > dragEl.offsetWidth),
						isLong = (target.offsetHeight > dragEl.offsetHeight),
						halfway = (floating ? (evt.clientX - targetRect.left) / width : (evt.clientY - targetRect.top) / height) > 0.5,
						nextSibling = target.nextElementSibling,
						moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt),
						after
					;

					if (moveVector !== false) {
						_silent = true;
						setTimeout(_unsilent, 30);

						_cloneHide(isOwner);

						if (moveVector === 1 || moveVector === -1) {
							after = (moveVector === 1);
						}
						else if (floating) {
							var elTop = dragEl.offsetTop,
								tgTop = target.offsetTop;

							if (elTop === tgTop) {
								after = (target.previousElementSibling === dragEl) && !isWide || halfway && isWide;
							}
							else if (target.previousElementSibling === dragEl || dragEl.previousElementSibling === target) {
								after = (evt.clientY - targetRect.top) / height > 0.5;
							} else {
								after = tgTop > elTop;
							}
						} else {
							after = (nextSibling !== dragEl) && !isLong || halfway && isLong;
						}

						if (!dragEl.contains(el)) {
							if (after && !nextSibling) {
								el.appendChild(dragEl);
							} else {
								target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
							}
						}

						parentEl = dragEl.parentNode; // actualization

						this._animate(dragRect, dragEl);
						this._animate(targetRect, target);
					}
				}
			}
		},

		_animate: function (prevRect, target) {
			var ms = this.options.animation;

			if (ms) {
				var currentRect = target.getBoundingClientRect();

				_css(target, 'transition', 'none');
				_css(target, 'transform', 'translate3d('
					+ (prevRect.left - currentRect.left) + 'px,'
					+ (prevRect.top - currentRect.top) + 'px,0)'
				);

				target.offsetWidth; // repaint

				_css(target, 'transition', 'all ' + ms + 'ms');
				_css(target, 'transform', 'translate3d(0,0,0)');

				clearTimeout(target.animated);
				target.animated = setTimeout(function () {
					_css(target, 'transition', '');
					_css(target, 'transform', '');
					target.animated = false;
				}, ms);
			}
		},

		_offUpEvents: function () {
			var ownerDocument = this.el.ownerDocument;

			_off(document, 'touchmove', this._onTouchMove);
			_off(ownerDocument, 'mouseup', this._onDrop);
			_off(ownerDocument, 'touchend', this._onDrop);
			_off(ownerDocument, 'touchcancel', this._onDrop);
		},

		_onDrop: function (/**Event*/evt) {
			var el = this.el,
				options = this.options;

			clearInterval(this._loopId);
			clearInterval(autoScroll.pid);
			clearTimeout(this._dragStartTimer);

			// Unbind events
			_off(document, 'mousemove', this._onTouchMove);

			if (this.nativeDraggable) {
				_off(document, 'drop', this);
				_off(el, 'dragstart', this._onDragStart);
			}

			this._offUpEvents();

			if (evt) {
				if (moved) {
					evt.preventDefault();
					!options.dropBubble && evt.stopPropagation();
				}

				ghostEl && ghostEl.parentNode.removeChild(ghostEl);

				if (dragEl) {
					if (this.nativeDraggable) {
						_off(dragEl, 'dragend', this);
					}

					_disableDraggable(dragEl);
					dragEl.style['will-change'] = '';

					// Remove class's
					_toggleClass(dragEl, this.options.ghostClass, false);
					_toggleClass(dragEl, this.options.chosenClass, false);

					if (rootEl !== parentEl) {
						newIndex = _index(dragEl, options.draggable);

						if (newIndex >= 0) {

							// Add event
							_dispatchEvent(null, parentEl, 'add', dragEl, rootEl, oldIndex, newIndex);

							// Remove event
							_dispatchEvent(this, rootEl, 'remove', dragEl, rootEl, oldIndex, newIndex);

							// drag from one list and drop into another
							_dispatchEvent(null, parentEl, 'sort', dragEl, rootEl, oldIndex, newIndex);
							_dispatchEvent(this, rootEl, 'sort', dragEl, rootEl, oldIndex, newIndex);
						}
					}
					else {
						// Remove clone
						cloneEl && cloneEl.parentNode.removeChild(cloneEl);

						if (dragEl.nextSibling !== nextEl) {
							// Get the index of the dragged element within its parent
							newIndex = _index(dragEl, options.draggable);

							if (newIndex >= 0) {
								// drag & drop within the same list
								_dispatchEvent(this, rootEl, 'update', dragEl, rootEl, oldIndex, newIndex);
								_dispatchEvent(this, rootEl, 'sort', dragEl, rootEl, oldIndex, newIndex);
							}
						}
					}

					if (Sortable.active) {
						/* jshint eqnull:true */
						if (newIndex == null || newIndex === -1) {
							newIndex = oldIndex;
						}

						_dispatchEvent(this, rootEl, 'end', dragEl, rootEl, oldIndex, newIndex);

						// Save sorting
						this.save();
					}
				}

			}

			this._nulling();
		},

		_nulling: function() {
			rootEl =
			dragEl =
			parentEl =
			ghostEl =
			nextEl =
			cloneEl =

			scrollEl =
			scrollParentEl =

			tapEvt =
			touchEvt =

			moved =
			newIndex =

			lastEl =
			lastCSS =

			putSortable =
			activeGroup =
			Sortable.active = null;
		},

		handleEvent: function (/**Event*/evt) {
			var type = evt.type;

			if (type === 'dragover' || type === 'dragenter') {
				if (dragEl) {
					this._onDragOver(evt);
					_globalDragOver(evt);
				}
			}
			else if (type === 'drop' || type === 'dragend') {
				this._onDrop(evt);
			}
		},


		/**
		 * Serializes the item into an array of string.
		 * @returns {String[]}
		 */
		toArray: function () {
			var order = [],
				el,
				children = this.el.children,
				i = 0,
				n = children.length,
				options = this.options;

			for (; i < n; i++) {
				el = children[i];
				if (_closest(el, options.draggable, this.el)) {
					order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
				}
			}

			return order;
		},


		/**
		 * Sorts the elements according to the array.
		 * @param  {String[]}  order  order of the items
		 */
		sort: function (order) {
			var items = {}, rootEl = this.el;

			this.toArray().forEach(function (id, i) {
				var el = rootEl.children[i];

				if (_closest(el, this.options.draggable, rootEl)) {
					items[id] = el;
				}
			}, this);

			order.forEach(function (id) {
				if (items[id]) {
					rootEl.removeChild(items[id]);
					rootEl.appendChild(items[id]);
				}
			});
		},


		/**
		 * Save the current sorting
		 */
		save: function () {
			var store = this.options.store;
			store && store.set(this);
		},


		/**
		 * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
		 * @param   {HTMLElement}  el
		 * @param   {String}       [selector]  default: `options.draggable`
		 * @returns {HTMLElement|null}
		 */
		closest: function (el, selector) {
			return _closest(el, selector || this.options.draggable, this.el);
		},


		/**
		 * Set/get option
		 * @param   {string} name
		 * @param   {*}      [value]
		 * @returns {*}
		 */
		option: function (name, value) {
			var options = this.options;

			if (value === void 0) {
				return options[name];
			} else {
				options[name] = value;

				if (name === 'group') {
					_prepareGroup(options);
				}
			}
		},


		/**
		 * Destroy
		 */
		destroy: function () {
			var el = this.el;

			el[expando] = null;

			_off(el, 'mousedown', this._onTapStart);
			_off(el, 'touchstart', this._onTapStart);

			if (this.nativeDraggable) {
				_off(el, 'dragover', this);
				_off(el, 'dragenter', this);
			}

			// Remove draggable attributes
			Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
				el.removeAttribute('draggable');
			});

			touchDragOverListeners.splice(touchDragOverListeners.indexOf(this._onDragOver), 1);

			this._onDrop();

			this.el = el = null;
		}
	};


	function _cloneHide(state) {
		if (cloneEl && (cloneEl.state !== state)) {
			_css(cloneEl, 'display', state ? 'none' : '');
			!state && cloneEl.state && rootEl.insertBefore(cloneEl, dragEl);
			cloneEl.state = state;
		}
	}


	function _closest(/**HTMLElement*/el, /**String*/selector, /**HTMLElement*/ctx) {
		if (el) {
			ctx = ctx || document;

			do {
				if ((selector === '>*' && el.parentNode === ctx) || _matches(el, selector)) {
					return el;
				}
				/* jshint boss:true */
			} while (el = _getParentOrHost(el));
		}

		return null;
	}


	function _getParentOrHost(el) {
		var parent = el.host;

		return (parent && parent.nodeType) ? parent : el.parentNode;
	}


	function _globalDragOver(/**Event*/evt) {
		if (evt.dataTransfer) {
			evt.dataTransfer.dropEffect = 'move';
		}
		evt.preventDefault();
	}


	function _on(el, event, fn) {
		el.addEventListener(event, fn, false);
	}


	function _off(el, event, fn) {
		el.removeEventListener(event, fn, false);
	}


	function _toggleClass(el, name, state) {
		if (el) {
			if (el.classList) {
				el.classList[state ? 'add' : 'remove'](name);
			}
			else {
				var className = (' ' + el.className + ' ').replace(RSPACE, ' ').replace(' ' + name + ' ', ' ');
				el.className = (className + (state ? ' ' + name : '')).replace(RSPACE, ' ');
			}
		}
	}


	function _css(el, prop, val) {
		var style = el && el.style;

		if (style) {
			if (val === void 0) {
				if (document.defaultView && document.defaultView.getComputedStyle) {
					val = document.defaultView.getComputedStyle(el, '');
				}
				else if (el.currentStyle) {
					val = el.currentStyle;
				}

				return prop === void 0 ? val : val[prop];
			}
			else {
				if (!(prop in style)) {
					prop = '-webkit-' + prop;
				}

				style[prop] = val + (typeof val === 'string' ? '' : 'px');
			}
		}
	}


	function _find(ctx, tagName, iterator) {
		if (ctx) {
			var list = ctx.getElementsByTagName(tagName), i = 0, n = list.length;

			if (iterator) {
				for (; i < n; i++) {
					iterator(list[i], i);
				}
			}

			return list;
		}

		return [];
	}



	function _dispatchEvent(sortable, rootEl, name, targetEl, fromEl, startIndex, newIndex) {
		sortable = (sortable || rootEl[expando]);

		var evt = document.createEvent('Event'),
			options = sortable.options,
			onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1);

		evt.initEvent(name, true, true);

		evt.to = rootEl;
		evt.from = fromEl || rootEl;
		evt.item = targetEl || rootEl;
		evt.clone = cloneEl;

		evt.oldIndex = startIndex;
		evt.newIndex = newIndex;

		rootEl.dispatchEvent(evt);

		if (options[onName]) {
			options[onName].call(sortable, evt);
		}
	}


	function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvt) {
		var evt,
			sortable = fromEl[expando],
			onMoveFn = sortable.options.onMove,
			retVal;

		evt = document.createEvent('Event');
		evt.initEvent('move', true, true);

		evt.to = toEl;
		evt.from = fromEl;
		evt.dragged = dragEl;
		evt.draggedRect = dragRect;
		evt.related = targetEl || toEl;
		evt.relatedRect = targetRect || toEl.getBoundingClientRect();

		fromEl.dispatchEvent(evt);

		if (onMoveFn) {
			retVal = onMoveFn.call(sortable, evt, originalEvt);
		}

		return retVal;
	}


	function _disableDraggable(el) {
		el.draggable = false;
	}


	function _unsilent() {
		_silent = false;
	}


	/** @returns {HTMLElement|false} */
	function _ghostIsLast(el, evt) {
		var lastEl = el.lastElementChild,
			rect = lastEl.getBoundingClientRect();

		// 5 — min delta
		// abs — нельзя добавлять, а то глюки при наведении сверху
		return (
			(evt.clientY - (rect.top + rect.height) > 5) ||
			(evt.clientX - (rect.right + rect.width) > 5)
		) && lastEl;
	}


	/**
	 * Generate id
	 * @param   {HTMLElement} el
	 * @returns {String}
	 * @private
	 */
	function _generateId(el) {
		var str = el.tagName + el.className + el.src + el.href + el.textContent,
			i = str.length,
			sum = 0;

		while (i--) {
			sum += str.charCodeAt(i);
		}

		return sum.toString(36);
	}

	/**
	 * Returns the index of an element within its parent for a selected set of
	 * elements
	 * @param  {HTMLElement} el
	 * @param  {selector} selector
	 * @return {number}
	 */
	function _index(el, selector) {
		var index = 0;

		if (!el || !el.parentNode) {
			return -1;
		}

		while (el && (el = el.previousElementSibling)) {
			if ((el.nodeName.toUpperCase() !== 'TEMPLATE') && (selector === '>*' || _matches(el, selector))) {
				index++;
			}
		}

		return index;
	}

	function _matches(/**HTMLElement*/el, /**String*/selector) {
		if (el) {
			selector = selector.split('.');

			var tag = selector.shift().toUpperCase(),
				re = new RegExp('\\s(' + selector.join('|') + ')(?=\\s)', 'g');

			return (
				(tag === '' || el.nodeName.toUpperCase() == tag) &&
				(!selector.length || ((' ' + el.className + ' ').match(re) || []).length == selector.length)
			);
		}

		return false;
	}

	function _throttle(callback, ms) {
		var args, _this;

		return function () {
			if (args === void 0) {
				args = arguments;
				_this = this;

				setTimeout(function () {
					if (args.length === 1) {
						callback.call(_this, args[0]);
					} else {
						callback.apply(_this, args);
					}

					args = void 0;
				}, ms);
			}
		};
	}

	function _extend(dst, src) {
		if (dst && src) {
			for (var key in src) {
				if (src.hasOwnProperty(key)) {
					dst[key] = src[key];
				}
			}
		}

		return dst;
	}

	function _clone(el) {
		return $
			? $(el).clone(true)[0]
			: (Polymer && Polymer.dom
				? Polymer.dom(el).cloneNode(true)
				: el.cloneNode(true)
			);
	}


	// Export utils
	Sortable.utils = {
		on: _on,
		off: _off,
		css: _css,
		find: _find,
		is: function (el, selector) {
			return !!_closest(el, selector, el);
		},
		extend: _extend,
		throttle: _throttle,
		closest: _closest,
		toggleClass: _toggleClass,
		clone: _clone,
		index: _index
	};


	/**
	 * Create sortable instance
	 * @param {HTMLElement}  el
	 * @param {Object}      [options]
	 */
	Sortable.create = function (el, options) {
		return new Sortable(el, options);
	};


	// Export
	Sortable.version = '1.4.2';
	return Sortable;
});


/***/ }),

/***/ "../../../vendor/assets/javascripts/autosize.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Autosize 3.0.14
	license: MIT
	http://www.jacklmoore.com/autosize
*/
(function (global, factory) {
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof exports !== 'undefined' && typeof module !== 'undefined') {
		factory(exports, module);
	} else {
		var mod = {
			exports: {}
		};
		factory(mod.exports, mod);
		global.autosize = mod.exports;
	}
})(this, function (exports, module) {
	'use strict';

	var set = typeof Set === 'function' ? new Set() : (function () {
		var list = [];

		return {
			has: function has(key) {
				return Boolean(list.indexOf(key) > -1);
			},
			add: function add(key) {
				list.push(key);
			},
			'delete': function _delete(key) {
				list.splice(list.indexOf(key), 1);
			} };
	})();

	function assign(ta) {
		var _ref = arguments[1] === undefined ? {} : arguments[1];

		var _ref$setOverflowX = _ref.setOverflowX;
		var setOverflowX = _ref$setOverflowX === undefined ? true : _ref$setOverflowX;
		var _ref$setOverflowY = _ref.setOverflowY;
		var setOverflowY = _ref$setOverflowY === undefined ? true : _ref$setOverflowY;

		if (!ta || !ta.nodeName || ta.nodeName !== 'TEXTAREA' || set.has(ta)) return;

		var heightOffset = null;
		var overflowY = null;
		var clientWidth = ta.clientWidth;

		function init() {
			var style = window.getComputedStyle(ta, null);

			overflowY = style.overflowY;

			if (style.resize === 'vertical') {
				ta.style.resize = 'none';
			} else if (style.resize === 'both') {
				ta.style.resize = 'horizontal';
			}

			if (style.boxSizing === 'content-box') {
				heightOffset = -(parseFloat(style.paddingTop) + parseFloat(style.paddingBottom));
			} else {
				heightOffset = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
			}
			// Fix when a textarea is not on document body and heightOffset is Not a Number
			if (isNaN(heightOffset)) {
				heightOffset = 0;
			}

			update();
		}

		function changeOverflow(value) {
			{
				// Chrome/Safari-specific fix:
				// When the textarea y-overflow is hidden, Chrome/Safari do not reflow the text to account for the space
				// made available by removing the scrollbar. The following forces the necessary text reflow.
				var width = ta.style.width;
				ta.style.width = '0px';
				// Force reflow:
				/* jshint ignore:start */
				ta.offsetWidth;
				/* jshint ignore:end */
				ta.style.width = width;
			}

			overflowY = value;

			if (setOverflowY) {
				ta.style.overflowY = value;
			}

			resize();
		}

		function resize() {
			var htmlTop = window.pageYOffset;
			var bodyTop = document.body.scrollTop;
			var originalHeight = ta.style.height;

			ta.style.height = 'auto';

			var endHeight = ta.scrollHeight + heightOffset;

			if (ta.scrollHeight === 0) {
				// If the scrollHeight is 0, then the element probably has display:none or is detached from the DOM.
				ta.style.height = originalHeight;
				return;
			}

			ta.style.height = endHeight + 'px';

			// used to check if an update is actually necessary on window.resize
			clientWidth = ta.clientWidth;

			// prevents scroll-position jumping
			document.documentElement.scrollTop = htmlTop;
			document.body.scrollTop = bodyTop;
		}

		function update() {
			var startHeight = ta.style.height;

			resize();

			var style = window.getComputedStyle(ta, null);

			if (style.height !== ta.style.height) {
				if (overflowY !== 'visible') {
					changeOverflow('visible');
				}
			} else {
				if (overflowY !== 'hidden') {
					changeOverflow('hidden');
				}
			}

			if (startHeight !== ta.style.height) {
				var evt = document.createEvent('Event');
				evt.initEvent('autosize:resized', true, false);
				ta.dispatchEvent(evt);
			}
		}

		var pageResize = function pageResize() {
			if (ta.clientWidth !== clientWidth) {
				update();
			}
		};

		var destroy = (function (style) {
			window.removeEventListener('resize', pageResize, false);
			ta.removeEventListener('input', update, false);
			ta.removeEventListener('keyup', update, false);
			ta.removeEventListener('autosize:destroy', destroy, false);
			ta.removeEventListener('autosize:update', update, false);
			set['delete'](ta);

			Object.keys(style).forEach(function (key) {
				ta.style[key] = style[key];
			});
		}).bind(ta, {
			height: ta.style.height,
			resize: ta.style.resize,
			overflowY: ta.style.overflowY,
			overflowX: ta.style.overflowX,
			wordWrap: ta.style.wordWrap });

		ta.addEventListener('autosize:destroy', destroy, false);

		// IE9 does not fire onpropertychange or oninput for deletions,
		// so binding to onkeyup to catch most of those events.
		// There is no way that I know of to detect something like 'cut' in IE9.
		if ('onpropertychange' in ta && 'oninput' in ta) {
			ta.addEventListener('keyup', update, false);
		}

		window.addEventListener('resize', pageResize, false);
		ta.addEventListener('input', update, false);
		ta.addEventListener('autosize:update', update, false);
		set.add(ta);

		if (setOverflowX) {
			ta.style.overflowX = 'hidden';
			ta.style.wordWrap = 'break-word';
		}

		init();
	}

	function destroy(ta) {
		if (!(ta && ta.nodeName && ta.nodeName === 'TEXTAREA')) return;
		var evt = document.createEvent('Event');
		evt.initEvent('autosize:destroy', true, false);
		ta.dispatchEvent(evt);
	}

	function update(ta) {
		if (!(ta && ta.nodeName && ta.nodeName === 'TEXTAREA')) return;
		var evt = document.createEvent('Event');
		evt.initEvent('autosize:update', true, false);
		ta.dispatchEvent(evt);
	}

	var autosize = null;

	// Do nothing in Node.js environment and IE8 (or lower)
	if (typeof window === 'undefined' || typeof window.getComputedStyle !== 'function') {
		autosize = function (el) {
			return el;
		};
		autosize.destroy = function (el) {
			return el;
		};
		autosize.update = function (el) {
			return el;
		};
	} else {
		autosize = function (el, options) {
			if (el) {
				Array.prototype.forEach.call(el.length ? el : [el], function (x) {
					return assign(x, options);
				});
			}
			return el;
		};
		autosize.destroy = function (el) {
			if (el) {
				Array.prototype.forEach.call(el.length ? el : [el], destroy);
			}
			return el;
		};
		autosize.update = function (el) {
			if (el) {
				Array.prototype.forEach.call(el.length ? el : [el], update);
			}
			return el;
		};
	}

	module.exports = autosize;
});

/***/ }),

/***/ "../../../vendor/assets/javascripts/date.format.js":
/***/ (function(module, exports, __webpack_require__) {

/*
 * Date Format 1.2.3
 * (c) 2007-2009 Steven Levithan <stevenlevithan.com>
 * MIT license
 *
 * Includes enhancements by Scott Trenda <scott.trenda.net>
 * and Kris Kowal <cixar.com/~kris.kowal/>
 *
 * Accepts a date, a mask, or a date and a mask.
 * Returns a formatted version of the given date.
 * The date defaults to the current date/time.
 * The mask defaults to dateFormat.masks.default.
 */
 (function (global, factory) {
      true ? module.exports = factory() :
     typeof define === 'function' && define.amd ? define(factory) :
     (global.dateFormat = factory());
 }(this, (function () { 'use strict';
  var dateFormat = function () {
    var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g,
      timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,
      timezoneClip = /[^-+\dA-Z]/g,
      pad = function (val, len) {
        val = String(val);
        len = len || 2;
        while (val.length < len) val = "0" + val;
        return val;
      };

    // Regexes and supporting functions are cached through closure
    return function (date, mask, utc) {
      var dF = dateFormat;

      // You can't provide utc if you skip other args (use the "UTC:" mask prefix)
      if (arguments.length == 1 && Object.prototype.toString.call(date) == "[object String]" && !/\d/.test(date)) {
        mask = date;
        date = undefined;
      }

      // Passing date through Date applies Date.parse, if necessary
      date = date ? new Date(date) : new Date;
      if (isNaN(date)) throw SyntaxError("invalid date");

      mask = String(dF.masks[mask] || mask || dF.masks["default"]);

      // Allow setting the utc argument via the mask
      if (mask.slice(0, 4) == "UTC:") {
        mask = mask.slice(4);
        utc = true;
      }

      var _ = utc ? "getUTC" : "get",
        d = date[_ + "Date"](),
        D = date[_ + "Day"](),
        m = date[_ + "Month"](),
        y = date[_ + "FullYear"](),
        H = date[_ + "Hours"](),
        M = date[_ + "Minutes"](),
        s = date[_ + "Seconds"](),
        L = date[_ + "Milliseconds"](),
        o = utc ? 0 : date.getTimezoneOffset(),
        flags = {
          d:    d,
          dd:   pad(d),
          ddd:  dF.i18n.dayNames[D],
          dddd: dF.i18n.dayNames[D + 7],
          m:    m + 1,
          mm:   pad(m + 1),
          mmm:  dF.i18n.monthNames[m],
          mmmm: dF.i18n.monthNames[m + 12],
          yy:   String(y).slice(2),
          yyyy: y,
          h:    H % 12 || 12,
          hh:   pad(H % 12 || 12),
          H:    H,
          HH:   pad(H),
          M:    M,
          MM:   pad(M),
          s:    s,
          ss:   pad(s),
          l:    pad(L, 3),
          L:    pad(L > 99 ? Math.round(L / 10) : L),
          t:    H < 12 ? "a"  : "p",
          tt:   H < 12 ? "am" : "pm",
          T:    H < 12 ? "A"  : "P",
          TT:   H < 12 ? "AM" : "PM",
          Z:    utc ? "UTC" : (String(date).match(timezone) || [""]).pop().replace(timezoneClip, ""),
          o:    (o > 0 ? "-" : "+") + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
          S:    ["th", "st", "nd", "rd"][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10]
        };

      return mask.replace(token, function ($0) {
        return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
      });
    };
  }();

  // Some common format strings
  dateFormat.masks = {
    "default":      "ddd mmm dd yyyy HH:MM:ss",
    shortDate:      "m/d/yy",
    mediumDate:     "mmm d, yyyy",
    longDate:       "mmmm d, yyyy",
    fullDate:       "dddd, mmmm d, yyyy",
    shortTime:      "h:MM TT",
    mediumTime:     "h:MM:ss TT",
    longTime:       "h:MM:ss TT Z",
    isoDate:        "yyyy-mm-dd",
    isoTime:        "HH:MM:ss",
    isoDateTime:    "yyyy-mm-dd'T'HH:MM:ss",
    isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"
  };

  // Internationalization strings
  dateFormat.i18n = {
    dayNames: [
      "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat",
      "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
    ],
    monthNames: [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
      "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
    ]
  };

  // For convenience...
  Date.prototype.format = function (mask, utc) {
    return dateFormat(this, mask, utc);
  };

  return dateFormat;
})));


/***/ }),

/***/ "../../../vendor/assets/javascripts/fuzzaldrin-plus.js":
/***/ (function(module, exports, __webpack_require__) {

var require;var require;/*!
 * fuzzaldrin-plus.js - 0.3.1
 * https://github.com/jeancroy/fuzzaldrin-plus
 *
 * Copyright 2016 - Jean Christophe Roy
 * Released under the MIT license
 * https://github.com/jeancroy/fuzzaldrin-plus/raw/master/LICENSE.md
 */
(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
fuzzaldrinPlus = require('fuzzaldrin-plus');

},{"fuzzaldrin-plus":3}],2:[function(require,module,exports){
(function() {
  var PathSeparator, legacy_scorer, pluckCandidates, scorer, sortCandidates;

  scorer = require('./scorer');

  legacy_scorer = require('./legacy');

  pluckCandidates = function(a) {
    return a.candidate;
  };

  sortCandidates = function(a, b) {
    return b.score - a.score;
  };

  PathSeparator = require('path').sep;

  module.exports = function(candidates, query, _arg) {
    var allowErrors, bAllowErrors, bKey, candidate, coreQuery, key, legacy, maxInners, maxResults, prepQuery, queryHasSlashes, score, scoredCandidates, spotLeft, string, _i, _j, _len, _len1, _ref;
    _ref = _arg != null ? _arg : {}, key = _ref.key, maxResults = _ref.maxResults, maxInners = _ref.maxInners, allowErrors = _ref.allowErrors, legacy = _ref.legacy;
    scoredCandidates = [];
    spotLeft = (maxInners != null) && maxInners > 0 ? maxInners : candidates.length;
    bAllowErrors = !!allowErrors;
    bKey = key != null;
    prepQuery = scorer.prepQuery(query);
    if (!legacy) {
      for (_i = 0, _len = candidates.length; _i < _len; _i++) {
        candidate = candidates[_i];
        string = bKey ? candidate[key] : candidate;
        if (!string) {
          continue;
        }
        score = scorer.score(string, query, prepQuery, bAllowErrors);
        if (score > 0) {
          scoredCandidates.push({
            candidate: candidate,
            score: score
          });
          if (!--spotLeft) {
            break;
          }
        }
      }
    } else {
      queryHasSlashes = prepQuery.depth > 0;
      coreQuery = prepQuery.core;
      for (_j = 0, _len1 = candidates.length; _j < _len1; _j++) {
        candidate = candidates[_j];
        string = key != null ? candidate[key] : candidate;
        if (!string) {
          continue;
        }
        score = legacy_scorer.score(string, coreQuery, queryHasSlashes);
        if (!queryHasSlashes) {
          score = legacy_scorer.basenameScore(string, coreQuery, score);
        }
        if (score > 0) {
          scoredCandidates.push({
            candidate: candidate,
            score: score
          });
        }
      }
    }
    scoredCandidates.sort(sortCandidates);
    candidates = scoredCandidates.map(pluckCandidates);
    if (maxResults != null) {
      candidates = candidates.slice(0, maxResults);
    }
    return candidates;
  };

}).call(this);

},{"./legacy":4,"./scorer":6,"path":7}],3:[function(require,module,exports){
(function() {
  var PathSeparator, filter, legacy_scorer, matcher, prepQueryCache, scorer;

  scorer = require('./scorer');

  legacy_scorer = require('./legacy');

  filter = require('./filter');

  matcher = require('./matcher');

  PathSeparator = require('path').sep;

  prepQueryCache = null;

  module.exports = {
    filter: function(candidates, query, options) {
      if (!((query != null ? query.length : void 0) && (candidates != null ? candidates.length : void 0))) {
        return [];
      }
      return filter(candidates, query, options);
    },
    prepQuery: function(query) {
      return scorer.prepQuery(query);
    },
    score: function(string, query, prepQuery, _arg) {
      var allowErrors, coreQuery, legacy, queryHasSlashes, score, _ref;
      _ref = _arg != null ? _arg : {}, allowErrors = _ref.allowErrors, legacy = _ref.legacy;
      if (!((string != null ? string.length : void 0) && (query != null ? query.length : void 0))) {
        return 0;
      }
      if (prepQuery == null) {
        prepQuery = prepQueryCache && prepQueryCache.query === query ? prepQueryCache : (prepQueryCache = scorer.prepQuery(query));
      }
      if (!legacy) {
        score = scorer.score(string, query, prepQuery, !!allowErrors);
      } else {
        queryHasSlashes = prepQuery.depth > 0;
        coreQuery = prepQuery.core;
        score = legacy_scorer.score(string, coreQuery, queryHasSlashes);
        if (!queryHasSlashes) {
          score = legacy_scorer.basenameScore(string, coreQuery, score);
        }
      }
      return score;
    },
    match: function(string, query, prepQuery, _arg) {
      var allowErrors, baseMatches, matches, query_lw, string_lw, _i, _ref, _results;
      allowErrors = (_arg != null ? _arg : {}).allowErrors;
      if (!string) {
        return [];
      }
      if (!query) {
        return [];
      }
      if (string === query) {
        return (function() {
          _results = [];
          for (var _i = 0, _ref = string.length; 0 <= _ref ? _i < _ref : _i > _ref; 0 <= _ref ? _i++ : _i--){ _results.push(_i); }
          return _results;
        }).apply(this);
      }
      if (prepQuery == null) {
        prepQuery = prepQueryCache && prepQueryCache.query === query ? prepQueryCache : (prepQueryCache = scorer.prepQuery(query));
      }
      if (!(allowErrors || scorer.isMatch(string, prepQuery.core_lw, prepQuery.core_up))) {
        return [];
      }
      string_lw = string.toLowerCase();
      query_lw = prepQuery.query_lw;
      matches = matcher.match(string, string_lw, prepQuery);
      if (matches.length === 0) {
        return matches;
      }
      if (string.indexOf(PathSeparator) > -1) {
        baseMatches = matcher.basenameMatch(string, string_lw, prepQuery);
        matches = matcher.mergeMatches(matches, baseMatches);
      }
      return matches;
    }
  };

}).call(this);

},{"./filter":2,"./legacy":4,"./matcher":5,"./scorer":6,"path":7}],4:[function(require,module,exports){
(function() {
  var PathSeparator, queryIsLastPathSegment;

  PathSeparator = require('path').sep;

  exports.basenameScore = function(string, query, score) {
    var base, depth, index, lastCharacter, segmentCount, slashCount;
    index = string.length - 1;
    while (string[index] === PathSeparator) {
      index--;
    }
    slashCount = 0;
    lastCharacter = index;
    base = null;
    while (index >= 0) {
      if (string[index] === PathSeparator) {
        slashCount++;
        if (base == null) {
          base = string.substring(index + 1, lastCharacter + 1);
        }
      } else if (index === 0) {
        if (lastCharacter < string.length - 1) {
          if (base == null) {
            base = string.substring(0, lastCharacter + 1);
          }
        } else {
          if (base == null) {
            base = string;
          }
        }
      }
      index--;
    }
    if (base === string) {
      score *= 2;
    } else if (base) {
      score += exports.score(base, query);
    }
    segmentCount = slashCount + 1;
    depth = Math.max(1, 10 - segmentCount);
    score *= depth * 0.01;
    return score;
  };

  exports.score = function(string, query) {
    var character, characterScore, indexInQuery, indexInString, lowerCaseIndex, minIndex, queryLength, queryScore, stringLength, totalCharacterScore, upperCaseIndex, _ref;
    if (string === query) {
      return 1;
    }
    if (queryIsLastPathSegment(string, query)) {
      return 1;
    }
    totalCharacterScore = 0;
    queryLength = query.length;
    stringLength = string.length;
    indexInQuery = 0;
    indexInString = 0;
    while (indexInQuery < queryLength) {
      character = query[indexInQuery++];
      lowerCaseIndex = string.indexOf(character.toLowerCase());
      upperCaseIndex = string.indexOf(character.toUpperCase());
      minIndex = Math.min(lowerCaseIndex, upperCaseIndex);
      if (minIndex === -1) {
        minIndex = Math.max(lowerCaseIndex, upperCaseIndex);
      }
      indexInString = minIndex;
      if (indexInString === -1) {
        return 0;
      }
      characterScore = 0.1;
      if (string[indexInString] === character) {
        characterScore += 0.1;
      }
      if (indexInString === 0 || string[indexInString - 1] === PathSeparator) {
        characterScore += 0.8;
      } else if ((_ref = string[indexInString - 1]) === '-' || _ref === '_' || _ref === ' ') {
        characterScore += 0.7;
      }
      string = string.substring(indexInString + 1, stringLength);
      totalCharacterScore += characterScore;
    }
    queryScore = totalCharacterScore / queryLength;
    return ((queryScore * (queryLength / stringLength)) + queryScore) / 2;
  };

  queryIsLastPathSegment = function(string, query) {
    if (string[string.length - query.length - 1] === PathSeparator) {
      return string.lastIndexOf(query) === string.length - query.length;
    }
  };

  exports.match = function(string, query, stringOffset) {
    var character, indexInQuery, indexInString, lowerCaseIndex, matches, minIndex, queryLength, stringLength, upperCaseIndex, _i, _ref, _results;
    if (stringOffset == null) {
      stringOffset = 0;
    }
    if (string === query) {
      return (function() {
        _results = [];
        for (var _i = stringOffset, _ref = stringOffset + string.length; stringOffset <= _ref ? _i < _ref : _i > _ref; stringOffset <= _ref ? _i++ : _i--){ _results.push(_i); }
        return _results;
      }).apply(this);
    }
    queryLength = query.length;
    stringLength = string.length;
    indexInQuery = 0;
    indexInString = 0;
    matches = [];
    while (indexInQuery < queryLength) {
      character = query[indexInQuery++];
      lowerCaseIndex = string.indexOf(character.toLowerCase());
      upperCaseIndex = string.indexOf(character.toUpperCase());
      minIndex = Math.min(lowerCaseIndex, upperCaseIndex);
      if (minIndex === -1) {
        minIndex = Math.max(lowerCaseIndex, upperCaseIndex);
      }
      indexInString = minIndex;
      if (indexInString === -1) {
        return [];
      }
      matches.push(stringOffset + indexInString);
      stringOffset += indexInString + 1;
      string = string.substring(indexInString + 1, stringLength);
    }
    return matches;
  };

}).call(this);

},{"path":7}],5:[function(require,module,exports){
(function() {
  var PathSeparator, scorer;

  PathSeparator = require('path').sep;

  scorer = require('./scorer');

  exports.basenameMatch = function(subject, subject_lw, prepQuery) {
    var basePos, depth, end;
    end = subject.length - 1;
    while (subject[end] === PathSeparator) {
      end--;
    }
    basePos = subject.lastIndexOf(PathSeparator, end);
    if (basePos === -1) {
      return [];
    }
    depth = prepQuery.depth;
    while (depth-- > 0) {
      basePos = subject.lastIndexOf(PathSeparator, basePos - 1);
      if (basePos === -1) {
        return [];
      }
    }
    basePos++;
    end++;
    return exports.match(subject.slice(basePos, end), subject_lw.slice(basePos, end), prepQuery, basePos);
  };

  exports.mergeMatches = function(a, b) {
    var ai, bj, i, j, m, n, out;
    m = a.length;
    n = b.length;
    if (n === 0) {
      return a.slice();
    }
    if (m === 0) {
      return b.slice();
    }
    i = -1;
    j = 0;
    bj = b[j];
    out = [];
    while (++i < m) {
      ai = a[i];
      while (bj <= ai && ++j < n) {
        if (bj < ai) {
          out.push(bj);
        }
        bj = b[j];
      }
      out.push(ai);
    }
    while (j < n) {
      out.push(b[j++]);
    }
    return out;
  };

  exports.match = function(subject, subject_lw, prepQuery, offset) {
    var DIAGONAL, LEFT, STOP, UP, acro_score, align, backtrack, csc_diag, csc_row, csc_score, i, j, m, matches, move, n, pos, query, query_lw, score, score_diag, score_row, score_up, si_lw, start, trace;
    if (offset == null) {
      offset = 0;
    }
    query = prepQuery.query;
    query_lw = prepQuery.query_lw;
    m = subject.length;
    n = query.length;
    acro_score = scorer.scoreAcronyms(subject, subject_lw, query, query_lw).score;
    score_row = new Array(n);
    csc_row = new Array(n);
    STOP = 0;
    UP = 1;
    LEFT = 2;
    DIAGONAL = 3;
    trace = new Array(m * n);
    pos = -1;
    j = -1;
    while (++j < n) {
      score_row[j] = 0;
      csc_row[j] = 0;
    }
    i = -1;
    while (++i < m) {
      score = 0;
      score_up = 0;
      csc_diag = 0;
      si_lw = subject_lw[i];
      j = -1;
      while (++j < n) {
        csc_score = 0;
        align = 0;
        score_diag = score_up;
        if (query_lw[j] === si_lw) {
          start = scorer.isWordStart(i, subject, subject_lw);
          csc_score = csc_diag > 0 ? csc_diag : scorer.scoreConsecutives(subject, subject_lw, query, query_lw, i, j, start);
          align = score_diag + scorer.scoreCharacter(i, j, start, acro_score, csc_score);
        }
        score_up = score_row[j];
        csc_diag = csc_row[j];
        if (score > score_up) {
          move = LEFT;
        } else {
          score = score_up;
          move = UP;
        }
        if (align > score) {
          score = align;
          move = DIAGONAL;
        } else {
          csc_score = 0;
        }
        score_row[j] = score;
        csc_row[j] = csc_score;
        trace[++pos] = score > 0 ? move : STOP;
      }
    }
    i = m - 1;
    j = n - 1;
    pos = i * n + j;
    backtrack = true;
    matches = [];
    while (backtrack && i >= 0 && j >= 0) {
      switch (trace[pos]) {
        case UP:
          i--;
          pos -= n;
          break;
        case LEFT:
          j--;
          pos--;
          break;
        case DIAGONAL:
          matches.push(i + offset);
          j--;
          i--;
          pos -= n + 1;
          break;
        default:
          backtrack = false;
      }
    }
    matches.reverse();
    return matches;
  };

}).call(this);

},{"./scorer":6,"path":7}],6:[function(require,module,exports){
(function() {
  var AcronymResult, PathSeparator, Query, basenameScore, coreChars, countDir, doScore, emptyAcronymResult, file_coeff, isMatch, isSeparator, isWordEnd, isWordStart, miss_coeff, opt_char_re, pos_bonus, scoreAcronyms, scoreCharacter, scoreConsecutives, scoreExact, scoreExactMatch, scorePattern, scorePosition, scoreSize, tau_depth, tau_size, truncatedUpperCase, wm;

  PathSeparator = require('path').sep;

  wm = 150;

  pos_bonus = 20;

  tau_depth = 13;

  tau_size = 85;

  file_coeff = 1.2;

  miss_coeff = 0.75;

  opt_char_re = /[ _\-:\/\\]/g;

  exports.coreChars = coreChars = function(query) {
    return query.replace(opt_char_re, '');
  };

  exports.score = function(string, query, prepQuery, allowErrors) {
    var score, string_lw;
    if (prepQuery == null) {
      prepQuery = new Query(query);
    }
    if (allowErrors == null) {
      allowErrors = false;
    }
    if (!(allowErrors || isMatch(string, prepQuery.core_lw, prepQuery.core_up))) {
      return 0;
    }
    string_lw = string.toLowerCase();
    score = doScore(string, string_lw, prepQuery);
    return Math.ceil(basenameScore(string, string_lw, prepQuery, score));
  };

  Query = (function() {
    function Query(query) {
      if (!(query != null ? query.length : void 0)) {
        return null;
      }
      this.query = query;
      this.query_lw = query.toLowerCase();
      this.core = coreChars(query);
      this.core_lw = this.core.toLowerCase();
      this.core_up = truncatedUpperCase(this.core);
      this.depth = countDir(query, query.length);
    }

    return Query;

  })();

  exports.prepQuery = function(query) {
    return new Query(query);
  };

  exports.isMatch = isMatch = function(subject, query_lw, query_up) {
    var i, j, m, n, qj_lw, qj_up, si;
    m = subject.length;
    n = query_lw.length;
    if (!m || n > m) {
      return false;
    }
    i = -1;
    j = -1;
    while (++j < n) {
      qj_lw = query_lw[j];
      qj_up = query_up[j];
      while (++i < m) {
        si = subject[i];
        if (si === qj_lw || si === qj_up) {
          break;
        }
      }
      if (i === m) {
        return false;
      }
    }
    return true;
  };

  doScore = function(subject, subject_lw, prepQuery) {
    var acro, acro_score, align, csc_diag, csc_row, csc_score, i, j, m, miss_budget, miss_left, mm, n, pos, query, query_lw, record_miss, score, score_diag, score_row, score_up, si_lw, start, sz;
    query = prepQuery.query;
    query_lw = prepQuery.query_lw;
    m = subject.length;
    n = query.length;
    acro = scoreAcronyms(subject, subject_lw, query, query_lw);
    acro_score = acro.score;
    if (acro.count === n) {
      return scoreExact(n, m, acro_score, acro.pos);
    }
    pos = subject_lw.indexOf(query_lw);
    if (pos > -1) {
      return scoreExactMatch(subject, subject_lw, query, query_lw, pos, n, m);
    }
    score_row = new Array(n);
    csc_row = new Array(n);
    sz = scoreSize(n, m);
    miss_budget = Math.ceil(miss_coeff * n) + 5;
    miss_left = miss_budget;
    j = -1;
    while (++j < n) {
      score_row[j] = 0;
      csc_row[j] = 0;
    }
    i = subject_lw.indexOf(query_lw[0]);
    if (i > -1) {
      i--;
    }
    mm = subject_lw.lastIndexOf(query_lw[n - 1], m);
    if (mm > i) {
      m = mm + 1;
    }
    while (++i < m) {
      score = 0;
      score_diag = 0;
      csc_diag = 0;
      si_lw = subject_lw[i];
      record_miss = true;
      j = -1;
      while (++j < n) {
        score_up = score_row[j];
        if (score_up > score) {
          score = score_up;
        }
        csc_score = 0;
        if (query_lw[j] === si_lw) {
          start = isWordStart(i, subject, subject_lw);
          csc_score = csc_diag > 0 ? csc_diag : scoreConsecutives(subject, subject_lw, query, query_lw, i, j, start);
          align = score_diag + scoreCharacter(i, j, start, acro_score, csc_score);
          if (align > score) {
            score = align;
            miss_left = miss_budget;
          } else {
            if (record_miss && --miss_left <= 0) {
              return score_row[n - 1] * sz;
            }
            record_miss = false;
          }
        }
        score_diag = score_up;
        csc_diag = csc_row[j];
        csc_row[j] = csc_score;
        score_row[j] = score;
      }
    }
    return score * sz;
  };

  exports.isWordStart = isWordStart = function(pos, subject, subject_lw) {
    var curr_s, prev_s;
    if (pos === 0) {
      return true;
    }
    curr_s = subject[pos];
    prev_s = subject[pos - 1];
    return isSeparator(curr_s) || isSeparator(prev_s) || (curr_s !== subject_lw[pos] && prev_s === subject_lw[pos - 1]);
  };

  exports.isWordEnd = isWordEnd = function(pos, subject, subject_lw, len) {
    var curr_s, next_s;
    if (pos === len - 1) {
      return true;
    }
    curr_s = subject[pos];
    next_s = subject[pos + 1];
    return isSeparator(curr_s) || isSeparator(next_s) || (curr_s === subject_lw[pos] && next_s !== subject_lw[pos + 1]);
  };

  isSeparator = function(c) {
    return c === ' ' || c === '.' || c === '-' || c === '_' || c === '/' || c === '\\';
  };

  scorePosition = function(pos) {
    var sc;
    if (pos < pos_bonus) {
      sc = pos_bonus - pos;
      return 100 + sc * sc;
    } else {
      return Math.max(100 + pos_bonus - pos, 0);
    }
  };

  scoreSize = function(n, m) {
    return tau_size / (tau_size + Math.abs(m - n));
  };

  scoreExact = function(n, m, quality, pos) {
    return 2 * n * (wm * quality + scorePosition(pos)) * scoreSize(n, m);
  };

  exports.scorePattern = scorePattern = function(count, len, sameCase, start, end) {
    var bonus, sz;
    sz = count;
    bonus = 6;
    if (sameCase === count) {
      bonus += 2;
    }
    if (start) {
      bonus += 3;
    }
    if (end) {
      bonus += 1;
    }
    if (count === len) {
      if (start) {
        if (sameCase === len) {
          sz += 2;
        } else {
          sz += 1;
        }
      }
      if (end) {
        bonus += 1;
      }
    }
    return sameCase + sz * (sz + bonus);
  };

  exports.scoreCharacter = scoreCharacter = function(i, j, start, acro_score, csc_score) {
    var posBonus;
    posBonus = scorePosition(i);
    if (start) {
      return posBonus + wm * ((acro_score > csc_score ? acro_score : csc_score) + 10);
    }
    return posBonus + wm * csc_score;
  };

  exports.scoreConsecutives = scoreConsecutives = function(subject, subject_lw, query, query_lw, i, j, start) {
    var k, m, mi, n, nj, sameCase, startPos, sz;
    m = subject.length;
    n = query.length;
    mi = m - i;
    nj = n - j;
    k = mi < nj ? mi : nj;
    startPos = i;
    sameCase = 0;
    sz = 0;
    if (query[j] === subject[i]) {
      sameCase++;
    }
    while (++sz < k && query_lw[++j] === subject_lw[++i]) {
      if (query[j] === subject[i]) {
        sameCase++;
      }
    }
    if (sz === 1) {
      return 1 + 2 * sameCase;
    }
    return scorePattern(sz, n, sameCase, start, isWordEnd(i, subject, subject_lw, m));
  };

  exports.scoreExactMatch = scoreExactMatch = function(subject, subject_lw, query, query_lw, pos, n, m) {
    var end, i, pos2, sameCase, start;
    start = isWordStart(pos, subject, subject_lw);
    if (!start) {
      pos2 = subject_lw.indexOf(query_lw, pos + 1);
      if (pos2 > -1) {
        start = isWordStart(pos2, subject, subject_lw);
        if (start) {
          pos = pos2;
        }
      }
    }
    i = -1;
    sameCase = 0;
    while (++i < n) {
      if (query[pos + i] === subject[i]) {
        sameCase++;
      }
    }
    end = isWordEnd(pos + n - 1, subject, subject_lw, m);
    return scoreExact(n, m, scorePattern(n, n, sameCase, start, end), pos);
  };

  AcronymResult = (function() {
    function AcronymResult(score, pos, count) {
      this.score = score;
      this.pos = pos;
      this.count = count;
    }

    return AcronymResult;

  })();

  emptyAcronymResult = new AcronymResult(0, 0.1, 0);

  exports.scoreAcronyms = scoreAcronyms = function(subject, subject_lw, query, query_lw) {
    var count, i, j, m, n, pos, qj_lw, sameCase, score;
    m = subject.length;
    n = query.length;
    if (!(m > 1 && n > 1)) {
      return emptyAcronymResult;
    }
    count = 0;
    pos = 0;
    sameCase = 0;
    i = -1;
    j = -1;
    while (++j < n) {
      qj_lw = query_lw[j];
      while (++i < m) {
        if (qj_lw === subject_lw[i] && isWordStart(i, subject, subject_lw)) {
          if (query[j] === subject[i]) {
            sameCase++;
          }
          pos += i;
          count++;
          break;
        }
      }
      if (i === m) {
        break;
      }
    }
    if (count < 2) {
      return emptyAcronymResult;
    }
    score = scorePattern(count, n, sameCase, true, false);
    return new AcronymResult(score, pos / count, count);
  };

  basenameScore = function(subject, subject_lw, prepQuery, fullPathScore) {
    var alpha, basePathScore, basePos, depth, end;
    if (fullPathScore === 0) {
      return 0;
    }
    end = subject.length - 1;
    while (subject[end] === PathSeparator) {
      end--;
    }
    basePos = subject.lastIndexOf(PathSeparator, end);
    if (basePos === -1) {
      return fullPathScore;
    }
    depth = prepQuery.depth;
    while (depth-- > 0) {
      basePos = subject.lastIndexOf(PathSeparator, basePos - 1);
      if (basePos === -1) {
        return fullPathScore;
      }
    }
    basePos++;
    end++;
    basePathScore = doScore(subject.slice(basePos, end), subject_lw.slice(basePos, end), prepQuery);
    alpha = 0.5 * tau_depth / (tau_depth + countDir(subject, end + 1));
    return alpha * basePathScore + (1 - alpha) * fullPathScore * scoreSize(0, file_coeff * (end - basePos));
  };

  exports.countDir = countDir = function(path, end) {
    var count, i;
    if (end < 1) {
      return 0;
    }
    count = 0;
    i = -1;
    while (++i < end && path[i] === PathSeparator) {
      continue;
    }
    while (++i < end) {
      if (path[i] === PathSeparator) {
        count++;
        while (++i < end && path[i] === PathSeparator) {
          continue;
        }
      }
    }
    return count;
  };

  truncatedUpperCase = function(str) {
    var char, upper, _i, _len;
    upper = "";
    for (_i = 0, _len = str.length; _i < _len; _i++) {
      char = str[_i];
      upper += char.toUpperCase()[0];
    }
    return upper;
  };

}).call(this);

},{"path":7}],7:[function(require,module,exports){
(function (process){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var splitPathRe =
    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
var splitPath = function(filename) {
  return splitPathRe.exec(filename).slice(1);
};

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function(path) {
  var result = splitPath(path),
      root = result[0],
      dir = result[1];

  if (!root && !dir) {
    // No dirname whatsoever
    return '.';
  }

  if (dir) {
    // It has a dirname, strip trailing slash
    dir = dir.substr(0, dir.length - 1);
  }

  return root + dir;
};


exports.basename = function(path, ext) {
  var f = splitPath(path)[2];
  // TODO: make this comparison case-insensitive on windows?
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};


exports.extname = function(path) {
  return splitPath(path)[3];
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

}).call(this,require('_process'))
},{"_process":8}],8:[function(require,module,exports){
// shim for using process in browser

var process = module.exports = {};
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = setTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    clearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        setTimeout(drainQueue, 0);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}]},{},[1]);


/***/ }),

/***/ "../../../vendor/assets/javascripts/latinise.js":
/***/ (function(module, exports) {

// Converting text to basic latin (aka removing accents)
//
// Based on: http://semplicewebsites.com/removing-accents-javascript
//
var Latinise = {
  map: {"Á":"A","Ă":"A","Ắ":"A","Ặ":"A","Ằ":"A","Ẳ":"A","Ẵ":"A","Ǎ":"A","Â":"A","Ấ":"A","Ậ":"A","Ầ":"A","Ẩ":"A","Ẫ":"A","Ä":"A","Ǟ":"A","Ȧ":"A","Ǡ":"A","Ạ":"A","Ȁ":"A","À":"A","Ả":"A","Ȃ":"A","Ā":"A","Ą":"A","Å":"A","Ǻ":"A","Ḁ":"A","Ⱥ":"A","Ã":"A","Ꜳ":"AA","Æ":"AE","Ǽ":"AE","Ǣ":"AE","Ꜵ":"AO","Ꜷ":"AU","Ꜹ":"AV","Ꜻ":"AV","Ꜽ":"AY","Ḃ":"B","Ḅ":"B","Ɓ":"B","Ḇ":"B","Ƀ":"B","Ƃ":"B","Ć":"C","Č":"C","Ç":"C","Ḉ":"C","Ĉ":"C","Ċ":"C","Ƈ":"C","Ȼ":"C","Ď":"D","Ḑ":"D","Ḓ":"D","Ḋ":"D","Ḍ":"D","Ɗ":"D","Ḏ":"D","ǲ":"D","ǅ":"D","Đ":"D","Ƌ":"D","Ǳ":"DZ","Ǆ":"DZ","É":"E","Ĕ":"E","Ě":"E","Ȩ":"E","Ḝ":"E","Ê":"E","Ế":"E","Ệ":"E","Ề":"E","Ể":"E","Ễ":"E","Ḙ":"E","Ë":"E","Ė":"E","Ẹ":"E","Ȅ":"E","È":"E","Ẻ":"E","Ȇ":"E","Ē":"E","Ḗ":"E","Ḕ":"E","Ę":"E","Ɇ":"E","Ẽ":"E","Ḛ":"E","Ꝫ":"ET","Ḟ":"F","Ƒ":"F","Ǵ":"G","Ğ":"G","Ǧ":"G","Ģ":"G","Ĝ":"G","Ġ":"G","Ɠ":"G","Ḡ":"G","Ǥ":"G","Ḫ":"H","Ȟ":"H","Ḩ":"H","Ĥ":"H","Ⱨ":"H","Ḧ":"H","Ḣ":"H","Ḥ":"H","Ħ":"H","Í":"I","Ĭ":"I","Ǐ":"I","Î":"I","Ï":"I","Ḯ":"I","İ":"I","Ị":"I","Ȉ":"I","Ì":"I","Ỉ":"I","Ȋ":"I","Ī":"I","Į":"I","Ɨ":"I","Ĩ":"I","Ḭ":"I","Ꝺ":"D","Ꝼ":"F","Ᵹ":"G","Ꞃ":"R","Ꞅ":"S","Ꞇ":"T","Ꝭ":"IS","Ĵ":"J","Ɉ":"J","Ḱ":"K","Ǩ":"K","Ķ":"K","Ⱪ":"K","Ꝃ":"K","Ḳ":"K","Ƙ":"K","Ḵ":"K","Ꝁ":"K","Ꝅ":"K","Ĺ":"L","Ƚ":"L","Ľ":"L","Ļ":"L","Ḽ":"L","Ḷ":"L","Ḹ":"L","Ⱡ":"L","Ꝉ":"L","Ḻ":"L","Ŀ":"L","Ɫ":"L","ǈ":"L","Ł":"L","Ǉ":"LJ","Ḿ":"M","Ṁ":"M","Ṃ":"M","Ɱ":"M","Ń":"N","Ň":"N","Ņ":"N","Ṋ":"N","Ṅ":"N","Ṇ":"N","Ǹ":"N","Ɲ":"N","Ṉ":"N","Ƞ":"N","ǋ":"N","Ñ":"N","Ǌ":"NJ","Ó":"O","Ŏ":"O","Ǒ":"O","Ô":"O","Ố":"O","Ộ":"O","Ồ":"O","Ổ":"O","Ỗ":"O","Ö":"O","Ȫ":"O","Ȯ":"O","Ȱ":"O","Ọ":"O","Ő":"O","Ȍ":"O","Ò":"O","Ỏ":"O","Ơ":"O","Ớ":"O","Ợ":"O","Ờ":"O","Ở":"O","Ỡ":"O","Ȏ":"O","Ꝋ":"O","Ꝍ":"O","Ō":"O","Ṓ":"O","Ṑ":"O","Ɵ":"O","Ǫ":"O","Ǭ":"O","Ø":"O","Ǿ":"O","Õ":"O","Ṍ":"O","Ṏ":"O","Ȭ":"O","Ƣ":"OI","Ꝏ":"OO","Ɛ":"E","Ɔ":"O","Ȣ":"OU","Ṕ":"P","Ṗ":"P","Ꝓ":"P","Ƥ":"P","Ꝕ":"P","Ᵽ":"P","Ꝑ":"P","Ꝙ":"Q","Ꝗ":"Q","Ŕ":"R","Ř":"R","Ŗ":"R","Ṙ":"R","Ṛ":"R","Ṝ":"R","Ȑ":"R","Ȓ":"R","Ṟ":"R","Ɍ":"R","Ɽ":"R","Ꜿ":"C","Ǝ":"E","Ś":"S","Ṥ":"S","Š":"S","Ṧ":"S","Ş":"S","Ŝ":"S","Ș":"S","Ṡ":"S","Ṣ":"S","Ṩ":"S","ẞ":"SS","Ť":"T","Ţ":"T","Ṱ":"T","Ț":"T","Ⱦ":"T","Ṫ":"T","Ṭ":"T","Ƭ":"T","Ṯ":"T","Ʈ":"T","Ŧ":"T","Ɐ":"A","Ꞁ":"L","Ɯ":"M","Ʌ":"V","Ꜩ":"TZ","Ú":"U","Ŭ":"U","Ǔ":"U","Û":"U","Ṷ":"U","Ü":"U","Ǘ":"U","Ǚ":"U","Ǜ":"U","Ǖ":"U","Ṳ":"U","Ụ":"U","Ű":"U","Ȕ":"U","Ù":"U","Ủ":"U","Ư":"U","Ứ":"U","Ự":"U","Ừ":"U","Ử":"U","Ữ":"U","Ȗ":"U","Ū":"U","Ṻ":"U","Ų":"U","Ů":"U","Ũ":"U","Ṹ":"U","Ṵ":"U","Ꝟ":"V","Ṿ":"V","Ʋ":"V","Ṽ":"V","Ꝡ":"VY","Ẃ":"W","Ŵ":"W","Ẅ":"W","Ẇ":"W","Ẉ":"W","Ẁ":"W","Ⱳ":"W","Ẍ":"X","Ẋ":"X","Ý":"Y","Ŷ":"Y","Ÿ":"Y","Ẏ":"Y","Ỵ":"Y","Ỳ":"Y","Ƴ":"Y","Ỷ":"Y","Ỿ":"Y","Ȳ":"Y","Ɏ":"Y","Ỹ":"Y","Ź":"Z","Ž":"Z","Ẑ":"Z","Ⱬ":"Z","Ż":"Z","Ẓ":"Z","Ȥ":"Z","Ẕ":"Z","Ƶ":"Z","Ĳ":"IJ","Œ":"OE","ᴀ":"A","ᴁ":"AE","ʙ":"B","ᴃ":"B","ᴄ":"C","ᴅ":"D","ᴇ":"E","ꜰ":"F","ɢ":"G","ʛ":"G","ʜ":"H","ɪ":"I","ʁ":"R","ᴊ":"J","ᴋ":"K","ʟ":"L","ᴌ":"L","ᴍ":"M","ɴ":"N","ᴏ":"O","ɶ":"OE","ᴐ":"O","ᴕ":"OU","ᴘ":"P","ʀ":"R","ᴎ":"N","ᴙ":"R","ꜱ":"S","ᴛ":"T","ⱻ":"E","ᴚ":"R","ᴜ":"U","ᴠ":"V","ᴡ":"W","ʏ":"Y","ᴢ":"Z","á":"a","ă":"a","ắ":"a","ặ":"a","ằ":"a","ẳ":"a","ẵ":"a","ǎ":"a","â":"a","ấ":"a","ậ":"a","ầ":"a","ẩ":"a","ẫ":"a","ä":"a","ǟ":"a","ȧ":"a","ǡ":"a","ạ":"a","ȁ":"a","à":"a","ả":"a","ȃ":"a","ā":"a","ą":"a","ᶏ":"a","ẚ":"a","å":"a","ǻ":"a","ḁ":"a","ⱥ":"a","ã":"a","ꜳ":"aa","æ":"ae","ǽ":"ae","ǣ":"ae","ꜵ":"ao","ꜷ":"au","ꜹ":"av","ꜻ":"av","ꜽ":"ay","ḃ":"b","ḅ":"b","ɓ":"b","ḇ":"b","ᵬ":"b","ᶀ":"b","ƀ":"b","ƃ":"b","ɵ":"o","ć":"c","č":"c","ç":"c","ḉ":"c","ĉ":"c","ɕ":"c","ċ":"c","ƈ":"c","ȼ":"c","ď":"d","ḑ":"d","ḓ":"d","ȡ":"d","ḋ":"d","ḍ":"d","ɗ":"d","ᶑ":"d","ḏ":"d","ᵭ":"d","ᶁ":"d","đ":"d","ɖ":"d","ƌ":"d","ı":"i","ȷ":"j","ɟ":"j","ʄ":"j","ǳ":"dz","ǆ":"dz","é":"e","ĕ":"e","ě":"e","ȩ":"e","ḝ":"e","ê":"e","ế":"e","ệ":"e","ề":"e","ể":"e","ễ":"e","ḙ":"e","ë":"e","ė":"e","ẹ":"e","ȅ":"e","è":"e","ẻ":"e","ȇ":"e","ē":"e","ḗ":"e","ḕ":"e","ⱸ":"e","ę":"e","ᶒ":"e","ɇ":"e","ẽ":"e","ḛ":"e","ꝫ":"et","ḟ":"f","ƒ":"f","ᵮ":"f","ᶂ":"f","ǵ":"g","ğ":"g","ǧ":"g","ģ":"g","ĝ":"g","ġ":"g","ɠ":"g","ḡ":"g","ᶃ":"g","ǥ":"g","ḫ":"h","ȟ":"h","ḩ":"h","ĥ":"h","ⱨ":"h","ḧ":"h","ḣ":"h","ḥ":"h","ɦ":"h","ẖ":"h","ħ":"h","ƕ":"hv","í":"i","ĭ":"i","ǐ":"i","î":"i","ï":"i","ḯ":"i","ị":"i","ȉ":"i","ì":"i","ỉ":"i","ȋ":"i","ī":"i","į":"i","ᶖ":"i","ɨ":"i","ĩ":"i","ḭ":"i","ꝺ":"d","ꝼ":"f","ᵹ":"g","ꞃ":"r","ꞅ":"s","ꞇ":"t","ꝭ":"is","ǰ":"j","ĵ":"j","ʝ":"j","ɉ":"j","ḱ":"k","ǩ":"k","ķ":"k","ⱪ":"k","ꝃ":"k","ḳ":"k","ƙ":"k","ḵ":"k","ᶄ":"k","ꝁ":"k","ꝅ":"k","ĺ":"l","ƚ":"l","ɬ":"l","ľ":"l","ļ":"l","ḽ":"l","ȴ":"l","ḷ":"l","ḹ":"l","ⱡ":"l","ꝉ":"l","ḻ":"l","ŀ":"l","ɫ":"l","ᶅ":"l","ɭ":"l","ł":"l","ǉ":"lj","ſ":"s","ẜ":"s","ẛ":"s","ẝ":"s","ḿ":"m","ṁ":"m","ṃ":"m","ɱ":"m","ᵯ":"m","ᶆ":"m","ń":"n","ň":"n","ņ":"n","ṋ":"n","ȵ":"n","ṅ":"n","ṇ":"n","ǹ":"n","ɲ":"n","ṉ":"n","ƞ":"n","ᵰ":"n","ᶇ":"n","ɳ":"n","ñ":"n","ǌ":"nj","ó":"o","ŏ":"o","ǒ":"o","ô":"o","ố":"o","ộ":"o","ồ":"o","ổ":"o","ỗ":"o","ö":"o","ȫ":"o","ȯ":"o","ȱ":"o","ọ":"o","ő":"o","ȍ":"o","ò":"o","ỏ":"o","ơ":"o","ớ":"o","ợ":"o","ờ":"o","ở":"o","ỡ":"o","ȏ":"o","ꝋ":"o","ꝍ":"o","ⱺ":"o","ō":"o","ṓ":"o","ṑ":"o","ǫ":"o","ǭ":"o","ø":"o","ǿ":"o","õ":"o","ṍ":"o","ṏ":"o","ȭ":"o","ƣ":"oi","ꝏ":"oo","ɛ":"e","ᶓ":"e","ɔ":"o","ᶗ":"o","ȣ":"ou","ṕ":"p","ṗ":"p","ꝓ":"p","ƥ":"p","ᵱ":"p","ᶈ":"p","ꝕ":"p","ᵽ":"p","ꝑ":"p","ꝙ":"q","ʠ":"q","ɋ":"q","ꝗ":"q","ŕ":"r","ř":"r","ŗ":"r","ṙ":"r","ṛ":"r","ṝ":"r","ȑ":"r","ɾ":"r","ᵳ":"r","ȓ":"r","ṟ":"r","ɼ":"r","ᵲ":"r","ᶉ":"r","ɍ":"r","ɽ":"r","ↄ":"c","ꜿ":"c","ɘ":"e","ɿ":"r","ś":"s","ṥ":"s","š":"s","ṧ":"s","ş":"s","ŝ":"s","ș":"s","ṡ":"s","ṣ":"s","ṩ":"s","ʂ":"s","ᵴ":"s","ᶊ":"s","ȿ":"s","ɡ":"g","ß":"ss","ᴑ":"o","ᴓ":"o","ᴝ":"u","ť":"t","ţ":"t","ṱ":"t","ț":"t","ȶ":"t","ẗ":"t","ⱦ":"t","ṫ":"t","ṭ":"t","ƭ":"t","ṯ":"t","ᵵ":"t","ƫ":"t","ʈ":"t","ŧ":"t","ᵺ":"th","ɐ":"a","ᴂ":"ae","ǝ":"e","ᵷ":"g","ɥ":"h","ʮ":"h","ʯ":"h","ᴉ":"i","ʞ":"k","ꞁ":"l","ɯ":"m","ɰ":"m","ᴔ":"oe","ɹ":"r","ɻ":"r","ɺ":"r","ⱹ":"r","ʇ":"t","ʌ":"v","ʍ":"w","ʎ":"y","ꜩ":"tz","ú":"u","ŭ":"u","ǔ":"u","û":"u","ṷ":"u","ü":"u","ǘ":"u","ǚ":"u","ǜ":"u","ǖ":"u","ṳ":"u","ụ":"u","ű":"u","ȕ":"u","ù":"u","ủ":"u","ư":"u","ứ":"u","ự":"u","ừ":"u","ử":"u","ữ":"u","ȗ":"u","ū":"u","ṻ":"u","ų":"u","ᶙ":"u","ů":"u","ũ":"u","ṹ":"u","ṵ":"u","ᵫ":"ue","ꝸ":"um","ⱴ":"v","ꝟ":"v","ṿ":"v","ʋ":"v","ᶌ":"v","ⱱ":"v","ṽ":"v","ꝡ":"vy","ẃ":"w","ŵ":"w","ẅ":"w","ẇ":"w","ẉ":"w","ẁ":"w","ⱳ":"w","ẘ":"w","ẍ":"x","ẋ":"x","ᶍ":"x","ý":"y","ŷ":"y","ÿ":"y","ẏ":"y","ỵ":"y","ỳ":"y","ƴ":"y","ỷ":"y","ỿ":"y","ȳ":"y","ẙ":"y","ɏ":"y","ỹ":"y","ź":"z","ž":"z","ẑ":"z","ʑ":"z","ⱬ":"z","ż":"z","ẓ":"z","ȥ":"z","ẕ":"z","ᵶ":"z","ᶎ":"z","ʐ":"z","ƶ":"z","ɀ":"z","ﬀ":"ff","ﬃ":"ffi","ﬄ":"ffl","ﬁ":"fi","ﬂ":"fl","ĳ":"ij","œ":"oe","ﬆ":"st","ₐ":"a","ₑ":"e","ᵢ":"i","ⱼ":"j","ₒ":"o","ᵣ":"r","ᵤ":"u","ᵥ":"v","ₓ":"x"}
};

String.prototype.latinise = function() {
  return this.replace(/[^A-Za-z0-9]/g, function(x) { return Latinise.map[x] || x; });
};


/***/ }),

/***/ "../../../vendor/assets/javascripts/peek.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {(function($) {
  var fetchRequestResults, getRequestId, peekEnabled, toggleBar, updatePerformanceBar;
  getRequestId = function() {
    return $('#peek').data('request-id');
  };
  peekEnabled = function() {
    return $('#peek').length;
  };
  updatePerformanceBar = function(results) {
    var key, label, data, table, html, tr, duration_td, sql_td, strong;

    Object.keys(results.data).forEach(function(key) {
      Object.keys(results.data[key]).forEach(function(label) {
        data = results.data[key][label];

        if (label == 'queries') {
          table = document.createElement('table');

          for (var i = 0; i < data.length; i += 1) {
            tr = document.createElement('tr');
            duration_td = document.createElement('td');
            sql_td = document.createElement('td');
            strong = document.createElement('strong');

            strong.append(data[i]['duration'] + 'ms');
            duration_td.appendChild(strong);
            tr.appendChild(duration_td);

            sql_td.appendChild(document.createTextNode(data[i]['sql']));
            tr.appendChild(sql_td);

            table.appendChild(tr);
          }

          table.className = 'table';
          $("[data-defer-to=" + key + "-" + label + "]").html(table);
        } else {
          $("[data-defer-to=" + key + "-" + label + "]").text(results.data[key][label]);
        }
      });
    });
    return $(document).trigger('peek:render', [getRequestId(), results]);
  };
  toggleBar = function(event) {
    var wrapper;
    if ($(event.target).is(':input')) {
      return;
    }
    if (event.which === 96 && !event.metaKey) {
      wrapper = $('#peek');
      if (wrapper.hasClass('disabled')) {
        wrapper.removeClass('disabled');
        return document.cookie = "peek=true; path=/";
      } else {
        wrapper.addClass('disabled');
        return document.cookie = "peek=false; path=/";
      }
    }
  };
  fetchRequestResults = function() {
    return $.ajax('/-/peek/results', {
      data: {
        request_id: getRequestId()
      },
      success: function(data, textStatus, xhr) {
        return updatePerformanceBar(data);
      },
      error: function(xhr, textStatus, error) {}
    });
  };
  $(document).on('keypress', toggleBar);
  $(document).on('peek:update', fetchRequestResults);
  return $(function() {
    if (peekEnabled()) {
      return $(this).trigger('peek:update');
    }
  });
})(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "../../../vendor/assets/javascripts/peek.performance_bar.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var PerformanceBar, ajaxStart, renderPerformanceBar, updateStatus;

PerformanceBar = (function() {
  PerformanceBar.prototype.appInfo = null;

  PerformanceBar.prototype.width = null;

  PerformanceBar.formatTime = function(value) {
    if (value >= 1000) {
      return ((value / 1000).toFixed(3)) + "s";
    } else {
      return (value.toFixed(0)) + "ms";
    }
  };

  function PerformanceBar(options) {
    var k, v;
    if (options == null) {
      options = {};
    }
    this.el = $('#peek-view-performance-bar .performance-bar');
    for (k in options) {
      v = options[k];
      this[k] = v;
    }
    if (this.width == null) {
      this.width = this.el.width();
    }
    if (this.timing == null) {
      this.timing = window.performance.timing;
    }
  }

  PerformanceBar.prototype.render = function(serverTime) {
    var networkTime, perfNetworkTime;
    if (serverTime == null) {
      serverTime = 0;
    }
    this.el.empty();
    this.addBar('frontend', '#90d35b', 'domLoading', 'domInteractive');
    perfNetworkTime = this.timing.responseEnd - this.timing.requestStart;
    if (serverTime && serverTime <= perfNetworkTime) {
      networkTime = perfNetworkTime - serverTime;
      this.addBar('latency / receiving', '#f1faff', this.timing.requestStart + serverTime, this.timing.requestStart + serverTime + networkTime);
      this.addBar('app', '#90afcf', this.timing.requestStart, this.timing.requestStart + serverTime, this.appInfo);
    } else {
      this.addBar('backend', '#c1d7ee', 'requestStart', 'responseEnd');
    }
    this.addBar('tcp / ssl', '#45688e', 'connectStart', 'connectEnd');
    this.addBar('redirect', '#0c365e', 'redirectStart', 'redirectEnd');
    this.addBar('dns', '#082541', 'domainLookupStart', 'domainLookupEnd');
    return this.el;
  };

  PerformanceBar.prototype.isLoaded = function() {
    return this.timing.domInteractive;
  };

  PerformanceBar.prototype.start = function() {
    return this.timing.navigationStart;
  };

  PerformanceBar.prototype.end = function() {
    return this.timing.domInteractive;
  };

  PerformanceBar.prototype.total = function() {
    return this.end() - this.start();
  };

  PerformanceBar.prototype.addBar = function(name, color, start, end, info) {
    var bar, left, offset, time, title, width;
    if (typeof start === 'string') {
      start = this.timing[start];
    }
    if (typeof end === 'string') {
      end = this.timing[end];
    }
    if (!((start != null) && (end != null))) {
      return;
    }
    time = end - start;
    offset = start - this.start();
    left = this.mapH(offset);
    width = this.mapH(time);
    title = name + ": " + (PerformanceBar.formatTime(time));
    bar = $('<li></li>', {
      'data-title': title,
      'data-toggle': 'tooltip',
      'data-container': 'body'
    });
    bar.css({
      width: width + "px",
      left: left + "px",
      background: color
    });
    return this.el.append(bar);
  };

  PerformanceBar.prototype.mapH = function(offset) {
    return offset * (this.width / this.total());
  };

  return PerformanceBar;

})();

renderPerformanceBar = function() {
  var bar, resp, span, time;
  resp = $('#peek-server_response_time');
  time = Math.round(resp.data('time') * 1000);
  bar = new PerformanceBar;
  bar.render(time);
  span = $('<span>', {
    'data-toggle': 'tooltip',
    'data-title': 'Total navigation time for this page.',
    'data-container': 'body'
  }).text(PerformanceBar.formatTime(bar.total()));
  return updateStatus(span);
};

updateStatus = function(html) {
  return $('#serverstats').html(html);
};

ajaxStart = null;

$(document).on('pjax:start page:fetch turbolinks:request-start', function(event) {
  return ajaxStart = event.timeStamp;
});

$(document).on('pjax:end page:load turbolinks:load', function(event, xhr) {
  var ajaxEnd, serverTime, total;
  if (ajaxStart == null) {
    return;
  }
  ajaxEnd = event.timeStamp;
  total = ajaxEnd - ajaxStart;
  serverTime = xhr ? parseInt(xhr.getResponseHeader('X-Runtime')) : 0;
  return setTimeout(function() {
    var bar, now, span, tech;
    now = new Date().getTime();
    bar = new PerformanceBar({
      timing: {
        requestStart: ajaxStart,
        responseEnd: ajaxEnd,
        domLoading: ajaxEnd,
        domInteractive: now
      },
      isLoaded: function() {
        return true;
      },
      start: function() {
        return ajaxStart;
      },
      end: function() {
        return now;
      }
    });
    bar.render(serverTime);
    if ($.fn.pjax != null) {
      tech = 'PJAX';
    } else {
      tech = 'Turbolinks';
    }
    span = $('<span>', {
      'data-toggle': 'tooltip',
      'data-title': tech + " navigation time",
      'data-container': 'body'
    }).text(PerformanceBar.formatTime(total));
    updateStatus(span);
    return ajaxStart = null;
  }, 0);
});

$(function() {
  if (window.performance) {
    return renderPerformanceBar();
  } else {
    return $('#peek-view-performance-bar').remove();
  }
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./abuse_reports.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MAX_MESSAGE_LENGTH = 500;
var MESSAGE_CELL_SELECTOR = '.abuse-reports .message';

var AbuseReports = function () {
  function AbuseReports() {
    _classCallCheck(this, AbuseReports);

    $(MESSAGE_CELL_SELECTOR).each(this.truncateLongMessage);
    $(document).off('click', MESSAGE_CELL_SELECTOR).on('click', MESSAGE_CELL_SELECTOR, this.toggleMessageTruncation);
  }

  _createClass(AbuseReports, [{
    key: 'truncateLongMessage',
    value: function truncateLongMessage() {
      var $messageCellElement = $(this);
      var reportMessage = $messageCellElement.text();
      if (reportMessage.length > MAX_MESSAGE_LENGTH) {
        $messageCellElement.data('original-message', reportMessage);
        $messageCellElement.data('message-truncated', 'true');
        $messageCellElement.text(window.gl.text.truncate(reportMessage, MAX_MESSAGE_LENGTH));
      }
    }
  }, {
    key: 'toggleMessageTruncation',
    value: function toggleMessageTruncation() {
      var $messageCellElement = $(this);
      var originalMessage = $messageCellElement.data('original-message');
      if (!originalMessage) return;
      if ($messageCellElement.data('message-truncated') === 'true') {
        $messageCellElement.data('message-truncated', 'false');
        $messageCellElement.text(originalMessage);
      } else {
        $messageCellElement.data('message-truncated', 'true');
        $messageCellElement.text(originalMessage.substr(0, MAX_MESSAGE_LENGTH - 3) + '...');
      }
    }
  }]);

  return AbuseReports;
}();

/* harmony default export */ __webpack_exports__["a"] = (AbuseReports);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./activities.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-param-reassign, class-methods-use-this */
/* global Pager */



var Activities = function () {
  function Activities() {
    var _this = this;

    _classCallCheck(this, Activities);

    Pager.init(20, true, false, function (data) {
      return data;
    }, this.updateTooltips);

    $('.event-filter-link').on('click', function (e) {
      e.preventDefault();
      _this.toggleFilter(e.currentTarget);
      _this.reloadActivities();
    });
  }

  _createClass(Activities, [{
    key: 'updateTooltips',
    value: function updateTooltips() {
      gl.utils.localTimeAgo($('.js-timeago', '.content_list'));
    }
  }, {
    key: 'reloadActivities',
    value: function reloadActivities() {
      $('.content_list').html('');
      Pager.init(20, true, false, function (data) {
        return data;
      }, this.updateTooltips);
    }
  }, {
    key: 'toggleFilter',
    value: function toggleFilter(sender) {
      var $sender = $(sender);
      var filter = $sender.attr('id').split('_')[0];

      $('.event-filter .active').removeClass('active');
      __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('event_filter', filter);

      $sender.closest('li').toggleClass('active');
    }
  }]);

  return Activities;
}();

window.gl = window.gl || {};
window.gl.Activities = Activities;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./admin.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife, one-var, no-var, one-var-declaration-per-line, no-unused-vars, no-else-return, prefer-arrow-callback, camelcase, quotes, comma-dangle, max-len */

window.Admin = function () {
  function Admin() {
    var modal, showBlacklistType;
    $('input#user_force_random_password').on('change', function (elem) {
      var elems;
      elems = $('#user_password, #user_password_confirmation');
      if ($(this).attr('checked')) {
        return elems.val('').attr('disabled', true);
      } else {
        return elems.removeAttr('disabled');
      }
    });
    $('body').on('click', '.js-toggle-colors-link', function (e) {
      e.preventDefault();
      return $('.js-toggle-colors-container').toggle();
    });
    $('.log-tabs a').click(function (e) {
      e.preventDefault();
      return $(this).tab('show');
    });
    $('.log-bottom').click(function (e) {
      var visible_log;
      e.preventDefault();
      visible_log = $(".file-content:visible");
      return visible_log.animate({
        scrollTop: visible_log.find('ol').height()
      }, "fast");
    });
    modal = $('.change-owner-holder');
    $('.change-owner-link').bind("click", function (e) {
      e.preventDefault();
      $(this).hide();
      return modal.show();
    });
    $('.change-owner-cancel-link').bind("click", function (e) {
      e.preventDefault();
      modal.hide();
      return $('.change-owner-link').show();
    });
    $('li.project_member').bind('ajax:success', function () {
      return gl.utils.refreshCurrentPage();
    });
    $('li.group_member').bind('ajax:success', function () {
      return gl.utils.refreshCurrentPage();
    });
    showBlacklistType = function showBlacklistType() {
      if ($("input[name='blacklist_type']:checked").val() === 'file') {
        $('.blacklist-file').show();
        return $('.blacklist-raw').hide();
      } else {
        $('.blacklist-file').hide();
        return $('.blacklist-raw').show();
      }
    };
    $("input[name='blacklist_type']").click(showBlacklistType);
    showBlacklistType();
  }

  return Admin;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./admin_email_select.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("./api.js");
/* eslint-disable no-var, wrap-iife, func-names, space-before-function-paren, camelcase, no-unused-vars, quotes, object-shorthand, one-var, one-var-declaration-per-line, prefer-arrow-callback, comma-dangle, prefer-template, no-else-return, yoda, prefer-rest-params, prefer-spread, max-len */


var slice = [].slice;

window.AdminEmailSelect = function () {
  function AdminEmailSelect() {
    $('.ajax-admin-email-select').each(function (_this) {
      return function (i, select) {
        var skip_ldap;
        skip_ldap = $(select).hasClass('skip_ldap');
        return $(select).select2({
          placeholder: "Select group or project",
          multiple: $(select).hasClass('multiselect'),
          minimumInputLength: 0,
          query: function query(_query) {
            var group_result, project_result;
            group_result = __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].groups(_query.term, {}, function (groups) {
              return groups;
            });
            project_result = __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].projects(_query.term, {
              order_by: 'id',
              membership: false
            }, function (projects) {
              return projects;
            });
            return $.when(project_result, group_result).done(function (projects, groups) {
              var all, data;
              all = {
                id: "all"
              };
              data = [all].concat(groups[0], projects[0]);
              return _query.callback({
                results: data
              });
            });
          },
          id: function id(object) {
            if (object.path_with_namespace) {
              return "project-" + object.id;
            } else if (object.path) {
              return "group-" + object.id;
            } else {
              return "all";
            }
          },
          formatResult: function formatResult() {
            var args;
            args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
            return _this.formatResult.apply(_this, args);
          },
          formatSelection: function formatSelection() {
            var args;
            args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
            return _this.formatSelection.apply(_this, args);
          },
          dropdownCssClass: "ajax-admin-email-dropdown",
          escapeMarkup: function escapeMarkup(m) {
            return m;
          }
        });
      };
    }(this));
  }

  AdminEmailSelect.prototype.formatResult = function (object) {
    if (object.path_with_namespace) {
      return "<div class='project-result'> <div class='project-name'>" + object.name + "</div> <div class='project-path'>" + object.path_with_namespace + "</div> </div>";
    } else if (object.path) {
      return "<div class='group-result'> <div class='group-name'>" + object.name + "</div> <div class='group-path'>" + object.path + "</div> </div>";
    } else {
      return "<div class='group-result'> <div class='group-name'>All</div> <div class='group-path'>All groups and projects</div> </div>";
    }
  };

  AdminEmailSelect.prototype.formatSelection = function (object) {
    if (object.path_with_namespace) {
      return "Project: " + object.name;
    } else if (object.path) {
      return "Group: " + object.name;
    } else {
      return "All groups and projects";
    }
  };

  return AdminEmailSelect;
}();
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./ajax_loading_spinner.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AjaxLoadingSpinner = function () {
  function AjaxLoadingSpinner() {
    _classCallCheck(this, AjaxLoadingSpinner);
  }

  _createClass(AjaxLoadingSpinner, null, [{
    key: 'init',
    value: function init() {
      var $elements = $('.js-ajax-loading-spinner');

      $elements.on('ajax:beforeSend', AjaxLoadingSpinner.ajaxBeforeSend);
      $elements.on('ajax:complete', AjaxLoadingSpinner.ajaxComplete);
    }
  }, {
    key: 'ajaxBeforeSend',
    value: function ajaxBeforeSend(e) {
      e.target.setAttribute('disabled', '');
      var iconElement = e.target.querySelector('i');
      // get first fa- icon
      var originalIcon = iconElement.className.match(/(fa-)([^\s]+)/g)[0];
      iconElement.dataset.icon = originalIcon;
      AjaxLoadingSpinner.toggleLoadingIcon(iconElement);
      $(e.target).off('ajax:beforeSend', AjaxLoadingSpinner.ajaxBeforeSend);
    }
  }, {
    key: 'ajaxComplete',
    value: function ajaxComplete(e) {
      e.target.removeAttribute('disabled');
      var iconElement = e.target.querySelector('i');
      AjaxLoadingSpinner.toggleLoadingIcon(iconElement);
      $(e.target).off('ajax:complete', AjaxLoadingSpinner.ajaxComplete);
    }
  }, {
    key: 'toggleLoadingIcon',
    value: function toggleLoadingIcon(iconElement) {
      var classList = iconElement.classList;
      classList.toggle(iconElement.dataset.icon);
      classList.toggle('fa-spinner');
      classList.toggle('fa-spin');
    }
  }]);

  return AjaxLoadingSpinner;
}();

/* harmony default export */ __webpack_exports__["a"] = (AjaxLoadingSpinner);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./api.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("../../../node_modules/jquery/dist/jquery.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);


var Api = {
  groupsPath: '/api/:version/groups.json',
  groupPath: '/api/:version/groups/:id.json',
  namespacesPath: '/api/:version/namespaces.json',
  groupProjectsPath: '/api/:version/groups/:id/projects.json',
  projectsPath: '/api/:version/projects.json',
  projectLabelsPath: '/:namespace_path/:project_path/labels',
  groupLabelsPath: '/groups/:namespace_path/labels',
  licensePath: '/api/:version/templates/licenses/:key',
  gitignorePath: '/api/:version/templates/gitignores/:key',
  gitlabCiYmlPath: '/api/:version/templates/gitlab_ci_ymls/:key',
  ldapGroupsPath: '/api/:version/ldap/:provider/groups.json',
  dockerfilePath: '/api/:version/templates/dockerfiles/:key',
  issuableTemplatePath: '/:namespace_path/:project_path/templates/:type/:key',
  usersPath: '/api/:version/users.json',
  commitPath: '/api/:version/projects/:id/repository/commits',

  group: function group(groupId, callback) {
    var url = Api.buildUrl(Api.groupPath).replace(':id', groupId);
    return __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      url: url,
      dataType: 'json'
    }).done(function (group) {
      return callback(group);
    });
  },


  // Return groups list. Filtered by query
  groups: function groups(query, options) {
    var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.noop;

    var url = Api.buildUrl(Api.groupsPath);
    return __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      url: url,
      data: Object.assign({
        search: query,
        per_page: 20
      }, options),
      dataType: 'json'
    }).done(function (groups) {
      return callback(groups);
    });
  },


  // Return namespaces list. Filtered by query
  namespaces: function namespaces(query, callback) {
    var url = Api.buildUrl(Api.namespacesPath);
    return __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      url: url,
      data: {
        search: query,
        per_page: 20
      },
      dataType: 'json'
    }).done(function (namespaces) {
      return callback(namespaces);
    });
  },


  // Return projects list. Filtered by query
  projects: function projects(query, options, callback) {
    var url = Api.buildUrl(Api.projectsPath);
    var defaults = {
      search: query,
      per_page: 20,
      simple: true
    };

    if (gon.current_user_id) {
      defaults.membership = true;
    }

    return __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      url: url,
      data: Object.assign(defaults, options),
      dataType: 'json'
    }).done(function (projects) {
      return callback(projects);
    });
  },
  newLabel: function newLabel(namespacePath, projectPath, data, callback) {
    var url = void 0;

    if (projectPath) {
      url = Api.buildUrl(Api.projectLabelsPath).replace(':namespace_path', namespacePath).replace(':project_path', projectPath);
    } else {
      url = Api.buildUrl(Api.groupLabelsPath).replace(':namespace_path', namespacePath);
    }

    return __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      url: url,
      type: 'POST',
      data: { label: data },
      dataType: 'json'
    }).done(function (label) {
      return callback(label);
    }).fail(function (message) {
      return callback(message.responseJSON);
    });
  },


  // Return group projects list. Filtered by query
  groupProjects: function groupProjects(groupId, query, callback) {
    var url = Api.buildUrl(Api.groupProjectsPath).replace(':id', groupId);
    return __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      url: url,
      data: {
        search: query,
        per_page: 20
      },
      dataType: 'json'
    }).done(function (projects) {
      return callback(projects);
    });
  },
  commitMultiple: function commitMultiple(id, data) {
    // see https://docs.gitlab.com/ce/api/commits.html#create-a-commit-with-multiple-files-and-actions
    var url = Api.buildUrl(Api.commitPath).replace(':id', id);
    return this.wrapAjaxCall({
      url: url,
      type: 'POST',
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify(data),
      dataType: 'json'
    });
  },


  // Return text for a specific license
  licenseText: function licenseText(key, data, callback) {
    var url = Api.buildUrl(Api.licensePath).replace(':key', key);
    return __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      url: url,
      data: data
    }).done(function (license) {
      return callback(license);
    });
  },
  gitignoreText: function gitignoreText(key, callback) {
    var url = Api.buildUrl(Api.gitignorePath).replace(':key', key);
    return __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.get(url, function (gitignore) {
      return callback(gitignore);
    });
  },
  gitlabCiYml: function gitlabCiYml(key, callback) {
    var url = Api.buildUrl(Api.gitlabCiYmlPath).replace(':key', key);
    return __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.get(url, function (file) {
      return callback(file);
    });
  },
  dockerfileYml: function dockerfileYml(key, callback) {
    var url = Api.buildUrl(Api.dockerfilePath).replace(':key', key);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.get(url, callback);
  },
  issueTemplate: function issueTemplate(namespacePath, projectPath, key, type, callback) {
    var url = Api.buildUrl(Api.issuableTemplatePath).replace(':key', key).replace(':type', type).replace(':project_path', projectPath).replace(':namespace_path', namespacePath);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      url: url,
      dataType: 'json'
    }).done(function (file) {
      return callback(null, file);
    }).fail(callback);
  },
  users: function users(query, options) {
    var url = Api.buildUrl(this.usersPath);
    return Api.wrapAjaxCall({
      url: url,
      data: Object.assign({
        search: query,
        per_page: 20
      }, options),
      dataType: 'json'
    });
  },
  approverUsers: function approverUsers(search, options) {
    var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.noop;

    var url = Api.buildUrl('/autocomplete/users.json');
    return __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      url: url,
      data: __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({
        search: search,
        per_page: 20
      }, options),
      dataType: 'json'
    }).done(callback);
  },
  ldap_groups: function ldap_groups(query, provider, callback) {
    var url = Api.buildUrl(this.ldapGroupsPath).replace(':provider', provider);
    return Api.wrapAjaxCall({
      url: url,
      data: Object.assign({
        search: query,
        per_page: 20,
        active: true
      }),
      dataType: 'json'
    }).then(function (groups) {
      return callback(groups);
    });
  },
  buildUrl: function buildUrl(url) {
    var urlRoot = '';
    if (gon.relative_url_root != null) {
      urlRoot = gon.relative_url_root;
    }
    return urlRoot + url.replace(':version', gon.api_version);
  },
  wrapAjaxCall: function wrapAjaxCall(options) {
    return new Promise(function (resolve, reject) {
      // jQuery 2 is not Promises/A+ compatible (missing catch)
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax(options) // eslint-disable-line promise/catch-or-return
      .then(function (data) {
        return resolve(data);
      }, function (jqXHR, textStatus, errorThrown) {
        var error = new Error(options.url + ': ' + errorThrown);
        error.textStatus = textStatus;
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Api);

/***/ }),

/***/ "./application_settings.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {
function ApplicationSettings() {
  var usageDataUrl = $('.usage-data').data('endpoint');

  $.ajax({
    type: 'GET',
    url: usageDataUrl,
    dataType: 'html',
    success: function success(html) {
      $('.usage-data').html(html);
    }
  });
}

window.gl = window.gl || {};
window.gl.ApplicationSettings = ApplicationSettings;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./approvals.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, prefer-arrow-callback, space-before-function-paren, quotes, no-var, comma-spacing, keyword-spacing, one-var, one-var-declaration-per-line, no-unused-vars, camelcase, prefer-template, max-len */

$(function () {
  $(".approver-list").on("click", ".unsaved-approvers.approver .btn-remove", function (ev) {
    var removeElement = $(this).closest("li");
    var approverId = parseInt(removeElement.attr("id").replace("user_", ""), 10);
    var approverIds = $("input#merge_request_approver_ids");
    var skipUsers = approverIds.data("skip-users") || [];
    var approverIndex = skipUsers.indexOf(approverId);

    removeElement.remove();

    if (approverIndex > -1) {
      approverIds.data("skip-users", skipUsers.splice(approverIndex, 1));
    }

    ev.preventDefault();
  });

  $(".approver-list").on("click", ".unsaved-approvers.approver-group .btn-remove", function (ev) {
    var removeElement = $(this).closest("li");
    var approverGroupId = parseInt(removeElement.attr("id").replace("group_", ""), 10);
    var approverGroupIds = $("input#merge_request_approver_group_ids");
    var skipGroups = approverGroupIds.data("skip-groups") || [];
    var approverGroupIndex = skipGroups.indexOf(approverGroupId);

    removeElement.remove();

    if (approverGroupIndex > -1) {
      approverGroupIds.data("skip-groups", skipGroups.splice(approverGroupIndex, 1));
    }

    ev.preventDefault();
  });

  $("form.merge-request-form").submit(function () {
    var approverIds, approversInput, approverGroupIds, approverGroupsInput;

    if ($("input#merge_request_approver_ids").length) {
      approverIds = $.map($("li.unsaved-approvers.approver").not(".approver-template"), function (li, i) {
        return li.id.replace("user_", "");
      });
      approversInput = $(this).find("input#merge_request_approver_ids");
      approverIds = approverIds.concat(approversInput.val().split(","));
      approversInput.val(_.compact(approverIds).join(","));
    }

    if ($("input#merge_request_approver_group_ids").length) {
      approverGroupIds = $.map($("li.unsaved-approvers.approver-group"), function (li, i) {
        return li.id.replace("group_", "");
      });
      approverGroupsInput = $(this).find("input#merge_request_approver_group_ids");
      approverGroupIds = approverGroupIds.concat(approverGroupsInput.val().split(","));
      approverGroupsInput.val(_.compact(approverGroupIds).join(","));
    }
  });

  return $(".suggested-approvers a").click(function () {
    var approver_item_html, user_id, user_name;
    user_id = this.id.replace("user_", "");
    user_name = this.text;
    if ($(".approver-list #user_" + user_id).length) {
      return false;
    }
    approver_item_html = $(".unsaved-approvers.approver-template").clone().removeClass("hide approver-template")[0].outerHTML.replace(/\{approver_name\}/g, user_name).replace(/\{user_id\}/g, user_id);
    $(".no-approvers").remove();
    $(".approver-list").append(approver_item_html);
    return false;
  });
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./approvers_select.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("./api.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var ApproversSelect = function () {
  function ApproversSelect() {
    _classCallCheck(this, ApproversSelect);

    this.$approverSelect = $('.js-select-user-and-group');
    var name = this.$approverSelect.data('name');
    this.fieldNames = [name + '[approver_ids]', name + '[approver_group_ids]'];
    this.$loadWrapper = $('.load-wrapper');

    this.bindEvents();
    this.addEvents();
    this.initSelect2();
  }

  _createClass(ApproversSelect, [{
    key: 'bindEvents',
    value: function bindEvents() {
      this.handleSelectChange = this.handleSelectChange.bind(this);
      this.fetchGroups = this.fetchGroups.bind(this);
      this.fetchUsers = this.fetchUsers.bind(this);
    }
  }, {
    key: 'addEvents',
    value: function addEvents() {
      var _this = this;

      $(document).on('click', '.js-add-approvers', function () {
        return _this.addApprover();
      });
      $(document).on('click', '.js-approver-remove', function (e) {
        return ApproversSelect.removeApprover(e);
      });
    }
  }, {
    key: 'fetchGroups',
    value: function fetchGroups(term) {
      var options = {
        skip_groups: ApproversSelect.getApprovers(this.fieldNames[1], '.js-approver-group')
      };
      return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].groups(term, options);
    }
  }, {
    key: 'fetchUsers',
    value: function fetchUsers(term) {
      var options = {
        skip_users: ApproversSelect.getApprovers(this.fieldNames[0], '.js-approver'),
        project_id: $('#project_id').val()
      };
      return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].approverUsers(term, options);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(e) {
      var added = e.added,
          removed = e.removed;

      var userInput = $('[name="' + this.fieldNames[0] + '"]');
      var groupInput = $('[name="' + this.fieldNames[1] + '"]');

      if (added) {
        if (added.full_name) {
          groupInput.val((groupInput.val() + ',' + added.id).replace(/^,/, ''));
        } else {
          userInput.val((userInput.val() + ',' + added.id).replace(/^,/, ''));
        }
      }

      if (removed) {
        if (removed.full_name) {
          groupInput.val(groupInput.val().replace(new RegExp(',?' + removed.id), ''));
        } else {
          userInput.val(userInput.val().replace(new RegExp(',?' + removed.id), ''));
        }
      }
    }
  }, {
    key: 'initSelect2',
    value: function initSelect2() {
      var _this2 = this;

      this.$approverSelect.select2({
        placeholder: 'Search for users or groups',
        multiple: true,
        minimumInputLength: 0,
        query: function query(_query) {
          var fetchGroups = _this2.fetchGroups(_query.term);
          var fetchUsers = _this2.fetchUsers(_query.term);
          return $.when(fetchGroups, fetchUsers).then(function (groups, users) {
            var data = {
              results: groups[0].concat(users[0])
            };
            return _query.callback(data);
          });
        },
        formatResult: ApproversSelect.formatResult,
        formatSelection: ApproversSelect.formatSelection,
        dropdownCss: function dropdownCss() {
          var $input = $('.js-select-user-and-group .select2-input');
          var offset = $input.offset();
          var inputRightPosition = offset.left + $input.outerWidth();
          var $dropdown = $('.select2-drop-active');

          var left = offset.left;
          if ($dropdown.outerWidth() > $input.outerWidth()) {
            left = inputRightPosition - $dropdown.width() + 'px';
          }
          return {
            left: left,
            right: 'auto',
            width: 'auto'
          };
        }
      }).on('change', this.handleSelectChange);
    }
  }, {
    key: 'addApprover',
    value: function addApprover() {
      this.fieldNames.forEach(ApproversSelect.saveApprovers);
    }
  }], [{
    key: 'getApprovers',
    value: function getApprovers(fieldName, approverList) {
      var input = $('[name="' + fieldName + '"]');
      var existingApprovers = $(approverList).map(function (i, el) {
        return parseInt($(el).data('id'), 10);
      });
      var selectedApprovers = input.val().split(',').filter(function (val) {
        return val !== '';
      });
      return [].concat(_toConsumableArray(existingApprovers), _toConsumableArray(selectedApprovers));
    }
  }, {
    key: 'formatSelection',
    value: function formatSelection(group) {
      return group.full_name || group.name;
    }
  }, {
    key: 'formatResult',
    value: function formatResult(_ref) {
      var name = _ref.name,
          username = _ref.username,
          avatarUrl = _ref.avatar_url,
          fullName = _ref.full_name,
          fullPath = _ref.full_path;

      if (username) {
        var avatar = avatarUrl || gon.default_avatar_url;
        return '\n        <div class="user-result">\n          <div class="user-image">\n            <img class="avatar s40" src="' + avatar + '">\n          </div>\n          <div class="user-info">\n            <div class="user-name">' + name + '</div>\n            <div class="user-username">@' + username + '</div>\n          </div>\n        </div>\n      ';
      }

      return '\n      <div class="group-result">\n        <div class="group-name">' + fullName + '</div>\n        <div class="group-path">' + fullPath + '</div>\n      </div>\n    ';
    }
  }, {
    key: 'saveApprovers',
    value: function saveApprovers(fieldName) {
      var $input = window.$('[name="' + fieldName + '"]');
      var newValue = $input.val();
      var $loadWrapper = $('.load-wrapper');
      var $approverSelect = $('.js-select-user-and-group');

      if (!newValue) {
        return;
      }

      var $form = $('.js-add-approvers').closest('form');
      $loadWrapper.removeClass('hidden');
      window.$.ajax({
        url: $form.attr('action'),
        type: 'POST',
        data: _defineProperty({
          _method: 'PATCH'
        }, fieldName, newValue),
        success: ApproversSelect.updateApproverList,
        complete: function complete() {
          $input.val('');
          $approverSelect.select2('val', '');
          $loadWrapper.addClass('hidden');
        },
        error: function error() {
          window.Flash('Failed to add Approver', 'alert');
        }
      });
    }
  }, {
    key: 'removeApprover',
    value: function removeApprover(e) {
      e.preventDefault();
      var target = e.currentTarget;
      var $loadWrapper = $('.load-wrapper');
      $loadWrapper.removeClass('hidden');
      $.ajax({
        url: target.getAttribute('href'),
        type: 'POST',
        data: {
          _method: 'DELETE'
        },
        success: ApproversSelect.updateApproverList,
        complete: function complete() {
          return $loadWrapper.addClass('hidden');
        },
        error: function error() {
          window.Flash('Failed to remove Approver', 'alert');
        }
      });
    }
  }, {
    key: 'updateApproverList',
    value: function updateApproverList(html) {
      $('.js-current-approvers').html($(html).find('.js-current-approvers').html());
    }
  }]);

  return ApproversSelect;
}();

/* harmony default export */ __webpack_exports__["a"] = (ApproversSelect);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./aside.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife, quotes, prefer-arrow-callback, no-var, one-var, one-var-declaration-per-line, no-else-return, max-len */

window.Aside = function () {
  function Aside() {
    $(document).off("click", "a.show-aside");
    $(document).on("click", 'a.show-aside', function (e) {
      var btn, icon;
      e.preventDefault();
      btn = $(e.currentTarget);
      icon = btn.find('i');
      if (icon.hasClass('fa-angle-left')) {
        btn.parent().find('section').hide();
        btn.parent().find('aside').fadeIn();
        return icon.removeClass('fa-angle-left').addClass('fa-angle-right');
      } else {
        btn.parent().find('aside').hide();
        btn.parent().find('section').fadeIn();
        return icon.removeClass('fa-angle-right').addClass('fa-angle-left');
      }
    });
  }

  return Aside;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./audit_logs.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__users_select__ = __webpack_require__("./users_select.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__groups_select__ = __webpack_require__("./groups_select.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__project_select__ = __webpack_require__("./project_select.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this, no-unneeded-ternary, quote-props, no-new */
/* global GroupsSelect */
/* global ProjectSelect */





var AuditLogs = function () {
  function AuditLogs() {
    _classCallCheck(this, AuditLogs);

    this.initFilters();
  }

  _createClass(AuditLogs, [{
    key: 'initFilters',
    value: function initFilters() {
      new ProjectSelect();
      new GroupsSelect();
      new __WEBPACK_IMPORTED_MODULE_0__users_select__["a" /* default */]();

      this.initFilterDropdown($('.js-type-filter'), 'event_type', null, function () {
        $('.hidden-filter-value').val('');
        $('form.filter-form').submit();
      });

      $('.project-item-select').on('click', function () {
        $('form.filter-form').submit();
      });
    }
  }, {
    key: 'initFilterDropdown',
    value: function initFilterDropdown($dropdown, fieldName, searchFields, cb) {
      var dropdownOptions = {
        fieldName: fieldName,
        selectable: true,
        filterable: searchFields ? true : false,
        search: { fields: searchFields },
        data: $dropdown.data('data'),
        clicked: function clicked() {
          return $dropdown.closest('form.filter-form').submit();
        }
      };
      if (cb) {
        dropdownOptions.clicked = cb;
      }
      $dropdown.glDropdown(dropdownOptions);
    }
  }]);

  return AuditLogs;
}();

/* harmony default export */ __webpack_exports__["a"] = (AuditLogs);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./autosave.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_accessor__ = __webpack_require__("./lib/utils/accessor.js");
/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-param-reassign, quotes, prefer-template, no-var, one-var, no-unused-vars, one-var-declaration-per-line, no-void, consistent-return, no-empty, max-len */


window.Autosave = function () {
  function Autosave(field, key, resource) {
    this.field = field;
    this.isLocalStorageAvailable = __WEBPACK_IMPORTED_MODULE_0__lib_utils_accessor__["a" /* default */].isLocalStorageAccessSafe();
    this.resource = resource;
    if (key.join != null) {
      key = key.join('/');
    }
    this.key = 'autosave/' + key;
    this.field.data('autosave', this);
    this.restore();
    this.field.on('input', function (_this) {
      return function () {
        return _this.save();
      };
    }(this));
  }

  Autosave.prototype.restore = function () {
    var text;

    if (!this.isLocalStorageAvailable) return;

    text = window.localStorage.getItem(this.key);

    if ((text != null ? text.length : void 0) > 0) {
      this.field.val(text);
    }
    if (!this.resource && this.resource !== 'issue') {
      this.field.trigger('input');
    } else {
      // v-model does not update with jQuery trigger
      // https://github.com/vuejs/vue/issues/2804#issuecomment-216968137
      var event = new Event('change', { bubbles: true, cancelable: false });
      var field = this.field.get(0);
      if (field) {
        field.dispatchEvent(event);
      }
    }
  };

  Autosave.prototype.save = function () {
    var text;
    text = this.field.val();

    if (this.isLocalStorageAvailable && (text != null ? text.length : void 0) > 0) {
      return window.localStorage.setItem(this.key, text);
    }

    return this.reset();
  };

  Autosave.prototype.reset = function () {
    if (!this.isLocalStorageAvailable) return;

    return window.localStorage.removeItem(this.key);
  };

  return Autosave;
}();

/* unused harmony default export */ var _unused_webpack_default_export = (window.Autosave);

/***/ }),

/***/ "./awards_handler.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (immutable) */ __webpack_exports__["a"] = loadAwardsHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils_common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this */
/* global Flash */




var animationEndEventString = 'animationend webkitAnimationEnd MSAnimationEnd oAnimationEnd';
var transitionEndEventString = 'transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd';
var requestAnimationFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.setTimeout;

var FROM_SENTENCE_REGEX = /(?:, and | and |, )/; // For separating lists produced by ruby's Array#toSentence

var categoryLabelMap = {
  activity: 'Activity',
  people: 'People',
  nature: 'Nature',
  food: 'Food',
  travel: 'Travel',
  objects: 'Objects',
  symbols: 'Symbols',
  flags: 'Flags'
};

var IS_VISIBLE = 'is-visible';
var IS_RENDERED = 'is-rendered';

var AwardsHandler = function () {
  function AwardsHandler(emoji) {
    var _this = this;

    _classCallCheck(this, AwardsHandler);

    this.emoji = emoji;
    this.eventListeners = [];
    // If the user shows intent let's pre-build the menu
    this.registerEventListener('one', $(document), 'mouseenter focus', '.js-add-award', 'mouseenter focus', function () {
      var $menu = $('.emoji-menu');
      if ($menu.length === 0) {
        requestAnimationFrame(function () {
          _this.createEmojiMenu();
        });
      }
    });
    this.registerEventListener('on', $(document), 'click', '.js-add-award', function (e) {
      e.stopPropagation();
      e.preventDefault();
      _this.showEmojiMenu($(e.currentTarget));
    });

    this.registerEventListener('on', $('html'), 'click', function (e) {
      var $target = $(e.target);
      if (!$target.closest('.emoji-menu-content').length) {
        $('.js-awards-block.current').removeClass('current');
      }
      if (!$target.closest('.emoji-menu').length) {
        if ($('.emoji-menu').is(':visible')) {
          $('.js-add-award.is-active').removeClass('is-active');
          _this.hideMenuElement($('.emoji-menu'));
        }
      }
    });
    this.registerEventListener('on', $(document), 'click', '.js-emoji-btn', function (e) {
      e.preventDefault();
      var $target = $(e.currentTarget);
      var $glEmojiElement = $target.find('gl-emoji');
      var $spriteIconElement = $target.find('.icon');
      var emojiName = ($glEmojiElement.length ? $glEmojiElement : $spriteIconElement).data('name');

      $target.closest('.js-awards-block').addClass('current');
      _this.addAward(_this.getVotesBlock(), _this.getAwardUrl(), emojiName);
    });
  }

  _createClass(AwardsHandler, [{
    key: 'registerEventListener',
    value: function registerEventListener() {
      for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      var _element$method;

      var method = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'on';
      var element = arguments[1];

      (_element$method = element[method]).call.apply(_element$method, [element].concat(args));
      this.eventListeners.push({
        element: element,
        args: args
      });
    }
  }, {
    key: 'showEmojiMenu',
    value: function showEmojiMenu($addBtn) {
      var _this2 = this;

      if ($addBtn.hasClass('js-note-emoji')) {
        $addBtn.closest('.note').find('.js-awards-block').addClass('current');
      } else {
        $addBtn.closest('.js-awards-block').addClass('current');
      }

      var $menu = $('.emoji-menu');
      var $thumbsBtn = $menu.find('[data-name="thumbsup"], [data-name="thumbsdown"]').parent();
      var $userAuthored = this.isUserAuthored($addBtn);
      if ($menu.length) {
        if ($menu.is('.is-visible')) {
          $addBtn.removeClass('is-active');
          this.hideMenuElement($menu);
          $('.js-emoji-menu-search').blur();
        } else {
          $addBtn.addClass('is-active');
          this.positionMenu($menu, $addBtn);
          this.showMenuElement($menu);
          $('.js-emoji-menu-search').focus();
        }
      } else {
        $addBtn.addClass('is-loading is-active');
        this.createEmojiMenu(function () {
          var $createdMenu = $('.emoji-menu');
          $addBtn.removeClass('is-loading');
          _this2.positionMenu($createdMenu, $addBtn);
          return setTimeout(function () {
            _this2.showMenuElement($createdMenu);
            $('.js-emoji-menu-search').focus();
          }, 200);
        });
      }

      $thumbsBtn.toggleClass('disabled', $userAuthored);
      $thumbsBtn.prop('disabled', $userAuthored);
    }

    // Create the emoji menu with the first category of emojis.
    // Then render the remaining categories of emojis one by one to avoid jank.

  }, {
    key: 'createEmojiMenu',
    value: function createEmojiMenu(callback) {
      if (this.isCreatingEmojiMenu) {
        return;
      }
      this.isCreatingEmojiMenu = true;

      // Render the first category
      var categoryMap = this.emoji.getEmojiCategoryMap();
      var categoryNameKey = Object.keys(categoryMap)[0];
      var emojisInCategory = categoryMap[categoryNameKey];
      var firstCategory = this.renderCategory(categoryLabelMap[categoryNameKey], emojisInCategory);

      // Render the frequently used
      var frequentlyUsedEmojis = this.getFrequentlyUsedEmojis();
      var frequentlyUsedCatgegory = '';
      if (frequentlyUsedEmojis.length > 0) {
        frequentlyUsedCatgegory = this.renderCategory('Frequently used', frequentlyUsedEmojis, {
          menuListClass: 'frequent-emojis'
        });
      }

      var emojiMenuMarkup = '\n      <div class="emoji-menu">\n        <input type="text" name="emoji-menu-search" value="" class="js-emoji-menu-search emoji-search search-input form-control" placeholder="Search emoji" />\n\n        <div class="emoji-menu-content">\n          ' + frequentlyUsedCatgegory + '\n          ' + firstCategory + '\n        </div>\n      </div>\n    ';

      document.body.insertAdjacentHTML('beforeend', emojiMenuMarkup);

      this.addRemainingEmojiMenuCategories();
      this.setupSearch();
      if (callback) {
        callback();
      }
    }
  }, {
    key: 'addRemainingEmojiMenuCategories',
    value: function addRemainingEmojiMenuCategories() {
      var _this3 = this;

      if (this.isAddingRemainingEmojiMenuCategories) {
        return;
      }
      this.isAddingRemainingEmojiMenuCategories = true;

      var categoryMap = this.emoji.getEmojiCategoryMap();

      // Avoid the jank and render the remaining categories separately
      // This will take more time, but makes UI more responsive
      var menu = document.querySelector('.emoji-menu');
      var emojiContentElement = menu.querySelector('.emoji-menu-content');
      var remainingCategories = Object.keys(categoryMap).slice(1);
      var allCategoriesAddedPromise = remainingCategories.reduce(function (promiseChain, categoryNameKey) {
        return promiseChain.then(function () {
          return new Promise(function (resolve) {
            var emojisInCategory = categoryMap[categoryNameKey];
            var categoryMarkup = _this3.renderCategory(categoryLabelMap[categoryNameKey], emojisInCategory);
            requestAnimationFrame(function () {
              emojiContentElement.insertAdjacentHTML('beforeend', categoryMarkup);
              resolve();
            });
          });
        });
      }, Promise.resolve());

      allCategoriesAddedPromise.then(function () {
        // Used for tests
        // We check for the menu in case it was destroyed in the meantime
        if (menu) {
          menu.dispatchEvent(new CustomEvent('build-emoji-menu-finish'));
        }
      }).catch(function (err) {
        emojiContentElement.insertAdjacentHTML('beforeend', '<p>We encountered an error while adding the remaining categories</p>');
        throw new Error('Error occurred in addRemainingEmojiMenuCategories: ' + err.message);
      });
    }
  }, {
    key: 'renderCategory',
    value: function renderCategory(name, emojiList) {
      var _this4 = this;

      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return '\n      <h5 class="emoji-menu-title">\n        ' + name + '\n      </h5>\n      <ul class="clearfix emoji-menu-list ' + (opts.menuListClass || '') + '">\n        ' + emojiList.map(function (emojiName) {
        return '\n          <li class="emoji-menu-list-item">\n            <button class="emoji-menu-btn text-center js-emoji-btn" type="button">\n              ' + _this4.emoji.glEmojiTag(emojiName, {
          sprite: true
        }) + '\n            </button>\n          </li>\n        ';
      }).join('\n') + '\n      </ul>\n    ';
    }
  }, {
    key: 'positionMenu',
    value: function positionMenu($menu, $addBtn) {
      var position = $addBtn.data('position');
      // The menu could potentially be off-screen or in a hidden overflow element
      // So we position the element absolute in the body
      var css = {
        top: $addBtn.offset().top + $addBtn.outerHeight() + 'px'
      };
      if (position === 'right') {
        css.left = $addBtn.offset().left - $menu.outerWidth() + 20 + 'px';
        $menu.addClass('is-aligned-right');
      } else {
        css.left = $addBtn.offset().left + 'px';
        $menu.removeClass('is-aligned-right');
      }
      return $menu.css(css);
    }
  }, {
    key: 'addAward',
    value: function addAward(votesBlock, awardUrl, emoji, checkMutuality, callback) {
      var _this5 = this;

      var isMainAwardsBlock = votesBlock.closest('.js-issue-note-awards').length;

      if (Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_common_utils__["m" /* isInIssuePage */])() && !isMainAwardsBlock) {
        var id = votesBlock.attr('id').replace('note_', '');

        this.hideMenuElement($('.emoji-menu'));

        $('.js-add-award.is-active').removeClass('is-active');
        var toggleAwardEvent = new CustomEvent('toggleAward', {
          detail: {
            awardName: emoji,
            noteId: id
          }
        });

        document.querySelector('.js-vue-notes-event').dispatchEvent(toggleAwardEvent);
      }

      var normalizedEmoji = this.emoji.normalizeEmojiName(emoji);
      var $emojiButton = this.findEmojiIcon(votesBlock, normalizedEmoji).parent();

      this.postEmoji($emojiButton, awardUrl, normalizedEmoji, function () {
        _this5.addAwardToEmojiBar(votesBlock, normalizedEmoji, checkMutuality);
        return typeof callback === 'function' ? callback() : undefined;
      });

      this.hideMenuElement($('.emoji-menu'));

      return $('.js-add-award.is-active').removeClass('is-active');
    }
  }, {
    key: 'addAwardToEmojiBar',
    value: function addAwardToEmojiBar(votesBlock, emoji, checkForMutuality) {
      if (checkForMutuality || checkForMutuality === null) {
        this.checkMutuality(votesBlock, emoji);
      }
      this.addEmojiToFrequentlyUsedList(emoji);
      var normalizedEmoji = this.emoji.normalizeEmojiName(emoji);
      var $emojiButton = this.findEmojiIcon(votesBlock, normalizedEmoji).parent();
      if ($emojiButton.length > 0) {
        if (this.isActive($emojiButton)) {
          this.decrementCounter($emojiButton, normalizedEmoji);
        } else {
          var counter = $emojiButton.find('.js-counter');
          counter.text(parseInt(counter.text(), 10) + 1);
          $emojiButton.addClass('active');
          this.addYouToUserList(votesBlock, normalizedEmoji);
          this.animateEmoji($emojiButton);
        }
      } else {
        votesBlock.removeClass('hidden');
        this.createEmoji(votesBlock, normalizedEmoji);
      }
    }
  }, {
    key: 'getVotesBlock',
    value: function getVotesBlock() {
      if (Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_common_utils__["m" /* isInIssuePage */])()) {
        var $el = $('.js-add-award.is-active').closest('.note.timeline-entry');

        if ($el.length) {
          return $el;
        }
      }

      var currentBlock = $('.js-awards-block.current');
      var resultantVotesBlock = currentBlock;
      if (currentBlock.length === 0) {
        resultantVotesBlock = $('.js-awards-block').eq(0);
      }

      return resultantVotesBlock;
    }
  }, {
    key: 'getAwardUrl',
    value: function getAwardUrl() {
      return this.getVotesBlock().data('award-url');
    }
  }, {
    key: 'checkMutuality',
    value: function checkMutuality(votesBlock, emoji) {
      var awardUrl = this.getAwardUrl();
      if (emoji === 'thumbsup' || emoji === 'thumbsdown') {
        var mutualVote = emoji === 'thumbsup' ? 'thumbsdown' : 'thumbsup';
        var $emojiButton = votesBlock.find('[data-name="' + mutualVote + '"]').parent();
        var isAlreadyVoted = $emojiButton.hasClass('active');
        if (isAlreadyVoted) {
          this.addAward(votesBlock, awardUrl, mutualVote, false);
        }
      }
    }
  }, {
    key: 'isActive',
    value: function isActive($emojiButton) {
      return $emojiButton.hasClass('active');
    }
  }, {
    key: 'isUserAuthored',
    value: function isUserAuthored($button) {
      return $button.hasClass('js-user-authored');
    }
  }, {
    key: 'decrementCounter',
    value: function decrementCounter($emojiButton, emoji) {
      var counter = $('.js-counter', $emojiButton);
      var counterNumber = parseInt(counter.text(), 10);
      if (counterNumber > 1) {
        counter.text(counterNumber - 1);
        this.removeYouFromUserList($emojiButton);
      } else if (emoji === 'thumbsup' || emoji === 'thumbsdown') {
        $emojiButton.tooltip('destroy');
        counter.text('0');
        this.removeYouFromUserList($emojiButton);
        if ($emojiButton.parents('.note').length) {
          this.removeEmoji($emojiButton);
        }
      } else {
        this.removeEmoji($emojiButton);
      }
      return $emojiButton.removeClass('active');
    }
  }, {
    key: 'removeEmoji',
    value: function removeEmoji($emojiButton) {
      $emojiButton.tooltip('destroy');
      $emojiButton.remove();
      var $votesBlock = this.getVotesBlock();
      if ($votesBlock.find('.js-emoji-btn').length === 0) {
        $votesBlock.addClass('hidden');
      }
    }
  }, {
    key: 'getAwardTooltip',
    value: function getAwardTooltip($awardBlock) {
      return $awardBlock.attr('data-original-title') || $awardBlock.attr('data-title') || '';
    }
  }, {
    key: 'toSentence',
    value: function toSentence(list) {
      var sentence = void 0;
      if (list.length <= 2) {
        sentence = list.join(' and ');
      } else {
        sentence = list.slice(0, -1).join(', ') + ', and ' + list[list.length - 1];
      }

      return sentence;
    }
  }, {
    key: 'removeYouFromUserList',
    value: function removeYouFromUserList($emojiButton) {
      var awardBlock = $emojiButton;
      var originalTitle = this.getAwardTooltip(awardBlock);
      var authors = originalTitle.split(FROM_SENTENCE_REGEX);
      authors.splice(authors.indexOf('You'), 1);
      return awardBlock.closest('.js-emoji-btn').removeData('title').removeAttr('data-title').removeAttr('data-original-title').attr('title', this.toSentence(authors)).tooltip('fixTitle');
    }
  }, {
    key: 'addYouToUserList',
    value: function addYouToUserList(votesBlock, emoji) {
      var awardBlock = this.findEmojiIcon(votesBlock, emoji).parent();
      var origTitle = this.getAwardTooltip(awardBlock);
      var users = [];
      if (origTitle) {
        users = origTitle.trim().split(FROM_SENTENCE_REGEX);
      }
      users.unshift('You');
      return awardBlock.attr('title', this.toSentence(users)).tooltip('fixTitle');
    }
  }, {
    key: 'createAwardButtonForVotesBlock',
    value: function createAwardButtonForVotesBlock(votesBlock, emojiName) {
      var buttonHtml = '\n      <button class="btn award-control js-emoji-btn has-tooltip active" title="You" data-placement="bottom">\n        ' + this.emoji.glEmojiTag(emojiName) + '\n        <span class="award-control-text js-counter">1</span>\n      </button>\n    ';
      var $emojiButton = $(buttonHtml);
      $emojiButton.insertBefore(votesBlock.find('.js-award-holder')).find('.emoji-icon').data('name', emojiName);
      this.animateEmoji($emojiButton);
      $('.award-control').tooltip();
      votesBlock.removeClass('current');
    }
  }, {
    key: 'animateEmoji',
    value: function animateEmoji($emoji) {
      var className = 'pulse animated once short';
      $emoji.addClass(className);

      this.registerEventListener('on', $emoji, animationEndEventString, function (e) {
        $(e.currentTarget).removeClass(className);
      });
    }
  }, {
    key: 'createEmoji',
    value: function createEmoji(votesBlock, emoji) {
      var _this6 = this;

      if ($('.emoji-menu').length) {
        this.createAwardButtonForVotesBlock(votesBlock, emoji);
      }
      this.createEmojiMenu(function () {
        _this6.createAwardButtonForVotesBlock(votesBlock, emoji);
      });
    }
  }, {
    key: 'postEmoji',
    value: function postEmoji($emojiButton, awardUrl, emoji, callback) {
      if (this.isUserAuthored($emojiButton)) {
        this.userAuthored($emojiButton);
      } else {
        $.post(awardUrl, {
          name: emoji
        }, function (data) {
          if (data.ok) {
            callback();
          }
        }).fail(function () {
          return new Flash('Something went wrong on our end.');
        });
      }
    }
  }, {
    key: 'findEmojiIcon',
    value: function findEmojiIcon(votesBlock, emoji) {
      return votesBlock.find('.js-emoji-btn [data-name="' + emoji + '"]');
    }
  }, {
    key: 'userAuthored',
    value: function userAuthored($emojiButton) {
      var oldTitle = this.getAwardTooltip($emojiButton);
      var newTitle = 'You cannot vote on your own issue, MR and note';
      Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_common_utils__["B" /* updateTooltipTitle */])($emojiButton, newTitle).tooltip('show');
      // Restore tooltip back to award list
      return setTimeout(function () {
        $emojiButton.tooltip('hide');
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_common_utils__["B" /* updateTooltipTitle */])($emojiButton, oldTitle);
      }, 2800);
    }
  }, {
    key: 'scrollToAwards',
    value: function scrollToAwards() {
      var options = {
        scrollTop: $('.awards').offset().top - 110
      };
      return $('body, html').animate(options, 200);
    }
  }, {
    key: 'addEmojiToFrequentlyUsedList',
    value: function addEmojiToFrequentlyUsedList(emoji) {
      if (this.emoji.isEmojiNameValid(emoji)) {
        this.frequentlyUsedEmojis = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.uniq(this.getFrequentlyUsedEmojis().concat(emoji));
        __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set('frequently_used_emojis', this.frequentlyUsedEmojis.join(','), { expires: 365 });
      }
    }
  }, {
    key: 'getFrequentlyUsedEmojis',
    value: function getFrequentlyUsedEmojis() {
      var _this7 = this;

      return this.frequentlyUsedEmojis || function () {
        var frequentlyUsedEmojis = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.uniq((__WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get('frequently_used_emojis') || '').split(','));
        _this7.frequentlyUsedEmojis = frequentlyUsedEmojis.filter(function (inputName) {
          return _this7.emoji.isEmojiNameValid(inputName);
        });

        return _this7.frequentlyUsedEmojis;
      }();
    }
  }, {
    key: 'setupSearch',
    value: function setupSearch() {
      var _this8 = this;

      var $search = $('.js-emoji-menu-search');

      this.registerEventListener('on', $search, 'input', function (e) {
        var term = $(e.target).val().trim();
        _this8.searchEmojis(term);
      });

      var $menu = $('.emoji-menu');
      this.registerEventListener('on', $menu, transitionEndEventString, function (e) {
        if (e.target === e.currentTarget) {
          // Clear the search
          _this8.searchEmojis('');
        }
      });
    }
  }, {
    key: 'searchEmojis',
    value: function searchEmojis(term) {
      var $search = $('.js-emoji-menu-search');
      $search.val(term);

      // Clean previous search results
      $('ul.emoji-menu-search, h5.emoji-search-title').remove();
      if (term.length > 0) {
        // Generate a search result block
        var h5 = $('<h5 class="emoji-search-title"/>').text('Search results');
        var foundEmojis = this.findMatchingEmojiElements(term).show();
        var ul = $('<ul>').addClass('emoji-menu-list emoji-menu-search').append(foundEmojis);
        $('.emoji-menu-content ul, .emoji-menu-content h5').hide();
        $('.emoji-menu-content').append(h5).append(ul);
      } else {
        $('.emoji-menu-content').children().show();
      }
    }
  }, {
    key: 'findMatchingEmojiElements',
    value: function findMatchingEmojiElements(query) {
      var emojiMatches = this.emoji.filterEmojiNamesByAlias(query);
      var $emojiElements = $('.emoji-menu-list:not(.frequent-emojis) [data-name]');
      var $matchingElements = $emojiElements.filter(function (i, elm) {
        return emojiMatches.indexOf(elm.dataset.name) >= 0;
      });
      return $matchingElements.closest('li').clone();
    }

    /* showMenuElement and hideMenuElement are performance optimizations. We use
     * opacity to show/hide the emoji menu, because we can animate it. But opacity
     * leaves hidden elements in the render tree, which is unacceptable given the number
     * of emoji elements in the emoji menu (5k+). To get the best of both worlds, we separately
     * apply IS_RENDERED to add/remove the menu from the render tree and IS_VISIBLE to animate
     * the menu being opened and closed. */

  }, {
    key: 'showMenuElement',
    value: function showMenuElement($emojiMenu) {
      $emojiMenu.addClass(IS_RENDERED);

      // enqueues animation as a microtask, so it begins ASAP once IS_RENDERED added
      return Promise.resolve().then(function () {
        return $emojiMenu.addClass(IS_VISIBLE);
      });
    }
  }, {
    key: 'hideMenuElement',
    value: function hideMenuElement($emojiMenu) {
      $emojiMenu.on(transitionEndEventString, function (e) {
        if (e.currentTarget === e.target) {
          $emojiMenu.removeClass(IS_RENDERED).off(transitionEndEventString);
        }
      });

      $emojiMenu.removeClass(IS_VISIBLE);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.eventListeners.forEach(function (entry) {
        var _entry$element$off;

        (_entry$element$off = entry.element.off).call.apply(_entry$element$off, [entry.element].concat(_toConsumableArray(entry.args)));
      });
      $('.emoji-menu').remove();
    }
  }]);

  return AwardsHandler;
}();

var awardsHandlerPromise = null;
function loadAwardsHandler() {
  var reload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  if (!awardsHandlerPromise || reload) {
    awardsHandlerPromise = __webpack_require__.e/* import() */("emoji").then(__webpack_require__.bind(null, "./emoji/index.js")).then(function (Emoji) {
      return new AwardsHandler(Emoji);
    });
  }
  return awardsHandlerPromise;
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./behaviors/bind_in_out.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BindInOut = function () {
  function BindInOut(bindIn, bindOut) {
    _classCallCheck(this, BindInOut);

    this.in = bindIn;
    this.out = bindOut;

    this.eventWrapper = {};
    this.eventType = /(INPUT|TEXTAREA)/.test(bindIn.tagName) ? 'keyup' : 'change';
  }

  _createClass(BindInOut, [{
    key: 'addEvents',
    value: function addEvents() {
      this.eventWrapper.updateOut = this.updateOut.bind(this);

      this.in.addEventListener(this.eventType, this.eventWrapper.updateOut);

      return this;
    }
  }, {
    key: 'updateOut',
    value: function updateOut() {
      this.out.textContent = this.in.value;

      return this;
    }
  }, {
    key: 'removeEvents',
    value: function removeEvents() {
      this.in.removeEventListener(this.eventType, this.eventWrapper.updateOut);

      return this;
    }
  }], [{
    key: 'initAll',
    value: function initAll() {
      var ins = document.querySelectorAll('*[data-bind-in]');

      return [].map.call(ins, function (anIn) {
        return BindInOut.init(anIn);
      });
    }
  }, {
    key: 'init',
    value: function init(anIn, anOut) {
      var out = anOut || document.querySelector('*[data-bind-out="' + anIn.dataset.bindIn + '"]');

      if (!out) return null;

      var bindInOut = new BindInOut(anIn, out);

      return bindInOut.addEvents().updateOut();
    }
  }]);

  return BindInOut;
}();

/* harmony default export */ __webpack_exports__["a"] = (BindInOut);

/***/ }),

/***/ "./behaviors/details_behavior.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {
$(function () {
  $('body').on('click', '.js-details-target', function target() {
    $(this).closest('.js-details-container').toggleClass('open');
  });

  // Show details content. Hides link after click.
  //
  // %div
  //   %a.js-details-expand
  //   %div.js-details-content
  //
  $('body').on('click', '.js-details-expand', function expand(e) {
    e.preventDefault();
    $(this).next('.js-details-content').removeClass('hide');
    $(this).hide();

    var truncatedItem = $(this).siblings('.js-details-short');
    if (truncatedItem.length) {
      truncatedItem.addClass('hide');
    }
  });
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./behaviors/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/vendor/assets/javascripts/autosize.js
var autosize = __webpack_require__("../../../vendor/assets/javascripts/autosize.js");
var autosize_default = /*#__PURE__*/__webpack_require__.n(autosize);

// CONCATENATED MODULE: ./behaviors/autosize.js


document.addEventListener('DOMContentLoaded', function () {
  var autosizeEls = document.querySelectorAll('.js-autosize');

  autosize_default()(autosizeEls);
  autosize_default.a.update(autosizeEls);
});
// EXTERNAL MODULE: ./behaviors/bind_in_out.js
var bind_in_out = __webpack_require__("./behaviors/bind_in_out.js");

// EXTERNAL MODULE: ./behaviors/details_behavior.js
var details_behavior = __webpack_require__("./behaviors/details_behavior.js");
var details_behavior_default = /*#__PURE__*/__webpack_require__.n(details_behavior);

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/document-register-element/build/document-register-element.node.js
var document_register_element_node = __webpack_require__("../../../node_modules/document-register-element/build/document-register-element.node.js");
var document_register_element_node_default = /*#__PURE__*/__webpack_require__.n(document_register_element_node);

// CONCATENATED MODULE: ./emoji/support/is_emoji_unicode_supported.js
// On Windows, flags render as two-letter country codes, see http://emojipedia.org/flags/
var flagACodePoint = 127462; // parseInt('1F1E6', 16)
var flagZCodePoint = 127487; // parseInt('1F1FF', 16)
function isFlagEmoji(emojiUnicode) {
  var cp = emojiUnicode.codePointAt(0);
  // Length 4 because flags are made of 2 characters which are surrogate pairs
  return emojiUnicode.length === 4 && cp >= flagACodePoint && cp <= flagZCodePoint;
}

// Chrome <57 renders keycaps oddly
// See https://bugs.chromium.org/p/chromium/issues/detail?id=632294
// Same issue on Windows also fixed in Chrome 57, http://i.imgur.com/rQF7woO.png
function isKeycapEmoji(emojiUnicode) {
  return emojiUnicode.length === 3 && emojiUnicode[2] === '\u20E3';
}

// Check for a skin tone variation emoji which aren't always supported
var tone1 = 127995; // parseInt('1F3FB', 16)
var tone5 = 127999; // parseInt('1F3FF', 16)
function isSkinToneComboEmoji(emojiUnicode) {
  return emojiUnicode.length > 2 && Array.from(emojiUnicode).some(function (char) {
    var cp = char.codePointAt(0);
    return cp >= tone1 && cp <= tone5;
  });
}

// macOS supports most skin tone emoji's but
// doesn't support the skin tone versions of horse racing
var horseRacingCodePoint = 127943; // parseInt('1F3C7', 16)
function isHorceRacingSkinToneComboEmoji(emojiUnicode) {
  var firstCharacter = Array.from(emojiUnicode)[0];
  return firstCharacter && firstCharacter.codePointAt(0) === horseRacingCodePoint && isSkinToneComboEmoji(emojiUnicode);
}

// Check for `family_*`, `kiss_*`, `couple_*`
// For ex. Windows 8.1 Firefox 51.0.1, doesn't support these
var zwj = 8205; // parseInt('200D', 16)
var personStartCodePoint = 128102; // parseInt('1F466', 16)
var personEndCodePoint = 128105; // parseInt('1F469', 16)
function isPersonZwjEmoji(emojiUnicode) {
  var hasPersonEmoji = false;
  var hasZwj = false;
  Array.from(emojiUnicode).forEach(function (character) {
    var cp = character.codePointAt(0);
    if (cp === zwj) {
      hasZwj = true;
    } else if (cp >= personStartCodePoint && cp <= personEndCodePoint) {
      hasPersonEmoji = true;
    }
  });

  return hasPersonEmoji && hasZwj;
}

// Helper so we don't have to run `isFlagEmoji` twice
// in `isEmojiUnicodeSupported` logic
function checkFlagEmojiSupport(unicodeSupportMap, emojiUnicode) {
  var isFlagResult = isFlagEmoji(emojiUnicode);
  return unicodeSupportMap.flag && isFlagResult || !isFlagResult;
}

// Helper so we don't have to run `isSkinToneComboEmoji` twice
// in `isEmojiUnicodeSupported` logic
function checkSkinToneModifierSupport(unicodeSupportMap, emojiUnicode) {
  var isSkinToneResult = isSkinToneComboEmoji(emojiUnicode);
  return unicodeSupportMap.skinToneModifier && isSkinToneResult || !isSkinToneResult;
}

// Helper func so we don't have to run `isHorceRacingSkinToneComboEmoji` twice
// in `isEmojiUnicodeSupported` logic
function checkHorseRacingSkinToneComboEmojiSupport(unicodeSupportMap, emojiUnicode) {
  var isHorseRacingSkinToneResult = isHorceRacingSkinToneComboEmoji(emojiUnicode);
  return unicodeSupportMap.horseRacing && isHorseRacingSkinToneResult || !isHorseRacingSkinToneResult;
}

// Helper so we don't have to run `isPersonZwjEmoji` twice
// in `isEmojiUnicodeSupported` logic
function checkPersonEmojiSupport(unicodeSupportMap, emojiUnicode) {
  var isPersonZwjResult = isPersonZwjEmoji(emojiUnicode);
  return unicodeSupportMap.personZwj && isPersonZwjResult || !isPersonZwjResult;
}

// Takes in a support map and determines whether
// the given unicode emoji is supported on the platform.
//
// Combines all the edge case tests into a one-stop shop method
function isEmojiUnicodeSupported() {
  var unicodeSupportMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var emojiUnicode = arguments[1];
  var unicodeVersion = arguments[2];

  var isOlderThanChrome57 = unicodeSupportMap.meta && unicodeSupportMap.meta.isChrome && unicodeSupportMap.meta.chromeVersion < 57;

  // For comments about each scenario, see the comments above each individual respective function
  return unicodeSupportMap[unicodeVersion] && !(isOlderThanChrome57 && isKeycapEmoji(emojiUnicode)) && checkFlagEmojiSupport(unicodeSupportMap, emojiUnicode) && checkSkinToneModifierSupport(unicodeSupportMap, emojiUnicode) && checkHorseRacingSkinToneComboEmojiSupport(unicodeSupportMap, emojiUnicode) && checkPersonEmojiSupport(unicodeSupportMap, emojiUnicode);
}


// EXTERNAL MODULE: ./lib/utils/accessor.js
var accessor = __webpack_require__("./lib/utils/accessor.js");

// CONCATENATED MODULE: ./emoji/support/unicode_support_map.js


var unicodeSupportTestMap = {
  // man, student (emojione does not have any of these yet), http://emojipedia.org/emoji-zwj-sequences/
  // occupationZwj: '\u{1F468}\u{200D}\u{1F393}',
  // woman, biking (emojione does not have any of these yet), http://emojipedia.org/emoji-zwj-sequences/
  // sexZwj: '\u{1F6B4}\u{200D}\u{2640}',
  // family_mwgb
  // Windows 8.1, Firefox 51.0.1 does not support `family_`, `kiss_`, `couple_`
  personZwj: '\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66',
  // horse_racing_tone5
  // Special case that is not supported on macOS 10.12 even though `skinToneModifier` succeeds
  horseRacing: '\uD83C\uDFC7\uD83C\uDFFF',
  // US flag, http://emojipedia.org/flags/
  flag: '\uD83C\uDDFA\uD83C\uDDF8',
  // http://emojipedia.org/modifiers/
  skinToneModifier: [
  // spy_tone5
  '\uD83D\uDD75\uD83C\uDFFF',
  // person_with_ball_tone5
  '\u26F9\uD83C\uDFFF',
  // angel_tone5
  '\uD83D\uDC7C\uD83C\uDFFF'],
  // rofl, http://emojipedia.org/unicode-9.0/
  '9.0': '\uD83E\uDD23',
  // metal, http://emojipedia.org/unicode-8.0/
  '8.0': '\uD83E\uDD18',
  // spy, http://emojipedia.org/unicode-7.0/
  '7.0': '\uD83D\uDD75',
  // expressionless, http://emojipedia.org/unicode-6.1/
  6.1: '\uD83D\uDE11',
  // japanese_goblin, http://emojipedia.org/unicode-6.0/
  '6.0': '\uD83D\uDC7A',
  // sailboat, http://emojipedia.org/unicode-5.2/
  5.2: '\u26F5',
  // mahjong, http://emojipedia.org/unicode-5.1/
  5.1: '\uD83C\uDC04',
  // gear, http://emojipedia.org/unicode-4.1/
  4.1: '\u2699',
  // zap, http://emojipedia.org/unicode-4.0/
  '4.0': '\u26A1',
  // recycle, http://emojipedia.org/unicode-3.2/
  3.2: '\u267B',
  // information_source, http://emojipedia.org/unicode-3.0/
  '3.0': '\u2139',
  // heart, http://emojipedia.org/unicode-1.1/
  1.1: '\u2764'
};

function checkPixelInImageDataArray(pixelOffset, imageDataArray) {
  // `4 *` because RGBA
  var indexOffset = 4 * pixelOffset;
  var hasColor = imageDataArray[indexOffset + 0] || imageDataArray[indexOffset + 1] || imageDataArray[indexOffset + 2];
  var isVisible = imageDataArray[indexOffset + 3];
  // Check for some sort of color other than black
  if (hasColor && isVisible) {
    return true;
  }
  return false;
}

var chromeMatches = navigator.userAgent.match(/Chrom(?:e|ium)\/([0-9]+)\./);
var isChrome = chromeMatches && chromeMatches.length > 0;
var chromeVersion = chromeMatches && chromeMatches[1] && parseInt(chromeMatches[1], 10);

// We use 16px because mobile Safari (iOS 9.3) doesn't properly scale emojis :/
// See 32px, https://i.imgur.com/htY6Zym.png
// See 16px, https://i.imgur.com/FPPsIF8.png
var fontSize = 16;
function generateUnicodeSupportMap(testMap) {
  var testMapKeys = Object.keys(testMap);
  var numTestEntries = testMapKeys.reduce(function (list, testKey) {
    return list.concat(testMap[testKey]);
  }, []).length;

  var canvas = document.createElement('canvas');
  (window.gl || window).testEmojiUnicodeSupportMapCanvas = canvas;
  var ctx = canvas.getContext('2d');
  canvas.width = 2 * fontSize;
  canvas.height = numTestEntries * fontSize;
  ctx.fillStyle = '#000000';
  ctx.textBaseline = 'middle';
  ctx.font = fontSize + 'px "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"';
  // Write each emoji to the canvas vertically
  var writeIndex = 0;
  testMapKeys.forEach(function (testKey) {
    var testEntry = testMap[testKey];
    [].concat(testEntry).forEach(function (emojiUnicode) {
      ctx.fillText(emojiUnicode, 0, writeIndex * fontSize + fontSize / 2);
      writeIndex += 1;
    });
  });

  // Read from the canvas
  var resultMap = {};
  var readIndex = 0;
  testMapKeys.forEach(function (testKey) {
    var testEntry = testMap[testKey];
    // This needs to be a `reduce` instead of `every` because we need to
    // keep the `readIndex` in sync from the writes by running all entries
    var isTestSatisfied = [].concat(testEntry).reduce(function (isSatisfied) {
      // Sample along the vertical-middle for a couple of characters
      var imageData = ctx.getImageData(0, readIndex * fontSize + fontSize / 2, 2 * fontSize, 1).data;

      var isValidEmoji = false;
      for (var currentPixel = 0; currentPixel < 64; currentPixel += 1) {
        var isLookingAtFirstChar = currentPixel < fontSize;
        var isLookingAtSecondChar = currentPixel >= fontSize + fontSize / 2;
        // Check for the emoji somewhere along the row
        if (isLookingAtFirstChar && checkPixelInImageDataArray(currentPixel, imageData)) {
          isValidEmoji = true;

          // Check to see that nothing is rendered next to the first character
          // to ensure that the ZWJ sequence rendered as one piece
        } else if (isLookingAtSecondChar && checkPixelInImageDataArray(currentPixel, imageData)) {
          isValidEmoji = false;
          break;
        }
      }

      readIndex += 1;
      return isSatisfied && isValidEmoji;
    }, true);

    resultMap[testKey] = isTestSatisfied;
  });

  resultMap.meta = {
    isChrome: isChrome,
    chromeVersion: chromeVersion
  };

  return resultMap;
}

function getUnicodeSupportMap() {
  var unicodeSupportMap = void 0;
  var userAgentFromCache = void 0;

  var isLocalStorageAvailable = accessor["a" /* default */].isLocalStorageAccessSafe();

  if (isLocalStorageAvailable) userAgentFromCache = window.localStorage.getItem('gl-emoji-user-agent');

  try {
    unicodeSupportMap = JSON.parse(window.localStorage.getItem('gl-emoji-unicode-support-map'));
  } catch (err) {
    // swallow
  }

  if (!unicodeSupportMap || userAgentFromCache !== navigator.userAgent) {
    unicodeSupportMap = generateUnicodeSupportMap(unicodeSupportTestMap);

    if (isLocalStorageAvailable) {
      window.localStorage.setItem('gl-emoji-user-agent', navigator.userAgent);
      window.localStorage.setItem('gl-emoji-unicode-support-map', JSON.stringify(unicodeSupportMap));
    }
  }

  return unicodeSupportMap;
}
// CONCATENATED MODULE: ./emoji/support/index.js



// cache browser support map between calls
var browserUnicodeSupportMap = void 0;

function isEmojiUnicodeSupportedByBrowser(emojiUnicode, unicodeVersion) {
  browserUnicodeSupportMap = browserUnicodeSupportMap || getUnicodeSupportMap();
  return isEmojiUnicodeSupported(browserUnicodeSupportMap, emojiUnicode, unicodeVersion);
}
// CONCATENATED MODULE: ./behaviors/gl_emoji.js



document_register_element_node_default()(window);

function installGlEmojiElement() {
  var GlEmojiElementProto = Object.create(HTMLElement.prototype);
  GlEmojiElementProto.createdCallback = function createdCallback() {
    var _this = this;

    var emojiUnicode = this.textContent.trim();
    var _dataset = this.dataset,
        name = _dataset.name,
        unicodeVersion = _dataset.unicodeVersion,
        fallbackSrc = _dataset.fallbackSrc,
        fallbackSpriteClass = _dataset.fallbackSpriteClass;


    var isEmojiUnicode = this.childNodes && Array.prototype.every.call(this.childNodes, function (childNode) {
      return childNode.nodeType === 3;
    });
    var hasImageFallback = fallbackSrc && fallbackSrc.length > 0;
    var hasCssSpriteFalback = fallbackSpriteClass && fallbackSpriteClass.length > 0;

    if (emojiUnicode && isEmojiUnicode && !isEmojiUnicodeSupportedByBrowser(emojiUnicode, unicodeVersion)) {
      // CSS sprite fallback takes precedence over image fallback
      if (hasCssSpriteFalback) {
        // IE 11 doesn't like adding multiple at once :(
        this.classList.add('emoji-icon');
        this.classList.add(fallbackSpriteClass);
      } else {
        __webpack_require__.e/* import() */("emoji").then(__webpack_require__.bind(null, "./emoji/index.js")).then(function (_ref) {
          var emojiImageTag = _ref.emojiImageTag,
              emojiFallbackImageSrc = _ref.emojiFallbackImageSrc;

          if (hasImageFallback) {
            _this.innerHTML = emojiImageTag(name, fallbackSrc);
          } else {
            var src = emojiFallbackImageSrc(name);
            _this.innerHTML = emojiImageTag(name, src);
          }
        }).catch(function () {
          // do nothing
        });
      }
    }
  };

  document.registerElement('gl-emoji', {
    prototype: GlEmojiElementProto
  });
}
// EXTERNAL MODULE: ./behaviors/quick_submit.js
var quick_submit = __webpack_require__("./behaviors/quick_submit.js");

// EXTERNAL MODULE: ./behaviors/requires_input.js
var requires_input = __webpack_require__("./behaviors/requires_input.js");

// EXTERNAL MODULE: ./behaviors/toggler_behavior.js
var toggler_behavior = __webpack_require__("./behaviors/toggler_behavior.js");

// CONCATENATED MODULE: ./behaviors/index.js








installGlEmojiElement();

/***/ }),

/***/ "./behaviors/quick_submit.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commons_bootstrap__ = __webpack_require__("./commons/bootstrap.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_common_utils__ = __webpack_require__("./lib/utils/common_utils.js");



// Quick Submit behavior
//
// When a child field of a form with a `js-quick-submit` class receives a
// "Meta+Enter" (Mac) or "Ctrl+Enter" (Linux/Windows) key combination, the form
// is submitted.
//
// ### Example Markup
//
//   <form action="/foo" class="js-quick-submit">
//     <input type="text" />
//     <textarea></textarea>
//     <input type="submit" value="Submit" />
//   </form>
//

function isMac() {
  return navigator.userAgent.match(/Macintosh/);
}

function keyCodeIs(e, keyCode) {
  if (e.originalEvent && e.originalEvent.repeat || e.repeat) {
    return false;
  }
  return e.keyCode === keyCode;
}

$(document).on('keydown.quick_submit', '.js-quick-submit', function (e) {
  // Enter
  if (!keyCodeIs(e, 13)) {
    return;
  }

  var onlyMeta = e.metaKey && !e.altKey && !e.ctrlKey && !e.shiftKey;
  var onlyCtrl = e.ctrlKey && !e.altKey && !e.metaKey && !e.shiftKey;
  if (!onlyMeta && !onlyCtrl) {
    return;
  }

  e.preventDefault();
  var $form = $(e.target).closest('form');
  var $submitButton = $form.find('input[type=submit], button[type=submit]').first();

  if (!$submitButton.attr('disabled')) {
    $submitButton.trigger('click', [e]);

    if (!Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils_common_utils__["m" /* isInIssuePage */])()) {
      $submitButton.disable();
    }
  }
});

// If the user tabs to a submit button on a `js-quick-submit` form, display a
// tooltip to let them know they could've used the hotkey
$(document).on('keyup.quick_submit', '.js-quick-submit input[type=submit], .js-quick-submit button[type=submit]', function displayTooltip(e) {
  // Tab
  if (!keyCodeIs(e, 9)) {
    return;
  }

  var $this = $(this);
  var title = isMac() ? 'You can also press &#8984;-Enter' : 'You can also press Ctrl-Enter';

  $this.tooltip({
    container: 'body',
    html: 'true',
    placement: 'auto top',
    title: title,
    trigger: 'manual'
  });
  $this.tooltip('show').one('blur', function () {
    return $this.tooltip('hide');
  });
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./behaviors/requires_input.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commons_bootstrap__ = __webpack_require__("./commons/bootstrap.js");



// Requires Input behavior
//
// When called on a form with input fields with the `required` attribute, the
// form's submit button will be disabled until all required fields have values.
//
// ### Example Markup
//
//   <form class="js-requires-input">
//     <input type="text" required="required">
//     <input type="submit" value="Submit">
//   </form>
//

$.fn.requiresInput = function requiresInput() {
  var $form = $(this);
  var $button = $('button[type=submit], input[type=submit]', $form);
  var fieldSelector = 'input[required=required], select[required=required], textarea[required=required]';

  function requireInput() {
    // Collect the input values of *all* required fields
    var values = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.map($(fieldSelector, $form), function (field) {
      return field.value;
    });

    // Disable the button if any required fields are empty
    if (values.length && __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.any(values, __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.isEmpty)) {
      $button.disable();
    } else {
      $button.enable();
    }
  }

  // Set initial button state
  requireInput();
  $form.on('change input', fieldSelector, requireInput);
};

// Hide or Show the help block when creating a new project
// based on the option selected
function hideOrShowHelpBlock(form) {
  var selected = $('.js-select-namespace option:selected');
  if (selected.length && selected.data('options-parent') === 'groups') {
    form.find('.help-block').hide();
  } else if (selected.length) {
    form.find('.help-block').show();
  }
}

$(function () {
  var $form = $('form.js-requires-input');
  if ($form) {
    $form.requiresInput();
    hideOrShowHelpBlock($form);
    $('.select2.js-select-namespace').change(function () {
      return hideOrShowHelpBlock($form);
    });
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./behaviors/toggler_behavior.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_url_utility__ = __webpack_require__("./lib/utils/url_utility.js");
// Toggle button. Show/hide content inside parent container.
// Button does not change visibility. If button has icon - it changes chevron style.
//
// %div.js-toggle-container
//   %button.js-toggle-button
//   %div.js-toggle-content
//


$(function () {
  function toggleContainer(container, toggleState) {
    var $container = $(container);

    $container.find('.js-toggle-button .fa').toggleClass('fa-chevron-up', toggleState).toggleClass('fa-chevron-down', toggleState !== undefined ? !toggleState : undefined);

    $container.find('.js-toggle-content').toggle(toggleState);
  }

  $('body').on('click', '.js-toggle-button', function toggleButton(e) {
    e.target.classList.toggle('open');
    toggleContainer($(this).closest('.js-toggle-container'));

    var targetTag = e.currentTarget.tagName.toLowerCase();
    if (targetTag === 'a' || targetTag === 'button') {
      e.preventDefault();
    }
  });

  // If we're accessing a permalink, ensure it is not inside a
  // closed js-toggle-container!
  var hash = window.gl.utils.getLocationHash();
  var anchor = hash && document.getElementById(hash);
  var container = anchor && $(anchor).closest('.js-toggle-container');

  if (container) {
    toggleContainer(container, true);
    anchor.scrollIntoView();
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./blob/blob_fork_suggestion.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var defaults = {
  // Buttons that will show the `suggestionSections`
  // has `data-fork-path`, and `data-action`
  openButtons: [],
  // Update the href(from `openButton` -> `data-fork-path`)
  // whenever a `openButton` is clicked
  forkButtons: [],
  // Buttons to hide the `suggestionSections`
  cancelButtons: [],
  // Section to show/hide
  suggestionSections: [],
  // Pieces of text that need updating depending on the action, `edit`, `replace`, `delete`
  actionTextPieces: []
};

var BlobForkSuggestion = function () {
  function BlobForkSuggestion(options) {
    _classCallCheck(this, BlobForkSuggestion);

    this.elementMap = Object.assign({}, defaults, options);
    this.onOpenButtonClick = this.onOpenButtonClick.bind(this);
    this.onCancelButtonClick = this.onCancelButtonClick.bind(this);
  }

  _createClass(BlobForkSuggestion, [{
    key: 'init',
    value: function init() {
      this.bindEvents();

      return this;
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      $(this.elementMap.openButtons).on('click', this.onOpenButtonClick);
      $(this.elementMap.cancelButtons).on('click', this.onCancelButtonClick);
    }
  }, {
    key: 'showSuggestionSection',
    value: function showSuggestionSection(forkPath) {
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'edit';

      $(this.elementMap.suggestionSections).removeClass('hidden');
      $(this.elementMap.forkButtons).attr('href', forkPath);
      $(this.elementMap.actionTextPieces).text(action);
    }
  }, {
    key: 'hideSuggestionSection',
    value: function hideSuggestionSection() {
      $(this.elementMap.suggestionSections).addClass('hidden');
    }
  }, {
    key: 'onOpenButtonClick',
    value: function onOpenButtonClick(e) {
      var forkPath = $(e.currentTarget).attr('data-fork-path');
      var action = $(e.currentTarget).attr('data-action');
      this.showSuggestionSection(forkPath, action);
    }
  }, {
    key: 'onCancelButtonClick',
    value: function onCancelButtonClick() {
      this.hideSuggestionSection();
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      $(this.elementMap.openButtons).off('click', this.onOpenButtonClick);
      $(this.elementMap.cancelButtons).off('click', this.onCancelButtonClick);
    }
  }]);

  return BlobForkSuggestion;
}();

/* harmony default export */ __webpack_exports__["a"] = (BlobForkSuggestion);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./blob/blob_line_permalink_updater.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var lineNumberRe = /^L[0-9]+/;

var updateLineNumbersOnBlobPermalinks = function updateLineNumbersOnBlobPermalinks(linksToUpdate) {
  var hash = gl.utils.getLocationHash();
  if (hash && lineNumberRe.test(hash)) {
    var hashUrlString = '#' + hash;

    [].concat(Array.prototype.slice.call(linksToUpdate)).forEach(function (permalinkButton) {
      var baseHref = permalinkButton.getAttribute('data-original-href') || function () {
        var href = permalinkButton.getAttribute('href');
        permalinkButton.setAttribute('data-original-href', href);
        return href;
      }();
      permalinkButton.setAttribute('href', '' + baseHref + hashUrlString);
    });
  }
};

function BlobLinePermalinkUpdater(blobContentHolder, lineNumberSelector, elementsToUpdate) {
  var updateBlameAndBlobPermalinkCb = function updateBlameAndBlobPermalinkCb() {
    // Wait for the hash to update from the LineHighlighter callback
    setTimeout(function () {
      updateLineNumbersOnBlobPermalinks(elementsToUpdate);
    }, 0);
  };

  blobContentHolder.addEventListener('click', function (e) {
    if (e.target.matches(lineNumberSelector)) {
      updateBlameAndBlobPermalinkCb();
    }
  });
  updateBlameAndBlobPermalinkCb();
}

/* harmony default export */ __webpack_exports__["a"] = (BlobLinePermalinkUpdater);

/***/ }),

/***/ "./blob/template_selector.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, jQuery) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this, no-unused-vars */

var TemplateSelector = function () {
  function TemplateSelector() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        dropdown = _ref.dropdown,
        data = _ref.data,
        pattern = _ref.pattern,
        wrapper = _ref.wrapper,
        editor = _ref.editor,
        $input = _ref.$input;

    _classCallCheck(this, TemplateSelector);

    this.pattern = pattern;
    this.editor = editor;
    this.dropdown = dropdown;
    this.$dropdownContainer = wrapper;
    this.$filenameInput = $input || $('#file_name');
    this.$dropdownIcon = $('.fa-chevron-down', dropdown);

    this.initDropdown(dropdown, data);
    this.listenForFilenameInput();
    this.renderMatchedDropdown();
    this.initAutosizeUpdateEvent();
  }

  _createClass(TemplateSelector, [{
    key: 'initDropdown',
    value: function initDropdown(dropdown, data) {
      var _this = this;

      return $(dropdown).glDropdown({
        data: data,
        filterable: true,
        selectable: true,
        toggleLabel: function toggleLabel(item) {
          return item.name;
        },
        search: {
          fields: ['name']
        },
        clicked: function clicked(options) {
          return _this.fetchFileTemplate(options);
        },
        text: function text(item) {
          return item.name;
        }
      });
    }
  }, {
    key: 'initAutosizeUpdateEvent',
    value: function initAutosizeUpdateEvent() {
      this.autosizeUpdateEvent = document.createEvent('Event');
      this.autosizeUpdateEvent.initEvent('autosize:update', true, false);
    }
  }, {
    key: 'listenForFilenameInput',
    value: function listenForFilenameInput() {
      var _this2 = this;

      return this.$filenameInput.on('keyup blur', function (e) {
        return _this2.renderMatchedDropdown(e);
      });
    }
  }, {
    key: 'renderMatchedDropdown',
    value: function renderMatchedDropdown() {
      if (!this.$filenameInput.length) {
        return null;
      }

      var filenameMatches = this.pattern.test(this.$filenameInput.val().trim());

      if (!filenameMatches) {
        return this.$dropdownContainer.addClass('hidden');
      }
      return this.$dropdownContainer.removeClass('hidden');
    }
  }, {
    key: 'fetchFileTemplate',
    value: function fetchFileTemplate(options) {
      var e = options.e;

      var item = options.selectedObj;

      e.preventDefault();
      return this.requestFile(item);
    }
  }, {
    key: 'requestFile',
    value: function requestFile(item) {}
    // This `requestFile` method is an abstract method that should
    // be added by all subclasses.


    // To be implemented on the extending class
    // e.g. Api.gitlabCiYml(query.name, file => this.setEditorContent(file));

  }, {
    key: 'setEditorContent',
    value: function setEditorContent(file) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          skipFocus = _ref2.skipFocus;

      if (!file) return;

      var newValue = file.content;

      this.editor.setValue(newValue, 1);

      if (!skipFocus) this.editor.focus();

      if (this.editor instanceof jQuery) {
        this.editor.get(0).dispatchEvent(this.autosizeUpdateEvent);
      }
    }
  }, {
    key: 'startLoadingSpinner',
    value: function startLoadingSpinner() {
      this.$dropdownIcon.addClass('fa-spinner fa-spin').removeClass('fa-chevron-down');
    }
  }, {
    key: 'stopLoadingSpinner',
    value: function stopLoadingSpinner() {
      this.$dropdownIcon.addClass('fa-chevron-down').removeClass('fa-spinner fa-spin');
    }
  }]);

  return TemplateSelector;
}();

/* harmony default export */ __webpack_exports__["a"] = (TemplateSelector);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js"), __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./blob/viewer/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global Flash */


var BlobViewer = function () {
  function BlobViewer() {
    _classCallCheck(this, BlobViewer);

    BlobViewer.initAuxiliaryViewer();

    this.initMainViewers();
  }

  _createClass(BlobViewer, [{
    key: 'initMainViewers',
    value: function initMainViewers() {
      this.$fileHolder = $('.file-holder');
      if (!this.$fileHolder.length) return;

      this.switcher = document.querySelector('.js-blob-viewer-switcher');
      this.switcherBtns = document.querySelectorAll('.js-blob-viewer-switch-btn');
      this.copySourceBtn = document.querySelector('.js-copy-blob-source-btn');

      this.simpleViewer = this.$fileHolder[0].querySelector('.blob-viewer[data-type="simple"]');
      this.richViewer = this.$fileHolder[0].querySelector('.blob-viewer[data-type="rich"]');

      this.initBindings();

      this.switchToInitialViewer();
    }
  }, {
    key: 'switchToInitialViewer',
    value: function switchToInitialViewer() {
      var initialViewer = this.$fileHolder[0].querySelector('.blob-viewer:not(.hidden)');
      var initialViewerName = initialViewer.getAttribute('data-type');

      if (this.switcher && location.hash.indexOf('#L') === 0) {
        initialViewerName = 'simple';
      }

      this.switchToViewer(initialViewerName);
    }
  }, {
    key: 'initBindings',
    value: function initBindings() {
      var _this = this;

      if (this.switcherBtns.length) {
        Array.from(this.switcherBtns).forEach(function (el) {
          el.addEventListener('click', _this.switchViewHandler.bind(_this));
        });
      }

      if (this.copySourceBtn) {
        this.copySourceBtn.addEventListener('click', function () {
          if (_this.copySourceBtn.classList.contains('disabled')) return _this.copySourceBtn.blur();

          return _this.switchToViewer('simple');
        });
      }
    }
  }, {
    key: 'switchViewHandler',
    value: function switchViewHandler(e) {
      var target = e.currentTarget;

      e.preventDefault();

      this.switchToViewer(target.getAttribute('data-viewer'));
    }
  }, {
    key: 'toggleCopyButtonState',
    value: function toggleCopyButtonState() {
      if (!this.copySourceBtn) return;

      if (this.simpleViewer.getAttribute('data-loaded')) {
        this.copySourceBtn.setAttribute('title', 'Copy source to clipboard');
        this.copySourceBtn.classList.remove('disabled');
      } else if (this.activeViewer === this.simpleViewer) {
        this.copySourceBtn.setAttribute('title', 'Wait for the source to load to copy it to the clipboard');
        this.copySourceBtn.classList.add('disabled');
      } else {
        this.copySourceBtn.setAttribute('title', 'Switch to the source to copy it to the clipboard');
        this.copySourceBtn.classList.add('disabled');
      }

      $(this.copySourceBtn).tooltip('fixTitle');
    }
  }, {
    key: 'switchToViewer',
    value: function switchToViewer(name) {
      var _this2 = this;

      var newViewer = this.$fileHolder[0].querySelector('.blob-viewer[data-type=\'' + name + '\']');
      if (this.activeViewer === newViewer) return;

      var oldButton = document.querySelector('.js-blob-viewer-switch-btn.active');
      var newButton = document.querySelector('.js-blob-viewer-switch-btn[data-viewer=\'' + name + '\']');
      var oldViewer = this.$fileHolder[0].querySelector('.blob-viewer:not([data-type=\'' + name + '\'])');

      if (oldButton) {
        oldButton.classList.remove('active');
      }

      if (newButton) {
        newButton.classList.add('active');
        newButton.blur();
      }

      if (oldViewer) {
        oldViewer.classList.add('hidden');
      }

      newViewer.classList.remove('hidden');

      this.activeViewer = newViewer;

      this.toggleCopyButtonState();

      BlobViewer.loadViewer(newViewer).then(function (viewer) {
        $(viewer).renderGFM();

        _this2.$fileHolder.trigger('highlight:line');
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_utils_common_utils__["k" /* handleLocationHash */])();

        _this2.toggleCopyButtonState();
      }).catch(function () {
        return new Flash('Error loading viewer');
      });
    }
  }], [{
    key: 'initAuxiliaryViewer',
    value: function initAuxiliaryViewer() {
      var auxiliaryViewer = document.querySelector('.blob-viewer[data-type="auxiliary"]');
      if (!auxiliaryViewer) return;

      BlobViewer.loadViewer(auxiliaryViewer);
    }
  }, {
    key: 'loadViewer',
    value: function loadViewer(viewerParam) {
      var viewer = viewerParam;
      var url = viewer.getAttribute('data-url');

      return new Promise(function (resolve, reject) {
        if (!url || viewer.getAttribute('data-loaded') || viewer.getAttribute('data-loading')) {
          resolve(viewer);
          return;
        }

        viewer.setAttribute('data-loading', 'true');

        $.ajax({
          url: url,
          dataType: 'JSON'
        }).fail(reject).done(function (data) {
          viewer.innerHTML = data.html;
          viewer.setAttribute('data-loaded', 'true');

          resolve(viewer);
        });
      });
    }
  }]);

  return BlobViewer;
}();

/* harmony default export */ __webpack_exports__["a"] = (BlobViewer);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./branches/branches_delete_modal.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MODAL_SELECTOR = '#modal-delete-branch';

var DeleteModal = function () {
  function DeleteModal() {
    _classCallCheck(this, DeleteModal);

    this.$modal = $(MODAL_SELECTOR);
    this.$toggleBtns = $('[data-target="' + MODAL_SELECTOR + '"]');
    this.$branchName = $('.js-branch-name', this.$modal);
    this.$confirmInput = $('.js-delete-branch-input', this.$modal);
    this.$deleteBtn = $('.js-delete-branch', this.$modal);
    this.$notMerged = $('.js-not-merged', this.$modal);
    this.bindEvents();
  }

  _createClass(DeleteModal, [{
    key: 'bindEvents',
    value: function bindEvents() {
      this.$toggleBtns.on('click', this.setModalData.bind(this));
      this.$confirmInput.on('input', this.setDeleteDisabled.bind(this));
    }
  }, {
    key: 'setModalData',
    value: function setModalData(e) {
      var branchData = e.currentTarget.dataset;
      this.branchName = branchData.branchName || '';
      this.deletePath = branchData.deletePath || '';
      this.isMerged = !!branchData.isMerged;
      this.updateModal();
    }
  }, {
    key: 'setDeleteDisabled',
    value: function setDeleteDisabled(e) {
      this.$deleteBtn.attr('disabled', e.currentTarget.value !== this.branchName);
    }
  }, {
    key: 'updateModal',
    value: function updateModal() {
      this.$branchName.text(this.branchName);
      this.$confirmInput.val('');
      this.$deleteBtn.attr('href', this.deletePath);
      this.$deleteBtn.attr('disabled', true);
      this.$notMerged.toggleClass('hidden', this.isMerged);
    }
  }]);

  return DeleteModal;
}();

/* harmony default export */ __webpack_exports__["a"] = (DeleteModal);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./breadcrumb.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* unused harmony export addTooltipToEl */
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var addTooltipToEl = function addTooltipToEl(el) {
  var textEl = el.querySelector('.js-breadcrumb-item-text');

  if (textEl && textEl.scrollWidth > textEl.offsetWidth) {
    el.setAttribute('title', el.textContent);
    el.setAttribute('data-container', 'body');
    el.classList.add('has-tooltip');
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var breadcrumbs = document.querySelector('.js-breadcrumbs-list');

  if (breadcrumbs) {
    var topLevelLinks = [].concat(_toConsumableArray(breadcrumbs.children)).filter(function (el) {
      return !el.classList.contains('dropdown');
    }).map(function (el) {
      return el.querySelector('a');
    }).filter(function (el) {
      return el;
    });
    var $expander = $('.js-breadcrumbs-collapsed-expander');

    topLevelLinks.forEach(function (el) {
      return addTooltipToEl(el);
    });

    $expander.closest('.dropdown').on('show.bs.dropdown hide.bs.dropdown', function (e) {
      $('.js-breadcrumbs-collapsed-expander', e.currentTarget).toggleClass('open').tooltip('hide');
    });
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./breakpoints.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export breakpoints */
var breakpoints = {
  lg: 1200,
  md: 992,
  sm: 768,
  xs: 0
};

var BreakpointInstance = {
  windowWidth: function windowWidth() {
    return window.innerWidth;
  },
  getBreakpointSize: function getBreakpointSize() {
    var windowWidth = this.windowWidth();

    var breakpoint = Object.keys(breakpoints).find(function (key) {
      return windowWidth > breakpoints[key];
    });

    return breakpoint;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (BreakpointInstance);

/***/ }),

/***/ "./broadcast_message.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, prefer-arrow-callback, no-var, quotes, no-else-return, object-shorthand, comma-dangle, max-len */

$(function () {
  var previewPath;
  $('input#broadcast_message_color').on('input', function () {
    var previewColor;
    previewColor = $(this).val();
    return $('div.broadcast-message-preview').css('background-color', previewColor);
  });
  $('input#broadcast_message_font').on('input', function () {
    var previewColor;
    previewColor = $(this).val();
    return $('div.broadcast-message-preview').css('color', previewColor);
  });
  previewPath = $('textarea#broadcast_message_message').data('preview-path');
  return $('textarea#broadcast_message_message').on('input', function () {
    var message;
    message = $(this).val();
    if (message === '') {
      return $('.js-broadcast-message-preview').text("Your message here");
    } else {
      return $.ajax({
        url: previewPath,
        type: "POST",
        data: {
          broadcast_message: {
            message: message
          }
        }
      });
    }
  });
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./build.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__breakpoints__ = __webpack_require__("./breakpoints.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils_number_utils__ = __webpack_require__("./lib/utils/number_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_utils_common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
/* eslint-disable func-names, wrap-iife, no-use-before-define,
consistent-return, prefer-rest-params */





window.Build = function () {
  Build.timeout = null;
  Build.state = null;

  function Build(options) {
    var _this = this;

    this.options = options || $('.js-build-options').data();

    this.pageUrl = this.options.pageUrl;
    this.buildStatus = this.options.buildStatus;
    this.state = this.options.logState;
    this.buildStage = this.options.buildStage;
    this.$document = $(document);
    this.logBytes = 0;
    this.hasBeenScrolled = false;

    this.updateDropdown = this.updateDropdown.bind(this);
    this.getBuildTrace = this.getBuildTrace.bind(this);

    this.$buildTrace = $('#build-trace');
    this.$buildRefreshAnimation = $('.js-build-refresh');
    this.$truncatedInfo = $('.js-truncated-info');
    this.$buildTraceOutput = $('.js-build-output');
    this.$topBar = $('.js-top-bar');

    // Scroll controllers
    this.$scrollTopBtn = $('.js-scroll-up');
    this.$scrollBottomBtn = $('.js-scroll-down');

    clearTimeout(Build.timeout);

    this.initSidebar();
    this.populateJobs(this.buildStage);
    this.updateStageDropdownText(this.buildStage);
    this.sidebarOnResize();

    this.$document.off('click', '.js-sidebar-build-toggle').on('click', '.js-sidebar-build-toggle', this.sidebarOnClick.bind(this));

    this.$document.off('click', '.stage-item').on('click', '.stage-item', this.updateDropdown);

    // add event listeners to the scroll buttons
    this.$scrollTopBtn.off('click').on('click', this.scrollToTop.bind(this));

    this.$scrollBottomBtn.off('click').on('click', this.scrollToBottom.bind(this));

    this.scrollThrottled = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.throttle(this.toggleScroll.bind(this), 100);

    $(window).off('scroll').on('scroll', function () {
      var contentHeight = _this.$buildTraceOutput.height();
      if (contentHeight > _this.windowSize) {
        // means the user did not scroll, the content was updated.
        _this.windowSize = contentHeight;
      } else {
        // User scrolled
        _this.hasBeenScrolled = true;
        _this.toggleScrollAnimation(false);
      }

      _this.scrollThrottled();
    });

    $(window).off('resize.build').on('resize.build', __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.throttle(this.sidebarOnResize.bind(this), 100));

    this.updateArtifactRemoveDate();
    this.initAffixTopArea();

    this.getBuildTrace();
  }

  Build.prototype.initAffixTopArea = function () {
    /**
      If the browser does not support position sticky, it returns the position as static.
      If the browser does support sticky, then we allow the browser to handle it, if not
      then we default back to Bootstraps affix
    **/
    if (this.$topBar.css('position') !== 'static') return;

    var offsetTop = this.$buildTrace.offset().top;

    this.$topBar.affix({
      offset: {
        top: offsetTop
      }
    });
  };

  Build.prototype.canScroll = function () {
    return $(document).height() > $(window).height();
  };

  Build.prototype.toggleScroll = function () {
    var currentPosition = $(document).scrollTop();
    var scrollHeight = $(document).height();

    var windowHeight = $(window).height();
    if (this.canScroll()) {
      if (currentPosition > 0 && scrollHeight - currentPosition !== windowHeight) {
        // User is in the middle of the log

        this.toggleDisableButton(this.$scrollTopBtn, false);
        this.toggleDisableButton(this.$scrollBottomBtn, false);
      } else if (currentPosition === 0) {
        // User is at Top of Build Log

        this.toggleDisableButton(this.$scrollTopBtn, true);
        this.toggleDisableButton(this.$scrollBottomBtn, false);
      } else if (scrollHeight - currentPosition === windowHeight) {
        // User is at the bottom of the build log.

        this.toggleDisableButton(this.$scrollTopBtn, false);
        this.toggleDisableButton(this.$scrollBottomBtn, true);
      }
    } else {
      this.toggleDisableButton(this.$scrollTopBtn, true);
      this.toggleDisableButton(this.$scrollBottomBtn, true);
    }
  };

  Build.prototype.scrollDown = function () {
    $(document).scrollTop($(document).height());
  };

  Build.prototype.scrollToBottom = function () {
    this.scrollDown();
    this.hasBeenScrolled = true;
    this.toggleScroll();
  };

  Build.prototype.scrollToTop = function () {
    $(document).scrollTop(0);
    this.hasBeenScrolled = true;
    this.toggleScroll();
  };

  Build.prototype.toggleDisableButton = function ($button, disable) {
    if (disable && $button.prop('disabled')) return;
    $button.prop('disabled', disable);
  };

  Build.prototype.toggleScrollAnimation = function (toggle) {
    this.$scrollBottomBtn.toggleClass('animate', toggle);
  };

  Build.prototype.initSidebar = function () {
    this.$sidebar = $('.js-build-sidebar');
  };

  Build.prototype.getBuildTrace = function () {
    var _this2 = this;

    return $.ajax({
      url: this.pageUrl + '/trace.json',
      data: { state: this.state }
    }).done(function (log) {
      Object(__WEBPACK_IMPORTED_MODULE_3__lib_utils_common_utils__["y" /* setCiStatusFavicon */])(_this2.pageUrl + '/status.json');

      if (log.state) {
        _this2.state = log.state;
      }

      _this2.windowSize = _this2.$buildTraceOutput.height();

      if (log.append) {
        _this2.$buildTraceOutput.append(log.html);
        _this2.logBytes += log.size;
      } else {
        _this2.$buildTraceOutput.html(log.html);
        _this2.logBytes = log.size;
      }

      // if the incremental sum of logBytes we received is less than the total
      // we need to show a message warning the user about that.
      if (_this2.logBytes < log.total) {
        // size is in bytes, we need to calculate KiB
        var size = Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_number_utils__["a" /* bytesToKiB */])(_this2.logBytes);
        $('.js-truncated-info-size').html('' + size);
        _this2.$truncatedInfo.removeClass('hidden');
      } else {
        _this2.$truncatedInfo.addClass('hidden');
      }

      if (!log.complete) {
        if (!_this2.hasBeenScrolled) {
          _this2.toggleScrollAnimation(true);
        } else {
          _this2.toggleScrollAnimation(false);
        }

        Build.timeout = setTimeout(function () {
          _this2.getBuildTrace();
        }, 4000);
      } else {
        _this2.$buildRefreshAnimation.remove();
        _this2.toggleScrollAnimation(false);
      }

      if (log.status !== _this2.buildStatus) {
        gl.utils.visitUrl(_this2.pageUrl);
      }
    }).fail(function () {
      _this2.$buildRefreshAnimation.remove();
    }).then(function () {
      if (!_this2.hasBeenScrolled) {
        _this2.scrollDown();
      }
    }).then(function () {
      return _this2.toggleScroll();
    });
  };

  Build.prototype.shouldHideSidebarForViewport = function () {
    var bootstrapBreakpoint = __WEBPACK_IMPORTED_MODULE_1__breakpoints__["a" /* default */].getBreakpointSize();
    return bootstrapBreakpoint === 'xs' || bootstrapBreakpoint === 'sm';
  };

  Build.prototype.toggleSidebar = function (shouldHide) {
    var shouldShow = typeof shouldHide === 'boolean' ? !shouldHide : undefined;
    var $toggleButton = $('.js-sidebar-build-toggle-header');

    this.$sidebar.toggleClass('right-sidebar-expanded', shouldShow).toggleClass('right-sidebar-collapsed', shouldHide);

    this.$topBar.toggleClass('sidebar-expanded', shouldShow).toggleClass('sidebar-collapsed', shouldHide);

    if (this.$sidebar.hasClass('right-sidebar-expanded')) {
      $toggleButton.addClass('hidden');
    } else {
      $toggleButton.removeClass('hidden');
    }
  };

  Build.prototype.sidebarOnResize = function () {
    this.toggleSidebar(this.shouldHideSidebarForViewport());
  };

  Build.prototype.sidebarOnClick = function () {
    if (this.shouldHideSidebarForViewport()) this.toggleSidebar();
  };

  Build.prototype.updateArtifactRemoveDate = function () {
    var $date = $('.js-artifacts-remove');
    if ($date.length) {
      var date = $date.text();
      return $date.text(gl.utils.timeFor(new Date(date.replace(/([0-9]+)-([0-9]+)-([0-9]+)/g, '$1/$2/$3')), ' '));
    }
  };

  Build.prototype.populateJobs = function (stage) {
    $('.build-job').hide();
    $('.build-job[data-stage="' + stage + '"]').show();
  };

  Build.prototype.updateStageDropdownText = function (stage) {
    $('.stage-selection').text(stage);
  };

  Build.prototype.updateDropdown = function (e) {
    e.preventDefault();
    var stage = e.currentTarget.text;
    this.updateStageDropdownText(stage);
    this.populateJobs(stage);
  };

  return Build;
}();
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./build_artifacts.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_url_utility__ = __webpack_require__("./lib/utils/url_utility.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
/* eslint-disable func-names, space-before-function-paren, wrap-iife, prefer-arrow-callback, no-unused-vars, no-return-assign, max-len */



window.BuildArtifacts = function () {
  function BuildArtifacts() {
    this.disablePropagation();
    this.setupEntryClick();
    this.setupTooltips();
  }

  BuildArtifacts.prototype.disablePropagation = function () {
    $('.top-block').on('click', '.download', function (e) {
      return e.stopPropagation();
    });
    return $('.tree-holder').on('click', 'tr[data-link] a', function (e) {
      return e.stopImmediatePropagation();
    });
  };

  BuildArtifacts.prototype.setupEntryClick = function () {
    return $('.tree-holder').on('click', 'tr[data-link]', function (e) {
      Object(__WEBPACK_IMPORTED_MODULE_0__lib_utils_url_utility__["a" /* visitUrl */])(this.dataset.link, Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils_common_utils__["d" /* convertPermissionToBoolean */])(this.dataset.externalLink));
    });
  };

  BuildArtifacts.prototype.setupTooltips = function () {
    $('.js-artifact-tree-tooltip').tooltip({
      placement: 'bottom',
      // Stop the tooltip from hiding when we stop hovering the element directly
      // We handle all the showing/hiding below
      trigger: 'manual'
    });

    // We want the tooltip to show if you hover anywhere on the row
    // But be placed below and in the middle of the file name
    $('.js-artifact-tree-row').on('mouseenter', function (e) {
      $(e.currentTarget).find('.js-artifact-tree-tooltip').tooltip('show');
    }).on('mouseleave', function (e) {
      $(e.currentTarget).find('.js-artifact-tree-tooltip').tooltip('hide');
    });
  };

  return BuildArtifacts;
}();
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./build_variables.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, prefer-arrow-callback, space-before-function-paren */

$(function () {
  $('.reveal-variables').off('click').on('click', function () {
    $('.js-build-variables').toggle();
    $(this).hide();
  });
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./ci_lint_editor.js":
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

window.gl = window.gl || {};

var CILintEditor = function CILintEditor() {
  var _this = this;

  _classCallCheck(this, CILintEditor);

  this.editor = window.ace.edit('ci-editor');
  this.textarea = document.querySelector('#content');

  this.editor.getSession().setMode('ace/mode/yaml');
  this.editor.on('input', function () {
    var content = _this.editor.getSession().getValue();
    _this.textarea.value = content;
  });
};

gl.CILintEditor = CILintEditor;

/***/ }),

/***/ "./commit/image_file.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vendor_jquery_waitforimages__ = __webpack_require__("../../../vendor/assets/javascripts/jquery.waitforimages.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vendor_jquery_waitforimages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vendor_jquery_waitforimages__);
/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, no-use-before-define, prefer-arrow-callback, no-else-return, consistent-return, prefer-template, quotes, one-var, one-var-declaration-per-line, no-unused-vars, no-return-assign, comma-dangle, quote-props, no-unused-expressions, no-sequences, object-shorthand, max-len */


(function () {
  gl.ImageFile = function () {
    var prepareFrames;

    // Width where images must fits in, for 2-up this gets divided by 2
    ImageFile.availWidth = 900;

    ImageFile.viewModes = ['two-up', 'swipe'];

    function ImageFile(file) {
      this.file = file;
      this.requestImageInfo($('.two-up.view .frame.deleted img', this.file), function (_this) {
        return function (deletedWidth, deletedHeight) {
          return _this.requestImageInfo($('.two-up.view .frame.added img', _this.file), function (width, height) {
            _this.initViewModes();

            // Load two-up view after images are loaded
            // so that we can display the correct width and height information
            var $images = $('.two-up.view img', _this.file);

            $images.waitForImages(function () {
              _this.initView('two-up');
            });
          });
        };
      }(this));
    }

    ImageFile.prototype.initViewModes = function () {
      var viewMode;
      viewMode = ImageFile.viewModes[0];
      $('.view-modes', this.file).removeClass('hide');
      $('.view-modes-menu', this.file).on('click', 'li', function (_this) {
        return function (event) {
          if (!$(event.currentTarget).hasClass('active')) {
            return _this.activateViewMode(event.currentTarget.className);
          }
        };
      }(this));
      return this.activateViewMode(viewMode);
    };

    ImageFile.prototype.activateViewMode = function (viewMode) {
      $('.view-modes-menu li', this.file).removeClass('active').filter("." + viewMode).addClass('active');
      return $(".view:visible:not(." + viewMode + ")", this.file).fadeOut(200, function (_this) {
        return function () {
          $(".view." + viewMode, _this.file).fadeIn(200);
          return _this.initView(viewMode);
        };
      }(this));
    };

    ImageFile.prototype.initView = function (viewMode) {
      return this.views[viewMode].call(this);
    };

    ImageFile.prototype.initDraggable = function ($el, padding, callback) {
      var dragging = false;
      var $body = $('body');
      var $offsetEl = $el.parent();

      $el.off('mousedown').on('mousedown', function () {
        dragging = true;
        $body.css('user-select', 'none');
      });

      $body.off('mouseup').off('mousemove').on('mouseup', function () {
        dragging = false;
        $body.css('user-select', '');
      }).on('mousemove', function (e) {
        var left;
        if (!dragging) return;

        left = e.pageX - ($offsetEl.offset().left + padding);

        callback(e, left);
      });
    };

    prepareFrames = function prepareFrames(view) {
      var maxHeight, maxWidth;
      maxWidth = 0;
      maxHeight = 0;
      $('.frame', view).each(function (_this) {
        return function (index, frame) {
          var height, width;
          width = $(frame).width();
          height = $(frame).height();
          maxWidth = width > maxWidth ? width : maxWidth;
          return maxHeight = height > maxHeight ? height : maxHeight;
        };
      }(this)).css({
        width: maxWidth,
        height: maxHeight
      });
      return [maxWidth, maxHeight];
    };

    ImageFile.prototype.views = {
      'two-up': function twoUp() {
        return $('.two-up.view .wrap', this.file).each(function (_this) {
          return function (index, wrap) {
            $('img', wrap).each(function () {
              var currentWidth;
              currentWidth = $(this).width();
              if (currentWidth > ImageFile.availWidth / 2) {
                return $(this).width(ImageFile.availWidth / 2);
              }
            });
            return _this.requestImageInfo($('img', wrap), function (width, height) {
              $('.image-info .meta-width', wrap).text(width + "px");
              $('.image-info .meta-height', wrap).text(height + "px");
              return $('.image-info', wrap).removeClass('hide');
            });
          };
        }(this));
      },
      'swipe': function swipe() {
        var maxHeight, maxWidth;
        maxWidth = 0;
        maxHeight = 0;
        return $('.swipe.view', this.file).each(function (_this) {
          return function (index, view) {
            var $swipeWrap, $swipeBar, $swipeFrame, wrapPadding, ref;
            ref = prepareFrames(view), maxWidth = ref[0], maxHeight = ref[1];
            $swipeFrame = $('.swipe-frame', view);
            $swipeWrap = $('.swipe-wrap', view);
            $swipeBar = $('.swipe-bar', view);

            $swipeFrame.css({
              width: maxWidth + 16,
              height: maxHeight + 28
            });
            $swipeWrap.css({
              width: maxWidth + 1,
              height: maxHeight + 2
            });
            // Set swipeBar left position to match image frame
            $swipeBar.css({
              left: 1
            });

            wrapPadding = parseInt($swipeWrap.css('right').replace('px', ''), 10);

            _this.initDraggable($swipeBar, wrapPadding, function (e, left) {
              if (left > 0 && left < $swipeFrame.width() - wrapPadding * 2) {
                $swipeWrap.width(maxWidth + 1 - left);
                $swipeBar.css('left', left);
              }
            });
          };
        }(this));
      },
      'onion-skin': function onionSkin() {
        var dragTrackWidth, maxHeight, maxWidth;
        maxWidth = 0;
        maxHeight = 0;
        dragTrackWidth = $('.drag-track', this.file).width() - $('.dragger', this.file).width();
        return $('.onion-skin.view', this.file).each(function (_this) {
          return function (index, view) {
            var $frame,
                $track,
                $dragger,
                $frameAdded,
                framePadding,
                ref,
                dragging = false;
            ref = prepareFrames(view), maxWidth = ref[0], maxHeight = ref[1];
            $frame = $('.onion-skin-frame', view);
            $frameAdded = $('.frame.added', view);
            $track = $('.drag-track', view);
            $dragger = $('.dragger', $track);

            $frame.css({
              width: maxWidth + 16,
              height: maxHeight + 28
            });
            $('.swipe-wrap', view).css({
              width: maxWidth + 1,
              height: maxHeight + 2
            });
            $dragger.css({
              left: dragTrackWidth
            });

            framePadding = parseInt($frameAdded.css('right').replace('px', ''), 10);

            _this.initDraggable($dragger, framePadding, function (e, left) {
              var opacity = left / dragTrackWidth;

              if (opacity >= 0 && opacity <= 1) {
                $dragger.css('left', left);
                $frameAdded.css('opacity', opacity);
              }
            });
          };
        }(this));
      }
    };

    ImageFile.prototype.requestImageInfo = function (img, callback) {
      var domImg;
      domImg = img.get(0);
      if (domImg) {
        if (domImg.complete) {
          return callback.call(this, domImg.naturalWidth, domImg.naturalHeight);
        } else {
          return img.on('load', function (_this) {
            return function () {
              return callback.call(_this, domImg.naturalWidth, domImg.naturalHeight);
            };
          }(this));
        }
      }
    };

    return ImageFile;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./commits.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, wrap-iife, consistent-return,
  no-return-assign, no-param-reassign, one-var-declaration-per-line, no-unused-vars,
  prefer-template, object-shorthand, prefer-arrow-callback */
/* global Pager */

/* harmony default export */ __webpack_exports__["a"] = ((function () {
  var CommitsList = {};

  CommitsList.timer = null;

  CommitsList.init = function (limit) {
    this.$contentList = $('.content_list');

    $('body').on('click', '.day-commits-table li.commit', function (e) {
      if (e.target.nodeName !== 'A') {
        location.href = $(this).attr('url');
        e.stopPropagation();
        return false;
      }
    });

    Pager.init(parseInt(limit, 10), false, false, this.processCommits);

    this.content = $('#commits-list');
    this.searchField = $('#commits-search');
    this.lastSearch = this.searchField.val();
    return this.initSearch();
  };

  CommitsList.initSearch = function () {
    this.timer = null;
    return this.searchField.keyup(function (_this) {
      return function () {
        clearTimeout(_this.timer);
        return _this.timer = setTimeout(_this.filterResults, 500);
      };
    }(this));
  };

  CommitsList.filterResults = function () {
    var form = $('.commits-search-form');
    var search = CommitsList.searchField.val();
    if (search === CommitsList.lastSearch) return;
    var commitsUrl = form.attr('action') + '?' + form.serialize();
    CommitsList.content.fadeTo('fast', 0.5);
    return $.ajax({
      type: 'GET',
      url: form.attr('action'),
      data: form.serialize(),
      complete: function complete() {
        return CommitsList.content.fadeTo('fast', 1.0);
      },
      success: function success(data) {
        CommitsList.lastSearch = search;
        CommitsList.content.html(data.html);
        return history.replaceState({
          page: commitsUrl
        }, document.title, commitsUrl);
      },
      error: function error() {
        CommitsList.lastSearch = null;
      },
      dataType: 'json'
    });
  };

  // Prepare loaded data.
  CommitsList.processCommits = function (data) {
    var processedData = data;
    var $processedData = $(processedData);
    var $commitsHeadersLast = CommitsList.$contentList.find('li.js-commit-header').last();
    var lastShownDay = $commitsHeadersLast.data('day');
    var $loadedCommitsHeadersFirst = $processedData.filter('li.js-commit-header').first();
    var loadedShownDayFirst = $loadedCommitsHeadersFirst.data('day');
    var commitsCount = void 0;

    // If commits headers show the same date,
    // remove the last header and change the previous one.
    if (lastShownDay === loadedShownDayFirst) {
      // Last shown commits count under the last commits header.
      commitsCount = $commitsHeadersLast.nextUntil('li.js-commit-header').find('li.commit').length;

      // Remove duplicate of commits header.
      processedData = $processedData.not('li.js-commit-header[data-day=\'' + loadedShownDayFirst + '\']');

      // Update commits count in the previous commits header.
      commitsCount += Number($(processedData).nextUntil('li.js-commit-header').first().find('li.commit').length);
      $commitsHeadersLast.find('span.commits-count').text(commitsCount + ' ' + gl.text.pluralize('commit', commitsCount));
    }

    gl.utils.localTimeAgo($processedData.find('.js-timeago'));

    return processedData;
  };

  return CommitsList;
})());
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./compare.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife, quotes, no-var, object-shorthand, consistent-return, no-unused-vars, comma-dangle, vars-on-top, prefer-template, max-len */

window.Compare = function () {
  function Compare(opts) {
    this.opts = opts;
    this.source_loading = $(".js-source-loading");
    this.target_loading = $(".js-target-loading");
    $('.js-compare-dropdown').each(function (_this) {
      return function (i, dropdown) {
        var $dropdown;
        $dropdown = $(dropdown);
        return $dropdown.glDropdown({
          selectable: true,
          fieldName: $dropdown.data('field-name'),
          filterable: true,
          id: function id(obj, $el) {
            return $el.data('id');
          },
          toggleLabel: function toggleLabel(obj, $el) {
            return $el.text().trim();
          },
          clicked: function clicked(e, el) {
            if ($dropdown.is('.js-target-branch')) {
              return _this.getTargetHtml();
            } else if ($dropdown.is('.js-source-branch')) {
              return _this.getSourceHtml();
            } else if ($dropdown.is('.js-target-project')) {
              return _this.getTargetProject();
            }
          }
        });
      };
    }(this));
    this.initialState();
  }

  Compare.prototype.initialState = function () {
    this.getSourceHtml();
    return this.getTargetHtml();
  };

  Compare.prototype.getTargetProject = function () {
    return $.ajax({
      url: this.opts.targetProjectUrl,
      data: {
        target_project_id: $("input[name='merge_request[target_project_id]']").val()
      },
      beforeSend: function beforeSend() {
        return $('.mr_target_commit').empty();
      },
      success: function success(html) {
        return $('.js-target-branch-dropdown .dropdown-content').html(html);
      }
    });
  };

  Compare.prototype.getSourceHtml = function () {
    return this.sendAjax(this.opts.sourceBranchUrl, this.source_loading, '.mr_source_commit', {
      ref: $("input[name='merge_request[source_branch]']").val()
    });
  };

  Compare.prototype.getTargetHtml = function () {
    return this.sendAjax(this.opts.targetBranchUrl, this.target_loading, '.mr_target_commit', {
      target_project_id: $("input[name='merge_request[target_project_id]']").val(),
      ref: $("input[name='merge_request[target_branch]']").val()
    });
  };

  Compare.prototype.sendAjax = function (url, loading, target, data) {
    var $target;
    $target = $(target);
    return $.ajax({
      url: url,
      data: data,
      beforeSend: function beforeSend() {
        loading.show();
        return $target.empty();
      },
      success: function success(html) {
        loading.hide();
        $target.html(html);
        var className = '.' + $target[0].className.replace(' ', '.');
        gl.utils.localTimeAgo($('.js-timeago', className));
      }
    });
  };

  return Compare;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./compare_autocomplete.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, one-var, no-var, one-var-declaration-per-line, object-shorthand, comma-dangle, prefer-arrow-callback, no-else-return, newline-per-chained-call, wrap-iife, max-len */

window.CompareAutocomplete = function () {
  function CompareAutocomplete() {
    this.initDropdown();
  }

  CompareAutocomplete.prototype.initDropdown = function () {
    return $('.js-compare-dropdown').each(function () {
      var $dropdown, selected;
      $dropdown = $(this);
      selected = $dropdown.data('selected');
      var $dropdownContainer = $dropdown.closest('.dropdown');
      var $fieldInput = $('input[name="' + $dropdown.data('field-name') + '"]', $dropdownContainer);
      var $filterInput = $('input[type="search"]', $dropdownContainer);
      $dropdown.glDropdown({
        data: function data(term, callback) {
          return $.ajax({
            url: $dropdown.data('refs-url'),
            data: {
              ref: $dropdown.data('ref'),
              search: term
            }
          }).done(function (refs) {
            return callback(refs);
          });
        },
        selectable: true,
        filterable: true,
        filterRemote: true,
        fieldName: $dropdown.data('field-name'),
        filterInput: 'input[type="search"]',
        renderRow: function renderRow(ref) {
          var link;
          if (ref.header != null) {
            return $('<li />').addClass('dropdown-header').text(ref.header);
          } else {
            link = $('<a />').attr('href', '#').addClass(ref === selected ? 'is-active' : '').text(ref).attr('data-ref', escape(ref));
            return $('<li />').append(link);
          }
        },
        id: function id(obj, $el) {
          return $el.attr('data-ref');
        },
        toggleLabel: function toggleLabel(obj, $el) {
          return $el.text().trim();
        }
      });
      $filterInput.on('keyup', function (e) {
        var keyCode = e.keyCode || e.which;
        if (keyCode !== 13) return;
        var text = $filterInput.val();
        $fieldInput.val(text);
        $('.dropdown-toggle-text', $dropdown).text(text);
        $dropdownContainer.removeClass('open');
      });

      $dropdownContainer.on('click', '.dropdown-content a', function (e) {
        $dropdown.prop('title', e.target.text.replace(/_+?/g, '-'));
        if ($dropdown.hasClass('has-tooltip')) {
          $dropdown.tooltip('fixTitle');
        }
      });
    });
  };

  return CompareAutocomplete;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./confirm_danger_modal.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
/* eslint-disable func-names, space-before-function-paren, wrap-iife, one-var, no-var, camelcase, one-var-declaration-per-line, no-else-return, max-len */


window.ConfirmDangerModal = function () {
  function ConfirmDangerModal(form, text, arg) {
    var project_path, submit, warningMessage;
    warningMessage = (arg != null ? arg : {}).warningMessage;
    this.form = form;
    $('.js-confirm-text').html(text || '');
    if (warningMessage) {
      $('.js-warning-text').html(warningMessage);
    }
    $('.js-confirm-danger-input').val('');
    $('#modal-confirm-danger').modal('show');
    project_path = $('.js-confirm-danger-match').text();
    submit = $('.js-confirm-danger-submit');
    submit.disable();
    $('.js-confirm-danger-input').off('input');
    $('.js-confirm-danger-input').on('input', function () {
      if (Object(__WEBPACK_IMPORTED_MODULE_0__lib_utils_common_utils__["w" /* rstrip */])($(this).val()) === project_path) {
        return submit.enable();
      } else {
        return submit.disable();
      }
    });
    $('.js-confirm-danger-submit').off('click');
    $('.js-confirm-danger-submit').on('click', function (_this) {
      return function () {
        return _this.form.submit();
      };
    }(this));
  }

  return ConfirmDangerModal;
}();
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./copy_as_gfm.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lazy_loader__ = __webpack_require__("./lazy_loader.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this, object-shorthand, no-unused-vars, no-use-before-define, no-new, max-len, no-restricted-syntax, guard-for-in, no-continue */




var gfmRules = {
  // The filters referenced in lib/banzai/pipeline/gfm_pipeline.rb convert
  // GitLab Flavored Markdown (GFM) to HTML.
  // These handlers consequently convert that same HTML to GFM to be copied to the clipboard.
  // Every filter in lib/banzai/pipeline/gfm_pipeline.rb that generates HTML
  // from GFM should have a handler here, in reverse order.
  // The GFM-to-HTML-to-GFM cycle is tested in spec/features/copy_as_gfm_spec.rb.
  InlineDiffFilter: {
    'span.idiff.addition': function spanIdiffAddition(el, text) {
      return '{+' + text + '+}';
    },
    'span.idiff.deletion': function spanIdiffDeletion(el, text) {
      return '{-' + text + '-}';
    }
  },
  TaskListFilter: {
    'input[type=checkbox].task-list-item-checkbox': function inputTypeCheckboxTaskListItemCheckbox(el) {
      return '[' + (el.checked ? 'x' : ' ') + ']';
    }
  },
  ReferenceFilter: {
    '.tooltip': function tooltip(el) {
      return '';
    },
    'a.gfm:not([data-link=true])': function aGfmNotDataLinkTrue(el, text) {
      return el.dataset.original || text;
    }
  },
  AutolinkFilter: {
    'a': function a(el, text) {
      // Fallback on the regular MarkdownFilter's `a` handler.
      if (text !== el.getAttribute('href')) return false;

      return text;
    }
  },
  TableOfContentsFilter: {
    'ul.section-nav': function ulSectionNav(el) {
      return '[[_TOC_]]';
    }
  },
  EmojiFilter: {
    'img.emoji': function imgEmoji(el) {
      return el.getAttribute('alt');
    },
    'gl-emoji': function glEmoji(el) {
      return ':' + el.getAttribute('data-name') + ':';
    }
  },
  ImageLinkFilter: {
    'a.no-attachment-icon': function aNoAttachmentIcon(el, text) {
      return text;
    }
  },
  ImageLazyLoadFilter: {
    'img': function img(el, text) {
      return '![' + el.getAttribute('alt') + '](' + el.getAttribute('src') + ')';
    }
  },
  VideoLinkFilter: {
    '.video-container': function videoContainer(el) {
      var videoEl = el.querySelector('video');
      if (!videoEl) return false;

      return CopyAsGFM.nodeToGFM(videoEl);
    },
    'video': function video(el) {
      return '![' + el.dataset.title + '](' + el.getAttribute('src') + ')';
    }
  },
  MathFilter: {
    'pre.code.math[data-math-style=display]': function preCodeMathDataMathStyleDisplay(el, text) {
      return '```math\n' + text.trim() + '\n```';
    },
    'code.code.math[data-math-style=inline]': function codeCodeMathDataMathStyleInline(el, text) {
      return '$`' + text + '`$';
    },
    'span.katex-display span.katex-mathml': function spanKatexDisplaySpanKatexMathml(el) {
      var mathAnnotation = el.querySelector('annotation[encoding="application/x-tex"]');
      if (!mathAnnotation) return false;

      return '```math\n' + CopyAsGFM.nodeToGFM(mathAnnotation) + '\n```';
    },
    'span.katex-mathml': function spanKatexMathml(el) {
      var mathAnnotation = el.querySelector('annotation[encoding="application/x-tex"]');
      if (!mathAnnotation) return false;

      return '$`' + CopyAsGFM.nodeToGFM(mathAnnotation) + '`$';
    },
    'span.katex-html': function spanKatexHtml(el) {
      // We don't want to include the content of this element in the copied text.
      return '';
    },
    'annotation[encoding="application/x-tex"]': function annotationEncodingApplicationXTex(el, text) {
      return text.trim();
    }
  },
  SanitizationFilter: {
    'a[name]:not([href]):empty': function aNameNotHrefEmpty(el) {
      return el.outerHTML;
    },
    'dl': function dl(el, text) {
      var lines = text.trim().split('\n');
      // Add two spaces to the front of subsequent list items lines,
      // or leave the line entirely blank.
      lines = lines.map(function (l) {
        var line = l.trim();
        if (line.length === 0) return '';

        return '  ' + line;
      });

      return '<dl>\n' + lines.join('\n') + '\n</dl>';
    },
    'sub, dt, dd, kbd, q, samp, var, ruby, rt, rp, abbr, summary, details': function subDtDdKbdQSampVarRubyRtRpAbbrSummaryDetails(el, text) {
      var tag = el.nodeName.toLowerCase();
      return '<' + tag + '>' + text + '</' + tag + '>';
    }
  },
  SyntaxHighlightFilter: {
    'pre.code.highlight': function preCodeHighlight(el, t) {
      var text = t.trimRight();

      var lang = el.getAttribute('lang');
      if (!lang || lang === 'plaintext') {
        lang = '';
      }

      // Prefixes lines with 4 spaces if the code contains triple backticks
      if (lang === '' && text.match(/^```/gm)) {
        return text.split('\n').map(function (l) {
          var line = l.trim();
          if (line.length === 0) return '';

          return '    ' + line;
        }).join('\n');
      }

      return '```' + lang + '\n' + text + '\n```';
    },
    'pre > code': function preCode(el, text) {
      // Don't wrap code blocks in ``
      return text;
    }
  },
  MarkdownFilter: {
    'br': function br(el) {
      // Two spaces at the end of a line are turned into a BR
      return '  ';
    },
    'code': function code(el, text) {
      var backtickCount = 1;
      var backtickMatch = text.match(/`+/);
      if (backtickMatch) {
        backtickCount = backtickMatch[0].length + 1;
      }

      var backticks = Array(backtickCount + 1).join('`');
      var spaceOrNoSpace = backtickCount > 1 ? ' ' : '';

      return backticks + spaceOrNoSpace + text.trim() + spaceOrNoSpace + backticks;
    },
    'blockquote': function blockquote(el, text) {
      return text.trim().split('\n').map(function (s) {
        return ('> ' + s).trim();
      }).join('\n');
    },
    'img': function img(el) {
      var imageSrc = el.src;
      var imageUrl = imageSrc && imageSrc !== __WEBPACK_IMPORTED_MODULE_2__lazy_loader__["b" /* placeholderImage */] ? imageSrc : el.dataset.src || '';
      return '![' + el.getAttribute('alt') + '](' + imageUrl + ')';
    },
    'a.anchor': function aAnchor(el, text) {
      // Don't render a Markdown link for the anchor link inside a heading
      return text;
    },
    'a': function a(el, text) {
      return '[' + text + '](' + el.getAttribute('href') + ')';
    },
    'li': function li(el, text) {
      var lines = text.trim().split('\n');
      var firstLine = '- ' + lines.shift();
      // Add four spaces to the front of subsequent list items lines,
      // or leave the line entirely blank.
      var nextLines = lines.map(function (s) {
        if (s.trim().length === 0) return '';

        return '    ' + s;
      });

      return firstLine + '\n' + nextLines.join('\n');
    },
    'ul': function ul(el, text) {
      return text;
    },
    'ol': function ol(el, text) {
      // LIs get a `- ` prefix by default, which we replace by `1. ` for ordered lists.
      return text.replace(/^- /mg, '1. ');
    },
    'h1': function h1(el, text) {
      return '# ' + text.trim();
    },
    'h2': function h2(el, text) {
      return '## ' + text.trim();
    },
    'h3': function h3(el, text) {
      return '### ' + text.trim();
    },
    'h4': function h4(el, text) {
      return '#### ' + text.trim();
    },
    'h5': function h5(el, text) {
      return '##### ' + text.trim();
    },
    'h6': function h6(el, text) {
      return '###### ' + text.trim();
    },
    'strong': function strong(el, text) {
      return '**' + text + '**';
    },
    'em': function em(el, text) {
      return '_' + text + '_';
    },
    'del': function del(el, text) {
      return '~~' + text + '~~';
    },
    'sup': function sup(el, text) {
      return '^' + text;
    },
    'hr': function hr(el) {
      return '-----';
    },
    'table': function table(el) {
      var theadEl = el.querySelector('thead');
      var tbodyEl = el.querySelector('tbody');
      if (!theadEl || !tbodyEl) return false;

      var theadText = CopyAsGFM.nodeToGFM(theadEl);
      var tbodyText = CopyAsGFM.nodeToGFM(tbodyEl);

      return [theadText, tbodyText].join('\n');
    },
    'thead': function thead(el, text) {
      var cells = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.map(el.querySelectorAll('th'), function (cell) {
        var chars = CopyAsGFM.nodeToGFM(cell).length + 2;

        var before = '';
        var after = '';
        switch (cell.style.textAlign) {
          case 'center':
            before = ':';
            after = ':';
            chars -= 2;
            break;
          case 'right':
            after = ':';
            chars -= 1;
            break;
          default:
            break;
        }

        chars = Math.max(chars, 3);

        var middle = Array(chars + 1).join('-');

        return before + middle + after;
      });

      var separatorRow = '|' + cells.join('|') + '|';

      return [text, separatorRow].join('\n');
    },
    'tr': function tr(el) {
      var cellEls = el.querySelectorAll('td, th');
      if (cellEls.length === 0) return false;

      var cells = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.map(cellEls, function (cell) {
        return CopyAsGFM.nodeToGFM(cell);
      });
      return '| ' + cells.join(' | ') + ' |';
    }
  }
};

var CopyAsGFM = function () {
  function CopyAsGFM() {
    _classCallCheck(this, CopyAsGFM);

    $(document).on('copy', '.md, .wiki', function (e) {
      CopyAsGFM.copyAsGFM(e, CopyAsGFM.transformGFMSelection);
    });
    $(document).on('copy', 'pre.code.highlight, .diff-content .line_content', function (e) {
      CopyAsGFM.copyAsGFM(e, CopyAsGFM.transformCodeSelection);
    });
    $(document).on('paste', '.js-gfm-input', CopyAsGFM.pasteGFM);
  }

  _createClass(CopyAsGFM, null, [{
    key: 'copyAsGFM',
    value: function copyAsGFM(e, transformer) {
      var clipboardData = e.originalEvent.clipboardData;
      if (!clipboardData) return;

      var documentFragment = Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils_common_utils__["i" /* getSelectedFragment */])();
      if (!documentFragment) return;

      var el = transformer(documentFragment.cloneNode(true), e.currentTarget);
      if (!el) return;

      e.preventDefault();
      e.stopPropagation();

      clipboardData.setData('text/plain', el.textContent);
      clipboardData.setData('text/x-gfm', this.nodeToGFM(el));
    }
  }, {
    key: 'pasteGFM',
    value: function pasteGFM(e) {
      var clipboardData = e.originalEvent.clipboardData;
      if (!clipboardData) return;

      var text = clipboardData.getData('text/plain');
      var gfm = clipboardData.getData('text/x-gfm');
      if (!gfm) return;

      e.preventDefault();

      window.gl.utils.insertText(e.target, function (textBefore, textAfter) {
        // If the text before the cursor contains an odd number of backticks,
        // we are either inside an inline code span that starts with 1 backtick
        // or a code block that starts with 3 backticks.
        // This logic still holds when there are one or more _closed_ code spans
        // or blocks that will have 2 or 6 backticks.
        // This will break down when the actual code block contains an uneven
        // number of backticks, but this is a rare edge case.
        var backtickMatch = textBefore.match(/`/g);
        var insideCodeBlock = backtickMatch && backtickMatch.length % 2 === 1;

        if (insideCodeBlock) {
          return text;
        }

        return gfm;
      });
    }
  }, {
    key: 'transformGFMSelection',
    value: function transformGFMSelection(documentFragment) {
      var gfmElements = documentFragment.querySelectorAll('.md, .wiki');
      switch (gfmElements.length) {
        case 0:
          {
            return documentFragment;
          }
        case 1:
          {
            return gfmElements[0];
          }
        default:
          {
            var allGfmElement = document.createElement('div');

            for (var i = 0; i < gfmElements.length; i += 1) {
              var gfmElement = gfmElements[i];
              allGfmElement.appendChild(gfmElement);
              allGfmElement.appendChild(document.createTextNode('\n\n'));
            }

            return allGfmElement;
          }
      }
    }
  }, {
    key: 'transformCodeSelection',
    value: function transformCodeSelection(documentFragment, target) {
      var lineSelector = '.line';

      if (target) {
        var lineClass = ['left-side', 'right-side'].filter(function (name) {
          return target.classList.contains(name);
        })[0];
        if (lineClass) {
          lineSelector = '.line_content.' + lineClass + ' ' + lineSelector;
        }
      }

      var lineElements = documentFragment.querySelectorAll(lineSelector);

      var codeElement = void 0;
      if (lineElements.length > 1) {
        codeElement = document.createElement('pre');
        codeElement.className = 'code highlight';

        var lang = lineElements[0].getAttribute('lang');
        if (lang) {
          codeElement.setAttribute('lang', lang);
        }
      } else {
        codeElement = document.createElement('code');
      }

      if (lineElements.length > 0) {
        for (var i = 0; i < lineElements.length; i += 1) {
          var lineElement = lineElements[i];
          codeElement.appendChild(lineElement);
          codeElement.appendChild(document.createTextNode('\n'));
        }
      } else {
        codeElement.appendChild(documentFragment);
      }

      return codeElement;
    }
  }, {
    key: 'nodeToGFM',
    value: function nodeToGFM(node) {
      var respectWhitespaceParam = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (node.nodeType === Node.COMMENT_NODE) {
        return '';
      }

      if (node.nodeType === Node.TEXT_NODE) {
        return node.textContent;
      }

      var respectWhitespace = respectWhitespaceParam || node.nodeName === 'PRE' || node.nodeName === 'CODE';

      var text = this.innerGFM(node, respectWhitespace);

      if (node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
        return text;
      }

      for (var filter in gfmRules) {
        var rules = gfmRules[filter];

        for (var selector in rules) {
          var func = rules[selector];

          if (!Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils_common_utils__["r" /* nodeMatchesSelector */])(node, selector)) continue;

          var result = void 0;
          if (func.length === 2) {
            // if `func` takes 2 arguments, it depends on text.
            // if there is no text, we don't need to generate GFM for this node.
            if (text.length === 0) continue;

            result = func(node, text);
          } else {
            result = func(node);
          }

          if (result === false) continue;

          return result;
        }
      }

      return text;
    }
  }, {
    key: 'innerGFM',
    value: function innerGFM(parentNode) {
      var respectWhitespace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var nodes = parentNode.childNodes;

      var clonedParentNode = parentNode.cloneNode(true);
      var clonedNodes = Array.prototype.slice.call(clonedParentNode.childNodes, 0);

      for (var i = 0; i < nodes.length; i += 1) {
        var node = nodes[i];
        var clonedNode = clonedNodes[i];

        var text = this.nodeToGFM(node, respectWhitespace);

        // `clonedNode.replaceWith(text)` is not yet widely supported
        clonedNode.parentNode.replaceChild(document.createTextNode(text), clonedNode);
      }

      var nodeText = clonedParentNode.innerText || clonedParentNode.textContent;

      if (!respectWhitespace) {
        nodeText = nodeText.trim();
      }

      return nodeText;
    }
  }]);

  return CopyAsGFM;
}();

window.gl = window.gl || {};
window.gl.CopyAsGFM = CopyAsGFM;

new CopyAsGFM();
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./copy_to_clipboard.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_clipboard__ = __webpack_require__("../../../node_modules/clipboard/lib/clipboard.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_clipboard__);
/* eslint-disable func-names, space-before-function-paren, one-var, no-var, one-var-declaration-per-line, prefer-template, quotes, no-unused-vars, prefer-arrow-callback, max-len */



var genericError, genericSuccess, showTooltip;

genericSuccess = function genericSuccess(e) {
  showTooltip(e.trigger, 'Copied');
  // Clear the selection and blur the trigger so it loses its border
  e.clearSelection();
  return $(e.trigger).blur();
};

// Safari doesn't support `execCommand`, so instead we inform the user to
// copy manually.
//
// See http://clipboardjs.com/#browser-support
genericError = function genericError(e) {
  var key;
  if (/Mac/i.test(navigator.userAgent)) {
    key = '&#8984;'; // Command
  } else {
    key = 'Ctrl';
  }
  return showTooltip(e.trigger, "Press " + key + "-C to copy");
};

showTooltip = function showTooltip(target, title) {
  var $target = $(target);
  var originalTitle = $target.data('original-title');

  if (!$target.data('hideTooltip')) {
    $target.attr('title', 'Copied').tooltip('fixTitle').tooltip('show').attr('title', originalTitle).tooltip('fixTitle');
  }
};

$(function () {
  var clipboard = new __WEBPACK_IMPORTED_MODULE_0_clipboard___default.a('[data-clipboard-target], [data-clipboard-text]');
  clipboard.on('success', genericSuccess);
  clipboard.on('error', genericError);

  // This a workaround around ClipboardJS limitations to allow the context-specific copy/pasting of plain text or GFM.
  // The Ruby `clipboard_button` helper sneaks a JSON hash with `text` and `gfm` keys into the `data-clipboard-text`
  // attribute that ClipboardJS reads from.
  // When ClipboardJS creates a new `textarea` (directly inside `body`, with a `readonly` attribute`), sets its value
  // to the value of this data attribute, focusses on it, and finally programmatically issues the 'Copy' command,
  // this code intercepts the copy command/event at the last minute to deconstruct this JSON hash and set the
  // `text/plain` and `text/x-gfm` copy data types to the intended values.
  $(document).on('copy', 'body > textarea[readonly]', function (e) {
    var clipboardData = e.originalEvent.clipboardData;
    if (!clipboardData) return;

    var text = e.target.value;

    var json = void 0;
    try {
      json = JSON.parse(text);
    } catch (ex) {
      return;
    }

    if (!json.text || !json.gfm) return;

    e.preventDefault();

    clipboardData.setData('text/plain', json.text);
    clipboardData.setData('text/x-gfm', json.gfm);
  });
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./create_label.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("./api.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable func-names, prefer-arrow-callback */


var CreateLabelDropdown = function () {
  function CreateLabelDropdown($el, namespacePath, projectPath) {
    _classCallCheck(this, CreateLabelDropdown);

    this.$el = $el;
    this.namespacePath = namespacePath;
    this.projectPath = projectPath;
    this.$dropdownBack = $('.dropdown-menu-back', this.$el.closest('.dropdown'));
    this.$cancelButton = $('.js-cancel-label-btn', this.$el);
    this.$newLabelField = $('#new_label_name', this.$el);
    this.$newColorField = $('#new_label_color', this.$el);
    this.$colorPreview = $('.js-dropdown-label-color-preview', this.$el);
    this.$newLabelError = $('.js-label-error', this.$el);
    this.$newLabelCreateButton = $('.js-new-label-btn', this.$el);
    this.$colorSuggestions = $('.suggest-colors-dropdown a', this.$el);

    this.$newLabelError.hide();
    this.$newLabelCreateButton.disable();

    this.cleanBinding();
    this.addBinding();
  }

  _createClass(CreateLabelDropdown, [{
    key: 'cleanBinding',
    value: function cleanBinding() {
      this.$colorSuggestions.off('click');
      this.$newLabelField.off('keyup change');
      this.$newColorField.off('keyup change');
      this.$dropdownBack.off('click');
      this.$cancelButton.off('click');
      this.$newLabelCreateButton.off('click');
    }
  }, {
    key: 'addBinding',
    value: function addBinding() {
      var self = this;

      this.$colorSuggestions.on('click', function (e) {
        var $this = $(this);
        self.addColorValue(e, $this);
      });

      this.$newLabelField.on('keyup change', this.enableLabelCreateButton.bind(this));
      this.$newColorField.on('keyup change', this.enableLabelCreateButton.bind(this));

      this.$dropdownBack.on('click', this.resetForm.bind(this));

      this.$cancelButton.on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        self.resetForm();
        self.$dropdownBack.trigger('click');
      });

      this.$newLabelCreateButton.on('click', this.saveLabel.bind(this));
    }
  }, {
    key: 'addColorValue',
    value: function addColorValue(e, $this) {
      e.preventDefault();
      e.stopPropagation();

      this.$newColorField.val($this.data('color')).trigger('change');
      this.$colorPreview.css('background-color', $this.data('color')).parent().addClass('is-active');
    }
  }, {
    key: 'enableLabelCreateButton',
    value: function enableLabelCreateButton() {
      if (this.$newLabelField.val() !== '' && this.$newColorField.val() !== '') {
        this.$newLabelError.hide();
        this.$newLabelCreateButton.enable();
      } else {
        this.$newLabelCreateButton.disable();
      }
    }
  }, {
    key: 'resetForm',
    value: function resetForm() {
      this.$newLabelField.val('').trigger('change');

      this.$newColorField.val('').trigger('change');

      this.$colorPreview.css('background-color', '').parent().removeClass('is-active');
    }
  }, {
    key: 'saveLabel',
    value: function saveLabel(e) {
      var _this = this;

      e.preventDefault();
      e.stopPropagation();

      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].newLabel(this.namespacePath, this.projectPath, {
        title: this.$newLabelField.val(),
        color: this.$newColorField.val()
      }, function (label) {
        _this.$newLabelCreateButton.enable();

        if (label.message) {
          var errors = void 0;

          if (typeof label.message === 'string') {
            errors = label.message;
          } else {
            errors = Object.keys(label.message).map(function (key) {
              return gl.text.humanize(key) + ' ' + label.message[key].join(', ');
            }).join('<br/>');
          }

          _this.$newLabelError.html(errors).show();
        } else {
          _this.$dropdownBack.trigger('click');

          $(document).trigger('created.label', label);
        }
      });
    }
  }]);

  return CreateLabelDropdown;
}();

/* harmony default export */ __webpack_exports__["a"] = (CreateLabelDropdown);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./create_merge_request_dropdown.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__droplab_drop_lab__ = __webpack_require__("./droplab/drop_lab.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__droplab_plugins_input_setter__ = __webpack_require__("./droplab/plugins/input_setter.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-new */
/* global Flash */



// Todo: Remove this when fixing issue in input_setter plugin
var InputSetter = Object.assign({}, __WEBPACK_IMPORTED_MODULE_1__droplab_plugins_input_setter__["a" /* default */]);

var CREATE_MERGE_REQUEST = 'create-mr';
var CREATE_BRANCH = 'create-branch';

var CreateMergeRequestDropdown = function () {
  function CreateMergeRequestDropdown(wrapperEl) {
    _classCallCheck(this, CreateMergeRequestDropdown);

    this.wrapperEl = wrapperEl;
    this.createMergeRequestButton = this.wrapperEl.querySelector('.js-create-merge-request');
    this.dropdownToggle = this.wrapperEl.querySelector('.js-dropdown-toggle');
    this.dropdownList = this.wrapperEl.querySelector('.dropdown-menu');
    this.availableButton = this.wrapperEl.querySelector('.available');
    this.unavailableButton = this.wrapperEl.querySelector('.unavailable');
    this.unavailableButtonArrow = this.unavailableButton.querySelector('.fa');
    this.unavailableButtonText = this.unavailableButton.querySelector('.text');

    this.createBranchPath = this.wrapperEl.dataset.createBranchPath;
    this.canCreatePath = this.wrapperEl.dataset.canCreatePath;
    this.createMrPath = this.wrapperEl.dataset.createMrPath;
    this.droplabInitialized = false;
    this.isCreatingMergeRequest = false;
    this.mergeRequestCreated = false;
    this.isCreatingBranch = false;
    this.branchCreated = false;

    this.init();
  }

  _createClass(CreateMergeRequestDropdown, [{
    key: 'init',
    value: function init() {
      this.checkAbilityToCreateBranch();
    }
  }, {
    key: 'available',
    value: function available() {
      this.availableButton.classList.remove('hide');
      this.unavailableButton.classList.add('hide');
    }
  }, {
    key: 'unavailable',
    value: function unavailable() {
      this.availableButton.classList.add('hide');
      this.unavailableButton.classList.remove('hide');
    }
  }, {
    key: 'enable',
    value: function enable() {
      this.createMergeRequestButton.classList.remove('disabled');
      this.createMergeRequestButton.removeAttribute('disabled');

      this.dropdownToggle.classList.remove('disabled');
      this.dropdownToggle.removeAttribute('disabled');
    }
  }, {
    key: 'disable',
    value: function disable() {
      this.createMergeRequestButton.classList.add('disabled');
      this.createMergeRequestButton.setAttribute('disabled', 'disabled');

      this.dropdownToggle.classList.add('disabled');
      this.dropdownToggle.setAttribute('disabled', 'disabled');
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.wrapperEl.classList.add('hide');
    }
  }, {
    key: 'setUnavailableButtonState',
    value: function setUnavailableButtonState() {
      var isLoading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (isLoading) {
        this.unavailableButtonArrow.classList.add('fa-spinner', 'fa-spin');
        this.unavailableButtonArrow.classList.remove('fa-exclamation-triangle');
        this.unavailableButtonText.textContent = 'Checking branch availability…';
      } else {
        this.unavailableButtonArrow.classList.remove('fa-spinner', 'fa-spin');
        this.unavailableButtonArrow.classList.add('fa-exclamation-triangle');
        this.unavailableButtonText.textContent = 'New branch unavailable';
      }
    }
  }, {
    key: 'checkAbilityToCreateBranch',
    value: function checkAbilityToCreateBranch() {
      var _this = this;

      return $.ajax({
        type: 'GET',
        dataType: 'json',
        url: this.canCreatePath,
        beforeSend: function beforeSend() {
          return _this.setUnavailableButtonState();
        }
      }).done(function (data) {
        _this.setUnavailableButtonState(false);

        if (data.can_create_branch) {
          _this.available();
          _this.enable();

          if (!_this.droplabInitialized) {
            _this.droplabInitialized = true;
            _this.initDroplab();
            _this.bindEvents();
          }
        } else if (data.has_related_branch) {
          _this.hide();
        }
      }).fail(function () {
        _this.unavailable();
        _this.disable();
        new Flash('Failed to check if a new branch can be created.');
      });
    }
  }, {
    key: 'initDroplab',
    value: function initDroplab() {
      this.droplab = new __WEBPACK_IMPORTED_MODULE_0__droplab_drop_lab__["a" /* default */]();

      this.droplab.init(this.dropdownToggle, this.dropdownList, [InputSetter], this.getDroplabConfig());
    }
  }, {
    key: 'getDroplabConfig',
    value: function getDroplabConfig() {
      return {
        InputSetter: [{
          input: this.createMergeRequestButton,
          valueAttribute: 'data-value',
          inputAttribute: 'data-action'
        }, {
          input: this.createMergeRequestButton,
          valueAttribute: 'data-text'
        }]
      };
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      this.createMergeRequestButton.addEventListener('click', this.onClickCreateMergeRequestButton.bind(this));
    }
  }, {
    key: 'isBusy',
    value: function isBusy() {
      return this.isCreatingMergeRequest || this.mergeRequestCreated || this.isCreatingBranch || this.branchCreated;
    }
  }, {
    key: 'onClickCreateMergeRequestButton',
    value: function onClickCreateMergeRequestButton(e) {
      var _this2 = this;

      var xhr = null;
      e.preventDefault();

      if (this.isBusy()) {
        return;
      }

      if (e.target.dataset.action === CREATE_MERGE_REQUEST) {
        xhr = this.createMergeRequest();
      } else if (e.target.dataset.action === CREATE_BRANCH) {
        xhr = this.createBranch();
      }

      xhr.fail(function () {
        _this2.isCreatingMergeRequest = false;
        _this2.isCreatingBranch = false;
      });

      xhr.always(function () {
        return _this2.enable();
      });

      this.disable();
    }
  }, {
    key: 'createMergeRequest',
    value: function createMergeRequest() {
      var _this3 = this;

      return $.ajax({
        method: 'POST',
        dataType: 'json',
        url: this.createMrPath,
        beforeSend: function beforeSend() {
          return _this3.isCreatingMergeRequest = true;
        }
      }).done(function (data) {
        _this3.mergeRequestCreated = true;
        window.location.href = data.url;
      }).fail(function () {
        return new Flash('Failed to create Merge Request. Please try again.');
      });
    }
  }, {
    key: 'createBranch',
    value: function createBranch() {
      var _this4 = this;

      return $.ajax({
        method: 'POST',
        dataType: 'json',
        url: this.createBranchPath,
        beforeSend: function beforeSend() {
          return _this4.isCreatingBranch = true;
        }
      }).done(function (data) {
        _this4.branchCreated = true;
        window.location.href = data.url;
      }).fail(function () {
        return new Flash('Failed to create a branch for this issue. Please try again.');
      });
    }
  }]);

  return CreateMergeRequestDropdown;
}();

/* harmony default export */ __webpack_exports__["a"] = (CreateMergeRequestDropdown);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./diff.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_url_utility__ = __webpack_require__("./lib/utils/url_utility.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__files_comment_button__ = __webpack_require__("./files_comment_button.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__single_file_diff__ = __webpack_require__("./single_file_diff.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__image_diff_helpers_index__ = __webpack_require__("./image_diff/helpers/index.js");
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this */






var UNFOLD_COUNT = 20;
var isBound = false;

var Diff = function () {
  function Diff() {
    _classCallCheck(this, Diff);

    var $diffFile = $('.files .diff-file');

    $diffFile.each(function (index, file) {
      if (!$.data(file, 'singleFileDiff')) {
        $.data(file, 'singleFileDiff', new __WEBPACK_IMPORTED_MODULE_2__single_file_diff__["a" /* default */](file));
      }
    });

    var tab = document.getElementById('diffs');
    if (!tab || tab && tab.dataset && tab.dataset.isLocked !== '') __WEBPACK_IMPORTED_MODULE_1__files_comment_button__["a" /* default */].init($diffFile);

    var firstFile = $('.files').first().get(0);
    var canCreateNote = firstFile && firstFile.hasAttribute('data-can-create-note');
    $diffFile.each(function (index, file) {
      return __WEBPACK_IMPORTED_MODULE_3__image_diff_helpers_index__["a" /* default */].initImageDiff(file, canCreateNote);
    });

    if (!isBound) {
      $(document).on('click', '.js-unfold', this.handleClickUnfold.bind(this)).on('click', '.diff-line-num a', this.handleClickLineNum.bind(this)).on('mousedown', 'td.line_content.parallel', this.handleParallelLineDown.bind(this));
      isBound = true;
    }

    if (gl.utils.getLocationHash()) {
      this.highlightSelectedLine();
    }

    this.openAnchoredDiff();
  }

  _createClass(Diff, [{
    key: 'handleClickUnfold',
    value: function handleClickUnfold(e) {
      var $target = $(e.target);

      var _lineNumbers = this.lineNumbers($target.parent()),
          _lineNumbers2 = _slicedToArray(_lineNumbers, 2),
          oldLineNumber = _lineNumbers2[0],
          newLineNumber = _lineNumbers2[1];

      var offset = newLineNumber - oldLineNumber;
      var bottom = $target.hasClass('js-unfold-bottom');
      var since = void 0;
      var to = void 0;
      var unfold = true;

      if (bottom) {
        var lineNumber = newLineNumber + 1;
        since = lineNumber;
        to = lineNumber + UNFOLD_COUNT;
      } else {
        var _lineNumber = newLineNumber - 1;
        since = _lineNumber - UNFOLD_COUNT;
        to = _lineNumber;

        // make sure we aren't loading more than we need
        var prevNewLine = this.lineNumbers($target.parent().prev())[1];
        if (since <= prevNewLine + 1) {
          since = prevNewLine + 1;
          unfold = false;
        }
      }

      var file = $target.parents('.diff-file');
      var link = file.data('blob-diff-path');
      var view = file.data('view');

      var params = { since: since, to: to, bottom: bottom, offset: offset, unfold: unfold, view: view };
      $.get(link, params, function (response) {
        return $target.parent().replaceWith(response);
      });
    }
  }, {
    key: 'openAnchoredDiff',
    value: function openAnchoredDiff(cb) {
      var _this = this;

      var locationHash = gl.utils.getLocationHash();
      var anchoredDiff = locationHash && locationHash.split('_')[0];

      if (!anchoredDiff) return;

      var diffTitle = $('#' + anchoredDiff);
      var diffFile = diffTitle.closest('.diff-file');
      var nothingHereBlock = $('.nothing-here-block:visible', diffFile);
      if (nothingHereBlock.length) {
        var clickTarget = $('.js-file-title, .click-to-expand', diffFile);
        diffFile.data('singleFileDiff').toggleDiff(clickTarget, function () {
          _this.highlightSelectedLine();
          if (cb) cb();
        });
      } else if (cb) {
        cb();
      }
    }
  }, {
    key: 'handleClickLineNum',
    value: function handleClickLineNum(e) {
      var hash = $(e.currentTarget).attr('href');
      e.preventDefault();
      if (window.history.pushState) {
        window.history.pushState(null, null, hash);
      } else {
        window.location.hash = hash;
      }
      this.highlightSelectedLine();
    }
  }, {
    key: 'handleParallelLineDown',
    value: function handleParallelLineDown(e) {
      var line = $(e.currentTarget);
      var table = line.closest('table');

      table.removeClass('left-side-selected right-side-selected');

      var lineClass = ['left-side', 'right-side'].filter(function (name) {
        return line.hasClass(name);
      })[0];
      if (lineClass) {
        table.addClass(lineClass + '-selected');
      }
    }
  }, {
    key: 'diffViewType',
    value: function diffViewType() {
      return $('.inline-parallel-buttons a.active').data('view-type');
    }
  }, {
    key: 'lineNumbers',
    value: function lineNumbers(line) {
      var children = line.find('.diff-line-num').toArray();
      if (children.length !== 2) {
        return [0, 0];
      }
      return children.map(function (elm) {
        return parseInt($(elm).data('linenumber'), 10) || 0;
      });
    }
  }, {
    key: 'highlightSelectedLine',
    value: function highlightSelectedLine() {
      var hash = gl.utils.getLocationHash();
      var $diffFiles = $('.diff-file');
      $diffFiles.find('.hll').removeClass('hll');

      if (hash) {
        $diffFiles.find('tr#' + hash + ':not(.match) td, td#' + hash + ', td[data-line-code="' + hash + '"]').addClass('hll');
      }
    }
  }]);

  return Diff;
}();

window.gl = window.gl || {};
window.gl.Diff = Diff;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./dispatcher.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commits__ = __webpack_require__("./commits.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__issue__ = __webpack_require__("./issue.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__behaviors_bind_in_out__ = __webpack_require__("./behaviors/bind_in_out.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__branches_branches_delete_modal__ = __webpack_require__("./branches/branches_delete_modal.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__group__ = __webpack_require__("./group.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__groups_list__ = __webpack_require__("./groups_list.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__projects_list__ = __webpack_require__("./projects_list.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__project_edit__ = __webpack_require__("./project_edit.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mini_pipeline_graph_dropdown__ = __webpack_require__("./mini_pipeline_graph_dropdown.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__blob_blob_line_permalink_updater__ = __webpack_require__("./blob/blob_line_permalink_updater.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__landing__ = __webpack_require__("./landing.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__blob_blob_fork_suggestion__ = __webpack_require__("./blob/blob_fork_suggestion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__user_callout__ = __webpack_require__("./user_callout.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shortcuts_wiki__ = __webpack_require__("./shortcuts_wiki.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pipelines__ = __webpack_require__("./pipelines.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__blob_viewer_index__ = __webpack_require__("./blob/viewer/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__geo_nodes__ = __webpack_require__("./geo_nodes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__issuable_auto_width_dropdown_select__ = __webpack_require__("./issuable/auto_width_dropdown_select.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__users_select__ = __webpack_require__("./users_select.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ref_select_dropdown__ = __webpack_require__("./ref_select_dropdown.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__gfm_auto_complete__ = __webpack_require__("./gfm_auto_complete.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__shortcuts_blob__ = __webpack_require__("./shortcuts_blob.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__signin_tabs_memoizer__ = __webpack_require__("./signin_tabs_memoizer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__star__ = __webpack_require__("./star.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__todos__ = __webpack_require__("./todos.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__tree__ = __webpack_require__("./tree.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__usage_ping__ = __webpack_require__("./usage_ping.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__username_validator__ = __webpack_require__("./username_validator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__version_check_image__ = __webpack_require__("./version_check_image.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__wikis__ = __webpack_require__("./wikis.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__zen_mode__ = __webpack_require__("./zen_mode.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__settings_panels__ = __webpack_require__("./settings_panels.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__experimental_flags__ = __webpack_require__("./experimental_flags.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__oauth_remember_me__ = __webpack_require__("./oauth_remember_me.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__performance_bar__ = __webpack_require__("./performance_bar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__init_notes__ = __webpack_require__("./init_notes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__init_legacy_filters__ = __webpack_require__("./init_legacy_filters.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__init_issuable_sidebar__ = __webpack_require__("./init_issuable_sidebar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__project_visibility__ = __webpack_require__("./project_visibility.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__gpg_badges__ = __webpack_require__("./gpg_badges.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__helpers_user_feature_helper__ = __webpack_require__("./helpers/user_feature_helper.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__init_changes_dropdown__ = __webpack_require__("./init_changes_dropdown.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__abuse_reports__ = __webpack_require__("./abuse_reports.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__lib_utils_common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__ajax_loading_spinner__ = __webpack_require__("./ajax_loading_spinner.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__approvers_select__ = __webpack_require__("./approvers_select.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__audit_logs__ = __webpack_require__("./audit_logs.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__init_geo_info_modal__ = __webpack_require__("./init_geo_info_modal.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__init_group_analytics__ = __webpack_require__("./init_group_analytics.js");
/* eslint-disable func-names, space-before-function-paren, no-var, prefer-arrow-callback, wrap-iife, no-shadow, consistent-return, one-var, one-var-declaration-per-line, camelcase, default-case, no-new, quotes, no-duplicate-case, no-case-declarations, no-fallthrough, max-len */
/* global ProjectSelect */
/* global ShortcutsNavigation */
/* global IssuableIndex */
/* global ShortcutsIssuable */
/* global Milestone */
/* global IssuableForm */
/* global LabelsSelect */
/* global MilestoneSelect */
/* global NewBranchForm */
/* global NotificationsForm */
/* global NotificationsDropdown */
/* global GroupAvatar */
/* global LineHighlighter */
/* global BuildArtifacts */
/* global GroupsSelect */
/* global Search */
/* global Admin */
/* global NamespaceSelects */
/* global NewCommitForm */
/* global NewBranchForm */
/* global Project */
/* global ProjectAvatar */
/* global MergeRequest */
/* global Compare */
/* global CompareAutocomplete */
/* global PathLocks */
/* global ProjectFindFile */
/* global ProjectNew */
/* global ProjectShow */
/* global ProjectImport */
/* global Labels */
/* global Shortcuts */
/* global ShortcutsFindFile */
/* global Sidebar */
/* global WeightSelect */
/* global AdminEmailSelect */
/* global ShortcutsWiki */















































// EE-only





(function () {
  var Dispatcher;

  Dispatcher = function () {
    function Dispatcher() {
      this.initSearch();
      this.initFieldErrors();
      this.initPageScripts();
    }

    Dispatcher.prototype.initPageScripts = function () {
      var page, path, shortcut_handler, fileBlobPermalinkUrlElement, fileBlobPermalinkUrl;
      page = $('body').attr('data-page');
      if (!page) {
        return false;
      }

      path = page.split(':');
      shortcut_handler = null;

      $('.js-gfm-input:not(.js-vue-textarea)').each(function (i, el) {
        var gfm = new __WEBPACK_IMPORTED_MODULE_20__gfm_auto_complete__["a" /* default */](gl.GfmAutoComplete && gl.GfmAutoComplete.dataSources);
        var enableGFM = Object(__WEBPACK_IMPORTED_MODULE_43__lib_utils_common_utils__["d" /* convertPermissionToBoolean */])(el.dataset.supportsAutocomplete);
        gfm.setup($(el), {
          emojis: true,
          members: enableGFM,
          issues: enableGFM,
          milestones: enableGFM,
          mergeRequests: enableGFM,
          labels: enableGFM
        });
      });

      function initBlobEE() {
        var dataEl = document.getElementById('js-file-lock');

        if (dataEl) {
          var _JSON$parse = JSON.parse(dataEl.innerHTML),
              toggle_path = _JSON$parse.toggle_path,
              _path = _JSON$parse.path;

          PathLocks.init(toggle_path, _path);
        }
      }

      function initBlob() {
        new LineHighlighter();

        new __WEBPACK_IMPORTED_MODULE_9__blob_blob_line_permalink_updater__["a" /* default */](document.querySelector('#blob-content-holder'), '.diff-line-num[data-line-number]', document.querySelectorAll('.js-data-file-blob-permalink-url, .js-blob-blame-link'));

        shortcut_handler = new ShortcutsNavigation();
        fileBlobPermalinkUrlElement = document.querySelector('.js-data-file-blob-permalink-url');
        fileBlobPermalinkUrl = fileBlobPermalinkUrlElement && fileBlobPermalinkUrlElement.getAttribute('href');
        new __WEBPACK_IMPORTED_MODULE_21__shortcuts_blob__["a" /* default */]({
          skipResetBindings: true,
          fileBlobPermalinkUrl: fileBlobPermalinkUrl
        });

        new __WEBPACK_IMPORTED_MODULE_11__blob_blob_fork_suggestion__["a" /* default */]({
          openButtons: document.querySelectorAll('.js-edit-blob-link-fork-toggler'),
          forkButtons: document.querySelectorAll('.js-fork-suggestion-button'),
          cancelButtons: document.querySelectorAll('.js-cancel-fork-suggestion-button'),
          suggestionSections: document.querySelectorAll('.js-file-fork-suggestion-section'),
          actionTextPieces: document.querySelectorAll('.js-file-fork-suggestion-section-action')
        }).init();

        initBlobEE();
      }

      var filteredSearchEnabled = gl.FilteredSearchManager && document.querySelector('.filtered-search');

      switch (page) {
        case 'profiles:preferences:show':
          Object(__WEBPACK_IMPORTED_MODULE_32__experimental_flags__["a" /* default */])();
          break;
        case 'sessions:new':
          new __WEBPACK_IMPORTED_MODULE_27__username_validator__["a" /* default */]();
          new __WEBPACK_IMPORTED_MODULE_22__signin_tabs_memoizer__["a" /* default */]();
          new __WEBPACK_IMPORTED_MODULE_33__oauth_remember_me__["a" /* default */]({ container: $(".omniauth-container") }).bindEvents();
          break;
        case 'projects:boards:show':
        case 'projects:boards:index':
          shortcut_handler = new ShortcutsNavigation();
          new __WEBPACK_IMPORTED_MODULE_18__users_select__["a" /* default */]();
          break;
        case 'projects:merge_requests:index':
        case 'projects:issues:index':
          if (filteredSearchEnabled) {
            var filteredSearchManager = new gl.FilteredSearchManager(page === 'projects:issues:index' ? 'issues' : 'merge_requests');
            filteredSearchManager.setup();
          }
          var pagePrefix = page === 'projects:merge_requests:index' ? 'merge_request_' : 'issue_';
          IssuableIndex.init(pagePrefix);

          shortcut_handler = new ShortcutsNavigation();
          new __WEBPACK_IMPORTED_MODULE_18__users_select__["a" /* default */]();
          break;
        case 'projects:issues:show':
          new __WEBPACK_IMPORTED_MODULE_1__issue__["a" /* default */]();
          shortcut_handler = new ShortcutsIssuable();
          new __WEBPACK_IMPORTED_MODULE_30__zen_mode__["a" /* default */]();
          Object(__WEBPACK_IMPORTED_MODULE_37__init_issuable_sidebar__["a" /* default */])();
          break;
        case 'dashboard:milestones:index':
          new ProjectSelect();
          break;
        case 'projects:milestones:show':
          new __WEBPACK_IMPORTED_MODULE_12__user_callout__["a" /* default */]();
        case 'groups:milestones:show':
        case 'dashboard:milestones:show':
          new Milestone();
          new Sidebar();
          break;
        case 'dashboard:issues':
        case 'dashboard:merge_requests':
          new ProjectSelect();
          Object(__WEBPACK_IMPORTED_MODULE_36__init_legacy_filters__["a" /* default */])();
          break;
        case 'groups:issues':
        case 'groups:merge_requests':
          if (filteredSearchEnabled) {
            var _filteredSearchManager = new gl.FilteredSearchManager(page === 'groups:issues' ? 'issues' : 'merge_requests');
            _filteredSearchManager.setup();
          }
          new ProjectSelect();
          break;
        case 'dashboard:todos:index':
          new __WEBPACK_IMPORTED_MODULE_24__todos__["a" /* default */]();
          break;
        case 'dashboard:projects:index':
        case 'dashboard:projects:starred':
        case 'explore:projects:index':
        case 'explore:projects:trending':
        case 'explore:projects:starred':
        case 'admin:projects:index':
          new __WEBPACK_IMPORTED_MODULE_6__projects_list__["a" /* default */]();
          break;
        case 'explore:groups:index':
          new __WEBPACK_IMPORTED_MODULE_5__groups_list__["default"]();
          var landingElement = document.querySelector('.js-explore-groups-landing');
          if (!landingElement) break;
          var exploreGroupsLanding = new __WEBPACK_IMPORTED_MODULE_10__landing__["a" /* default */](landingElement, landingElement.querySelector('.dismiss-button'), 'explore_groups_landing_dismissed');
          exploreGroupsLanding.toggle();
          break;
        case 'projects:milestones:new':
        case 'projects:milestones:edit':
        case 'projects:milestones:update':
        case 'groups:milestones:new':
        case 'groups:milestones:edit':
        case 'groups:milestones:update':
          new __WEBPACK_IMPORTED_MODULE_30__zen_mode__["a" /* default */]();
          new gl.DueDateSelectors();
          new gl.GLForm($('.milestone-form'), true);
          break;
        case 'projects:compare:show':
          new gl.Diff();
          Object(__WEBPACK_IMPORTED_MODULE_41__init_changes_dropdown__["a" /* default */])();
          break;
        case 'projects:branches:new':
        case 'projects:branches:create':
          new NewBranchForm($('.js-create-branch-form'), JSON.parse(document.getElementById('availableRefs').innerHTML));
          break;
        case 'projects:branches:index':
          __WEBPACK_IMPORTED_MODULE_44__ajax_loading_spinner__["a" /* default */].init();
          new __WEBPACK_IMPORTED_MODULE_3__branches_branches_delete_modal__["a" /* default */]();
          break;
        case 'projects:issues:new':
        case 'projects:issues:edit':
          shortcut_handler = new ShortcutsNavigation();
          new gl.GLForm($('.issue-form'), true);
          new IssuableForm($('.issue-form'));
          new LabelsSelect();
          new MilestoneSelect();
          new WeightSelect();
          new gl.IssuableTemplateSelectors();
          break;
        case 'projects:merge_requests:creations:new':
          var mrNewCompareNode = document.querySelector('.js-merge-request-new-compare');
          if (mrNewCompareNode) {
            new Compare({
              targetProjectUrl: mrNewCompareNode.dataset.targetProjectUrl,
              sourceBranchUrl: mrNewCompareNode.dataset.sourceBranchUrl,
              targetBranchUrl: mrNewCompareNode.dataset.targetBranchUrl
            });
          } else {
            var mrNewSubmitNode = document.querySelector('.js-merge-request-new-submit');
            new MergeRequest({
              action: mrNewSubmitNode.dataset.mrSubmitAction
            });
          }
          new __WEBPACK_IMPORTED_MODULE_12__user_callout__["a" /* default */]();
        case 'projects:merge_requests:creations:diffs':
        case 'projects:merge_requests:edit':
          new gl.Diff();
          shortcut_handler = new ShortcutsNavigation();
          new gl.GLForm($('.merge-request-form'), true);
          new IssuableForm($('.merge-request-form'));
          new LabelsSelect();
          new MilestoneSelect();
          new gl.IssuableTemplateSelectors();
          new __WEBPACK_IMPORTED_MODULE_17__issuable_auto_width_dropdown_select__["a" /* default */]($('.js-target-branch-select')).init();
          break;
        case 'projects:tags:new':
          new __WEBPACK_IMPORTED_MODULE_30__zen_mode__["a" /* default */]();
          new gl.GLForm($('.tag-form'), true);
          new __WEBPACK_IMPORTED_MODULE_19__ref_select_dropdown__["a" /* default */]($('.js-branch-select'));
          break;
        case 'projects:snippets:show':
          Object(__WEBPACK_IMPORTED_MODULE_35__init_notes__["a" /* default */])();
          break;
        case 'projects:snippets:new':
        case 'projects:snippets:edit':
        case 'projects:snippets:create':
        case 'projects:snippets:update':
          new gl.GLForm($('.snippet-form'), true);
          break;
        case 'snippets:new':
        case 'snippets:edit':
        case 'snippets:create':
        case 'snippets:update':
          new gl.GLForm($('.snippet-form'), false);
          break;
        case 'projects:releases:edit':
          new __WEBPACK_IMPORTED_MODULE_30__zen_mode__["a" /* default */]();
          new gl.GLForm($('.release-form'), true);
          break;
        case 'projects:merge_requests:show':
          new gl.Diff();
          shortcut_handler = new ShortcutsIssuable(true);
          new __WEBPACK_IMPORTED_MODULE_30__zen_mode__["a" /* default */]();

          Object(__WEBPACK_IMPORTED_MODULE_37__init_issuable_sidebar__["a" /* default */])();
          Object(__WEBPACK_IMPORTED_MODULE_35__init_notes__["a" /* default */])();

          var mrShowNode = document.querySelector('.merge-request');
          window.mergeRequest = new MergeRequest({
            action: mrShowNode.dataset.mrAction
          });
          break;
        case 'dashboard:activity':
          new gl.Activities();
          break;
        case 'projects:commit:show':
          new gl.Diff();
          new __WEBPACK_IMPORTED_MODULE_30__zen_mode__["a" /* default */]();
          shortcut_handler = new ShortcutsNavigation();
          new __WEBPACK_IMPORTED_MODULE_8__mini_pipeline_graph_dropdown__["a" /* default */]({
            container: '.js-commit-pipeline-graph'
          }).bindEvents();
          Object(__WEBPACK_IMPORTED_MODULE_35__init_notes__["a" /* default */])();
          Object(__WEBPACK_IMPORTED_MODULE_41__init_changes_dropdown__["a" /* default */])();
          $('.commit-info.branches').load(document.querySelector('.js-commit-box').dataset.commitPath);
          break;
        case 'projects:commit:pipelines':
          new __WEBPACK_IMPORTED_MODULE_8__mini_pipeline_graph_dropdown__["a" /* default */]({
            container: '.js-commit-pipeline-graph'
          }).bindEvents();
          $('.commit-info.branches').load(document.querySelector('.js-commit-box').dataset.commitPath);
          break;
        case 'projects:activity':
          new gl.Activities();
          shortcut_handler = new ShortcutsNavigation();
          break;
        case 'projects:commits:show':
          __WEBPACK_IMPORTED_MODULE_0__commits__["a" /* default */].init(document.querySelector('.js-project-commits-show').dataset.commitsLimit);
          shortcut_handler = new ShortcutsNavigation();
          __WEBPACK_IMPORTED_MODULE_39__gpg_badges__["a" /* default */].fetch();
          break;
        case 'projects:imports:show':
          new ProjectImport();
          break;
        case 'projects:show':
          shortcut_handler = new ShortcutsNavigation();
          new NotificationsForm();
          new __WEBPACK_IMPORTED_MODULE_12__user_callout__["a" /* default */]({
            setCalloutPerProject: true,
            className: 'js-autodevops-banner'
          });

          if ($('#tree-slider').length) new __WEBPACK_IMPORTED_MODULE_25__tree__["a" /* default */]();
          if ($('.blob-viewer').length) new __WEBPACK_IMPORTED_MODULE_15__blob_viewer_index__["a" /* default */]();
          if ($('.project-show-activity').length) new gl.Activities();

          $('#tree-slider').waitForImages(function () {
            Object(__WEBPACK_IMPORTED_MODULE_43__lib_utils_common_utils__["a" /* ajaxGet */])(document.querySelector('.js-tree-content').dataset.logsPath);
          });

          Object(__WEBPACK_IMPORTED_MODULE_47__init_geo_info_modal__["a" /* default */])();
          break;
        case 'projects:edit':
          new __WEBPACK_IMPORTED_MODULE_18__users_select__["a" /* default */]();
          new GroupsSelect();
          Object(__WEBPACK_IMPORTED_MODULE_7__project_edit__["a" /* default */])();
          // Initialize expandable settings panels
          Object(__WEBPACK_IMPORTED_MODULE_31__settings_panels__["a" /* default */])();
          new __WEBPACK_IMPORTED_MODULE_12__user_callout__["a" /* default */]({ className: 'js-service-desk-callout' });
          new __WEBPACK_IMPORTED_MODULE_12__user_callout__["a" /* default */]({ className: 'js-mr-approval-callout' });
          break;
        case 'projects:imports:show':
          new ProjectImport();
          break;
        case 'projects:pipelines:new':
          new NewBranchForm($('.js-new-pipeline-form'));
          break;
        case 'projects:pipelines:builds':
        case 'projects:pipelines:failures':
        case 'projects:pipelines:show':
          var controllerAction = document.querySelector('.js-pipeline-container').dataset.controllerAction;

          var pipelineStatusUrl = document.querySelector('.js-pipeline-tab-link a').getAttribute('href') + '/status.json';

          new __WEBPACK_IMPORTED_MODULE_14__pipelines__["a" /* default */]({
            initTabs: true,
            pipelineStatusUrl: pipelineStatusUrl,
            tabsOptions: {
              action: controllerAction,
              defaultAction: 'pipelines',
              parentEl: '.pipelines-tabs'
            }
          });
          break;
        case 'groups:activity':
          new gl.Activities();
          break;
        case 'groups:show':
          shortcut_handler = new ShortcutsNavigation();
          new NotificationsForm();
          new NotificationsDropdown();
          new __WEBPACK_IMPORTED_MODULE_6__projects_list__["a" /* default */]();
          break;
        case 'groups:group_members:index':
          new gl.MemberExpirationDate();
          new gl.Members();
          new __WEBPACK_IMPORTED_MODULE_18__users_select__["a" /* default */]();
          break;
        case 'projects:project_members:index':
          new gl.MemberExpirationDate('.js-access-expiration-date-groups');
          new GroupsSelect();
          new gl.MemberExpirationDate();
          new gl.Members();
          new __WEBPACK_IMPORTED_MODULE_18__users_select__["a" /* default */]();
          break;
        case 'groups:new':
        case 'admin:groups:new':
        case 'groups:create':
        case 'admin:groups:create':
          __WEBPACK_IMPORTED_MODULE_2__behaviors_bind_in_out__["a" /* default */].initAll();
          new __WEBPACK_IMPORTED_MODULE_4__group__["default"]();
          new GroupAvatar();
          break;
        case 'groups:edit':
        case 'admin:groups:edit':
          new GroupAvatar();
          break;
        case 'projects:tree:show':
          shortcut_handler = new ShortcutsNavigation();

          if (__WEBPACK_IMPORTED_MODULE_40__helpers_user_feature_helper__["a" /* default */].isNewRepoEnabled()) break;

          new __WEBPACK_IMPORTED_MODULE_25__tree__["a" /* default */]();
          new __WEBPACK_IMPORTED_MODULE_15__blob_viewer_index__["a" /* default */]();
          new NewCommitForm($('.js-create-dir-form'));

          if (document.querySelector('.js-tree-content').dataset.pathLocksAvailable === 'true') {
            PathLocks.init(document.querySelector('.js-tree-content').dataset.pathLocksToggle, document.querySelector('.js-tree-content').dataset.pathLocksPath);
          }

          $('#tree-slider').waitForImages(function () {
            Object(__WEBPACK_IMPORTED_MODULE_43__lib_utils_common_utils__["a" /* ajaxGet */])(document.querySelector('.js-tree-content').dataset.logsPath);
          });
          break;
        case 'projects:find_file:show':
          var findElement = document.querySelector('.js-file-finder');
          var projectFindFile = new ProjectFindFile($(".file-finder-holder"), {
            url: findElement.dataset.fileFindUrl,
            treeUrl: findElement.dataset.findTreeUrl,
            blobUrlTemplate: findElement.dataset.blobUrlTemplate
          });
          new ShortcutsFindFile(projectFindFile);
          shortcut_handler = true;
          break;
        case 'projects:blob:show':
          if (__WEBPACK_IMPORTED_MODULE_40__helpers_user_feature_helper__["a" /* default */].isNewRepoEnabled()) break;
          new __WEBPACK_IMPORTED_MODULE_15__blob_viewer_index__["a" /* default */]();
          initBlob();
          break;
        case 'projects:blame:show':
          initBlob();
          break;
        case 'groups:labels:new':
        case 'groups:labels:edit':
        case 'projects:labels:new':
        case 'projects:labels:edit':
          new Labels();
          break;
        case 'groups:labels:index':
        case 'projects:labels:index':
          if ($('.prioritized-labels').length) {
            new gl.LabelManager();
          }
          $('.label-subscription').each(function (i, el) {
            var $el = $(el);

            if ($el.find('.dropdown-group-label').length) {
              new gl.GroupLabelSubscription($el);
            } else {
              new gl.ProjectLabelSubscription($el);
            }
          });
          break;
        case 'projects:network:show':
          // Ensure we don't create a particular shortcut handler here. This is
          // already created, where the network graph is created.
          shortcut_handler = true;
          break;
        case 'projects:forks:new':
          __webpack_require__.e/* import() */("project_fork").then(__webpack_require__.bind(null, "./project_fork.js")).then(function (fork) {
            return fork.default();
          }).catch(function () {});
          break;
        case 'projects:artifacts:browse':
          new ShortcutsNavigation();
          new BuildArtifacts();
          break;
        case 'projects:artifacts:file':
          new ShortcutsNavigation();
          new __WEBPACK_IMPORTED_MODULE_15__blob_viewer_index__["a" /* default */]();
          break;
        case 'help:index':
          __WEBPACK_IMPORTED_MODULE_28__version_check_image__["a" /* default */].bindErrorEvent($('img.js-version-status-badge'));
          break;
        case 'search:show':
          new Search();
          new __WEBPACK_IMPORTED_MODULE_12__user_callout__["a" /* default */]();
          break;
        case 'projects:mirrors:show':
        case 'projects:mirrors:update':
          new __WEBPACK_IMPORTED_MODULE_18__users_select__["a" /* default */]();
          break;
        case 'admin:emails:show':
          new AdminEmailSelect();
          break;
        case 'admin:audit_logs:index':
          new __WEBPACK_IMPORTED_MODULE_46__audit_logs__["a" /* default */]();
          break;
        case 'projects:settings:repository:show':
          new __WEBPACK_IMPORTED_MODULE_18__users_select__["a" /* default */]();
          new __WEBPACK_IMPORTED_MODULE_12__user_callout__["a" /* default */]();
          // Initialize expandable settings panels
          Object(__WEBPACK_IMPORTED_MODULE_31__settings_panels__["a" /* default */])();
          break;
        case 'projects:settings:ci_cd:show':
          // Initialize expandable settings panels
          Object(__WEBPACK_IMPORTED_MODULE_31__settings_panels__["a" /* default */])();
        case 'groups:settings:ci_cd:show':
          new gl.ProjectVariables();
          break;
        case 'ci:lints:create':
        case 'ci:lints:show':
          new gl.CILintEditor();
          break;
        case 'users:show':
          new __WEBPACK_IMPORTED_MODULE_12__user_callout__["a" /* default */]();
          break;
        case 'admin:conversational_development_index:show':
          new __WEBPACK_IMPORTED_MODULE_12__user_callout__["a" /* default */]();
          break;
        case 'snippets:show':
          new LineHighlighter();
          new __WEBPACK_IMPORTED_MODULE_15__blob_viewer_index__["a" /* default */]();
          Object(__WEBPACK_IMPORTED_MODULE_35__init_notes__["a" /* default */])();
          break;
        case 'import:fogbugz:new_user_map':
          new __WEBPACK_IMPORTED_MODULE_18__users_select__["a" /* default */]();
          break;
        case 'profiles:personal_access_tokens:index':
        case 'admin:impersonation_tokens:index':
          new gl.DueDateSelectors();
          break;
        case 'projects:clusters:show':
          __webpack_require__.e/* import() */("clusters").then(__webpack_require__.bind(null, "./clusters.js")).then(function (cluster) {
            return new cluster.default();
          }) // eslint-disable-line new-cap
          .catch(function () {});
          break;
        case 'admin:licenses:new':
          var $licenseFile = $('.license-file');
          var $licenseKey = $('.license-key');

          var showLicenseType = function showLicenseType() {
            var $checkedFile = $('input[name="license_type"]:checked').val() === 'file';

            $licenseFile.toggle($checkedFile);
            $licenseKey.toggle(!$checkedFile);
          };

          $('input[name="license_type"]').on('change', showLicenseType);
          showLicenseType();
          break;
        case 'groups:analytics:show':
          Object(__WEBPACK_IMPORTED_MODULE_48__init_group_analytics__["a" /* default */])();
          break;
      }
      switch (path[0]) {
        case 'sessions':
        case 'omniauth_callbacks':
          if (!gon.u2f) break;
          gl.u2fAuthenticate = new gl.U2FAuthenticate($('#js-authenticate-u2f'), '#js-login-u2f-form', gon.u2f, document.querySelector('#js-login-2fa-device'), document.querySelector('.js-2fa-form'));
          gl.u2fAuthenticate.start();
        case 'admin':
          new Admin();
          switch (path[1]) {
            case 'cohorts':
              new __WEBPACK_IMPORTED_MODULE_26__usage_ping__["a" /* default */]();
              break;
            case 'groups':
              new __WEBPACK_IMPORTED_MODULE_18__users_select__["a" /* default */]();
              break;
            case 'projects':
              new NamespaceSelects();
              break;
            case 'labels':
              switch (path[2]) {
                case 'new':
                case 'edit':
                  new Labels();
              }
            case 'abuse_reports':
              new __WEBPACK_IMPORTED_MODULE_42__abuse_reports__["a" /* default */]();
              break;
            case 'geo_nodes':
              new __WEBPACK_IMPORTED_MODULE_16__geo_nodes__["a" /* default */]($('.geo-nodes'));
              __webpack_require__.e/* import() */("geo_node_form").then(__webpack_require__.bind(null, "./geo/geo_node_form.js")).then(function (geoNodeForm) {
                return geoNodeForm.default($('.js-geo-node-form'));
              }).catch(function () {});
              break;
          }
          break;
        case 'dashboard':
        case 'root':
          new __WEBPACK_IMPORTED_MODULE_12__user_callout__["a" /* default */]();
          break;
        case 'profiles':
          new NotificationsForm();
          new NotificationsDropdown();
          break;
        case 'projects':
          new Project();
          new ProjectAvatar();
          switch (path[1]) {
            case 'compare':
              new CompareAutocomplete();
              break;
            case 'edit':
              shortcut_handler = new ShortcutsNavigation();
              new ProjectNew();
              new __WEBPACK_IMPORTED_MODULE_45__approvers_select__["a" /* default */]();
              __webpack_require__.e/* import() */("project_permissions").then(__webpack_require__.bind(null, "./projects/permissions/index.js")).then(function (permissions) {
                return permissions.default();
              }).catch(function () {});
              break;
            case 'new':
              new ProjectNew();
              Object(__WEBPACK_IMPORTED_MODULE_38__project_visibility__["a" /* default */])();
              break;
            case 'show':
              new __WEBPACK_IMPORTED_MODULE_23__star__["a" /* default */]();
              new ProjectNew();
              new ProjectShow();
              new NotificationsDropdown();
              break;
            case 'wikis':
              new __WEBPACK_IMPORTED_MODULE_29__wikis__["a" /* default */]();
              shortcut_handler = new __WEBPACK_IMPORTED_MODULE_13__shortcuts_wiki__["a" /* default */]();
              new __WEBPACK_IMPORTED_MODULE_30__zen_mode__["a" /* default */]();
              new gl.GLForm($('.wiki-form'), true);
              break;
            case 'snippets':
              shortcut_handler = new ShortcutsNavigation();
              if (path[2] === 'show') {
                new __WEBPACK_IMPORTED_MODULE_30__zen_mode__["a" /* default */]();
                new LineHighlighter();
                new __WEBPACK_IMPORTED_MODULE_15__blob_viewer_index__["a" /* default */]();
              }
              break;
            case 'labels':
            case 'graphs':
            case 'compare':
            case 'pipelines':
            case 'forks':
            case 'milestones':
            case 'project_members':
            case 'deploy_keys':
            case 'builds':
            case 'hooks':
            case 'services':
            case 'repository':
              shortcut_handler = new ShortcutsNavigation();
          }
          break;
        case 'users':
          var action = path[1];
          __webpack_require__.e/* import() */("user_profile").then(__webpack_require__.bind(null, "./users/index.js")).then(function (user) {
            return user.default(action);
          }).catch(function () {});
          break;
      }
      // If we haven't installed a custom shortcut handler, install the default one
      if (!shortcut_handler) {
        new Shortcuts();
      }

      if (document.querySelector('#peek')) {
        new __WEBPACK_IMPORTED_MODULE_34__performance_bar__["default"]({ container: '#peek' });
      }
    };

    Dispatcher.prototype.initSearch = function () {
      // Only when search form is present
      if ($('.search').length) {
        return new gl.SearchAutocomplete();
      }
    };

    Dispatcher.prototype.initFieldErrors = function () {
      $('.gl-show-field-errors').each(function (i, form) {
        new gl.GlFieldErrors(form);
      });
    };

    return Dispatcher;
  }();

  $(window).on('load', function () {
    new Dispatcher();
  });
}).call(window);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./droplab/drop_lab.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/underscore/underscore.js
var underscore = __webpack_require__("../../../node_modules/underscore/underscore.js");
var underscore_default = /*#__PURE__*/__webpack_require__.n(underscore);

// CONCATENATED MODULE: ./droplab/constants.js
var DATA_TRIGGER = 'data-dropdown-trigger';
var DATA_DROPDOWN = 'data-dropdown';
var SELECTED_CLASS = 'droplab-item-selected';
var ACTIVE_CLASS = 'droplab-item-active';
var IGNORE_CLASS = 'droplab-item-ignore';
// Matches `{{anything}}` and `{{ everything }}`.
var TEMPLATE_REGEX = /\{\{(.+?)\}\}/g;


// CONCATENATED MODULE: ./droplab/utils.js
/* eslint-disable */




var utils = {
  toCamelCase: function toCamelCase(attr) {
    return this.camelize(attr.split('-').slice(1).join(' '));
  },
  template: function template(templateString, data) {
    var template = Object(underscore["template"])(templateString, {
      escape: TEMPLATE_REGEX
    });

    return template(data);
  },
  camelize: function camelize(str) {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (letter, index) {
      return index === 0 ? letter.toLowerCase() : letter.toUpperCase();
    }).replace(/\s+/g, '');
  },
  closest: function closest(thisTag, stopTag) {
    while (thisTag && thisTag.tagName !== stopTag && thisTag.tagName !== 'HTML') {
      thisTag = thisTag.parentNode;
    }
    return thisTag;
  },
  isDropDownParts: function isDropDownParts(target) {
    if (!target || target.tagName === 'HTML') return false;
    return target.hasAttribute(DATA_TRIGGER) || target.hasAttribute(DATA_DROPDOWN);
  }
};

/* harmony default export */ var droplab_utils = (utils);
// CONCATENATED MODULE: ./droplab/drop_down.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var drop_down_DropDown = function () {
  function DropDown(list) {
    _classCallCheck(this, DropDown);

    this.currentIndex = 0;
    this.hidden = true;
    this.list = typeof list === 'string' ? document.querySelector(list) : list;
    this.items = [];

    this.eventWrapper = {};

    this.getItems();
    this.initTemplateString();
    this.addEvents();

    this.initialState = list.innerHTML;
  }

  _createClass(DropDown, [{
    key: 'getItems',
    value: function getItems() {
      this.items = [].slice.call(this.list.querySelectorAll('li'));
      return this.items;
    }
  }, {
    key: 'initTemplateString',
    value: function initTemplateString() {
      var items = this.items || this.getItems();

      var templateString = '';
      if (items.length > 0) templateString = items[items.length - 1].outerHTML;
      this.templateString = templateString;

      return this.templateString;
    }
  }, {
    key: 'clickEvent',
    value: function clickEvent(e) {
      if (e.target.tagName === 'UL') return;
      if (e.target.classList.contains(IGNORE_CLASS)) return;

      var selected = droplab_utils.closest(e.target, 'LI');
      if (!selected) return;

      this.addSelectedClass(selected);

      e.preventDefault();
      this.hide();

      var listEvent = new CustomEvent('click.dl', {
        detail: {
          list: this,
          selected: selected,
          data: e.target.dataset
        }
      });
      this.list.dispatchEvent(listEvent);
    }
  }, {
    key: 'addSelectedClass',
    value: function addSelectedClass(selected) {
      this.removeSelectedClasses();
      selected.classList.add(SELECTED_CLASS);
    }
  }, {
    key: 'removeSelectedClasses',
    value: function removeSelectedClasses() {
      var items = this.items || this.getItems();

      items.forEach(function (item) {
        return item.classList.remove(SELECTED_CLASS);
      });
    }
  }, {
    key: 'addEvents',
    value: function addEvents() {
      this.eventWrapper.clickEvent = this.clickEvent.bind(this);
      this.list.addEventListener('click', this.eventWrapper.clickEvent);
    }
  }, {
    key: 'setData',
    value: function setData(data) {
      this.data = data;
      this.render(data);
    }
  }, {
    key: 'addData',
    value: function addData(data) {
      this.data = (this.data || []).concat(data);
      this.render(this.data);
    }
  }, {
    key: 'render',
    value: function render(data) {
      var children = data ? data.map(this.renderChildren.bind(this)) : [];
      var renderableList = this.list.querySelector('ul[data-dynamic]') || this.list;

      renderableList.innerHTML = children.join('');

      var listEvent = new CustomEvent('render.dl', {
        detail: {
          list: this
        }
      });
      this.list.dispatchEvent(listEvent);
    }
  }, {
    key: 'renderChildren',
    value: function renderChildren(data) {
      var html = droplab_utils.template(this.templateString, data);
      var template = document.createElement('div');

      template.innerHTML = html;
      DropDown.setImagesSrc(template);
      template.firstChild.style.display = data.droplab_hidden ? 'none' : 'block';

      return template.firstChild.outerHTML;
    }
  }, {
    key: 'show',
    value: function show() {
      if (!this.hidden) return;
      this.list.style.display = 'block';
      this.currentIndex = 0;
      this.hidden = false;
    }
  }, {
    key: 'hide',
    value: function hide() {
      if (this.hidden) return;
      this.list.style.display = 'none';
      this.currentIndex = 0;
      this.hidden = true;
    }
  }, {
    key: 'toggle',
    value: function toggle() {
      if (this.hidden) return this.show();

      return this.hide();
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.hide();
      this.list.removeEventListener('click', this.eventWrapper.clickEvent);
    }
  }], [{
    key: 'setImagesSrc',
    value: function setImagesSrc(template) {
      var images = [].concat(_toConsumableArray(template.querySelectorAll('img[data-src]')));

      images.forEach(function (image) {
        var img = image;

        img.src = img.getAttribute('data-src');
        img.removeAttribute('data-src');
      });
    }
  }]);

  return DropDown;
}();

/* harmony default export */ var drop_down = (drop_down_DropDown);
// CONCATENATED MODULE: ./droplab/hook.js
function hook__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var hook_Hook = function Hook(trigger, list, plugins, config) {
  hook__classCallCheck(this, Hook);

  this.trigger = trigger;
  this.list = new drop_down(list);
  this.type = 'Hook';
  this.event = 'click';
  this.plugins = plugins || [];
  this.config = config || {};
  this.id = trigger.id;
};

/* harmony default export */ var droplab_hook = (hook_Hook);
// CONCATENATED MODULE: ./droplab/hook_button.js
var hook_button__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function hook_button__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var HookButton = function (_Hook) {
  _inherits(HookButton, _Hook);

  function HookButton(trigger, list, plugins, config) {
    hook_button__classCallCheck(this, HookButton);

    var _this = _possibleConstructorReturn(this, (HookButton.__proto__ || Object.getPrototypeOf(HookButton)).call(this, trigger, list, plugins, config));

    _this.type = 'button';
    _this.event = 'click';

    _this.eventWrapper = {};

    _this.addEvents();
    _this.addPlugins();
    return _this;
  }

  hook_button__createClass(HookButton, [{
    key: 'addPlugins',
    value: function addPlugins() {
      var _this2 = this;

      this.plugins.forEach(function (plugin) {
        return plugin.init(_this2);
      });
    }
  }, {
    key: 'clicked',
    value: function clicked(e) {
      var buttonEvent = new CustomEvent('click.dl', {
        detail: {
          hook: this
        },
        bubbles: true,
        cancelable: true
      });
      e.target.dispatchEvent(buttonEvent);

      this.list.toggle();
    }
  }, {
    key: 'addEvents',
    value: function addEvents() {
      this.eventWrapper.clicked = this.clicked.bind(this);
      this.trigger.addEventListener('click', this.eventWrapper.clicked);
    }
  }, {
    key: 'removeEvents',
    value: function removeEvents() {
      this.trigger.removeEventListener('click', this.eventWrapper.clicked);
    }
  }, {
    key: 'restoreInitialState',
    value: function restoreInitialState() {
      this.list.list.innerHTML = this.list.initialState;
    }
  }, {
    key: 'removePlugins',
    value: function removePlugins() {
      this.plugins.forEach(function (plugin) {
        return plugin.destroy();
      });
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.restoreInitialState();

      this.removeEvents();
      this.removePlugins();
    }
  }]);

  return HookButton;
}(droplab_hook);

/* harmony default export */ var hook_button = (HookButton);
// CONCATENATED MODULE: ./droplab/hook_input.js
var hook_input__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function hook_input__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function hook_input__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function hook_input__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var HookInput = function (_Hook) {
  hook_input__inherits(HookInput, _Hook);

  function HookInput(trigger, list, plugins, config) {
    hook_input__classCallCheck(this, HookInput);

    var _this = hook_input__possibleConstructorReturn(this, (HookInput.__proto__ || Object.getPrototypeOf(HookInput)).call(this, trigger, list, plugins, config));

    _this.type = 'input';
    _this.event = 'input';

    _this.eventWrapper = {};

    _this.addEvents();
    _this.addPlugins();
    return _this;
  }

  hook_input__createClass(HookInput, [{
    key: 'addPlugins',
    value: function addPlugins() {
      var _this2 = this;

      this.plugins.forEach(function (plugin) {
        return plugin.init(_this2);
      });
    }
  }, {
    key: 'addEvents',
    value: function addEvents() {
      this.eventWrapper.mousedown = this.mousedown.bind(this);
      this.eventWrapper.input = this.input.bind(this);
      this.eventWrapper.keyup = this.keyup.bind(this);
      this.eventWrapper.keydown = this.keydown.bind(this);

      this.trigger.addEventListener('mousedown', this.eventWrapper.mousedown);
      this.trigger.addEventListener('input', this.eventWrapper.input);
      this.trigger.addEventListener('keyup', this.eventWrapper.keyup);
      this.trigger.addEventListener('keydown', this.eventWrapper.keydown);
    }
  }, {
    key: 'removeEvents',
    value: function removeEvents() {
      this.hasRemovedEvents = true;

      this.trigger.removeEventListener('mousedown', this.eventWrapper.mousedown);
      this.trigger.removeEventListener('input', this.eventWrapper.input);
      this.trigger.removeEventListener('keyup', this.eventWrapper.keyup);
      this.trigger.removeEventListener('keydown', this.eventWrapper.keydown);
    }
  }, {
    key: 'input',
    value: function input(e) {
      if (this.hasRemovedEvents) return;

      this.list.show();

      var inputEvent = new CustomEvent('input.dl', {
        detail: {
          hook: this,
          text: e.target.value
        },
        bubbles: true,
        cancelable: true
      });
      e.target.dispatchEvent(inputEvent);
    }
  }, {
    key: 'mousedown',
    value: function mousedown(e) {
      if (this.hasRemovedEvents) return;

      var mouseEvent = new CustomEvent('mousedown.dl', {
        detail: {
          hook: this,
          text: e.target.value
        },
        bubbles: true,
        cancelable: true
      });
      e.target.dispatchEvent(mouseEvent);
    }
  }, {
    key: 'keyup',
    value: function keyup(e) {
      if (this.hasRemovedEvents) return;

      this.keyEvent(e, 'keyup.dl');
    }
  }, {
    key: 'keydown',
    value: function keydown(e) {
      if (this.hasRemovedEvents) return;

      this.keyEvent(e, 'keydown.dl');
    }
  }, {
    key: 'keyEvent',
    value: function keyEvent(e, eventName) {
      this.list.show();

      var keyEvent = new CustomEvent(eventName, {
        detail: {
          hook: this,
          text: e.target.value,
          which: e.which,
          key: e.key
        },
        bubbles: true,
        cancelable: true
      });
      e.target.dispatchEvent(keyEvent);
    }
  }, {
    key: 'restoreInitialState',
    value: function restoreInitialState() {
      this.list.list.innerHTML = this.list.initialState;
    }
  }, {
    key: 'removePlugins',
    value: function removePlugins() {
      this.plugins.forEach(function (plugin) {
        return plugin.destroy();
      });
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.restoreInitialState();

      this.removeEvents();
      this.removePlugins();

      this.list.destroy();
    }
  }]);

  return HookInput;
}(droplab_hook);

/* harmony default export */ var hook_input = (HookInput);
// CONCATENATED MODULE: ./droplab/keyboard.js
/* eslint-disable */



var keyboard_Keyboard = function Keyboard() {
  var currentKey;
  var currentFocus;
  var isUpArrow = false;
  var isDownArrow = false;
  var removeHighlight = function removeHighlight(list) {
    var itemElements = Array.prototype.slice.call(list.list.querySelectorAll('li:not(.divider):not(.hidden)'), 0);
    var listItems = [];
    for (var i = 0; i < itemElements.length; i++) {
      var listItem = itemElements[i];
      listItem.classList.remove(ACTIVE_CLASS);

      if (listItem.style.display !== 'none') {
        listItems.push(listItem);
      }
    }
    return listItems;
  };

  var setMenuForArrows = function setMenuForArrows(list) {
    var listItems = removeHighlight(list);
    if (list.currentIndex > 0) {
      if (!listItems[list.currentIndex - 1]) {
        list.currentIndex = list.currentIndex - 1;
      }

      if (listItems[list.currentIndex - 1]) {
        var el = listItems[list.currentIndex - 1];
        var filterDropdownEl = el.closest('.filter-dropdown');
        el.classList.add(ACTIVE_CLASS);

        if (filterDropdownEl) {
          var filterDropdownBottom = filterDropdownEl.offsetHeight;
          var elOffsetTop = el.offsetTop - 30;

          if (elOffsetTop > filterDropdownBottom) {
            filterDropdownEl.scrollTop = elOffsetTop - filterDropdownBottom;
          }
        }
      }
    }
  };

  var mousedown = function mousedown(e) {
    var list = e.detail.hook.list;
    removeHighlight(list);
    list.show();
    list.currentIndex = 0;
    isUpArrow = false;
    isDownArrow = false;
  };
  var selectItem = function selectItem(list) {
    var listItems = removeHighlight(list);
    var currentItem = listItems[list.currentIndex - 1];
    var listEvent = new CustomEvent('click.dl', {
      detail: {
        list: list,
        selected: currentItem,
        data: currentItem.dataset
      }
    });
    list.list.dispatchEvent(listEvent);
    list.hide();
  };

  var keydown = function keydown(e) {
    var typedOn = e.target;
    var list = e.detail.hook.list;
    var currentIndex = list.currentIndex;
    isUpArrow = false;
    isDownArrow = false;

    if (e.detail.which) {
      currentKey = e.detail.which;
      if (currentKey === 13) {
        selectItem(e.detail.hook.list);
        return;
      }
      if (currentKey === 38) {
        isUpArrow = true;
      }
      if (currentKey === 40) {
        isDownArrow = true;
      }
    } else if (e.detail.key) {
      currentKey = e.detail.key;
      if (currentKey === 'Enter') {
        selectItem(e.detail.hook.list);
        return;
      }
      if (currentKey === 'ArrowUp') {
        isUpArrow = true;
      }
      if (currentKey === 'ArrowDown') {
        isDownArrow = true;
      }
    }
    if (isUpArrow) {
      currentIndex--;
    }
    if (isDownArrow) {
      currentIndex++;
    }
    if (currentIndex < 0) {
      currentIndex = 0;
    }
    list.currentIndex = currentIndex;
    setMenuForArrows(e.detail.hook.list);
  };

  document.addEventListener('mousedown.dl', mousedown);
  document.addEventListener('keydown.dl', keydown);
};

/* harmony default export */ var keyboard = (keyboard_Keyboard);
// CONCATENATED MODULE: ./droplab/drop_lab.js
var drop_lab__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function drop_lab__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function drop_lab__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







var drop_lab_DropLab = function () {
  function DropLab() {
    drop_lab__classCallCheck(this, DropLab);

    this.ready = false;
    this.hooks = [];
    this.queuedData = [];
    this.config = {};

    this.eventWrapper = {};
  }

  drop_lab__createClass(DropLab, [{
    key: 'loadStatic',
    value: function loadStatic() {
      var dropdownTriggers = [].slice.apply(document.querySelectorAll('[' + DATA_TRIGGER + ']'));
      this.addHooks(dropdownTriggers);
    }
  }, {
    key: 'addData',
    value: function addData() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      this.applyArgs(args, 'processAddData');
    }
  }, {
    key: 'setData',
    value: function setData() {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      this.applyArgs(args, 'processSetData');
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.hooks.forEach(function (hook) {
        return hook.destroy();
      });
      this.hooks = [];
      this.removeEvents();
    }
  }, {
    key: 'applyArgs',
    value: function applyArgs(args, methodName) {
      if (this.ready) return this[methodName].apply(this, drop_lab__toConsumableArray(args));

      this.queuedData = this.queuedData || [];
      this.queuedData.push(args);

      return this.ready;
    }
  }, {
    key: 'processAddData',
    value: function processAddData(trigger, data) {
      this.processData(trigger, data, 'addData');
    }
  }, {
    key: 'processSetData',
    value: function processSetData(trigger, data) {
      this.processData(trigger, data, 'setData');
    }
  }, {
    key: 'processData',
    value: function processData(trigger, data, methodName) {
      this.hooks.forEach(function (hook) {
        if (Array.isArray(trigger)) hook.list[methodName](trigger);

        if (hook.trigger.id === trigger) hook.list[methodName](data);
      });
    }
  }, {
    key: 'addEvents',
    value: function addEvents() {
      this.eventWrapper.documentClicked = this.documentClicked.bind(this);
      document.addEventListener('click', this.eventWrapper.documentClicked);
    }
  }, {
    key: 'documentClicked',
    value: function documentClicked(e) {
      var thisTag = e.target;

      if (thisTag.tagName !== 'UL') thisTag = droplab_utils.closest(thisTag, 'UL');
      if (droplab_utils.isDropDownParts(thisTag, this.hooks)) return;
      if (droplab_utils.isDropDownParts(e.target, this.hooks)) return;

      this.hooks.forEach(function (hook) {
        return hook.list.hide();
      });
    }
  }, {
    key: 'removeEvents',
    value: function removeEvents() {
      document.removeEventListener('click', this.eventWrapper.documentClicked);
    }
  }, {
    key: 'changeHookList',
    value: function changeHookList(trigger, list, plugins, config) {
      var _this = this;

      var availableTrigger = typeof trigger === 'string' ? document.getElementById(trigger) : trigger;

      this.hooks.forEach(function (hook, i) {
        var aHook = hook;

        aHook.list.list.dataset.dropdownActive = false;

        if (aHook.trigger !== availableTrigger) return;

        aHook.destroy();
        _this.hooks.splice(i, 1);
        _this.addHook(availableTrigger, list, plugins, config);
      });
    }
  }, {
    key: 'addHook',
    value: function addHook(hook, list, plugins, config) {
      var availableHook = typeof hook === 'string' ? document.querySelector(hook) : hook;
      var availableList = void 0;

      if (typeof list === 'string') {
        availableList = document.querySelector(list);
      } else if (list instanceof Element) {
        availableList = list;
      } else {
        availableList = document.querySelector(hook.dataset[droplab_utils.toCamelCase(DATA_TRIGGER)]);
      }

      availableList.dataset.dropdownActive = true;

      var HookObject = availableHook.tagName === 'INPUT' ? hook_input : hook_button;
      this.hooks.push(new HookObject(availableHook, availableList, plugins, config));

      return this;
    }
  }, {
    key: 'addHooks',
    value: function addHooks(hooks, plugins, config) {
      var _this2 = this;

      hooks.forEach(function (hook) {
        return _this2.addHook(hook, null, plugins, config);
      });
      return this;
    }
  }, {
    key: 'setConfig',
    value: function setConfig(obj) {
      this.config = obj;
    }
  }, {
    key: 'fireReady',
    value: function fireReady() {
      var readyEvent = new CustomEvent('ready.dl', {
        detail: {
          dropdown: this
        }
      });
      document.dispatchEvent(readyEvent);

      this.ready = true;
    }
  }, {
    key: 'init',
    value: function init(hook, list, plugins, config) {
      var _this3 = this;

      if (hook) {
        this.addHook(hook, list, plugins, config);
      } else {
        this.loadStatic();
      }

      this.addEvents();

      keyboard();

      this.fireReady();

      this.queuedData.forEach(function (data) {
        return _this3.addData(data);
      });
      this.queuedData = [];

      return this;
    }
  }]);

  return DropLab;
}();

/* harmony default export */ var drop_lab = __webpack_exports__["a"] = (drop_lab_DropLab);

/***/ }),

/***/ "./droplab/plugins/input_setter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */

var InputSetter = {
  init: function init(hook) {
    this.hook = hook;
    this.destroyed = false;
    this.config = hook.config.InputSetter || (this.hook.config.InputSetter = {});

    this.eventWrapper = {};

    this.addEvents();
  },
  addEvents: function addEvents() {
    this.eventWrapper.setInputs = this.setInputs.bind(this);
    this.hook.list.list.addEventListener('click.dl', this.eventWrapper.setInputs);
  },
  removeEvents: function removeEvents() {
    this.hook.list.list.removeEventListener('click.dl', this.eventWrapper.setInputs);
  },
  setInputs: function setInputs(e) {
    var _this = this;

    if (this.destroyed) return;

    var selectedItem = e.detail.selected;

    if (!Array.isArray(this.config)) this.config = [this.config];

    this.config.forEach(function (config) {
      return _this.setInput(config, selectedItem);
    });
  },
  setInput: function setInput(config, selectedItem) {
    var input = config.input || this.hook.trigger;
    var newValue = selectedItem.getAttribute(config.valueAttribute);
    var inputAttribute = config.inputAttribute;

    if (input.hasAttribute(inputAttribute)) return input.setAttribute(inputAttribute, newValue);
    if (input.tagName === 'INPUT') return input.value = newValue;
    return input.textContent = newValue;
  },
  destroy: function destroy() {
    this.destroyed = true;

    this.removeEvents();
  }
};

/* harmony default export */ __webpack_exports__["a"] = (InputSetter);

/***/ }),

/***/ "./dropzone_input.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preview_markdown__ = __webpack_require__("./preview_markdown.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preview_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__preview_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils_csrf__ = __webpack_require__("./lib/utils/csrf.js");
/* eslint-disable func-names, space-before-function-paren, wrap-iife, max-len, one-var, no-var, one-var-declaration-per-line, no-unused-vars, camelcase, quotes, no-useless-concat, prefer-template, quote-props, comma-dangle, object-shorthand, consistent-return, prefer-arrow-callback */
/* global Dropzone */




window.DropzoneInput = function () {
  function DropzoneInput(form) {
    var divHover = '<div class="div-dropzone-hover"></div>';
    var iconPaperclip = '<i class="fa fa-paperclip div-dropzone-icon"></i>';
    var $attachButton = form.find('.button-attach-file');
    var $attachingFileMessage = form.find('.attaching-file-message');
    var $cancelButton = form.find('.button-cancel-uploading-files');
    var $retryLink = form.find('.retry-uploading-link');
    var $uploadProgress = form.find('.uploading-progress');
    var $uploadingErrorContainer = form.find('.uploading-error-container');
    var $uploadingErrorMessage = form.find('.uploading-error-message');
    var $uploadingProgressContainer = form.find('.uploading-progress-container');
    var uploadsPath = window.uploads_path || null;
    var maxFileSize = gon.max_file_size || 10;
    var formTextarea = form.find('.js-gfm-input');
    var handlePaste = void 0;
    var pasteText = void 0;
    var addFileToForm = void 0;
    var updateAttachingMessage = void 0;
    var isImage = void 0;
    var getFilename = void 0;
    var uploadFile = void 0;

    formTextarea.wrap('<div class="div-dropzone"></div>');
    formTextarea.on('paste', function (_this) {
      return function (event) {
        return handlePaste(event);
      };
    }(this));

    // Add dropzone area to the form.
    var $mdArea = formTextarea.closest('.md-area');
    form.setupMarkdownPreview();
    var $formDropzone = form.find('.div-dropzone');
    $formDropzone.parent().addClass('div-dropzone-wrapper');
    $formDropzone.append(divHover);
    $formDropzone.find('.div-dropzone-hover').append(iconPaperclip);

    if (!uploadsPath) return;

    var dropzone = $formDropzone.dropzone({
      url: uploadsPath,
      dictDefaultMessage: '',
      clickable: true,
      paramName: 'file',
      maxFilesize: maxFileSize,
      uploadMultiple: false,
      headers: __WEBPACK_IMPORTED_MODULE_2__lib_utils_csrf__["a" /* default */].headers,
      previewContainer: false,
      processing: function processing() {
        return $('.div-dropzone-alert').alert('close');
      },
      dragover: function dragover() {
        $mdArea.addClass('is-dropzone-hover');
        form.find('.div-dropzone-hover').css('opacity', 0.7);
      },
      dragleave: function dragleave() {
        $mdArea.removeClass('is-dropzone-hover');
        form.find('.div-dropzone-hover').css('opacity', 0);
      },
      drop: function drop() {
        $mdArea.removeClass('is-dropzone-hover');
        form.find('.div-dropzone-hover').css('opacity', 0);
        formTextarea.focus();
      },
      success: function success(header, response) {
        var processingFileCount = this.getQueuedFiles().length + this.getUploadingFiles().length;
        var shouldPad = processingFileCount >= 1;

        pasteText(response.link.markdown, shouldPad);
        // Show 'Attach a file' link only when all files have been uploaded.
        if (!processingFileCount) $attachButton.removeClass('hide');
        addFileToForm(response.link.url);
      },
      error: function error(file) {
        var errorMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Attaching the file failed.';
        var xhr = arguments[2];

        // If 'error' event is fired by dropzone, the second parameter is error message.
        // If the 'errorMessage' parameter is empty, the default error message is set.
        // If the 'error' event is fired by backend (xhr) error response, the third parameter is
        // xhr object (xhr.responseText is error message).
        // On error we hide the 'Attach' and 'Cancel' buttons
        // and show an error.

        // If there's xhr error message, let's show it instead of dropzone's one.
        var message = xhr ? xhr.responseText : errorMessage;

        $uploadingErrorContainer.removeClass('hide');
        $uploadingErrorMessage.html(message);
        $attachButton.addClass('hide');
        $cancelButton.addClass('hide');
      },
      totaluploadprogress: function totaluploadprogress(totalUploadProgress) {
        updateAttachingMessage(this.files, $attachingFileMessage);
        $uploadProgress.text(Math.round(totalUploadProgress) + '%');
      },
      sending: function sending(file) {
        // DOM elements already exist.
        // Instead of dynamically generating them,
        // we just either hide or show them.
        $attachButton.addClass('hide');
        $uploadingErrorContainer.addClass('hide');
        $uploadingProgressContainer.removeClass('hide');
        $cancelButton.removeClass('hide');
      },
      removedfile: function removedfile() {
        $attachButton.removeClass('hide');
        $cancelButton.addClass('hide');
        $uploadingProgressContainer.addClass('hide');
        $uploadingErrorContainer.addClass('hide');
      },
      queuecomplete: function queuecomplete() {
        $('.dz-preview').remove();
        $('.markdown-area').trigger('input');

        $uploadingProgressContainer.addClass('hide');
        $cancelButton.addClass('hide');
      }
    });

    var child = $(dropzone[0]).children('textarea');

    // removeAllFiles(true) stops uploading files (if any)
    // and remove them from dropzone files queue.
    $cancelButton.on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      Dropzone.forElement($formDropzone.get(0)).removeAllFiles(true);
    });

    // If 'error' event is fired, we store a failed files,
    // clear dropzone files queue, change status of failed files to undefined,
    // and add that files to the dropzone files queue again.
    // addFile() adds file to dropzone files queue and upload it.
    $retryLink.on('click', function (e) {
      var dropzoneInstance = Dropzone.forElement(e.target.closest('.js-main-target-form').querySelector('.div-dropzone'));
      var failedFiles = dropzoneInstance.files;

      e.preventDefault();

      // 'true' parameter of removeAllFiles() cancels uploading of files that are being uploaded at the moment.
      dropzoneInstance.removeAllFiles(true);

      failedFiles.map(function (failedFile, i) {
        var file = failedFile;

        if (file.status === Dropzone.ERROR) {
          file.status = undefined;
          file.accepted = undefined;
        }

        return dropzoneInstance.addFile(file);
      });
    });

    handlePaste = function handlePaste(event) {
      var filename, image, pasteEvent, text;
      pasteEvent = event.originalEvent;
      if (pasteEvent.clipboardData && pasteEvent.clipboardData.items) {
        image = isImage(pasteEvent);
        if (image) {
          event.preventDefault();
          filename = getFilename(pasteEvent) || 'image.png';
          text = '{{' + filename + '}}';
          pasteText(text);
          return uploadFile(image.getAsFile(), filename);
        }
      }
    };

    isImage = function isImage(data) {
      var i, item;
      i = 0;
      while (i < data.clipboardData.items.length) {
        item = data.clipboardData.items[i];
        if (item.type.indexOf('image') !== -1) {
          return item;
        }
        i += 1;
      }
      return false;
    };

    pasteText = function pasteText(text, shouldPad) {
      var afterSelection, beforeSelection, caretEnd, caretStart, textEnd;
      var formattedText = text;
      if (shouldPad) formattedText += "\n\n";
      var textarea = child.get(0);
      caretStart = textarea.selectionStart;
      caretEnd = textarea.selectionEnd;
      textEnd = $(child).val().length;
      beforeSelection = $(child).val().substring(0, caretStart);
      afterSelection = $(child).val().substring(caretEnd, textEnd);
      $(child).val(beforeSelection + formattedText + afterSelection);
      textarea.setSelectionRange(caretStart + formattedText.length, caretEnd + formattedText.length);
      textarea.style.height = textarea.scrollHeight + 'px';
      formTextarea.get(0).dispatchEvent(new Event('input'));
      return formTextarea.trigger('input');
    };

    addFileToForm = function addFileToForm(path) {
      $(form).append('<input type="hidden" name="files[]" value="' + __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(path) + '">');
    };

    getFilename = function getFilename(e) {
      var value;
      if (window.clipboardData && window.clipboardData.getData) {
        value = window.clipboardData.getData('Text');
      } else if (e.clipboardData && e.clipboardData.getData) {
        value = e.clipboardData.getData('text/plain');
      }
      value = value.split("\r");
      return value[0];
    };

    var showSpinner = function showSpinner(e) {
      return $uploadingProgressContainer.removeClass('hide');
    };

    var closeSpinner = function closeSpinner() {
      return $uploadingProgressContainer.addClass('hide');
    };

    var showError = function showError(message) {
      $uploadingErrorContainer.removeClass('hide');
      $uploadingErrorMessage.html(message);
    };

    var closeAlertMessage = function closeAlertMessage() {
      return form.find('.div-dropzone-alert').alert('close');
    };

    var insertToTextArea = function insertToTextArea(filename, url) {
      var $child = $(child);
      $child.val(function (index, val) {
        return val.replace('{{' + filename + '}}', url);
      });

      $child.trigger('change');
    };

    var appendToTextArea = function appendToTextArea(url) {
      return $(child).val(function (index, val) {
        return val + url + "\n";
      });
    };

    uploadFile = function uploadFile(item, filename) {
      var formData;
      formData = new FormData();
      formData.append('file', item, filename);
      return $.ajax({
        url: uploadsPath,
        type: 'POST',
        data: formData,
        dataType: 'json',
        processData: false,
        contentType: false,
        headers: __WEBPACK_IMPORTED_MODULE_2__lib_utils_csrf__["a" /* default */].headers,
        beforeSend: function beforeSend() {
          showSpinner();
          return closeAlertMessage();
        },
        success: function success(e, textStatus, response) {
          return insertToTextArea(filename, response.responseJSON.link.markdown);
        },
        error: function error(response) {
          return showError(response.responseJSON.message);
        },
        complete: function complete() {
          return closeSpinner();
        }
      });
    };

    updateAttachingMessage = function updateAttachingMessage(files, messageContainer) {
      var attachingMessage = void 0;
      var filesCount = files.filter(function (file) {
        return file.status === 'uploading' || file.status === 'queued';
      }).length;

      // Dinamycally change uploading files text depending on files number in
      // dropzone files queue.
      if (filesCount > 1) {
        attachingMessage = 'Attaching ' + filesCount + ' files -';
      } else {
        attachingMessage = 'Attaching a file -';
      }

      messageContainer.text(attachingMessage);
    };

    form.find('.markdown-selector').click(function (e) {
      e.preventDefault();
      $(this).closest('.gfm-form').find('.div-dropzone').click();
      formTextarea.focus();
    });
  }

  return DropzoneInput;
}();
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./due_date_select.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pikaday__ = __webpack_require__("../../../node_modules/pikaday/pikaday.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pikaday___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pikaday__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_datefix__ = __webpack_require__("./lib/utils/datefix.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable wrap-iife, func-names, space-before-function-paren, comma-dangle, prefer-template, consistent-return, class-methods-use-this, arrow-body-style, no-unused-vars, no-underscore-dangle, no-new, max-len, no-sequences, no-unused-expressions, no-param-reassign */
/* global dateFormat */




var DueDateSelect = function () {
  function DueDateSelect() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        $dropdown = _ref.$dropdown,
        $loading = _ref.$loading;

    _classCallCheck(this, DueDateSelect);

    var $dropdownParent = $dropdown.closest('.dropdown');
    var $block = $dropdown.closest('.block');
    this.$loading = $loading;
    this.$dropdown = $dropdown;
    this.$dropdownParent = $dropdownParent;
    this.$datePicker = $dropdownParent.find('.js-due-date-calendar');
    this.$block = $block;
    this.$selectbox = $dropdown.closest('.selectbox');
    this.$value = $block.find('.value');
    this.$valueContent = $block.find('.value-content');
    this.$sidebarValue = $('.js-due-date-sidebar-value', $block);
    this.fieldName = $dropdown.data('field-name'), this.abilityName = $dropdown.data('ability-name'), this.issueUpdateURL = $dropdown.data('issue-update');

    this.rawSelectedDate = null;
    this.displayedDate = null;
    this.datePayload = null;

    this.initGlDropdown();
    this.initRemoveDueDate();
    this.initDatePicker();
  }

  _createClass(DueDateSelect, [{
    key: 'initGlDropdown',
    value: function initGlDropdown() {
      var _this = this;

      this.$dropdown.glDropdown({
        opened: function opened() {
          var calendar = _this.$datePicker.data('pikaday');
          calendar.show();
        },
        hidden: function hidden() {
          _this.$selectbox.hide();
          _this.$value.css('display', '');
        }
      });
    }
  }, {
    key: 'initDatePicker',
    value: function initDatePicker() {
      var _this2 = this;

      var $dueDateInput = $('input[name=\'' + this.fieldName + '\']');
      var dateFix = __WEBPACK_IMPORTED_MODULE_1__lib_utils_datefix__["a" /* default */].dashedFix($dueDateInput.val());
      var calendar = new __WEBPACK_IMPORTED_MODULE_0_pikaday___default.a({
        field: $dueDateInput.get(0),
        theme: 'gitlab-theme',
        format: 'yyyy-mm-dd',
        onSelect: function onSelect(dateText) {
          var formattedDate = dateFormat(new Date(dateText), 'yyyy-mm-dd');
          $dueDateInput.val(formattedDate);

          if (_this2.$dropdown.hasClass('js-issue-boards-due-date')) {
            gl.issueBoards.BoardsStore.detail.issue.dueDate = $dueDateInput.val();
            _this2.updateIssueBoardIssue();
          } else {
            _this2.saveDueDate(true);
          }
        }
      });

      calendar.setDate(dateFix);
      this.$datePicker.append(calendar.el);
      this.$datePicker.data('pikaday', calendar);
    }
  }, {
    key: 'initRemoveDueDate',
    value: function initRemoveDueDate() {
      var _this3 = this;

      this.$block.on('click', '.js-remove-due-date', function (e) {
        var calendar = _this3.$datePicker.data('pikaday');
        e.preventDefault();

        calendar.setDate(null);

        if (_this3.$dropdown.hasClass('js-issue-boards-due-date')) {
          gl.issueBoards.BoardsStore.detail.issue.dueDate = '';
          _this3.updateIssueBoardIssue();
        } else {
          $("input[name='" + _this3.fieldName + "']").val('');
          return _this3.saveDueDate(false);
        }
      });
    }
  }, {
    key: 'saveDueDate',
    value: function saveDueDate(isDropdown) {
      this.parseSelectedDate();
      this.prepSelectedDate();
      this.submitSelectedDate(isDropdown);
    }
  }, {
    key: 'parseSelectedDate',
    value: function parseSelectedDate() {
      this.rawSelectedDate = $('input[name=\'' + this.fieldName + '\']').val();

      if (this.rawSelectedDate.length) {
        // Construct Date object manually to avoid buggy dateString support within Date constructor
        var dateArray = this.rawSelectedDate.split('-').map(function (v) {
          return parseInt(v, 10);
        });
        var dateObj = new Date(dateArray[0], dateArray[1] - 1, dateArray[2]);
        this.displayedDate = dateFormat(dateObj, 'mmm d, yyyy');
      } else {
        this.displayedDate = 'No due date';
      }
    }
  }, {
    key: 'prepSelectedDate',
    value: function prepSelectedDate() {
      var datePayload = {};
      datePayload[this.abilityName] = {};
      datePayload[this.abilityName].due_date = this.rawSelectedDate;
      this.datePayload = datePayload;
    }
  }, {
    key: 'updateIssueBoardIssue',
    value: function updateIssueBoardIssue() {
      var _this4 = this;

      this.$loading.fadeIn();
      this.$dropdown.trigger('loading.gl.dropdown');
      this.$selectbox.hide();
      this.$value.css('display', '');
      var fadeOutLoader = function fadeOutLoader() {
        _this4.$loading.fadeOut();
      };

      gl.issueBoards.BoardsStore.detail.issue.update(this.$dropdown.attr('data-issue-update')).then(fadeOutLoader).catch(fadeOutLoader);
    }
  }, {
    key: 'submitSelectedDate',
    value: function submitSelectedDate(isDropdown) {
      var _this5 = this;

      return $.ajax({
        type: 'PUT',
        url: this.issueUpdateURL,
        data: this.datePayload,
        dataType: 'json',
        beforeSend: function beforeSend() {
          var selectedDateValue = _this5.datePayload[_this5.abilityName].due_date;
          var displayedDateStyle = _this5.displayedDate !== 'No due date' ? 'bold' : 'no-value';

          _this5.$loading.removeClass('hidden').fadeIn();

          if (isDropdown) {
            _this5.$dropdown.trigger('loading.gl.dropdown');
            _this5.$selectbox.hide();
          }

          _this5.$value.css('display', '');
          _this5.$valueContent.html('<span class=\'' + displayedDateStyle + '\'>' + _this5.displayedDate + '</span>');
          _this5.$sidebarValue.html(_this5.displayedDate);

          return selectedDateValue.length ? $('.js-remove-due-date-holder').removeClass('hidden') : $('.js-remove-due-date-holder').addClass('hidden');
        }
      }).done(function (data) {
        if (isDropdown) {
          _this5.$dropdown.trigger('loaded.gl.dropdown');
          _this5.$dropdown.dropdown('toggle');
        }
        return _this5.$loading.fadeOut();
      });
    }
  }]);

  return DueDateSelect;
}();

var DueDateSelectors = function () {
  function DueDateSelectors() {
    _classCallCheck(this, DueDateSelectors);

    this.initMilestoneDatePicker();
    this.initIssuableSelect();
  }

  _createClass(DueDateSelectors, [{
    key: 'initMilestoneDatePicker',
    value: function initMilestoneDatePicker() {
      $('.datepicker').each(function () {
        var $datePicker = $(this);
        var dateFix = __WEBPACK_IMPORTED_MODULE_1__lib_utils_datefix__["a" /* default */].dashedFix($datePicker.val());
        var calendar = new __WEBPACK_IMPORTED_MODULE_0_pikaday___default.a({
          field: $datePicker.get(0),
          theme: 'gitlab-theme animate-picker',
          format: 'yyyy-mm-dd',
          container: $datePicker.parent().get(0),
          onSelect: function onSelect(dateText) {
            $datePicker.val(dateFormat(new Date(dateText), 'yyyy-mm-dd'));
          }
        });

        calendar.setDate(dateFix);

        $datePicker.data('pikaday', calendar);
      });

      $('.js-clear-due-date,.js-clear-start-date').on('click', function (e) {
        e.preventDefault();
        var calendar = $(e.target).siblings('.datepicker').data('pikaday');
        calendar.setDate(null);
      });
    }
  }, {
    key: 'initIssuableSelect',
    value: function initIssuableSelect() {
      var $loading = $('.js-issuable-update .due_date').find('.block-loading').hide();

      $('.js-due-date-select').each(function (i, dropdown) {
        var $dropdown = $(dropdown);
        new DueDateSelect({
          $dropdown: $dropdown,
          $loading: $loading
        });
      });
    }
  }]);

  return DueDateSelectors;
}();

window.gl = window.gl || {};
window.gl.DueDateSelectors = DueDateSelectors;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./ee_trial_banner/ee_trial_banner.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var EETrialBanner = function () {
  function EETrialBanner($trialBanner) {
    _classCallCheck(this, EETrialBanner);

    this.COOKIE_KEY = 'show_ee_trial_banner';
    this.$trialBanner = $trialBanner;
    this.$mainNavbar = this.$trialBanner.siblings('.js-navbar-gitlab');
    this.$secondaryNavbar = this.$mainNavbar.siblings('.js-page-with-sidebar');

    this.licenseExpiresOn = new Date(this.$trialBanner.data('license-expiry'));
  }

  _createClass(EETrialBanner, [{
    key: 'init',
    value: function init() {
      var _this = this;

      // Wait for navbars to render before querying
      this.setCookies();
      this.$trialBanner.on('close.bs.alert', function (e) {
        return _this.handleTrialBannerDismiss(e);
      });
    }

    /**
     * Trial Expiring/Expired Banner has two stages;
     * 1. Show banner when user enters last 7 days of trial
     * 2. Show banner again when last 7 days are over and license has expired
     *
     * Stage 1:
     *    Banner is showed when `trial_license_message` is sent by backend
     *    for the first time (in `app/views/layouts/header/_default.html.haml`).
     *    Here, we perform following steps;
     *
     *    1. Set cookie `show_ee_trial_banner` with expiry same as license
     *    2. Set cookie value to `true`
     *    3. Show banner using `toggleBanner(true)`
     *
     *    At this stage, if user dismisses banner, we set cookie value to `false`
     *    and everytime page is initialized, we check for cookie existence as
     *    well as its value, and decide show/hide status of banner
     *
     * Stage 2:
     *    At this point, Cookie we had set earlier will be expired and
     *    backend will now send updated message in `trial_license_message`.
     *    Here, we perform following steps;
     *
     *    1. Check if cookie is defined (it'll not be defined as it is expired now)
     *    2. If cookie is gone, we re-set `show_ee_trial_banner` cookie but with
     *       expiry of 20 years
     *    3. Set cookie value to `true`
     *    4. Show banner using `toggleBanner(true)`, which now has updated message
     *
     *    At this stage, if user dismisses banner, we set cookie value to `false`
     *    and our existing logic of show/hide banner based on cookie value continues
     *    to work. And since, cookie is set to expire after 20 years, user won't be
     *    seeing banner again.
     */

  }, {
    key: 'setCookies',
    value: function setCookies() {
      var today = new Date();

      // Check if Cookie is defined
      if (!__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(this.COOKIE_KEY)) {
        // Cookie was not defined, let's define with default value

        // Check if License is yet to expire
        if (today < this.licenseExpiresOn) {
          // License has not expired yet, we show initial banner of 7 days
          // with cookie set to validity same as license expiry
          __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(this.COOKIE_KEY, 'true', { expires: this.licenseExpiresOn });
        } else {
          // License is already expired so we show final Banner with cookie set to 20 years validity.
          __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(this.COOKIE_KEY, 'true', { expires: 7300 });
        }

        this.toggleBanner(true);
      } else {
        // Cookie was defined, let's read value and show/hide banner
        this.toggleBanner(__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(this.COOKIE_KEY) === 'true');
      }
    }
  }, {
    key: 'toggleMainNavbarMargin',
    value: function toggleMainNavbarMargin(state) {
      if (this.$mainNavbar.length) {
        this.$mainNavbar.toggleClass('has-trial-banner', state);
      }
    }
  }, {
    key: 'toggleSecondaryNavbarMargin',
    value: function toggleSecondaryNavbarMargin(state) {
      if (this.$secondaryNavbar.length) {
        this.$secondaryNavbar.toggleClass('has-trial-banner', state);
      }
    }
  }, {
    key: 'toggleBanner',
    value: function toggleBanner(state) {
      this.$trialBanner.toggleClass('hidden', !state);
      this.toggleMainNavbarMargin(state);
      this.toggleSecondaryNavbarMargin(state);
    }
  }, {
    key: 'handleTrialBannerDismiss',
    value: function handleTrialBannerDismiss() {
      this.toggleMainNavbarMargin(false);
      this.toggleSecondaryNavbarMargin(false);
      if (__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(this.COOKIE_KEY)) {
        __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(this.COOKIE_KEY, 'false');
      }
    }
  }]);

  return EETrialBanner;
}();

/* harmony default export */ __webpack_exports__["a"] = (EETrialBanner);

/***/ }),

/***/ "./ee_trial_banner/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ee_trial_banner__ = __webpack_require__("./ee_trial_banner/ee_trial_banner.js");


$(function () {
  var $trialBanner = $('.js-gitlab-ee-license-banner');
  if ($trialBanner.length) {
    var eeTrialBanner = new __WEBPACK_IMPORTED_MODULE_0__ee_trial_banner__["a" /* default */]($trialBanner);
    eeTrialBanner.init();
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./experimental_flags.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);


/* harmony default export */ __webpack_exports__["a"] = (function () {
  $('.js-experiment-feature-toggle').on('change', function (e) {
    var el = e.target;

    __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(el.name, el.value, {
      expires: 365 * 10
    });

    document.body.scrollTop = 0;
    window.location.reload();
  });
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./files_comment_button.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, max-len, one-var, one-var-declaration-per-line, quotes, prefer-template, newline-per-chained-call, comma-dangle, new-cap, no-else-return, consistent-return */
/* global notes */

/* Developer beware! Do not add logic to showButton or hideButton
 * that will force a reflow. Doing so will create a signficant performance
 * bottleneck for pages with large diffs. For a comprehensive list of what
 * causes reflows, visit https://gist.github.com/paulirish/5d52fb081b3570c81e3a
 */



var LINE_NUMBER_CLASS = 'diff-line-num';
var UNFOLDABLE_LINE_CLASS = 'js-unfold';
var NO_COMMENT_CLASS = 'no-comment-btn';
var EMPTY_CELL_CLASS = 'empty-cell';
var OLD_LINE_CLASS = 'old_line';
var LINE_COLUMN_CLASSES = '.' + LINE_NUMBER_CLASS + ', .line_content';
var DIFF_CONTAINER_SELECTOR = '.files';
var DIFF_EXPANDED_CLASS = 'diff-expanded';

/* harmony default export */ __webpack_exports__["a"] = ({
  init: function init($diffFile) {
    var _this = this;

    /* Caching is used only when the following members are *true*. This is because there are likely to be
     * differently configured versions of diffs in the same session. However if these values are true, they
     * will be true in all cases */

    if (!this.userCanCreateNote) {
      // data-can-create-note is an empty string when true, otherwise undefined
      this.userCanCreateNote = $diffFile.closest(DIFF_CONTAINER_SELECTOR).data('can-create-note') === '';
    }

    this.isParallelView = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('diff_view') === 'parallel';

    if (this.userCanCreateNote) {
      $diffFile.on('mouseover', LINE_COLUMN_CLASSES, function (e) {
        return _this.showButton(_this.isParallelView, e);
      }).on('mouseleave', LINE_COLUMN_CLASSES, function (e) {
        return _this.hideButton(_this.isParallelView, e);
      });
    }
  },
  showButton: function showButton(isParallelView, e) {
    var buttonParentElement = this.getButtonParent(e.currentTarget, isParallelView);

    if (!this.validateButtonParent(buttonParentElement)) return;

    buttonParentElement.classList.add('is-over');
    buttonParentElement.nextElementSibling.classList.add('is-over');
  },
  hideButton: function hideButton(isParallelView, e) {
    var buttonParentElement = this.getButtonParent(e.currentTarget, isParallelView);

    buttonParentElement.classList.remove('is-over');
    buttonParentElement.nextElementSibling.classList.remove('is-over');
  },
  getButtonParent: function getButtonParent(hoveredElement, isParallelView) {
    if (isParallelView) {
      if (!hoveredElement.classList.contains(LINE_NUMBER_CLASS)) {
        return hoveredElement.previousElementSibling;
      }
    } else if (!hoveredElement.classList.contains(OLD_LINE_CLASS)) {
      return hoveredElement.parentNode.querySelector('.' + OLD_LINE_CLASS);
    }
    return hoveredElement;
  },
  validateButtonParent: function validateButtonParent(buttonParentElement) {
    return !buttonParentElement.classList.contains(EMPTY_CELL_CLASS) && !buttonParentElement.classList.contains(UNFOLDABLE_LINE_CLASS) && !buttonParentElement.classList.contains(NO_COMMENT_CLASS) && !buttonParentElement.parentNode.classList.contains(DIFF_EXPANDED_CLASS);
  }
});

/***/ }),

/***/ "./filterable_list.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



/**
 * Makes search request for content when user types a value in the search input.
 * Updates the html content of the page with the received one.
 */

var FilterableList = function () {
  function FilterableList(form, filter, holder) {
    _classCallCheck(this, FilterableList);

    this.filterForm = form;
    this.listFilterElement = filter;
    this.listHolderElement = holder;
    this.isBusy = false;
  }

  _createClass(FilterableList, [{
    key: 'getFilterEndpoint',
    value: function getFilterEndpoint() {
      return this.filterForm.getAttribute('action') + '?' + $(this.filterForm).serialize();
    }
  }, {
    key: 'getPagePath',
    value: function getPagePath() {
      return this.getFilterEndpoint();
    }
  }, {
    key: 'initSearch',
    value: function initSearch() {
      // Wrap to prevent passing event arguments to .filterResults;
      this.debounceFilter = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.debounce(this.onFilterInput.bind(this), 500);

      this.unbindEvents();
      this.bindEvents();
    }
  }, {
    key: 'onFilterInput',
    value: function onFilterInput() {
      var $form = $(this.filterForm);
      var queryData = {};
      var filterGroupsParam = $form.find('[name="filter_groups"]').val();

      if (filterGroupsParam) {
        queryData.filter_groups = filterGroupsParam;
      }

      this.filterResults(queryData);

      if (this.setDefaultFilterOption) {
        this.setDefaultFilterOption();
      }
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      this.listFilterElement.addEventListener('input', this.debounceFilter);
    }
  }, {
    key: 'unbindEvents',
    value: function unbindEvents() {
      this.listFilterElement.removeEventListener('input', this.debounceFilter);
    }
  }, {
    key: 'filterResults',
    value: function filterResults(queryData) {
      var _this = this;

      if (this.isBusy) {
        return false;
      }

      $(this.listHolderElement).fadeTo(250, 0.5);

      return $.ajax({
        url: this.getFilterEndpoint(),
        data: queryData,
        type: 'GET',
        dataType: 'json',
        context: this,
        complete: this.onFilterComplete,
        beforeSend: function beforeSend() {
          _this.isBusy = true;
        },
        success: function success(response, textStatus, xhr) {
          _this.onFilterSuccess(response, xhr, queryData);
        }
      });
    }
  }, {
    key: 'onFilterSuccess',
    value: function onFilterSuccess(response, xhr, queryData) {
      if (response.html) {
        this.listHolderElement.innerHTML = response.html;
      }

      // Change url so if user reload a page - search results are saved
      var currentPath = this.getPagePath(queryData);

      return window.history.replaceState({
        page: currentPath
      }, document.title, currentPath);
    }
  }, {
    key: 'onFilterComplete',
    value: function onFilterComplete() {
      this.isBusy = false;
      $(this.listHolderElement).fadeTo(250, 1);
    }
  }]);

  return FilterableList;
}();

/* harmony default export */ __webpack_exports__["a"] = (FilterableList);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./filtered_search/container.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this */
var container = document;

var FilteredSearchContainerClass = function () {
  function FilteredSearchContainerClass() {
    _classCallCheck(this, FilteredSearchContainerClass);
  }

  _createClass(FilteredSearchContainerClass, [{
    key: "container",
    set: function set(containerParam) {
      container = containerParam;
    },
    get: function get() {
      return container;
    }
  }]);

  return FilteredSearchContainerClass;
}();

/* harmony default export */ __webpack_exports__["a"] = (new FilteredSearchContainerClass());

/***/ }),

/***/ "./filtered_search/dropdown_utils.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__container__ = __webpack_require__("./filtered_search/container.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var DropdownUtils = function () {
  function DropdownUtils() {
    _classCallCheck(this, DropdownUtils);
  }

  _createClass(DropdownUtils, null, [{
    key: 'getEscapedText',
    value: function getEscapedText(text) {
      var escapedText = text;
      var hasSpace = text.indexOf(' ') !== -1;
      var hasDoubleQuote = text.indexOf('"') !== -1;

      // Encapsulate value with quotes if it has spaces
      // Known side effect: values's with both single and double quotes
      // won't escape properly
      if (hasSpace) {
        if (hasDoubleQuote) {
          escapedText = '\'' + text + '\'';
        } else {
          // Encapsulate singleQuotes or if it hasSpace
          escapedText = '"' + text + '"';
        }
      }

      return escapedText;
    }
  }, {
    key: 'filterWithSymbol',
    value: function filterWithSymbol(filterSymbol, input, item) {
      var updatedItem = item;
      var searchInput = gl.DropdownUtils.getSearchInput(input);

      var title = updatedItem.title.toLowerCase();
      var value = searchInput.toLowerCase();
      var symbol = '';

      // Remove the symbol for filter
      if (value[0] === filterSymbol) {
        symbol = value[0];
        value = value.slice(1);
      }

      // Removes the first character if it is a quotation so that we can search
      // with multiple words
      if ((value[0] === '"' || value[0] === '\'') && title.indexOf(' ') !== -1) {
        value = value.slice(1);
      }

      // Eg. filterSymbol = ~ for labels
      var matchWithoutSymbol = symbol === filterSymbol && title.indexOf(value) !== -1;
      var match = title.indexOf('' + symbol + value) !== -1;

      updatedItem.droplab_hidden = !match && !matchWithoutSymbol;

      return updatedItem;
    }
  }, {
    key: 'mergeDuplicateLabels',
    value: function mergeDuplicateLabels(dataMap, newLabel) {
      var updatedMap = dataMap;
      var key = newLabel.title;

      var hasKeyProperty = Object.prototype.hasOwnProperty.call(updatedMap, key);

      if (!hasKeyProperty) {
        updatedMap[key] = newLabel;
      } else {
        var existing = updatedMap[key];

        if (!existing.multipleColors) {
          existing.multipleColors = [existing.color];
        }

        existing.multipleColors.push(newLabel.color);
      }

      return updatedMap;
    }
  }, {
    key: 'duplicateLabelColor',
    value: function duplicateLabelColor(labelColors) {
      var colors = labelColors;
      var spacing = 100 / colors.length;

      // Reduce the colors to 4
      colors.length = Math.min(colors.length, 4);

      var color = colors.map(function (c, i) {
        var percentFirst = Math.floor(spacing * i);
        var percentSecond = Math.floor(spacing * (i + 1));
        return c + ' ' + percentFirst + '%, ' + c + ' ' + percentSecond + '%';
      }).join(', ');

      return 'linear-gradient(' + color + ')';
    }
  }, {
    key: 'duplicateLabelPreprocessing',
    value: function duplicateLabelPreprocessing(data) {
      var results = [];
      var dataMap = {};

      data.forEach(DropdownUtils.mergeDuplicateLabels.bind(null, dataMap));

      Object.keys(dataMap).forEach(function (key) {
        var label = dataMap[key];

        if (label.multipleColors) {
          label.color = DropdownUtils.duplicateLabelColor(label.multipleColors);
          label.text_color = '#000000';
        }

        results.push(label);
      });

      results.preprocessed = true;

      return results;
    }
  }, {
    key: 'filterHint',
    value: function filterHint(config, item) {
      var input = config.input,
          allowedKeys = config.allowedKeys;

      var updatedItem = item;
      var searchInput = gl.DropdownUtils.getSearchQuery(input);

      var _gl$FilteredSearchTok = gl.FilteredSearchTokenizer.processTokens(searchInput, allowedKeys),
          lastToken = _gl$FilteredSearchTok.lastToken,
          tokens = _gl$FilteredSearchTok.tokens;

      var lastKey = lastToken.key || lastToken || '';
      var allowMultiple = item.type === 'array';
      var itemInExistingTokens = tokens.some(function (t) {
        return t.key === item.hint;
      });

      if (!allowMultiple && itemInExistingTokens) {
        updatedItem.droplab_hidden = true;
      } else if (!lastKey || __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.last(searchInput.split('')) === ' ') {
        updatedItem.droplab_hidden = false;
      } else if (lastKey) {
        var split = lastKey.split(':');
        var tokenName = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.last(split[0].split(' '));

        var match = updatedItem.hint.indexOf(tokenName.toLowerCase()) === -1;
        updatedItem.droplab_hidden = tokenName ? match : false;
      }

      return updatedItem;
    }
  }, {
    key: 'setDataValueIfSelected',
    value: function setDataValueIfSelected(filter, selected) {
      var dataValue = selected.getAttribute('data-value');

      if (dataValue) {
        gl.FilteredSearchDropdownManager.addWordToInput(filter, dataValue, true);
      }

      // Return boolean based on whether it was set
      return dataValue !== null;
    }

    // Determines the full search query (visual tokens + input)

  }, {
    key: 'getSearchQuery',
    value: function getSearchQuery() {
      var untilInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var container = __WEBPACK_IMPORTED_MODULE_1__container__["a" /* default */].container;
      var tokens = [].slice.call(container.querySelectorAll('.tokens-container li'));
      var values = [];

      if (untilInput) {
        var inputIndex = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.findIndex(tokens, function (t) {
          return t.classList.contains('input-token');
        });
        // Add one to include input-token to the tokens array
        tokens.splice(inputIndex + 1);
      }

      tokens.forEach(function (token) {
        if (token.classList.contains('js-visual-token')) {
          var name = token.querySelector('.name');
          var value = token.querySelector('.value');
          var valueContainer = token.querySelector('.value-container');
          var symbol = value && value.dataset.symbol ? value.dataset.symbol : '';
          var valueText = '';

          if (valueContainer && valueContainer.dataset.originalValue) {
            valueText = valueContainer.dataset.originalValue;
          } else if (value && value.innerText) {
            valueText = value.innerText;
          }

          if (token.className.indexOf('filtered-search-token') !== -1) {
            values.push(name.innerText.toLowerCase() + ':' + symbol + valueText);
          } else {
            values.push(name.innerText);
          }
        } else if (token.classList.contains('input-token')) {
          var _gl$FilteredSearchVis = gl.FilteredSearchVisualTokens.getLastVisualTokenBeforeInput(),
              isLastVisualTokenValid = _gl$FilteredSearchVis.isLastVisualTokenValid;

          var input = __WEBPACK_IMPORTED_MODULE_1__container__["a" /* default */].container.querySelector('.filtered-search');
          var inputValue = input && input.value;

          if (isLastVisualTokenValid) {
            values.push(inputValue);
          } else {
            var previous = values.pop();
            values.push('' + previous + inputValue);
          }
        }
      });

      return values.map(function (value) {
        return value.trim();
      }).join(' ');
    }
  }, {
    key: 'getSearchInput',
    value: function getSearchInput(filteredSearchInput) {
      var inputValue = filteredSearchInput.value;

      var _gl$DropdownUtils$get = gl.DropdownUtils.getInputSelectionPosition(filteredSearchInput),
          right = _gl$DropdownUtils$get.right;

      return inputValue.slice(0, right);
    }
  }, {
    key: 'getInputSelectionPosition',
    value: function getInputSelectionPosition(input) {
      var selectionStart = input.selectionStart;
      var inputValue = input.value;
      // Replace all spaces inside quote marks with underscores
      // (will continue to match entire string until an end quote is found if any)
      // This helps with matching the beginning & end of a token:key
      inputValue = inputValue.replace(/(('[^']*'{0,1})|("[^"]*"{0,1})|:\s+)/g, function (str) {
        return str.replace(/\s/g, '_');
      });

      // Get the right position for the word selected
      // Regex matches first space
      var right = inputValue.slice(selectionStart).search(/\s/);

      if (right >= 0) {
        right += selectionStart;
      } else if (right < 0) {
        right = inputValue.length;
      }

      // Get the left position for the word selected
      // Regex matches last non-whitespace character
      var left = inputValue.slice(0, right).search(/\S+$/);

      if (selectionStart === 0) {
        left = 0;
      } else if (selectionStart === inputValue.length && left < 0) {
        left = inputValue.length;
      } else if (left < 0) {
        left = selectionStart;
      }

      return {
        left: left,
        right: right
      };
    }
  }]);

  return DropdownUtils;
}();

window.gl = window.gl || {};
gl.DropdownUtils = DropdownUtils;

/***/ }),

/***/ "./flash.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, one-var, one-var-declaration-per-line, no-param-reassign, quotes, quote-props, prefer-template, comma-dangle, max-len */

window.Flash = function () {
  var hideFlash;

  hideFlash = function hideFlash() {
    return $(this).fadeOut();
  };

  /**
   * Flash banner supports different types of Flash configurations
   * along with ability to provide actionConfig which can be used to show
   * additional action or link on banner next to message
   *
   * @param {String} message Flash message
   * @param {String} type Type of Flash, it can be `notice` or `alert` (default)
   * @param {Object} parent Reference to Parent element under which Flash needs to appear
   * @param {Object} actionConfig Map of config to show action on banner
   *    @param {String} href URL to which action link should point (default '#')
   *    @param {String} title Title of action
   *    @param {Function} clickHandler Method to call when action is clicked on
   */
  function Flash(message, type, parent, actionConfig) {
    var flash, textDiv, actionLink;
    if (type == null) {
      type = 'alert';
    }
    if (parent == null) {
      parent = null;
    }
    if (parent) {
      var $parent = $(parent);
      this.flashContainer = $parent.find('.flash-container');
    } else {
      this.flashContainer = $('.flash-container-page');
    }
    this.flashContainer.html('');
    flash = $('<div/>', {
      "class": "flash-" + type
    });
    flash.on('click', hideFlash);
    textDiv = $('<div/>', {
      "class": 'flash-text',
      text: message
    });
    textDiv.appendTo(flash);

    if (actionConfig) {
      var actionLinkConfig = {
        class: 'flash-action',
        href: actionConfig.href || '#',
        text: actionConfig.title
      };

      if (!actionConfig.href) {
        actionLinkConfig.role = 'button';
      }

      actionLink = $('<a/>', actionLinkConfig);

      actionLink.appendTo(flash);
      this.flashContainer.on('click', '.flash-action', actionConfig.clickHandler);
    }
    if (this.flashContainer.parent().hasClass('content-wrapper')) {
      textDiv.addClass('container-fluid container-limited');
    }
    flash.appendTo(this.flashContainer);
    this.flashContainer.show();
  }

  Flash.prototype.destroy = function () {
    this.flashContainer.html('');
  };

  return Flash;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./fly_out_nav.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mousePos */
/* unused harmony export setSidebar */
/* unused harmony export getOpenMenu */
/* unused harmony export setOpenMenu */
/* unused harmony export slope */
/* unused harmony export getHeaderHeight */
/* unused harmony export isSidebarCollapsed */
/* unused harmony export canShowActiveSubItems */
/* unused harmony export canShowSubItems */
/* unused harmony export getHideSubItemsInterval */
/* unused harmony export calculateTop */
/* unused harmony export hideMenu */
/* unused harmony export moveSubItemsToPosition */
/* unused harmony export showSubLevelItems */
/* unused harmony export mouseEnterTopItems */
/* unused harmony export mouseLeaveTopItem */
/* unused harmony export documentMouseMove */
/* unused harmony export subItemsMouseLeave */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__breakpoints__ = __webpack_require__("./breakpoints.js");
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



var HIDE_INTERVAL_TIMEOUT = 300;
var IS_OVER_CLASS = 'is-over';
var IS_ABOVE_CLASS = 'is-above';
var IS_SHOWING_FLY_OUT_CLASS = 'is-showing-fly-out';
var currentOpenMenu = null;
var menuCornerLocs = void 0;
var timeoutId = void 0;
var sidebar = void 0;

var mousePos = [];

var setSidebar = function setSidebar(el) {
  sidebar = el;
};
var getOpenMenu = function getOpenMenu() {
  return currentOpenMenu;
};
var setOpenMenu = function setOpenMenu() {
  var menu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  currentOpenMenu = menu;
};

var slope = function slope(a, b) {
  return (b.y - a.y) / (b.x - a.x);
};

var headerHeight = 50;

var getHeaderHeight = function getHeaderHeight() {
  return headerHeight;
};

var isSidebarCollapsed = function isSidebarCollapsed() {
  return sidebar && sidebar.classList.contains('sidebar-icons-only');
};

var canShowActiveSubItems = function canShowActiveSubItems(el) {
  if (el.classList.contains('active') && !isSidebarCollapsed()) {
    return false;
  }

  return true;
};

var canShowSubItems = function canShowSubItems() {
  return __WEBPACK_IMPORTED_MODULE_0__breakpoints__["a" /* default */].getBreakpointSize() === 'sm' || __WEBPACK_IMPORTED_MODULE_0__breakpoints__["a" /* default */].getBreakpointSize() === 'md' || __WEBPACK_IMPORTED_MODULE_0__breakpoints__["a" /* default */].getBreakpointSize() === 'lg';
};

var getHideSubItemsInterval = function getHideSubItemsInterval() {
  if (!currentOpenMenu || !mousePos.length) return 0;

  var currentMousePos = mousePos[mousePos.length - 1];
  var prevMousePos = mousePos[0];
  var currentMousePosY = currentMousePos.y;

  var _menuCornerLocs = menuCornerLocs,
      _menuCornerLocs2 = _slicedToArray(_menuCornerLocs, 2),
      menuTop = _menuCornerLocs2[0],
      menuBottom = _menuCornerLocs2[1];

  if (currentMousePosY < menuTop.y || currentMousePosY > menuBottom.y) return 0;

  if (slope(prevMousePos, menuBottom) < slope(currentMousePos, menuBottom) && slope(prevMousePos, menuTop) > slope(currentMousePos, menuTop)) {
    return HIDE_INTERVAL_TIMEOUT;
  }

  return 0;
};

var calculateTop = function calculateTop(boundingRect, outerHeight) {
  var windowHeight = window.innerHeight;
  var bottomOverflow = windowHeight - (boundingRect.top + outerHeight);

  return bottomOverflow < 0 ? boundingRect.top - outerHeight + boundingRect.height : boundingRect.top;
};

var hideMenu = function hideMenu(el) {
  if (!el) return;

  var parentEl = el.parentNode;

  el.style.display = ''; // eslint-disable-line no-param-reassign
  el.style.transform = ''; // eslint-disable-line no-param-reassign
  el.classList.remove(IS_ABOVE_CLASS);
  parentEl.classList.remove(IS_OVER_CLASS);
  parentEl.classList.remove(IS_SHOWING_FLY_OUT_CLASS);

  setOpenMenu();
};

var moveSubItemsToPosition = function moveSubItemsToPosition(el, subItems) {
  var boundingRect = el.getBoundingClientRect();
  var top = calculateTop(boundingRect, subItems.offsetHeight);
  var left = sidebar ? sidebar.offsetWidth : 50;
  var isAbove = top < boundingRect.top;

  subItems.classList.add('fly-out-list');
  subItems.style.transform = 'translate3d(' + left + 'px, ' + (Math.floor(top) - headerHeight) + 'px, 0)'; // eslint-disable-line no-param-reassign

  var subItemsRect = subItems.getBoundingClientRect();

  menuCornerLocs = [{
    x: subItemsRect.left, // left position of the sub items
    y: subItemsRect.top }, {
    x: subItemsRect.left, // left position of the sub items
    y: subItemsRect.top + subItemsRect.height }];

  if (isAbove) {
    subItems.classList.add(IS_ABOVE_CLASS);
  }
};

var showSubLevelItems = function showSubLevelItems(el) {
  var subItems = el.querySelector('.sidebar-sub-level-items');
  var isIconOnly = subItems && subItems.classList.contains('is-fly-out-only');

  if (!canShowSubItems() || !canShowActiveSubItems(el)) return;

  el.classList.add(IS_OVER_CLASS);

  if (!subItems || !isSidebarCollapsed() && isIconOnly) return;

  subItems.style.display = 'block';
  el.classList.add(IS_SHOWING_FLY_OUT_CLASS);

  setOpenMenu(subItems);
  moveSubItemsToPosition(el, subItems);
};

var mouseEnterTopItems = function mouseEnterTopItems(el) {
  clearTimeout(timeoutId);

  timeoutId = setTimeout(function () {
    if (currentOpenMenu) hideMenu(currentOpenMenu);

    showSubLevelItems(el);
  }, getHideSubItemsInterval());
};

var mouseLeaveTopItem = function mouseLeaveTopItem(el) {
  var subItems = el.querySelector('.sidebar-sub-level-items');

  if (!canShowSubItems() || !canShowActiveSubItems(el) || subItems && subItems === currentOpenMenu) return;

  el.classList.remove(IS_OVER_CLASS);
};

var documentMouseMove = function documentMouseMove(e) {
  mousePos.push({
    x: e.clientX,
    y: e.clientY
  });

  if (mousePos.length > 6) mousePos.shift();
};

var subItemsMouseLeave = function subItemsMouseLeave(relatedTarget) {
  clearTimeout(timeoutId);

  if (relatedTarget && !relatedTarget.closest('.' + IS_OVER_CLASS)) {
    hideMenu(currentOpenMenu);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  sidebar = document.querySelector('.nav-sidebar');

  if (!sidebar) return;

  var items = [].concat(_toConsumableArray(sidebar.querySelectorAll('.sidebar-top-level-items > li')));

  sidebar.querySelector('.sidebar-top-level-items').addEventListener('mouseleave', function () {
    clearTimeout(timeoutId);

    timeoutId = setTimeout(function () {
      if (currentOpenMenu) hideMenu(currentOpenMenu);
    }, getHideSubItemsInterval());
  });

  headerHeight = document.querySelector('.nav-sidebar').offsetTop;

  items.forEach(function (el) {
    var subItems = el.querySelector('.sidebar-sub-level-items');

    if (subItems) {
      subItems.addEventListener('mouseleave', function (e) {
        return subItemsMouseLeave(e.relatedTarget);
      });
    }

    el.addEventListener('mouseenter', function (e) {
      return mouseEnterTopItems(e.currentTarget);
    });
    el.addEventListener('mouseleave', function (e) {
      return mouseLeaveTopItem(e.currentTarget);
    });
  });

  document.addEventListener('mousemove', documentMouseMove);
});

/***/ }),

/***/ "./geo_nodes.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__smart_interval__ = __webpack_require__("./smart_interval.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__smart_interval___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__smart_interval__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_pretty_time__ = __webpack_require__("./lib/utils/pretty_time.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-new*/



var healthyClass = 'geo-node-healthy';
var unhealthyClass = 'geo-node-unhealthy';
var unknownClass = 'geo-node-unknown';
var healthyIcon = 'fa-check';
var unhealthyIcon = 'fa-times';
var unknownIcon = 'fa-times';

var GeoNodeStatus = function () {
  function GeoNodeStatus(el) {
    _classCallCheck(this, GeoNodeStatus);

    this.$el = $(el);
    this.$icon = $('.js-geo-node-icon', this.$el);
    this.$loadingIcon = $('.js-geo-node-loading', this.$el);
    this.$dbReplicationLag = $('.js-db-replication-lag', this.$status);
    this.$healthStatus = $('.js-health-status', this.$el);
    this.$status = $('.js-geo-node-status', this.$el);
    this.$repositoriesSynced = $('.js-repositories-synced', this.$status);
    this.$repositoriesFailed = $('.js-repositories-failed', this.$status);
    this.$lfsObjectsSynced = $('.js-lfs-objects-synced', this.$status);
    this.$lfsObjectsFailed = $('.js-lfs-objects-failed', this.$status);
    this.$attachmentsSynced = $('.js-attachments-synced', this.$status);
    this.$attachmentsFailed = $('.js-attachments-failed', this.$status);
    this.$lastEventSeen = $('.js-last-event-seen', this.$status);
    this.$lastCursorEvent = $('.js-last-cursor-event', this.$status);
    this.$health = $('.js-health', this.$status);
    this.endpoint = this.$el.data('status-url');
    this.$advancedStatus = $('.js-advanced-geo-node-status-toggler', this.$status);
    this.$advancedStatus.on('click', GeoNodeStatus.toggleShowAdvancedStatus);

    this.statusInterval = new gl.SmartInterval({
      callback: this.getStatus.bind(this),
      startingInterval: 30000,
      maxInterval: 120000,
      hiddenInterval: 240000,
      incrementByFactorOf: 15000,
      immediateExecution: true
    });
  }

  _createClass(GeoNodeStatus, [{
    key: 'getStatus',
    value: function getStatus() {
      var _this = this;

      $.getJSON(this.endpoint, function (status) {
        _this.setStatusIcon(status.healthy);
        _this.setHealthStatus(status.healthy);

        // Replication lag can be nil if the secondary isn't actually streaming
        if (status.db_replication_lag) {
          var parsedTime = Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils_pretty_time__["b" /* parseSeconds */])(status.db_replication_lag, {
            hoursPerDay: 24,
            daysPerWeek: 7
          });
          _this.$dbReplicationLag.text(Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils_pretty_time__["c" /* stringifyTime */])(parsedTime));
        } else {
          _this.$dbReplicationLag.text('UNKNOWN');
        }

        _this.$repositoriesSynced.text(status.repositories_synced_count + '/' + status.repositories_count + ' (' + status.repositories_synced_in_percentage + ')');
        _this.$repositoriesFailed.text(status.repositories_failed_count);
        _this.$lfsObjectsSynced.text(status.lfs_objects_synced_count + '/' + status.lfs_objects_count + ' (' + status.lfs_objects_synced_in_percentage + ')');
        _this.$lfsObjectsFailed.text(status.lfs_objects_failed_count);
        _this.$attachmentsSynced.text(status.attachments_synced_count + '/' + status.attachments_count + ' (' + status.attachments_synced_in_percentage + ')');
        _this.$attachmentsFailed.text(status.attachments_failed_count);

        var eventDate = gl.utils.formatDate(new Date(status.last_event_date));
        var cursorDate = gl.utils.formatDate(new Date(status.cursor_last_event_date));
        _this.$lastEventSeen.text(status.last_event_id + ' (' + eventDate + ')');
        _this.$lastCursorEvent.text(status.cursor_last_event_id + ' (' + cursorDate + ')');
        if (status.health === 'Healthy') {
          _this.$health.text('');
        } else {
          var strippedData = $('<div>').html('' + status.health).text();
          _this.$health.html('<code class="geo-health">' + strippedData + '</code>');
        }

        _this.$status.show();
      });
    }
  }, {
    key: 'setStatusIcon',
    value: function setStatusIcon(healthy) {
      this.$loadingIcon.hide();
      this.$icon.removeClass(unknownClass + ' ' + unknownIcon);

      if (healthy) {
        this.$icon.removeClass(unhealthyClass + ' ' + unhealthyIcon).addClass(healthyClass + ' ' + healthyIcon).attr('title', 'Healthy');
      } else {
        this.$icon.removeClass(healthyClass + ' ' + healthyIcon).addClass(unhealthyClass + ' ' + unhealthyIcon).attr('title', 'Unhealthy');
      }
    }
  }, {
    key: 'setHealthStatus',
    value: function setHealthStatus(healthy) {
      if (healthy) {
        this.$healthStatus.removeClass(unhealthyClass).addClass(healthyClass).text('Healthy');
      } else {
        this.$healthStatus.removeClass(healthyClass).addClass(unhealthyClass).text('Unhealthy');
      }
    }
  }], [{
    key: 'toggleShowAdvancedStatus',
    value: function toggleShowAdvancedStatus(e) {
      var $element = $(e.currentTarget);
      var $closestStatus = $element.siblings('.advanced-status');

      $element.find('.fa').toggleClass('fa-angle-down').toggleClass('fa-angle-up');
      $closestStatus.toggleClass('hidden');
    }
  }]);

  return GeoNodeStatus;
}();

var GeoNodes = function () {
  function GeoNodes(container) {
    _classCallCheck(this, GeoNodes);

    this.$container = $(container);
    this.pollForSecondaryNodeStatus();
  }

  _createClass(GeoNodes, [{
    key: 'pollForSecondaryNodeStatus',
    value: function pollForSecondaryNodeStatus() {
      $('.js-geo-secondary-node', this.$container).each(function (i, el) {
        new GeoNodeStatus(el);
      });
    }
  }]);

  return GeoNodes;
}();

/* harmony default export */ __webpack_exports__["a"] = (GeoNodes);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./gfm_auto_complete.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_regexp__ = __webpack_require__("./lib/utils/regexp.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils_ajax_cache__ = __webpack_require__("./lib/utils/ajax_cache.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





function sanitize(str) {
  return str.replace(/<(?:.|\n)*?>/gm, '');
}

var GfmAutoComplete = function () {
  function GfmAutoComplete(dataSources) {
    _classCallCheck(this, GfmAutoComplete);

    this.dataSources = dataSources || {};
    this.cachedData = {};
    this.isLoadingData = {};
  }

  _createClass(GfmAutoComplete, [{
    key: 'setup',
    value: function setup(input) {
      var enableMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        emojis: true,
        members: true,
        issues: true,
        milestones: true,
        mergeRequests: true,
        labels: true
      };

      // Add GFM auto-completion to all input fields, that accept GFM input.
      this.input = input || $('.js-gfm-input');
      this.enableMap = enableMap;
      this.setupLifecycle();
    }
  }, {
    key: 'setupLifecycle',
    value: function setupLifecycle() {
      var _this = this;

      this.input.each(function (i, input) {
        var $input = $(input);
        $input.off('focus.setupAtWho').on('focus.setupAtWho', _this.setupAtWho.bind(_this, $input));
        $input.on('change.atwho', function () {
          return input.dispatchEvent(new Event('input'));
        });
        // This triggers at.js again
        // Needed for quick actions with suffixes (ex: /label ~)
        $input.on('inserted-commands.atwho', $input.trigger.bind($input, 'keyup'));
        $input.on('clear-commands-cache.atwho', function () {
          return _this.clearCache();
        });
      });
    }
  }, {
    key: 'setupAtWho',
    value: function setupAtWho($input) {
      if (this.enableMap.emojis) this.setupEmoji($input);
      if (this.enableMap.members) this.setupMembers($input);
      if (this.enableMap.issues) this.setupIssues($input);
      if (this.enableMap.milestones) this.setupMilestones($input);
      if (this.enableMap.mergeRequests) this.setupMergeRequests($input);
      if (this.enableMap.labels) this.setupLabels($input);

      // We don't instantiate the quick actions autocomplete for note and issue/MR edit forms
      $input.filter('[data-supports-quick-actions="true"]').atwho({
        at: '/',
        alias: 'commands',
        searchKey: 'search',
        skipSpecialCharacterTest: true,
        data: GfmAutoComplete.defaultLoadingData,
        displayTpl: function displayTpl(value) {
          if (GfmAutoComplete.isLoading(value)) return GfmAutoComplete.Loading.template;
          // eslint-disable-next-line no-template-curly-in-string
          var tpl = '<li>/${name}';
          if (value.aliases.length > 0) {
            tpl += ' <small>(or /<%- aliases.join(", /") %>)</small>';
          }
          if (value.params.length > 0) {
            tpl += ' <small><%- params.join(" ") %></small>';
          }
          if (value.description !== '') {
            tpl += '<small class="description"><i><%- description %></i></small>';
          }
          tpl += '</li>';
          return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.template(tpl)(value);
        },
        insertTpl: function insertTpl(value) {
          // eslint-disable-next-line no-template-curly-in-string
          var tpl = '/${name} ';
          var referencePrefix = null;
          if (value.params.length > 0) {
            referencePrefix = value.params[0][0];
            if (/^[@%~]/.test(referencePrefix)) {
              tpl += '<%- referencePrefix %>';
            }
          }
          return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.template(tpl)({ referencePrefix: referencePrefix });
        },

        suffix: '',
        callbacks: _extends({}, this.getDefaultCallbacks(), {
          beforeSave: function beforeSave(commands) {
            if (GfmAutoComplete.isLoading(commands)) return commands;
            return $.map(commands, function (c) {
              var search = c.name;
              if (c.aliases.length > 0) {
                search = search + ' ' + c.aliases.join(' ');
              }
              return {
                name: c.name,
                aliases: c.aliases,
                params: c.params,
                description: c.description,
                search: search
              };
            });
          },
          matcher: function matcher(flag, subtext) {
            var regexp = /(?:^|\n)\/([A-Za-z_]*)$/gi;
            var match = regexp.exec(subtext);
            if (match) {
              return match[1];
            }
            return null;
          }
        })
      });
    }
  }, {
    key: 'setupEmoji',
    value: function setupEmoji($input) {
      // Emoji
      $input.atwho({
        at: ':',
        displayTpl: function displayTpl(value) {
          var tmpl = GfmAutoComplete.Loading.template;
          if (value && value.name) {
            tmpl = GfmAutoComplete.Emoji.templateFunction(value.name);
          }
          return tmpl;
        },

        // eslint-disable-next-line no-template-curly-in-string
        insertTpl: ':${name}:',
        skipSpecialCharacterTest: true,
        data: GfmAutoComplete.defaultLoadingData,
        callbacks: _extends({}, this.getDefaultCallbacks(), {
          matcher: function matcher(flag, subtext) {
            var relevantText = subtext.trim().split(/\s/).pop();
            var regexp = new RegExp('(?:[^' + __WEBPACK_IMPORTED_MODULE_1__lib_utils_regexp__["a" /* default */].unicodeLetters + '0-9:]|\n|^):([^:]*)$', 'gi');
            var match = regexp.exec(relevantText);

            return match && match.length ? match[1] : null;
          }
        })
      });
    }
  }, {
    key: 'setupMembers',
    value: function setupMembers($input) {
      // Team Members
      $input.atwho({
        at: '@',
        displayTpl: function displayTpl(value) {
          var tmpl = GfmAutoComplete.Loading.template;
          if (value.username != null) {
            tmpl = GfmAutoComplete.Members.template;
          }
          return tmpl;
        },

        // eslint-disable-next-line no-template-curly-in-string
        insertTpl: '${atwho-at}${username}',
        searchKey: 'search',
        alwaysHighlightFirst: true,
        skipSpecialCharacterTest: true,
        data: GfmAutoComplete.defaultLoadingData,
        callbacks: _extends({}, this.getDefaultCallbacks(), {
          beforeSave: function beforeSave(members) {
            return $.map(members, function (m) {
              var title = '';
              if (m.username == null) {
                return m;
              }
              title = m.name;
              if (m.count) {
                title += ' (' + m.count + ')';
              }

              var autoCompleteAvatar = m.avatar_url || m.username.charAt(0).toUpperCase();
              var imgAvatar = '<img src="' + m.avatar_url + '" alt="' + m.username + '" class="avatar avatar-inline center s26"/>';
              var txtAvatar = '<div class="avatar center avatar-inline s26">' + autoCompleteAvatar + '</div>';

              return {
                username: m.username,
                avatarTag: autoCompleteAvatar.length === 1 ? txtAvatar : imgAvatar,
                title: sanitize(title),
                search: sanitize(m.username + ' ' + m.name)
              };
            });
          }
        })
      });
    }
  }, {
    key: 'setupIssues',
    value: function setupIssues($input) {
      $input.atwho({
        at: '#',
        alias: 'issues',
        searchKey: 'search',
        displayTpl: function displayTpl(value) {
          var tmpl = GfmAutoComplete.Loading.template;
          if (value.title != null) {
            tmpl = GfmAutoComplete.Issues.template;
          }
          return tmpl;
        },

        data: GfmAutoComplete.defaultLoadingData,
        // eslint-disable-next-line no-template-curly-in-string
        insertTpl: '${atwho-at}${id}',
        callbacks: _extends({}, this.getDefaultCallbacks(), {
          beforeSave: function beforeSave(issues) {
            return $.map(issues, function (i) {
              if (i.title == null) {
                return i;
              }
              return {
                id: i.iid,
                title: sanitize(i.title),
                search: i.iid + ' ' + i.title
              };
            });
          }
        })
      });
    }
  }, {
    key: 'setupMilestones',
    value: function setupMilestones($input) {
      $input.atwho({
        at: '%',
        alias: 'milestones',
        searchKey: 'search',
        // eslint-disable-next-line no-template-curly-in-string
        insertTpl: '${atwho-at}${title}',
        displayTpl: function displayTpl(value) {
          var tmpl = GfmAutoComplete.Loading.template;
          if (value.title != null) {
            tmpl = GfmAutoComplete.Milestones.template;
          }
          return tmpl;
        },

        data: GfmAutoComplete.defaultLoadingData,
        callbacks: _extends({}, this.getDefaultCallbacks(), {
          beforeSave: function beforeSave(milestones) {
            return $.map(milestones, function (m) {
              if (m.title == null) {
                return m;
              }
              return {
                id: m.iid,
                title: sanitize(m.title),
                search: m.title
              };
            });
          }
        })
      });
    }
  }, {
    key: 'setupMergeRequests',
    value: function setupMergeRequests($input) {
      $input.atwho({
        at: '!',
        alias: 'mergerequests',
        searchKey: 'search',
        displayTpl: function displayTpl(value) {
          var tmpl = GfmAutoComplete.Loading.template;
          if (value.title != null) {
            tmpl = GfmAutoComplete.Issues.template;
          }
          return tmpl;
        },

        data: GfmAutoComplete.defaultLoadingData,
        // eslint-disable-next-line no-template-curly-in-string
        insertTpl: '${atwho-at}${id}',
        callbacks: _extends({}, this.getDefaultCallbacks(), {
          beforeSave: function beforeSave(merges) {
            return $.map(merges, function (m) {
              if (m.title == null) {
                return m;
              }
              return {
                id: m.iid,
                title: sanitize(m.title),
                search: m.iid + ' ' + m.title
              };
            });
          }
        })
      });
    }
  }, {
    key: 'setupLabels',
    value: function setupLabels($input) {
      $input.atwho({
        at: '~',
        alias: 'labels',
        searchKey: 'search',
        data: GfmAutoComplete.defaultLoadingData,
        displayTpl: function displayTpl(value) {
          var tmpl = GfmAutoComplete.Labels.template;
          if (GfmAutoComplete.isLoading(value)) {
            tmpl = GfmAutoComplete.Loading.template;
          }
          return tmpl;
        },

        // eslint-disable-next-line no-template-curly-in-string
        insertTpl: '${atwho-at}${title}',
        callbacks: _extends({}, this.getDefaultCallbacks(), {
          beforeSave: function beforeSave(merges) {
            if (GfmAutoComplete.isLoading(merges)) return merges;
            return $.map(merges, function (m) {
              return {
                title: sanitize(m.title),
                color: m.color,
                search: m.title
              };
            });
          }
        })
      });
    }
  }, {
    key: 'getDefaultCallbacks',
    value: function getDefaultCallbacks() {
      var fetchData = this.fetchData.bind(this);

      return {
        sorter: function sorter(query, items, searchKey) {
          this.setting.highlightFirst = this.setting.alwaysHighlightFirst || query.length > 0;
          if (GfmAutoComplete.isLoading(items)) {
            this.setting.highlightFirst = false;
            return items;
          }
          return $.fn.atwho.default.callbacks.sorter(query, items, searchKey);
        },
        filter: function filter(query, data, searchKey) {
          if (GfmAutoComplete.isLoading(data)) {
            fetchData(this.$inputor, this.at);
            return data;
          }
          return $.fn.atwho.default.callbacks.filter(query, data, searchKey);
        },
        beforeInsert: function beforeInsert(value) {
          var resultantValue = value;
          if (value && !this.setting.skipSpecialCharacterTest) {
            var withoutAt = value.substring(1);
            if (withoutAt && /[^\w\d]/.test(withoutAt)) {
              resultantValue = value.charAt() + '"' + withoutAt + '"';
            }
          }
          return resultantValue;
        },
        matcher: function matcher(flag, subtext) {
          // The below is taken from At.js source
          // Tweaked to commands to start without a space only if char before is a non-word character
          // https://github.com/ichord/At.js
          var atSymbolsWithBar = Object.keys(this.app.controllers).join('|');
          var atSymbolsWithoutBar = Object.keys(this.app.controllers).join('');
          var targetSubtext = subtext.split(/\s+/g).pop();
          var resultantFlag = flag.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');

          var accentAChar = decodeURI('%C3%80');
          var accentYChar = decodeURI('%C3%BF');

          var regexp = new RegExp('^(?:\\B|[^a-zA-Z0-9_' + atSymbolsWithoutBar + ']|\\s)' + resultantFlag + '(?!' + atSymbolsWithBar + ')((?:[A-Za-z' + accentAChar + '-' + accentYChar + '0-9_\'.+-]|[^\\x00-\\x7a])*)$', 'gi');

          var match = regexp.exec(targetSubtext);

          if (match) {
            return match[1];
          }
          return null;
        }
      };
    }
  }, {
    key: 'fetchData',
    value: function fetchData($input, at) {
      var _this2 = this;

      if (this.isLoadingData[at]) return;
      this.isLoadingData[at] = true;
      if (this.cachedData[at]) {
        this.loadData($input, at, this.cachedData[at]);
      } else if (GfmAutoComplete.atTypeMap[at] === 'emojis') {
        __webpack_require__.e/* import() */("emoji").then(__webpack_require__.bind(null, "./emoji/index.js")).then(function (_ref) {
          var validEmojiNames = _ref.validEmojiNames,
              glEmojiTag = _ref.glEmojiTag;

          _this2.loadData($input, at, validEmojiNames);
          GfmAutoComplete.glEmojiTag = glEmojiTag;
        }).catch(function () {
          _this2.isLoadingData[at] = false;
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_2__lib_utils_ajax_cache__["a" /* default */].retrieve(this.dataSources[GfmAutoComplete.atTypeMap[at]], true).then(function (data) {
          _this2.loadData($input, at, data);
        }).catch(function () {
          _this2.isLoadingData[at] = false;
        });
      }
    }
  }, {
    key: 'loadData',
    value: function loadData($input, at, data) {
      this.isLoadingData[at] = false;
      this.cachedData[at] = data;
      $input.atwho('load', at, data);
      // This trigger at.js again
      // otherwise we would be stuck with loading until the user types
      return $input.trigger('keyup');
    }
  }, {
    key: 'clearCache',
    value: function clearCache() {
      this.cachedData = {};
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.input.each(function (i, input) {
        var $input = $(input);
        $input.atwho('destroy');
      });
    }
  }], [{
    key: 'isLoading',
    value: function isLoading(data) {
      var dataToInspect = data;
      if (data && data.length > 0) {
        dataToInspect = data[0];
      }

      var loadingState = GfmAutoComplete.defaultLoadingData[0];
      return dataToInspect && (dataToInspect === loadingState || dataToInspect.name === loadingState);
    }
  }]);

  return GfmAutoComplete;
}();

GfmAutoComplete.defaultLoadingData = ['loading'];

GfmAutoComplete.atTypeMap = {
  ':': 'emojis',
  '@': 'members',
  '#': 'issues',
  '!': 'mergeRequests',
  '~': 'labels',
  '%': 'milestones',
  '/': 'commands'
};

// Emoji
GfmAutoComplete.glEmojiTag = null;
GfmAutoComplete.Emoji = {
  templateFunction: function templateFunction(name) {
    // glEmojiTag helper is loaded on-demand in fetchData()
    if (GfmAutoComplete.glEmojiTag) {
      return '<li>' + name + ' ' + GfmAutoComplete.glEmojiTag(name) + '</li>';
    }
    return '<li>' + name + '</li>';
  }
};
// Team Members
GfmAutoComplete.Members = {
  // eslint-disable-next-line no-template-curly-in-string
  template: '<li>${avatarTag} ${username} <small>${title}</small></li>'
};
GfmAutoComplete.Labels = {
  // eslint-disable-next-line no-template-curly-in-string
  template: '<li><span class="dropdown-label-box" style="background: ${color}"></span> ${title}</li>'
};
// Issues and MergeRequests
GfmAutoComplete.Issues = {
  // eslint-disable-next-line no-template-curly-in-string
  template: '<li><small>${id}</small> ${title}</li>'
};
// Milestones
GfmAutoComplete.Milestones = {
  // eslint-disable-next-line no-template-curly-in-string
  template: '<li>${title}</li>'
};
GfmAutoComplete.Loading = {
  template: '<li style="pointer-events: none;"><i class="fa fa-spinner fa-spin"></i> Loading...</li>'
};

/* harmony default export */ __webpack_exports__["a"] = (GfmAutoComplete);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./gl_dropdown.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_type_utility__ = __webpack_require__("./lib/utils/type_utility.js");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* eslint-disable func-names, no-underscore-dangle, space-before-function-paren, no-var, one-var, one-var-declaration-per-line, prefer-rest-params, max-len, vars-on-top, wrap-iife, no-unused-vars, quotes, no-shadow, no-cond-assign, prefer-arrow-callback, no-return-assign, no-else-return, camelcase, comma-dangle, no-lonely-if, guard-for-in, no-restricted-syntax, consistent-return, prefer-template, no-param-reassign, no-loop-func, no-mixed-operators */
/* global fuzzaldrinPlus */



var GitLabDropdown, GitLabDropdownFilter, GitLabDropdownRemote, GitLabDropdownInput;

GitLabDropdownInput = function () {
  function GitLabDropdownInput(input, options) {
    var $inputContainer, $clearButton;
    var _this = this;
    this.input = input;
    this.options = options;
    this.fieldName = this.options.fieldName || 'field-name';
    $inputContainer = this.input.parent();
    $clearButton = $inputContainer.find('.js-dropdown-input-clear');
    $clearButton.on('click', function (_this) {
      // Clear click
      return function (e) {
        e.preventDefault();
        e.stopPropagation();
        return _this.input.val('').trigger('input').focus();
      };
    }(this));

    this.input.on('keydown', function (e) {
      var keyCode = e.which;
      if (keyCode === 13 && !options.elIsInput) {
        e.preventDefault();
      }
    }).on('input', function (e) {
      var val = e.currentTarget.value || _this.options.inputFieldName;
      val = val.split(' ').join('-') // replaces space with dash
      .replace(/[^a-zA-Z0-9 -]/g, '').toLowerCase() // replace non alphanumeric
      .replace(/(-)\1+/g, '-'); // replace repeated dashes
      _this.cb(_this.options.fieldName, val, {}, true);
      _this.input.closest('.dropdown').find('.dropdown-toggle-text').text(val);
    });
  }

  GitLabDropdownInput.prototype.onInput = function (cb) {
    this.cb = cb;
  };

  return GitLabDropdownInput;
}();

GitLabDropdownFilter = function () {
  var ARROW_KEY_CODES, BLUR_KEYCODES, HAS_VALUE_CLASS;

  BLUR_KEYCODES = [27, 40];

  ARROW_KEY_CODES = [38, 40];

  HAS_VALUE_CLASS = "has-value";

  function GitLabDropdownFilter(input, options) {
    var $clearButton, $inputContainer, ref, timeout;
    this.input = input;
    this.options = options;
    this.filterInputBlur = (ref = this.options.filterInputBlur) != null ? ref : true;
    $inputContainer = this.input.parent();
    $clearButton = $inputContainer.find('.js-dropdown-input-clear');
    $clearButton.on('click', function (_this) {
      // Clear click
      return function (e) {
        e.preventDefault();
        e.stopPropagation();
        return _this.input.val('').trigger('input').focus();
      };
    }(this));
    // Key events
    timeout = "";
    this.input.on('keydown', function (e) {
      var keyCode = e.which;
      if (keyCode === 13 && !options.elIsInput) {
        e.preventDefault();
      }
    }).on('input', function () {
      if (this.input.val() !== "" && !$inputContainer.hasClass(HAS_VALUE_CLASS)) {
        $inputContainer.addClass(HAS_VALUE_CLASS);
      } else if (this.input.val() === "" && $inputContainer.hasClass(HAS_VALUE_CLASS)) {
        $inputContainer.removeClass(HAS_VALUE_CLASS);
      }
      // Only filter asynchronously only if option remote is set
      if (this.options.remote) {
        clearTimeout(timeout);
        return timeout = setTimeout(function () {
          $inputContainer.parent().addClass('is-loading');

          return this.options.query(this.input.val(), function (data) {
            $inputContainer.parent().removeClass('is-loading');
            return this.options.callback(data);
          }.bind(this));
        }.bind(this), 250);
      } else {
        return this.filter(this.input.val());
      }
    }.bind(this));
  }

  GitLabDropdownFilter.prototype.shouldBlur = function (keyCode) {
    return BLUR_KEYCODES.indexOf(keyCode) !== -1;
  };

  GitLabDropdownFilter.prototype.filter = function (search_text) {
    var data, elements, group, key, results, tmp;
    if (this.options.onFilter) {
      this.options.onFilter(search_text);
    }
    data = this.options.data();
    if (data != null && !this.options.filterByText) {
      results = data;
      if (search_text !== '') {
        // When data is an array of objects therefore [object Array] e.g.
        // [
        //   { prop: 'foo' },
        //   { prop: 'baz' }
        // ]
        if (__WEBPACK_IMPORTED_MODULE_0_underscore___default.a.isArray(data)) {
          results = fuzzaldrinPlus.filter(data, search_text, {
            key: this.options.keys
          });
        } else {
          // If data is grouped therefore an [object Object]. e.g.
          // {
          //   groupName1: [
          //     { prop: 'foo' },
          //     { prop: 'baz' }
          //   ],
          //   groupName2: [
          //     { prop: 'abc' },
          //     { prop: 'def' }
          //   ]
          // }
          if (Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils_type_utility__["a" /* isObject */])(data)) {
            results = {};
            for (key in data) {
              group = data[key];
              tmp = fuzzaldrinPlus.filter(group, search_text, {
                key: this.options.keys
              });
              if (tmp.length) {
                results[key] = tmp.map(function (item) {
                  return item;
                });
              }
            }
          }
        }
      }
      return this.options.callback(results);
    } else {
      elements = this.options.elements();
      if (search_text) {
        elements.each(function () {
          var $el, matches;
          $el = $(this);
          matches = fuzzaldrinPlus.match($el.text().trim(), search_text);
          if (!$el.is('.dropdown-header')) {
            if (matches.length) {
              return $el.show().removeClass('option-hidden');
            } else {
              return $el.hide().addClass('option-hidden');
            }
          }
        });
      } else {
        elements.show().removeClass('option-hidden');
      }

      elements.parent().find('.dropdown-menu-empty-item').toggleClass('hidden', elements.is(':visible'));
    }
  };

  return GitLabDropdownFilter;
}();

GitLabDropdownRemote = function () {
  function GitLabDropdownRemote(dataEndpoint, options) {
    this.dataEndpoint = dataEndpoint;
    this.options = options;
  }

  GitLabDropdownRemote.prototype.execute = function () {
    if (typeof this.dataEndpoint === "string") {
      return this.fetchData();
    } else if (typeof this.dataEndpoint === "function") {
      if (this.options.beforeSend) {
        this.options.beforeSend();
      }
      return this.dataEndpoint("", function (_this) {
        // Fetch the data by calling the data funcfion
        return function (data) {
          if (_this.options.success) {
            _this.options.success(data);
          }
          if (_this.options.beforeSend) {
            return _this.options.beforeSend();
          }
        };
      }(this));
    }
  };

  GitLabDropdownRemote.prototype.fetchData = function () {
    return $.ajax({
      url: this.dataEndpoint,
      dataType: this.options.dataType,
      beforeSend: function (_this) {
        return function () {
          if (_this.options.beforeSend) {
            return _this.options.beforeSend();
          }
        };
      }(this),
      success: function (_this) {
        return function (data) {
          if (_this.options.success) {
            return _this.options.success(data);
          }
        };
      }(this)
    });
    // Fetch the data through ajax if the data is a string
  };

  return GitLabDropdownRemote;
}();

GitLabDropdown = function () {
  var ACTIVE_CLASS, FILTER_INPUT, NO_FILTER_INPUT, INDETERMINATE_CLASS, LOADING_CLASS, PAGE_TWO_CLASS, NON_SELECTABLE_CLASSES, SELECTABLE_CLASSES, CURSOR_SELECT_SCROLL_PADDING, currentIndex;

  LOADING_CLASS = "is-loading";

  PAGE_TWO_CLASS = "is-page-two";

  ACTIVE_CLASS = "is-active";

  INDETERMINATE_CLASS = "is-indeterminate";

  currentIndex = -1;

  NON_SELECTABLE_CLASSES = '.divider, .separator, .dropdown-header, .dropdown-menu-empty-item';

  SELECTABLE_CLASSES = ".dropdown-content li:not(" + NON_SELECTABLE_CLASSES + ", .option-hidden)";

  CURSOR_SELECT_SCROLL_PADDING = 5;

  FILTER_INPUT = '.dropdown-input .dropdown-input-field:not(.dropdown-no-filter)';

  NO_FILTER_INPUT = '.dropdown-input .dropdown-input-field.dropdown-no-filter';

  function GitLabDropdown(el1, options) {
    var searchFields, selector, self;
    this.el = el1;
    this.options = options;
    this.updateLabel = this.updateLabel.bind(this);
    this.hidden = this.hidden.bind(this);
    this.opened = this.opened.bind(this);
    this.shouldPropagate = this.shouldPropagate.bind(this);
    self = this;
    selector = $(this.el).data("target");
    this.dropdown = selector != null ? $(selector) : $(this.el).parent();
    // Set Defaults
    this.filterInput = this.options.filterInput || this.getElement(FILTER_INPUT);
    this.noFilterInput = this.options.noFilterInput || this.getElement(NO_FILTER_INPUT);
    this.highlight = !!this.options.highlight;
    this.filterInputBlur = this.options.filterInputBlur != null ? this.options.filterInputBlur : true;
    // If no input is passed create a default one
    self = this;
    // If selector was passed
    if (__WEBPACK_IMPORTED_MODULE_0_underscore___default.a.isString(this.filterInput)) {
      this.filterInput = this.getElement(this.filterInput);
    }
    searchFields = this.options.search ? this.options.search.fields : [];
    if (this.options.data) {
      // If we provided data
      // data could be an array of objects or a group of arrays
      if (__WEBPACK_IMPORTED_MODULE_0_underscore___default.a.isObject(this.options.data) && !__WEBPACK_IMPORTED_MODULE_0_underscore___default.a.isFunction(this.options.data)) {
        this.fullData = this.options.data;
        currentIndex = -1;
        this.parseData(this.options.data);
        this.focusTextInput();
      } else {
        this.remote = new GitLabDropdownRemote(this.options.data, {
          dataType: this.options.dataType,
          beforeSend: this.toggleLoading.bind(this),
          success: function (_this) {
            return function (data) {
              _this.fullData = data;
              _this.parseData(_this.fullData);
              _this.focusTextInput(true);
              if (_this.options.filterable && _this.filter && _this.filter.input && _this.filter.input.val() && _this.filter.input.val().trim() !== '') {
                return _this.filter.input.trigger('input');
              }
            };
            // Remote data
          }(this),
          instance: this
        });
      }
    }
    if (this.noFilterInput.length) {
      this.plainInput = new GitLabDropdownInput(this.noFilterInput, this.options);
      this.plainInput.onInput(this.addInput.bind(this));
    }
    // Init filterable
    if (this.options.filterable) {
      this.filter = new GitLabDropdownFilter(this.filterInput, {
        elIsInput: $(this.el).is('input'),
        filterInputBlur: this.filterInputBlur,
        filterByText: this.options.filterByText,
        onFilter: this.options.onFilter,
        remote: this.options.filterRemote,
        query: this.options.data,
        keys: searchFields,
        instance: this,
        elements: function (_this) {
          return function () {
            selector = '.dropdown-content li:not(' + NON_SELECTABLE_CLASSES + ')';
            if (_this.dropdown.find('.dropdown-toggle-page').length) {
              selector = ".dropdown-page-one " + selector;
            }
            return $(selector);
          };
        }(this),
        data: function (_this) {
          return function () {
            return _this.fullData;
          };
        }(this),
        callback: function (_this) {
          return function (data) {
            _this.parseData(data);
            if (_this.filterInput.val() !== '') {
              selector = SELECTABLE_CLASSES;
              if (_this.dropdown.find('.dropdown-toggle-page').length) {
                selector = ".dropdown-page-one " + selector;
              }
              if ($(_this.el).is('input')) {
                currentIndex = -1;
              } else {
                $(selector, _this.dropdown).first().find('a').addClass('is-focused');
                currentIndex = 0;
              }
            }
          };
        }(this)
      });
    }
    // Event listeners
    this.dropdown.on("shown.bs.dropdown", this.opened);
    this.dropdown.on("hidden.bs.dropdown", this.hidden);
    $(this.el).on("update.label", this.updateLabel);
    this.dropdown.on("click", ".dropdown-menu, .dropdown-menu-close", this.shouldPropagate);
    this.dropdown.on('keyup', function (_this) {
      return function (e) {
        // Escape key
        if (e.which === 27) {
          return $('.dropdown-menu-close', _this.dropdown).trigger('click');
        }
      };
    }(this));
    this.dropdown.on('blur', 'a', function (_this) {
      return function (e) {
        var $dropdownMenu, $relatedTarget;
        if (e.relatedTarget != null) {
          $relatedTarget = $(e.relatedTarget);
          $dropdownMenu = $relatedTarget.closest('.dropdown-menu');
          if ($dropdownMenu.length === 0) {
            return _this.dropdown.removeClass('open');
          }
        }
      };
    }(this));
    if (this.dropdown.find(".dropdown-toggle-page").length) {
      this.dropdown.find(".dropdown-toggle-page, .dropdown-menu-back").on("click", function (_this) {
        return function (e) {
          e.preventDefault();
          e.stopPropagation();
          return _this.togglePage();
        };
      }(this));
    }
    if (this.options.selectable) {
      selector = ".dropdown-content a";
      if (this.dropdown.find(".dropdown-toggle-page").length) {
        selector = ".dropdown-page-one .dropdown-content a";
      }
      this.dropdown.on("click", selector, function (e) {
        var $el, selected, selectedObj, isMarking;
        $el = $(e.currentTarget);
        selected = self.rowClicked($el);
        selectedObj = selected ? selected[0] : null;
        isMarking = selected ? selected[1] : null;
        if (this.options.clicked) {
          this.options.clicked.call(this, {
            selectedObj: selectedObj,
            $el: $el,
            e: e,
            isMarking: isMarking
          });
        }

        // Update label right after all modifications in dropdown has been done
        if (this.options.toggleLabel) {
          this.updateLabel(selectedObj, $el, this);
        }

        $el.trigger('blur');
      }.bind(this));
    }
  }

  // Finds an element inside wrapper element
  GitLabDropdown.prototype.getElement = function (selector) {
    return this.dropdown.find(selector);
  };

  GitLabDropdown.prototype.toggleLoading = function () {
    return $('.dropdown-menu', this.dropdown).toggleClass(LOADING_CLASS);
  };

  GitLabDropdown.prototype.togglePage = function () {
    var menu;
    menu = $('.dropdown-menu', this.dropdown);
    if (menu.hasClass(PAGE_TWO_CLASS)) {
      if (this.remote) {
        this.remote.execute();
      }
    }
    menu.toggleClass(PAGE_TWO_CLASS);
    // Focus first visible input on active page
    return this.dropdown.find('[class^="dropdown-page-"]:visible :text:visible:first').focus();
  };

  GitLabDropdown.prototype.parseData = function (data) {
    var full_html, groupData, html, name;
    this.renderedData = data;
    if (this.options.filterable && data.length === 0) {
      // render no matching results
      html = [this.noResults()];
    } else {
      // Handle array groups
      if (Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils_type_utility__["a" /* isObject */])(data)) {
        html = [];
        for (name in data) {
          groupData = data[name];
          html.push(this.renderItem({
            header: name
            // Add header for each group
          }, name));
          this.renderData(groupData, name).map(function (item) {
            return html.push(item);
          });
        }
      } else {
        // Render each row
        html = this.renderData(data);
      }
    }
    // Render the full menu
    full_html = this.renderMenu(html);
    return this.appendMenu(full_html);
  };

  GitLabDropdown.prototype.renderData = function (data, group) {
    if (group == null) {
      group = false;
    }
    return data.map(function (_this) {
      return function (obj, index) {
        return _this.renderItem(obj, group, index);
      };
    }(this));
  };

  GitLabDropdown.prototype.shouldPropagate = function (e) {
    var $target;
    if (this.options.multiSelect || this.options.shouldPropagate === false) {
      $target = $(e.target);
      if ($target && !$target.hasClass('dropdown-menu-close') && !$target.hasClass('dropdown-menu-close-icon') && !$target.data('is-link')) {
        e.stopPropagation();
        return false;
      } else {
        return true;
      }
    }
  };

  GitLabDropdown.prototype.filteredFullData = function () {
    return this.fullData.filter(function (r) {
      return (typeof r === 'undefined' ? 'undefined' : _typeof(r)) === 'object' && !Object.prototype.hasOwnProperty.call(r, 'beforeDivider') && !Object.prototype.hasOwnProperty.call(r, 'header');
    });
  };

  GitLabDropdown.prototype.opened = function (e) {
    var contentHtml;
    this.resetRows();
    this.addArrowKeyEvent();

    var dropdownToggle = this.dropdown.find('.dropdown-menu-toggle');
    var hasFilterBulkUpdate = dropdownToggle.hasClass('js-filter-bulk-update');
    var hasMultiSelect = dropdownToggle.hasClass('js-multiselect');

    // Makes indeterminate items effective
    if (this.fullData && hasFilterBulkUpdate) {
      this.parseData(this.fullData);
    }

    // Process the data to make sure rendered data
    // matches the correct layout
    var inputValue = this.filterInput.val();
    if (this.fullData && hasMultiSelect && this.options.processData && inputValue.length === 0) {
      this.options.processData.call(this.options, inputValue, this.filteredFullData(), this.parseData.bind(this));
    }

    contentHtml = $('.dropdown-content', this.dropdown).html();
    if (this.remote && contentHtml === "") {
      this.remote.execute();
    } else {
      this.focusTextInput();
    }

    if (this.options.showMenuAbove) {
      this.positionMenuAbove();
    }

    if (this.options.opened) {
      this.options.opened.call(this, e);
    }

    return this.dropdown.trigger('shown.gl.dropdown');
  };

  GitLabDropdown.prototype.positionMenuAbove = function () {
    var $menu = this.dropdown.find('.dropdown-menu');

    $menu.addClass('dropdown-open-top');
    $menu.css('top', 'initial');
    $menu.css('bottom', '100%');
  };

  GitLabDropdown.prototype.hidden = function (e) {
    var $input;
    this.resetRows();
    this.removeArrayKeyEvent();
    $input = this.dropdown.find(".dropdown-input-field");
    if (this.options.filterable) {
      $input.blur();
    }
    if (this.dropdown.find(".dropdown-toggle-page").length) {
      $('.dropdown-menu', this.dropdown).removeClass(PAGE_TWO_CLASS);
    }
    if (this.options.hidden) {
      this.options.hidden.call(this, e);
    }
    return this.dropdown.trigger('hidden.gl.dropdown');
  };

  // Render the full menu
  GitLabDropdown.prototype.renderMenu = function (html) {
    if (this.options.renderMenu) {
      return this.options.renderMenu(html);
    } else {
      var ul = document.createElement('ul');

      for (var i = 0; i < html.length; i += 1) {
        var el = html[i];

        if (el instanceof jQuery) {
          el = el.get(0);
        }

        if (typeof el === 'string') {
          ul.innerHTML += el;
        } else {
          ul.appendChild(el);
        }
      }

      return ul;
    }
  };

  // Append the menu into the dropdown
  GitLabDropdown.prototype.appendMenu = function (html) {
    return this.clearMenu().append(html);
  };

  GitLabDropdown.prototype.clearMenu = function () {
    var selector;
    selector = '.dropdown-content';
    if (this.dropdown.find(".dropdown-toggle-page").length) {
      selector = ".dropdown-page-one .dropdown-content";
    }

    return $(selector, this.dropdown).empty();
  };

  GitLabDropdown.prototype.renderItem = function (data, group, index) {
    var field, fieldName, html, selected, text, url, value, rowHidden;

    if (!this.options.renderRow) {
      value = this.options.id ? this.options.id(data) : data.id;

      if (value) {
        value = value.toString().replace(/'/g, '\\\'');
      }
    }

    // Hide element
    if (this.options.hideRow && this.options.hideRow(value)) {
      rowHidden = true;
    }
    if (group == null) {
      group = false;
    }
    if (index == null) {
      // Render the row
      index = false;
    }
    html = document.createElement('li');

    if (rowHidden) {
      html.style.display = 'none';
    }

    if (data === 'divider' || data === 'separator') {
      html.className = data;
      return html;
    }
    // Header
    if (data.header != null) {
      html.className = 'dropdown-header';
      html.innerHTML = data.header;
      return html;
    }
    if (this.options.renderRow) {
      // Call the render function
      html = this.options.renderRow.call(this.options, data, this);
    } else {
      if (!selected) {
        fieldName = this.options.fieldName;

        if (value) {
          field = this.dropdown.parent().find('input[name=\'' + fieldName + '\'][value=\'' + value + '\']');
          if (field.length) {
            selected = true;
          }
        } else {
          field = this.dropdown.parent().find('input[name=\'' + fieldName + '\']');
          selected = !field.length;
        }
      }
      // Set URL
      if (this.options.url != null) {
        url = this.options.url(data);
      } else {
        url = data.url != null ? data.url : '#';
      }
      // Set Text
      if (this.options.text != null) {
        text = this.options.text(data);
      } else {
        text = data.text != null ? data.text : '';
      }
      if (this.highlight) {
        text = this.highlightTextMatches(text, this.filterInput.val());
      }
      // Create the list item & the link
      var link = document.createElement('a');

      link.href = url;

      if (this.highlight) {
        link.innerHTML = text;
      } else {
        link.textContent = text;
      }

      if (selected) {
        link.className = 'is-active';
      }

      if (group) {
        link.dataset.group = group;
        link.dataset.index = index;
      }

      html.appendChild(link);
    }
    return html;
  };

  GitLabDropdown.prototype.highlightTextMatches = function (text, term) {
    var occurrences = fuzzaldrinPlus.match(text, term);
    var indexOf = [].indexOf;
    return text.split('').map(function (character, i) {
      if (indexOf.call(occurrences, i) !== -1) {
        return "<b>" + character + "</b>";
      } else {
        return character;
      }
    }).join('');
  };

  GitLabDropdown.prototype.noResults = function () {
    var html;
    return '<li class="dropdown-menu-empty-item"><a>No matching results</a></li>';
  };

  GitLabDropdown.prototype.rowClicked = function (el) {
    var field, fieldName, groupName, isInput, selectedIndex, selectedObject, value, isMarking;

    fieldName = this.options.fieldName;
    isInput = $(this.el).is('input');
    if (this.renderedData) {
      groupName = el.data('group');
      if (groupName) {
        selectedIndex = el.data('index');
        selectedObject = this.renderedData[groupName][selectedIndex];
      } else {
        selectedIndex = el.closest('li').index();
        selectedObject = this.renderedData[selectedIndex];
      }
    }

    if (this.options.vue) {
      if (el.hasClass(ACTIVE_CLASS)) {
        el.removeClass(ACTIVE_CLASS);
      } else {
        el.addClass(ACTIVE_CLASS);
      }

      return [selectedObject];
    }

    field = [];
    value = this.options.id ? this.options.id(selectedObject, el) : selectedObject.id;
    if (isInput) {
      field = $(this.el);
    } else if (value != null) {
      field = this.dropdown.parent().find("input[name='" + fieldName + "'][value='" + value.toString().replace(/'/g, '\\\'') + "']");
    }

    if (this.options.isSelectable && !this.options.isSelectable(selectedObject, el)) {
      return;
    }

    if (el.hasClass(ACTIVE_CLASS) && value !== 0) {
      isMarking = false;
      el.removeClass(ACTIVE_CLASS);
      if (field && field.length) {
        this.clearField(field, isInput);
      }
    } else if (el.hasClass(INDETERMINATE_CLASS)) {
      isMarking = true;
      el.addClass(ACTIVE_CLASS);
      el.removeClass(INDETERMINATE_CLASS);
      if (field && field.length && value == null) {
        this.clearField(field, isInput);
      }
      if ((!field || !field.length) && fieldName) {
        this.addInput(fieldName, value, selectedObject);
      }
    } else {
      isMarking = true;
      if (!this.options.multiSelect || el.hasClass('dropdown-clear-active')) {
        this.dropdown.find("." + ACTIVE_CLASS).removeClass(ACTIVE_CLASS);
        if (!isInput) {
          this.dropdown.parent().find("input[name='" + fieldName + "']").remove();
        }
      }
      if (field && field.length && value == null) {
        this.clearField(field, isInput);
      }
      // Toggle active class for the tick mark
      el.addClass(ACTIVE_CLASS);
      if (value != null) {
        if ((!field || !field.length) && fieldName) {
          this.addInput(fieldName, value, selectedObject);
        } else if (field && field.length) {
          field.val(value).trigger('change');
        }
      }
    }

    return [selectedObject, isMarking];
  };

  GitLabDropdown.prototype.focusTextInput = function () {
    var _this2 = this;

    var triggerFocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (this.options.filterable) {
      this.dropdown.one('transitionend', function () {
        var initialScrollTop = $(window).scrollTop();

        if (_this2.dropdown.is('.open')) {
          _this2.filterInput.focus();
        }

        if ($(window).scrollTop() < initialScrollTop) {
          $(window).scrollTop(initialScrollTop);
        }
      });

      if (triggerFocus) {
        // This triggers after a ajax request
        // in case of slow requests, the dropdown transition could already be finished
        this.dropdown.trigger('transitionend');
      }
    }
  };

  GitLabDropdown.prototype.addInput = function (fieldName, value, selectedObject, single) {
    var $input;
    // Create hidden input for form
    if (single) {
      $('input[name="' + fieldName + '"]').remove();
    }

    $input = $('<input>').attr('type', 'hidden').attr('name', fieldName).val(value);
    if (this.options.inputId != null) {
      $input.attr('id', this.options.inputId);
    }

    if (this.options.multiSelect) {
      Object.keys(selectedObject).forEach(function (attribute) {
        $input.attr('data-' + attribute, selectedObject[attribute]);
      });
    }

    if (this.options.inputMeta) {
      $input.attr('data-meta', selectedObject[this.options.inputMeta]);
    }

    this.dropdown.before($input).trigger('change');
  };

  GitLabDropdown.prototype.selectRowAtIndex = function (index) {
    var $el, selector;
    // If we pass an option index
    if (typeof index !== "undefined") {
      selector = SELECTABLE_CLASSES + ":eq(" + index + ") a";
    } else {
      selector = ".dropdown-content .is-focused";
    }
    if (this.dropdown.find(".dropdown-toggle-page").length) {
      selector = ".dropdown-page-one " + selector;
    }
    // simulate a click on the first link
    $el = $(selector, this.dropdown);
    if ($el.length) {
      var href = $el.attr('href');
      if (href && href !== '#') {
        gl.utils.visitUrl(href);
      } else {
        $el.trigger('click');
      }
    }
  };

  GitLabDropdown.prototype.addArrowKeyEvent = function () {
    var $input, ARROW_KEY_CODES, selector;
    ARROW_KEY_CODES = [38, 40];
    $input = this.dropdown.find(".dropdown-input-field");
    selector = SELECTABLE_CLASSES;
    if (this.dropdown.find(".dropdown-toggle-page").length) {
      selector = ".dropdown-page-one " + selector;
    }
    return $('body').on('keydown', function (_this) {
      return function (e) {
        var $listItems, PREV_INDEX, currentKeyCode;
        currentKeyCode = e.which;
        if (ARROW_KEY_CODES.indexOf(currentKeyCode) !== -1) {
          e.preventDefault();
          e.stopImmediatePropagation();
          PREV_INDEX = currentIndex;
          $listItems = $(selector, _this.dropdown);
          // if @options.filterable
          //   $input.blur()
          if (currentKeyCode === 40) {
            // Move down
            if (currentIndex < $listItems.length - 1) {
              currentIndex += 1;
            }
          } else if (currentKeyCode === 38) {
            // Move up
            if (currentIndex > 0) {
              currentIndex -= 1;
            }
          }
          if (currentIndex !== PREV_INDEX) {
            _this.highlightRowAtIndex($listItems, currentIndex);
          }
          return false;
        }
        if (currentKeyCode === 13 && currentIndex !== -1) {
          e.preventDefault();
          _this.selectRowAtIndex();
        }
      };
    }(this));
  };

  GitLabDropdown.prototype.removeArrayKeyEvent = function () {
    return $('body').off('keydown');
  };

  GitLabDropdown.prototype.resetRows = function resetRows() {
    currentIndex = -1;
    $('.is-focused', this.dropdown).removeClass('is-focused');
  };

  GitLabDropdown.prototype.highlightRowAtIndex = function ($listItems, index) {
    var $dropdownContent, $listItem, dropdownContentBottom, dropdownContentHeight, dropdownContentTop, dropdownScrollTop, listItemBottom, listItemHeight, listItemTop;
    // Remove the class for the previously focused row
    $('.is-focused', this.dropdown).removeClass('is-focused');
    // Update the class for the row at the specific index
    $listItem = $listItems.eq(index);
    $listItem.find('a:first-child').addClass("is-focused");
    // Dropdown content scroll area
    $dropdownContent = $listItem.closest('.dropdown-content');
    dropdownScrollTop = $dropdownContent.scrollTop();
    dropdownContentHeight = $dropdownContent.outerHeight();
    dropdownContentTop = $dropdownContent.prop('offsetTop');
    dropdownContentBottom = dropdownContentTop + dropdownContentHeight;
    // Get the offset bottom of the list item
    listItemHeight = $listItem.outerHeight();
    listItemTop = $listItem.prop('offsetTop');
    listItemBottom = listItemTop + listItemHeight;
    if (!index) {
      // Scroll the dropdown content to the top
      $dropdownContent.scrollTop(0);
    } else if (index === $listItems.length - 1) {
      // Scroll the dropdown content to the bottom
      $dropdownContent.scrollTop($dropdownContent.prop('scrollHeight'));
    } else if (listItemBottom > dropdownContentBottom + dropdownScrollTop) {
      // Scroll the dropdown content down
      $dropdownContent.scrollTop(listItemBottom - dropdownContentBottom + CURSOR_SELECT_SCROLL_PADDING);
    } else if (listItemTop < dropdownContentTop + dropdownScrollTop) {
      // Scroll the dropdown content up
      return $dropdownContent.scrollTop(listItemTop - dropdownContentTop - CURSOR_SELECT_SCROLL_PADDING);
    }
  };

  GitLabDropdown.prototype.updateLabel = function (selected, el, instance) {
    if (selected == null) {
      selected = null;
    }
    if (el == null) {
      el = null;
    }
    if (instance == null) {
      instance = null;
    }

    var toggleText = this.options.toggleLabel(selected, el, instance);
    if (this.options.updateLabel) {
      // Option to override the dropdown label text
      toggleText = this.options.updateLabel;
    }

    return $(this.el).find(".dropdown-toggle-text").text(toggleText);
  };

  GitLabDropdown.prototype.clearField = function (field, isInput) {
    return isInput ? field.val('') : field.remove();
  };

  return GitLabDropdown;
}();

$.fn.glDropdown = function (opts) {
  return this.each(function () {
    if (!$.data(this, 'glDropdown')) {
      return $.data(this, 'glDropdown', new GitLabDropdown(this, opts));
    }
  });
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js"), __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./gl_field_error.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * This class overrides the browser's validation error bubbles, displaying custom
 * error messages for invalid fields instead. To begin validating any form, add the
 * class `gl-show-field-errors` to the form element, and ensure error messages are
 * declared in each inputs' `title` attribute. If no title is declared for an invalid
 * field the user attempts to submit, "This field is required." will be shown by default.
 *
 * Opt not to validate certain fields by adding the class `gl-field-error-ignore` to the input.
 *
 * Set a custom error anchor for error message to be injected after with the
 * class `gl-field-error-anchor`
 *
 * Examples:
 *
 * Basic:
 *
 * <form class='gl-show-field-errors'>
 *  <input type='text' name='username' title='Username is required.'/>
 * </form>
 *
 * Ignore specific inputs (e.g. UsernameValidator):
 *
 * <form class='gl-show-field-errors'>
 *   <div class="form-group>
 *     <input type='text' class='gl-field-errors-ignore' pattern='[a-zA-Z0-9-_]+'/>
 *   </div>
 *   <div class="form-group">
 *      <input type='text' name='username' title='Username is required.'/>
 *    </div>
 * </form>
 *
 * Custom Error Anchor (allows error message to be injected after specified element):
 *
 * <form class='gl-show-field-errors'>
 *  <div class="form-group gl-field-error-anchor">
 *    <input type='text' name='username' title='Username is required.'/>
 *    // Error message typically injected here
 *  </div>
 *  // Error message now injected here
 * </form>
 *
 */

/**
 * Regex Patterns in use:
 *
 * Only alphanumeric: : "[a-zA-Z0-9]+"
 * No special characters : "[a-zA-Z0-9-_]+",
 *
 */

var errorMessageClass = 'gl-field-error';
var inputErrorClass = 'gl-field-error-outline';
var errorAnchorSelector = '.gl-field-error-anchor';
var ignoreInputSelector = '.gl-field-error-ignore';

var GlFieldError = function () {
  function GlFieldError(_ref) {
    var input = _ref.input,
        formErrors = _ref.formErrors;

    _classCallCheck(this, GlFieldError);

    this.inputElement = $(input);
    this.inputDomElement = this.inputElement.get(0);
    this.form = formErrors;
    this.errorMessage = this.inputElement.attr('title') || 'This field is required.';
    this.fieldErrorElement = $('<p class=\'' + errorMessageClass + ' hide\'>' + this.errorMessage + '</p>');

    this.state = {
      valid: false,
      empty: true,
      submitted: false
    };

    this.initFieldValidation();
  }

  _createClass(GlFieldError, [{
    key: 'initFieldValidation',
    value: function initFieldValidation() {
      var customErrorAnchor = this.inputElement.parents(errorAnchorSelector);
      var errorAnchor = customErrorAnchor.length ? customErrorAnchor : this.inputElement;

      // hidden when injected into DOM
      errorAnchor.after(this.fieldErrorElement);
      this.inputElement.off('invalid').on('invalid', this.handleInvalidSubmit.bind(this));
      this.scopedSiblings = this.safelySelectSiblings();
    }
  }, {
    key: 'safelySelectSiblings',
    value: function safelySelectSiblings() {
      // Apply `ignoreSelector` in markup to siblings whose visibility should not be toggled
      var unignoredSiblings = this.inputElement.siblings('p:not(' + ignoreInputSelector + ')');
      var parentContainer = this.inputElement.parent('.form-group');

      // Only select siblings when they're scoped within a form-group with one input
      var safelyScoped = parentContainer.length && parentContainer.find('input').length === 1;

      return safelyScoped ? unignoredSiblings : this.fieldErrorElement;
    }
  }, {
    key: 'renderValidity',
    value: function renderValidity() {
      this.renderClear();

      if (this.state.valid) {
        this.renderValid();
      } else if (this.state.empty) {
        this.renderEmpty();
      } else if (!this.state.valid) {
        this.renderInvalid();
      }
    }
  }, {
    key: 'handleInvalidSubmit',
    value: function handleInvalidSubmit(event) {
      event.preventDefault();
      var currentValue = this.accessCurrentValue();
      this.state.valid = false;
      this.state.empty = currentValue === '';
      this.state.submitted = true;
      this.renderValidity();
      this.form.focusOnFirstInvalid.apply(this.form);

      // For UX, wait til after first invalid submission to check each keyup
      this.inputElement.off('keyup.fieldValidator').on('keyup.fieldValidator', this.updateValidity.bind(this));
    }

    /* Get or set current input value */

  }, {
    key: 'accessCurrentValue',
    value: function accessCurrentValue(newVal) {
      return newVal ? this.inputElement.val(newVal) : this.inputElement.val();
    }
  }, {
    key: 'getInputValidity',
    value: function getInputValidity() {
      return this.inputDomElement.validity.valid;
    }
  }, {
    key: 'updateValidity',
    value: function updateValidity() {
      var inputVal = this.accessCurrentValue();
      this.state.empty = !inputVal.length;
      this.state.valid = this.getInputValidity();
      this.renderValidity();
    }
  }, {
    key: 'renderValid',
    value: function renderValid() {
      return this.renderClear();
    }
  }, {
    key: 'renderEmpty',
    value: function renderEmpty() {
      return this.renderInvalid();
    }
  }, {
    key: 'renderInvalid',
    value: function renderInvalid() {
      this.inputElement.addClass(inputErrorClass);
      this.scopedSiblings.hide();
      return this.fieldErrorElement.show();
    }
  }, {
    key: 'renderClear',
    value: function renderClear() {
      var inputVal = this.accessCurrentValue();
      if (!inputVal.split(' ').length) {
        var trimmedInput = inputVal.trim();
        this.accessCurrentValue(trimmedInput);
      }
      this.inputElement.removeClass(inputErrorClass);
      this.scopedSiblings.hide();
      this.fieldErrorElement.hide();
    }
  }]);

  return GlFieldError;
}();

window.gl = window.gl || {};
window.gl.GlFieldError = GlFieldError;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./gl_field_errors.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gl_field_error__ = __webpack_require__("./gl_field_error.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gl_field_error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__gl_field_error__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable comma-dangle, class-methods-use-this, max-len, space-before-function-paren, arrow-parens, no-param-reassign */



var customValidationFlag = 'gl-field-error-ignore';

var GlFieldErrors = function () {
  function GlFieldErrors(form) {
    _classCallCheck(this, GlFieldErrors);

    this.form = $(form);
    this.state = {
      inputs: [],
      valid: false
    };
    this.initValidators();
  }

  _createClass(GlFieldErrors, [{
    key: 'initValidators',
    value: function initValidators() {
      var _this = this;

      // register selectors here as needed
      var validateSelectors = [':text', ':password', '[type=email]'].map(function (selector) {
        return 'input' + selector;
      }).join(',');

      this.state.inputs = this.form.find(validateSelectors).toArray().filter(function (input) {
        return !input.classList.contains(customValidationFlag);
      }).map(function (input) {
        return new window.gl.GlFieldError({ input: input, formErrors: _this });
      });

      this.form.on('submit', this.catchInvalidFormSubmit);
    }

    /* Neccessary to prevent intercept and override invalid form submit
     * because Safari & iOS quietly allow form submission when form is invalid
     * and prevents disabling of invalid submit button by application.js */

  }, {
    key: 'catchInvalidFormSubmit',
    value: function catchInvalidFormSubmit(event) {
      var $form = $(event.currentTarget);

      if (!$form.attr('novalidate')) {
        if (!event.currentTarget.checkValidity()) {
          event.preventDefault();
          event.stopPropagation();
        }
      }
    }

    /* Public method for triggering validity updates manually  */

  }, {
    key: 'updateFormValidityState',
    value: function updateFormValidityState() {
      this.state.inputs.forEach(function (field) {
        if (field.state.submitted) {
          field.updateValidity();
        }
      });
    }
  }, {
    key: 'focusOnFirstInvalid',
    value: function focusOnFirstInvalid() {
      var firstInvalid = this.state.inputs.filter(function (input) {
        return !input.inputDomElement.validity.valid;
      })[0];
      firstInvalid.inputElement.focus();
    }
  }]);

  return GlFieldErrors;
}();

window.gl = window.gl || {};
window.gl.GlFieldErrors = GlFieldErrors;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./gl_form.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gfm_auto_complete__ = __webpack_require__("./gfm_auto_complete.js");
/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, no-new, max-len */
/* global GitLab */
/* global DropzoneInput */
/* global autosize */



window.gl = window.gl || {};

function GLForm(form) {
  var enableGFM = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  this.form = form;
  this.textarea = this.form.find('textarea.js-gfm-input');
  this.enableGFM = enableGFM;
  // Before we start, we should clean up any previous data for this form
  this.destroy();
  // Setup the form
  this.setupForm();
  this.form.data('gl-form', this);
}

GLForm.prototype.destroy = function () {
  // Clean form listeners
  this.clearEventListeners();
  if (this.autoComplete) {
    this.autoComplete.destroy();
  }
  return this.form.data('gl-form', null);
};

GLForm.prototype.setupForm = function () {
  var isNewForm;
  isNewForm = this.form.is(':not(.gfm-form)');
  this.form.removeClass('js-new-note-form');
  if (isNewForm) {
    this.form.find('.div-dropzone').remove();
    this.form.addClass('gfm-form');
    // remove notify commit author checkbox for non-commit notes
    gl.utils.disableButtonIfEmptyField(this.form.find('.js-note-text'), this.form.find('.js-comment-button, .js-note-new-discussion'));
    this.autoComplete = new __WEBPACK_IMPORTED_MODULE_0__gfm_auto_complete__["a" /* default */](gl.GfmAutoComplete && gl.GfmAutoComplete.dataSources);
    this.autoComplete.setup(this.form.find('.js-gfm-input'), {
      emojis: true,
      members: this.enableGFM,
      issues: this.enableGFM,
      milestones: this.enableGFM,
      mergeRequests: this.enableGFM,
      labels: this.enableGFM
    });
    new DropzoneInput(this.form);
    autosize(this.textarea);
  }
  // form and textarea event listeners
  this.addEventListeners();
  gl.text.init(this.form);
  // hide discard button
  this.form.find('.js-note-discard').hide();
  this.form.show();
  if (this.isAutosizeable) this.setupAutosize();
};

GLForm.prototype.setupAutosize = function () {
  var _this = this;

  this.textarea.off('autosize:resized').on('autosize:resized', this.setHeightData.bind(this));

  this.textarea.off('mouseup.autosize').on('mouseup.autosize', this.destroyAutosize.bind(this));

  setTimeout(function () {
    autosize(_this.textarea);
    _this.textarea.css('resize', 'vertical');
  }, 0);
};

GLForm.prototype.setHeightData = function () {
  this.textarea.data('height', this.textarea.outerHeight());
};

GLForm.prototype.destroyAutosize = function () {
  var outerHeight = this.textarea.outerHeight();

  if (this.textarea.data('height') === outerHeight) return;

  autosize.destroy(this.textarea);

  this.textarea.data('height', outerHeight);
  this.textarea.outerHeight(outerHeight);
  this.textarea.css('max-height', window.outerHeight);
};

GLForm.prototype.clearEventListeners = function () {
  this.textarea.off('focus');
  this.textarea.off('blur');
  return gl.text.removeListeners(this.form);
};

GLForm.prototype.addEventListeners = function () {
  this.textarea.on('focus', function () {
    return $(this).closest('.md-area').addClass('is-focused');
  });
  return this.textarea.on('blur', function () {
    return $(this).closest('.md-area').removeClass('is-focused');
  });
};

window.gl.GLForm = GLForm;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./gpg_badges.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GpgBadges = function () {
  function GpgBadges() {
    _classCallCheck(this, GpgBadges);
  }

  _createClass(GpgBadges, null, [{
    key: 'fetch',
    value: function fetch() {
      var badges = $('.js-loading-gpg-badge');
      var form = $('.commits-search-form');

      badges.html('<i class="fa fa-spinner fa-spin"></i>');

      $.get({
        url: form.data('signatures-path'),
        data: form.serialize()
      }).done(function (response) {
        response.signatures.forEach(function (signature) {
          badges.filter('[data-commit-sha="' + signature.commit_sha + '"]').replaceWith(signature.html);
        });
      });
    }
  }]);

  return GpgBadges;
}();

/* harmony default export */ __webpack_exports__["a"] = (GpgBadges);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./group.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Group = function () {
  function Group() {
    _classCallCheck(this, Group);

    this.groupPath = $('#group_path');
    this.groupName = $('#group_name');
    this.updateHandler = this.update.bind(this);
    this.resetHandler = this.reset.bind(this);
    if (this.groupName.val() === '') {
      this.groupPath.on('keyup', this.updateHandler);
      this.groupName.on('keydown', this.resetHandler);
    }
  }

  _createClass(Group, [{
    key: 'update',
    value: function update() {
      this.groupName.val(this.groupPath.val());
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.groupPath.off('keyup', this.updateHandler);
      this.groupName.off('keydown', this.resetHandler);
    }
  }]);

  return Group;
}();

/* harmony default export */ __webpack_exports__["default"] = (Group);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./group_avatar.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife, quotes, no-var, one-var, one-var-declaration-per-line, no-useless-escape, max-len */

window.GroupAvatar = function () {
  function GroupAvatar() {
    $('.js-choose-group-avatar-button').on("click", function () {
      var form;
      form = $(this).closest("form");
      return form.find(".js-group-avatar-input").click();
    });
    $('.js-group-avatar-input').on("change", function () {
      var filename, form;
      form = $(this).closest("form");
      filename = $(this).val().replace(/^.*[\\\/]/, '');
      return form.find(".js-avatar-filename").text(filename);
    });
  }

  return GroupAvatar;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./group_label_subscription.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable func-names, object-shorthand, comma-dangle, wrap-iife, space-before-function-paren, no-param-reassign, max-len */

var GroupLabelSubscription = function () {
  function GroupLabelSubscription(container) {
    _classCallCheck(this, GroupLabelSubscription);

    var $container = $(container);
    this.$dropdown = $container.find('.dropdown');
    this.$subscribeButtons = $container.find('.js-subscribe-button');
    this.$unsubscribeButtons = $container.find('.js-unsubscribe-button');

    this.$subscribeButtons.on('click', this.subscribe.bind(this));
    this.$unsubscribeButtons.on('click', this.unsubscribe.bind(this));
  }

  _createClass(GroupLabelSubscription, [{
    key: 'unsubscribe',
    value: function unsubscribe(event) {
      var _this = this;

      event.preventDefault();

      var url = this.$unsubscribeButtons.attr('data-url');

      $.ajax({
        type: 'POST',
        url: url
      }).done(function () {
        _this.toggleSubscriptionButtons();
        _this.$unsubscribeButtons.removeAttr('data-url');
      });
    }
  }, {
    key: 'subscribe',
    value: function subscribe(event) {
      var _this2 = this;

      event.preventDefault();

      var $btn = $(event.currentTarget);
      var url = $btn.attr('data-url');

      this.$unsubscribeButtons.attr('data-url', url);

      $.ajax({
        type: 'POST',
        url: url
      }).done(function () {
        _this2.toggleSubscriptionButtons();
      });
    }
  }, {
    key: 'toggleSubscriptionButtons',
    value: function toggleSubscriptionButtons() {
      this.$dropdown.toggleClass('hidden');
      this.$subscribeButtons.toggleClass('hidden');
      this.$unsubscribeButtons.toggleClass('hidden');
    }
  }]);

  return GroupLabelSubscription;
}();

window.gl = window.gl || {};
window.gl.GroupLabelSubscription = GroupLabelSubscription;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./groups_list.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filterable_list__ = __webpack_require__("./filterable_list.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



/**
 * Makes search request for groups when user types a value in the search input.
 * Updates the html content of the page with the received one.
 */

var GroupsList = function GroupsList() {
  _classCallCheck(this, GroupsList);

  var form = document.querySelector('form#group-filter-form');
  var filter = document.querySelector('.js-groups-list-filter');
  var holder = document.querySelector('.js-groups-list-holder');

  if (form && filter && holder) {
    var list = new __WEBPACK_IMPORTED_MODULE_0__filterable_list__["a" /* default */](form, filter, holder);
    list.initSearch();
  }
};

/* harmony default export */ __webpack_exports__["default"] = (GroupsList);

/***/ }),

/***/ "./groups_select.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("./api.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
/* eslint-disable func-names, space-before-function-paren, no-var, wrap-iife, one-var,
                  camelcase, one-var-declaration-per-line, quotes, object-shorthand,
                  prefer-arrow-callback, comma-dangle, consistent-return, yoda,
                  prefer-rest-params, prefer-spread, no-unused-vars, prefer-template,
                  promise/catch-or-return */



var slice = [].slice;

window.GroupsSelect = function () {
  function GroupsSelect() {
    $('.ajax-groups-select').each(function (_this) {
      var self = _this;

      return function (i, select) {
        var all_available, skip_groups;
        var $select = $(select);
        all_available = $select.data('all-available');
        skip_groups = $select.data('skip-groups') || [];

        $select.select2({
          placeholder: "Search for a group",
          multiple: $select.hasClass('multiselect'),
          minimumInputLength: 0,
          ajax: {
            url: __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].buildUrl(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].groupsPath),
            dataType: 'json',
            quietMillis: 250,
            transport: function transport(params) {
              $.ajax(params).then(function (data, status, xhr) {
                var results = data || [];

                var headers = Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils_common_utils__["s" /* normalizeCRLFHeaders */])(xhr.getAllResponseHeaders());
                var currentPage = parseInt(headers['X-PAGE'], 10) || 0;
                var totalPages = parseInt(headers['X-TOTAL-PAGES'], 10) || 0;
                var more = currentPage < totalPages;

                return {
                  results: results,
                  pagination: {
                    more: more
                  }
                };
              }).then(params.success).fail(params.error);
            },
            data: function data(search, page) {
              return {
                search: search,
                page: page,
                per_page: GroupsSelect.PER_PAGE,
                all_available: all_available
              };
            },
            results: function results(data, page) {
              if (data.length) return { results: [] };

              var groups = data.length ? data : data.results || [];
              var more = data.pagination ? data.pagination.more : false;
              var results = groups.filter(function (group) {
                return skip_groups.indexOf(group.id) === -1;
              });

              return {
                results: results,
                page: page,
                more: more
              };
            }
          },
          initSelection: function initSelection(element, callback) {
            var id;
            id = $(element).val();
            if (id !== "") {
              return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].group(id, callback);
            }
          },
          formatResult: function formatResult() {
            var args;
            args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
            return self.formatResult.apply(self, args);
          },
          formatSelection: function formatSelection() {
            var args;
            args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
            return self.formatSelection.apply(self, args);
          },
          dropdownCssClass: "ajax-groups-dropdown select2-infinite",
          // we do not want to escape markup since we are displaying html in results
          escapeMarkup: function escapeMarkup(m) {
            return m;
          }
        });

        self.dropdown = document.querySelector('.select2-infinite .select2-results');

        $select.on('select2-loaded', self.forceOverflow.bind(self));
      };
    }(this));
  }

  GroupsSelect.prototype.formatResult = function (group) {
    var avatar;
    if (group.avatar_url) {
      avatar = group.avatar_url;
    } else {
      avatar = gon.default_avatar_url;
    }
    return "<div class='group-result'> <div class='group-name'>" + group.full_name + "</div> <div class='group-path'>" + group.full_path + "</div> </div>";
  };

  GroupsSelect.prototype.formatSelection = function (group) {
    return group.full_name;
  };

  GroupsSelect.prototype.forceOverflow = function (e) {
    this.dropdown.style.height = Math.floor(this.dropdown.scrollHeight) + 'px';
  };

  GroupsSelect.PER_PAGE = 20;

  return GroupsSelect;
}();
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./header.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, prefer-arrow-callback, no-var */

$(document).on('todo:toggle', function (e, count) {
  var $todoPendingCount = $('.todos-count');
  $todoPendingCount.text(gl.text.highCountTrim(count));
  $todoPendingCount.toggleClass('hidden', count === 0);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./helpers/issuables_helper.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./droplab/drop_lab.js + 7 modules
var drop_lab = __webpack_require__("./droplab/drop_lab.js");

// EXTERNAL MODULE: ./droplab/plugins/input_setter.js
var input_setter = __webpack_require__("./droplab/plugins/input_setter.js");

// CONCATENATED MODULE: ./close_reopen_report_toggle.js
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




// Todo: Remove this when fixing issue in input_setter plugin
var InputSetter = Object.assign({}, input_setter["a" /* default */]);

var close_reopen_report_toggle_CloseReopenReportToggle = function () {
  function CloseReopenReportToggle() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, CloseReopenReportToggle);

    this.dropdownTrigger = opts.dropdownTrigger;
    this.dropdownList = opts.dropdownList;
    this.button = opts.button;
  }

  _createClass(CloseReopenReportToggle, [{
    key: 'initDroplab',
    value: function initDroplab() {
      this.reopenItem = this.dropdownList.querySelector('.reopen-item');
      this.closeItem = this.dropdownList.querySelector('.close-item');

      this.droplab = new drop_lab["a" /* default */]();

      var config = this.setConfig();

      this.droplab.init(this.dropdownTrigger, this.dropdownList, [InputSetter], config);
    }
  }, {
    key: 'updateButton',
    value: function updateButton(isClosed) {
      this.toggleButtonType(isClosed);

      this.button.blur();
    }
  }, {
    key: 'toggleButtonType',
    value: function toggleButtonType(isClosed) {
      var _getButtonTypes = this.getButtonTypes(isClosed),
          _getButtonTypes2 = _slicedToArray(_getButtonTypes, 2),
          showItem = _getButtonTypes2[0],
          hideItem = _getButtonTypes2[1];

      showItem.classList.remove('hidden');
      showItem.classList.add('droplab-item-selected');

      hideItem.classList.add('hidden');
      hideItem.classList.remove('droplab-item-selected');

      showItem.click();
    }
  }, {
    key: 'getButtonTypes',
    value: function getButtonTypes(isClosed) {
      return isClosed ? [this.reopenItem, this.closeItem] : [this.closeItem, this.reopenItem];
    }
  }, {
    key: 'setDisable',
    value: function setDisable() {
      var shouldDisable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (shouldDisable) {
        this.button.setAttribute('disabled', 'true');
        this.dropdownTrigger.setAttribute('disabled', 'true');
      } else {
        this.button.removeAttribute('disabled');
        this.dropdownTrigger.removeAttribute('disabled');
      }
    }
  }, {
    key: 'setConfig',
    value: function setConfig() {
      var config = {
        InputSetter: [{
          input: this.button,
          valueAttribute: 'data-text',
          inputAttribute: 'data-value'
        }, {
          input: this.button,
          valueAttribute: 'data-text',
          inputAttribute: 'title'
        }, {
          input: this.button,
          valueAttribute: 'data-button-class',
          inputAttribute: 'class'
        }, {
          input: this.dropdownTrigger,
          valueAttribute: 'data-toggle-class',
          inputAttribute: 'class'
        }, {
          input: this.button,
          valueAttribute: 'data-url',
          inputAttribute: 'href'
        }, {
          input: this.button,
          valueAttribute: 'data-method',
          inputAttribute: 'data-method'
        }]
      };

      return config;
    }
  }]);

  return CloseReopenReportToggle;
}();

/* harmony default export */ var close_reopen_report_toggle = (close_reopen_report_toggle_CloseReopenReportToggle);
// CONCATENATED MODULE: ./helpers/issuables_helper.js


function initCloseReopenReport() {
  var container = document.querySelector('.js-issuable-close-dropdown');

  if (!container) return undefined;

  var dropdownTrigger = container.querySelector('.js-issuable-close-toggle');
  var dropdownList = container.querySelector('.js-issuable-close-menu');
  var button = container.querySelector('.js-issuable-close-button');

  var closeReopenReportToggle = new close_reopen_report_toggle({
    dropdownTrigger: dropdownTrigger,
    dropdownList: dropdownList,
    button: button
  });

  closeReopenReportToggle.initDroplab();

  return closeReopenReportToggle;
}

var IssuablesHelper = {
  initCloseReopenReport: initCloseReopenReport
};

/* harmony default export */ var issuables_helper = __webpack_exports__["a"] = (IssuablesHelper);

/***/ }),

/***/ "./helpers/user_feature_helper.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);


/* harmony default export */ __webpack_exports__["a"] = ({
  isNewRepoEnabled: function isNewRepoEnabled() {
    return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('new_repo') === 'true';
  }
});

/***/ }),

/***/ "./image_diff/helpers/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./image_diff/helpers/badge_helper.js
function createImageBadge(noteId, _ref) {
  var x = _ref.x,
      y = _ref.y;
  var classNames = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var buttonEl = document.createElement('button');
  var classList = classNames.concat(['js-image-badge']);
  classList.forEach(function (className) {
    return buttonEl.classList.add(className);
  });
  buttonEl.setAttribute('type', 'button');
  buttonEl.setAttribute('disabled', true);
  buttonEl.dataset.noteId = noteId;
  buttonEl.style.left = x + 'px';
  buttonEl.style.top = y + 'px';

  return buttonEl;
}

function addImageBadge(containerEl, _ref2) {
  var coordinate = _ref2.coordinate,
      badgeText = _ref2.badgeText,
      noteId = _ref2.noteId;

  var buttonEl = createImageBadge(noteId, coordinate, ['badge']);
  buttonEl.innerText = badgeText;

  containerEl.appendChild(buttonEl);
}

function addImageCommentBadge(containerEl, _ref3) {
  var coordinate = _ref3.coordinate,
      noteId = _ref3.noteId;

  var buttonEl = createImageBadge(noteId, coordinate, ['image-comment-badge', 'inverted']);
  var iconEl = document.createElement('i');
  iconEl.className = 'fa fa-comment-o';
  iconEl.setAttribute('aria-label', 'comment');

  buttonEl.appendChild(iconEl);
  containerEl.appendChild(buttonEl);
}

function addAvatarBadge(el, event) {
  var _event$detail = event.detail,
      noteId = _event$detail.noteId,
      badgeNumber = _event$detail.badgeNumber;

  // Add badge to new comment

  var avatarBadgeEl = el.querySelector('#' + noteId + ' .badge');
  avatarBadgeEl.innerText = badgeNumber;
  avatarBadgeEl.classList.remove('hidden');
}
// CONCATENATED MODULE: ./image_diff/helpers/comment_indicator_helper.js
function addCommentIndicator(containerEl, _ref) {
  var x = _ref.x,
      y = _ref.y;

  var buttonEl = document.createElement('button');
  buttonEl.classList.add('btn-transparent');
  buttonEl.classList.add('comment-indicator');
  buttonEl.setAttribute('type', 'button');
  buttonEl.style.left = x + 'px';
  buttonEl.style.top = y + 'px';

  buttonEl.innerHTML = gl.utils.spriteIcon('image-comment-dark');

  containerEl.appendChild(buttonEl);
}

function removeCommentIndicator(imageFrameEl) {
  var commentIndicatorEl = imageFrameEl.querySelector('.comment-indicator');
  var imageEl = imageFrameEl.querySelector('img');
  var willRemove = !!commentIndicatorEl;
  var meta = {};

  if (willRemove) {
    meta = {
      x: parseInt(commentIndicatorEl.style.left, 10),
      y: parseInt(commentIndicatorEl.style.top, 10),
      image: {
        width: imageEl.width,
        height: imageEl.height
      }
    };

    commentIndicatorEl.remove();
  }

  return Object.assign({}, meta, {
    removed: willRemove
  });
}

function showCommentIndicator(imageFrameEl, coordinate) {
  var x = coordinate.x,
      y = coordinate.y;

  var commentIndicatorEl = imageFrameEl.querySelector('.comment-indicator');

  if (commentIndicatorEl) {
    commentIndicatorEl.style.left = x + 'px';
    commentIndicatorEl.style.top = y + 'px';
  } else {
    addCommentIndicator(imageFrameEl, coordinate);
  }
}

function commentIndicatorOnClick(event) {
  // Prevent from triggering onAddImageDiffNote in notes.js
  event.stopPropagation();

  var buttonEl = event.currentTarget;
  var diffViewerEl = buttonEl.closest('.diff-viewer');
  var textareaEl = diffViewerEl.querySelector('.note-container .note-textarea');
  textareaEl.focus();
}
// CONCATENATED MODULE: ./image_diff/helpers/dom_helper.js
function setPositionDataAttribute(el, options) {
  // Update position data attribute so that the
  // new comment form can use this data for ajax request
  var x = options.x,
      y = options.y,
      width = options.width,
      height = options.height;

  var position = el.dataset.position;
  var positionObject = Object.assign({}, JSON.parse(position), {
    x: x,
    y: y,
    width: width,
    height: height
  });

  el.setAttribute('data-position', JSON.stringify(positionObject));
}

function updateDiscussionAvatarBadgeNumber(discussionEl, newBadgeNumber) {
  var avatarBadgeEl = discussionEl.querySelector('.image-diff-avatar-link .badge');
  avatarBadgeEl.innerText = newBadgeNumber;
}

function updateDiscussionBadgeNumber(discussionEl, newBadgeNumber) {
  var discussionBadgeEl = discussionEl.querySelector('.badge');
  discussionBadgeEl.innerText = newBadgeNumber;
}

function toggleCollapsed(event) {
  var toggleButtonEl = event.currentTarget;
  var discussionNotesEl = toggleButtonEl.closest('.discussion-notes');
  var formEl = discussionNotesEl.querySelector('.discussion-form');
  var isCollapsed = discussionNotesEl.classList.contains('collapsed');

  if (isCollapsed) {
    discussionNotesEl.classList.remove('collapsed');
  } else {
    discussionNotesEl.classList.add('collapsed');
  }

  // Override the inline display style set in notes.js
  if (formEl && !isCollapsed) {
    formEl.style.display = 'none';
  } else if (formEl && isCollapsed) {
    formEl.style.display = 'block';
  }
}
// EXTERNAL MODULE: ./image_diff/image_badge.js
var image_badge = __webpack_require__("./image_diff/image_badge.js");

// EXTERNAL MODULE: ./image_diff/image_diff.js
var image_diff = __webpack_require__("./image_diff/image_diff.js");

// CONCATENATED MODULE: ./image_diff/view_types.js
var viewTypes = {
  TWO_UP: 'TWO_UP',
  SWIPE: 'SWIPE',
  ONION_SKIN: 'ONION_SKIN'
};

function isValidViewType(validate) {
  return !!Object.getOwnPropertyNames(viewTypes).find(function (viewType) {
    return viewType === validate;
  });
}
// CONCATENATED MODULE: ./image_diff/replaced_image_diff.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var replaced_image_diff_ReplacedImageDiff = function (_ImageDiff) {
  _inherits(ReplacedImageDiff, _ImageDiff);

  function ReplacedImageDiff() {
    _classCallCheck(this, ReplacedImageDiff);

    return _possibleConstructorReturn(this, (ReplacedImageDiff.__proto__ || Object.getPrototypeOf(ReplacedImageDiff)).apply(this, arguments));
  }

  _createClass(ReplacedImageDiff, [{
    key: 'init',
    value: function init() {
      var _imageFrameEls, _viewModesEls;

      var defaultViewType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : viewTypes.TWO_UP;

      this.imageFrameEls = (_imageFrameEls = {}, _defineProperty(_imageFrameEls, viewTypes.TWO_UP, this.el.querySelector('.two-up .js-image-frame')), _defineProperty(_imageFrameEls, viewTypes.SWIPE, this.el.querySelector('.swipe .js-image-frame')), _defineProperty(_imageFrameEls, viewTypes.ONION_SKIN, this.el.querySelector('.onion-skin .js-image-frame')), _imageFrameEls);

      var viewModesEl = this.el.querySelector('.view-modes-menu');
      this.viewModesEls = (_viewModesEls = {}, _defineProperty(_viewModesEls, viewTypes.TWO_UP, viewModesEl.querySelector('.two-up')), _defineProperty(_viewModesEls, viewTypes.SWIPE, viewModesEl.querySelector('.swipe')), _defineProperty(_viewModesEls, viewTypes.ONION_SKIN, viewModesEl.querySelector('.onion-skin')), _viewModesEls);

      this.currentView = defaultViewType;
      this.generateImageEls();
      this.bindEvents();
    }
  }, {
    key: 'generateImageEls',
    value: function generateImageEls() {
      var _this2 = this;

      this.imageEls = {};

      var viewTypeNames = Object.getOwnPropertyNames(viewTypes);
      viewTypeNames.forEach(function (viewType) {
        _this2.imageEls[viewType] = _this2.imageFrameEls[viewType].querySelector('img');
      });
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      _get(ReplacedImageDiff.prototype.__proto__ || Object.getPrototypeOf(ReplacedImageDiff.prototype), 'bindEvents', this).call(this);

      this.changeToViewTwoUp = this.changeView.bind(this, viewTypes.TWO_UP);
      this.changeToViewSwipe = this.changeView.bind(this, viewTypes.SWIPE);
      this.changeToViewOnionSkin = this.changeView.bind(this, viewTypes.ONION_SKIN);

      this.viewModesEls[viewTypes.TWO_UP].addEventListener('click', this.changeToViewTwoUp);
      this.viewModesEls[viewTypes.SWIPE].addEventListener('click', this.changeToViewSwipe);
      this.viewModesEls[viewTypes.ONION_SKIN].addEventListener('click', this.changeToViewOnionSkin);
    }
  }, {
    key: 'changeView',
    value: function changeView(newView) {
      if (!isValidViewType(newView)) {
        return;
      }

      var indicator = helpers.removeCommentIndicator(this.imageFrameEl);

      this.currentView = newView;

      // Clear existing badges on new view
      var existingBadges = this.imageFrameEl.querySelectorAll('.badge');
      [].concat(_toConsumableArray(existingBadges)).map(function (badge) {
        return badge.remove();
      });

      // Remove existing references to old view image badges
      this.imageBadges = [];

      // Image_file.js has a fade animation of 200ms for loading the view
      // Need to wait an additional 250ms for the images to be displayed
      // on window in order to re-normalize their dimensions
      setTimeout(this.renderNewView.bind(this, indicator), 250);
    }
  }, {
    key: 'renderNewView',
    value: function renderNewView(indicator) {
      // Generate badge coordinates on new view
      this.renderBadges();

      // Re-render indicator in new view
      if (indicator.removed) {
        var normalizedIndicator = helpers.resizeCoordinatesToImageElement(this.imageEl, {
          x: indicator.x,
          y: indicator.y,
          width: indicator.image.width,
          height: indicator.image.height
        });
        helpers.showCommentIndicator(this.imageFrameEl, normalizedIndicator);
      }
    }
  }, {
    key: 'imageEl',
    get: function get() {
      return this.imageEls[this.currentView];
    }
  }, {
    key: 'imageFrameEl',
    get: function get() {
      return this.imageFrameEls[this.currentView];
    }
  }]);

  return ReplacedImageDiff;
}(image_diff["a" /* default */]);

/* harmony default export */ var replaced_image_diff = (replaced_image_diff_ReplacedImageDiff);
// EXTERNAL MODULE: ./commit/image_file.js
var image_file = __webpack_require__("./commit/image_file.js");

// CONCATENATED MODULE: ./image_diff/helpers/utils_helper.js





function resizeCoordinatesToImageElement(imageEl, meta) {
  var x = meta.x,
      y = meta.y,
      width = meta.width,
      height = meta.height;


  var imageWidth = imageEl.width;
  var imageHeight = imageEl.height;

  var widthRatio = imageWidth / width;
  var heightRatio = imageHeight / height;

  return {
    x: Math.round(x * widthRatio),
    y: Math.round(y * heightRatio),
    width: imageWidth,
    height: imageHeight
  };
}

function generateBadgeFromDiscussionDOM(imageFrameEl, discussionEl) {
  var position = JSON.parse(discussionEl.dataset.position);
  var firstNoteEl = discussionEl.querySelector('.note');
  var badge = new image_badge["a" /* default */]({
    actual: position,
    imageEl: imageFrameEl.querySelector('img'),
    noteId: firstNoteEl.id,
    discussionId: discussionEl.dataset.discussionId
  });

  return badge;
}

function getTargetSelection(event) {
  var containerEl = event.currentTarget;
  var imageEl = containerEl.querySelector('img');

  var x = event.offsetX;
  var y = event.offsetY;

  var width = imageEl.width;
  var height = imageEl.height;

  var actualWidth = imageEl.naturalWidth;
  var actualHeight = imageEl.naturalHeight;

  var widthRatio = actualWidth / width;
  var heightRatio = actualHeight / height;

  // Browser will include the frame as a clickable target,
  // which would result in potential 1px out of bounds value
  // This bound the coordinates to inside the frame
  var normalizedX = Math.max(0, x) && Math.min(x, width);
  var normalizedY = Math.max(0, y) && Math.min(y, height);

  return {
    browser: {
      x: normalizedX,
      y: normalizedY,
      width: width,
      height: height
    },
    actual: {
      // Round x, y so that we don't need to deal with decimals
      x: Math.round(normalizedX * widthRatio),
      y: Math.round(normalizedY * heightRatio),
      width: actualWidth,
      height: actualHeight
    }
  };
}

function initImageDiff(fileEl, canCreateNote, renderCommentBadge) {
  var options = {
    canCreateNote: canCreateNote,
    renderCommentBadge: renderCommentBadge
  };
  var diff = void 0;

  // ImageFile needs to be invoked before initImageDiff so that badges
  // can mount to the correct location
  new gl.ImageFile(fileEl); // eslint-disable-line no-new

  if (fileEl.querySelector('.diff-file .js-single-image')) {
    diff = new image_diff["a" /* default */](fileEl, options);
    diff.init();
  } else if (fileEl.querySelector('.diff-file .js-replaced-image')) {
    diff = new replaced_image_diff(fileEl, options);
    diff.init();
  }

  return diff;
}
// CONCATENATED MODULE: ./image_diff/helpers/index.js





/* harmony default export */ var helpers = __webpack_exports__["a"] = ({
  addCommentIndicator: addCommentIndicator,
  removeCommentIndicator: removeCommentIndicator,
  showCommentIndicator: showCommentIndicator,
  commentIndicatorOnClick: commentIndicatorOnClick,

  addImageBadge: addImageBadge,
  addImageCommentBadge: addImageCommentBadge,
  addAvatarBadge: addAvatarBadge,

  setPositionDataAttribute: setPositionDataAttribute,
  updateDiscussionAvatarBadgeNumber: updateDiscussionAvatarBadgeNumber,
  updateDiscussionBadgeNumber: updateDiscussionBadgeNumber,
  toggleCollapsed: toggleCollapsed,

  resizeCoordinatesToImageElement: resizeCoordinatesToImageElement,
  generateBadgeFromDiscussionDOM: generateBadgeFromDiscussionDOM,
  getTargetSelection: getTargetSelection,
  initImageDiff: initImageDiff
});

/***/ }),

/***/ "./image_diff/image_badge.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_index__ = __webpack_require__("./image_diff/helpers/index.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var defaultMeta = {
  x: 0,
  y: 0,
  width: 0,
  height: 0
};

var ImageBadge = function ImageBadge(options) {
  _classCallCheck(this, ImageBadge);

  var noteId = options.noteId,
      discussionId = options.discussionId;


  this.actual = options.actual || defaultMeta;
  this.browser = options.browser || defaultMeta;
  this.noteId = noteId;
  this.discussionId = discussionId;

  if (options.imageEl && !options.browser) {
    this.browser = __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].resizeCoordinatesToImageElement(options.imageEl, this.actual);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (ImageBadge);

/***/ }),

/***/ "./image_diff/image_diff.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_index__ = __webpack_require__("./image_diff/helpers/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__image_badge__ = __webpack_require__("./image_diff/image_badge.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils_image_utility__ = __webpack_require__("./lib/utils/image_utility.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var ImageDiff = function () {
  function ImageDiff(el, options) {
    _classCallCheck(this, ImageDiff);

    this.el = el;
    this.canCreateNote = !!(options && options.canCreateNote);
    this.renderCommentBadge = !!(options && options.renderCommentBadge);
    this.$noteContainer = $('.note-container', this.el);
    this.imageBadges = [];
  }

  _createClass(ImageDiff, [{
    key: 'init',
    value: function init() {
      this.imageFrameEl = this.el.querySelector('.diff-file .js-image-frame');
      this.imageEl = this.imageFrameEl.querySelector('img');

      this.bindEvents();
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      this.imageClickedWrapper = this.imageClicked.bind(this);
      this.imageBlurredWrapper = __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].removeCommentIndicator.bind(null, this.imageFrameEl);
      this.addBadgeWrapper = this.addBadge.bind(this);
      this.removeBadgeWrapper = this.removeBadge.bind(this);
      this.renderBadgesWrapper = this.renderBadges.bind(this);

      // Render badges
      if (Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_image_utility__["a" /* isImageLoaded */])(this.imageEl)) {
        this.renderBadges();
      } else {
        this.imageEl.addEventListener('load', this.renderBadgesWrapper);
      }

      // jquery makes the event delegation here much simpler
      this.$noteContainer.on('click', '.js-diff-notes-toggle', __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].toggleCollapsed);
      $(this.el).on('click', '.comment-indicator', __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].commentIndicatorOnClick);

      if (this.canCreateNote) {
        this.el.addEventListener('click.imageDiff', this.imageClickedWrapper);
        this.el.addEventListener('blur.imageDiff', this.imageBlurredWrapper);
        this.el.addEventListener('addBadge.imageDiff', this.addBadgeWrapper);
        this.el.addEventListener('removeBadge.imageDiff', this.removeBadgeWrapper);
      }
    }
  }, {
    key: 'imageClicked',
    value: function imageClicked(event) {
      var customEvent = event.detail;
      var selection = __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].getTargetSelection(customEvent);
      var el = customEvent.currentTarget;

      __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].setPositionDataAttribute(el, selection.actual);
      __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].showCommentIndicator(this.imageFrameEl, selection.browser);
    }
  }, {
    key: 'renderBadges',
    value: function renderBadges() {
      var discussionsEls = this.el.querySelectorAll('.note-container .discussion-notes .notes');
      [].concat(_toConsumableArray(discussionsEls)).forEach(this.renderBadge.bind(this));
    }
  }, {
    key: 'renderBadge',
    value: function renderBadge(discussionEl, index) {
      var imageBadge = __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].generateBadgeFromDiscussionDOM(this.imageFrameEl, discussionEl);

      this.imageBadges.push(imageBadge);

      var options = {
        coordinate: imageBadge.browser,
        noteId: imageBadge.noteId
      };

      if (this.renderCommentBadge) {
        __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].addImageCommentBadge(this.imageFrameEl, options);
      } else {
        var numberBadgeOptions = Object.assign({}, options, {
          badgeText: index + 1
        });

        __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].addImageBadge(this.imageFrameEl, numberBadgeOptions);
      }
    }
  }, {
    key: 'addBadge',
    value: function addBadge(event) {
      var _event$detail = event.detail,
          x = _event$detail.x,
          y = _event$detail.y,
          width = _event$detail.width,
          height = _event$detail.height,
          noteId = _event$detail.noteId,
          discussionId = _event$detail.discussionId;

      var badgeText = this.imageBadges.length + 1;
      var imageBadge = new __WEBPACK_IMPORTED_MODULE_1__image_badge__["a" /* default */]({
        actual: {
          x: x,
          y: y,
          width: width,
          height: height
        },
        imageEl: this.imageFrameEl.querySelector('img'),
        noteId: noteId,
        discussionId: discussionId
      });

      this.imageBadges.push(imageBadge);

      __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].addImageBadge(this.imageFrameEl, {
        coordinate: imageBadge.browser,
        badgeText: badgeText,
        noteId: noteId
      });

      __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].addAvatarBadge(this.el, {
        detail: {
          noteId: noteId,
          badgeNumber: badgeText
        }
      });

      var discussionEl = this.el.querySelector('#discussion_' + discussionId);
      __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].updateDiscussionBadgeNumber(discussionEl, badgeText);
    }
  }, {
    key: 'removeBadge',
    value: function removeBadge(event) {
      var _this = this;

      var badgeNumber = event.detail.badgeNumber;

      var indexToRemove = badgeNumber - 1;
      var imageBadgeEls = this.imageFrameEl.querySelectorAll('.badge');

      if (this.imageBadges.length !== badgeNumber) {
        // Cascade badges count numbers for (avatar badges + image badges)
        this.imageBadges.forEach(function (badge, index) {
          if (index > indexToRemove) {
            var discussionId = badge.discussionId;

            var updatedBadgeNumber = index;
            var discussionEl = _this.el.querySelector('#discussion_' + discussionId);

            imageBadgeEls[index].innerText = updatedBadgeNumber;

            __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].updateDiscussionBadgeNumber(discussionEl, updatedBadgeNumber);
            __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].updateDiscussionAvatarBadgeNumber(discussionEl, updatedBadgeNumber);
          }
        });
      }

      this.imageBadges.splice(indexToRemove, 1);

      var imageBadgeEl = imageBadgeEls[indexToRemove];
      imageBadgeEl.remove();
    }
  }]);

  return ImageDiff;
}();

/* harmony default export */ __webpack_exports__["a"] = (ImageDiff);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./image_diff/init_discussion_tab.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_index__ = __webpack_require__("./image_diff/helpers/index.js");
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



/* harmony default export */ __webpack_exports__["a"] = (function () {
  // Always pass can-create-note as false because a user
  // cannot place new badge markers on discussion tab
  var canCreateNote = false;
  var renderCommentBadge = true;

  var diffFileEls = document.querySelectorAll('.timeline-content .diff-file.js-image-file');
  [].concat(_toConsumableArray(diffFileEls)).forEach(function (diffFileEl) {
    return __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].initImageDiff(diffFileEl, canCreateNote, renderCommentBadge);
  });
});

/***/ }),

/***/ "./importer_status.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife, camelcase, no-var, one-var, one-var-declaration-per-line, prefer-template, quotes, object-shorthand, comma-dangle, no-unused-vars, prefer-arrow-callback, no-else-return, vars-on-top, no-new, max-len */

(function () {
  window.ImporterStatus = function () {
    function ImporterStatus(jobs_url, import_url) {
      this.jobs_url = jobs_url;
      this.import_url = import_url;
      this.initStatusPage();
      this.setAutoUpdate();
    }

    ImporterStatus.prototype.initStatusPage = function () {
      $('.js-add-to-import').off('click').on('click', function (_this) {
        return function (e) {
          var $btn, $namespace_input, $target_field, $tr, id, target_namespace, newName;
          $btn = $(e.currentTarget);
          $tr = $btn.closest('tr');
          $target_field = $tr.find('.import-target');
          $namespace_input = $target_field.find('.js-select-namespace option:selected');
          id = $tr.attr('id').replace('repo_', '');
          target_namespace = null;
          newName = null;
          if ($namespace_input.length > 0) {
            target_namespace = $namespace_input[0].innerHTML;
            newName = $target_field.find('#path').prop('value');
            $target_field.empty().append(target_namespace + "/" + newName);
          }
          $btn.disable().addClass('is-loading');
          return $.post(_this.import_url, {
            repo_id: id,
            target_namespace: target_namespace,
            new_name: newName
          }, {
            dataType: 'script'
          });
        };
      }(this));
      return $('.js-import-all').off('click').on('click', function (e) {
        var $btn;
        $btn = $(this);
        $btn.disable().addClass('is-loading');
        return $('.js-add-to-import').each(function () {
          return $(this).trigger('click');
        });
      });
    };

    ImporterStatus.prototype.setAutoUpdate = function () {
      return setInterval(function (_this) {
        return function () {
          return $.get(_this.jobs_url, function (data) {
            return $.each(data, function (i, job) {
              var job_item, status_field;
              job_item = $("#project_" + job.id);
              status_field = job_item.find(".job-status");
              if (job.import_status === 'finished') {
                job_item.removeClass("active").addClass("success");
                return status_field.html('<span><i class="fa fa-check"></i> done</span>');
              } else if (job.import_status === 'scheduled') {
                return status_field.html("<i class='fa fa-spinner fa-spin'></i> scheduled");
              } else if (job.import_status === 'started') {
                return status_field.html("<i class='fa fa-spinner fa-spin'></i> started");
              } else {
                return status_field.html(job.import_status);
              }
            });
          });
        };
      }(this), 4000);
    };

    return ImporterStatus;
  }();

  $(function () {
    if ($('.js-importer-status').length) {
      var jobsImportPath = $('.js-importer-status').data('jobs-import-path');
      var importPath = $('.js-importer-status').data('import-path');

      new window.ImporterStatus(jobsImportPath, importPath);
    }
  });
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./init_changes_dropdown.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_sticky__ = __webpack_require__("./lib/utils/sticky.js");


/* harmony default export */ __webpack_exports__["a"] = (function () {
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_utils_sticky__["a" /* default */])(document.querySelector('.js-diff-files-changed'));

  $('.js-diff-stats-dropdown').glDropdown({
    filterable: true,
    remoteFilter: false
  });
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./init_geo_info_modal.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony default export */ __webpack_exports__["a"] = (function () {
  var $modal = $('#modal-geo-info');

  if (!$modal.length) return;

  $modal.appendTo('body').modal({
    modal: true,
    show: false
  }).on('show.bs.modal', function (e) {
    var _$$data = $(e.currentTarget).data(),
        cloneUrlPrimary = _$$data.cloneUrlPrimary,
        cloneUrlSecondary = _$$data.cloneUrlSecondary;

    $('#geo-info-1').text('git clone ' + (cloneUrlSecondary || '<clone url for secondary repository>'));

    $('#geo-info-2').text('git remote set-url --push origin ' + (cloneUrlPrimary || '<clone url for primary repository>'));
  });
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./init_group_analytics.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* global Chart */
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var dataEl = document.getElementById('js-analytics-data');
  if (dataEl) {
    var data = JSON.parse(dataEl.innerHTML);
    var labels = data.labels;
    var outputElIds = ['push', 'issues_closed', 'merge_requests_created'];

    outputElIds.forEach(function (id) {
      var el = document.getElementById(id);
      var ctx = el.getContext('2d');
      var chart = new Chart(ctx);

      chart.Bar({
        labels: labels,
        datasets: [{
          fillColor: 'rgba(220,220,220,0.5)',
          strokeColor: 'rgba(220,220,220,1)',
          barStrokeWidth: 1,
          barValueSpacing: 1,
          barDatasetSpacing: 1,
          data: data[id].data
        }]
      }, {
        scaleOverlay: true,
        responsive: true,
        maintainAspectRatio: false
      });
    });

    $('#event-stats').tablesorter();
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./init_issuable_sidebar.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable no-new */
/* global MilestoneSelect */
/* global LabelsSelect */
/* global WeightSelect */
/* global IssuableContext */
/* global Sidebar */

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var sidebarOptions = JSON.parse(document.querySelector('.js-sidebar-options').innerHTML);

  new MilestoneSelect({
    full_path: sidebarOptions.fullPath
  });
  new LabelsSelect();
  new WeightSelect();
  new IssuableContext(sidebarOptions.currentUser);
  gl.Subscription.bindAll('.subscription');
  new gl.DueDateSelectors();
  window.sidebar = new Sidebar();
});

/***/ }),

/***/ "./init_legacy_filters.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__users_select__ = __webpack_require__("./users_select.js");
/* eslint-disable no-new */
/* global LabelsSelect */
/* global MilestoneSelect */
/* global IssueStatusSelect */
/* global SubscriptionSelect */
/* global WeightSelect */



/* harmony default export */ __webpack_exports__["a"] = (function () {
  new __WEBPACK_IMPORTED_MODULE_0__users_select__["a" /* default */]();
  new LabelsSelect();
  new MilestoneSelect();
  new IssueStatusSelect();
  new SubscriptionSelect();
  new WeightSelect();
});

/***/ }),

/***/ "./init_notes.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* global Notes */

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var dataEl = document.querySelector('.js-notes-data');

  var _JSON$parse = JSON.parse(dataEl.innerHTML),
      notesUrl = _JSON$parse.notesUrl,
      notesIds = _JSON$parse.notesIds,
      now = _JSON$parse.now,
      diffView = _JSON$parse.diffView,
      autocomplete = _JSON$parse.autocomplete;

  window.notes = new Notes(notesUrl, notesIds, now, diffView, autocomplete);
});

/***/ }),

/***/ "./issuable/auto_width_dropdown_select.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var instanceCount = 0;

var AutoWidthDropdownSelect = function () {
  function AutoWidthDropdownSelect(selectElement) {
    _classCallCheck(this, AutoWidthDropdownSelect);

    this.$selectElement = $(selectElement);
    this.dropdownClass = 'js-auto-width-select-dropdown-' + instanceCount;
    instanceCount += 1;
  }

  _createClass(AutoWidthDropdownSelect, [{
    key: 'init',
    value: function init() {
      var dropdownClass = this.dropdownClass;
      this.$selectElement.select2({
        dropdownCssClass: dropdownClass,
        dropdownCss: function dropdownCss() {
          var resultantWidth = 'auto';
          var $dropdown = $('.' + dropdownClass);

          // We have to look at the parent because
          // `offsetParent` on a `display: none;` is `null`
          var offsetParentWidth = $(this).parent().offsetParent().width();
          // Reset any width to let it naturally flow
          $dropdown.css('width', 'auto');
          if ($dropdown.outerWidth(false) > offsetParentWidth) {
            resultantWidth = offsetParentWidth;
          }

          return {
            width: resultantWidth,
            maxWidth: offsetParentWidth
          };
        }
      });

      return this;
    }
  }]);

  return AutoWidthDropdownSelect;
}();

/* harmony default export */ __webpack_exports__["a"] = (AutoWidthDropdownSelect);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./issuable_bulk_update_actions.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* eslint-disable comma-dangle, quotes, consistent-return, func-names, array-callback-return, space-before-function-paren, prefer-arrow-callback, max-len, no-unused-expressions, no-sequences, no-underscore-dangle, no-unused-vars, no-param-reassign */
/* global IssuableIndex */
/* global Flash */


/* harmony default export */ __webpack_exports__["a"] = ({
  init: function init() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        container = _ref.container,
        form = _ref.form,
        issues = _ref.issues,
        prefixId = _ref.prefixId;

    this.prefixId = prefixId || 'issue_';
    this.form = form || this.getElement('.bulk-update');
    this.$labelDropdown = this.form.find('.js-label-select');
    this.issues = issues || this.getElement('.issues-list .issue');
    this.willUpdateLabels = false;
    this.bindEvents();
  },
  bindEvents: function bindEvents() {
    return this.form.off('submit').on('submit', this.onFormSubmit.bind(this));
  },
  onFormSubmit: function onFormSubmit(e) {
    e.preventDefault();
    return this.submit();
  },
  submit: function submit() {
    var _this2 = this;

    var _this = this;
    var xhr = $.ajax({
      url: this.form.attr('action'),
      method: this.form.attr('method'),
      dataType: 'JSON',
      data: this.getFormDataAsObject()
    });
    xhr.done(function () {
      return window.location.reload();
    });
    xhr.fail(function () {
      return _this2.onFormSubmitFailure();
    });
  },
  onFormSubmitFailure: function onFormSubmitFailure() {
    this.form.find('[type="submit"]').enable();
    return new Flash("Issue update failed");
  },
  getSelectedIssues: function getSelectedIssues() {
    return this.issues.has('.selected_issue:checked');
  },
  getLabelsFromSelection: function getLabelsFromSelection() {
    var labels = [];
    this.getSelectedIssues().map(function () {
      var labelsData = $(this).data('labels');
      if (labelsData) {
        return labelsData.map(function (labelId) {
          if (labels.indexOf(labelId) === -1) {
            return labels.push(labelId);
          }
        });
      }
    });
    return labels;
  },


  /**
   * Will return only labels that were marked previously and the user has unmarked
   * @return {Array} Label IDs
   */

  getUnmarkedIndeterminedLabels: function getUnmarkedIndeterminedLabels() {
    var result = [];
    var labelsToKeep = this.$labelDropdown.data('indeterminate');

    this.getLabelsFromSelection().forEach(function (id) {
      if (labelsToKeep.indexOf(id) === -1) {
        result.push(id);
      }
    });

    return result;
  },


  /**
   * Simple form serialization, it will return just what we need
   * Returns key/value pairs from form data
   */

  getFormDataAsObject: function getFormDataAsObject() {
    var formData = {
      update: {
        state_event: this.form.find('input[name="update[state_event]"]').val(),
        // For Merge Requests
        assignee_id: this.form.find('input[name="update[assignee_id]"]').val(),
        // For Issues
        assignee_ids: [this.form.find('input[name="update[assignee_ids][]"]').val()],
        milestone_id: this.form.find('input[name="update[milestone_id]"]').val(),
        issuable_ids: this.form.find('input[name="update[issuable_ids]"]').val(),
        subscription_event: this.form.find('input[name="update[subscription_event]"]').val(),
        add_label_ids: [],
        remove_label_ids: []
      }
    };
    if (this.willUpdateLabels) {
      formData.update.add_label_ids = this.$labelDropdown.data('marked');
      formData.update.remove_label_ids = this.$labelDropdown.data('unmarked');
    }
    return formData;
  },
  setOriginalDropdownData: function setOriginalDropdownData() {
    var $labelSelect = $('.bulk-update .js-label-select');
    $labelSelect.data('common', this.getOriginalCommonIds());
    $labelSelect.data('marked', this.getOriginalMarkedIds());
    $labelSelect.data('indeterminate', this.getOriginalIndeterminateIds());
  },


  // From issuable's initial bulk selection
  getOriginalCommonIds: function getOriginalCommonIds() {
    var _this3 = this;

    var labelIds = [];

    this.getElement('.selected_issue:checked').each(function (i, el) {
      labelIds.push(_this3.getElement('#' + _this3.prefixId + el.dataset.id).data('labels'));
    });
    return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.intersection.apply(this, labelIds);
  },


  // From issuable's initial bulk selection
  getOriginalMarkedIds: function getOriginalMarkedIds() {
    var _this4 = this;

    var labelIds = [];
    this.getElement('.selected_issue:checked').each(function (i, el) {
      labelIds.push(_this4.getElement('#' + _this4.prefixId + el.dataset.id).data('labels'));
    });
    return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.intersection.apply(this, labelIds);
  },


  // From issuable's initial bulk selection
  getOriginalIndeterminateIds: function getOriginalIndeterminateIds() {
    var _this5 = this;

    var uniqueIds = [];
    var labelIds = [];
    var issuableLabels = [];

    // Collect unique label IDs for all checked issues
    this.getElement('.selected_issue:checked').each(function (i, el) {
      issuableLabels = _this5.getElement('#' + _this5.prefixId + el.dataset.id).data('labels');
      issuableLabels.forEach(function (labelId) {
        // Store unique IDs
        if (uniqueIds.indexOf(labelId) === -1) {
          uniqueIds.push(labelId);
        }
      });
      // Store array of IDs per issuable
      labelIds.push(issuableLabels);
    });
    // Add uniqueIds to add it as argument for _.intersection
    labelIds.unshift(uniqueIds);
    // Return IDs that are present but not in all selected issueables
    return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.difference(uniqueIds, __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.intersection.apply(this, labelIds));
  },
  getElement: function getElement(selector) {
    this.scopeEl = this.scopeEl || $('.content');
    return this.scopeEl.find(selector);
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./issuable_bulk_update_sidebar.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__issuable_bulk_update_actions__ = __webpack_require__("./issuable_bulk_update_actions.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this, no-new */
/* global LabelsSelect */
/* global MilestoneSelect */
/* global IssueStatusSelect */
/* global SubscriptionSelect */



var HIDDEN_CLASS = 'hidden';
var DISABLED_CONTENT_CLASS = 'disabled-content';
var SIDEBAR_EXPANDED_CLASS = 'right-sidebar-expanded issuable-bulk-update-sidebar';
var SIDEBAR_COLLAPSED_CLASS = 'right-sidebar-collapsed issuable-bulk-update-sidebar';

var IssuableBulkUpdateSidebar = function () {
  function IssuableBulkUpdateSidebar() {
    _classCallCheck(this, IssuableBulkUpdateSidebar);

    this.initDomElements();
    this.bindEvents();
    this.initDropdowns();
    this.setupBulkUpdateActions();
  }

  _createClass(IssuableBulkUpdateSidebar, [{
    key: 'initDomElements',
    value: function initDomElements() {
      this.$page = $('.page-with-sidebar');
      this.$sidebar = $('.right-sidebar');
      this.$sidebarInnerContainer = this.$sidebar.find('.issuable-sidebar');
      this.$bulkEditCancelBtn = $('.js-bulk-update-menu-hide');
      this.$bulkEditSubmitBtn = $('.update-selected-issues');
      this.$bulkUpdateEnableBtn = $('.js-bulk-update-toggle');
      this.$otherFilters = $('.issues-other-filters');
      this.$checkAllContainer = $('.check-all-holder');
      this.$issueChecks = $('.issue-check');
      this.$issuesList = $('.selected_issue');
      this.$issuableIdsInput = $('#update_issuable_ids');
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      var _this = this;

      this.$bulkUpdateEnableBtn.on('click', function (e) {
        return _this.toggleBulkEdit(e, true);
      });
      this.$bulkEditCancelBtn.on('click', function (e) {
        return _this.toggleBulkEdit(e, false);
      });
      this.$checkAllContainer.on('click', function (e) {
        return _this.selectAll(e);
      });
      this.$issuesList.on('change', function () {
        return _this.updateFormState();
      });
      this.$bulkEditSubmitBtn.on('click', function () {
        return _this.prepForSubmit();
      });
      this.$checkAllContainer.on('click', function () {
        return _this.updateFormState();
      });
    }
  }, {
    key: 'initDropdowns',
    value: function initDropdowns() {
      new LabelsSelect();
      new MilestoneSelect();
      new IssueStatusSelect();
      new SubscriptionSelect();
    }
  }, {
    key: 'setupBulkUpdateActions',
    value: function setupBulkUpdateActions() {
      __WEBPACK_IMPORTED_MODULE_0__issuable_bulk_update_actions__["a" /* default */].setOriginalDropdownData();
    }
  }, {
    key: 'updateFormState',
    value: function updateFormState() {
      var noCheckedIssues = !$('.selected_issue:checked').length;

      this.toggleSubmitButtonDisabled(noCheckedIssues);
      this.updateSelectedIssuableIds();

      __WEBPACK_IMPORTED_MODULE_0__issuable_bulk_update_actions__["a" /* default */].setOriginalDropdownData();
    }
  }, {
    key: 'prepForSubmit',
    value: function prepForSubmit() {
      var _this2 = this;

      // if submit button is disabled, submission is blocked. This ensures we disable after
      // form submission is carried out
      setTimeout(function () {
        return _this2.$bulkEditSubmitBtn.disable();
      });
      this.updateSelectedIssuableIds();
    }
  }, {
    key: 'toggleBulkEdit',
    value: function toggleBulkEdit(e, enable) {
      e.preventDefault();

      this.toggleSidebarDisplay(enable);
      this.toggleBulkEditButtonDisabled(enable);
      this.toggleOtherFiltersDisabled(enable);
      this.toggleCheckboxDisplay(enable);
    }
  }, {
    key: 'updateSelectedIssuableIds',
    value: function updateSelectedIssuableIds() {
      this.$issuableIdsInput.val(IssuableBulkUpdateSidebar.getCheckedIssueIds());
    }
  }, {
    key: 'selectAll',
    value: function selectAll() {
      var checkAllButtonState = this.$checkAllContainer.find('input').prop('checked');

      this.$issuesList.prop('checked', checkAllButtonState);
    }
  }, {
    key: 'toggleSidebarDisplay',
    value: function toggleSidebarDisplay(show) {
      this.$page.toggleClass(SIDEBAR_EXPANDED_CLASS, show);
      this.$page.toggleClass(SIDEBAR_COLLAPSED_CLASS, !show);
      this.$sidebarInnerContainer.toggleClass(HIDDEN_CLASS, !show);
      this.$sidebar.toggleClass(SIDEBAR_EXPANDED_CLASS, show);
      this.$sidebar.toggleClass(SIDEBAR_COLLAPSED_CLASS, !show);
    }
  }, {
    key: 'toggleBulkEditButtonDisabled',
    value: function toggleBulkEditButtonDisabled(disable) {
      if (disable) {
        this.$bulkUpdateEnableBtn.disable();
      } else {
        this.$bulkUpdateEnableBtn.enable();
      }
    }
  }, {
    key: 'toggleCheckboxDisplay',
    value: function toggleCheckboxDisplay(show) {
      this.$checkAllContainer.toggleClass(HIDDEN_CLASS, !show);
      this.$issueChecks.toggleClass(HIDDEN_CLASS, !show);
    }
  }, {
    key: 'toggleOtherFiltersDisabled',
    value: function toggleOtherFiltersDisabled(disable) {
      this.$otherFilters.toggleClass(DISABLED_CONTENT_CLASS, disable);
    }
  }, {
    key: 'toggleSubmitButtonDisabled',
    value: function toggleSubmitButtonDisabled(disable) {
      if (disable) {
        this.$bulkEditSubmitBtn.disable();
      } else {
        this.$bulkEditSubmitBtn.enable();
      }
    }
  }], [{
    key: 'getCheckedIssueIds',
    value: function getCheckedIssueIds() {
      var $checkedIssues = $('.selected_issue:checked');

      if ($checkedIssues.length > 0) {
        return $.map($checkedIssues, function (value) {
          return $(value).data('id');
        });
      }

      return [];
    }
  }]);

  return IssuableBulkUpdateSidebar;
}();

/* harmony default export */ __webpack_exports__["a"] = (IssuableBulkUpdateSidebar);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./issuable_context.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__breakpoints__ = __webpack_require__("./breakpoints.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__users_select__ = __webpack_require__("./users_select.js");
/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-new, comma-dangle, quotes, prefer-arrow-callback, consistent-return, one-var, no-var, one-var-declaration-per-line, no-underscore-dangle, max-len */




var PARTICIPANTS_ROW_COUNT = 7;

(function () {
  this.IssuableContext = function () {
    function IssuableContext(currentUser) {
      this.initParticipants();
      new __WEBPACK_IMPORTED_MODULE_2__users_select__["a" /* default */](currentUser);
      $('select.select2').select2({
        width: 'resolve',
        dropdownAutoWidth: true
      });
      $(".issuable-sidebar .inline-update").on("change", "select", function () {
        return $(this).submit();
      });
      $(".issuable-sidebar .inline-update").on("change", ".js-assignee", function () {
        return $(this).submit();
      });
      $(document).off('click', '.issuable-sidebar .dropdown-content a').on('click', '.issuable-sidebar .dropdown-content a', function (e) {
        return e.preventDefault();
      });
      $(document).off('click', '.edit-link').on('click', '.edit-link', function (e) {
        var $block, $selectbox;
        e.preventDefault();
        $block = $(this).parents('.block');
        $selectbox = $block.find('.selectbox');
        if ($selectbox.is(':visible')) {
          $selectbox.hide();
          $block.find('.value').show();
        } else {
          $selectbox.show();
          $block.find('.value').hide();
        }
        if ($selectbox.is(':visible')) {
          return setTimeout(function () {
            return $block.find('.dropdown-menu-toggle').trigger('click');
          }, 0);
        }
      });
      window.addEventListener('beforeunload', function () {
        // collapsed_gutter cookie hides the sidebar
        var bpBreakpoint = __WEBPACK_IMPORTED_MODULE_1__breakpoints__["a" /* default */].getBreakpointSize();
        if (bpBreakpoint === 'xs' || bpBreakpoint === 'sm') {
          __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('collapsed_gutter', true);
        }
      });
    }

    IssuableContext.prototype.initParticipants = function () {
      $(document).on("click", ".js-participants-more", this.toggleHiddenParticipants);
      return $(".js-participants-author").each(function (i) {
        if (i >= PARTICIPANTS_ROW_COUNT) {
          return $(this).addClass("js-participants-hidden").hide();
        }
      });
    };

    IssuableContext.prototype.toggleHiddenParticipants = function (e) {
      var currentText, lessText, originalText;
      e.preventDefault();
      currentText = $(this).text().trim();
      lessText = $(this).data("less-text");
      originalText = $(this).data("original-text");
      if (currentText === originalText) {
        $(this).text(lessText);

        if (gl.lazyLoader) gl.lazyLoader.loadCheck();
      } else {
        $(this).text(originalText);
      }

      $(".js-participants-hidden").toggle();
    };

    return IssuableContext;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./issuable_form.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pikaday__ = __webpack_require__("../../../node_modules/pikaday/pikaday.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pikaday___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pikaday__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__users_select__ = __webpack_require__("./users_select.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gfm_auto_complete__ = __webpack_require__("./gfm_auto_complete.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__zen_mode__ = __webpack_require__("./zen_mode.js");
/* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, no-use-before-define, no-useless-escape, no-new, quotes, object-shorthand, no-unused-vars, comma-dangle, no-alert, consistent-return, no-else-return, prefer-template, one-var, one-var-declaration-per-line, curly, max-len */
/* global GitLab */
/* global Autosave */
/* global GroupsSelect */
/* global dateFormat */






(function () {
  this.IssuableForm = function () {
    IssuableForm.prototype.wipRegex = /^\s*(\[WIP\]\s*|WIP:\s*|WIP\s+)+\s*/i;

    function IssuableForm(form) {
      var $issuableDueDate, calendar;
      this.form = form;
      this.toggleWip = this.toggleWip.bind(this);
      this.renderWipExplanation = this.renderWipExplanation.bind(this);
      this.resetAutosave = this.resetAutosave.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
      new __WEBPACK_IMPORTED_MODULE_2__gfm_auto_complete__["a" /* default */](gl.GfmAutoComplete && gl.GfmAutoComplete.dataSources).setup();
      new __WEBPACK_IMPORTED_MODULE_1__users_select__["a" /* default */]();
      new GroupsSelect();
      new __WEBPACK_IMPORTED_MODULE_3__zen_mode__["a" /* default */]();
      this.titleField = this.form.find("input[name*='[title]']");
      this.descriptionField = this.form.find("textarea[name*='[description]']");
      if (!(this.titleField.length && this.descriptionField.length)) {
        return;
      }
      this.initAutosave();
      this.form.on("submit", this.handleSubmit);
      this.form.on("click", ".btn-cancel", this.resetAutosave);
      this.initWip();
      $issuableDueDate = $('#issuable-due-date');
      if ($issuableDueDate.length) {
        calendar = new __WEBPACK_IMPORTED_MODULE_0_pikaday___default.a({
          field: $issuableDueDate.get(0),
          theme: 'gitlab-theme animate-picker',
          format: 'yyyy-mm-dd',
          container: $issuableDueDate.parent().get(0),
          onSelect: function onSelect(dateText) {
            $issuableDueDate.val(dateFormat(new Date(dateText), 'yyyy-mm-dd'));
          }
        });
        calendar.setDate(new Date($issuableDueDate.val()));
      }
    }

    IssuableForm.prototype.initAutosave = function () {
      new Autosave(this.titleField, [document.location.pathname, document.location.search, "title"]);
      return new Autosave(this.descriptionField, [document.location.pathname, document.location.search, "description"]);
    };

    IssuableForm.prototype.handleSubmit = function () {
      return this.resetAutosave();
    };

    IssuableForm.prototype.resetAutosave = function () {
      this.titleField.data("autosave").reset();
      return this.descriptionField.data("autosave").reset();
    };

    IssuableForm.prototype.initWip = function () {
      this.$wipExplanation = this.form.find(".js-wip-explanation");
      this.$noWipExplanation = this.form.find(".js-no-wip-explanation");
      if (!(this.$wipExplanation.length && this.$noWipExplanation.length)) {
        return;
      }
      this.form.on("click", ".js-toggle-wip", this.toggleWip);
      this.titleField.on("keyup blur", this.renderWipExplanation);
      return this.renderWipExplanation();
    };

    IssuableForm.prototype.workInProgress = function () {
      return this.wipRegex.test(this.titleField.val());
    };

    IssuableForm.prototype.renderWipExplanation = function () {
      if (this.workInProgress()) {
        this.$wipExplanation.show();
        return this.$noWipExplanation.hide();
      } else {
        this.$wipExplanation.hide();
        return this.$noWipExplanation.show();
      }
    };

    IssuableForm.prototype.toggleWip = function (event) {
      event.preventDefault();
      if (this.workInProgress()) {
        this.removeWip();
      } else {
        this.addWip();
      }
      return this.renderWipExplanation();
    };

    IssuableForm.prototype.removeWip = function () {
      return this.titleField.val(this.titleField.val().replace(this.wipRegex, ""));
    };

    IssuableForm.prototype.addWip = function () {
      return this.titleField.val("WIP: " + this.titleField.val());
    };

    return IssuableForm;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./issuable_index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__issuable_bulk_update_sidebar__ = __webpack_require__("./issuable_bulk_update_sidebar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__issuable_bulk_update_actions__ = __webpack_require__("./issuable_bulk_update_actions.js");
var _this2 = this;

/* eslint-disable no-param-reassign, func-names, no-var, camelcase, no-unused-vars, object-shorthand, space-before-function-paren, no-return-assign, comma-dangle, consistent-return, one-var, one-var-declaration-per-line, quotes, prefer-template, prefer-arrow-callback, wrap-iife, max-len */
/* global IssuableIndex */




(function (global) {
  var issuable_created;

  issuable_created = false;

  global.IssuableIndex = {
    init: function init(pagePrefix) {
      IssuableIndex.initTemplates();
      IssuableIndex.initSearch();
      IssuableIndex.initBulkUpdate(pagePrefix);
      IssuableIndex.initResetFilters();
      IssuableIndex.resetIncomingEmailToken();
      IssuableIndex.initLabelFilterRemove();
    },
    initTemplates: function initTemplates() {
      return IssuableIndex.labelRow = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.template('<% _.each(labels, function(label){ %> <span class="label-row btn-group" role="group" aria-label="<%- label.title %>" style="color: <%- label.text_color %>;"> <a href="#" class="btn btn-transparent has-tooltip" style="background-color: <%- label.color %>;" title="<%- label.description %>" data-container="body"> <%- label.title %> </a> <button type="button" class="btn btn-transparent label-remove js-label-filter-remove" style="background-color: <%- label.color %>;" data-label="<%- label.title %>"> <i class="fa fa-times"></i> </button> </span> <% }); %>');
    },
    initSearch: function initSearch() {
      var $searchInput = $('#issuable_search');

      IssuableIndex.initSearchState($searchInput);

      // `immediate` param set to false debounces on the `trailing` edge, lets user finish typing
      var debouncedExecSearch = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.debounce(IssuableIndex.executeSearch, 1000, false);

      $searchInput.off('keyup').on('keyup', debouncedExecSearch);

      // ensures existing filters are preserved when manually submitted
      $('#issuable_search_form').on('submit', function (e) {
        e.preventDefault();
        debouncedExecSearch(e);
      });
    },
    initSearchState: function initSearchState($searchInput) {
      var currentSearchVal = $searchInput.val();

      IssuableIndex.searchState = {
        elem: $searchInput,
        current: currentSearchVal
      };

      IssuableIndex.maybeFocusOnSearch();
    },
    accessSearchPristine: function accessSearchPristine(set) {
      // store reference to previous value to prevent search on non-mutating keyup
      var state = IssuableIndex.searchState;
      var currentSearchVal = state.elem.val();

      if (set) {
        state.current = currentSearchVal;
      } else {
        return state.current === currentSearchVal;
      }
    },
    maybeFocusOnSearch: function maybeFocusOnSearch() {
      var currentSearchVal = IssuableIndex.searchState.current;
      if (currentSearchVal && currentSearchVal !== '') {
        var queryLength = currentSearchVal.length;
        var $searchInput = IssuableIndex.searchState.elem;

        /* The following ensures that the cursor is initially placed at
          * the end of search input when focus is applied. It accounts
          * for differences in browser implementations of `setSelectionRange`
          * and cursor placement for elements in focus.
        */
        $searchInput.focus();
        if ($searchInput.setSelectionRange) {
          $searchInput.setSelectionRange(queryLength, queryLength);
        } else {
          $searchInput.val(currentSearchVal);
        }
      }
    },
    executeSearch: function executeSearch(e) {
      var $search = $('#issuable_search');
      var $searchName = $search.attr('name');
      var $searchValue = $search.val();
      var $filtersForm = $('.js-filter-form');
      var $input = $('input[name=\'' + $searchName + '\']', $filtersForm);
      var isPristine = IssuableIndex.accessSearchPristine();

      if (isPristine) {
        return;
      }

      if (!$input.length) {
        $filtersForm.append('<input type=\'hidden\' name=\'' + $searchName + '\' value=\'' + __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape($searchValue) + '\'/>');
      } else {
        $input.val($searchValue);
      }

      IssuableIndex.filterResults($filtersForm);
    },
    initLabelFilterRemove: function initLabelFilterRemove() {
      return $(document).off('click', '.js-label-filter-remove').on('click', '.js-label-filter-remove', function (e) {
        var $button;
        $button = $(this);
        // Remove the label input box
        $('input[name="label_name[]"]').filter(function () {
          return this.value === $button.data('label');
        }).remove();
        // Submit the form to get new data
        IssuableIndex.filterResults($('.filter-form'));
      });
    },
    filterResults: function (_this) {
      return function (form) {
        var formAction, formData, issuesUrl;
        formData = form.serializeArray();
        formData = formData.filter(function (data) {
          return data.value !== '';
        });
        formData = $.param(formData);
        formAction = form.attr('action');
        issuesUrl = formAction;
        issuesUrl += "" + (formAction.indexOf('?') === -1 ? '?' : '&');
        issuesUrl += formData;
        return gl.utils.visitUrl(issuesUrl);
      };
    }(_this2),
    initResetFilters: function initResetFilters() {
      $('.reset-filters').on('click', function (e) {
        e.preventDefault();
        var target = e.target;
        var $form = $(target).parents('.js-filter-form');
        var baseIssuesUrl = target.href;

        $form.attr('action', baseIssuesUrl);
        gl.utils.visitUrl(baseIssuesUrl);
      });
    },
    initBulkUpdate: function initBulkUpdate(pagePrefix) {
      var userCanBulkUpdate = $('.issues-bulk-update').length > 0;
      var alreadyInitialized = !!this.bulkUpdateSidebar;

      if (userCanBulkUpdate && !alreadyInitialized) {
        __WEBPACK_IMPORTED_MODULE_2__issuable_bulk_update_actions__["a" /* default */].init({
          prefixId: pagePrefix
        });

        this.bulkUpdateSidebar = new __WEBPACK_IMPORTED_MODULE_1__issuable_bulk_update_sidebar__["a" /* default */]();
      }
    },
    resetIncomingEmailToken: function resetIncomingEmailToken() {
      $('.incoming-email-token-reset').on('click', function (e) {
        e.preventDefault();

        $.ajax({
          type: 'PUT',
          url: $('.incoming-email-token-reset').attr('href'),
          dataType: 'json',
          success: function success(response) {
            $('#issue_email').val(response.new_issue_address).focus();
          },
          beforeSend: function beforeSend() {
            $('.incoming-email-token-reset').text('resetting...');
          },
          complete: function complete() {
            $('.incoming-email-token-reset').text('reset it');
          }
        });
      });
    }
  };
})(window);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./issue.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vendor_jquery_waitforimages__ = __webpack_require__("../../../vendor/assets/javascripts/jquery.waitforimages.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vendor_jquery_waitforimages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vendor_jquery_waitforimages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_text_utility__ = __webpack_require__("./lib/utils/text_utility.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__flash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__task_list__ = __webpack_require__("./task_list.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__create_merge_request_dropdown__ = __webpack_require__("./create_merge_request_dropdown.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_issuables_helper__ = __webpack_require__("./helpers/issuables_helper.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, one-var, no-underscore-dangle, one-var-declaration-per-line, object-shorthand, no-unused-vars, no-new, comma-dangle, consistent-return, quotes, dot-notation, quote-props, prefer-arrow-callback, max-len */
/* global Flash */








var Issue = function () {
  function Issue() {
    _classCallCheck(this, Issue);

    if ($('a.btn-close').length) {
      this.taskList = new __WEBPACK_IMPORTED_MODULE_3__task_list__["a" /* default */]({
        dataType: 'issue',
        fieldName: 'description',
        selector: '.detail-page-description',
        onSuccess: function onSuccess(result) {
          document.querySelector('#task_status').innerText = result.task_status;
          document.querySelector('#task_status_short').innerText = result.task_status_short;
        }
      });
      this.initIssueBtnEventListeners();
    }

    Issue.$btnNewBranch = $('#new-branch');
    Issue.createMrDropdownWrap = document.querySelector('.create-mr-dropdown-wrap');

    Issue.initMergeRequests();
    Issue.initRelatedBranches();

    this.closeButtons = $('a.btn-close');
    this.reopenButtons = $('a.btn-reopen');

    this.initCloseReopenReport();

    if (Issue.createMrDropdownWrap) {
      this.createMergeRequestDropdown = new __WEBPACK_IMPORTED_MODULE_4__create_merge_request_dropdown__["a" /* default */](Issue.createMrDropdownWrap);
    }
  }

  _createClass(Issue, [{
    key: 'initIssueBtnEventListeners',
    value: function initIssueBtnEventListeners() {
      var _this = this;

      var issueFailMessage = 'Unable to update this issue at this time.';

      return $(document).on('click', '.js-issuable-actions a.btn-close, .js-issuable-actions a.btn-reopen', function (e) {
        var $button, shouldSubmit, url;
        e.preventDefault();
        e.stopImmediatePropagation();
        $button = $(e.currentTarget);
        shouldSubmit = $button.hasClass('btn-comment');
        if (shouldSubmit) {
          Issue.submitNoteForm($button.closest('form'));
        }

        _this.disableCloseReopenButton($button);

        url = $button.attr('href');
        return $.ajax({
          type: 'PUT',
          url: url
        }).fail(function () {
          return new Flash(issueFailMessage);
        }).done(function (data) {
          var isClosedBadge = $('div.status-box-closed');
          var isOpenBadge = $('div.status-box-open');
          var projectIssuesCounter = $('.issue_counter');

          if ('id' in data) {
            var isClosed = $button.hasClass('btn-close');
            isClosedBadge.toggleClass('hidden', !isClosed);
            isOpenBadge.toggleClass('hidden', isClosed);

            $(document).trigger('issuable:change', isClosed);
            _this.toggleCloseReopenButton(isClosed);

            var numProjectIssues = Number(projectIssuesCounter.first().text().trim().replace(/[^\d]/, ''));
            numProjectIssues = isClosed ? numProjectIssues - 1 : numProjectIssues + 1;
            projectIssuesCounter.text(gl.text.addDelimiter(numProjectIssues));

            if (_this.createMergeRequestDropdown) {
              if (isClosed) {
                _this.createMergeRequestDropdown.unavailable();
                _this.createMergeRequestDropdown.disable();
              } else {
                // We should check in case a branch was created in another tab
                _this.createMergeRequestDropdown.checkAbilityToCreateBranch();
              }
            }
          } else {
            new Flash(issueFailMessage);
          }
        }).then(function () {
          _this.disableCloseReopenButton($button, false);
        });
      });
    }
  }, {
    key: 'initCloseReopenReport',
    value: function initCloseReopenReport() {
      this.closeReopenReportToggle = __WEBPACK_IMPORTED_MODULE_5__helpers_issuables_helper__["a" /* default */].initCloseReopenReport();

      if (this.closeButtons) this.closeButtons = this.closeButtons.not('.issuable-close-button');
      if (this.reopenButtons) this.reopenButtons = this.reopenButtons.not('.issuable-close-button');
    }
  }, {
    key: 'disableCloseReopenButton',
    value: function disableCloseReopenButton($button, shouldDisable) {
      if (this.closeReopenReportToggle) {
        this.closeReopenReportToggle.setDisable(shouldDisable);
      } else {
        $button.prop('disabled', shouldDisable);
      }
    }
  }, {
    key: 'toggleCloseReopenButton',
    value: function toggleCloseReopenButton(isClosed) {
      if (this.closeReopenReportToggle) this.closeReopenReportToggle.updateButton(isClosed);
      this.closeButtons.toggleClass('hidden', isClosed);
      this.reopenButtons.toggleClass('hidden', !isClosed);
    }
  }], [{
    key: 'submitNoteForm',
    value: function submitNoteForm(form) {
      var noteText;
      noteText = form.find("textarea.js-note-text").val();
      if (noteText && noteText.trim().length > 0) {
        return form.submit();
      }
    }
  }, {
    key: 'initMergeRequests',
    value: function initMergeRequests() {
      var $container;
      $container = $('#merge-requests');
      return $.getJSON($container.data('url')).fail(function () {
        return new Flash('Failed to load referenced merge requests');
      }).done(function (data) {
        if ('html' in data) {
          return $container.html(data.html);
        }
      });
    }
  }, {
    key: 'initRelatedBranches',
    value: function initRelatedBranches() {
      var $container;
      $container = $('#related-branches');
      return $.getJSON($container.data('url')).fail(function () {
        return new Flash('Failed to load related branches');
      }).done(function (data) {
        if ('html' in data) {
          return $container.html(data.html);
        }
      });
    }
  }]);

  return Issue;
}();

/* harmony default export */ __webpack_exports__["a"] = (Issue);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./issue_status_select.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, quotes, object-shorthand, no-unused-vars, no-shadow, one-var, one-var-declaration-per-line, comma-dangle, max-len */
(function () {
  this.IssueStatusSelect = function () {
    function IssueStatusSelect() {
      $('.js-issue-status').each(function (i, el) {
        var fieldName;
        fieldName = $(el).data("field-name");
        return $(el).glDropdown({
          selectable: true,
          fieldName: fieldName,
          toggleLabel: function (_this) {
            return function (selected, el, instance) {
              var $item, label;
              label = 'Author';
              $item = instance.dropdown.find('.is-active');
              if ($item.length) {
                label = $item.text();
              }
              return label;
            };
          }(this),
          clicked: function clicked(options) {
            return options.e.preventDefault();
          },
          id: function id(obj, el) {
            return $(el).data("id");
          }
        });
      });
    }

    return IssueStatusSelect;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./label_manager.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable comma-dangle, class-methods-use-this, no-underscore-dangle, no-param-reassign, no-unused-vars, consistent-return, func-names, space-before-function-paren, max-len */
/* global Flash */
/* global Sortable */

(function (global) {
  var LabelManager = function () {
    function LabelManager() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          togglePriorityButton = _ref.togglePriorityButton,
          prioritizedLabels = _ref.prioritizedLabels,
          otherLabels = _ref.otherLabels;

      _classCallCheck(this, LabelManager);

      this.togglePriorityButton = togglePriorityButton || $('.js-toggle-priority');
      this.prioritizedLabels = prioritizedLabels || $('.js-prioritized-labels');
      this.otherLabels = otherLabels || $('.js-other-labels');
      this.errorMessage = 'Unable to update label prioritization at this time';
      this.emptyState = document.querySelector('#js-priority-labels-empty-state');
      this.sortable = Sortable.create(this.prioritizedLabels.get(0), {
        filter: '.empty-message',
        forceFallback: true,
        fallbackClass: 'is-dragging',
        dataIdAttr: 'data-id',
        onUpdate: this.onPrioritySortUpdate.bind(this)
      });
      this.bindEvents();
    }

    _createClass(LabelManager, [{
      key: 'bindEvents',
      value: function bindEvents() {
        this.prioritizedLabels.find('.btn-action').on('mousedown', this, this.onButtonActionClick);
        return this.togglePriorityButton.on('click', this, this.onTogglePriorityClick);
      }
    }, {
      key: 'onTogglePriorityClick',
      value: function onTogglePriorityClick(e) {
        e.preventDefault();
        var _this = e.data;
        var $btn = $(e.currentTarget);
        var $label = $('#' + $btn.data('domId'));
        var action = $btn.parents('.js-prioritized-labels').length ? 'remove' : 'add';
        var $tooltip = $('#' + $btn.find('.has-tooltip:visible').attr('aria-describedby'));
        $tooltip.tooltip('destroy');
        _this.toggleLabelPriority($label, action);
        _this.toggleEmptyState($label, $btn, action);
      }
    }, {
      key: 'onButtonActionClick',
      value: function onButtonActionClick(e) {
        e.stopPropagation();
        $(e.currentTarget).tooltip('hide');
      }
    }, {
      key: 'toggleEmptyState',
      value: function toggleEmptyState($label, $btn, action) {
        this.emptyState.classList.toggle('hidden', !!this.prioritizedLabels[0].querySelector(':scope > li'));
      }
    }, {
      key: 'toggleLabelPriority',
      value: function toggleLabelPriority($label, action, persistState) {
        if (persistState == null) {
          persistState = true;
        }
        var xhr = void 0;
        var _this = this;
        var url = $label.find('.js-toggle-priority').data('url');
        var $target = this.prioritizedLabels;
        var $from = this.otherLabels;
        if (action === 'remove') {
          $target = this.otherLabels;
          $from = this.prioritizedLabels;
        }
        $label.detach().appendTo($target);
        if ($from.find('li').length) {
          $from.find('.empty-message').removeClass('hidden');
        }
        if ($target.find('> li:not(.empty-message)').length) {
          $target.find('.empty-message').addClass('hidden');
        }
        // Return if we are not persisting state
        if (!persistState) {
          return;
        }
        if (action === 'remove') {
          xhr = $.ajax({
            url: url,
            type: 'DELETE'
          });
          // Restore empty message
          if (!$from.find('li').length) {
            $from.find('.empty-message').removeClass('hidden');
          }
        } else {
          xhr = this.savePrioritySort($label, action);
        }
        return xhr.fail(this.rollbackLabelPosition.bind(this, $label, action));
      }
    }, {
      key: 'onPrioritySortUpdate',
      value: function onPrioritySortUpdate() {
        var xhr = this.savePrioritySort();
        return xhr.fail(function () {
          return new Flash(this.errorMessage, 'alert');
        });
      }
    }, {
      key: 'savePrioritySort',
      value: function savePrioritySort() {
        return $.post({
          url: this.prioritizedLabels.data('url'),
          data: {
            label_ids: this.getSortedLabelsIds()
          }
        });
      }
    }, {
      key: 'rollbackLabelPosition',
      value: function rollbackLabelPosition($label, originalAction) {
        var action = originalAction === 'remove' ? 'add' : 'remove';
        this.toggleLabelPriority($label, action, false);
        return new Flash(this.errorMessage, 'alert');
      }
    }, {
      key: 'getSortedLabelsIds',
      value: function getSortedLabelsIds() {
        var sortedIds = [];
        this.prioritizedLabels.find('> li').each(function () {
          var id = $(this).data('id');

          if (id) {
            sortedIds.push(id);
          }
        });
        return sortedIds;
      }
    }]);

    return LabelManager;
  }();

  gl.LabelManager = LabelManager;
})(window.gl || (window.gl = {}));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./labels.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, vars-on-top, no-unused-vars, max-len */
(function () {
  this.Labels = function () {
    function Labels() {
      this.setSuggestedColor = this.setSuggestedColor.bind(this);
      this.updateColorPreview = this.updateColorPreview.bind(this);
      var form;
      form = $('.label-form');
      this.cleanBinding();
      this.addBinding();
      this.updateColorPreview();
    }

    Labels.prototype.addBinding = function () {
      $(document).on('click', '.suggest-colors a', this.setSuggestedColor);
      return $(document).on('input', 'input#label_color', this.updateColorPreview);
    };

    Labels.prototype.cleanBinding = function () {
      $(document).off('click', '.suggest-colors a');
      return $(document).off('input', 'input#label_color');
    };

    Labels.prototype.updateColorPreview = function () {
      var previewColor;
      previewColor = $('input#label_color').val();
      return $('div.label-color-preview').css('background-color', previewColor);
      // Updates the the preview color with the hex-color input
    };

    // Updates the preview color with a click on a suggested color
    Labels.prototype.setSuggestedColor = function (e) {
      var color;
      color = $(e.currentTarget).data('color');
      $('input#label_color').val(color);
      this.updateColorPreview();
      // Notify the form, that color has changed
      $('.label-form').trigger('keyup');
      return e.preventDefault();
    };

    return Labels;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./labels_select.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__issuable_bulk_update_actions__ = __webpack_require__("./issuable_bulk_update_actions.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filtered_search_dropdown_utils__ = __webpack_require__("./filtered_search/dropdown_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__create_label__ = __webpack_require__("./create_label.js");
/* eslint-disable no-useless-return, func-names, space-before-function-paren, wrap-iife, no-var, no-underscore-dangle, prefer-arrow-callback, max-len, one-var, no-unused-vars, one-var-declaration-per-line, prefer-template, no-new, consistent-return, object-shorthand, comma-dangle, no-shadow, no-param-reassign, brace-style, vars-on-top, quotes, no-lonely-if, no-else-return, dot-notation, no-empty, no-return-assign, camelcase, prefer-spread */
/* global Issuable */
/* global ListLabel */





(function () {
  this.LabelsSelect = function () {
    function LabelsSelect(els) {
      var _this, $els;
      _this = this;

      $els = $(els);

      if (!els) {
        $els = $('.js-label-select');
      }

      $els.each(function (i, dropdown) {
        var $block, $colorPreview, $dropdown, $form, $loading, $selectbox, $sidebarCollapsedValue, $value, abilityName, defaultLabel, enableLabelCreateButton, issueURLSplit, issueUpdateURL, labelHTMLTemplate, labelNoneHTMLTemplate, labelUrl, namespacePath, projectPath, saveLabelData, selectedLabel, showAny, showNo, $sidebarLabelTooltip, initialSelected, $toggleText, fieldName, useId, propertyName, showMenuAbove, $container, $dropdownContainer;
        $dropdown = $(dropdown);
        $dropdownContainer = $dropdown.closest('.labels-filter');
        $toggleText = $dropdown.find('.dropdown-toggle-text');
        namespacePath = $dropdown.data('namespace-path');
        projectPath = $dropdown.data('project-path');
        labelUrl = $dropdown.data('labels');
        issueUpdateURL = $dropdown.data('issueUpdate');
        selectedLabel = $dropdown.data('selected');
        if (selectedLabel != null && !$dropdown.hasClass('js-multiselect')) {
          selectedLabel = selectedLabel.split(',');
        }
        showNo = $dropdown.data('show-no');
        showAny = $dropdown.data('show-any');
        showMenuAbove = $dropdown.data('showMenuAbove');
        defaultLabel = $dropdown.data('default-label');
        abilityName = $dropdown.data('ability-name');
        $selectbox = $dropdown.closest('.selectbox');
        $block = $selectbox.closest('.block');
        $form = $dropdown.closest('form, .js-issuable-update');
        $sidebarCollapsedValue = $block.find('.sidebar-collapsed-icon span');
        $sidebarLabelTooltip = $block.find('.js-sidebar-labels-tooltip');
        $value = $block.find('.value');
        $loading = $block.find('.block-loading').fadeOut();
        fieldName = $dropdown.data('field-name');
        useId = $dropdown.is('.js-issuable-form-dropdown, .js-filter-bulk-update, .js-label-sidebar-dropdown');
        propertyName = useId ? 'id' : 'title';
        initialSelected = $selectbox.find('input[name="' + $dropdown.data('field-name') + '"]').map(function () {
          return this.value;
        }).get();
        if (issueUpdateURL != null) {
          issueURLSplit = issueUpdateURL.split('/');
        }
        if (issueUpdateURL) {
          labelHTMLTemplate = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.template('<% _.each(labels, function(label){ %> <a href="<%- ["",issueURLSplit[1], issueURLSplit[2],""].join("/") %>issues?label_name[]=<%- encodeURIComponent(label.title) %>"> <span class="label has-tooltip color-label" title="<%- label.description %>" style="background-color: <%- label.color %>; color: <%- label.text_color %>;"> <%- label.title %> </span> </a> <% }); %>');
          labelNoneHTMLTemplate = '<span class="no-value">None</span>';
        }

        $sidebarLabelTooltip.tooltip();

        if ($dropdown.closest('.dropdown').find('.dropdown-new-label').length) {
          new __WEBPACK_IMPORTED_MODULE_3__create_label__["a" /* default */]($dropdown.closest('.dropdown').find('.dropdown-new-label'), namespacePath, projectPath);
        }

        saveLabelData = function saveLabelData() {
          var data, selected;
          selected = $dropdown.closest('.selectbox').find("input[name='" + fieldName + "']").map(function () {
            return this.value;
          }).get();

          if (__WEBPACK_IMPORTED_MODULE_0_underscore___default.a.isEqual(initialSelected, selected)) return;
          initialSelected = selected;

          data = {};
          data[abilityName] = {};
          data[abilityName].label_ids = selected;
          if (!selected.length) {
            data[abilityName].label_ids = [''];
          }
          $loading.removeClass('hidden').fadeIn();
          $dropdown.trigger('loading.gl.dropdown');
          return $.ajax({
            type: 'PUT',
            url: issueUpdateURL,
            dataType: 'JSON',
            data: data
          }).done(function (data) {
            var labelCount, template, labelTooltipTitle, labelTitles;
            $loading.fadeOut();
            $dropdown.trigger('loaded.gl.dropdown');
            $selectbox.hide();
            data.issueURLSplit = issueURLSplit;
            labelCount = 0;
            if (data.labels.length) {
              template = labelHTMLTemplate(data);
              labelCount = data.labels.length;
            } else {
              template = labelNoneHTMLTemplate;
            }
            $value.removeAttr('style').html(template);
            $sidebarCollapsedValue.text(labelCount);

            if (data.labels.length) {
              labelTitles = data.labels.map(function (label) {
                return label.title;
              });

              if (labelTitles.length > 5) {
                labelTitles = labelTitles.slice(0, 5);
                labelTitles.push('and ' + (data.labels.length - 5) + ' more');
              }

              labelTooltipTitle = labelTitles.join(', ');
            } else {
              labelTooltipTitle = '';
              $sidebarLabelTooltip.tooltip('destroy');
            }

            $sidebarLabelTooltip.attr('title', labelTooltipTitle).tooltip('fixTitle');

            $('.has-tooltip', $value).tooltip({
              container: 'body'
            });
          });
        };
        $dropdown.glDropdown({
          showMenuAbove: showMenuAbove,
          data: function data(term, callback) {
            return $.ajax({
              url: labelUrl
            }).done(function (data) {
              data = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.chain(data).groupBy(function (label) {
                return label.title;
              }).map(function (label) {
                var color;
                color = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.map(label, function (dup) {
                  return dup.color;
                });
                return {
                  id: label[0].id,
                  title: label[0].title,
                  color: color,
                  duplicate: color.length > 1
                };
              }).value();
              if ($dropdown.hasClass('js-extra-options')) {
                var extraData = [];
                if (showNo) {
                  extraData.unshift({
                    id: 0,
                    title: 'No Label'
                  });
                }
                if (showAny) {
                  extraData.unshift({
                    isAny: true,
                    title: 'Any Label'
                  });
                }
                if (extraData.length) {
                  extraData.push('divider');
                  data = extraData.concat(data);
                }
              }

              callback(data);
              if (showMenuAbove) {
                $dropdown.data('glDropdown').positionMenuAbove();
              }
            });
          },
          renderRow: function renderRow(label, instance) {
            var $a, $li, color, colorEl, indeterminate, removesAll, selectedClass, spacing, i, marked, dropdownName, dropdownValue;
            $li = $('<li>');
            $a = $('<a href="#">');
            selectedClass = [];
            removesAll = label.id <= 0 || label.id == null;
            if ($dropdown.hasClass('js-filter-bulk-update')) {
              indeterminate = $dropdown.data('indeterminate') || [];
              marked = $dropdown.data('marked') || [];

              if (indeterminate.indexOf(label.id) !== -1) {
                selectedClass.push('is-indeterminate');
              }

              if (marked.indexOf(label.id) !== -1) {
                // Remove is-indeterminate class if the item will be marked as active
                i = selectedClass.indexOf('is-indeterminate');
                if (i !== -1) {
                  selectedClass.splice(i, 1);
                }
                selectedClass.push('is-active');
              }
            } else {
              if (this.id(label)) {
                dropdownName = $dropdown.data('fieldName');
                dropdownValue = this.id(label).toString().replace(/'/g, '\\\'');

                if ($form.find("input[type='hidden'][name='" + dropdownName + "'][value='" + dropdownValue + "']").length) {
                  selectedClass.push('is-active');
                }
              }

              if ($dropdown.hasClass('js-multiselect') && removesAll) {
                selectedClass.push('dropdown-clear-active');
              }
            }
            if (label.duplicate) {
              color = gl.DropdownUtils.duplicateLabelColor(label.color);
            } else {
              if (label.color != null) {
                color = label.color[0];
              }
            }
            if (color) {
              colorEl = "<span class='dropdown-label-box' style='background: " + color + "'></span>";
            } else {
              colorEl = '';
            }
            // We need to identify which items are actually labels
            if (label.id) {
              selectedClass.push('label-item');
              $a.attr('data-label-id', label.id);
            }
            $a.addClass(selectedClass.join(' ')).html(colorEl + " " + label.title);
            // Return generated html
            return $li.html($a).prop('outerHTML');
          },
          search: {
            fields: ['title']
          },
          selectable: true,
          filterable: true,
          selected: $dropdown.data('selected') || [],
          toggleLabel: function toggleLabel(selected, el) {
            var isSelected = el !== null ? el.hasClass('is-active') : false;
            var title = selected.title;
            var selectedLabels = this.selected;

            if (selected.id === 0) {
              this.selected = [];
              return 'No Label';
            } else if (isSelected) {
              this.selected.push(title);
            } else {
              var index = this.selected.indexOf(title);
              this.selected.splice(index, 1);
            }

            if (selectedLabels.length === 1) {
              return selectedLabels;
            } else if (selectedLabels.length) {
              return selectedLabels[0] + " +" + (selectedLabels.length - 1) + " more";
            } else {
              return defaultLabel;
            }
          },
          fieldName: $dropdown.data('field-name'),
          id: function id(label) {
            if (label.id <= 0) return label.title;

            if ($dropdown.hasClass('js-issuable-form-dropdown')) {
              return label.id;
            }

            if ($dropdown.hasClass("js-filter-submit") && label.isAny == null) {
              return label.title;
            } else {
              return label.id;
            }
          },
          hidden: function hidden() {
            var isIssueIndex, isMRIndex, page, selectedLabels;
            page = $('body').data('page');
            isIssueIndex = page === 'projects:issues:index';
            isMRIndex = page === 'projects:merge_requests:index';
            $selectbox.hide();
            // display:block overrides the hide-collapse rule
            $value.removeAttr('style');

            if ($dropdown.hasClass('js-issuable-form-dropdown')) {
              return;
            }

            if ($('html').hasClass('issue-boards-page')) {
              return;
            }
            if ($dropdown.hasClass('js-multiselect')) {
              if ($dropdown.hasClass('js-filter-submit') && (isIssueIndex || isMRIndex)) {
                selectedLabels = $dropdown.closest('form').find("input:hidden[name='" + $dropdown.data('fieldName') + "']");
                Issuable.filterResults($dropdown.closest('form'));
              } else if ($dropdown.hasClass('js-filter-submit')) {
                $dropdown.closest('form').submit();
              } else {
                if (!$dropdown.hasClass('js-filter-bulk-update')) {
                  saveLabelData();
                }
              }
            }
          },
          multiSelect: $dropdown.hasClass('js-multiselect'),
          vue: $dropdown.hasClass('js-issue-board-sidebar'),
          clicked: function clicked(options) {
            var $el = options.$el,
                e = options.e,
                isMarking = options.isMarking;

            var label = options.selectedObj;

            var isIssueIndex, isMRIndex, page, boardsModel;
            var fadeOutLoader = function fadeOutLoader() {
              $loading.fadeOut();
            };

            page = $('body').data('page');
            isIssueIndex = page === 'projects:issues:index';
            isMRIndex = page === 'projects:merge_requests:index';

            if ($dropdown.parent().find('.is-active:not(.dropdown-clear-active)').length) {
              $dropdown.parent().find('.dropdown-clear-active').removeClass('is-active');
            }

            if ($dropdown.hasClass('js-issuable-form-dropdown')) {
              return;
            }

            if ($dropdown.hasClass('js-filter-bulk-update')) {
              _this.enableBulkLabelDropdown();
              _this.setDropdownData($dropdown, isMarking, label.id);
              return;
            }

            if ($dropdown.closest('.add-issues-modal').length) {
              boardsModel = gl.issueBoards.ModalStore.store.filter;
            }

            if (boardsModel) {
              if (label.isAny) {
                boardsModel['label_name'] = [];
              } else if ($el.hasClass('is-active')) {
                boardsModel['label_name'].push(label.title);
              }

              e.preventDefault();
              return;
            } else if ($dropdown.hasClass('js-filter-submit') && (isIssueIndex || isMRIndex)) {
              if (!$dropdown.hasClass('js-multiselect')) {
                selectedLabel = label.title;
                return Issuable.filterResults($dropdown.closest('form'));
              }
            } else if ($dropdown.hasClass('js-filter-submit')) {
              return $dropdown.closest('form').submit();
            } else if ($dropdown.hasClass('js-issue-board-sidebar')) {
              if ($el.hasClass('is-active')) {
                gl.issueBoards.BoardsStore.detail.issue.labels.push(new ListLabel({
                  id: label.id,
                  title: label.title,
                  color: label.color[0],
                  textColor: '#fff'
                }));
              } else {
                var labels = gl.issueBoards.BoardsStore.detail.issue.labels;
                labels = labels.filter(function (selectedLabel) {
                  return selectedLabel.id !== label.id;
                });
                gl.issueBoards.BoardsStore.detail.issue.labels = labels;
              }

              $loading.fadeIn();

              gl.issueBoards.BoardsStore.detail.issue.update($dropdown.attr('data-issue-update')).then(fadeOutLoader).catch(fadeOutLoader);
            } else {
              if ($dropdown.hasClass('js-multiselect')) {} else {
                return saveLabelData();
              }
            }
          }
        });

        // Set dropdown data
        _this.setOriginalDropdownData($dropdownContainer, $dropdown);
      });
      this.bindEvents();
    }

    LabelsSelect.prototype.bindEvents = function () {
      return $('body').on('change', '.selected_issue', this.onSelectCheckboxIssue);
    };

    LabelsSelect.prototype.onSelectCheckboxIssue = function () {
      if ($('.selected_issue:checked').length) {
        return;
      }
      return $('.issues-bulk-update .labels-filter .dropdown-toggle-text').text('Label');
    };

    LabelsSelect.prototype.enableBulkLabelDropdown = function () {
      __WEBPACK_IMPORTED_MODULE_1__issuable_bulk_update_actions__["a" /* default */].willUpdateLabels = true;
    };

    LabelsSelect.prototype.setDropdownData = function ($dropdown, isMarking, value) {
      var i, markedIds, unmarkedIds, indeterminateIds;

      markedIds = $dropdown.data('marked') || [];
      unmarkedIds = $dropdown.data('unmarked') || [];
      indeterminateIds = $dropdown.data('indeterminate') || [];

      if (isMarking) {
        markedIds.push(value);

        i = indeterminateIds.indexOf(value);
        if (i > -1) {
          indeterminateIds.splice(i, 1);
        }

        i = unmarkedIds.indexOf(value);
        if (i > -1) {
          unmarkedIds.splice(i, 1);
        }
      } else {
        // If marked item (not common) is unmarked
        i = markedIds.indexOf(value);
        if (i > -1) {
          markedIds.splice(i, 1);
        }

        // If an indeterminate item is being unmarked
        if (__WEBPACK_IMPORTED_MODULE_1__issuable_bulk_update_actions__["a" /* default */].getOriginalIndeterminateIds().indexOf(value) > -1) {
          unmarkedIds.push(value);
        }

        // If a marked item is being unmarked
        // (a marked item could also be a label that is present in all selection)
        if (__WEBPACK_IMPORTED_MODULE_1__issuable_bulk_update_actions__["a" /* default */].getOriginalCommonIds().indexOf(value) > -1) {
          unmarkedIds.push(value);
        }
      }

      $dropdown.data('marked', markedIds);
      $dropdown.data('unmarked', unmarkedIds);
      $dropdown.data('indeterminate', indeterminateIds);
    };

    LabelsSelect.prototype.setOriginalDropdownData = function ($container, $dropdown) {
      var labels = [];
      $container.find('[name="label_name[]"]').map(function () {
        return labels.push(this.value);
      });
      $dropdown.data('marked', labels);
    };

    return LabelsSelect;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./landing.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var Landing = function () {
  function Landing(landingElement, dismissButton, cookieName) {
    _classCallCheck(this, Landing);

    this.landingElement = landingElement;
    this.cookieName = cookieName;
    this.dismissButton = dismissButton;
    this.eventWrapper = {};
  }

  _createClass(Landing, [{
    key: 'toggle',
    value: function toggle() {
      var isDismissed = this.isDismissed();

      this.landingElement.classList.toggle('hidden', isDismissed);
      if (!isDismissed) this.addEvents();
    }
  }, {
    key: 'addEvents',
    value: function addEvents() {
      this.eventWrapper.dismissLanding = this.dismissLanding.bind(this);
      this.dismissButton.addEventListener('click', this.eventWrapper.dismissLanding);
    }
  }, {
    key: 'removeEvents',
    value: function removeEvents() {
      this.dismissButton.removeEventListener('click', this.eventWrapper.dismissLanding);
    }
  }, {
    key: 'dismissLanding',
    value: function dismissLanding() {
      this.landingElement.classList.add('hidden');
      __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(this.cookieName, 'true', { expires: 365 });
    }
  }, {
    key: 'isDismissed',
    value: function isDismissed() {
      return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(this.cookieName) === 'true';
    }
  }]);

  return Landing;
}();

/* harmony default export */ __webpack_exports__["a"] = (Landing);

/***/ }),

/***/ "./layout_nav.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__new_sidebar__ = __webpack_require__("./new_sidebar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fly_out_nav__ = __webpack_require__("./fly_out_nav.js");
/* eslint-disable func-names, space-before-function-paren, no-var, prefer-arrow-callback, no-unused-vars, one-var, one-var-declaration-per-line, vars-on-top, max-len */





(function () {
  var hideEndFade;

  hideEndFade = function hideEndFade($scrollingTabs) {
    return $scrollingTabs.each(function () {
      var $this;
      $this = $(this);
      return $this.siblings('.fade-right').toggleClass('scrolling', $this.width() < $this.prop('scrollWidth'));
    });
  };

  $(document).on('init.scrolling-tabs', function () {
    var $scrollingTabs = $('.scrolling-tabs').not('.is-initialized');
    $scrollingTabs.addClass('is-initialized');

    hideEndFade($scrollingTabs);
    $(window).off('resize.nav').on('resize.nav', function () {
      return hideEndFade($scrollingTabs);
    });
    $scrollingTabs.off('scroll').on('scroll', function (event) {
      var $this, currentPosition, maxPosition;
      $this = $(this);
      currentPosition = $this.scrollLeft();
      maxPosition = $this.prop('scrollWidth') - $this.outerWidth();
      $this.siblings('.fade-left').toggleClass('scrolling', currentPosition > 0);
      return $this.siblings('.fade-right').toggleClass('scrolling', currentPosition < maxPosition - 1);
    });

    $scrollingTabs.each(function () {
      var $this = $(this);
      var scrollingTabWidth = $this.width();
      var $active = $this.find('.active');
      var activeWidth = $active.width();

      if ($active.length) {
        var offset = $active.offset().left + activeWidth;

        if (offset > scrollingTabWidth - 30) {
          var scrollLeft = scrollingTabWidth / 2;
          scrollLeft = offset - scrollLeft - activeWidth / 2;
          $this.scrollLeft(scrollLeft);
        }
      }
    });
  });

  $(function () {
    var newNavSidebar = new __WEBPACK_IMPORTED_MODULE_2__new_sidebar__["a" /* default */]();
    newNavSidebar.bindEvents();

    Object(__WEBPACK_IMPORTED_MODULE_3__fly_out_nav__["a" /* default */])();
  });
}).call(window);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./lazy_loader.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return placeholderImage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable one-export, one-var, one-var-declaration-per-line */



var placeholderImage = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
var SCROLL_THRESHOLD = 300;

var LazyLoader = function () {
  function LazyLoader() {
    var _this = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, LazyLoader);

    this.lazyImages = [];
    this.observerNode = options.observerNode || '#content-body';

    var throttledScrollCheck = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.throttle(function () {
      return _this.scrollCheck();
    }, 300);
    var debouncedElementsInView = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.debounce(function () {
      return _this.checkElementsInView();
    }, 300);

    window.addEventListener('scroll', throttledScrollCheck);
    window.addEventListener('resize', debouncedElementsInView);

    var scrollContainer = options.scrollContainer || window;
    scrollContainer.addEventListener('load', function () {
      return _this.loadCheck();
    });
  }

  _createClass(LazyLoader, [{
    key: 'searchLazyImages',
    value: function searchLazyImages() {
      this.lazyImages = [].slice.call(document.querySelectorAll('.lazy'));
      this.checkElementsInView();
    }
  }, {
    key: 'startContentObserver',
    value: function startContentObserver() {
      var _this2 = this;

      var contentNode = document.querySelector(this.observerNode) || document.querySelector('body');

      if (contentNode) {
        var observer = new MutationObserver(function () {
          return _this2.searchLazyImages();
        });

        observer.observe(contentNode, {
          childList: true,
          subtree: true
        });
      }
    }
  }, {
    key: 'loadCheck',
    value: function loadCheck() {
      this.searchLazyImages();
      this.startContentObserver();
    }
  }, {
    key: 'scrollCheck',
    value: function scrollCheck() {
      var _this3 = this;

      requestAnimationFrame(function () {
        return _this3.checkElementsInView();
      });
    }
  }, {
    key: 'checkElementsInView',
    value: function checkElementsInView() {
      var scrollTop = pageYOffset;
      var visHeight = scrollTop + innerHeight + SCROLL_THRESHOLD;
      var imgBoundRect = void 0,
          imgTop = void 0,
          imgBound = void 0;

      // Loading Images which are in the current viewport or close to them
      this.lazyImages = this.lazyImages.filter(function (selectedImage) {
        if (selectedImage.getAttribute('data-src')) {
          imgBoundRect = selectedImage.getBoundingClientRect();

          imgTop = scrollTop + imgBoundRect.top;
          imgBound = imgTop + imgBoundRect.height;

          if (scrollTop < imgBound && visHeight > imgTop) {
            LazyLoader.loadImage(selectedImage);
            return false;
          }

          return true;
        }
        return false;
      });
    }
  }], [{
    key: 'loadImage',
    value: function loadImage(img) {
      if (img.getAttribute('data-src')) {
        img.setAttribute('src', img.getAttribute('data-src'));
        img.removeAttribute('data-src');
        img.classList.remove('lazy');
        img.classList.add('js-lazy-loaded');
      }
    }
  }]);

  return LazyLoader;
}();

/* harmony default export */ __webpack_exports__["a"] = (LazyLoader);

/***/ }),

/***/ "./ldap_groups_select.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("./api.js");
/* eslint-disable space-before-function-paren, prefer-arrow-callback, no-var, one-var, one-var-declaration-per-line, object-shorthand, quotes, comma-dangle, consistent-return, no-unused-vars, padded-blocks, func-names, max-len */


(function () {
  $(function () {
    var groupFormatSelection, ldapGroupResult;
    ldapGroupResult = function ldapGroupResult(group) {
      return group.cn;
    };
    groupFormatSelection = function groupFormatSelection(group) {
      return group.cn;
    };
    $('.ajax-ldap-groups-select').each(function (i, select) {
      return $(select).select2({
        id: function id(group) {
          return group.cn;
        },
        placeholder: "Search for a LDAP group",
        minimumInputLength: 1,
        query: function query(_query) {
          var provider;
          provider = $('#ldap_group_link_provider').val();
          return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].ldap_groups(_query.term, provider, function (groups) {
            var data;
            data = {
              results: groups
            };
            return _query.callback(data);
          });
        },
        initSelection: function initSelection(element, callback) {
          var id;
          id = $(element).val();
          if (id !== "") {
            return callback({
              cn: id
            });
          }
        },
        formatResult: ldapGroupResult,
        formatSelection: groupFormatSelection,
        dropdownCssClass: "ajax-groups-dropdown",
        formatNoMatches: function formatNoMatches(nomatch) {
          return "Match not found; try refining your search query.";
        }
      });
    });
    return $('#ldap_group_link_provider').on('change', function () {
      return $('.ajax-ldap-groups-select').select2('data', null);
    });
  });
}).call(window);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./lib/utils/accessor.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isPropertyAccessSafe(base, property) {
  var safe = void 0;

  try {
    safe = !!base[property];
  } catch (error) {
    safe = false;
  }

  return safe;
}

function isFunctionCallSafe(base, functionName) {
  var safe = true;

  try {
    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }

    base[functionName].apply(base, args);
  } catch (error) {
    safe = false;
  }

  return safe;
}

function isLocalStorageAccessSafe() {
  var safe = void 0;

  var TEST_KEY = 'isLocalStorageAccessSafe';
  var TEST_VALUE = 'true';

  safe = isPropertyAccessSafe(window, 'localStorage');
  if (!safe) return safe;

  safe = isFunctionCallSafe(window.localStorage, 'setItem', TEST_KEY, TEST_VALUE);

  if (safe) window.localStorage.removeItem(TEST_KEY);

  return safe;
}

var AccessorUtilities = {
  isPropertyAccessSafe: isPropertyAccessSafe,
  isFunctionCallSafe: isFunctionCallSafe,
  isLocalStorageAccessSafe: isLocalStorageAccessSafe
};

/* harmony default export */ __webpack_exports__["a"] = (AccessorUtilities);

/***/ }),

/***/ "./lib/utils/ajax_cache.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cache__ = __webpack_require__("./lib/utils/cache.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var AjaxCache = function (_Cache) {
  _inherits(AjaxCache, _Cache);

  function AjaxCache() {
    _classCallCheck(this, AjaxCache);

    var _this = _possibleConstructorReturn(this, (AjaxCache.__proto__ || Object.getPrototypeOf(AjaxCache)).call(this));

    _this.pendingRequests = {};
    return _this;
  }

  _createClass(AjaxCache, [{
    key: 'override',
    value: function override(endpoint, data) {
      this.internalStorage[endpoint] = data;
    }
  }, {
    key: 'retrieve',
    value: function retrieve(endpoint, forceRetrieve) {
      var _this2 = this;

      if (this.hasData(endpoint) && !forceRetrieve) {
        return Promise.resolve(this.get(endpoint));
      }

      var pendingRequest = this.pendingRequests[endpoint];

      if (!pendingRequest) {
        pendingRequest = new Promise(function (resolve, reject) {
          // jQuery 2 is not Promises/A+ compatible (missing catch)
          $.ajax(endpoint) // eslint-disable-line promise/catch-or-return
          .then(function (data) {
            return resolve(data);
          }, function (jqXHR, textStatus, errorThrown) {
            var error = new Error(endpoint + ': ' + errorThrown);
            error.textStatus = textStatus;
            reject(error);
          });
        }).then(function (data) {
          _this2.internalStorage[endpoint] = data;
          delete _this2.pendingRequests[endpoint];
        }).catch(function (error) {
          delete _this2.pendingRequests[endpoint];
          throw error;
        });

        this.pendingRequests[endpoint] = pendingRequest;
      }

      return pendingRequest.then(function () {
        return _this2.get(endpoint);
      });
    }
  }]);

  return AjaxCache;
}(__WEBPACK_IMPORTED_MODULE_0__cache__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new AjaxCache());
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./lib/utils/bootstrap_linked_tabs.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Linked Tabs
 *
 * Handles persisting and restores the current tab selection and content.
 * Reusable component for static content.
 *
 * ### Example Markup
 *
 *  <ul class="nav-links tab-links">
 *    <li class="active">
 *      <a data-action="tab1" data-target="#tab1" data-toggle="tab" href="/path/tab1">
 *        Tab 1
 *      </a>
 *    </li>
 *    <li class="groups-tab">
 *      <a data-action="tab2" data-target="#tab2" data-toggle="tab" href="/path/tab2">
 *        Tab 2
 *      </a>
 *    </li>
 *
 *
 *  <div class="tab-content">
 *    <div class="tab-pane" id="tab1">
 *      Tab 1 Content
 *    </div>
 *    <div class="tab-pane" id="tab2">
 *      Tab 2 Content
 *    </div>
 * </div>
 *
 *
 * ### How to use
 *
 *  new LinkedTabs({
 *    action: "#{controller.action_name}",
 *    defaultAction: 'tab1',
 *    parentEl: '.tab-links'
 *  });
 */

var LinkedTabs = function () {
  /**
   * Binds the events and activates de default tab.
   *
   * @param  {Object} options
   */
  function LinkedTabs() {
    var _this = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, LinkedTabs);

    this.options = options;

    this.defaultAction = this.options.defaultAction;
    this.action = this.options.action || this.defaultAction;

    if (this.action === 'show') {
      this.action = this.defaultAction;
    }

    this.currentLocation = window.location;

    var tabSelector = this.options.parentEl + ' a[data-toggle="tab"]';

    // since this is a custom event we need jQuery :(
    $(document).off('shown.bs.tab', tabSelector).on('shown.bs.tab', tabSelector, function (e) {
      return _this.tabShown(e);
    });

    this.activateTab(this.action);
  }

  /**
   * Handles the `shown.bs.tab` event to set the currect url action.
   *
   * @param  {type} evt
   * @return {Function}
   */


  _createClass(LinkedTabs, [{
    key: 'tabShown',
    value: function tabShown(evt) {
      var source = evt.target.getAttribute('href');

      return this.setCurrentAction(source);
    }

    /**
     * Updates the URL with the path that matched the given action.
     *
     * @param  {String} source
     * @return {String}
     */

  }, {
    key: 'setCurrentAction',
    value: function setCurrentAction(source) {
      var copySource = source;

      copySource.replace(/\/+$/, '');

      var newState = '' + copySource + this.currentLocation.search + this.currentLocation.hash;

      history.replaceState({
        url: newState
      }, document.title, newState);
      return newState;
    }

    /**
     * Given the current action activates the correct tab.
     * http://getbootstrap.com/javascript/#tab-show
     * Note: Will trigger `shown.bs.tab`
     */

  }, {
    key: 'activateTab',
    value: function activateTab() {
      return $(this.options.parentEl + ' a[data-action=\'' + this.action + '\']').tab('show');
    }
  }]);

  return LinkedTabs;
}();

/* harmony default export */ __webpack_exports__["a"] = (LinkedTabs);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./lib/utils/cache.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Cache = function () {
  function Cache() {
    _classCallCheck(this, Cache);

    this.internalStorage = {};
  }

  _createClass(Cache, [{
    key: "get",
    value: function get(key) {
      return this.internalStorage[key];
    }
  }, {
    key: "hasData",
    value: function hasData(key) {
      return Object.prototype.hasOwnProperty.call(this.internalStorage, key);
    }
  }, {
    key: "remove",
    value: function remove(key) {
      delete this.internalStorage[key];
    }
  }]);

  return Cache;
}();

/* harmony default export */ __webpack_exports__["a"] = (Cache);

/***/ }),

/***/ "./lib/utils/common_utils.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getPagePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return isInGroupsPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return isInProjectPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getProjectSlug; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getGroupSlug; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return isInIssuePage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ajaxGet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ajaxPost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return rstrip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return updateTooltipTitle; });
/* unused harmony export disableButtonIfEmptyField */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return handleLocationHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return isInViewport; });
/* unused harmony export parseUrl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return parseUrlPathname; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getUrlParamsArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return isMetaKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return isMetaClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return scrollToElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getParameterByName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getSelectedFragment; });
/* unused harmony export insertText */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return nodeMatchesSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return normalizeHeaders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return normalizeCRLFHeaders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return parseIntPagination; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return setParamInURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return convertPermissionToBoolean; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return backOff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return setFavicon; });
/* unused harmony export resetFavicon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return setCiStatusFavicon; });
/* unused harmony export spriteIcon */
/* unused harmony export imagePath */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var getPagePath = function getPagePath() {
  var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return $('body').data('page').split(':')[index];
};

var isInGroupsPage = function isInGroupsPage() {
  return getPagePath() === 'groups';
};

var isInProjectPage = function isInProjectPage() {
  return getPagePath() === 'projects';
};

var getProjectSlug = function getProjectSlug() {
  if (isInProjectPage()) {
    return $('body').data('project');
  }
  return null;
};

var getGroupSlug = function getGroupSlug() {
  if (isInGroupsPage()) {
    return $('body').data('group');
  }
  return null;
};

var isInIssuePage = function isInIssuePage() {
  var page = getPagePath(1);
  var action = getPagePath(2);

  return page === 'issues' && action === 'show';
};

var ajaxGet = function ajaxGet(url) {
  return $.ajax({
    type: 'GET',
    url: url,
    dataType: 'script'
  });
};

var ajaxPost = function ajaxPost(url, data) {
  return $.ajax({
    type: 'POST',
    url: url,
    data: data
  });
};

var rstrip = function rstrip(val) {
  if (val) {
    return val.replace(/\s+$/, '');
  }
  return val;
};

var updateTooltipTitle = function updateTooltipTitle($tooltipEl, newTitle) {
  return $tooltipEl.attr('title', newTitle).tooltip('fixTitle');
};

var disableButtonIfEmptyField = function disableButtonIfEmptyField(fieldSelector, buttonSelector) {
  var eventName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'input';

  var field = $(fieldSelector);
  var closestSubmit = field.closest('form').find(buttonSelector);
  if (rstrip(field.val()) === '') {
    closestSubmit.disable();
  }
  // eslint-disable-next-line func-names
  return field.on(eventName, function () {
    if (rstrip($(this).val()) === '') {
      return closestSubmit.disable();
    }
    return closestSubmit.enable();
  });
};

// automatically adjust scroll position for hash urls taking the height of the navbar into account
// https://github.com/twitter/bootstrap/issues/1768
var handleLocationHash = function handleLocationHash() {
  var hash = window.gl.utils.getLocationHash();
  if (!hash) return;

  // This is required to handle non-unicode characters in hash
  hash = decodeURIComponent(hash);

  var target = document.getElementById(hash) || document.getElementById('user-content-' + hash);
  var fixedTabs = document.querySelector('.js-tabs-affix');
  var fixedDiffStats = document.querySelector('.js-diff-files-changed.is-stuck');
  var fixedNav = document.querySelector('.navbar-gitlab');

  var adjustment = 0;
  if (fixedNav) adjustment -= fixedNav.offsetHeight;

  if (target && target.scrollIntoView) {
    target.scrollIntoView(true);
  }

  if (fixedTabs) {
    adjustment -= fixedTabs.offsetHeight;
  }

  if (fixedDiffStats) {
    adjustment -= fixedDiffStats.offsetHeight;
  }

  window.scrollBy(0, adjustment);
};

// Check if element scrolled into viewport from above or below
// Courtesy http://stackoverflow.com/a/7557433/414749
var isInViewport = function isInViewport(el) {
  var rect = el.getBoundingClientRect();

  return rect.top >= 0 && rect.left >= 0 && rect.bottom <= window.innerHeight && rect.right <= window.innerWidth;
};

var parseUrl = function parseUrl(url) {
  var parser = document.createElement('a');
  parser.href = url;
  return parser;
};

var parseUrlPathname = function parseUrlPathname(url) {
  var parsedUrl = parseUrl(url);
  // parsedUrl.pathname will return an absolute path for Firefox and a relative path for IE11
  // We have to make sure we always have an absolute path.
  return parsedUrl.pathname.charAt(0) === '/' ? parsedUrl.pathname : '/' + parsedUrl.pathname;
};

// We can trust that each param has one & since values containing & will be encoded
// Remove the first character of search as it is always ?
var getUrlParamsArray = function getUrlParamsArray() {
  return window.location.search.slice(1).split('&').map(function (param) {
    var split = param.split('=');
    return [decodeURI(split[0]), split[1]].join('=');
  });
};

var isMetaKey = function isMetaKey(e) {
  return e.metaKey || e.ctrlKey || e.altKey || e.shiftKey;
};

// Identify following special clicks
// 1) Cmd + Click on Mac (e.metaKey)
// 2) Ctrl + Click on PC (e.ctrlKey)
// 3) Middle-click or Mouse Wheel Click (e.which is 2)
var isMetaClick = function isMetaClick(e) {
  return e.metaKey || e.ctrlKey || e.which === 2;
};

var scrollToElement = function scrollToElement($el) {
  var top = $el.offset().top;
  var mrTabsHeight = $('.merge-request-tabs').height() || 0;
  var headerHeight = $('.navbar-gitlab').height() || 0;

  return $('body, html').animate({
    scrollTop: top - mrTabsHeight - headerHeight
  }, 200);
};

/**
  this will take in the `name` of the param you want to parse in the url
  if the name does not exist this function will return `null`
  otherwise it will return the value of the param key provided
*/
var getParameterByName = function getParameterByName(name, urlToParse) {
  var url = urlToParse || window.location.href;
  var parsedName = name.replace(/[[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + parsedName + '(=([^&#]*)|&|#|$)');
  var results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

var getSelectedFragment = function getSelectedFragment() {
  var selection = window.getSelection();
  if (selection.rangeCount === 0) return null;
  var documentFragment = document.createDocumentFragment();
  for (var i = 0; i < selection.rangeCount; i += 1) {
    documentFragment.appendChild(selection.getRangeAt(i).cloneContents());
  }
  if (documentFragment.textContent.length === 0) return null;

  return documentFragment;
};

// TODO: Update this name, there is a gl.text.insertText function.
var insertText = function insertText(target, text) {
  // Firefox doesn't support `document.execCommand('insertText', false, text)` on textareas
  var selectionStart = target.selectionStart;
  var selectionEnd = target.selectionEnd;
  var value = target.value;

  var textBefore = value.substring(0, selectionStart);
  var textAfter = value.substring(selectionEnd, value.length);

  var insertedText = text instanceof Function ? text(textBefore, textAfter) : text;
  var newText = textBefore + insertedText + textAfter;

  // eslint-disable-next-line no-param-reassign
  target.value = newText;
  // eslint-disable-next-line no-param-reassign
  target.selectionStart = target.selectionEnd = selectionStart + insertedText.length;

  // Trigger autosave
  $(target).trigger('input');

  // Trigger autosize
  var event = document.createEvent('Event');
  event.initEvent('autosize:update', true, false);
  target.dispatchEvent(event);
};

var nodeMatchesSelector = function nodeMatchesSelector(node, selector) {
  var matches = Element.prototype.matches || Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector;

  if (matches) {
    return matches.call(node, selector);
  }

  // IE11 doesn't support `node.matches(selector)`

  var parentNode = node.parentNode;
  if (!parentNode) {
    parentNode = document.createElement('div');
    // eslint-disable-next-line no-param-reassign
    node = node.cloneNode(true);
    parentNode.appendChild(node);
  }

  var matchingNodes = parentNode.querySelectorAll(selector);
  return Array.prototype.indexOf.call(matchingNodes, node) !== -1;
};

/**
  this will take in the headers from an API response and normalize them
  this way we don't run into production issues when nginx gives us lowercased header keys
*/
var normalizeHeaders = function normalizeHeaders(headers) {
  var upperCaseHeaders = {};

  Object.keys(headers).forEach(function (e) {
    upperCaseHeaders[e.toUpperCase()] = headers[e];
  });

  return upperCaseHeaders;
};

/**
  this will take in the getAllResponseHeaders result and normalize them
  this way we don't run into production issues when nginx gives us lowercased header keys
*/
var normalizeCRLFHeaders = function normalizeCRLFHeaders(headers) {
  var headersObject = {};
  var headersArray = headers.split('\n');

  headersArray.forEach(function (header) {
    var keyValue = header.split(': ');
    headersObject[keyValue[0]] = keyValue[1];
  });

  return normalizeHeaders(headersObject);
};

/**
 * Parses pagination object string values into numbers.
 *
 * @param {Object} paginationInformation
 * @returns {Object}
 */
var parseIntPagination = function parseIntPagination(paginationInformation) {
  return {
    perPage: parseInt(paginationInformation['X-PER-PAGE'], 10),
    page: parseInt(paginationInformation['X-PAGE'], 10),
    total: parseInt(paginationInformation['X-TOTAL'], 10),
    totalPages: parseInt(paginationInformation['X-TOTAL-PAGES'], 10),
    nextPage: parseInt(paginationInformation['X-NEXT-PAGE'], 10),
    previousPage: parseInt(paginationInformation['X-PREV-PAGE'], 10)
  };
};

/**
 * Updates the search parameter of a URL given the parameter and value provided.
 *
 * If no search params are present we'll add it.
 * If param for page is already present, we'll update it
 * If there are params but not for the given one, we'll add it at the end.
 * Returns the new search parameters.
 *
 * @param {String} param
 * @param {Number|String|Undefined|Null} value
 * @return {String}
 */
var setParamInURL = function setParamInURL(param, value) {
  var search = void 0;
  var locationSearch = window.location.search;

  if (locationSearch.length) {
    var parameters = locationSearch.substring(1, locationSearch.length).split('&').reduce(function (acc, element) {
      var val = element.split('=');
      // eslint-disable-next-line no-param-reassign
      acc[val[0]] = decodeURIComponent(val[1]);
      return acc;
    }, {});

    parameters[param] = value;

    var _toString = Object.keys(parameters).map(function (val) {
      return val + '=' + encodeURIComponent(parameters[val]);
    }).join('&');

    search = '?' + _toString;
  } else {
    search = '?' + param + '=' + value;
  }

  return search;
};

/**
 * Converts permission provided as strings to booleans.
 *
 * @param  {String} string
 * @returns {Boolean}
 */
var convertPermissionToBoolean = function convertPermissionToBoolean(permission) {
  return permission === 'true';
};

/**
 * Back Off exponential algorithm
 * backOff :: (Function<next, stop>, Number) -> Promise<Any, Error>
 *
 * @param {Function<next, stop>} fn function to be called
 * @param {Number} timeout
 * @return {Promise<Any, Error>}
 * @example
 * ```
 *  backOff(function (next, stop) {
 *    // Let's perform this function repeatedly for 60s or for the timeout provided.
 *
 *    ourFunction()
 *      .then(function (result) {
 *        // continue if result is not what we need
 *        next();
 *
 *        // when result is what we need let's stop with the repetions and jump out of the cycle
 *        stop(result);
 *      })
 *      .catch(function (error) {
 *        // if there is an error, we need to stop this with an error.
 *        stop(error);
 *      })
 *  }, 60000)
 *  .then(function (result) {})
 *  .catch(function (error) {
 *    // deal with errors passed to stop()
 *  })
 * ```
 */
var backOff = function backOff(fn) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 60000;

  var maxInterval = 32000;
  var nextInterval = 2000;
  var timeElapsed = 0;

  return new Promise(function (resolve, reject) {
    var stop = function stop(arg) {
      return arg instanceof Error ? reject(arg) : resolve(arg);
    };

    var next = function next() {
      if (timeElapsed < timeout) {
        setTimeout(function () {
          return fn(next, stop);
        }, nextInterval);
        timeElapsed += nextInterval;
        nextInterval = Math.min(nextInterval + nextInterval, maxInterval);
      } else {
        reject(new Error('BACKOFF_TIMEOUT'));
      }
    };

    fn(next, stop);
  });
};

var setFavicon = function setFavicon(faviconPath) {
  var faviconEl = document.getElementById('favicon');
  if (faviconEl && faviconPath) {
    faviconEl.setAttribute('href', faviconPath);
  }
};

var resetFavicon = function resetFavicon() {
  var faviconEl = document.getElementById('favicon');
  var originalFavicon = faviconEl ? faviconEl.getAttribute('href') : null;
  if (faviconEl) {
    faviconEl.setAttribute('href', originalFavicon);
  }
};

var setCiStatusFavicon = function setCiStatusFavicon(pageUrl) {
  $.ajax({
    url: pageUrl,
    dataType: 'json',
    success: function success(data) {
      if (data && data.favicon) {
        setFavicon(data.favicon);
      } else {
        resetFavicon();
      }
    },
    error: function error() {
      resetFavicon();
    }
  });
};

var spriteIcon = function spriteIcon(icon) {
  return '<svg><use xlink:href="' + gon.sprite_icons + '#' + icon + '" /></svg>';
};

var imagePath = function imagePath(imgUrl) {
  return '' + (gon.asset_host || '') + (gon.relative_url_root || '') + '/assets/' + imgUrl;
};

window.gl = window.gl || {};
window.gl.utils = _extends({}, window.gl.utils || {}, {
  getPagePath: getPagePath,
  isInGroupsPage: isInGroupsPage,
  isInProjectPage: isInProjectPage,
  getProjectSlug: getProjectSlug,
  getGroupSlug: getGroupSlug,
  isInIssuePage: isInIssuePage,
  ajaxGet: ajaxGet,
  ajaxPost: ajaxPost,
  rstrip: rstrip,
  updateTooltipTitle: updateTooltipTitle,
  disableButtonIfEmptyField: disableButtonIfEmptyField,
  handleLocationHash: handleLocationHash,
  isInViewport: isInViewport,
  parseUrl: parseUrl,
  parseUrlPathname: parseUrlPathname,
  getUrlParamsArray: getUrlParamsArray,
  isMetaKey: isMetaKey,
  isMetaClick: isMetaClick,
  scrollToElement: scrollToElement,
  getParameterByName: getParameterByName,
  getSelectedFragment: getSelectedFragment,
  insertText: insertText,
  nodeMatchesSelector: nodeMatchesSelector,
  spriteIcon: spriteIcon,
  imagePath: imagePath
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./lib/utils/constants.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BYTES_IN_KIB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HIDDEN_CLASS; });
/* eslint-disable import/prefer-default-export */
var BYTES_IN_KIB = 1024;
var HIDDEN_CLASS = 'hidden';

/***/ }),

/***/ "./lib/utils/csrf.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
This module provides easy access to the CSRF token and caches
it for re-use. It also exposes some values commonly used in relation
to the CSRF token (header key and headers object).

If you need to refresh the csrfToken for some reason, just call `init` and
then use the accessors as you would normally.

If you need to compose a headers object, use the spread operator:

```
  headers: {
    ...csrf.headers,
    someOtherHeader: '12345',
  }
```

see also http://guides.rubyonrails.org/security.html#cross-site-request-forgery-csrf
and https://github.com/rails/jquery-rails/blob/v4.3.1/vendor/assets/javascripts/jquery_ujs.js#L59-L62
 */

var csrf = {
  init: function init() {
    var tokenEl = document.querySelector('meta[name=csrf-token]');

    if (tokenEl !== null) {
      this.csrfToken = tokenEl.getAttribute('content');
    } else {
      this.csrfToken = null;
    }
  },


  get token() {
    return this.csrfToken;
  },

  get headerKey() {
    return 'X-CSRF-Token';
  },

  get headers() {
    if (this.csrfToken !== null) {
      return _defineProperty({}, this.headerKey, this.token);
    }
    return {};
  }
};

csrf.init();

// use our cached token for any $.rails-generated AJAX requests
if ($.rails) {
  $.rails.csrfToken = function () {
    return csrf.token;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (csrf);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./lib/utils/datefix.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var DateFix = {
  dashedFix: function dashedFix(val) {
    var _val$split = val.split('-'),
        _val$split2 = _slicedToArray(_val$split, 3),
        y = _val$split2[0],
        m = _val$split2[1],
        d = _val$split2[2];

    return new Date(y, m - 1, d);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (DateFix);

/***/ }),

/***/ "./lib/utils/datetime_utility.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (immutable) */ __webpack_exports__["a"] = timeIntervalInWords;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_timeago_js__ = __webpack_require__("../../../node_modules/timeago.js/dist/timeago.min.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_timeago_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_timeago_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vendor_date_format__ = __webpack_require__("../../../vendor/assets/javascripts/date.format.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vendor_date_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vendor_date_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__locale__ = __webpack_require__("./locale/index.js");
/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, no-param-reassign, no-cond-assign, comma-dangle, no-unused-expressions, prefer-template, max-len */






window.timeago = __WEBPACK_IMPORTED_MODULE_0_timeago_js___default.a;
window.dateFormat = __WEBPACK_IMPORTED_MODULE_1_vendor_date_format___default.a;

(function () {
  (function (w) {
    var base;
    var timeagoInstance;

    if (w.gl == null) {
      w.gl = {};
    }
    if ((base = w.gl).utils == null) {
      base.utils = {};
    }
    w.gl.utils.days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    w.gl.utils.formatDate = function (datetime) {
      return __WEBPACK_IMPORTED_MODULE_1_vendor_date_format___default()(datetime, 'mmm d, yyyy h:MMtt Z');
    };

    w.gl.utils.getDayName = function (date) {
      return this.days[date.getDay()];
    };

    w.gl.utils.localTimeAgo = function ($timeagoEls) {
      var setTimeago = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      $timeagoEls.each(function (i, el) {
        el.setAttribute('title', el.getAttribute('title'));

        if (setTimeago) {
          // Recreate with custom template
          $(el).tooltip({
            template: '<div class="tooltip local-timeago" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
          });
        }

        el.classList.add('js-timeago-render');
      });

      gl.utils.renderTimeago($timeagoEls);
    };

    w.gl.utils.getTimeago = function () {
      var locale;

      if (!timeagoInstance) {
        var localeRemaining = function localeRemaining(number, index) {
          return [[Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|less than a minute ago'), Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|in a while')], [Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|less than a minute ago'), Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|%s seconds remaining')], [Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|about a minute ago'), Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|1 minute remaining')], [Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|%s minutes ago'), Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|%s minutes remaining')], [Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|about an hour ago'), Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|1 hour remaining')], [Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|about %s hours ago'), Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|%s hours remaining')], [Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|a day ago'), Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|1 day remaining')], [Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|%s days ago'), Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|%s days remaining')], [Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|a week ago'), Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|1 week remaining')], [Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|%s weeks ago'), Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|%s weeks remaining')], [Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|a month ago'), Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|1 month remaining')], [Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|%s months ago'), Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|%s months remaining')], [Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|a year ago'), Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|1 year remaining')], [Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|%s years ago'), Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|%s years remaining')]][index];
        };
        locale = function locale(number, index) {
          return [[Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|less than a minute ago'), Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|in a while')], [Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|less than a minute ago'), Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|in %s seconds')], [Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|about a minute ago'), Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|in 1 minute')], [Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|%s minutes ago'), Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|in %s minutes')], [Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|about an hour ago'), Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|in 1 hour')], [Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|about %s hours ago'), Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|in %s hours')], [Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|a day ago'), Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|in 1 day')], [Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|%s days ago'), Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|in %s days')], [Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|a week ago'), Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|in 1 week')], [Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|%s weeks ago'), Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|in %s weeks')], [Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|a month ago'), Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|in 1 month')], [Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|%s months ago'), Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|in %s months')], [Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|a year ago'), Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|in 1 year')], [Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|%s years ago'), Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|in %s years')]][index];
        };

        __WEBPACK_IMPORTED_MODULE_0_timeago_js___default.a.register(__WEBPACK_IMPORTED_MODULE_2__locale__["lang"], locale);
        __WEBPACK_IMPORTED_MODULE_0_timeago_js___default.a.register(__WEBPACK_IMPORTED_MODULE_2__locale__["lang"] + '-remaining', localeRemaining);
        timeagoInstance = __WEBPACK_IMPORTED_MODULE_0_timeago_js___default()();
      }

      return timeagoInstance;
    };

    w.gl.utils.timeFor = function (time, suffix, expiredLabel) {
      var timefor;
      if (!time) {
        return '';
      }
      if (new Date(time) < new Date()) {
        expiredLabel || (expiredLabel = Object(__WEBPACK_IMPORTED_MODULE_2__locale__["s__"])('Timeago|Past due'));
        timefor = expiredLabel;
      } else {
        timefor = gl.utils.getTimeago().format(time, __WEBPACK_IMPORTED_MODULE_2__locale__["lang"] + '-remaining').trim();
      }
      return timefor;
    };

    w.gl.utils.renderTimeago = function ($els) {
      var timeagoEls = $els || document.querySelectorAll('.js-timeago-render');

      // timeago.js sets timeouts internally for each timeago value to be updated in real time
      gl.utils.getTimeago().render(timeagoEls, __WEBPACK_IMPORTED_MODULE_2__locale__["lang"]);
    };

    w.gl.utils.getDayDifference = function (a, b) {
      var millisecondsPerDay = 1000 * 60 * 60 * 24;
      var date1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
      var date2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

      return Math.floor((date2 - date1) / millisecondsPerDay);
    };
  })(window);
}).call(window);

/**
 * Port of ruby helper time_interval_in_words.
 *
 * @param  {Number} seconds
 * @return {String}
 */
// eslint-disable-next-line import/prefer-default-export
function timeIntervalInWords(intervalInSeconds) {
  var secondsInteger = parseInt(intervalInSeconds, 10);
  var minutes = Math.floor(secondsInteger / 60);
  var seconds = secondsInteger - minutes * 60;
  var text = '';

  if (minutes >= 1) {
    text = minutes + ' ' + gl.text.pluralize('minute', minutes) + ' ' + seconds + ' ' + gl.text.pluralize('second', seconds);
  } else {
    text = seconds + ' ' + gl.text.pluralize('second', seconds);
  }
  return text;
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./lib/utils/image_utility.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isImageLoaded;
/* eslint-disable import/prefer-default-export */

function isImageLoaded(element) {
  return element.complete && element.naturalHeight !== 0;
}

/***/ }),

/***/ "./lib/utils/number_utils.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = formatRelevantDigits;
/* harmony export (immutable) */ __webpack_exports__["a"] = bytesToKiB;
/* harmony export (immutable) */ __webpack_exports__["b"] = bytesToMiB;
/* unused harmony export bytesToGiB */
/* harmony export (immutable) */ __webpack_exports__["d"] = numberToHumanSize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("./lib/utils/constants.js");


/**
 * Function that allows a number with an X amount of decimals
 * to be formatted in the following fashion:
 * * For 1 digit to the left of the decimal point and X digits to the right of it
 * * * Show 3 digits to the right
 * * For 2 digits to the left of the decimal point and X digits to the right of it
 * * * Show 2 digits to the right
*/
function formatRelevantDigits(number) {
  var digitsLeft = '';
  var relevantDigits = 0;
  var formattedNumber = '';
  if (!isNaN(Number(number))) {
    digitsLeft = number.toString().split('.')[0];
    switch (digitsLeft.length) {
      case 1:
        relevantDigits = 3;
        break;
      case 2:
        relevantDigits = 2;
        break;
      case 3:
        relevantDigits = 1;
        break;
      default:
        relevantDigits = 4;
        break;
    }
    formattedNumber = Number(number).toFixed(relevantDigits);
  }
  return formattedNumber;
}

/**
 * Utility function that calculates KiB of the given bytes.
 *
 * @param  {Number} number bytes
 * @return {Number}        KiB
 */
function bytesToKiB(number) {
  return number / __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */];
}

/**
 * Utility function that calculates MiB of the given bytes.
 *
 * @param  {Number} number bytes
 * @return {Number}        MiB
 */
function bytesToMiB(number) {
  return number / (__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */] * __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */]);
}

/**
 * Utility function that calculates GiB of the given bytes.
 * @param {Number} number
 * @returns {Number}
 */
function bytesToGiB(number) {
  return number / (__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */] * __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */] * __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */]);
}

/**
 * Port of rails number_to_human_size
 * Formats the bytes in number into a more understandable
 * representation (e.g., giving it 1500 yields 1.5 KB).
 *
 * @param {Number} size
 * @returns {String}
 */
function numberToHumanSize(size) {
  if (size < __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */]) {
    return size + ' bytes';
  } else if (size < __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */] * __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */]) {
    return bytesToKiB(size).toFixed(2) + ' KiB';
  } else if (size < __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */] * __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */] * __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */]) {
    return bytesToMiB(size).toFixed(2) + ' MiB';
  }
  return bytesToGiB(size).toFixed(2) + ' GiB';
}

/***/ }),

/***/ "./lib/utils/pretty_time.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = parseSeconds;
/* harmony export (immutable) */ __webpack_exports__["c"] = stringifyTime;
/* harmony export (immutable) */ __webpack_exports__["a"] = abbreviateTime;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);


/*
 * TODO: Make these methods more configurable (e.g. stringifyTime condensed or
 * non-condensed, abbreviateTimelengths)
 * */

/*
 * Accepts seconds and returns a timeObject { weeks: #, days: #, hours: #, minutes: # }
 * Seconds can be negative or positive, zero or non-zero. Can be configured for any day
 * or week length.
*/

function parseSeconds(seconds) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$daysPerWeek = _ref.daysPerWeek,
      daysPerWeek = _ref$daysPerWeek === undefined ? 5 : _ref$daysPerWeek,
      _ref$hoursPerDay = _ref.hoursPerDay,
      hoursPerDay = _ref$hoursPerDay === undefined ? 8 : _ref$hoursPerDay;

  var DAYS_PER_WEEK = daysPerWeek;
  var HOURS_PER_DAY = hoursPerDay;
  var MINUTES_PER_HOUR = 60;
  var MINUTES_PER_WEEK = DAYS_PER_WEEK * HOURS_PER_DAY * MINUTES_PER_HOUR;
  var MINUTES_PER_DAY = HOURS_PER_DAY * MINUTES_PER_HOUR;

  var timePeriodConstraints = {
    weeks: MINUTES_PER_WEEK,
    days: MINUTES_PER_DAY,
    hours: MINUTES_PER_HOUR,
    minutes: 1
  };

  var unorderedMinutes = Math.abs(seconds / MINUTES_PER_HOUR);

  return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.mapObject(timePeriodConstraints, function (minutesPerPeriod) {
    var periodCount = Math.floor(unorderedMinutes / minutesPerPeriod);

    unorderedMinutes -= periodCount * minutesPerPeriod;

    return periodCount;
  });
}

/*
* Accepts a timeObject (see parseSeconds) and returns a condensed string representation of it
* (e.g. '1w 2d 3h 1m' or '1h 30m'). Zero value units are not included.
*/

function stringifyTime(timeObject) {
  var reducedTime = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.reduce(timeObject, function (memo, unitValue, unitName) {
    var isNonZero = !!unitValue;
    return isNonZero ? memo + ' ' + unitValue + unitName.charAt(0) : memo;
  }, '').trim();
  return reducedTime.length ? reducedTime : '0m';
}

/*
* Accepts a time string of any size (e.g. '1w 2d 3h 5m' or '1w 2d') and returns
*  the first non-zero unit/value pair.
*/

function abbreviateTime(timeStr) {
  return timeStr.split(' ').filter(function (unitStr) {
    return unitStr.charAt(0) !== '0';
  })[0];
}

/***/ }),

/***/ "./lib/utils/regexp.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Regexp utility for the convenience of working with regular expressions.
 *
 */

// Inspired by https://github.com/mishoo/UglifyJS/blob/2bc1d02363db3798d5df41fb5059a19edca9b7eb/lib/parse-js.js#L203
// Unicode 6.1
var unicodeLetters = '\\u0041-\\u005A\\u0061-\\u007A\\u00AA\\u00B5\\u00BA\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02C1\\u02C6-\\u02D1\\u02E0-\\u02E4\\u02EC\\u02EE\\u0370-\\u0374\\u0376\\u0377\\u037A-\\u037D\\u0386\\u0388-\\u038A\\u038C\\u038E-\\u03A1\\u03A3-\\u03F5\\u03F7-\\u0481\\u048A-\\u0527\\u0531-\\u0556\\u0559\\u0561-\\u0587\\u05D0-\\u05EA\\u05F0-\\u05F2\\u0620-\\u064A\\u066E\\u066F\\u0671-\\u06D3\\u06D5\\u06E5\\u06E6\\u06EE\\u06EF\\u06FA-\\u06FC\\u06FF\\u0710\\u0712-\\u072F\\u074D-\\u07A5\\u07B1\\u07CA-\\u07EA\\u07F4\\u07F5\\u07FA\\u0800-\\u0815\\u081A\\u0824\\u0828\\u0840-\\u0858\\u08A0\\u08A2-\\u08AC\\u0904-\\u0939\\u093D\\u0950\\u0958-\\u0961\\u0971-\\u0977\\u0979-\\u097F\\u0985-\\u098C\\u098F\\u0990\\u0993-\\u09A8\\u09AA-\\u09B0\\u09B2\\u09B6-\\u09B9\\u09BD\\u09CE\\u09DC\\u09DD\\u09DF-\\u09E1\\u09F0\\u09F1\\u0A05-\\u0A0A\\u0A0F\\u0A10\\u0A13-\\u0A28\\u0A2A-\\u0A30\\u0A32\\u0A33\\u0A35\\u0A36\\u0A38\\u0A39\\u0A59-\\u0A5C\\u0A5E\\u0A72-\\u0A74\\u0A85-\\u0A8D\\u0A8F-\\u0A91\\u0A93-\\u0AA8\\u0AAA-\\u0AB0\\u0AB2\\u0AB3\\u0AB5-\\u0AB9\\u0ABD\\u0AD0\\u0AE0\\u0AE1\\u0B05-\\u0B0C\\u0B0F\\u0B10\\u0B13-\\u0B28\\u0B2A-\\u0B30\\u0B32\\u0B33\\u0B35-\\u0B39\\u0B3D\\u0B5C\\u0B5D\\u0B5F-\\u0B61\\u0B71\\u0B83\\u0B85-\\u0B8A\\u0B8E-\\u0B90\\u0B92-\\u0B95\\u0B99\\u0B9A\\u0B9C\\u0B9E\\u0B9F\\u0BA3\\u0BA4\\u0BA8-\\u0BAA\\u0BAE-\\u0BB9\\u0BD0\\u0C05-\\u0C0C\\u0C0E-\\u0C10\\u0C12-\\u0C28\\u0C2A-\\u0C33\\u0C35-\\u0C39\\u0C3D\\u0C58\\u0C59\\u0C60\\u0C61\\u0C85-\\u0C8C\\u0C8E-\\u0C90\\u0C92-\\u0CA8\\u0CAA-\\u0CB3\\u0CB5-\\u0CB9\\u0CBD\\u0CDE\\u0CE0\\u0CE1\\u0CF1\\u0CF2\\u0D05-\\u0D0C\\u0D0E-\\u0D10\\u0D12-\\u0D3A\\u0D3D\\u0D4E\\u0D60\\u0D61\\u0D7A-\\u0D7F\\u0D85-\\u0D96\\u0D9A-\\u0DB1\\u0DB3-\\u0DBB\\u0DBD\\u0DC0-\\u0DC6\\u0E01-\\u0E30\\u0E32\\u0E33\\u0E40-\\u0E46\\u0E81\\u0E82\\u0E84\\u0E87\\u0E88\\u0E8A\\u0E8D\\u0E94-\\u0E97\\u0E99-\\u0E9F\\u0EA1-\\u0EA3\\u0EA5\\u0EA7\\u0EAA\\u0EAB\\u0EAD-\\u0EB0\\u0EB2\\u0EB3\\u0EBD\\u0EC0-\\u0EC4\\u0EC6\\u0EDC-\\u0EDF\\u0F00\\u0F40-\\u0F47\\u0F49-\\u0F6C\\u0F88-\\u0F8C\\u1000-\\u102A\\u103F\\u1050-\\u1055\\u105A-\\u105D\\u1061\\u1065\\u1066\\u106E-\\u1070\\u1075-\\u1081\\u108E\\u10A0-\\u10C5\\u10C7\\u10CD\\u10D0-\\u10FA\\u10FC-\\u1248\\u124A-\\u124D\\u1250-\\u1256\\u1258\\u125A-\\u125D\\u1260-\\u1288\\u128A-\\u128D\\u1290-\\u12B0\\u12B2-\\u12B5\\u12B8-\\u12BE\\u12C0\\u12C2-\\u12C5\\u12C8-\\u12D6\\u12D8-\\u1310\\u1312-\\u1315\\u1318-\\u135A\\u1380-\\u138F\\u13A0-\\u13F4\\u1401-\\u166C\\u166F-\\u167F\\u1681-\\u169A\\u16A0-\\u16EA\\u16EE-\\u16F0\\u1700-\\u170C\\u170E-\\u1711\\u1720-\\u1731\\u1740-\\u1751\\u1760-\\u176C\\u176E-\\u1770\\u1780-\\u17B3\\u17D7\\u17DC\\u1820-\\u1877\\u1880-\\u18A8\\u18AA\\u18B0-\\u18F5\\u1900-\\u191C\\u1950-\\u196D\\u1970-\\u1974\\u1980-\\u19AB\\u19C1-\\u19C7\\u1A00-\\u1A16\\u1A20-\\u1A54\\u1AA7\\u1B05-\\u1B33\\u1B45-\\u1B4B\\u1B83-\\u1BA0\\u1BAE\\u1BAF\\u1BBA-\\u1BE5\\u1C00-\\u1C23\\u1C4D-\\u1C4F\\u1C5A-\\u1C7D\\u1CE9-\\u1CEC\\u1CEE-\\u1CF1\\u1CF5\\u1CF6\\u1D00-\\u1DBF\\u1E00-\\u1F15\\u1F18-\\u1F1D\\u1F20-\\u1F45\\u1F48-\\u1F4D\\u1F50-\\u1F57\\u1F59\\u1F5B\\u1F5D\\u1F5F-\\u1F7D\\u1F80-\\u1FB4\\u1FB6-\\u1FBC\\u1FBE\\u1FC2-\\u1FC4\\u1FC6-\\u1FCC\\u1FD0-\\u1FD3\\u1FD6-\\u1FDB\\u1FE0-\\u1FEC\\u1FF2-\\u1FF4\\u1FF6-\\u1FFC\\u2071\\u207F\\u2090-\\u209C\\u2102\\u2107\\u210A-\\u2113\\u2115\\u2119-\\u211D\\u2124\\u2126\\u2128\\u212A-\\u212D\\u212F-\\u2139\\u213C-\\u213F\\u2145-\\u2149\\u214E\\u2160-\\u2188\\u2C00-\\u2C2E\\u2C30-\\u2C5E\\u2C60-\\u2CE4\\u2CEB-\\u2CEE\\u2CF2\\u2CF3\\u2D00-\\u2D25\\u2D27\\u2D2D\\u2D30-\\u2D67\\u2D6F\\u2D80-\\u2D96\\u2DA0-\\u2DA6\\u2DA8-\\u2DAE\\u2DB0-\\u2DB6\\u2DB8-\\u2DBE\\u2DC0-\\u2DC6\\u2DC8-\\u2DCE\\u2DD0-\\u2DD6\\u2DD8-\\u2DDE\\u2E2F\\u3005-\\u3007\\u3021-\\u3029\\u3031-\\u3035\\u3038-\\u303C\\u3041-\\u3096\\u309D-\\u309F\\u30A1-\\u30FA\\u30FC-\\u30FF\\u3105-\\u312D\\u3131-\\u318E\\u31A0-\\u31BA\\u31F0-\\u31FF\\u3400-\\u4DB5\\u4E00-\\u9FCC\\uA000-\\uA48C\\uA4D0-\\uA4FD\\uA500-\\uA60C\\uA610-\\uA61F\\uA62A\\uA62B\\uA640-\\uA66E\\uA67F-\\uA697\\uA6A0-\\uA6EF\\uA717-\\uA71F\\uA722-\\uA788\\uA78B-\\uA78E\\uA790-\\uA793\\uA7A0-\\uA7AA\\uA7F8-\\uA801\\uA803-\\uA805\\uA807-\\uA80A\\uA80C-\\uA822\\uA840-\\uA873\\uA882-\\uA8B3\\uA8F2-\\uA8F7\\uA8FB\\uA90A-\\uA925\\uA930-\\uA946\\uA960-\\uA97C\\uA984-\\uA9B2\\uA9CF\\uAA00-\\uAA28\\uAA40-\\uAA42\\uAA44-\\uAA4B\\uAA60-\\uAA76\\uAA7A\\uAA80-\\uAAAF\\uAAB1\\uAAB5\\uAAB6\\uAAB9-\\uAABD\\uAAC0\\uAAC2\\uAADB-\\uAADD\\uAAE0-\\uAAEA\\uAAF2-\\uAAF4\\uAB01-\\uAB06\\uAB09-\\uAB0E\\uAB11-\\uAB16\\uAB20-\\uAB26\\uAB28-\\uAB2E\\uABC0-\\uABE2\\uAC00-\\uD7A3\\uD7B0-\\uD7C6\\uD7CB-\\uD7FB\\uF900-\\uFA6D\\uFA70-\\uFAD9\\uFB00-\\uFB06\\uFB13-\\uFB17\\uFB1D\\uFB1F-\\uFB28\\uFB2A-\\uFB36\\uFB38-\\uFB3C\\uFB3E\\uFB40\\uFB41\\uFB43\\uFB44\\uFB46-\\uFBB1\\uFBD3-\\uFD3D\\uFD50-\\uFD8F\\uFD92-\\uFDC7\\uFDF0-\\uFDFB\\uFE70-\\uFE74\\uFE76-\\uFEFC\\uFF21-\\uFF3A\\uFF41-\\uFF5A\\uFF66-\\uFFBE\\uFFC2-\\uFFC7\\uFFCA-\\uFFCF\\uFFD2-\\uFFD7\\uFFDA-\\uFFDC';

/* harmony default export */ __webpack_exports__["a"] = ({ unicodeLetters: unicodeLetters });

/***/ }),

/***/ "./lib/utils/sticky.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createPlaceholder */
/* unused harmony export isSticky */
var createPlaceholder = function createPlaceholder() {
  var placeholder = document.createElement('div');
  placeholder.classList.add('sticky-placeholder');

  return placeholder;
};

var isSticky = function isSticky(el, scrollY, stickyTop, insertPlaceholder) {
  var top = Math.floor(el.offsetTop - scrollY);

  if (top <= stickyTop && !el.classList.contains('is-stuck')) {
    var placeholder = insertPlaceholder ? createPlaceholder() : null;
    var heightBefore = el.offsetHeight;

    el.classList.add('is-stuck');

    if (insertPlaceholder) {
      el.parentNode.insertBefore(placeholder, el.nextElementSibling);

      placeholder.style.height = heightBefore - el.offsetHeight + 'px';
    }
  } else if (top > stickyTop && el.classList.contains('is-stuck')) {
    el.classList.remove('is-stuck');

    if (insertPlaceholder && el.nextElementSibling && el.nextElementSibling.classList.contains('sticky-placeholder')) {
      el.nextElementSibling.remove();
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function (el) {
  var insertPlaceholder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (!el) return;

  var computedStyle = window.getComputedStyle(el);

  if (!/sticky/.test(computedStyle.position)) return;

  var stickyTop = parseInt(computedStyle.top, 10);

  document.addEventListener('scroll', function () {
    return isSticky(el, window.scrollY, stickyTop, insertPlaceholder);
  }, {
    passive: true
  });
});

/***/ }),

/***/ "./lib/utils/text_utility.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vendor_latinise__ = __webpack_require__("../../../vendor/assets/javascripts/latinise.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vendor_latinise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vendor_latinise__);
/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, no-param-reassign, no-cond-assign, quotes, one-var, one-var-declaration-per-line, operator-assignment, no-else-return, prefer-template, prefer-arrow-callback, no-empty, max-len, consistent-return, no-unused-vars, no-return-assign, max-len, vars-on-top */



var base;
var w = window;
if (w.gl == null) {
  w.gl = {};
}
if ((base = w.gl).text == null) {
  base.text = {};
}
gl.text.addDelimiter = function (text) {
  return text ? text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : text;
};
gl.text.highCountTrim = function (count) {
  return count > 99 ? '99+' : count;
};
gl.text.randomString = function () {
  return Math.random().toString(36).substring(7);
};
gl.text.replaceRange = function (s, start, end, substitute) {
  return s.substring(0, start) + substitute + s.substring(end);
};
gl.text.getTextWidth = function (text, font) {
  /**
  * Uses canvas.measureText to compute and return the width of the given text of given font in pixels.
  *
  * @param {String} text The text to be rendered.
  * @param {String} font The css font descriptor that text is to be rendered with (e.g. "bold 14px verdana").
  *
  * @see http://stackoverflow.com/questions/118241/calculate-text-width-with-javascript/21015393#21015393
  */
  // re-use canvas object for better performance
  var canvas = gl.text.getTextWidth.canvas || (gl.text.getTextWidth.canvas = document.createElement('canvas'));
  var context = canvas.getContext('2d');
  context.font = font;
  return context.measureText(text).width;
};
gl.text.selectedText = function (text, textarea) {
  return text.substring(textarea.selectionStart, textarea.selectionEnd);
};
gl.text.lineBefore = function (text, textarea) {
  var split;
  split = text.substring(0, textarea.selectionStart).trim().split('\n');
  return split[split.length - 1];
};
gl.text.lineAfter = function (text, textarea) {
  return text.substring(textarea.selectionEnd).trim().split('\n')[0];
};
gl.text.blockTagText = function (text, textArea, blockTag, selected) {
  var lineAfter, lineBefore;
  lineBefore = this.lineBefore(text, textArea);
  lineAfter = this.lineAfter(text, textArea);
  if (lineBefore === blockTag && lineAfter === blockTag) {
    // To remove the block tag we have to select the line before & after
    if (blockTag != null) {
      textArea.selectionStart = textArea.selectionStart - (blockTag.length + 1);
      textArea.selectionEnd = textArea.selectionEnd + (blockTag.length + 1);
    }
    return selected;
  } else {
    return blockTag + "\n" + selected + "\n" + blockTag;
  }
};
gl.text.insertText = function (textArea, text, tag, blockTag, selected, wrap) {
  var insertText, inserted, selectedSplit, startChar, removedLastNewLine, removedFirstNewLine, currentLineEmpty, lastNewLine;
  removedLastNewLine = false;
  removedFirstNewLine = false;
  currentLineEmpty = false;

  // Remove the first newline
  if (selected.indexOf('\n') === 0) {
    removedFirstNewLine = true;
    selected = selected.replace(/\n+/, '');
  }

  // Remove the last newline
  if (textArea.selectionEnd - textArea.selectionStart > selected.replace(/\n$/, '').length) {
    removedLastNewLine = true;
    selected = selected.replace(/\n$/, '');
  }

  selectedSplit = selected.split('\n');

  if (!wrap) {
    lastNewLine = textArea.value.substr(0, textArea.selectionStart).lastIndexOf('\n');

    // Check whether the current line is empty or consists only of spaces(=handle as empty)
    if (/^\s*$/.test(textArea.value.substring(lastNewLine, textArea.selectionStart))) {
      currentLineEmpty = true;
    }
  }

  startChar = !wrap && !currentLineEmpty && textArea.selectionStart > 0 ? '\n' : '';

  if (selectedSplit.length > 1 && (!wrap || blockTag != null && blockTag !== '')) {
    if (blockTag != null && blockTag !== '') {
      insertText = this.blockTagText(text, textArea, blockTag, selected);
    } else {
      insertText = selectedSplit.map(function (val) {
        if (val.indexOf(tag) === 0) {
          return "" + val.replace(tag, '');
        } else {
          return "" + tag + val;
        }
      }).join('\n');
    }
  } else {
    insertText = "" + startChar + tag + selected + (wrap ? tag : ' ');
  }

  if (removedFirstNewLine) {
    insertText = '\n' + insertText;
  }

  if (removedLastNewLine) {
    insertText += '\n';
  }

  if (document.queryCommandSupported('insertText')) {
    inserted = document.execCommand('insertText', false, insertText);
  }
  if (!inserted) {
    try {
      document.execCommand("ms-beginUndoUnit");
    } catch (error) {}
    textArea.value = this.replaceRange(text, textArea.selectionStart, textArea.selectionEnd, insertText);
    try {
      document.execCommand("ms-endUndoUnit");
    } catch (error) {}
  }
  return this.moveCursor(textArea, tag, wrap, removedLastNewLine);
};
gl.text.moveCursor = function (textArea, tag, wrapped, removedLastNewLine) {
  var pos;
  if (!textArea.setSelectionRange) {
    return;
  }
  if (textArea.selectionStart === textArea.selectionEnd) {
    if (wrapped) {
      pos = textArea.selectionStart - tag.length;
    } else {
      pos = textArea.selectionStart;
    }

    if (removedLastNewLine) {
      pos -= 1;
    }

    return textArea.setSelectionRange(pos, pos);
  }
};
gl.text.updateText = function (textArea, tag, blockTag, wrap) {
  var $textArea, selected, text;
  $textArea = $(textArea);
  textArea = $textArea.get(0);
  text = $textArea.val();
  selected = this.selectedText(text, textArea);
  $textArea.focus();
  return this.insertText(textArea, text, tag, blockTag, selected, wrap);
};
gl.text.init = function (form) {
  var self;
  self = this;
  return $('.js-md', form).off('click').on('click', function () {
    var $this;
    $this = $(this);
    return self.updateText($this.closest('.md-area').find('textarea'), $this.data('md-tag'), $this.data('md-block'), !$this.data('md-prepend'));
  });
};
gl.text.removeListeners = function (form) {
  return $('.js-md', form).off('click');
};
gl.text.humanize = function (string) {
  return string.charAt(0).toUpperCase() + string.replace(/_/g, ' ').slice(1);
};
gl.text.pluralize = function (str, count) {
  return str + (count > 1 || count === 0 ? 's' : '');
};
gl.text.truncate = function (string, maxLength) {
  return string.substr(0, maxLength - 3) + '...';
};
gl.text.dasherize = function (str) {
  return str.replace(/[_\s]+/g, '-');
};
gl.text.slugify = function (str) {
  return str.trim().toLowerCase().latinise();
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./lib/utils/type_utility.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isObject; });
// eslint-disable-next-line import/prefer-default-export
var isObject = function isObject(obj) {
  return obj && obj.constructor === Object;
};

/***/ }),

/***/ "./lib/utils/url_utility.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = visitUrl;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, no-param-reassign, no-cond-assign, one-var, one-var-declaration-per-line, no-void, guard-for-in, no-restricted-syntax, prefer-template, quotes, max-len */

var base;
var w = window;
if (w.gl == null) {
  w.gl = {};
}
if ((base = w.gl).utils == null) {
  base.utils = {};
}
// Returns an array containing the value(s) of the
// of the key passed as an argument
w.gl.utils.getParameterValues = function (sParam) {
  var i, sPageURL, sParameterName, sURLVariables, values;
  sPageURL = decodeURIComponent(window.location.search.substring(1));
  sURLVariables = sPageURL.split('&');
  sParameterName = void 0;
  values = [];
  i = 0;
  while (i < sURLVariables.length) {
    sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] === sParam) {
      values.push(sParameterName[1].replace(/\+/g, ' '));
    }
    i += 1;
  }
  return values;
};
// @param {Object} params - url keys and value to merge
// @param {String} url
w.gl.utils.mergeUrlParams = function (params, url) {
  var lastChar, newUrl, paramName, paramValue, pattern;
  newUrl = decodeURIComponent(url);
  for (paramName in params) {
    paramValue = params[paramName];
    pattern = new RegExp("\\b(" + paramName + "=).*?(&|$)");
    if (paramValue == null) {
      newUrl = newUrl.replace(pattern, '');
    } else if (url.search(pattern) !== -1) {
      newUrl = newUrl.replace(pattern, "$1" + paramValue + "$2");
    } else {
      newUrl = "" + newUrl + (newUrl.indexOf('?') > 0 ? '&' : '?') + paramName + "=" + paramValue;
    }
  }
  // Remove a trailing ampersand
  lastChar = newUrl[newUrl.length - 1];
  if (lastChar === '&') {
    newUrl = newUrl.slice(0, -1);
  }
  return newUrl;
};
// removes parameter query string from url. returns the modified url
w.gl.utils.removeParamQueryString = function (url, param) {
  var urlVariables, variables;
  url = decodeURIComponent(url);
  urlVariables = url.split('&');
  return function () {
    var j, len, results;
    results = [];
    for (j = 0, len = urlVariables.length; j < len; j += 1) {
      variables = urlVariables[j];
      if (variables.indexOf(param) === -1) {
        results.push(variables);
      }
    }
    return results;
  }().join('&');
};
w.gl.utils.removeParams = function (params) {
  var url = document.createElement('a');
  url.href = window.location.href;
  params.forEach(function (param) {
    url.search = w.gl.utils.removeParamQueryString(url.search, param);
  });
  return url.href;
};
w.gl.utils.getLocationHash = function (url) {
  var hashIndex;
  if (typeof url === 'undefined') {
    // Note: We can't use window.location.hash here because it's
    // not consistent across browsers - Firefox will pre-decode it
    url = window.location.href;
  }
  hashIndex = url.indexOf('#');
  return hashIndex === -1 ? null : url.substring(hashIndex + 1);
};

w.gl.utils.refreshCurrentPage = function () {
  return gl.utils.visitUrl(document.location.href);
};

// eslint-disable-next-line import/prefer-default-export
function visitUrl(url) {
  var external = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (external) {
    // Simulate `target="blank" rel="noopener noreferrer"`
    // See https://mathiasbynens.github.io/rel-noopener/
    var otherWindow = window.open();
    otherWindow.opener = null;
    otherWindow.location = url;
  } else {
    document.location.href = url;
  }
}

window.gl = window.gl || {};
window.gl.utils = _extends({}, window.gl.utils || {}, {
  visitUrl: visitUrl
});

/***/ }),

/***/ "./line_highlighter.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, no-use-before-define, no-underscore-dangle, no-param-reassign, prefer-template, quotes, comma-dangle, prefer-arrow-callback, consistent-return, one-var, one-var-declaration-per-line, no-else-return, max-len */

// LineHighlighter
//
// Handles single- and multi-line selection and highlight for blob views.
//
//
// ### Example Markup
//
//   <div id="blob-content-holder">
//     <div class="file-content">
//       <div class="line-numbers">
//         <a href="#L1" id="L1" data-line-number="1">1</a>
//         <a href="#L2" id="L2" data-line-number="2">2</a>
//         <a href="#L3" id="L3" data-line-number="3">3</a>
//         <a href="#L4" id="L4" data-line-number="4">4</a>
//         <a href="#L5" id="L5" data-line-number="5">5</a>
//       </div>
//       <pre class="code highlight">
//         <code>
//           <span id="LC1" class="line">...</span>
//           <span id="LC2" class="line">...</span>
//           <span id="LC3" class="line">...</span>
//           <span id="LC4" class="line">...</span>
//           <span id="LC5" class="line">...</span>
//         </code>
//       </pre>
//     </div>
//   </div>
//

var LineHighlighter = function LineHighlighter() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  options.highlightLineClass = options.highlightLineClass || 'hll';
  options.fileHolderSelector = options.fileHolderSelector || '.file-holder';
  options.scrollFileHolder = options.scrollFileHolder || false;
  options.hash = options.hash || location.hash;

  this.options = options;
  this._hash = options.hash;
  this.highlightLineClass = options.highlightLineClass;
  this.setHash = this.setHash.bind(this);
  this.highlightLine = this.highlightLine.bind(this);
  this.clickHandler = this.clickHandler.bind(this);
  this.highlightHash = this.highlightHash.bind(this);

  this.bindEvents();
  this.highlightHash();
};

LineHighlighter.prototype.bindEvents = function () {
  var $fileHolder = $(this.options.fileHolderSelector);

  $fileHolder.on('click', 'a[data-line-number]', this.clickHandler);
  $fileHolder.on('highlight:line', this.highlightHash);
};

LineHighlighter.prototype.highlightHash = function (newHash) {
  var range = void 0;
  if (newHash && typeof newHash === 'string') this._hash = newHash;

  this.clearHighlight();

  if (this._hash !== '') {
    range = this.hashToRange(this._hash);
    if (range[0]) {
      this.highlightRange(range);
      var lineSelector = '#L' + range[0];
      var scrollOptions = {
        // Scroll to the first highlighted line on initial load
        // Offset -50 for the sticky top bar, and another -100 for some context
        offset: -150
      };
      if (this.options.scrollFileHolder) {
        $(this.options.fileHolderSelector).scrollTo(lineSelector, scrollOptions);
      } else {
        $.scrollTo(lineSelector, scrollOptions);
      }
    }
  }
};

LineHighlighter.prototype.clickHandler = function (event) {
  var current, lineNumber, range;
  event.preventDefault();
  this.clearHighlight();
  lineNumber = $(event.target).closest('a').data('line-number');
  current = this.hashToRange(this._hash);
  if (!(current[0] && event.shiftKey)) {
    // If there's no current selection, or there is but Shift wasn't held,
    // treat this like a single-line selection.
    this.setHash(lineNumber);
    return this.highlightLine(lineNumber);
  } else if (event.shiftKey) {
    if (lineNumber < current[0]) {
      range = [lineNumber, current[0]];
    } else {
      range = [current[0], lineNumber];
    }
    this.setHash(range[0], range[1]);
    return this.highlightRange(range);
  }
};

LineHighlighter.prototype.clearHighlight = function () {
  return $("." + this.highlightLineClass).removeClass(this.highlightLineClass);
};

// Convert a URL hash String into line numbers
//
// hash - Hash String
//
// Examples:
//
//   hashToRange('#L5')    # => [5, null]
//   hashToRange('#L5-15') # => [5, 15]
//   hashToRange('#foo')   # => [null, null]
//
// Returns an Array
LineHighlighter.prototype.hashToRange = function (hash) {
  var first, last, matches;
  // ?L(\d+)(?:-(\d+))?$/)
  matches = hash.match(/^#?L(\d+)(?:-(\d+))?$/);
  if (matches && matches.length) {
    first = parseInt(matches[1], 10);
    last = matches[2] ? parseInt(matches[2], 10) : null;
    return [first, last];
  } else {
    return [null, null];
  }
};

// Highlight a single line
//
// lineNumber - Line number to highlight
LineHighlighter.prototype.highlightLine = function (lineNumber) {
  return $("#LC" + lineNumber).addClass(this.highlightLineClass);
};

// Highlight all lines within a range
//
// range - Array containing the starting and ending line numbers
LineHighlighter.prototype.highlightRange = function (range) {
  var i, lineNumber, ref, ref1, results;
  if (range[1]) {
    results = [];
    for (lineNumber = i = ref = range[0], ref1 = range[1]; ref <= ref1 ? i <= ref1 : i >= ref1; lineNumber = ref <= ref1 ? i += 1 : i -= 1) {
      results.push(this.highlightLine(lineNumber));
    }
    return results;
  } else {
    return this.highlightLine(range[0]);
  }
};

// Set the URL hash string
LineHighlighter.prototype.setHash = function (firstLineNumber, lastLineNumber) {
  var hash;
  if (lastLineNumber) {
    hash = "#L" + firstLineNumber + "-" + lastLineNumber;
  } else {
    hash = "#L" + firstLineNumber;
  }
  this._hash = hash;
  return this.__setLocationHash__(hash);
};

// Make the actual hash change in the browser
//
// This method is stubbed in tests.
LineHighlighter.prototype.__setLocationHash__ = function (value) {
  return history.pushState({
    url: value
    // We're using pushState instead of assigning location.hash directly to
    // prevent the page from scrolling on the hashchange event
  }, document.title, value);
};

window.LineHighlighter = LineHighlighter;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./locale/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/jed/jed.js
var jed = __webpack_require__("../../../node_modules/jed/jed.js");
var jed_default = /*#__PURE__*/__webpack_require__.n(jed);

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/underscore/underscore.js
var underscore = __webpack_require__("../../../node_modules/underscore/underscore.js");
var underscore_default = /*#__PURE__*/__webpack_require__.n(underscore);

// CONCATENATED MODULE: ./locale/sprintf.js


/**
  Very limited implementation of sprintf supporting only named parameters.

  @param input (translated) text with parameters (e.g. '%{num_users} users use us')
  @param parameters object mapping parameter names to values (e.g. { num_users: 5 })
  @param escapeParameters whether parameter values should be escaped (see http://underscorejs.org/#escape)
  @returns {String} the text with parameters replaces (e.g. '5 users use us')

  @see https://ruby-doc.org/core-2.3.3/Kernel.html#method-i-sprintf
  @see https://gitlab.com/gitlab-org/gitlab-ce/issues/37992
**/
/* harmony default export */ var sprintf = (function (input, parameters) {
  var escapeParameters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var output = input;

  if (parameters) {
    Object.keys(parameters).forEach(function (parameterName) {
      var parameterValue = parameters[parameterName];
      var escapedParameterValue = escapeParameters ? underscore_default.a.escape(parameterValue) : parameterValue;
      output = output.replace(new RegExp('%{' + parameterName + '}', 'g'), escapedParameterValue);
    });
  }

  return output;
});
// CONCATENATED MODULE: ./locale/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lang", function() { return lang; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__", function() { return gettext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n__", function() { return ngettext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s__", function() { return pgettext; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "sprintf", function() { return sprintf; });



var langAttribute = document.querySelector('html').getAttribute('lang');
var lang = (langAttribute || 'en').replace(/-/g, '_');
var locale = new jed_default.a(window.translations || {});
delete window.translations;

/**
  Translates `text`
  @param text The text to be translated
  @returns {String} The translated text
**/
var gettext = locale.gettext.bind(locale);

/**
  Translate the text with a number
  if the number is more than 1 it will use the `pluralText` translation.
  This method allows for contexts, see below re. contexts

  @param text Singular text to translate (eg. '%d day')
  @param pluralText Plural text to translate (eg. '%d days')
  @param count Number to decide which translation to use (eg. 2)
  @returns {String} Translated text with the number replaced (eg. '2 days')
**/
var ngettext = function ngettext(text, pluralText, count) {
  var translated = locale.ngettext(text, pluralText, count).replace(/%d/g, count).split('|');

  return translated[translated.length - 1];
};

/**
  Translate context based text
  Either pass in the context translation like `Context|Text to translate`
  or allow for dynamic text by doing passing in the context first & then the text to translate

  @param keyOrContext Can be either the key to translate including the context
                      (eg. 'Context|Text') or just the context for the translation
                      (eg. 'Context')
  @param key Is the dynamic variable you want to be translated
  @returns {String} Translated context based text
**/
var pgettext = function pgettext(keyOrContext, key) {
  var normalizedKey = key ? keyOrContext + '|' + key : keyOrContext;
  var translated = gettext(normalizedKey).split('|');

  return translated[translated.length - 1];
};






/* harmony default export */ var locale_0 = __webpack_exports__["default"] = (locale);

/***/ }),

/***/ "./logo.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, prefer-arrow-callback */

(function () {
  window.addEventListener('beforeunload', function () {
    $('.tanuki-logo').addClass('animate');
  });
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./main.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("../../../node_modules/jquery/dist/jquery.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dropzone__ = __webpack_require__("../../../node_modules/dropzone/dist/dropzone.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vendor_Sortable__ = __webpack_require__("../../../vendor/assets/javascripts/Sortable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vendor_Sortable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vendor_Sortable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_svg4everybody__ = __webpack_require__("../../../node_modules/svg4everybody/dist/svg4everybody.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_svg4everybody___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_svg4everybody__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mousetrap__ = __webpack_require__("../../../node_modules/mousetrap/mousetrap.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mousetrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mousetrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mousetrap_plugins_pause_mousetrap_pause__ = __webpack_require__("../../../node_modules/mousetrap/plugins/pause/mousetrap-pause.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mousetrap_plugins_pause_mousetrap_pause___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mousetrap_plugins_pause_mousetrap_pause__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vendor_fuzzaldrin_plus__ = __webpack_require__("../../../vendor/assets/javascripts/fuzzaldrin-plus.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vendor_fuzzaldrin_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vendor_fuzzaldrin_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shortcuts__ = __webpack_require__("./shortcuts.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shortcuts_blob__ = __webpack_require__("./shortcuts_blob.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shortcuts_dashboard_navigation__ = __webpack_require__("./shortcuts_dashboard_navigation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shortcuts_navigation__ = __webpack_require__("./shortcuts_navigation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shortcuts_find_file__ = __webpack_require__("./shortcuts_find_file.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shortcuts_issuable__ = __webpack_require__("./shortcuts_issuable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shortcuts_network__ = __webpack_require__("./shortcuts_network.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__templates_issuable_template_selector__ = __webpack_require__("./templates/issuable_template_selector.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__templates_issuable_template_selectors__ = __webpack_require__("./templates/issuable_template_selectors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__templates_issuable_template_selectors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__templates_issuable_template_selectors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__commit_image_file__ = __webpack_require__("./commit/image_file.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__lib_utils_common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__lib_utils_datetime_utility__ = __webpack_require__("./lib/utils/datetime_utility.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__lib_utils_pretty_time__ = __webpack_require__("./lib/utils/pretty_time.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__lib_utils_text_utility__ = __webpack_require__("./lib/utils/text_utility.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__lib_utils_url_utility__ = __webpack_require__("./lib/utils/url_utility.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__behaviors___ = __webpack_require__("./behaviors/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__u2f_authenticate__ = __webpack_require__("./u2f/authenticate.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__u2f_error__ = __webpack_require__("./u2f/error.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__u2f_error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__u2f_error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__u2f_register__ = __webpack_require__("./u2f/register.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__u2f_util__ = __webpack_require__("./u2f/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__u2f_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__u2f_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__activities__ = __webpack_require__("./activities.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__admin__ = __webpack_require__("./admin.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__admin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__admin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__api__ = __webpack_require__("./api.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__ajax_loading_spinner__ = __webpack_require__("./ajax_loading_spinner.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__aside__ = __webpack_require__("./aside.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__aside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__aside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__autosave__ = __webpack_require__("./autosave.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__awards_handler__ = __webpack_require__("./awards_handler.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__breakpoints__ = __webpack_require__("./breakpoints.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__broadcast_message__ = __webpack_require__("./broadcast_message.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__broadcast_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__broadcast_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__build__ = __webpack_require__("./build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__build_artifacts__ = __webpack_require__("./build_artifacts.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__build_variables__ = __webpack_require__("./build_variables.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__build_variables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__build_variables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__ci_lint_editor__ = __webpack_require__("./ci_lint_editor.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__ci_lint_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__ci_lint_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__commits__ = __webpack_require__("./commits.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__compare__ = __webpack_require__("./compare.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__compare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__compare_autocomplete__ = __webpack_require__("./compare_autocomplete.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__compare_autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__compare_autocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__confirm_danger_modal__ = __webpack_require__("./confirm_danger_modal.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__copy_as_gfm__ = __webpack_require__("./copy_as_gfm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__copy_to_clipboard__ = __webpack_require__("./copy_to_clipboard.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__diff__ = __webpack_require__("./diff.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__dropzone_input__ = __webpack_require__("./dropzone_input.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__due_date_select__ = __webpack_require__("./due_date_select.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__files_comment_button__ = __webpack_require__("./files_comment_button.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__flash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__flash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__gl_dropdown__ = __webpack_require__("./gl_dropdown.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__gl_field_error__ = __webpack_require__("./gl_field_error.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__gl_field_error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__gl_field_error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__gl_field_errors__ = __webpack_require__("./gl_field_errors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__gl_form__ = __webpack_require__("./gl_form.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__group_avatar__ = __webpack_require__("./group_avatar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__group_avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__group_avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__group_label_subscription__ = __webpack_require__("./group_label_subscription.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__group_label_subscription___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__group_label_subscription__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__groups_select__ = __webpack_require__("./groups_select.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__header__ = __webpack_require__("./header.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__importer_status__ = __webpack_require__("./importer_status.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__importer_status___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__importer_status__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__issuable_index__ = __webpack_require__("./issuable_index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__issuable_context__ = __webpack_require__("./issuable_context.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__issuable_form__ = __webpack_require__("./issuable_form.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__issue__ = __webpack_require__("./issue.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__issue_status_select__ = __webpack_require__("./issue_status_select.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__issue_status_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66__issue_status_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__label_manager__ = __webpack_require__("./label_manager.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__label_manager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67__label_manager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__labels__ = __webpack_require__("./labels.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__labels___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68__labels__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__labels_select__ = __webpack_require__("./labels_select.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__layout_nav__ = __webpack_require__("./layout_nav.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__lazy_loader__ = __webpack_require__("./lazy_loader.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__line_highlighter__ = __webpack_require__("./line_highlighter.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__line_highlighter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72__line_highlighter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__logo__ = __webpack_require__("./logo.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__logo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73__logo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__member_expiration_date__ = __webpack_require__("./member_expiration_date.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__members__ = __webpack_require__("./members.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__members___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75__members__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__merge_request__ = __webpack_require__("./merge_request.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__merge_request_tabs__ = __webpack_require__("./merge_request_tabs.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__milestone__ = __webpack_require__("./milestone.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__milestone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78__milestone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__milestone_select__ = __webpack_require__("./milestone_select.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__namespace_select__ = __webpack_require__("./namespace_select.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__new_branch_form__ = __webpack_require__("./new_branch_form.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__new_commit_form__ = __webpack_require__("./new_commit_form.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__new_commit_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82__new_commit_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__notes__ = __webpack_require__("./notes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__notifications_dropdown__ = __webpack_require__("./notifications_dropdown.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__notifications_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84__notifications_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__notifications_form__ = __webpack_require__("./notifications_form.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__notifications_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85__notifications_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__pager__ = __webpack_require__("./pager.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__preview_markdown__ = __webpack_require__("./preview_markdown.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__preview_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_87__preview_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__project__ = __webpack_require__("./project.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__project_avatar__ = __webpack_require__("./project_avatar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__project_avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_89__project_avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__project_find_file__ = __webpack_require__("./project_find_file.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__project_find_file___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_90__project_find_file__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__project_import__ = __webpack_require__("./project_import.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__project_import___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_91__project_import__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__project_label_subscription__ = __webpack_require__("./project_label_subscription.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__project_label_subscription___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_92__project_label_subscription__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__project_new__ = __webpack_require__("./project_new.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__project_select__ = __webpack_require__("./project_select.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__project_show__ = __webpack_require__("./project_show.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__project_show___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_95__project_show__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__project_variables__ = __webpack_require__("./project_variables.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__project_variables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_96__project_variables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__projects_dropdown__ = __webpack_require__("./projects_dropdown/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__projects_list__ = __webpack_require__("./projects_list.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__syntax_highlight__ = __webpack_require__("./syntax_highlight.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__syntax_highlight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_99__syntax_highlight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__render_math__ = __webpack_require__("./render_math.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__render_math___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_100__render_math__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__render_gfm__ = __webpack_require__("./render_gfm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__render_gfm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_101__render_gfm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__right_sidebar__ = __webpack_require__("./right_sidebar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__search__ = __webpack_require__("./search.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__search_autocomplete__ = __webpack_require__("./search_autocomplete.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__smart_interval__ = __webpack_require__("./smart_interval.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__smart_interval___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_105__smart_interval__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__star__ = __webpack_require__("./star.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__subscription__ = __webpack_require__("./subscription.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__subscription___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_107__subscription__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__subscription_select__ = __webpack_require__("./subscription_select.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__subscription_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_108__subscription_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__breadcrumb__ = __webpack_require__("./breadcrumb.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__admin_email_select__ = __webpack_require__("./admin_email_select.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__application_settings__ = __webpack_require__("./application_settings.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__application_settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_111__application_settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__approvals__ = __webpack_require__("./approvals.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__approvals___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_112__approvals__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__ee_trial_banner__ = __webpack_require__("./ee_trial_banner/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__ldap_groups_select__ = __webpack_require__("./ldap_groups_select.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__path_locks__ = __webpack_require__("./path_locks.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__path_locks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_115__path_locks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__weight_select__ = __webpack_require__("./weight_select.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__weight_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_116__weight_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__dispatcher__ = __webpack_require__("./dispatcher.js");
/* eslint-disable func-names, space-before-function-paren, no-var, quotes, consistent-return, prefer-arrow-callback, comma-dangle, object-shorthand, no-new, max-len, no-multi-spaces, import/newline-after-import, import/first */
/* global Flash */
/* global ConfirmDangerModal */
/* global Aside */








// libraries with import side-effects




// expose common libraries as globals (TODO: remove these)
window.jQuery = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;
window.$ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;
window._ = __WEBPACK_IMPORTED_MODULE_1_underscore___default.a;
window.Dropzone = __WEBPACK_IMPORTED_MODULE_3_dropzone___default.a;
window.Sortable = __WEBPACK_IMPORTED_MODULE_4_vendor_Sortable___default.a;

// shortcuts








// templates





// lib/utils






// behaviors


// u2f





// everything else


















































































// EE-only scripts










// eslint-disable-next-line global-require, import/no-commonjs
if (false) require('./test_utils/');

__WEBPACK_IMPORTED_MODULE_3_dropzone___default.a.autoDiscover = false;

__WEBPACK_IMPORTED_MODULE_5_svg4everybody___default()();

document.addEventListener('beforeunload', function () {
  // Unbind scroll events
  $(document).off('scroll');
  // Close any open tooltips
  $('.has-tooltip, [data-toggle="tooltip"]').tooltip('destroy');
  // Close any open popover
  $('[data-toggle="popover"]').popover('destroy');
});

window.addEventListener('hashchange', __WEBPACK_IMPORTED_MODULE_19__lib_utils_common_utils__["k" /* handleLocationHash */]);
window.addEventListener('load', function onLoad() {
  window.removeEventListener('load', onLoad, false);
  Object(__WEBPACK_IMPORTED_MODULE_19__lib_utils_common_utils__["k" /* handleLocationHash */])();
}, false);

gl.lazyLoader = new __WEBPACK_IMPORTED_MODULE_71__lazy_loader__["a" /* default */]({
  scrollContainer: window,
  observerNode: '#content-body'
});

$(function () {
  var $body = $('body');
  var $document = $(document);
  var $window = $(window);
  var $sidebarGutterToggle = $('.js-sidebar-toggle');
  var $flash = $('.flash-container');
  var bootstrapBreakpoint = __WEBPACK_IMPORTED_MODULE_36__breakpoints__["a" /* default */].getBreakpointSize();
  var fitSidebarForSize;

  Object(__WEBPACK_IMPORTED_MODULE_109__breadcrumb__["a" /* default */])();

  // Set the default path for all cookies to GitLab's root directory
  __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.defaults.path = gon.relative_url_root || '/';

  // `hashchange` is not triggered when link target is already in window.location
  $body.on('click', 'a[href^="#"]', function () {
    var href = this.getAttribute('href');
    if (href.substr(1) === gl.utils.getLocationHash()) {
      setTimeout(__WEBPACK_IMPORTED_MODULE_19__lib_utils_common_utils__["k" /* handleLocationHash */], 1);
    }
  });

  if (bootstrapBreakpoint === 'xs') {
    var $rightSidebar = $('aside.right-sidebar, .page-with-sidebar');

    $rightSidebar.removeClass('right-sidebar-expanded').addClass('right-sidebar-collapsed');
  }

  // prevent default action for disabled buttons
  $('.btn').click(function (e) {
    if ($(this).hasClass('disabled')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }
  });

  $('.js-select-on-focus').on('focusin', function () {
    return $(this).select().one('mouseup', function (e) {
      return e.preventDefault();
    });
    // Click a .js-select-on-focus field, select the contents
    // Prevent a mouseup event from deselecting the input
  });
  $('.remove-row').bind('ajax:success', function () {
    $(this).tooltip('destroy').closest('li').fadeOut();
  });
  $('.js-remove-tr').bind('ajax:before', function () {
    return $(this).hide();
  });
  $('.js-remove-tr').bind('ajax:success', function () {
    return $(this).closest('tr').fadeOut();
  });
  $('select.select2').select2({
    width: 'resolve',
    // Initialize select2 selects
    dropdownAutoWidth: true
  });
  $('.js-select2').bind('select2-close', function () {
    return setTimeout(function () {
      $('.select2-container-active').removeClass('select2-container-active');
      return $(':focus').blur();
    }, 1);
    // Close select2 on escape
  });
  // Initialize tooltips
  $.fn.tooltip.Constructor.DEFAULTS.trigger = 'hover';
  $body.tooltip({
    selector: '.has-tooltip, [data-toggle="tooltip"]',
    placement: function placement(tip, el) {
      return $(el).data('placement') || 'bottom';
    }
  });
  // Initialize popovers
  $body.popover({
    selector: '[data-toggle="popover"]',
    trigger: 'focus',
    // set the viewport to the main content, excluding the navigation bar, so
    // the navigation can't overlap the popover
    viewport: '.page-with-sidebar'
  });
  $('.trigger-submit').on('change', function () {
    return $(this).parents('form').submit();
    // Form submitter
  });
  gl.utils.localTimeAgo($('abbr.timeago, .js-timeago'), true);
  // Flash
  if ($flash.length > 0) {
    $flash.click(function () {
      return $(this).fadeOut();
    });
    $flash.show();
  }
  // Disable form buttons while a form is submitting
  $body.on('ajax:complete, ajax:beforeSend, submit', 'form', function (e) {
    var buttons;
    buttons = $('[type="submit"], .js-disable-on-submit', this);
    switch (e.type) {
      case 'ajax:beforeSend':
      case 'submit':
        return buttons.disable();
      default:
        return buttons.enable();
    }
  });
  $(document).ajaxError(function (e, xhrObj) {
    var ref = xhrObj.status;
    if (xhrObj.status === 401) {
      return new Flash('You need to be logged in.', 'alert');
    } else if (ref === 404 || ref === 500) {
      return new Flash('Something went wrong on our end.', 'alert');
    }
  });
  $('.account-box').hover(function () {
    // Show/Hide the profile menu when hovering the account box
    return $(this).toggleClass('hover');
  });
  $document.on('click', '.diff-content .js-show-suppressed-diff', function () {
    var $container;
    $container = $(this).parent();
    $container.next('table').show();
    return $container.remove();
    // Commit show suppressed diff
  });
  $('.navbar-toggle').on('click', function () {
    $('.header-content').toggleClass('menu-expanded');
    gl.lazyLoader.loadCheck();
  });
  // Show/hide comments on diff
  $body.on('click', '.js-toggle-diff-comments', function (e) {
    var $this = $(this);
    var notesHolders = $this.closest('.diff-file').find('.notes_holder');
    $this.toggleClass('active');
    if ($this.hasClass('active')) {
      notesHolders.show().find('.hide, .content').show();
    } else {
      notesHolders.hide().find('.content').hide();
    }
    $(document).trigger('toggle.comments');
    return e.preventDefault();
  });
  $document.off('click', '.js-confirm-danger');
  $document.on('click', '.js-confirm-danger', function (e) {
    var btn = $(e.target);
    var form = btn.closest('form');
    var text = btn.data('confirm-danger-message');
    var warningMessage = btn.data('warning-message');
    e.preventDefault();
    return new ConfirmDangerModal(form, text, {
      warningMessage: warningMessage
    });
  });
  $('input[type="search"]').each(function () {
    var $this = $(this);
    $this.attr('value', $this.val());
  });
  $document.off('keyup', 'input[type="search"]').on('keyup', 'input[type="search"]', function () {
    var $this;
    $this = $(this);
    return $this.attr('value', $this.val());
  });
  $document.off('breakpoint:change').on('breakpoint:change', function (e, breakpoint) {
    var $gutterIcon;
    if (breakpoint === 'sm' || breakpoint === 'xs') {
      $gutterIcon = $sidebarGutterToggle.find('i');
      if ($gutterIcon.hasClass('fa-angle-double-right')) {
        return $sidebarGutterToggle.trigger('click');
      }
    }
  });
  fitSidebarForSize = function fitSidebarForSize() {
    var oldBootstrapBreakpoint;
    oldBootstrapBreakpoint = bootstrapBreakpoint;
    bootstrapBreakpoint = __WEBPACK_IMPORTED_MODULE_36__breakpoints__["a" /* default */].getBreakpointSize();
    if (bootstrapBreakpoint !== oldBootstrapBreakpoint) {
      return $document.trigger('breakpoint:change', [bootstrapBreakpoint]);
    }
  };
  $window.off('resize.app').on('resize.app', function () {
    return fitSidebarForSize();
  });
  Object(__WEBPACK_IMPORTED_MODULE_35__awards_handler__["a" /* default */])();
  new Aside();

  gl.utils.renderTimeago();

  $(document).trigger('init.scrolling-tabs');

  $('form.filter-form').on('submit', function (event) {
    var link = document.createElement('a');
    link.href = this.action;

    var action = '' + this.action + (link.search === '' ? '?' : '&');

    event.preventDefault();
    gl.utils.visitUrl('' + action + $(this).serialize());
  });

  /**
   * EE specific scripts
   */
  $('#modal-upload-trial-license').modal('show');
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./member_expiration_date.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pikaday__ = __webpack_require__("../../../node_modules/pikaday/pikaday.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pikaday___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pikaday__);
/* global dateFormat */



(function () {
  // Add datepickers to all `js-access-expiration-date` elements. If those elements are
  // children of an element with the `clearable-input` class, and have a sibling
  // `js-clear-input` element, then show that element when there is a value in the
  // datepicker, and make clicking on that element clear the field.
  //
  window.gl = window.gl || {};
  gl.MemberExpirationDate = function () {
    var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.js-access-expiration-date';

    function toggleClearInput() {
      $(this).closest('.clearable-input').toggleClass('has-value', $(this).val() !== '');
    }
    var inputs = $(selector);

    inputs.each(function (i, el) {
      var $input = $(el);

      var calendar = new __WEBPACK_IMPORTED_MODULE_0_pikaday___default.a({
        field: $input.get(0),
        theme: 'gitlab-theme animate-picker',
        format: 'yyyy-mm-dd',
        minDate: new Date(),
        container: $input.parent().get(0),
        onSelect: function onSelect(dateText) {
          $input.val(dateFormat(new Date(dateText), 'yyyy-mm-dd'));

          $input.trigger('change');

          toggleClearInput.call($input);
        }
      });

      calendar.setDate(new Date($input.val()));
      $input.data('pikaday', calendar);
    });

    inputs.next('.js-clear-input').on('click', function clicked(event) {
      event.preventDefault();

      var input = $(this).closest('.clearable-input').find(selector);
      var calendar = input.data('pikaday');

      calendar.setDate(null);
      input.trigger('change');
      toggleClearInput.call(input);
    });

    inputs.on('blur', toggleClearInput);

    inputs.each(toggleClearInput);
  };
}).call(window);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./members.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this, promise/catch-or-return */
/* eslint-disable no-new */
/* global Flash */
(function () {
  window.gl = window.gl || {};

  var Members = function () {
    function Members() {
      _classCallCheck(this, Members);

      this.addListeners();
      this.initGLDropdown();
    }

    _createClass(Members, [{
      key: 'addListeners',
      value: function addListeners() {
        $('.js-ldap-permissions').off('click').on('click', this.showLDAPPermissionsWarning.bind(this));
        $('.js-ldap-override').off('click').on('click', this.toggleMemberAccessToggle.bind(this));
        $('.project_member, .group_member').off('ajax:success').on('ajax:success', this.removeRow);
        $('.js-member-update-control').off('change').on('change', this.formSubmit.bind(this));
        $('.js-edit-member-form').off('ajax:success').on('ajax:success', this.formSuccess.bind(this));
        gl.utils.disableButtonIfEmptyField('#user_ids', 'input[name=commit]', 'change');
      }
    }, {
      key: 'initGLDropdown',
      value: function initGLDropdown() {
        var _this = this;

        $('.js-member-permissions-dropdown').each(function (i, btn) {
          var $btn = $(btn);

          $btn.glDropdown({
            selectable: true,
            isSelectable: function isSelectable(selected, $el) {
              if ($el.data('revert')) {
                return false;
              }

              return !$el.hasClass('is-active');
            },

            fieldName: $btn.data('field-name'),
            id: function id(selected, $el) {
              return $el.data('id');
            },
            toggleLabel: function toggleLabel(selected, $el) {
              if ($el.data('revert')) {
                return $btn.text();
              }

              return $el.text();
            },

            clicked: function clicked(options) {
              var $link = options.$el;

              if (!$link.data('revert')) {
                _this.formSubmit(null, $link);
              } else {
                var _getMemberListItems = _this.getMemberListItems($link),
                    $memberListItem = _getMemberListItems.$memberListItem,
                    $toggle = _getMemberListItems.$toggle,
                    $dateInput = _getMemberListItems.$dateInput;

                $toggle.disable();
                $dateInput.disable();

                _this.overrideLdap($memberListItem, $link.data('endpoint'), false).fail(function () {
                  $toggle.enable();
                  $dateInput.enable();
                });
              }
            }
          });
        });
      }
    }, {
      key: 'removeRow',
      value: function removeRow(e) {
        var $target = $(e.target);

        if ($target.hasClass('btn-remove')) {
          $target.closest('.member').fadeOut(function fadeOutMemberRow() {
            $(this).remove();
          });
        }
      }
    }, {
      key: 'formSubmit',
      value: function formSubmit(e) {
        var $el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        var $this = e ? $(e.currentTarget) : $el;

        var _getMemberListItems2 = this.getMemberListItems($this),
            $toggle = _getMemberListItems2.$toggle,
            $dateInput = _getMemberListItems2.$dateInput;

        $this.closest('form').trigger('submit.rails');

        $toggle.disable();
        $dateInput.disable();
      }
    }, {
      key: 'formSuccess',
      value: function formSuccess(e) {
        var _getMemberListItems3 = this.getMemberListItems($(e.currentTarget).closest('.member')),
            $toggle = _getMemberListItems3.$toggle,
            $dateInput = _getMemberListItems3.$dateInput;

        $toggle.enable();
        $dateInput.enable();
      }
    }, {
      key: 'showLDAPPermissionsWarning',
      value: function showLDAPPermissionsWarning(e) {
        var $btn = $(e.currentTarget);

        var _getMemberListItems4 = this.getMemberListItems($btn),
            $memberListItem = _getMemberListItems4.$memberListItem;

        var $ldapPermissionsElement = $memberListItem.next();

        $ldapPermissionsElement.toggle();
      }
    }, {
      key: 'getMemberListItems',
      value: function getMemberListItems($el) {
        var $memberListItem = $el.is('.member') ? $el : $('#' + $el.data('el-id'));

        return {
          $memberListItem: $memberListItem,
          $toggle: $memberListItem.find('.dropdown-menu-toggle'),
          $dateInput: $memberListItem.find('.js-access-expiration-date')
        };
      }
    }, {
      key: 'toggleMemberAccessToggle',
      value: function toggleMemberAccessToggle(e) {
        var _this2 = this;

        var $btn = $(e.currentTarget);

        var _getMemberListItems5 = this.getMemberListItems($btn),
            $memberListItem = _getMemberListItems5.$memberListItem,
            $toggle = _getMemberListItems5.$toggle,
            $dateInput = _getMemberListItems5.$dateInput;

        $btn.disable();

        this.overrideLdap($memberListItem, $btn.data('endpoint'), true).then(function () {
          _this2.showLDAPPermissionsWarning(e);

          $toggle.enable();
          $dateInput.enable();
        }).fail(function (xhr) {
          $btn.enable();

          if (xhr.status === 403) {
            new Flash('You do not have the correct permissions to override the settings from the LDAP group sync.', 'alert');
          } else {
            new Flash('An error occured whilst saving LDAP override status. Please try again.', 'alert');
          }
        });
      }
    }, {
      key: 'overrideLdap',
      value: function overrideLdap($memberListitem, endpoint, override) {
        return $.ajax({
          url: endpoint,
          type: 'PATCH',
          data: {
            group_member: {
              override: override
            }
          }
        }).then(function () {
          $memberListitem.toggleClass('is-overriden', override);
        });
      }
    }]);

    return Members;
  }();

  gl.Members = Members;
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./merge_request.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vendor_jquery_waitforimages__ = __webpack_require__("../../../vendor/assets/javascripts/jquery.waitforimages.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vendor_jquery_waitforimages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vendor_jquery_waitforimages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__task_list__ = __webpack_require__("./task_list.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__merge_request_tabs__ = __webpack_require__("./merge_request_tabs.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_issuables_helper__ = __webpack_require__("./helpers/issuables_helper.js");
/* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, quotes, no-underscore-dangle, one-var, one-var-declaration-per-line, consistent-return, dot-notation, quote-props, comma-dangle, object-shorthand, max-len, prefer-arrow-callback */
/* global MergeRequestTabs */






(function () {
  this.MergeRequest = function () {
    function MergeRequest(opts) {
      // Initialize MergeRequest behavior
      //
      // Options:
      //   action - String, current controller action
      //
      this.opts = opts != null ? opts : {};
      this.submitNoteForm = this.submitNoteForm.bind(this);
      this.$el = $('.merge-request');
      this.$('.show-all-commits').on('click', function (_this) {
        return function () {
          return _this.showAllCommits();
        };
      }(this));

      this.initTabs();
      this.initMRBtnListeners();
      this.initCommitMessageListeners();
      this.closeReopenReportToggle = __WEBPACK_IMPORTED_MODULE_3__helpers_issuables_helper__["a" /* default */].initCloseReopenReport();

      if ($("a.btn-close").length) {
        this.taskList = new __WEBPACK_IMPORTED_MODULE_1__task_list__["a" /* default */]({
          dataType: 'merge_request',
          fieldName: 'description',
          selector: '.detail-page-description',
          onSuccess: function onSuccess(result) {
            document.querySelector('#task_status').innerText = result.task_status;
            document.querySelector('#task_status_short').innerText = result.task_status_short;
          }
        });
      }
    }

    // Local jQuery finder
    MergeRequest.prototype.$ = function (selector) {
      return this.$el.find(selector);
    };

    MergeRequest.prototype.initTabs = function () {
      if (window.mrTabs) {
        window.mrTabs.unbindEvents();
      }
      window.mrTabs = new gl.MergeRequestTabs(this.opts);
    };

    MergeRequest.prototype.showAllCommits = function () {
      this.$('.first-commits').remove();
      return this.$('.all-commits').removeClass('hide');
    };

    MergeRequest.prototype.initMRBtnListeners = function () {
      var _this;
      _this = this;
      return $('a.btn-close, a.btn-reopen').on('click', function (e) {
        var $this, shouldSubmit;
        $this = $(this);
        shouldSubmit = $this.hasClass('btn-comment');
        if (shouldSubmit && $this.data('submitted')) {
          return;
        }

        if (this.closeReopenReportToggle) this.closeReopenReportToggle.setDisable();

        if (shouldSubmit) {
          if ($this.hasClass('btn-comment-and-close') || $this.hasClass('btn-comment-and-reopen')) {
            e.preventDefault();
            e.stopImmediatePropagation();

            _this.submitNoteForm($this.closest('form'), $this);
          }
        }
      });
    };

    MergeRequest.prototype.submitNoteForm = function (form, $button) {
      var noteText;
      noteText = form.find("textarea.js-note-text").val();
      if (noteText.trim().length > 0) {
        form.submit();
        $button.data('submitted', true);
        return $button.trigger('click');
      }
    };

    MergeRequest.prototype.initCommitMessageListeners = function () {
      $(document).on('click', 'a.js-with-description-link', function (e) {
        var textarea = $('textarea.js-commit-message');
        e.preventDefault();

        textarea.val(textarea.data('messageWithDescription'));
        $('.js-with-description-hint').hide();
        $('.js-without-description-hint').show();
      });

      $(document).on('click', 'a.js-without-description-link', function (e) {
        var textarea = $('textarea.js-commit-message');
        e.preventDefault();

        textarea.val(textarea.data('messageWithoutDescription'));
        $('.js-with-description-hint').show();
        $('.js-without-description-hint').hide();
      });
    };

    MergeRequest.prototype.updateStatusText = function (classToRemove, classToAdd, newStatusText) {
      $('.detail-page-header .status-box').removeClass(classToRemove).addClass(classToAdd).find('span').text(newStatusText);
    };

    MergeRequest.prototype.decreaseCounter = function () {
      var by = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      var $el = $('.nav-links .js-merge-counter');
      var count = Math.max(parseInt($el.text().replace(/[^\d]/, ''), 10) - by, 0);

      $el.text(gl.text.addDelimiter(count));
    };

    MergeRequest.prototype.hideCloseButton = function () {
      var el = document.querySelector('.merge-request .issuable-actions');
      var closeDropdownItem = el.querySelector('li.close-item');
      if (closeDropdownItem) {
        closeDropdownItem.classList.add('hidden');
        // Selects the next dropdown item
        el.querySelector('li.report-item').click();
      } else {
        // No dropdown just hide the Close button
        el.querySelector('.btn-close').classList.add('hidden');
      }
      // Dropdown for mobile screen
      el.querySelector('li.js-close-item').classList.add('hidden');
    };

    return MergeRequest;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./merge_request_tabs.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__flash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__blob_blob_fork_suggestion__ = __webpack_require__("./blob/blob_fork_suggestion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__init_changes_dropdown__ = __webpack_require__("./init_changes_dropdown.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breakpoints__ = __webpack_require__("./breakpoints.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_utils_common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__image_diff_init_discussion_tab__ = __webpack_require__("./image_diff/init_discussion_tab.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-new, class-methods-use-this */
/* global Flash */
/* global notes */










/* eslint-disable max-len */
// MergeRequestTabs
//
// Handles persisting and restoring the current tab selection and lazily-loading
// content on the MergeRequests#show page.
//
// ### Example Markup
//
//   <ul class="nav-links merge-request-tabs">
//     <li class="notes-tab active">
//       <a data-action="notes" data-target="#notes" data-toggle="tab" href="/foo/bar/merge_requests/1">
//         Discussion
//       </a>
//     </li>
//     <li class="commits-tab">
//       <a data-action="commits" data-target="#commits" data-toggle="tab" href="/foo/bar/merge_requests/1/commits">
//         Commits
//       </a>
//     </li>
//     <li class="diffs-tab">
//       <a data-action="diffs" data-target="#diffs" data-toggle="tab" href="/foo/bar/merge_requests/1/diffs">
//         Diffs
//       </a>
//     </li>
//   </ul>
//
//   <div class="tab-content">
//     <div class="notes tab-pane active" id="notes">
//       Notes Content
//     </div>
//     <div class="commits tab-pane" id="commits">
//       Commits Content
//     </div>
//     <div class="diffs tab-pane" id="diffs">
//       Diffs Content
//     </div>
//   </div>
//
//   <div class="mr-loading-status">
//     <div class="loading">
//       Loading Animation
//     </div>
//   </div>
//
/* eslint-enable max-len */

(function () {
  // Store the `location` object, allowing for easier stubbing in tests
  var location = window.location;

  var MergeRequestTabs = function () {
    function MergeRequestTabs() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          action = _ref.action,
          setUrl = _ref.setUrl,
          stubLocation = _ref.stubLocation;

      _classCallCheck(this, MergeRequestTabs);

      this.diffsLoaded = false;
      this.pipelinesLoaded = false;
      this.commitsLoaded = false;
      this.fixedLayoutPref = null;

      this.setUrl = setUrl !== undefined ? setUrl : true;
      this.setCurrentAction = this.setCurrentAction.bind(this);
      this.tabShown = this.tabShown.bind(this);
      this.showTab = this.showTab.bind(this);

      if (stubLocation) {
        location = stubLocation;
      }

      this.bindEvents();
      this.activateTab(action);
      this.initAffix();
    }

    _createClass(MergeRequestTabs, [{
      key: 'bindEvents',
      value: function bindEvents() {
        $(document).on('shown.bs.tab', '.merge-request-tabs a[data-toggle="tab"]', this.tabShown).on('click', '.js-show-tab', this.showTab);

        $('.merge-request-tabs a[data-toggle="tab"]').on('click', this.clickTab);
      }

      // Used in tests

    }, {
      key: 'unbindEvents',
      value: function unbindEvents() {
        $(document).off('shown.bs.tab', '.merge-request-tabs a[data-toggle="tab"]', this.tabShown).off('click', '.js-show-tab', this.showTab);

        $('.merge-request-tabs a[data-toggle="tab"]').off('click', this.clickTab);
      }
    }, {
      key: 'destroyPipelinesView',
      value: function destroyPipelinesView() {
        if (this.commitPipelinesTable) {
          this.commitPipelinesTable.$destroy();
          this.commitPipelinesTable = null;

          document.querySelector('#commit-pipeline-table-view').innerHTML = '';
        }
      }
    }, {
      key: 'showTab',
      value: function showTab(e) {
        e.preventDefault();
        this.activateTab($(e.target).data('action'));
      }
    }, {
      key: 'clickTab',
      value: function clickTab(e) {
        if (e.currentTarget && Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils_common_utils__["p" /* isMetaClick */])(e)) {
          var targetLink = e.currentTarget.getAttribute('href');
          e.stopImmediatePropagation();
          e.preventDefault();
          window.open(targetLink, '_blank');
        }
      }
    }, {
      key: 'tabShown',
      value: function tabShown(e) {
        var $target = $(e.target);
        var action = $target.data('action');

        if (action === 'commits') {
          this.loadCommits($target.attr('href'));
          this.expandView();
          this.resetViewContainer();
          this.destroyPipelinesView();
        } else if (this.isDiffAction(action)) {
          this.loadDiff($target.attr('href'));
          if (__WEBPACK_IMPORTED_MODULE_4__breakpoints__["a" /* default */].getBreakpointSize() !== 'lg') {
            this.shrinkView();
          }
          if (this.diffViewType() === 'parallel') {
            this.expandViewContainer();
          }
          this.destroyPipelinesView();
        } else if (action === 'pipelines') {
          this.resetViewContainer();
          this.mountPipelinesView();
        } else {
          if (__WEBPACK_IMPORTED_MODULE_4__breakpoints__["a" /* default */].getBreakpointSize() !== 'xs') {
            this.expandView();
          }
          this.resetViewContainer();
          this.destroyPipelinesView();

          Object(__WEBPACK_IMPORTED_MODULE_6__image_diff_init_discussion_tab__["a" /* default */])();
        }
        if (this.setUrl) {
          this.setCurrentAction(action);
        }
      }
    }, {
      key: 'scrollToElement',
      value: function scrollToElement(container) {
        if (location.hash) {
          var offset = 0 - ($('.navbar-gitlab').outerHeight() + $('.js-tabs-affix').outerHeight());
          var $el = $(container + ' ' + location.hash + ':not(.match)');
          if ($el.length) {
            $.scrollTo($el[0], { offset: offset });
          }
        }
      }

      // Activate a tab based on the current action

    }, {
      key: 'activateTab',
      value: function activateTab(action) {
        // important note: the .tab('show') method triggers 'shown.bs.tab' event itself
        $('.merge-request-tabs a[data-action=\'' + action + '\']').tab('show');
      }

      // Replaces the current Merge Request-specific action in the URL with a new one
      //
      // If the action is "notes", the URL is reset to the standard
      // `MergeRequests#show` route.
      //
      // Examples:
      //
      //   location.pathname # => "/namespace/project/merge_requests/1"
      //   setCurrentAction('diffs')
      //   location.pathname # => "/namespace/project/merge_requests/1/diffs"
      //
      //   location.pathname # => "/namespace/project/merge_requests/1/diffs"
      //   setCurrentAction('show')
      //   location.pathname # => "/namespace/project/merge_requests/1"
      //
      //   location.pathname # => "/namespace/project/merge_requests/1/diffs"
      //   setCurrentAction('commits')
      //   location.pathname # => "/namespace/project/merge_requests/1/commits"
      //
      // Returns the new URL String

    }, {
      key: 'setCurrentAction',
      value: function setCurrentAction(action) {
        this.currentAction = action;

        // Remove a trailing '/commits' '/diffs' '/pipelines'
        var newState = location.pathname.replace(/\/(commits|diffs|pipelines)(\.html)?\/?$/, '');

        // Append the new action if we're on a tab other than 'notes'
        if (this.currentAction !== 'show' && this.currentAction !== 'new') {
          newState += '/' + this.currentAction;
        }

        // Ensure parameters and hash come along for the ride
        newState += location.search + location.hash;

        // TODO: Consider refactoring in light of turbolinks removal.

        // Replace the current history state with the new one without breaking
        // Turbolinks' history.
        //
        // See https://github.com/rails/turbolinks/issues/363
        window.history.replaceState({
          url: newState
        }, document.title, newState);

        return newState;
      }
    }, {
      key: 'loadCommits',
      value: function loadCommits(source) {
        var _this = this;

        if (this.commitsLoaded) {
          return;
        }
        this.ajaxGet({
          url: source + '.json',
          success: function success(data) {
            document.querySelector('div#commits').innerHTML = data.html;
            gl.utils.localTimeAgo($('.js-timeago', 'div#commits'));
            _this.commitsLoaded = true;
            _this.scrollToElement('#commits');
          }
        });
      }
    }, {
      key: 'mountPipelinesView',
      value: function mountPipelinesView() {
        var pipelineTableViewEl = document.querySelector('#commit-pipeline-table-view');
        var CommitPipelinesTable = gl.CommitPipelinesTable;
        this.commitPipelinesTable = new CommitPipelinesTable({
          propsData: {
            endpoint: pipelineTableViewEl.dataset.endpoint,
            helpPagePath: pipelineTableViewEl.dataset.helpPagePath,
            emptyStateSvgPath: pipelineTableViewEl.dataset.emptyStateSvgPath,
            errorStateSvgPath: pipelineTableViewEl.dataset.errorStateSvgPath,
            autoDevopsHelpPath: pipelineTableViewEl.dataset.helpAutoDevopsPath
          }
        }).$mount();

        // $mount(el) replaces the el with the new rendered component. We need it in order to mount
        // it everytime this tab is clicked - https://vuejs.org/v2/api/#vm-mount
        pipelineTableViewEl.appendChild(this.commitPipelinesTable.$el);
      }
    }, {
      key: 'loadDiff',
      value: function loadDiff(source) {
        var _this2 = this;

        if (this.diffsLoaded) {
          document.dispatchEvent(new CustomEvent('scroll'));
          return;
        }

        // We extract pathname for the current Changes tab anchor href
        // some pages like MergeRequestsController#new has query parameters on that anchor
        var urlPathname = Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils_common_utils__["v" /* parseUrlPathname */])(source);

        this.ajaxGet({
          url: urlPathname + '.json' + location.search,
          success: function success(data) {
            var $container = $('#diffs');
            $container.html(data.html);

            Object(__WEBPACK_IMPORTED_MODULE_3__init_changes_dropdown__["a" /* default */])();

            if (typeof gl.diffNotesCompileComponents !== 'undefined') {
              gl.diffNotesCompileComponents();
            }

            gl.utils.localTimeAgo($('.js-timeago', 'div#diffs'));
            $('#diffs .js-syntax-highlight').syntaxHighlight();

            if (_this2.diffViewType() === 'parallel' && _this2.isDiffAction(_this2.currentAction)) {
              _this2.expandViewContainer();
            }
            _this2.diffsLoaded = true;

            new gl.Diff();
            _this2.scrollToElement('#diffs');

            $('.diff-file').each(function (i, el) {
              new __WEBPACK_IMPORTED_MODULE_2__blob_blob_fork_suggestion__["a" /* default */]({
                openButtons: $(el).find('.js-edit-blob-link-fork-toggler'),
                forkButtons: $(el).find('.js-fork-suggestion-button'),
                cancelButtons: $(el).find('.js-cancel-fork-suggestion-button'),
                suggestionSections: $(el).find('.js-file-fork-suggestion-section'),
                actionTextPieces: $(el).find('.js-file-fork-suggestion-section-action')
              }).init();
            });

            // Scroll any linked note into view
            // Similar to `toggler_behavior` in the discussion tab
            var hash = window.gl.utils.getLocationHash();
            var anchor = hash && $container.find('.note[id="' + hash + '"]');
            if (anchor && anchor.length > 0) {
              var notesContent = anchor.closest('.notes_content');
              var lineType = notesContent.hasClass('new') ? 'new' : 'old';
              notes.toggleDiffNote({
                target: anchor,
                lineType: lineType,
                forceShow: true
              });
              anchor[0].scrollIntoView();
              Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils_common_utils__["k" /* handleLocationHash */])();
              // We have multiple elements on the page with `#note_xxx`
              // (discussion and diff tabs) and `:target` only applies to the first
              anchor.addClass('target');
            }
          }
        });
      }

      // Show or hide the loading spinner
      //
      // status - Boolean, true to show, false to hide

    }, {
      key: 'toggleLoading',
      value: function toggleLoading(status) {
        $('.mr-loading-status .loading').toggle(status);
      }
    }, {
      key: 'ajaxGet',
      value: function ajaxGet(options) {
        var _this3 = this;

        var defaults = {
          beforeSend: function beforeSend() {
            return _this3.toggleLoading(true);
          },
          error: function error() {
            return new Flash('An error occurred while fetching this tab.', 'alert');
          },
          complete: function complete() {
            return _this3.toggleLoading(false);
          },
          dataType: 'json',
          type: 'GET'
        };
        $.ajax($.extend({}, defaults, options));
      }
    }, {
      key: 'diffViewType',
      value: function diffViewType() {
        return $('.inline-parallel-buttons a.active').data('view-type');
      }
    }, {
      key: 'isDiffAction',
      value: function isDiffAction(action) {
        return action === 'diffs' || action === 'new/diffs';
      }
    }, {
      key: 'expandViewContainer',
      value: function expandViewContainer() {
        var $wrapper = $('.content-wrapper .container-fluid').not('.breadcrumbs');
        if (this.fixedLayoutPref === null) {
          this.fixedLayoutPref = $wrapper.hasClass('container-limited');
        }
        $wrapper.removeClass('container-limited');
      }
    }, {
      key: 'resetViewContainer',
      value: function resetViewContainer() {
        if (this.fixedLayoutPref !== null) {
          $('.content-wrapper .container-fluid').toggleClass('container-limited', this.fixedLayoutPref);
        }
      }
    }, {
      key: 'shrinkView',
      value: function shrinkView() {
        var $gutterIcon = $('.js-sidebar-toggle i:visible');

        // Wait until listeners are set
        setTimeout(function () {
          // Only when sidebar is expanded
          if ($gutterIcon.is('.fa-angle-double-right')) {
            $gutterIcon.closest('a').trigger('click', [true]);
          }
        }, 0);
      }

      // Expand the issuable sidebar unless the user explicitly collapsed it

    }, {
      key: 'expandView',
      value: function expandView() {
        if (__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('collapsed_gutter') === 'true') {
          return;
        }
        var $gutterIcon = $('.js-sidebar-toggle i:visible');

        // Wait until listeners are set
        setTimeout(function () {
          // Only when sidebar is collapsed
          if ($gutterIcon.is('.fa-angle-double-left')) {
            $gutterIcon.closest('a').trigger('click', [true]);
          }
        }, 0);
      }
    }, {
      key: 'initAffix',
      value: function initAffix() {
        var $tabs = $('.js-tabs-affix');
        var $fixedNav = $('.navbar-gitlab');

        // Screen space on small screens is usually very sparse
        // So we dont affix the tabs on these
        if (__WEBPACK_IMPORTED_MODULE_4__breakpoints__["a" /* default */].getBreakpointSize() === 'xs' || !$tabs.length) return;

        /**
          If the browser does not support position sticky, it returns the position as static.
          If the browser does support sticky, then we allow the browser to handle it, if not
          then we default back to Bootstraps affix
        **/
        if ($tabs.css('position') !== 'static') return;

        var $diffTabs = $('#diff-notes-app');

        $tabs.off('affix.bs.affix affix-top.bs.affix').affix({
          offset: {
            top: function top() {
              return $diffTabs.offset().top - $tabs.height() - $fixedNav.height();
            }
          }
        }).on('affix.bs.affix', function () {
          return $diffTabs.css({ marginTop: $tabs.height() });
        }).on('affix-top.bs.affix', function () {
          return $diffTabs.css({ marginTop: '' });
        });

        // Fix bug when reloading the page already scrolling
        if ($tabs.hasClass('affix')) {
          $tabs.trigger('affix.bs.affix');
        }
      }
    }]);

    return MergeRequestTabs;
  }();

  window.gl = window.gl || {};
  window.gl.MergeRequestTabs = MergeRequestTabs;
})();
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./milestone.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-use-before-define, camelcase, quotes, object-shorthand, no-shadow, no-unused-vars, comma-dangle, no-var, prefer-template, no-underscore-dangle, consistent-return, one-var, one-var-declaration-per-line, default-case, prefer-arrow-callback, max-len */
/* global Flash */
/* global Sortable */

(function () {
  this.Milestone = function () {
    function Milestone() {
      this.bindTabsSwitching();

      // Load merge request tab if it is active
      // merge request tab is active based on different conditions in the backend
      this.loadTab($('.js-milestone-tabs .active a'));

      this.loadInitialTab();
    }

    Milestone.prototype.bindTabsSwitching = function () {
      var _this = this;

      return $('a[data-toggle="tab"]').on('show.bs.tab', function (e) {
        var $target = $(e.target);

        location.hash = $target.attr('href');
        _this.loadTab($target);
      });
    };

    Milestone.prototype.loadInitialTab = function () {
      var $target = $('.js-milestone-tabs a[href="' + location.hash + '"]');

      if ($target.length) {
        $target.tab('show');
      }
    };

    Milestone.prototype.loadTab = function ($target) {
      var endpoint = $target.data('endpoint');
      var tabElId = $target.attr('href');

      if (endpoint && !$target.hasClass('is-loaded')) {
        $.ajax({
          url: endpoint,
          dataType: 'JSON'
        }).fail(function () {
          return new Flash('Error loading milestone tab');
        }).done(function (data) {
          $(tabElId).html(data.html);
          $target.addClass('is-loaded');
        });
      }
    };

    return Milestone;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./milestone_select.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, no-underscore-dangle, prefer-arrow-callback, max-len, one-var, one-var-declaration-per-line, no-unused-vars, object-shorthand, comma-dangle, no-else-return, no-self-compare, consistent-return, no-param-reassign, no-shadow */
/* global Issuable */
/* global ListMilestone */


(function () {
  this.MilestoneSelect = function () {
    function MilestoneSelect(currentProject, els) {
      var _this, $els;
      if (currentProject != null) {
        _this = this;
        this.currentProject = typeof currentProject === 'string' ? JSON.parse(currentProject) : currentProject;
      }

      $els = $(els);

      if (!els) {
        $els = $('.js-milestone-select');
      }

      $els.each(function (i, dropdown) {
        var $block, $dropdown, $loading, $selectbox, $sidebarCollapsedValue, $value, abilityName, collapsedSidebarLabelTemplate, defaultLabel, defaultNo, issuableId, issueUpdateURL, milestoneLinkNoneTemplate, milestoneLinkTemplate, milestonesUrl, projectId, selectedMilestone, selectedMilestoneDefault, showAny, showNo, showUpcoming, showStarted, useId, showMenuAbove;
        $dropdown = $(dropdown);
        projectId = $dropdown.data('project-id');
        milestonesUrl = $dropdown.data('milestones');
        issueUpdateURL = $dropdown.data('issueUpdate');
        showNo = $dropdown.data('show-no');
        showAny = $dropdown.data('show-any');
        showMenuAbove = $dropdown.data('showMenuAbove');
        showUpcoming = $dropdown.data('show-upcoming');
        showStarted = $dropdown.data('show-started');
        useId = $dropdown.data('use-id');
        defaultLabel = $dropdown.data('default-label');
        defaultNo = $dropdown.data('default-no');
        issuableId = $dropdown.data('issuable-id');
        abilityName = $dropdown.data('ability-name');
        $selectbox = $dropdown.closest('.selectbox');
        $block = $selectbox.closest('.block');
        $sidebarCollapsedValue = $block.find('.sidebar-collapsed-icon');
        $value = $block.find('.value');
        $loading = $block.find('.block-loading').fadeOut();
        selectedMilestoneDefault = showAny ? '' : null;
        selectedMilestoneDefault = showNo && defaultNo ? 'No Milestone' : selectedMilestoneDefault;
        selectedMilestone = $dropdown.data('selected') || selectedMilestoneDefault;
        if (issueUpdateURL) {
          milestoneLinkTemplate = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.template('<a href="/<%- full_path %>/milestones/<%- iid %>" class="bold has-tooltip" data-container="body" title="<%- remaining %>"><%- title %></a>');
          milestoneLinkNoneTemplate = '<span class="no-value">None</span>';
          collapsedSidebarLabelTemplate = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.template('<span class="has-tooltip" data-container="body" title="<%- name %><br /><%- remaining %>" data-placement="left" data-html="true"> <%- title %> </span>');
        }
        return $dropdown.glDropdown({
          showMenuAbove: showMenuAbove,
          data: function data(term, callback) {
            return $.ajax({
              url: milestonesUrl
            }).done(function (data) {
              var extraOptions = [];
              if (showAny) {
                extraOptions.push({
                  id: 0,
                  name: '',
                  title: 'Any Milestone'
                });
              }
              if (showNo) {
                extraOptions.push({
                  id: -1,
                  name: 'No Milestone',
                  title: 'No Milestone'
                });
              }
              if (showUpcoming) {
                extraOptions.push({
                  id: -2,
                  name: '#upcoming',
                  title: 'Upcoming'
                });
              }
              if (showStarted) {
                extraOptions.push({
                  id: -3,
                  name: '#started',
                  title: 'Started'
                });
              }
              if (extraOptions.length) {
                extraOptions.push('divider');
              }

              callback(extraOptions.concat(data));
              if (showMenuAbove) {
                $dropdown.data('glDropdown').positionMenuAbove();
              }
              $('[data-milestone-id="' + selectedMilestone + '"] > a').addClass('is-active');
            });
          },
          renderRow: function renderRow(milestone) {
            return '\n              <li data-milestone-id="' + milestone.name + '">\n                <a href=\'#\' class=\'dropdown-menu-milestone-link\'>\n                  ' + __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(milestone.title) + '\n                </a>\n              </li>\n            ';
          },
          filterable: true,
          search: {
            fields: ['title']
          },
          selectable: true,
          toggleLabel: function toggleLabel(selected, el, e) {
            if ($('html').hasClass('issue-boards-page') && !$dropdown.hasClass('js-issue-board-sidebar') && !$dropdown.closest('.add-issues-modal').length && !selected) {
              return gl.issueBoards.BoardsStore.state.currentBoard.milestone.title;
            }

            if (selected && 'id' in selected && $(el).hasClass('is-active')) {
              return selected.title;
            } else {
              return defaultLabel;
            }
          },
          defaultLabel: defaultLabel,
          fieldName: $dropdown.data('field-name'),
          text: function text(milestone) {
            return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(milestone.title);
          },
          id: function id(milestone) {
            if (!useId && !$dropdown.is('.js-issuable-form-dropdown')) {
              return milestone.name;
            } else {
              return milestone.id;
            }
          },
          isSelected: function isSelected(milestone) {
            return milestone.name === selectedMilestone;
          },
          hidden: function hidden() {
            $selectbox.hide();
            // display:block overrides the hide-collapse rule
            return $value.css('display', '');
          },
          opened: function opened(e) {
            var $el = $(e.currentTarget);
            if ($dropdown.hasClass('js-issue-board-sidebar')) {
              selectedMilestone = $dropdown[0].dataset.selected || selectedMilestoneDefault;
            }
            $('a.is-active', $el).removeClass('is-active');
            $('[data-milestone-id="' + selectedMilestone + '"] > a', $el).addClass('is-active');
          },
          vue: $dropdown.hasClass('js-issue-board-sidebar'),
          hideRow: function hideRow(milestone) {
            if ($('html').hasClass('issue-boards-page') && !$dropdown.hasClass('js-issue-board-sidebar') && !$dropdown.closest('.add-issues-modal').length && gl.issueBoards.BoardsStore.state.currentBoard.milestone) {
              return milestone !== gl.issueBoards.BoardsStore.state.currentBoard.milestone.title;
            }

            return false;
          },
          isSelectable: function isSelectable() {
            if ($('html').hasClass('issue-boards-page') && !$dropdown.hasClass('js-issue-board-sidebar') && !$dropdown.closest('.add-issues-modal').length && gl.issueBoards.BoardsStore.state.currentBoard.milestone_id) {
              return false;
            }

            return true;
          },
          clicked: function clicked(options) {
            var $el = options.$el,
                e = options.e;

            var selected = options.selectedObj;

            var data, isIssueIndex, isMRIndex, isSelecting, page, boardsStore;
            if (!selected) return;
            page = $('body').data('page');
            isIssueIndex = page === 'projects:issues:index';
            isMRIndex = page === page && page === 'projects:merge_requests:index';
            isSelecting = selected.name !== selectedMilestone;
            selectedMilestone = isSelecting ? selected.name : selectedMilestoneDefault;
            if ($dropdown.hasClass('js-filter-bulk-update') || $dropdown.hasClass('js-issuable-form-dropdown')) {
              e.preventDefault();
              return;
            }

            if ($dropdown.closest('.add-issues-modal').length) {
              boardsStore = gl.issueBoards.ModalStore.store.filter;
            }

            if (boardsStore) {
              boardsStore[$dropdown.data('field-name')] = selected.name;
              e.preventDefault();
            } else if ($dropdown.hasClass('js-filter-submit') && (isIssueIndex || isMRIndex)) {
              return Issuable.filterResults($dropdown.closest('form'));
            } else if ($dropdown.hasClass('js-filter-submit')) {
              return $dropdown.closest('form').submit();
            } else if ($dropdown.hasClass('js-issue-board-sidebar')) {
              if (selected.id !== -1 && isSelecting) {
                gl.issueBoards.boardStoreIssueSet('milestone', new ListMilestone({
                  id: selected.id,
                  title: selected.name
                }));
              } else {
                gl.issueBoards.boardStoreIssueDelete('milestone');
              }

              $dropdown.trigger('loading.gl.dropdown');
              $loading.removeClass('hidden').fadeIn();

              gl.issueBoards.BoardsStore.detail.issue.update($dropdown.attr('data-issue-update')).then(function () {
                $dropdown.trigger('loaded.gl.dropdown');
                $loading.fadeOut();
              }).catch(function () {
                $loading.fadeOut();
              });
            } else {
              selected = $selectbox.find('input[type="hidden"]').val();
              data = {};
              data[abilityName] = {};
              data[abilityName].milestone_id = selected != null ? selected : null;
              $loading.removeClass('hidden').fadeIn();
              $dropdown.trigger('loading.gl.dropdown');
              return $.ajax({
                type: 'PUT',
                url: issueUpdateURL,
                data: data
              }).done(function (data) {
                $dropdown.trigger('loaded.gl.dropdown');
                $loading.fadeOut();
                $selectbox.hide();
                $value.css('display', '');
                if (data.milestone != null) {
                  data.milestone.full_path = _this.currentProject.full_path;
                  data.milestone.remaining = gl.utils.timeFor(data.milestone.due_date);
                  data.milestone.name = data.milestone.title;
                  $value.html(milestoneLinkTemplate(data.milestone));
                  return $sidebarCollapsedValue.find('span').html(collapsedSidebarLabelTemplate(data.milestone));
                } else {
                  $value.html(milestoneLinkNoneTemplate);
                  return $sidebarCollapsedValue.find('span').text('No');
                }
              });
            }
          }
        });
      });
    }

    return MilestoneSelect;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./mini_pipeline_graph_dropdown.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-new */
/* global Flash */

/**
 * In each pipelines table we have a mini pipeline graph for each pipeline.
 *
 * When we click in a pipeline stage, we need to make an API call to get the
 * builds list to render in a dropdown.
 *
 * The container should be the table element.
 *
 * The stage icon clicked needs to have the following HTML structure:
 * <div class="dropdown">
 *   <button class="dropdown js-builds-dropdown-button" data-toggle="dropdown"></button>
 *   <div class="js-builds-dropdown-container dropdown-menu"></div>
 * </div>
 */

var MiniPipelineGraph = function () {
  function MiniPipelineGraph() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, MiniPipelineGraph);

    this.container = opts.container || '';
    this.dropdownListSelector = '.js-builds-dropdown-container';
    this.getBuildsList = this.getBuildsList.bind(this);
  }

  /**
   * Adds the event listener when the dropdown is opened.
   * All dropdown events are fired at the .dropdown-menu's parent element.
   */


  _createClass(MiniPipelineGraph, [{
    key: 'bindEvents',
    value: function bindEvents() {
      $(document).off('shown.bs.dropdown', this.container).on('shown.bs.dropdown', this.container, this.getBuildsList);
    }

    /**
     * When the user right clicks or cmd/ctrl + click in the job name
     * the dropdown should not be closed and the link should open in another tab,
     * so we stop propagation of the click event inside the dropdown.
     *
     * Since this component is rendered multiple times per page we need to guarantee we only
     * target the click event of this component.
     */

  }, {
    key: 'stopDropdownClickPropagation',
    value: function stopDropdownClickPropagation() {
      $(document).on('click', this.container + ' .js-builds-dropdown-list a.mini-pipeline-graph-dropdown-item', function (e) {
        e.stopPropagation();
      });
    }

    /**
     * For the clicked stage, renders the given data in the dropdown list.
     *
     * @param  {HTMLElement} stageContainer
     * @param  {Object} data
     */

  }, {
    key: 'renderBuildsList',
    value: function renderBuildsList(stageContainer, data) {
      var dropdownContainer = stageContainer.parentElement.querySelector(this.dropdownListSelector + ' .js-builds-dropdown-list');

      dropdownContainer.innerHTML = data;
    }

    /**
     * For the clicked stage, gets the list of builds.
     *
     * All dropdown events have a relatedTarget property,
     * whose value is the toggling anchor element.
     *
     * @param  {Object} e bootstrap dropdown event
     * @return {Promise}
     */

  }, {
    key: 'getBuildsList',
    value: function getBuildsList(e) {
      var _this = this;

      var button = e.relatedTarget;
      var endpoint = button.dataset.stageEndpoint;

      return $.ajax({
        dataType: 'json',
        type: 'GET',
        url: endpoint,
        beforeSend: function beforeSend() {
          _this.renderBuildsList(button, '');
          _this.toggleLoading(button);
        },
        success: function success(data) {
          _this.toggleLoading(button);
          _this.renderBuildsList(button, data.html);
          _this.stopDropdownClickPropagation();
        },
        error: function error() {
          _this.toggleLoading(button);
          if ($(button).parent().hasClass('open')) {
            $(button).dropdown('toggle');
          }
          new Flash('An error occurred while fetching the builds.', 'alert');
        }
      });
    }

    /**
     * Toggles the visibility of the loading icon.
     *
     * @param  {HTMLElement} stageContainer
     * @return {type}
     */

  }, {
    key: 'toggleLoading',
    value: function toggleLoading(stageContainer) {
      stageContainer.parentElement.querySelector(this.dropdownListSelector + ' .js-builds-dropdown-loading').classList.toggle('hidden');
    }
  }]);

  return MiniPipelineGraph;
}();

/* harmony default export */ __webpack_exports__["a"] = (MiniPipelineGraph);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./namespace_select.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("./api.js");
/* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, one-var, vars-on-top, one-var-declaration-per-line, comma-dangle, object-shorthand, no-else-return, prefer-template, quotes, prefer-arrow-callback, no-param-reassign, no-cond-assign, max-len */


(function () {
  window.NamespaceSelect = function () {
    function NamespaceSelect(opts) {
      this.onSelectItem = this.onSelectItem.bind(this);
      var fieldName, showAny;
      this.dropdown = opts.dropdown;
      showAny = true;
      fieldName = 'namespace_id';
      if (this.dropdown.attr('data-field-name')) {
        fieldName = this.dropdown.data('fieldName');
      }
      if (this.dropdown.attr('data-show-any')) {
        showAny = this.dropdown.data('showAny');
      }
      this.dropdown.glDropdown({
        filterable: true,
        selectable: true,
        filterRemote: true,
        search: {
          fields: ['path']
        },
        fieldName: fieldName,
        toggleLabel: function toggleLabel(selected) {
          if (selected.id == null) {
            return selected.text;
          } else {
            return selected.kind + ": " + selected.full_path;
          }
        },
        data: function data(term, dataCallback) {
          return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].namespaces(term, function (namespaces) {
            var anyNamespace;
            if (showAny) {
              anyNamespace = {
                text: 'Any namespace',
                id: null
              };
              namespaces.unshift(anyNamespace);
              namespaces.splice(1, 0, 'divider');
            }
            return dataCallback(namespaces);
          });
        },
        text: function text(namespace) {
          if (namespace.id == null) {
            return namespace.text;
          } else {
            return namespace.kind + ": " + namespace.full_path;
          }
        },
        renderRow: this.renderRow,
        clicked: this.onSelectItem
      });
    }

    NamespaceSelect.prototype.onSelectItem = function (options) {
      var e = options.e;

      return e.preventDefault();
    };

    return NamespaceSelect;
  }();

  window.NamespaceSelects = function () {
    function NamespaceSelects(opts) {
      var ref;
      if (opts == null) {
        opts = {};
      }
      this.$dropdowns = (ref = opts.$dropdowns) != null ? ref : $('.js-namespace-select');
      this.$dropdowns.each(function (i, dropdown) {
        var $dropdown;
        $dropdown = $(dropdown);
        return new window.NamespaceSelect({
          dropdown: $dropdown
        });
      });
    }

    return NamespaceSelects;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./new_branch_form.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ref_select_dropdown__ = __webpack_require__("./ref_select_dropdown.js");
/* eslint-disable func-names, space-before-function-paren, no-var, one-var, prefer-rest-params, max-len, vars-on-top, wrap-iife, consistent-return, comma-dangle, one-var-declaration-per-line, quotes, no-return-assign, prefer-arrow-callback, prefer-template, no-shadow, no-else-return, max-len, object-shorthand */


(function () {
  this.NewBranchForm = function () {
    function NewBranchForm(form, availableRefs) {
      this.validate = this.validate.bind(this);
      this.branchNameError = form.find('.js-branch-name-error');
      this.name = form.find('.js-branch-name');
      this.ref = form.find('#ref');
      new __WEBPACK_IMPORTED_MODULE_0__ref_select_dropdown__["a" /* default */]($('.js-branch-select'), availableRefs); // eslint-disable-line no-new
      this.setupRestrictions();
      this.addBinding();
      this.init();
    }

    NewBranchForm.prototype.addBinding = function () {
      return this.name.on('blur', this.validate);
    };

    NewBranchForm.prototype.init = function () {
      if (this.name.length && this.name.val().length > 0) {
        return this.name.trigger('blur');
      }
    };

    NewBranchForm.prototype.setupRestrictions = function () {
      var endsWith, invalid, single, startsWith;
      startsWith = {
        pattern: /^(\/|\.)/g,
        prefix: "can't start with",
        conjunction: "or"
      };
      endsWith = {
        pattern: /(\/|\.|\.lock)$/g,
        prefix: "can't end in",
        conjunction: "or"
      };
      invalid = {
        pattern: /(\s|~|\^|:|\?|\*|\[|\\|\.\.|@\{|\/{2,}){1}/g,
        prefix: "can't contain",
        conjunction: ", "
      };
      single = {
        pattern: /^@+$/g,
        prefix: "can't be",
        conjunction: "or"
      };
      return this.restrictions = [startsWith, invalid, endsWith, single];
    };

    NewBranchForm.prototype.validate = function () {
      var errorMessage, errors, formatter, unique, validator;
      var indexOf = [].indexOf;

      this.branchNameError.empty();
      unique = function unique(values, value) {
        if (indexOf.call(values, value) === -1) {
          values.push(value);
        }
        return values;
      };
      formatter = function formatter(values, restriction) {
        var formatted;
        formatted = values.map(function (value) {
          switch (false) {
            case !/\s/.test(value):
              return 'spaces';
            case !/\/{2,}/g.test(value):
              return 'consecutive slashes';
            default:
              return "'" + value + "'";
          }
        });
        return restriction.prefix + " " + formatted.join(restriction.conjunction);
      };
      validator = function (_this) {
        return function (errors, restriction) {
          var matched;
          matched = _this.name.val().match(restriction.pattern);
          if (matched) {
            return errors.concat(formatter(matched.reduce(unique, []), restriction));
          } else {
            return errors;
          }
        };
      }(this);
      errors = this.restrictions.reduce(validator, []);
      if (errors.length > 0) {
        errorMessage = $("<span/>").text(errors.join(', '));
        return this.branchNameError.append(errorMessage);
      }
    };

    return NewBranchForm;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./new_commit_form.js":
/***/ (function(module, exports) {

/* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, no-return-assign, max-len */
(function () {
  this.NewCommitForm = function () {
    function NewCommitForm(form) {
      this.form = form;
      this.renderDestination = this.renderDestination.bind(this);
      this.branchName = form.find('.js-branch-name');
      this.originalBranch = form.find('.js-original-branch');
      this.createMergeRequest = form.find('.js-create-merge-request');
      this.createMergeRequestContainer = form.find('.js-create-merge-request-container');
      this.branchName.keyup(this.renderDestination);
      this.renderDestination();
    }

    NewCommitForm.prototype.renderDestination = function () {
      var different;
      different = this.branchName.val() !== this.originalBranch.val();
      if (different) {
        this.createMergeRequestContainer.show();
        if (!this.wasDifferent) {
          this.createMergeRequest.prop('checked', true);
        }
      } else {
        this.createMergeRequestContainer.hide();
        this.createMergeRequest.prop('checked', false);
      }
      return this.wasDifferent = different;
    };

    return NewCommitForm;
  }();
}).call(window);

/***/ }),

/***/ "./new_sidebar.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__breakpoints__ = __webpack_require__("./breakpoints.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var NewNavSidebar = function () {
  function NewNavSidebar() {
    _classCallCheck(this, NewNavSidebar);

    this.initDomElements();
    this.render();
  }

  _createClass(NewNavSidebar, [{
    key: 'initDomElements',
    value: function initDomElements() {
      this.$page = $('.page-with-sidebar');
      this.$sidebar = $('.nav-sidebar');
      this.$innerScroll = $('.nav-sidebar-inner-scroll', this.$sidebar);
      this.$overlay = $('.mobile-overlay');
      this.$openSidebar = $('.toggle-mobile-nav');
      this.$closeSidebar = $('.close-nav-button');
      this.$sidebarToggle = $('.js-toggle-sidebar');
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      var _this = this;

      document.addEventListener('click', function (e) {
        if (!e.target.closest('.nav-sidebar') && (__WEBPACK_IMPORTED_MODULE_2__breakpoints__["a" /* default */].getBreakpointSize() === 'sm' || __WEBPACK_IMPORTED_MODULE_2__breakpoints__["a" /* default */].getBreakpointSize() === 'md')) {
          _this.toggleCollapsedSidebar(true);
        }
      });
      this.$openSidebar.on('click', function () {
        return _this.toggleSidebarNav(true);
      });
      this.$closeSidebar.on('click', function () {
        return _this.toggleSidebarNav(false);
      });
      this.$overlay.on('click', function () {
        return _this.toggleSidebarNav(false);
      });
      this.$sidebarToggle.on('click', function () {
        var value = !_this.$sidebar.hasClass('sidebar-icons-only');
        _this.toggleCollapsedSidebar(value);
      });

      $(window).on('resize', function () {
        return __WEBPACK_IMPORTED_MODULE_1_underscore___default.a.debounce(_this.render(), 100);
      });
    }
  }, {
    key: 'toggleSidebarNav',
    value: function toggleSidebarNav(show) {
      this.$sidebar.toggleClass('nav-sidebar-expanded', show);
      this.$overlay.toggleClass('mobile-nav-open', show);
      this.$sidebar.removeClass('sidebar-icons-only');
    }
  }, {
    key: 'toggleCollapsedSidebar',
    value: function toggleCollapsedSidebar(collapsed) {
      var breakpoint = __WEBPACK_IMPORTED_MODULE_2__breakpoints__["a" /* default */].getBreakpointSize();

      if (this.$sidebar.length) {
        this.$sidebar.toggleClass('sidebar-icons-only', collapsed);
        this.$page.toggleClass('page-with-icon-sidebar', breakpoint === 'sm' ? true : collapsed);
      }
      NewNavSidebar.setCollapsedCookie(collapsed);

      this.toggleSidebarOverflow();
    }
  }, {
    key: 'toggleSidebarOverflow',
    value: function toggleSidebarOverflow() {
      if (this.$innerScroll.prop('scrollHeight') > this.$innerScroll.prop('offsetHeight')) {
        this.$innerScroll.css('overflow-y', 'scroll');
      } else {
        this.$innerScroll.css('overflow-y', '');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var breakpoint = __WEBPACK_IMPORTED_MODULE_2__breakpoints__["a" /* default */].getBreakpointSize();

      if (breakpoint === 'sm' || breakpoint === 'md') {
        this.toggleCollapsedSidebar(true);
      } else if (breakpoint === 'lg') {
        var collapse = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('sidebar_collapsed') === 'true';
        this.toggleCollapsedSidebar(collapse);
      }
    }
  }], [{
    key: 'setCollapsedCookie',
    value: function setCollapsedCookie(value) {
      if (__WEBPACK_IMPORTED_MODULE_2__breakpoints__["a" /* default */].getBreakpointSize() !== 'lg') {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('sidebar_collapsed', value, { expires: 365 * 10 });
    }
  }]);

  return NewNavSidebar;
}();

/* harmony default export */ __webpack_exports__["a"] = (NewNavSidebar);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./notes.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("../../../node_modules/jquery/dist/jquery.js");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/underscore/underscore.js
var underscore = __webpack_require__("../../../node_modules/underscore/underscore.js");
var underscore_default = /*#__PURE__*/__webpack_require__.n(underscore);

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/vendor/assets/javascripts/autosize.js
var autosize = __webpack_require__("../../../vendor/assets/javascripts/autosize.js");
var autosize_default = /*#__PURE__*/__webpack_require__.n(autosize);

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/dropzone/dist/dropzone.js
var dropzone = __webpack_require__("../../../node_modules/dropzone/dist/dropzone.js");
var dropzone_default = /*#__PURE__*/__webpack_require__.n(dropzone);

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/vendor/assets/javascripts/jquery.caret.js
var jquery_caret = __webpack_require__("../../../vendor/assets/javascripts/jquery.caret.js");
var jquery_caret_default = /*#__PURE__*/__webpack_require__.n(jquery_caret);

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/vendor/assets/javascripts/jquery.atwho.js
var jquery_atwho = __webpack_require__("../../../vendor/assets/javascripts/jquery.atwho.js");
var jquery_atwho_default = /*#__PURE__*/__webpack_require__.n(jquery_atwho);

// EXTERNAL MODULE: ./lib/utils/ajax_cache.js
var ajax_cache = __webpack_require__("./lib/utils/ajax_cache.js");

// EXTERNAL MODULE: ./droplab/drop_lab.js + 7 modules
var drop_lab = __webpack_require__("./droplab/drop_lab.js");

// EXTERNAL MODULE: ./droplab/plugins/input_setter.js
var input_setter = __webpack_require__("./droplab/plugins/input_setter.js");

// CONCATENATED MODULE: ./comment_type_toggle.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




// Todo: Remove this when fixing issue in input_setter plugin
var InputSetter = Object.assign({}, input_setter["a" /* default */]);

var comment_type_toggle_CommentTypeToggle = function () {
  function CommentTypeToggle() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, CommentTypeToggle);

    this.dropdownTrigger = opts.dropdownTrigger;
    this.dropdownList = opts.dropdownList;
    this.noteTypeInput = opts.noteTypeInput;
    this.submitButton = opts.submitButton;
    this.closeButton = opts.closeButton;
    this.reopenButton = opts.reopenButton;
  }

  _createClass(CommentTypeToggle, [{
    key: 'initDroplab',
    value: function initDroplab() {
      this.droplab = new drop_lab["a" /* default */]();

      var config = this.setConfig();

      this.droplab.init(this.dropdownTrigger, this.dropdownList, [InputSetter], config);
    }
  }, {
    key: 'setConfig',
    value: function setConfig() {
      var config = {
        InputSetter: [{
          input: this.noteTypeInput,
          valueAttribute: 'data-value'
        }, {
          input: this.submitButton,
          valueAttribute: 'data-submit-text'
        }]
      };

      if (this.closeButton) {
        config.InputSetter.push({
          input: this.closeButton,
          valueAttribute: 'data-close-text'
        }, {
          input: this.closeButton,
          valueAttribute: 'data-close-text',
          inputAttribute: 'data-alternative-text'
        });
      }

      if (this.reopenButton) {
        config.InputSetter.push({
          input: this.reopenButton,
          valueAttribute: 'data-reopen-text'
        }, {
          input: this.reopenButton,
          valueAttribute: 'data-reopen-text',
          inputAttribute: 'data-alternative-text'
        });
      }

      return config;
    }
  }]);

  return CommentTypeToggle;
}();

/* harmony default export */ var comment_type_toggle = (comment_type_toggle_CommentTypeToggle);
// EXTERNAL MODULE: ./awards_handler.js
var awards_handler = __webpack_require__("./awards_handler.js");

// EXTERNAL MODULE: ./autosave.js
var autosave = __webpack_require__("./autosave.js");

// EXTERNAL MODULE: ./dropzone_input.js
var dropzone_input = __webpack_require__("./dropzone_input.js");

// EXTERNAL MODULE: ./task_list.js
var task_list = __webpack_require__("./task_list.js");

// EXTERNAL MODULE: ./lib/utils/common_utils.js
var common_utils = __webpack_require__("./lib/utils/common_utils.js");

// EXTERNAL MODULE: ./image_diff/helpers/index.js + 6 modules
var helpers = __webpack_require__("./image_diff/helpers/index.js");

// CONCATENATED MODULE: ./notes.js
var notes__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function notes__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-restricted-properties, func-names, space-before-function-paren,
no-var, prefer-rest-params, wrap-iife, no-use-before-define, camelcase,
no-unused-expressions, quotes, max-len, one-var, one-var-declaration-per-line,
default-case, prefer-template, consistent-return, no-alert, no-return-assign,
no-param-reassign, prefer-arrow-callback, no-else-return, comma-dangle, no-new,
brace-style, no-lonely-if, vars-on-top, no-unused-vars, no-sequences, no-shadow,
newline-per-chained-call, no-useless-escape, class-methods-use-this */
/* global Flash */
/* global Autosave */
/* global ResolveService */
/* global mrRefreshWidgetUrl */






 // required by jquery.atwho










window.autosize = autosize_default.a;
window.Dropzone = dropzone_default.a;

function normalizeNewlines(str) {
  return str.replace(/\r\n/g, '\n');
}

var MAX_VISIBLE_COMMIT_LIST_COUNT = 3;
var REGEX_QUICK_ACTIONS = /^\/\w+.*$/gm;

var notes_Notes = function () {
  function Notes(notes_url, note_ids, last_fetched_at, view) {
    var enableGFM = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

    notes__classCallCheck(this, Notes);

    this.updateTargetButtons = this.updateTargetButtons.bind(this);
    this.updateComment = this.updateComment.bind(this);
    this.visibilityChange = this.visibilityChange.bind(this);
    this.cancelDiscussionForm = this.cancelDiscussionForm.bind(this);
    this.onAddDiffNote = this.onAddDiffNote.bind(this);
    this.onAddImageDiffNote = this.onAddImageDiffNote.bind(this);
    this.setupDiscussionNoteForm = this.setupDiscussionNoteForm.bind(this);
    this.onReplyToDiscussionNote = this.onReplyToDiscussionNote.bind(this);
    this.removeNote = this.removeNote.bind(this);
    this.cancelEdit = this.cancelEdit.bind(this);
    this.updateNote = this.updateNote.bind(this);
    this.addDiscussionNote = this.addDiscussionNote.bind(this);
    this.addNoteError = this.addNoteError.bind(this);
    this.addNote = this.addNote.bind(this);
    this.resetMainTargetForm = this.resetMainTargetForm.bind(this);
    this.refresh = this.refresh.bind(this);
    this.keydownNoteText = this.keydownNoteText.bind(this);
    this.toggleCommitList = this.toggleCommitList.bind(this);
    this.postComment = this.postComment.bind(this);
    this.clearFlashWrapper = this.clearFlash.bind(this);
    this.onHashChange = this.onHashChange.bind(this);

    this.notes_url = notes_url;
    this.note_ids = note_ids;
    this.enableGFM = enableGFM;
    // Used to keep track of updated notes while people are editing things
    this.updatedNotesTrackingMap = {};
    this.last_fetched_at = last_fetched_at;
    this.noteable_url = document.URL;
    this.notesCountBadge || (this.notesCountBadge = jquery_default()('.issuable-details').find('.notes-tab .badge'));
    this.basePollingInterval = 15000;
    this.maxPollingSteps = 4;

    this.cleanBinding();
    this.addBinding();
    this.setPollingInterval();
    this.setupMainTargetNoteForm();
    this.taskList = new task_list["a" /* default */]({
      dataType: 'note',
      fieldName: 'note',
      selector: '.notes'
    });
    this.collapseLongCommitList();
    this.setViewType(view);

    // We are in the Merge Requests page so we need another edit form for Changes tab
    if (Object(common_utils["f" /* getPagePath */])(1) === 'merge_requests') {
      jquery_default()('.note-edit-form').clone().addClass('mr-note-edit-form').insertAfter('.note-edit-form');
    }
  }

  notes__createClass(Notes, [{
    key: 'setViewType',
    value: function setViewType(view) {
      this.view = js_cookie_default.a.get('diff_view') || view;
    }
  }, {
    key: 'addBinding',
    value: function addBinding() {
      // Edit note link
      jquery_default()(document).on('click', '.js-note-edit', this.showEditForm.bind(this));
      jquery_default()(document).on('click', '.note-edit-cancel', this.cancelEdit);
      // Reopen and close actions for Issue/MR combined with note form submit
      jquery_default()(document).on('click', '.js-comment-submit-button', this.postComment);
      jquery_default()(document).on('click', '.js-comment-save-button', this.updateComment);
      jquery_default()(document).on('keyup input', '.js-note-text', this.updateTargetButtons);
      // resolve a discussion
      jquery_default()(document).on('click', '.js-comment-resolve-button', this.postComment);
      // remove a note (in general)
      jquery_default()(document).on('click', '.js-note-delete', this.removeNote);
      // delete note attachment
      jquery_default()(document).on('click', '.js-note-attachment-delete', this.removeAttachment);
      // reset main target form when clicking discard
      jquery_default()(document).on('click', '.js-note-discard', this.resetMainTargetForm);
      // update the file name when an attachment is selected
      jquery_default()(document).on('change', '.js-note-attachment-input', this.updateFormAttachment);
      // reply to diff/discussion notes
      jquery_default()(document).on('click', '.js-discussion-reply-button', this.onReplyToDiscussionNote);
      // add diff note
      jquery_default()(document).on('click', '.js-add-diff-note-button', this.onAddDiffNote);
      // add diff note for images
      jquery_default()(document).on('click', '.js-add-image-diff-note-button', this.onAddImageDiffNote);
      // hide diff note form
      jquery_default()(document).on('click', '.js-close-discussion-note-form', this.cancelDiscussionForm);
      // toggle commit list
      jquery_default()(document).on('click', '.system-note-commit-list-toggler', this.toggleCommitList);
      // fetch notes when tab becomes visible
      jquery_default()(document).on('visibilitychange', this.visibilityChange);
      // when issue status changes, we need to refresh data
      jquery_default()(document).on('issuable:change', this.refresh);
      // ajax:events that happen on Form when actions like Reopen, Close are performed on Issues and MRs.
      jquery_default()(document).on('ajax:success', '.js-main-target-form', this.addNote);
      jquery_default()(document).on('ajax:success', '.js-discussion-note-form', this.addDiscussionNote);
      jquery_default()(document).on('ajax:success', '.js-main-target-form', this.resetMainTargetForm);
      jquery_default()(document).on('ajax:complete', '.js-main-target-form', this.reenableTargetFormSubmitButton);
      // when a key is clicked on the notes
      jquery_default()(document).on('keydown', '.js-note-text', this.keydownNoteText);
      // When the URL fragment/hash has changed, `#note_xxx`
      return jquery_default()(window).on('hashchange', this.onHashChange);
    }
  }, {
    key: 'cleanBinding',
    value: function cleanBinding() {
      jquery_default()(document).off('click', '.js-note-edit');
      jquery_default()(document).off('click', '.note-edit-cancel');
      jquery_default()(document).off('click', '.js-note-delete');
      jquery_default()(document).off('click', '.js-note-attachment-delete');
      jquery_default()(document).off('click', '.js-discussion-reply-button');
      jquery_default()(document).off('click', '.js-add-diff-note-button');
      jquery_default()(document).off('click', '.js-add-image-diff-note-button');
      jquery_default()(document).off('visibilitychange');
      jquery_default()(document).off('keyup input', '.js-note-text');
      jquery_default()(document).off('click', '.js-note-target-reopen');
      jquery_default()(document).off('click', '.js-note-target-close');
      jquery_default()(document).off('click', '.js-note-discard');
      jquery_default()(document).off('keydown', '.js-note-text');
      jquery_default()(document).off('click', '.js-comment-resolve-button');
      jquery_default()(document).off('click', '.system-note-commit-list-toggler');
      jquery_default()(document).off('ajax:success', '.js-main-target-form');
      jquery_default()(document).off('ajax:success', '.js-discussion-note-form');
      jquery_default()(document).off('ajax:complete', '.js-main-target-form');
      jquery_default()(window).off('hashchange', this.onHashChange);
    }
  }, {
    key: 'keydownNoteText',
    value: function keydownNoteText(e) {
      var $textarea, discussionNoteForm, editNote, myLastNote, myLastNoteEditBtn, newText, originalText;
      if (Object(common_utils["q" /* isMetaKey */])(e)) {
        return;
      }

      $textarea = jquery_default()(e.target);
      // Edit previous note when UP arrow is hit
      switch (e.which) {
        case 38:
          if ($textarea.val() !== '') {
            return;
          }
          myLastNote = jquery_default()('li.note[data-author-id=\'' + gon.current_user_id + '\'][data-editable]:last', $textarea.closest('.note, .notes_holder, #notes'));
          if (myLastNote.length) {
            myLastNoteEditBtn = myLastNote.find('.js-note-edit');
            return myLastNoteEditBtn.trigger('click', [true, myLastNote]);
          }
          break;
        // Cancel creating diff note or editing any note when ESCAPE is hit
        case 27:
          discussionNoteForm = $textarea.closest('.js-discussion-note-form');
          if (discussionNoteForm.length) {
            if ($textarea.val() !== '') {
              if (!confirm('Are you sure you want to cancel creating this comment?')) {
                return;
              }
            }
            this.removeDiscussionNoteForm(discussionNoteForm);
            return;
          }
          editNote = $textarea.closest('.note');
          if (editNote.length) {
            originalText = $textarea.closest('form').data('original-note');
            newText = $textarea.val();
            if (originalText !== newText) {
              if (!confirm('Are you sure you want to cancel editing this comment?')) {
                return;
              }
            }
            return this.removeNoteEditForm(editNote);
          }
      }
    }
  }, {
    key: 'initRefresh',
    value: function initRefresh() {
      if (Notes.interval) {
        clearInterval(Notes.interval);
      }
      return Notes.interval = setInterval(function (_this) {
        return function () {
          return _this.refresh();
        };
      }(this), this.pollingInterval);
    }
  }, {
    key: 'refresh',
    value: function refresh() {
      if (!document.hidden) {
        return this.getContent();
      }
    }
  }, {
    key: 'getContent',
    value: function getContent() {
      if (this.refreshing) {
        return;
      }
      this.refreshing = true;
      return jquery_default.a.ajax({
        url: this.notes_url,
        headers: { 'X-Last-Fetched-At': this.last_fetched_at },
        dataType: 'json',
        success: function (_this) {
          return function (data) {
            var notes;
            notes = data.notes;
            _this.last_fetched_at = data.last_fetched_at;
            _this.setPollingInterval(data.notes.length);
            return jquery_default.a.each(notes, function (i, note) {
              _this.renderNote(note);
            });
          };
        }(this)
      }).always(function (_this) {
        return function () {
          return _this.refreshing = false;
        };
      }(this));
    }

    /**
     * Increase @pollingInterval up to 120 seconds on every function call,
     * if `shouldReset` has a truthy value, 'null' or 'undefined' the variable
     * will reset to @basePollingInterval.
     *
     * Note: this function is used to gradually increase the polling interval
     * if there aren't new notes coming from the server
     */

  }, {
    key: 'setPollingInterval',
    value: function setPollingInterval(shouldReset) {
      var nthInterval;
      if (shouldReset == null) {
        shouldReset = true;
      }
      nthInterval = this.basePollingInterval * Math.pow(2, this.maxPollingSteps - 1);
      if (shouldReset) {
        this.pollingInterval = this.basePollingInterval;
      } else if (this.pollingInterval < nthInterval) {
        this.pollingInterval *= 2;
      }
      return this.initRefresh();
    }
  }, {
    key: 'handleQuickActions',
    value: function handleQuickActions(noteEntity) {
      var votesBlock;
      if (noteEntity.commands_changes) {
        if ('merge' in noteEntity.commands_changes) {
          Notes.checkMergeRequestStatus();
        }

        if ('emoji_award' in noteEntity.commands_changes) {
          votesBlock = jquery_default()('.js-awards-block').eq(0);

          Object(awards_handler["a" /* default */])().then(function (awardsHandler) {
            awardsHandler.addAwardToEmojiBar(votesBlock, noteEntity.commands_changes.emoji_award);
            awardsHandler.scrollToAwards();
          }).catch(function () {
            // ignore
          });
        }
      }
    }
  }, {
    key: 'setupNewNote',
    value: function setupNewNote($note) {
      // Update datetime format on the recent note
      gl.utils.localTimeAgo($note.find('.js-timeago'), false);

      this.collapseLongCommitList();
      this.taskList.init();

      // This stops the note highlight, #note_xxx`, from being removed after real time update
      // The `:target` selector does not re-evaluate after we replace element in the DOM
      Notes.updateNoteTargetSelector($note);
      this.$noteToCleanHighlight = $note;
    }
  }, {
    key: 'onHashChange',
    value: function onHashChange() {
      if (this.$noteToCleanHighlight) {
        Notes.updateNoteTargetSelector(this.$noteToCleanHighlight);
      }

      this.$noteToCleanHighlight = null;
    }
  }, {
    key: 'renderNote',


    /**
     * Render note in main comments area.
     *
     * Note: for rendering inline notes use renderDiscussionNote
     */
    value: function renderNote(noteEntity, $form) {
      var $notesList = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : jquery_default()('.main-notes-list');

      if (noteEntity.discussion_html) {
        return this.renderDiscussionNote(noteEntity, $form);
      }

      if (!noteEntity.valid) {
        if (noteEntity.errors.commands_only) {
          if (noteEntity.commands_changes && Object.keys(noteEntity.commands_changes).length > 0) {
            $notesList.find('.system-note.being-posted').remove();
          }
          this.addFlash(noteEntity.errors.commands_only, 'notice', this.parentTimeline);
          this.refresh();
        }
        return;
      }

      var $note = $notesList.find('#note_' + noteEntity.id);
      if (Notes.isNewNote(noteEntity, this.note_ids)) {
        this.note_ids.push(noteEntity.id);

        if ($notesList.length) {
          $notesList.find('.system-note.being-posted').remove();
        }
        var $newNote = Notes.animateAppendNote(noteEntity.html, $notesList);

        this.setupNewNote($newNote);
        this.refresh();
        return this.updateNotesCount(1);
      }
      // The server can send the same update multiple times so we need to make sure to only update once per actual update.
      else if (Notes.isUpdatedNote(noteEntity, $note)) {
          var isEditing = $note.hasClass('is-editing');
          var initialContent = normalizeNewlines($note.find('.original-note-content').text().trim());
          var $textarea = $note.find('.js-note-text');
          var currentContent = $textarea.val();
          // There can be CRLF vs LF mismatches if we don't sanitize and compare the same way
          var sanitizedNoteNote = normalizeNewlines(noteEntity.note);
          var isTextareaUntouched = currentContent === initialContent || currentContent === sanitizedNoteNote;

          if (isEditing && isTextareaUntouched) {
            $textarea.val(noteEntity.note);
            this.updatedNotesTrackingMap[noteEntity.id] = noteEntity;
          } else if (isEditing && !isTextareaUntouched) {
            this.putConflictEditWarningInPlace(noteEntity, $note);
            this.updatedNotesTrackingMap[noteEntity.id] = noteEntity;
          } else {
            var $updatedNote = Notes.animateUpdateNote(noteEntity.html, $note);
            this.setupNewNote($updatedNote);
          }
        }
    }
  }, {
    key: 'isParallelView',
    value: function isParallelView() {
      return js_cookie_default.a.get('diff_view') === 'parallel';
    }

    /**
     * Render note in discussion area.
     *
     * Note: for rendering inline notes use renderDiscussionNote
     */

  }, {
    key: 'renderDiscussionNote',
    value: function renderDiscussionNote(noteEntity, $form) {
      var discussionContainer, form, row, lineType, diffAvatarContainer;
      if (!Notes.isNewNote(noteEntity, this.note_ids)) {
        return;
      }
      this.note_ids.push(noteEntity.id);
      form = $form || jquery_default()('.js-discussion-note-form[data-discussion-id="' + noteEntity.discussion_id + '"]');
      row = form.closest('tr');

      if (noteEntity.on_image) {
        row = form;
      }

      lineType = this.isParallelView() ? form.find('#line_type').val() : 'old';
      diffAvatarContainer = row.prevAll('.line_holder').first().find('.js-avatar-container.' + lineType + '_line');
      // is this the first note of discussion?
      discussionContainer = jquery_default()('.notes[data-discussion-id="' + noteEntity.discussion_id + '"]');
      if (!discussionContainer.length) {
        discussionContainer = form.closest('.discussion').find('.notes');
      }
      if (discussionContainer.length === 0) {
        if (noteEntity.diff_discussion_html) {
          var $discussion = jquery_default()(noteEntity.diff_discussion_html).renderGFM();

          if (!this.isParallelView() || row.hasClass('js-temp-notes-holder') || noteEntity.on_image) {
            // insert the note and the reply button after the temp row
            row.after($discussion);
          } else {
            // Merge new discussion HTML in
            var $notes = $discussion.find('.notes[data-discussion-id="' + noteEntity.discussion_id + '"]');
            var contentContainerClass = '.' + $notes.closest('.notes_content').attr('class').split(' ').join('.');

            row.find(contentContainerClass + ' .content').append($notes.closest('.content').children());
          }
        }
        // Init discussion on 'Discussion' page if it is merge request page
        var page = jquery_default()('body').attr('data-page');
        if (page && page.indexOf('projects:merge_request') !== -1 || !noteEntity.diff_discussion_html) {
          Notes.animateAppendNote(noteEntity.discussion_html, jquery_default()('.main-notes-list'));
        }
      } else {
        // append new note to all matching discussions
        Notes.animateAppendNote(noteEntity.html, discussionContainer);
      }

      if (typeof gl.diffNotesCompileComponents !== 'undefined' && noteEntity.discussion_resolvable) {
        gl.diffNotesCompileComponents();

        this.renderDiscussionAvatar(diffAvatarContainer, noteEntity);
      }

      gl.utils.localTimeAgo(jquery_default()('.js-timeago'), false);
      Notes.checkMergeRequestStatus();
      return this.updateNotesCount(1);
    }
  }, {
    key: 'getLineHolder',
    value: function getLineHolder(changesDiscussionContainer) {
      return jquery_default()(changesDiscussionContainer).closest('.notes_holder').prevAll('.line_holder').first().get(0);
    }
  }, {
    key: 'renderDiscussionAvatar',
    value: function renderDiscussionAvatar(diffAvatarContainer, noteEntity) {
      var avatarHolder = diffAvatarContainer.find('.diff-comment-avatar-holders');

      if (!avatarHolder.length) {
        avatarHolder = document.createElement('diff-note-avatars');
        avatarHolder.setAttribute('discussion-id', noteEntity.discussion_id);

        diffAvatarContainer.append(avatarHolder);

        gl.diffNotesCompileComponents();
      }
    }

    /**
     * Called in response the main target form has been successfully submitted.
     *
     * Removes any errors.
     * Resets text and preview.
     * Resets buttons.
     */

  }, {
    key: 'resetMainTargetForm',
    value: function resetMainTargetForm(e) {
      var form;
      form = jquery_default()('.js-main-target-form');
      // remove validation errors
      form.find('.js-errors').remove();
      // reset text and preview
      form.find('.js-md-write-button').click();
      form.find('.js-note-text').val('').trigger('input');
      form.find('.js-note-text').data('autosave').reset();

      var event = document.createEvent('Event');
      event.initEvent('autosize:update', true, false);
      form.find('.js-autosize')[0].dispatchEvent(event);

      this.updateTargetButtons(e);
    }
  }, {
    key: 'reenableTargetFormSubmitButton',
    value: function reenableTargetFormSubmitButton() {
      var form;
      form = jquery_default()('.js-main-target-form');
      return form.find('.js-note-text').trigger('input');
    }

    /**
     * Shows the main form and does some setup on it.
     *
     * Sets some hidden fields in the form.
     */

  }, {
    key: 'setupMainTargetNoteForm',
    value: function setupMainTargetNoteForm() {
      var form;
      // find the form
      form = jquery_default()('.js-new-note-form');
      // Set a global clone of the form for later cloning
      this.formClone = form.clone();
      // show the form
      this.setupNoteForm(form);
      // fix classes
      form.removeClass('js-new-note-form');
      form.addClass('js-main-target-form');
      form.find('#note_line_code').remove();
      form.find('#note_position').remove();
      form.find('#note_type').val('');
      form.find('#note_project_id').remove();
      form.find('#in_reply_to_discussion_id').remove();
      form.find('.js-comment-resolve-button').closest('comment-and-resolve-btn').remove();
      this.parentTimeline = form.parents('.timeline');

      if (form.length) {
        Notes.initCommentTypeToggle(form.get(0));
      }
    }

    /**
     * General note form setup.
     *
     * deactivates the submit button when text is empty
     * hides the preview button when text is empty
     * setup GFM auto complete
     * show the form
     */

  }, {
    key: 'setupNoteForm',
    value: function setupNoteForm(form) {
      var textarea, key;
      new gl.GLForm(form, this.enableGFM);
      textarea = form.find('.js-note-text');
      key = ['Note', form.find('#note_noteable_type').val(), form.find('#note_noteable_id').val(), form.find('#note_commit_id').val(), form.find('#note_type').val(), form.find('#note_project_id').val(), form.find('#in_reply_to_discussion_id').val(),

      // LegacyDiffNote
      form.find('#note_line_code').val(),

      // DiffNote
      form.find('#note_position').val()];
      return new Autosave(textarea, key);
    }

    /**
     * Called in response to the new note form being submitted
     *
     * Adds new note to list.
     */

  }, {
    key: 'addNote',
    value: function addNote($form, note) {
      return this.renderNote(note);
    }
  }, {
    key: 'addNoteError',
    value: function addNoteError($form) {
      var formParentTimeline = void 0;
      if ($form.hasClass('js-main-target-form')) {
        formParentTimeline = $form.parents('.timeline');
      } else if ($form.hasClass('js-discussion-note-form')) {
        formParentTimeline = $form.closest('.discussion-notes').find('.notes');
      }
      return this.addFlash('Your comment could not be submitted! Please check your network connection and try again.', 'alert', formParentTimeline);
    }
  }, {
    key: 'updateNoteError',
    value: function updateNoteError($parentTimeline) {
      new Flash('Your comment could not be updated! Please check your network connection and try again.');
    }

    /**
     * Called in response to the new note form being submitted
     *
     * Adds new note to list.
     */

  }, {
    key: 'addDiscussionNote',
    value: function addDiscussionNote($form, note, isNewDiffComment) {
      if ($form.attr('data-resolve-all') != null) {
        var projectPath = $form.data('project-path');
        var discussionId = $form.data('discussion-id');
        var mergeRequestId = $form.data('noteable-iid');

        if (ResolveService != null) {
          ResolveService.toggleResolveForDiscussion(mergeRequestId, discussionId);
        }
      }

      this.renderNote(note, $form);
      // cleanup after successfully creating a diff/discussion note
      if (isNewDiffComment) {
        this.removeDiscussionNoteForm($form);
      }
    }

    /**
     * Called in response to the edit note form being submitted
     *
     * Updates the current note field.
     */

  }, {
    key: 'updateNote',
    value: function updateNote(noteEntity, $targetNote) {
      var $noteEntityEl, $note_li;
      // Convert returned HTML to a jQuery object so we can modify it further
      $noteEntityEl = jquery_default()(noteEntity.html);
      $noteEntityEl.addClass('fade-in-full');
      this.revertNoteEditForm($targetNote);
      $noteEntityEl.renderGFM();
      // Find the note's `li` element by ID and replace it with the updated HTML
      $note_li = jquery_default()('.note-row-' + noteEntity.id);

      $note_li.replaceWith($noteEntityEl);
      this.setupNewNote($noteEntityEl);

      if (typeof gl.diffNotesCompileComponents !== 'undefined') {
        gl.diffNotesCompileComponents();
      }
    }
  }, {
    key: 'checkContentToAllowEditing',
    value: function checkContentToAllowEditing($el) {
      var initialContent = $el.find('.original-note-content').text().trim();
      var currentContent = $el.find('.js-note-text').val();
      var isAllowed = true;

      if (currentContent === initialContent) {
        this.removeNoteEditForm($el);
      } else {
        var $buttons = $el.find('.note-form-actions');
        var isWidgetVisible = Object(common_utils["o" /* isInViewport */])($el.get(0));

        if (!isWidgetVisible) {
          Object(common_utils["x" /* scrollToElement */])($el);
        }

        $el.find('.js-finish-edit-warning').show();
        isAllowed = false;
      }

      return isAllowed;
    }

    /**
     * Called in response to clicking the edit note link
     *
     * Replaces the note text with the note edit form
     * Adds a data attribute to the form with the original content of the note for cancellations
     */

  }, {
    key: 'showEditForm',
    value: function showEditForm(e, scrollTo, myLastNote) {
      e.preventDefault();

      var $target = jquery_default()(e.target);
      var $editForm = jquery_default()(this.getEditFormSelector($target));
      var $note = $target.closest('.note');
      var $currentlyEditing = jquery_default()('.note.is-editing:visible');

      if ($currentlyEditing.length) {
        var isEditAllowed = this.checkContentToAllowEditing($currentlyEditing);

        if (!isEditAllowed) {
          return;
        }
      }

      $note.find('.js-note-attachment-delete').show();
      $editForm.addClass('current-note-edit-form');
      $note.addClass('is-editing');
      this.putEditFormInPlace($target);
    }

    /**
     * Called in response to clicking the edit note link
     *
     * Hides edit form and restores the original note text to the editor textarea.
     */

  }, {
    key: 'cancelEdit',
    value: function cancelEdit(e) {
      e.preventDefault();
      var $target = jquery_default()(e.target);
      var $note = $target.closest('.note');
      var noteId = $note.attr('data-note-id');

      this.revertNoteEditForm($target);

      if (this.updatedNotesTrackingMap[noteId]) {
        var $newNote = jquery_default()(this.updatedNotesTrackingMap[noteId].html);
        $note.replaceWith($newNote);
        this.setupNewNote($newNote);
        // Now that we have taken care of the update, clear it out
        delete this.updatedNotesTrackingMap[noteId];
      } else {
        $note.find('.js-finish-edit-warning').hide();
        this.removeNoteEditForm($note);
      }
    }
  }, {
    key: 'revertNoteEditForm',
    value: function revertNoteEditForm($target) {
      $target = $target || jquery_default()('.note.is-editing:visible');
      var selector = this.getEditFormSelector($target);
      var $editForm = jquery_default()(selector);

      $editForm.insertBefore('.notes-form');
      $editForm.find('.js-comment-save-button').enable();
      $editForm.find('.js-finish-edit-warning').hide();
    }
  }, {
    key: 'getEditFormSelector',
    value: function getEditFormSelector($el) {
      var selector = '.note-edit-form:not(.mr-note-edit-form)';

      if ($el.parents('#diffs').length) {
        selector = '.note-edit-form.mr-note-edit-form';
      }

      return selector;
    }
  }, {
    key: 'removeNoteEditForm',
    value: function removeNoteEditForm($note) {
      var form = $note.find('.current-note-edit-form');
      $note.removeClass('is-editing');
      form.removeClass('current-note-edit-form');
      form.find('.js-finish-edit-warning').hide();
      // Replace markdown textarea text with original note text.
      return form.find('.js-note-text').val(form.find('form.edit-note').data('original-note'));
    }

    /**
     * Called in response to deleting a note of any kind.
     *
     * Removes the actual note from view.
     * Removes the whole discussion if the last note is being removed.
     */

  }, {
    key: 'removeNote',
    value: function removeNote(e) {
      var noteElId, noteId, dataNoteId, $note, lineHolder;
      $note = jquery_default()(e.currentTarget).closest('.note');
      noteElId = $note.attr('id');
      noteId = $note.attr('data-note-id');
      lineHolder = jquery_default()(e.currentTarget).closest('.notes[data-discussion-id]').closest('.notes_holder').prev('.line_holder');
      jquery_default()('.note[id="' + noteElId + '"]').each(function (_this) {
        // A same note appears in the "Discussion" and in the "Changes" tab, we have
        // to remove all. Using $('.note[id='noteId']') ensure we get all the notes,
        // where $('#noteId') would return only one.
        return function (i, el) {
          var $note, $notes;
          $note = jquery_default()(el);
          $notes = $note.closest('.discussion-notes');
          var discussionId = jquery_default()('.notes', $notes).data('discussion-id');

          if (typeof gl.diffNotesCompileComponents !== 'undefined') {
            if (gl.diffNoteApps[noteElId]) {
              gl.diffNoteApps[noteElId].$destroy();
            }
          }

          $note.remove();

          // check if this is the last note for this line
          if ($notes.find('.note').length === 0) {
            var notesTr = $notes.closest('tr');

            // "Discussions" tab
            $notes.closest('.timeline-entry').remove();

            jquery_default()('.js-diff-avatars-' + discussionId).trigger('remove.vue');

            // The notes tr can contain multiple lists of notes, like on the parallel diff
            // notesTr does not exist for image diffs
            if (notesTr.find('.discussion-notes').length > 1 || notesTr.length === 0) {
              var $diffFile = $notes.closest('.diff-file');
              if ($diffFile.length > 0) {
                var removeBadgeEvent = new CustomEvent('removeBadge.imageDiff', {
                  detail: {
                    // badgeNumber's start with 1 and index starts with 0
                    badgeNumber: $notes.index() + 1
                  }
                });

                $diffFile[0].dispatchEvent(removeBadgeEvent);
              }

              $notes.remove();
            } else if (notesTr.length > 0) {
              notesTr.remove();
            }
          }
        };
      }(this));

      Notes.checkMergeRequestStatus();
      return this.updateNotesCount(-1);
    }

    /**
     * Called in response to clicking the delete attachment link
     *
     * Removes the attachment wrapper view, including image tag if it exists
     * Resets the note editing form
     */

  }, {
    key: 'removeAttachment',
    value: function removeAttachment() {
      var $note = jquery_default()(this).closest('.note');
      $note.find('.note-attachment').remove();
      $note.find('.note-body > .note-text').show();
      $note.find('.note-header').show();
      return $note.find('.current-note-edit-form').remove();
    }

    /**
     * Called when clicking on the "reply" button for a diff line.
     *
     * Shows the note form below the notes.
     */

  }, {
    key: 'onReplyToDiscussionNote',
    value: function onReplyToDiscussionNote(e) {
      this.replyToDiscussionNote(e.target);
    }
  }, {
    key: 'replyToDiscussionNote',
    value: function replyToDiscussionNote(target) {
      var form, replyLink;
      form = this.cleanForm(this.formClone.clone());
      replyLink = jquery_default()(target).closest('.js-discussion-reply-button');
      // insert the form after the button
      replyLink.closest('.discussion-reply-holder').hide().after(form);
      // show the form
      return this.setupDiscussionNoteForm(replyLink, form);
    }

    /**
     * Shows the diff or discussion form and does some setup on it.
     *
     * Sets some hidden fields in the form.
     *
     * Note: dataHolder must have the "discussionId" and "lineCode" data attributes set.
     */

  }, {
    key: 'setupDiscussionNoteForm',
    value: function setupDiscussionNoteForm(dataHolder, form) {
      // setup note target
      var diffFileData = dataHolder.closest('.text-file');

      if (diffFileData.length === 0) {
        diffFileData = dataHolder.closest('.image');
      }

      var discussionID = dataHolder.data('discussionId');

      if (discussionID) {
        form.attr('data-discussion-id', discussionID);
        form.find('#in_reply_to_discussion_id').val(discussionID);
      }

      form.find('#note_project_id').val(dataHolder.data('discussionProjectId'));

      form.attr('data-line-code', dataHolder.data('lineCode'));
      form.find('#line_type').val(dataHolder.data('lineType'));

      form.find('#note_noteable_type').val(diffFileData.data('noteableType'));
      form.find('#note_noteable_id').val(diffFileData.data('noteableId'));
      form.find('#note_commit_id').val(diffFileData.data('commitId'));

      form.find('#note_type').val(dataHolder.data('noteType'));

      // LegacyDiffNote
      form.find('#note_line_code').val(dataHolder.data('lineCode'));

      // DiffNote
      form.find('#note_position').val(dataHolder.attr('data-position'));

      form.find('.js-note-discard').show().removeClass('js-note-discard').addClass('js-close-discussion-note-form').text(form.find('.js-close-discussion-note-form').data('cancel-text'));
      form.find('.js-note-target-close').remove();
      form.find('.js-note-new-discussion').remove();
      this.setupNoteForm(form);

      form.removeClass('js-main-target-form').addClass('discussion-form js-discussion-note-form');

      if (typeof gl.diffNotesCompileComponents !== 'undefined') {
        var $commentBtn = form.find('comment-and-resolve-btn');
        $commentBtn.attr(':discussion-id', '\'' + discussionID + '\'');

        gl.diffNotesCompileComponents();
      }

      form.find('.js-note-text').focus();
      form.find('.js-comment-resolve-button').attr('data-discussion-id', discussionID);
    }

    /**
     * Called when clicking on the "add a comment" button on the side of a diff line.
     *
     * Inserts a temporary row for the form below the line.
     * Sets up the form and shows it.
     */

  }, {
    key: 'onAddDiffNote',
    value: function onAddDiffNote(e) {
      e.preventDefault();
      var link = e.currentTarget || e.target;
      var $link = jquery_default()(link);
      var showReplyInput = !$link.hasClass('js-diff-comment-avatar');
      this.toggleDiffNote({
        target: $link,
        lineType: link.dataset.lineType,
        showReplyInput: showReplyInput
      });
    }
  }, {
    key: 'onAddImageDiffNote',
    value: function onAddImageDiffNote(e) {
      var $link = jquery_default()(e.currentTarget || e.target);
      var $diffFile = $link.closest('.diff-file');

      var clickEvent = new CustomEvent('click.imageDiff', {
        detail: e
      });

      $diffFile[0].dispatchEvent(clickEvent);

      // Setup comment form
      var newForm = void 0;
      var $noteContainer = $link.closest('.diff-viewer').find('.note-container');
      var $form = $noteContainer.find('> .discussion-form');

      if ($form.length === 0) {
        newForm = this.cleanForm(this.formClone.clone());
        newForm.appendTo($noteContainer);
      } else {
        newForm = $form;
      }

      this.setupDiscussionNoteForm($link, newForm);
    }
  }, {
    key: 'toggleDiffNote',
    value: function toggleDiffNote(_ref) {
      var target = _ref.target,
          lineType = _ref.lineType,
          forceShow = _ref.forceShow,
          _ref$showReplyInput = _ref.showReplyInput,
          showReplyInput = _ref$showReplyInput === undefined ? false : _ref$showReplyInput;

      var $link, addForm, hasNotes, newForm, noteForm, replyButton, row, rowCssToAdd, targetContent, isDiffCommentAvatar;
      $link = jquery_default()(target);
      row = $link.closest('tr');
      var nextRow = row.next();
      var targetRow = row;
      if (nextRow.is('.notes_holder')) {
        targetRow = nextRow;
      }

      hasNotes = nextRow.is('.notes_holder');
      addForm = false;
      var lineTypeSelector = '';
      rowCssToAdd = '<tr class="notes_holder js-temp-notes-holder"><td class="notes_line" colspan="2"></td><td class="notes_content"><div class="content"></div></td></tr>';
      // In parallel view, look inside the correct left/right pane
      if (this.isParallelView()) {
        lineTypeSelector = '.' + lineType;
        rowCssToAdd = '<tr class="notes_holder js-temp-notes-holder"><td class="notes_line old"></td><td class="notes_content parallel old"><div class="content"></div></td><td class="notes_line new"></td><td class="notes_content parallel new"><div class="content"></div></td></tr>';
      }
      var notesContentSelector = '.notes_content' + lineTypeSelector + ' .content';
      var notesContent = targetRow.find(notesContentSelector);

      if (hasNotes && showReplyInput) {
        targetRow.show();
        notesContent = targetRow.find(notesContentSelector);
        if (notesContent.length) {
          notesContent.show();
          replyButton = notesContent.find('.js-discussion-reply-button:visible');
          if (replyButton.length) {
            this.replyToDiscussionNote(replyButton[0]);
          } else {
            // In parallel view, the form may not be present in one of the panes
            noteForm = notesContent.find('.js-discussion-note-form');
            if (noteForm.length === 0) {
              addForm = true;
            }
          }
        }
      } else if (showReplyInput) {
        // add a notes row and insert the form
        row.after(rowCssToAdd);
        targetRow = row.next();
        notesContent = targetRow.find(notesContentSelector);
        addForm = true;
      } else {
        var isCurrentlyShown = targetRow.find('.content:not(:empty)').is(':visible');
        var isForced = forceShow === true || forceShow === false;
        var showNow = forceShow === true || !isCurrentlyShown && !isForced;

        targetRow.toggle(showNow);
        notesContent.toggle(showNow);
      }

      if (addForm) {
        newForm = this.cleanForm(this.formClone.clone());
        newForm.appendTo(notesContent);
        // show the form
        return this.setupDiscussionNoteForm($link, newForm);
      }
    }

    /**
     * Called in response to "cancel" on a diff note form.
     *
     * Shows the reply button again.
     * Removes the form and if necessary it's temporary row.
     */

  }, {
    key: 'removeDiscussionNoteForm',
    value: function removeDiscussionNoteForm(form) {
      var glForm, row;
      row = form.closest('tr');
      glForm = form.data('gl-form');
      glForm.destroy();
      form.find('.js-note-text').data('autosave').reset();
      // show the reply button (will only work for replies)
      form.prev('.discussion-reply-holder').show();
      if (row.is('.js-temp-notes-holder')) {
        // remove temporary row for diff lines
        return row.remove();
      } else {
        // only remove the form
        return form.remove();
      }
    }
  }, {
    key: 'cancelDiscussionForm',
    value: function cancelDiscussionForm(e) {
      e.preventDefault();
      var $form = jquery_default()(e.target).closest('.js-discussion-note-form');
      var $discussionNote = jquery_default()(e.target).closest('.discussion-notes');

      if ($discussionNote.length === 0) {
        // Only send blur event when the discussion form
        // is not part of a discussion note
        var $diffFile = $form.closest('.diff-file');

        if ($diffFile.length > 0) {
          var blurEvent = new CustomEvent('blur.imageDiff', {
            detail: e
          });

          $diffFile[0].dispatchEvent(blurEvent);
        }
      }

      return this.removeDiscussionNoteForm($form);
    }

    /**
     * Called after an attachment file has been selected.
     *
     * Updates the file name for the selected attachment.
     */

  }, {
    key: 'updateFormAttachment',
    value: function updateFormAttachment() {
      var filename, form;
      form = jquery_default()(this).closest('form');
      // get only the basename
      filename = jquery_default()(this).val().replace(/^.*[\\\/]/, '');
      return form.find('.js-attachment-filename').text(filename);
    }

    /**
     * Called when the tab visibility changes
     */

  }, {
    key: 'visibilityChange',
    value: function visibilityChange() {
      return this.refresh();
    }
  }, {
    key: 'updateTargetButtons',
    value: function updateTargetButtons(e) {
      var closebtn, closetext, discardbtn, form, reopenbtn, reopentext, textarea;
      textarea = jquery_default()(e.target);
      form = textarea.parents('form');
      reopenbtn = form.find('.js-note-target-reopen');
      closebtn = form.find('.js-note-target-close');
      discardbtn = form.find('.js-note-discard');

      if (textarea.val().trim().length > 0) {
        reopentext = reopenbtn.attr('data-alternative-text');
        closetext = closebtn.attr('data-alternative-text');
        if (reopenbtn.text() !== reopentext) {
          reopenbtn.text(reopentext);
        }
        if (closebtn.text() !== closetext) {
          closebtn.text(closetext);
        }
        if (reopenbtn.is(':not(.btn-comment-and-reopen)')) {
          reopenbtn.addClass('btn-comment-and-reopen');
        }
        if (closebtn.is(':not(.btn-comment-and-close)')) {
          closebtn.addClass('btn-comment-and-close');
        }
        if (discardbtn.is(':hidden')) {
          return discardbtn.show();
        }
      } else {
        reopentext = reopenbtn.data('original-text');
        closetext = closebtn.data('original-text');
        if (reopenbtn.text() !== reopentext) {
          reopenbtn.text(reopentext);
        }
        if (closebtn.text() !== closetext) {
          closebtn.text(closetext);
        }
        if (reopenbtn.is('.btn-comment-and-reopen')) {
          reopenbtn.removeClass('btn-comment-and-reopen');
        }
        if (closebtn.is('.btn-comment-and-close')) {
          closebtn.removeClass('btn-comment-and-close');
        }
        if (discardbtn.is(':visible')) {
          return discardbtn.hide();
        }
      }
    }
  }, {
    key: 'putEditFormInPlace',
    value: function putEditFormInPlace($el) {
      var $editForm = jquery_default()(this.getEditFormSelector($el));
      var $note = $el.closest('.note');

      $editForm.insertAfter($note.find('.note-text'));

      var $originalContentEl = $note.find('.original-note-content');
      var originalContent = $originalContentEl.text().trim();
      var postUrl = $originalContentEl.data('post-url');
      var targetId = $originalContentEl.data('target-id');
      var targetType = $originalContentEl.data('target-type');

      new gl.GLForm($editForm.find('form'), this.enableGFM);

      $editForm.find('form').attr('action', postUrl).attr('data-remote', 'true');
      $editForm.find('.js-form-target-id').val(targetId);
      $editForm.find('.js-form-target-type').val(targetType);
      $editForm.find('.js-note-text').focus().val(originalContent);
      $editForm.find('.js-md-write-button').trigger('click');
      $editForm.find('.referenced-users').hide();
    }
  }, {
    key: 'putConflictEditWarningInPlace',
    value: function putConflictEditWarningInPlace(noteEntity, $note) {
      if ($note.find('.js-conflict-edit-warning').length === 0) {
        var $alert = jquery_default()('<div class="js-conflict-edit-warning alert alert-danger">\n        This comment has changed since you started editing, please review the\n        <a href="#note_' + noteEntity.id + '" target="_blank" rel="noopener noreferrer">\n          updated comment\n        </a>\n        to ensure information is not lost\n      </div>');
        $alert.insertAfter($note.find('.note-text'));
      }
    }
  }, {
    key: 'updateNotesCount',
    value: function updateNotesCount(updateCount) {
      return this.notesCountBadge.text(parseInt(this.notesCountBadge.text(), 10) + updateCount);
    }
  }, {
    key: 'toggleCommitList',
    value: function toggleCommitList(e) {
      var $element = jquery_default()(e.currentTarget);
      var $closestSystemCommitList = $element.siblings('.system-note-commit-list');

      $element.find('.fa').toggleClass('fa-angle-down').toggleClass('fa-angle-up');
      $closestSystemCommitList.toggleClass('hide-shade');
    }

    /**
     * Scans system notes with `ul` elements in system note body
     * then collapse long commit list pushed by user to make it less
     * intrusive.
     */

  }, {
    key: 'collapseLongCommitList',
    value: function collapseLongCommitList() {
      var systemNotes = jquery_default()('#notes-list').find('li.system-note').has('ul');

      jquery_default.a.each(systemNotes, function (index, systemNote) {
        var $systemNote = jquery_default()(systemNote);
        var headerMessage = $systemNote.find('.note-text').find('p:first').text().replace(':', '');

        $systemNote.find('.note-header .system-note-message').html(headerMessage);

        if ($systemNote.find('li').length > MAX_VISIBLE_COMMIT_LIST_COUNT) {
          $systemNote.find('.note-text').addClass('system-note-commit-list');
          $systemNote.find('.system-note-commit-list-toggler').show();
        } else {
          $systemNote.find('.note-text').addClass('system-note-commit-list hide-shade');
        }
      });
    }
  }, {
    key: 'addFlash',
    value: function addFlash() {
      for (var _len = arguments.length, flashParams = Array(_len), _key = 0; _key < _len; _key++) {
        flashParams[_key] = arguments[_key];
      }

      this.flashInstance = new (Function.prototype.bind.apply(Flash, [null].concat(flashParams)))();
    }
  }, {
    key: 'clearFlash',
    value: function clearFlash() {
      if (this.flashInstance && this.flashInstance.flashContainer) {
        this.flashInstance.flashContainer.hide();
        this.flashInstance = null;
      }
    }
  }, {
    key: 'cleanForm',
    value: function cleanForm($form) {
      // Remove JS classes that are not needed here
      $form.find('.js-comment-type-dropdown').removeClass('btn-group');

      // Remove dropdown
      $form.find('.dropdown-menu').remove();

      return $form;
    }

    /**
     * Check if note does not exists on page
     */

  }, {
    key: 'getFormData',


    /**
     * Get data from Form attributes to use for saving/submitting comment.
     */
    value: function getFormData($form) {
      return {
        formData: $form.serialize(),
        formContent: underscore_default.a.escape($form.find('.js-note-text').val()),
        formAction: $form.attr('action')
      };
    }

    /**
     * Identify if comment has any quick actions
     */

  }, {
    key: 'hasQuickActions',
    value: function hasQuickActions(formContent) {
      return REGEX_QUICK_ACTIONS.test(formContent);
    }

    /**
     * Remove quick actions and leave comment with pure message
     */

  }, {
    key: 'stripQuickActions',
    value: function stripQuickActions(formContent) {
      return formContent.replace(REGEX_QUICK_ACTIONS, '').trim();
    }

    /**
     * Gets appropriate description from quick actions found in provided `formContent`
     */

  }, {
    key: 'getQuickActionDescription',
    value: function getQuickActionDescription(formContent) {
      var availableQuickActions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      var tempFormContent = void 0;

      // Identify executed quick actions from `formContent`
      var executedCommands = availableQuickActions.filter(function (command, index) {
        var commandRegex = new RegExp('/' + command.name);
        return commandRegex.test(formContent);
      });

      if (executedCommands && executedCommands.length) {
        if (executedCommands.length > 1) {
          tempFormContent = 'Applying multiple commands';
        } else {
          var commandDescription = executedCommands[0].description.toLowerCase();
          tempFormContent = 'Applying command to ' + commandDescription;
        }
      } else {
        tempFormContent = 'Applying command';
      }

      return tempFormContent;
    }

    /**
     * Create placeholder note DOM element populated with comment body
     * that we will show while comment is being posted.
     * Once comment is _actually_ posted on server, we will have final element
     * in response that we will show in place of this temporary element.
     */

  }, {
    key: 'createPlaceholderNote',
    value: function createPlaceholderNote(_ref2) {
      var formContent = _ref2.formContent,
          uniqueId = _ref2.uniqueId,
          isDiscussionNote = _ref2.isDiscussionNote,
          currentUsername = _ref2.currentUsername,
          currentUserFullname = _ref2.currentUserFullname,
          currentUserAvatar = _ref2.currentUserAvatar;

      var discussionClass = isDiscussionNote ? 'discussion' : '';
      var $tempNote = jquery_default()('<li id="' + uniqueId + '" class="note being-posted fade-in-half timeline-entry">\n         <div class="timeline-entry-inner">\n            <div class="timeline-icon">\n               <a href="/' + underscore_default.a.escape(currentUsername) + '">\n                 <img class="avatar s40" src="' + currentUserAvatar + '" />\n               </a>\n            </div>\n            <div class="timeline-content ' + discussionClass + '">\n               <div class="note-header">\n                  <div class="note-header-info">\n                     <a href="/' + underscore_default.a.escape(currentUsername) + '">\n                       <span class="hidden-xs">' + underscore_default.a.escape(currentUsername) + '</span>\n                       <span class="note-headline-light">' + underscore_default.a.escape(currentUsername) + '</span>\n                     </a>\n                  </div>\n               </div>\n               <div class="note-body">\n                 <div class="note-text">\n                   <p>' + formContent + '</p>\n                 </div>\n               </div>\n            </div>\n         </div>\n      </li>');

      $tempNote.find('.hidden-xs').text(underscore_default.a.escape(currentUserFullname));
      $tempNote.find('.note-headline-light').text('@' + underscore_default.a.escape(currentUsername));

      return $tempNote;
    }

    /**
     * Create Placeholder System Note DOM element populated with quick action description
     */

  }, {
    key: 'createPlaceholderSystemNote',
    value: function createPlaceholderSystemNote(_ref3) {
      var formContent = _ref3.formContent,
          uniqueId = _ref3.uniqueId;

      var $tempNote = jquery_default()('<li id="' + uniqueId + '" class="note system-note timeline-entry being-posted fade-in-half">\n         <div class="timeline-entry-inner">\n           <div class="timeline-content">\n             <i>' + formContent + '</i>\n           </div>\n         </div>\n       </li>');

      return $tempNote;
    }

    /**
     * This method does following tasks step-by-step whenever a new comment
     * is submitted by user (both main thread comments as well as discussion comments).
     *
     * 1) Get Form metadata
     * 2) Identify comment type; a) Main thread b) Discussion thread c) Discussion resolve
     * 3) Build temporary placeholder element (using `createPlaceholderNote`)
     * 4) Show placeholder note on UI
     * 5) Perform network request to submit the note using `ajaxPost`
     *    a) If request is successfully completed
     *        1. Remove placeholder element
     *        2. Show submitted Note element
     *        3. Perform post-submit errands
     *           a. Mark discussion as resolved if comment submission was for resolve.
     *           b. Reset comment form to original state.
     *    b) If request failed
     *        1. Remove placeholder element
     *        2. Show error Flash message about failure
     */

  }, {
    key: 'postComment',
    value: function postComment(e) {
      var _this2 = this;

      e.preventDefault();

      // Get Form metadata
      var $submitBtn = jquery_default()(e.target);
      var $form = $submitBtn.parents('form');
      var $closeBtn = $form.find('.js-note-target-close');
      var isDiscussionNote = $submitBtn.parent().find('li.droplab-item-selected').attr('id') === 'discussion';
      var isMainForm = $form.hasClass('js-main-target-form');
      var isDiscussionForm = $form.hasClass('js-discussion-note-form');
      var isDiscussionResolve = $submitBtn.hasClass('js-comment-resolve-button');

      var _getFormData = this.getFormData($form),
          formData = _getFormData.formData,
          formContent = _getFormData.formContent,
          formAction = _getFormData.formAction;

      var noteUniqueId = void 0;
      var systemNoteUniqueId = void 0;
      var hasQuickActions = false;
      var $notesContainer = void 0;
      var tempFormContent = void 0;

      // Get reference to notes container based on type of comment
      if (isDiscussionForm) {
        $notesContainer = $form.parent('.discussion-notes').find('.notes');
      } else if (isMainForm) {
        $notesContainer = jquery_default()('ul.main-notes-list');
      }

      // If comment is to resolve discussion, disable submit buttons while
      // comment posting is finished.
      if (isDiscussionResolve) {
        $submitBtn.disable();
        $form.find('.js-comment-submit-button').disable();
      }

      tempFormContent = formContent;
      if (this.hasQuickActions(formContent)) {
        tempFormContent = this.stripQuickActions(formContent);
        hasQuickActions = true;
      }

      // Show placeholder note
      if (tempFormContent) {
        noteUniqueId = underscore_default.a.uniqueId('tempNote_');
        $notesContainer.append(this.createPlaceholderNote({
          formContent: tempFormContent,
          uniqueId: noteUniqueId,
          isDiscussionNote: isDiscussionNote,
          currentUsername: gon.current_username,
          currentUserFullname: gon.current_user_fullname,
          currentUserAvatar: gon.current_user_avatar_url
        }));
      }

      // Show placeholder system note
      if (hasQuickActions) {
        systemNoteUniqueId = underscore_default.a.uniqueId('tempSystemNote_');
        $notesContainer.append(this.createPlaceholderSystemNote({
          formContent: this.getQuickActionDescription(formContent, ajax_cache["a" /* default */].get(gl.GfmAutoComplete.dataSources.commands)),
          uniqueId: systemNoteUniqueId
        }));
      }

      // Clear the form textarea
      if ($notesContainer.length) {
        if (isMainForm) {
          this.resetMainTargetForm(e);
        } else if (isDiscussionForm) {
          this.removeDiscussionNoteForm($form);
        }
      }

      /* eslint-disable promise/catch-or-return */
      // Make request to submit comment on server
      Object(common_utils["b" /* ajaxPost */])(formAction, formData).then(function (note) {
        // Submission successful! remove placeholder
        $notesContainer.find('#' + noteUniqueId).remove();

        var $diffFile = $form.closest('.diff-file');
        if ($diffFile.length > 0) {
          var blurEvent = new CustomEvent('blur.imageDiff', {
            detail: e
          });

          $diffFile[0].dispatchEvent(blurEvent);
        }

        // Reset cached commands list when command is applied
        if (hasQuickActions) {
          $form.find('textarea.js-note-text').trigger('clear-commands-cache.atwho');
        }

        // Clear previous form errors
        _this2.clearFlashWrapper();

        // Check if this was discussion comment
        if (isDiscussionForm) {
          // Remove flash-container
          $notesContainer.find('.flash-container').remove();

          // If comment intends to resolve discussion, do the same.
          if (isDiscussionResolve) {
            $form.attr('data-discussion-id', $submitBtn.data('discussion-id')).attr('data-resolve-all', 'true').attr('data-project-path', $submitBtn.data('project-path'));
          }

          // Show final note element on UI
          var isNewDiffComment = $notesContainer.length === 0;
          _this2.addDiscussionNote($form, note, isNewDiffComment);

          if (isNewDiffComment) {
            // Add image badge, avatar badge and toggle discussion badge for new image diffs
            var notePosition = $form.find('#note_position').val();
            if ($diffFile.length > 0 && notePosition.length > 0) {
              var _JSON$parse = JSON.parse(notePosition),
                  x = _JSON$parse.x,
                  y = _JSON$parse.y,
                  width = _JSON$parse.width,
                  height = _JSON$parse.height;

              var addBadgeEvent = new CustomEvent('addBadge.imageDiff', {
                detail: {
                  x: x,
                  y: y,
                  width: width,
                  height: height,
                  noteId: 'note_' + note.id,
                  discussionId: note.discussion_id
                }
              });

              $diffFile[0].dispatchEvent(addBadgeEvent);
            }
          }

          // append flash-container to the Notes list
          if ($notesContainer.length) {
            $notesContainer.append('<div class="flash-container" style="display: none;"></div>');
          }
        } else if (isMainForm) {
          // Check if this was main thread comment
          // Show final note element on UI and perform form and action buttons cleanup
          _this2.addNote($form, note);
          _this2.reenableTargetFormSubmitButton(e);
        }

        if (note.commands_changes) {
          _this2.handleQuickActions(note);
        }

        $form.trigger('ajax:success', [note]);
      }).fail(function () {
        // Submission failed, remove placeholder note and show Flash error message
        $notesContainer.find('#' + noteUniqueId).remove();

        var blurEvent = new CustomEvent('blur.imageDiff', {
          detail: e
        });

        var closestDiffFile = $form.closest('.diff-file');

        if (closestDiffFile.length) {
          closestDiffFile[0].dispatchEvent(blurEvent);
        }

        if (hasQuickActions) {
          $notesContainer.find('#' + systemNoteUniqueId).remove();
        }

        // Show form again on UI on failure
        if (isDiscussionForm && $notesContainer.length) {
          var replyButton = $notesContainer.parent().find('.js-discussion-reply-button');
          _this2.replyToDiscussionNote(replyButton[0]);
          $form = $notesContainer.parent().find('form');
        }

        $form.find('.js-note-text').val(formContent);
        _this2.reenableTargetFormSubmitButton(e);
        _this2.addNoteError($form);
      });

      return $closeBtn.text($closeBtn.data('original-text'));
    }

    /**
     * This method does following tasks step-by-step whenever an existing comment
     * is updated by user (both main thread comments as well as discussion comments).
     *
     * 1) Get Form metadata
     * 2) Update note element with new content
     * 3) Perform network request to submit the updated note using `ajaxPost`
     *    a) If request is successfully completed
     *        1. Show submitted Note element
     *    b) If request failed
     *        1. Revert Note element to original content
     *        2. Show error Flash message about failure
     */

  }, {
    key: 'updateComment',
    value: function updateComment(e) {
      var _this3 = this;

      e.preventDefault();

      // Get Form metadata
      var $submitBtn = jquery_default()(e.target);
      var $form = $submitBtn.parents('form');
      var $closeBtn = $form.find('.js-note-target-close');
      var $editingNote = $form.parents('.note.is-editing');
      var $noteBody = $editingNote.find('.js-task-list-container');
      var $noteBodyText = $noteBody.find('.note-text');

      var _getFormData2 = this.getFormData($form),
          formData = _getFormData2.formData,
          formContent = _getFormData2.formContent,
          formAction = _getFormData2.formAction;

      var $diffFile = $form.closest('.diff-file');
      var $notesContainer = $form.closest('.notes');

      // Cache original comment content
      var cachedNoteBodyText = $noteBodyText.html();

      // Show updated comment content temporarily
      $noteBodyText.html(formContent);
      $editingNote.removeClass('is-editing fade-in-full').addClass('being-posted fade-in-half');
      $editingNote.find('.note-headline-meta a').html('<i class="fa fa-spinner fa-spin" aria-label="Comment is being updated" aria-hidden="true"></i>');

      /* eslint-disable promise/catch-or-return */
      // Make request to update comment on server
      Object(common_utils["b" /* ajaxPost */])(formAction, formData).then(function (note) {
        // Submission successful! render final note element
        _this3.updateNote(note, $editingNote);
      }).fail(function () {
        // Submission failed, revert back to original note
        $noteBodyText.html(underscore_default.a.escape(cachedNoteBodyText));
        $editingNote.removeClass('being-posted fade-in');
        $editingNote.find('.fa.fa-spinner').remove();

        // Show Flash message about failure
        _this3.updateNoteError();
      });

      return $closeBtn.text($closeBtn.data('original-text'));
    }
  }], [{
    key: 'initCommentTypeToggle',
    value: function initCommentTypeToggle(form) {
      var dropdownTrigger = form.querySelector('.js-comment-type-dropdown .dropdown-toggle');
      var dropdownList = form.querySelector('.js-comment-type-dropdown .dropdown-menu');
      var noteTypeInput = form.querySelector('#note_type');
      var submitButton = form.querySelector('.js-comment-type-dropdown .js-comment-submit-button');
      var closeButton = form.querySelector('.js-note-target-close');
      var reopenButton = form.querySelector('.js-note-target-reopen');

      var commentTypeToggle = new comment_type_toggle({
        dropdownTrigger: dropdownTrigger,
        dropdownList: dropdownList,
        noteTypeInput: noteTypeInput,
        submitButton: submitButton,
        closeButton: closeButton,
        reopenButton: reopenButton
      });

      commentTypeToggle.initDroplab();
    }
  }, {
    key: 'updateNoteTargetSelector',
    value: function updateNoteTargetSelector($note) {
      var hash = gl.utils.getLocationHash();
      // Needs to be an explicit true/false for the jQuery `toggleClass(force)`
      var addTargetClass = Boolean(hash && $note.filter('#' + hash).length > 0);
      $note.toggleClass('target', addTargetClass);
    }
  }, {
    key: 'isNewNote',
    value: function isNewNote(noteEntity, noteIds) {
      return jquery_default.a.inArray(noteEntity.id, noteIds) === -1;
    }

    /**
     * Check if $note already contains the `noteEntity` content
     */

  }, {
    key: 'isUpdatedNote',
    value: function isUpdatedNote(noteEntity, $note) {
      // There can be CRLF vs LF mismatches if we don't sanitize and compare the same way
      var sanitizedNoteEntityText = normalizeNewlines(noteEntity.note.trim());
      var currentNoteText = normalizeNewlines($note.find('.original-note-content').first().text().trim());
      return sanitizedNoteEntityText !== currentNoteText;
    }
  }, {
    key: 'checkMergeRequestStatus',
    value: function checkMergeRequestStatus() {
      if (Object(common_utils["f" /* getPagePath */])(1) === 'merge_requests') {
        gl.mrWidget.checkStatus();
      }
    }
  }, {
    key: 'animateAppendNote',
    value: function animateAppendNote(noteHtml, $notesList) {
      var $note = jquery_default()(noteHtml);

      $note.addClass('fade-in-full').renderGFM();
      $notesList.append($note);
      return $note;
    }
  }, {
    key: 'animateUpdateNote',
    value: function animateUpdateNote(noteHtml, $note) {
      var $updatedNote = jquery_default()(noteHtml);

      $updatedNote.addClass('fade-in').renderGFM();
      $note.replaceWith($updatedNote);
      return $updatedNote;
    }
  }]);

  return Notes;
}();

/* harmony default export */ var notes_0 = (notes_Notes);


window.Notes = notes_Notes;

/***/ }),

/***/ "./notifications_dropdown.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife, one-var, no-var, one-var-declaration-per-line, no-unused-vars, consistent-return, prefer-arrow-callback, no-else-return, max-len */
/* global Flash */

(function () {
  this.NotificationsDropdown = function () {
    function NotificationsDropdown() {
      $(document).off('click', '.update-notification').on('click', '.update-notification', function (e) {
        var form, label, notificationLevel;
        e.preventDefault();
        if ($(this).is('.is-active') && $(this).data('notification-level') === 'custom') {
          return;
        }
        notificationLevel = $(this).data('notification-level');
        label = $(this).data('notification-title');
        form = $(this).parents('.notification-form:first');
        form.find('.js-notification-loading').toggleClass('fa-bell fa-spin fa-spinner');
        form.find('#notification_setting_level').val(notificationLevel);
        return form.submit();
      });
      $(document).off('ajax:success', '.notification-form').on('ajax:success', '.notification-form', function (e, data) {
        if (data.saved) {
          return $(e.currentTarget).closest('.js-notification-dropdown').replaceWith(data.html);
        } else {
          return new Flash('Failed to save new settings', 'alert');
        }
      });
    }

    return NotificationsDropdown;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./notifications_form.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, one-var, one-var-declaration-per-line, newline-per-chained-call, comma-dangle, consistent-return, prefer-arrow-callback, max-len */
(function () {
  this.NotificationsForm = function () {
    function NotificationsForm() {
      this.toggleCheckbox = this.toggleCheckbox.bind(this);
      this.removeEventListeners();
      this.initEventListeners();
    }

    NotificationsForm.prototype.removeEventListeners = function () {
      return $(document).off('change', '.js-custom-notification-event');
    };

    NotificationsForm.prototype.initEventListeners = function () {
      return $(document).on('change', '.js-custom-notification-event', this.toggleCheckbox);
    };

    NotificationsForm.prototype.toggleCheckbox = function (e) {
      var $checkbox, $parent;
      $checkbox = $(e.currentTarget);
      $parent = $checkbox.closest('.checkbox');
      return this.saveEvent($checkbox, $parent);
    };

    NotificationsForm.prototype.showCheckboxLoadingSpinner = function ($parent) {
      return $parent.addClass('is-loading').find('.custom-notification-event-loading').removeClass('fa-check').addClass('fa-spin fa-spinner').removeClass('is-done');
    };

    NotificationsForm.prototype.saveEvent = function ($checkbox, $parent) {
      var form;
      form = $parent.parents('form:first');
      return $.ajax({
        url: form.attr('action'),
        method: form.attr('method'),
        dataType: 'json',
        data: form.serialize(),
        beforeSend: function (_this) {
          return function () {
            return _this.showCheckboxLoadingSpinner($parent);
          };
        }(this)
      }).done(function (data) {
        $checkbox.enable();
        if (data.saved) {
          $parent.find('.custom-notification-event-loading').toggleClass('fa-spin fa-spinner fa-check is-done');
          return setTimeout(function () {
            return $parent.removeClass('is-loading').find('.custom-notification-event-loading').toggleClass('fa-spin fa-spinner fa-check is-done');
          }, 2000);
        }
      });
    };

    return NotificationsForm;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./oauth_remember_me.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * OAuth-based login buttons have a separate "remember me" checkbox.
 *
 * Toggling this checkbox adds/removes a `remember_me` parameter to the
 * login buttons' href, which is passed on to the omniauth callback.
 **/

var OAuthRememberMe = function () {
  function OAuthRememberMe() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, OAuthRememberMe);

    this.container = opts.container || '';
    this.loginLinkSelector = '.oauth-login';
  }

  _createClass(OAuthRememberMe, [{
    key: 'bindEvents',
    value: function bindEvents() {
      $('#remember_me', this.container).on('click', this.toggleRememberMe);
    }

    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'toggleRememberMe',
    value: function toggleRememberMe(event) {
      var rememberMe = $(event.target).is(':checked');

      $('.oauth-login', this.container).each(function (i, element) {
        var href = $(element).attr('href');

        if (rememberMe) {
          $(element).attr('href', href + '?remember_me=1');
        } else {
          $(element).attr('href', href.replace('?remember_me=1', ''));
        }
      });
    }
  }]);

  return OAuthRememberMe;
}();

/* harmony default export */ __webpack_exports__["a"] = (OAuthRememberMe);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./pager.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_url_utility__ = __webpack_require__("./lib/utils/url_utility.js");



(function () {
  var ENDLESS_SCROLL_BOTTOM_PX = 400;
  var ENDLESS_SCROLL_FIRE_DELAY_MS = 1000;

  var Pager = {
    init: function init() {
      var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var preload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var disable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var prepareData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $.noop;
      var callback = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : $.noop;

      this.url = $('.content_list').data('href') || gl.utils.removeParams(['limit', 'offset']);
      this.limit = limit;
      this.offset = parseInt(Object(__WEBPACK_IMPORTED_MODULE_0__lib_utils_common_utils__["g" /* getParameterByName */])('offset'), 10) || this.limit;
      this.disable = disable;
      this.prepareData = prepareData;
      this.callback = callback;
      this.loading = $('.loading').first();
      if (preload) {
        this.offset = 0;
        this.getOld();
      }
      this.initLoadMore();
    },
    getOld: function getOld() {
      var _this = this;

      this.loading.show();
      $.ajax({
        type: 'GET',
        url: this.url,
        data: 'limit=' + this.limit + '&offset=' + this.offset,
        dataType: 'json',
        error: function error() {
          return _this.loading.hide();
        },
        success: function success(data) {
          _this.append(data.count, _this.prepareData(data.html));
          _this.callback();

          // keep loading until we've filled the viewport height
          if (!_this.disable && !_this.isScrollable()) {
            _this.getOld();
          } else {
            _this.loading.hide();
          }
        }
      });
    },
    append: function append(count, html) {
      $('.content_list').append(html);
      if (count > 0) {
        this.offset += count;
      } else {
        this.disable = true;
      }
    },
    isScrollable: function isScrollable() {
      var $w = $(window);
      return $(document).height() > $w.height() + $w.scrollTop() + ENDLESS_SCROLL_BOTTOM_PX;
    },
    initLoadMore: function initLoadMore() {
      var _this2 = this;

      $(document).unbind('scroll');
      $(document).endlessScroll({
        bottomPixels: ENDLESS_SCROLL_BOTTOM_PX,
        fireDelay: ENDLESS_SCROLL_FIRE_DELAY_MS,
        fireOnce: true,
        ceaseFire: function ceaseFire() {
          return _this2.disable === true;
        },
        callback: function callback() {
          if (!_this2.loading.is(':visible')) {
            _this2.loading.show();
            _this2.getOld();
          }
        }
      });
    }
  };

  window.Pager = Pager;
})();
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./path_locks.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable space-before-function-paren, wrap-iife, one-var, no-var, one-var-declaration-per-line, no-unused-vars, object-shorthand, comma-dangle, prefer-arrow-callback, padded-blocks, func-names, max-len */

(function () {
  this.PathLocks = function () {
    function PathLocks() {}

    PathLocks.init = function (url, path) {
      return $('a.path-lock').on('click', function (e) {
        var $lockBtn, currentState, toggleAction;
        e.preventDefault();
        $lockBtn = $(this);
        currentState = $lockBtn.data('state');
        toggleAction = currentState === 'lock' ? 'unlock' : 'lock';
        return $.post(url, {
          path: path
        }, function () {
          location.reload();
        });
      });
    };

    return PathLocks;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./performance_bar.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vendor_peek__ = __webpack_require__("../../../vendor/assets/javascripts/peek.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vendor_peek___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vendor_peek__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vendor_peek_performance_bar__ = __webpack_require__("../../../vendor/assets/javascripts/peek.performance_bar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vendor_peek_performance_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vendor_peek_performance_bar__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var PerformanceBar = function () {
  function PerformanceBar(opts) {
    _classCallCheck(this, PerformanceBar);

    if (!PerformanceBar.singleton) {
      this.init(opts);
      PerformanceBar.singleton = this;
    }
    return PerformanceBar.singleton;
  }

  _createClass(PerformanceBar, [{
    key: 'init',
    value: function init(opts) {
      var $container = $(opts.container);
      this.$sqlProfileLink = $container.find('.js-toggle-modal-peek-sql');
      this.$sqlProfileModal = $container.find('#modal-peek-pg-queries');
      this.$lineProfileLink = $container.find('.js-toggle-modal-peek-line-profile');
      this.$lineProfileModal = $('#modal-peek-line-profile');
      this.initEventListeners();
      this.showModalOnLoad();
    }
  }, {
    key: 'initEventListeners',
    value: function initEventListeners() {
      var _this = this;

      this.$sqlProfileLink.on('click', function () {
        return _this.handleSQLProfileLink();
      });
      this.$lineProfileLink.on('click', function (e) {
        return _this.handleLineProfileLink(e);
      });
      $(document).on('click', '.js-lineprof-file', PerformanceBar.toggleLineProfileFile);
    }
  }, {
    key: 'showModalOnLoad',
    value: function showModalOnLoad() {
      // When a lineprofiler query-string param is present, we show the line
      // profiler modal upon page load
      if (/lineprofiler/.test(window.location.search)) {
        PerformanceBar.toggleModal(this.$lineProfileModal);
      }
    }
  }, {
    key: 'handleSQLProfileLink',
    value: function handleSQLProfileLink() {
      PerformanceBar.toggleModal(this.$sqlProfileModal);
    }
  }, {
    key: 'handleLineProfileLink',
    value: function handleLineProfileLink(e) {
      var lineProfilerParameter = gl.utils.getParameterValues('lineprofiler');
      var lineProfilerParameterRegex = new RegExp('lineprofiler=' + lineProfilerParameter[0]);
      var shouldToggleModal = lineProfilerParameter.length > 0 && lineProfilerParameterRegex.test(e.currentTarget.href);

      if (shouldToggleModal) {
        e.preventDefault();
        PerformanceBar.toggleModal(this.$lineProfileModal);
      }
    }
  }], [{
    key: 'toggleModal',
    value: function toggleModal($modal) {
      if ($modal.length) {
        $modal.modal('toggle');
      }
    }
  }, {
    key: 'toggleLineProfileFile',
    value: function toggleLineProfileFile(e) {
      $(e.currentTarget).parents('.peek-rblineprof-file').find('.data').toggle();
    }
  }]);

  return PerformanceBar;
}();

/* harmony default export */ __webpack_exports__["default"] = (PerformanceBar);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./pipelines.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_bootstrap_linked_tabs__ = __webpack_require__("./lib/utils/bootstrap_linked_tabs.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var Pipelines = function Pipelines() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  _classCallCheck(this, Pipelines);

  if (options.initTabs && options.tabsOptions) {
    // eslint-disable-next-line no-new
    new __WEBPACK_IMPORTED_MODULE_0__lib_utils_bootstrap_linked_tabs__["a" /* default */](options.tabsOptions);
  }

  if (options.pipelineStatusUrl) {
    Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils_common_utils__["y" /* setCiStatusFavicon */])(options.pipelineStatusUrl);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Pipelines);

/***/ }),

/***/ "./preview_markdown.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, no-var, object-shorthand, comma-dangle, prefer-arrow-callback */

// MarkdownPreview
//
// Handles toggling the "Write" and "Preview" tab clicks, rendering the preview
// (including the explanation of quick actions), and showing a warning when
// more than `x` users are referenced.
//
(function () {
  var lastTextareaPreviewed;
  var lastTextareaHeight = null;
  var markdownPreview;
  var previewButtonSelector;
  var writeButtonSelector;

  window.MarkdownPreview = function () {
    function MarkdownPreview() {}

    // Minimum number of users referenced before triggering a warning
    MarkdownPreview.prototype.referenceThreshold = 10;
    MarkdownPreview.prototype.emptyMessage = 'Nothing to preview.';

    MarkdownPreview.prototype.ajaxCache = {};

    MarkdownPreview.prototype.showPreview = function ($form) {
      var mdText;
      var preview = $form.find('.js-md-preview');
      var url = preview.data('url');
      if (preview.hasClass('md-preview-loading')) {
        return;
      }
      mdText = $form.find('textarea.markdown-area').val();

      if (mdText.trim().length === 0) {
        preview.text(this.emptyMessage);
        this.hideReferencedUsers($form);
      } else {
        preview.addClass('md-preview-loading').text('Loading...');
        this.fetchMarkdownPreview(mdText, url, function (response) {
          var body;
          if (response.body.length > 0) {
            body = response.body;
          } else {
            body = this.emptyMessage;
          }

          preview.removeClass('md-preview-loading').html(body);
          preview.renderGFM();
          this.renderReferencedUsers(response.references.users, $form);

          if (response.references.commands) {
            this.renderReferencedCommands(response.references.commands, $form);
          }
        }.bind(this));
      }
    };

    MarkdownPreview.prototype.fetchMarkdownPreview = function (text, url, success) {
      if (!url) {
        return;
      }
      if (text === this.ajaxCache.text) {
        success(this.ajaxCache.response);
        return;
      }
      $.ajax({
        type: 'POST',
        url: url,
        data: {
          text: text
        },
        dataType: 'json',
        success: function (response) {
          this.ajaxCache = {
            text: text,
            response: response
          };
          success(response);
        }.bind(this)
      });
    };

    MarkdownPreview.prototype.hideReferencedUsers = function ($form) {
      $form.find('.referenced-users').hide();
    };

    MarkdownPreview.prototype.renderReferencedUsers = function (users, $form) {
      var referencedUsers;
      referencedUsers = $form.find('.referenced-users');
      if (referencedUsers.length) {
        if (users.length >= this.referenceThreshold) {
          referencedUsers.show();
          referencedUsers.find('.js-referenced-users-count').text(users.length);
        } else {
          referencedUsers.hide();
        }
      }
    };

    MarkdownPreview.prototype.hideReferencedCommands = function ($form) {
      $form.find('.referenced-commands').hide();
    };

    MarkdownPreview.prototype.renderReferencedCommands = function (commands, $form) {
      var referencedCommands;
      referencedCommands = $form.find('.referenced-commands');
      if (commands.length > 0) {
        referencedCommands.html(commands);
        referencedCommands.show();
      } else {
        referencedCommands.html('');
        referencedCommands.hide();
      }
    };

    return MarkdownPreview;
  }();

  markdownPreview = new window.MarkdownPreview();

  previewButtonSelector = '.js-md-preview-button';

  writeButtonSelector = '.js-md-write-button';

  lastTextareaPreviewed = null;

  $.fn.setupMarkdownPreview = function () {
    var $form = $(this);
    $form.find('textarea.markdown-area').on('input', function () {
      markdownPreview.hideReferencedUsers($form);
    });
  };

  $(document).on('markdown-preview:show', function (e, $form) {
    if (!$form) {
      return;
    }

    lastTextareaPreviewed = $form.find('textarea.markdown-area');
    lastTextareaHeight = lastTextareaPreviewed.height();

    // toggle tabs
    $form.find(writeButtonSelector).parent().removeClass('active');
    $form.find(previewButtonSelector).parent().addClass('active');

    // toggle content
    $form.find('.md-write-holder').hide();
    $form.find('.md-preview-holder').show();
    markdownPreview.showPreview($form);
  });

  $(document).on('markdown-preview:hide', function (e, $form) {
    if (!$form) {
      return;
    }
    lastTextareaPreviewed = null;

    if (lastTextareaHeight) {
      $form.find('textarea.markdown-area').height(lastTextareaHeight);
    }

    // toggle tabs
    $form.find(writeButtonSelector).parent().addClass('active');
    $form.find(previewButtonSelector).parent().removeClass('active');

    // toggle content
    $form.find('.md-write-holder').show();
    $form.find('textarea.markdown-area').focus();
    $form.find('.md-preview-holder').hide();

    markdownPreview.hideReferencedCommands($form);
  });

  $(document).on('markdown-preview:toggle', function (e, keyboardEvent) {
    var $target;
    $target = $(keyboardEvent.target);
    if ($target.is('textarea.markdown-area')) {
      $(document).triggerHandler('markdown-preview:show', [$target.closest('form')]);
      keyboardEvent.preventDefault();
    } else if (lastTextareaPreviewed) {
      $target = lastTextareaPreviewed;
      $(document).triggerHandler('markdown-preview:hide', [$target.closest('form')]);
      keyboardEvent.preventDefault();
    }
  });

  $(document).on('click', previewButtonSelector, function (e) {
    var $form;
    e.preventDefault();
    $form = $(this).closest('form');
    $(document).triggerHandler('markdown-preview:show', [$form]);
  });

  $(document).on('click', writeButtonSelector, function (e) {
    var $form;
    e.preventDefault();
    $form = $(this).closest('form');
    $(document).triggerHandler('markdown-preview:hide', [$form]);
  });
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./project.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, quotes, consistent-return, no-new, prefer-arrow-callback, no-return-assign, one-var, one-var-declaration-per-line, object-shorthand, comma-dangle, no-else-return, newline-per-chained-call, no-shadow, vars-on-top, prefer-template, max-len */
/* global ProjectSelect */



(function () {
  this.Project = function () {
    function Project() {
      var $cloneOptions = $('ul.clone-options-dropdown');
      var $projectCloneField = $('#project_clone');
      var $cloneBtnText = $('a.clone-dropdown-btn span');

      var selectedCloneOption = $cloneBtnText.text().trim();
      if (selectedCloneOption.length > 0) {
        $('a:contains(\'' + selectedCloneOption + '\')', $cloneOptions).addClass('is-active');
      }

      $('a', $cloneOptions).on('click', function (e) {
        var $this = $(e.currentTarget);
        var url = $this.attr('href');

        e.preventDefault();

        $('.is-active', $cloneOptions).not($this).removeClass('is-active');
        $this.toggleClass('is-active');
        $projectCloneField.val(url);
        $cloneBtnText.text($this.text());

        $('#modal-geo-info').data({
          cloneUrlSecondary: $this.attr('href'),
          cloneUrlPrimary: $this.data('primaryUrl') || ''
        });

        return $('.clone').text(url);
      });
      // Ref switcher
      this.initRefSwitcher();
      $('.project-refs-select').on('change', function () {
        return $(this).parents('form').submit();
      });
      $('.hide-no-ssh-message').on('click', function (e) {
        __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('hide_no_ssh_message', 'false');
        $(this).parents('.no-ssh-key-message').remove();
        return e.preventDefault();
      });
      $('.hide-no-password-message').on('click', function (e) {
        __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('hide_no_password_message', 'false');
        $(this).parents('.no-password-message').remove();
        return e.preventDefault();
      });
      $('.hide-shared-runner-limit-message').on('click', function (e) {
        var $alert = $(this).parents('.shared-runner-quota-message');
        var scope = $alert.data('scope');
        __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('hide_shared_runner_quota_message', 'false', { path: scope });
        $alert.remove();
        e.preventDefault();
      });
      this.projectSelectDropdown();
    }

    Project.prototype.projectSelectDropdown = function () {
      new ProjectSelect();
      $('.project-item-select').on('click', function (_this) {
        return function (e) {
          return _this.changeProject($(e.currentTarget).val());
        };
      }(this));
    };

    Project.prototype.changeProject = function (url) {
      return window.location = url;
    };

    Project.prototype.initRefSwitcher = function () {
      var refListItem = document.createElement('li');
      var refLink = document.createElement('a');

      refLink.href = '#';

      return $('.js-project-refs-dropdown').each(function () {
        var $dropdown, selected;
        $dropdown = $(this);
        selected = $dropdown.data('selected');
        return $dropdown.glDropdown({
          data: function data(term, callback) {
            return $.ajax({
              url: $dropdown.data('refs-url'),
              data: {
                ref: $dropdown.data('ref'),
                search: term
              },
              dataType: "json"
            }).done(function (refs) {
              return callback(refs);
            });
          },
          selectable: true,
          filterable: true,
          filterRemote: true,
          filterByText: true,
          inputFieldName: $dropdown.data('input-field-name'),
          fieldName: $dropdown.data('field-name'),
          renderRow: function renderRow(ref) {
            var li = refListItem.cloneNode(false);

            if (ref.header != null) {
              li.className = 'dropdown-header';
              li.textContent = ref.header;
            } else {
              var link = refLink.cloneNode(false);

              if (ref === selected) {
                link.className = 'is-active';
              }

              link.textContent = ref;
              link.dataset.ref = ref;

              li.appendChild(link);
            }

            return li;
          },
          id: function id(obj, $el) {
            return $el.attr('data-ref');
          },
          toggleLabel: function toggleLabel(obj, $el) {
            return $el.text().trim();
          },
          clicked: function clicked(options) {
            var e = options.e;

            e.preventDefault();
            if ($('input[name="ref"]').length) {
              var $form = $dropdown.closest('form');

              var $visit = $dropdown.data('visit');
              var shouldVisit = $visit ? true : $visit;
              var action = $form.attr('action');
              var divider = action.indexOf('?') === -1 ? '?' : '&';
              if (shouldVisit) {
                gl.utils.visitUrl('' + action + divider + $form.serialize());
              }
            }
          }
        });
      });
    };

    return Project;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./project_avatar.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, one-var, one-var-declaration-per-line, no-useless-escape, max-len */
(function () {
  this.ProjectAvatar = function () {
    function ProjectAvatar() {
      $('.js-choose-project-avatar-button').bind('click', function () {
        var form;
        form = $(this).closest('form');
        return form.find('.js-project-avatar-input').click();
      });
      $('.js-project-avatar-input').bind('change', function () {
        var filename, form;
        form = $(this).closest('form');
        filename = $(this).val().replace(/^.*[\\\/]/, '');
        return form.find('.js-avatar-filename').text(filename);
      });
    }

    return ProjectAvatar;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./project_edit.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (immutable) */ __webpack_exports__["a"] = setupProjectEdit;
function setupProjectEdit() {
  var $transferForm = $('.js-project-transfer-form');
  var $selectNamespace = $transferForm.find('select.select2');

  $selectNamespace.on('change', function () {
    $transferForm.find(':submit').prop('disabled', !$selectNamespace.val());
  });
  $selectNamespace.trigger('change');
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./project_find_file.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, quotes, consistent-return, one-var, one-var-declaration-per-line, no-cond-assign, max-len, object-shorthand, no-param-reassign, comma-dangle, prefer-template, no-unused-vars, no-return-assign */
/* global fuzzaldrinPlus */

(function () {
  this.ProjectFindFile = function () {
    var highlighter;

    function ProjectFindFile(element1, options) {
      this.element = element1;
      this.options = options;
      this.goToBlob = this.goToBlob.bind(this);
      this.goToTree = this.goToTree.bind(this);
      this.selectRowDown = this.selectRowDown.bind(this);
      this.selectRowUp = this.selectRowUp.bind(this);
      this.filePaths = {};
      this.inputElement = this.element.find(".file-finder-input");
      // init event
      this.initEvent();
      // focus text input box
      this.inputElement.focus();
      // load file list
      this.load(this.options.url);
    }

    ProjectFindFile.prototype.initEvent = function () {
      this.inputElement.off("keyup");
      this.inputElement.on("keyup", function (_this) {
        return function (event) {
          var oldValue, ref, target, value;
          target = $(event.target);
          value = target.val();
          oldValue = (ref = target.data("oldValue")) != null ? ref : "";
          if (value !== oldValue) {
            target.data("oldValue", value);
            _this.findFile();
            return _this.element.find("tr.tree-item").eq(0).addClass("selected").focus();
          }
        };
      }(this));
    };

    ProjectFindFile.prototype.findFile = function () {
      var result, searchText;
      searchText = this.inputElement.val();
      result = searchText.length > 0 ? fuzzaldrinPlus.filter(this.filePaths, searchText) : this.filePaths;
      return this.renderList(result, searchText);
      // find file
    };

    // files pathes load
    ProjectFindFile.prototype.load = function (url) {
      return $.ajax({
        url: url,
        method: "get",
        dataType: "json",
        success: function (_this) {
          return function (data) {
            _this.element.find(".loading").hide();
            _this.filePaths = data;
            _this.findFile();
            return _this.element.find(".files-slider tr.tree-item").eq(0).addClass("selected").focus();
          };
        }(this)
      });
    };

    // render result
    ProjectFindFile.prototype.renderList = function (filePaths, searchText) {
      var blobItemUrl, filePath, html, i, j, len, matches, results;
      this.element.find(".tree-table > tbody").empty();
      results = [];
      for (i = j = 0, len = filePaths.length; j < len; i = j += 1) {
        filePath = filePaths[i];
        if (i === 20) {
          break;
        }
        if (searchText) {
          matches = fuzzaldrinPlus.match(filePath, searchText);
        }
        blobItemUrl = this.options.blobUrlTemplate + "/" + filePath;
        html = this.makeHtml(filePath, matches, blobItemUrl);
        results.push(this.element.find(".tree-table > tbody").append(html));
      }
      return results;
    };

    // highlight text(awefwbwgtc -> <b>a</b>wefw<b>b</b>wgt<b>c</b> )
    highlighter = function highlighter(element, text, matches) {
      var highlightText, j, lastIndex, len, matchIndex, matchedChars, unmatched;
      lastIndex = 0;
      highlightText = "";
      matchedChars = [];
      for (j = 0, len = matches.length; j < len; j += 1) {
        matchIndex = matches[j];
        unmatched = text.substring(lastIndex, matchIndex);
        if (unmatched) {
          if (matchedChars.length) {
            element.append(matchedChars.join("").bold());
          }
          matchedChars = [];
          element.append(document.createTextNode(unmatched));
        }
        matchedChars.push(text[matchIndex]);
        lastIndex = matchIndex + 1;
      }
      if (matchedChars.length) {
        element.append(matchedChars.join("").bold());
      }
      return element.append(document.createTextNode(text.substring(lastIndex)));
    };

    // make tbody row html
    ProjectFindFile.prototype.makeHtml = function (filePath, matches, blobItemUrl) {
      var $tr;
      $tr = $("<tr class='tree-item'><td class='tree-item-file-name link-container'><a><i class='fa fa-file-text-o fa-fw'></i><span class='str-truncated'></span></a></td></tr>");
      if (matches) {
        $tr.find("a").replaceWith(highlighter($tr.find("a"), filePath, matches).attr("href", blobItemUrl));
      } else {
        $tr.find("a").attr("href", blobItemUrl);
        $tr.find(".str-truncated").text(filePath);
      }
      return $tr;
    };

    ProjectFindFile.prototype.selectRow = function (type) {
      var next, rows, selectedRow;
      rows = this.element.find(".files-slider tr.tree-item");
      selectedRow = this.element.find(".files-slider tr.tree-item.selected");
      if (rows && rows.length > 0) {
        if (selectedRow && selectedRow.length > 0) {
          if (type === "UP") {
            next = selectedRow.prev();
          } else if (type === "DOWN") {
            next = selectedRow.next();
          }
          if (next.length > 0) {
            selectedRow.removeClass("selected");
            selectedRow = next;
          }
        } else {
          selectedRow = rows.eq(0);
        }
        return selectedRow.addClass("selected").focus();
      }
    };

    ProjectFindFile.prototype.selectRowUp = function () {
      return this.selectRow("UP");
    };

    ProjectFindFile.prototype.selectRowDown = function () {
      return this.selectRow("DOWN");
    };

    ProjectFindFile.prototype.goToTree = function () {
      return location.href = this.options.treeUrl;
    };

    ProjectFindFile.prototype.goToBlob = function () {
      var $link = this.element.find(".tree-item.selected .tree-item-file-name a");

      if ($link.length) {
        $link.get(0).click();
      }
    };

    return ProjectFindFile;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./project_import.js":
/***/ (function(module, exports) {

/* eslint-disable func-names, space-before-function-paren, wrap-iife, prefer-arrow-callback, max-len */

(function () {
  this.ProjectImport = function () {
    function ProjectImport() {
      setTimeout(function () {
        return gl.utils.visitUrl(location.href);
      }, 5000);
    }

    return ProjectImport;
  }();
}).call(window);

/***/ }),

/***/ "./project_label_subscription.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable wrap-iife, func-names, space-before-function-paren, object-shorthand, comma-dangle, one-var, one-var-declaration-per-line, no-restricted-syntax, max-len, no-param-reassign */

(function (global) {
  var ProjectLabelSubscription = function () {
    function ProjectLabelSubscription(container) {
      _classCallCheck(this, ProjectLabelSubscription);

      this.$container = $(container);
      this.$buttons = this.$container.find('.js-subscribe-button');

      this.$buttons.on('click', this.toggleSubscription.bind(this));
    }

    _createClass(ProjectLabelSubscription, [{
      key: 'toggleSubscription',
      value: function toggleSubscription(event) {
        var _this = this;

        event.preventDefault();

        var $btn = $(event.currentTarget);
        var $span = $btn.find('span');
        var url = $btn.attr('data-url');
        var oldStatus = $btn.attr('data-status');

        $btn.addClass('disabled');
        $span.toggleClass('hidden');

        $.ajax({
          type: 'POST',
          url: url
        }).done(function () {
          var newStatus = void 0,
              newAction = void 0;

          if (oldStatus === 'unsubscribed') {
            newStatus = 'subscribed';
            newAction = 'Unsubscribe';
          } else {
            newStatus = 'unsubscribed';
            newAction = 'Subscribe';
          }

          $span.toggleClass('hidden');
          $btn.removeClass('disabled');

          _this.$buttons.attr('data-status', newStatus);
          _this.$buttons.find('> span').text(newAction);

          _this.$buttons.map(function (button) {
            var $button = $(button);

            if ($button.attr('data-original-title')) {
              $button.tooltip('hide').attr('data-original-title', newAction).tooltip('fixTitle');
            }

            return button;
          });
        });
      }
    }]);

    return ProjectLabelSubscription;
  }();

  global.ProjectLabelSubscription = ProjectLabelSubscription;
})(window.gl || (window.gl = {}));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./project_new.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__visibility_select__ = __webpack_require__("./visibility_select.js");
/* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, no-unused-vars, one-var, no-underscore-dangle, prefer-template, no-else-return, prefer-arrow-callback, max-len */



function highlightChanges($elm) {
  $elm.addClass('highlight-changes');
  setTimeout(function () {
    return $elm.removeClass('highlight-changes');
  }, 10);
}

(function () {
  this.ProjectNew = function () {
    function ProjectNew() {
      this.toggleSettings = this.toggleSettings.bind(this);
      this.$selects = $('.features select');
      this.$repoSelects = this.$selects.filter('.js-repo-select');
      this.$enableApprovers = $('.js-require-approvals-toggle');
      this.$projectSelects = this.$selects.not('.js-repo-select');

      $('.project-edit-container').on('ajax:before', function (_this) {
        return function () {
          $('.project-edit-container').hide();
          return $('.save-project-loader').show();
        };
      }(this));

      this.initVisibilitySelect();

      this.toggleSettings();
      this.bindEvents();
      this.toggleRepoVisibility();
    }

    ProjectNew.prototype.bindEvents = function () {
      var _this2 = this;

      this.$selects.on('change', function () {
        return _this2.toggleSettings();
      });
      $('#require_approvals').on('change', function (e) {
        return _this2.toggleApproverSettingsVisibility(e);
      });
    };

    ProjectNew.prototype.initVisibilitySelect = function () {
      var _this3 = this;

      var visibilityContainer = document.querySelector('.js-visibility-select');
      if (!visibilityContainer) return;
      var visibilitySelect = new __WEBPACK_IMPORTED_MODULE_0__visibility_select__["a" /* default */](visibilityContainer);
      visibilitySelect.init();

      var $visibilitySelect = $(visibilityContainer).find('select');
      var projectVisibility = $visibilitySelect.val();
      var PROJECT_VISIBILITY_PRIVATE = '0';

      $visibilitySelect.on('change', function () {
        var newProjectVisibility = $visibilitySelect.val();

        if (projectVisibility !== newProjectVisibility) {
          _this3.$projectSelects.each(function (idx, select) {
            var $select = $(select);
            var $options = $select.find('option');
            var values = $.map($options, function (e) {
              return e.value;
            });

            // if switched to "private", limit visibility options
            if (newProjectVisibility === PROJECT_VISIBILITY_PRIVATE) {
              if ($select.val() !== values[0] && $select.val() !== values[1]) {
                $select.val(values[1]).trigger('change');
                highlightChanges($select);
              }
              $options.slice(2).disable();
            }

            // if switched from "private", increase visibility for non-disabled options
            if (projectVisibility === PROJECT_VISIBILITY_PRIVATE) {
              $options.enable();
              if ($select.val() !== values[0] && $select.val() !== values[values.length - 1]) {
                $select.val(values[values.length - 1]).trigger('change');
                highlightChanges($select);
              }
            }
          });

          projectVisibility = newProjectVisibility;
        }
      });
    };

    ProjectNew.prototype.toggleApproverSettingsVisibility = function (e) {
      this.$requiredApprovals = $('#project_approvals_before_merge');
      var enabled = $(e.target).prop('checked');
      var val = enabled ? 1 : 0;
      this.$requiredApprovals.val(val);
      this.$requiredApprovals.prop('min', val);
      $('.nested-settings').toggleClass('hidden', !enabled);
    };

    ProjectNew.prototype.toggleSettings = function () {
      var self = this;

      this.$selects.each(function () {
        var $select = $(this);
        var className = $select.data('field').replace(/_/g, '-').replace('access-level', 'feature');
        self._showOrHide($select, '.' + className);
      });
    };

    ProjectNew.prototype._showOrHide = function (checkElement, container) {
      var $container = $(container);

      if ($(checkElement).val() !== '0') {
        return $container.show();
      } else {
        return $container.hide();
      }
    };

    ProjectNew.prototype.toggleRepoVisibility = function () {
      var $repoAccessLevel = $('.js-repo-access-level select');
      var $lfsEnabledOption = $('.js-lfs-enabled select');
      var containerRegistry = document.querySelectorAll('.js-container-registry')[0];
      var containerRegistryCheckbox = document.getElementById('project_container_registry_enabled');
      var prevSelectedVal = parseInt($repoAccessLevel.val(), 10);

      this.$repoSelects.find("option[value='" + $repoAccessLevel.val() + "']").nextAll().hide();

      $repoAccessLevel.off('change').on('change', function () {
        var selectedVal = parseInt($repoAccessLevel.val(), 10);

        this.$repoSelects.each(function () {
          var $this = $(this);
          var repoSelectVal = parseInt($this.val(), 10);

          $this.find('option').enable();

          if (selectedVal < repoSelectVal || repoSelectVal === prevSelectedVal) {
            $this.val(selectedVal).trigger('change');
            highlightChanges($this);
          }

          $this.find("option[value='" + selectedVal + "']").nextAll().disable();
        });

        if (selectedVal) {
          this.$repoSelects.removeClass('disabled');

          if ($lfsEnabledOption.length) {
            $lfsEnabledOption.removeClass('disabled');
            highlightChanges($lfsEnabledOption);
          }
          if (containerRegistry) {
            containerRegistry.style.display = '';
          }
        } else {
          this.$repoSelects.addClass('disabled');

          if ($lfsEnabledOption.length) {
            $lfsEnabledOption.val('false').addClass('disabled');
            highlightChanges($lfsEnabledOption);
          }
          if (containerRegistry) {
            containerRegistry.style.display = 'none';
            containerRegistryCheckbox.checked = false;
          }
        }

        prevSelectedVal = selectedVal;
      }.bind(this));
    };

    return ProjectNew;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./project_select.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("./api.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__project_select_combo_button__ = __webpack_require__("./project_select_combo_button.js");
/* eslint-disable func-names, space-before-function-paren, wrap-iife, prefer-arrow-callback, no-var, comma-dangle, object-shorthand, one-var, one-var-declaration-per-line, no-else-return, quotes, max-len */



(function () {
  this.ProjectSelect = function () {
    function ProjectSelect() {
      $('.ajax-project-select').each(function (i, select) {
        var placeholder;
        this.groupId = $(select).data('group-id');
        this.includeGroups = $(select).data('include-groups');
        this.allProjects = $(select).data('allprojects') || false;
        this.orderBy = $(select).data('order-by') || 'id';
        this.withIssuesEnabled = $(select).data('with-issues-enabled');
        this.withMergeRequestsEnabled = $(select).data('with-merge-requests-enabled');

        placeholder = "Search for project";
        if (this.includeGroups) {
          placeholder += " or group";
        }

        $(select).select2({
          placeholder: placeholder,
          minimumInputLength: 0,
          query: function (_this) {
            return function (query) {
              var finalCallback, projectsCallback;
              finalCallback = function finalCallback(projects) {
                var data;
                data = {
                  results: projects
                };
                return query.callback(data);
              };
              if (_this.includeGroups) {
                projectsCallback = function projectsCallback(projects) {
                  var groupsCallback;
                  groupsCallback = function groupsCallback(groups) {
                    var data;
                    data = groups.concat(projects);
                    return finalCallback(data);
                  };
                  return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].groups(query.term, {}, groupsCallback);
                };
              } else {
                projectsCallback = finalCallback;
              }
              if (_this.groupId) {
                return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].groupProjects(_this.groupId, query.term, projectsCallback);
              } else {
                return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].projects(query.term, {
                  order_by: _this.orderBy,
                  with_issues_enabled: _this.withIssuesEnabled,
                  with_merge_requests_enabled: _this.withMergeRequestsEnabled,
                  membership: !_this.allProjects
                }, projectsCallback);
              }
            };
          }(this),
          id: function id(project) {
            return JSON.stringify({
              name: project.name,
              url: project.web_url
            });
          },
          text: function text(project) {
            return project.name_with_namespace || project.name;
          },
          dropdownCssClass: "ajax-project-dropdown"
        });

        return new __WEBPACK_IMPORTED_MODULE_1__project_select_combo_button__["a" /* default */](select);
      });
    }

    return ProjectSelect;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./project_select_combo_button.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_accessor__ = __webpack_require__("./lib/utils/accessor.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var ProjectSelectComboButton = function () {
  function ProjectSelectComboButton(select) {
    _classCallCheck(this, ProjectSelectComboButton);

    this.projectSelectInput = $(select);
    this.newItemBtn = $('.new-project-item-link');
    this.resourceType = this.newItemBtn.data('type');
    this.resourceLabel = this.newItemBtn.data('label');
    this.formattedText = this.deriveTextVariants();
    this.groupId = this.projectSelectInput.data('groupId');
    this.bindEvents();
    this.initLocalStorage();
  }

  _createClass(ProjectSelectComboButton, [{
    key: 'bindEvents',
    value: function bindEvents() {
      var _this = this;

      this.projectSelectInput.siblings('.new-project-item-select-button').on('click', function (e) {
        return _this.openDropdown(e);
      });

      this.newItemBtn.on('click', function (e) {
        if (!_this.getProjectFromLocalStorage()) {
          e.preventDefault();
          _this.openDropdown(e);
        }
      });

      this.projectSelectInput.on('change', function () {
        return _this.selectProject();
      });
    }
  }, {
    key: 'initLocalStorage',
    value: function initLocalStorage() {
      var localStorageIsSafe = __WEBPACK_IMPORTED_MODULE_0__lib_utils_accessor__["a" /* default */].isLocalStorageAccessSafe();

      if (localStorageIsSafe) {
        this.localStorageKey = ['group', this.groupId, this.formattedText.localStorageItemType, 'recent-project'].join('-');
        this.setBtnTextFromLocalStorage();
      }
    }

    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'openDropdown',
    value: function openDropdown(event) {
      $(event.currentTarget).siblings('.project-item-select').select2('open');
    }
  }, {
    key: 'selectProject',
    value: function selectProject() {
      var selectedProjectData = JSON.parse(this.projectSelectInput.val());
      var projectUrl = selectedProjectData.url + '/' + this.projectSelectInput.data('relativePath');
      var projectName = selectedProjectData.name;

      var projectMeta = {
        url: projectUrl,
        name: projectName
      };

      this.setNewItemBtnAttributes(projectMeta);
      this.setProjectInLocalStorage(projectMeta);
    }
  }, {
    key: 'setBtnTextFromLocalStorage',
    value: function setBtnTextFromLocalStorage() {
      var cachedProjectData = this.getProjectFromLocalStorage();

      this.setNewItemBtnAttributes(cachedProjectData);
    }
  }, {
    key: 'setNewItemBtnAttributes',
    value: function setNewItemBtnAttributes(project) {
      if (project) {
        this.newItemBtn.attr('href', project.url);
        this.newItemBtn.text(this.formattedText.defaultTextPrefix + ' in ' + project.name);
      } else {
        this.newItemBtn.text('Select project to create ' + this.formattedText.presetTextSuffix);
      }
    }
  }, {
    key: 'getProjectFromLocalStorage',
    value: function getProjectFromLocalStorage() {
      var projectString = localStorage.getItem(this.localStorageKey);

      return JSON.parse(projectString);
    }
  }, {
    key: 'setProjectInLocalStorage',
    value: function setProjectInLocalStorage(projectMeta) {
      var projectString = JSON.stringify(projectMeta);

      localStorage.setItem(this.localStorageKey, projectString);
    }
  }, {
    key: 'deriveTextVariants',
    value: function deriveTextVariants() {
      var defaultTextPrefix = this.resourceLabel;

      // the trailing slice call depluralizes each of these strings (e.g. new-issues -> new-issue)
      var localStorageItemType = 'new-' + this.resourceType.split('_').join('-').slice(0, -1);
      var presetTextSuffix = this.resourceType.split('_').join(' ').slice(0, -1);

      return {
        localStorageItemType: localStorageItemType, // new-issue / new-merge-request
        defaultTextPrefix: defaultTextPrefix, // New issue / New merge request
        presetTextSuffix: presetTextSuffix };
    }
  }]);

  return ProjectSelectComboButton;
}();

/* harmony default export */ __webpack_exports__["a"] = (ProjectSelectComboButton);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./project_show.js":
/***/ (function(module, exports) {

/* eslint-disable func-names, space-before-function-paren, wrap-iife */

(function () {
  this.ProjectShow = function () {
    function ProjectShow() {}

    return ProjectShow;
  }();
}).call(window);

// I kept class for future

/***/ }),

/***/ "./project_variables.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  var HIDDEN_VALUE_TEXT = '******';

  var ProjectVariables = function () {
    function ProjectVariables() {
      _classCallCheck(this, ProjectVariables);

      this.$revealBtn = $('.js-btn-toggle-reveal-values');
      this.$revealBtn.on('click', this.toggleRevealState.bind(this));
    }

    _createClass(ProjectVariables, [{
      key: 'toggleRevealState',
      value: function toggleRevealState(e) {
        e.preventDefault();

        var oldStatus = this.$revealBtn.attr('data-status');
        var newStatus = 'hidden';
        var newAction = 'Reveal Values';

        if (oldStatus === 'hidden') {
          newStatus = 'revealed';
          newAction = 'Hide Values';
        }

        this.$revealBtn.attr('data-status', newStatus);

        var $variables = $('.variable-value');

        $variables.each(function (_, variable) {
          var $variable = $(variable);
          var newText = HIDDEN_VALUE_TEXT;

          if (newStatus === 'revealed') {
            newText = $variable.attr('data-value');
          }

          $variable.text(newText);
        });

        this.$revealBtn.text(newAction);
      }
    }]);

    return ProjectVariables;
  }();

  window.gl = window.gl || {};
  window.gl.ProjectVariables = ProjectVariables;
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./project_visibility.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (immutable) */ __webpack_exports__["a"] = initProjectVisibilitySelector;
function setVisibilityOptions(namespaceSelector) {
  if (!namespaceSelector || !('selectedIndex' in namespaceSelector)) {
    return;
  }
  var selectedNamespace = namespaceSelector.options[namespaceSelector.selectedIndex];
  var _selectedNamespace$da = selectedNamespace.dataset,
      name = _selectedNamespace$da.name,
      visibility = _selectedNamespace$da.visibility,
      visibilityLevel = _selectedNamespace$da.visibilityLevel,
      showPath = _selectedNamespace$da.showPath,
      editPath = _selectedNamespace$da.editPath;


  document.querySelectorAll('.visibility-level-setting .radio').forEach(function (option) {
    var optionInput = option.querySelector('input[type=radio]');
    var optionValue = optionInput ? optionInput.value : 0;
    var optionTitle = option.querySelector('.option-title');
    var optionName = optionTitle ? optionTitle.innerText.toLowerCase() : '';

    // don't change anything if the option is restricted by admin
    if (!option.classList.contains('restricted')) {
      if (visibilityLevel < optionValue) {
        option.classList.add('disabled');
        optionInput.disabled = true;
        var reason = option.querySelector('.option-disabled-reason');
        if (reason) {
          reason.innerHTML = 'This project cannot be ' + optionName + ' because the visibility of\n            <a href="' + showPath + '">' + name + '</a> is ' + visibility + '. To make this project\n            ' + optionName + ', you must first <a href="' + editPath + '">change the visibility</a>\n            of the parent group.';
        }
      } else {
        option.classList.remove('disabled');
        optionInput.disabled = false;
      }
    }
  });
}

function initProjectVisibilitySelector() {
  var namespaceSelector = document.querySelector('select.js-select-namespace');
  if (namespaceSelector) {
    $('.select2.js-select-namespace').on('change', function () {
      return setVisibilityOptions(namespaceSelector);
    });
    setVisibilityOptions(namespaceSelector);
  }
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./projects_dropdown/components/app.vue":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")(
  /* script */
  __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./projects_dropdown/components/app.vue"),
  /* template */
  __webpack_require__("../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-c8728b10\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./projects_dropdown/components/app.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "./projects_dropdown/components/projects_list_frequent.vue":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")(
  /* script */
  __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./projects_dropdown/components/projects_list_frequent.vue"),
  /* template */
  __webpack_require__("../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-3040ab43\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./projects_dropdown/components/projects_list_frequent.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "./projects_dropdown/components/projects_list_item.vue":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")(
  /* script */
  __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./projects_dropdown/components/projects_list_item.vue"),
  /* template */
  __webpack_require__("../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-1c52c0f0\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./projects_dropdown/components/projects_list_item.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "./projects_dropdown/components/projects_list_search.vue":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")(
  /* script */
  __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./projects_dropdown/components/projects_list_search.vue"),
  /* template */
  __webpack_require__("../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-740ed45d\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./projects_dropdown/components/projects_list_search.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "./projects_dropdown/components/search.vue":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")(
  /* script */
  __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./projects_dropdown/components/search.vue"),
  /* template */
  __webpack_require__("../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-7f3261a1\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./projects_dropdown/components/search.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "./projects_dropdown/event_hub.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),

/***/ "./projects_dropdown/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_shared_translate__ = __webpack_require__("./vue_shared/translate.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub__ = __webpack_require__("./projects_dropdown/event_hub.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service_projects_service__ = __webpack_require__("./projects_dropdown/service/projects_service.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_projects_store__ = __webpack_require__("./projects_dropdown/store/projects_store.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_app_vue__ = __webpack_require__("./projects_dropdown/components/app.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_app_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_app_vue__);









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1__vue_shared_translate__["a" /* default */]);

document.addEventListener('DOMContentLoaded', function () {
  var el = document.getElementById('js-projects-dropdown');
  var navEl = document.getElementById('nav-projects-dropdown');

  // Don't do anything if element doesn't exist (No projects dropdown)
  // This is for when the user accesses GitLab without logging in
  if (!el || !navEl) {
    return;
  }

  $(navEl).on('show.bs.dropdown', function (e) {
    var dropdownEl = $(e.currentTarget).find('.projects-dropdown-menu');
    dropdownEl.one('transitionend', function () {
      __WEBPACK_IMPORTED_MODULE_2__event_hub__["a" /* default */].$emit('dropdownOpen');
    });
  });

  // eslint-disable-next-line no-new
  new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: el,
    components: {
      projectsDropdownApp: __WEBPACK_IMPORTED_MODULE_5__components_app_vue___default.a
    },
    data: function data() {
      var dataset = this.$options.el.dataset;
      var store = new __WEBPACK_IMPORTED_MODULE_4__store_projects_store__["a" /* default */]();
      var service = new __WEBPACK_IMPORTED_MODULE_3__service_projects_service__["a" /* default */](dataset.userName);

      var project = {
        id: Number(dataset.projectId),
        name: dataset.projectName,
        namespace: dataset.projectNamespace,
        webUrl: dataset.projectWebUrl,
        avatarUrl: dataset.projectAvatarUrl || null,
        lastAccessedOn: Date.now()
      };

      return {
        store: store,
        service: service,
        state: store.state,
        currentUserName: dataset.userName,
        currentProject: project
      };
    },
    render: function render(createElement) {
      return createElement('projects-dropdown-app', {
        props: {
          currentUserName: this.currentUserName,
          currentProject: this.currentProject,
          store: this.store,
          service: this.service
        }
      });
    }
  });
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./projects_dropdown/service/projects_service.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-resource/dist/vue-resource.es2015.js
var vue_resource_es2015 = __webpack_require__("../../../node_modules/vue-resource/dist/vue-resource.es2015.js");

// EXTERNAL MODULE: ./breakpoints.js
var breakpoints = __webpack_require__("./breakpoints.js");

// EXTERNAL MODULE: ./api.js
var api = __webpack_require__("./api.js");

// EXTERNAL MODULE: ./lib/utils/accessor.js
var accessor = __webpack_require__("./lib/utils/accessor.js");

// CONCATENATED MODULE: ./projects_dropdown/constants.js
var FREQUENT_PROJECTS = {
  MAX_COUNT: 20,
  LIST_COUNT_DESKTOP: 5,
  LIST_COUNT_MOBILE: 3,
  ELIGIBLE_FREQUENCY: 3
};

var HOUR_IN_MS = 3600000;

var STORAGE_KEY = 'frequent-projects';
// CONCATENATED MODULE: ./projects_dropdown/service/projects_service.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }










vue_esm["a" /* default */].use(vue_resource_es2015["a" /* default */]);

var projects_service_ProjectsService = function () {
  function ProjectsService(currentUserName) {
    _classCallCheck(this, ProjectsService);

    this.isLocalStorageAvailable = accessor["a" /* default */].isLocalStorageAccessSafe();
    this.currentUserName = currentUserName;
    this.storageKey = this.currentUserName + '/' + STORAGE_KEY;
    this.projectsPath = vue_esm["a" /* default */].resource(api["a" /* default */].buildUrl(api["a" /* default */].projectsPath));
  }

  _createClass(ProjectsService, [{
    key: 'getSearchedProjects',
    value: function getSearchedProjects(searchQuery) {
      return this.projectsPath.get({
        simple: true,
        per_page: 20,
        membership: !!gon.current_user_id,
        order_by: 'last_activity_at',
        search: searchQuery
      });
    }
  }, {
    key: 'getFrequentProjects',
    value: function getFrequentProjects() {
      if (this.isLocalStorageAvailable) {
        return this.getTopFrequentProjects();
      }
      return null;
    }
  }, {
    key: 'logProjectAccess',
    value: function logProjectAccess(project) {
      var matchFound = false;
      var storedFrequentProjects = void 0;

      if (this.isLocalStorageAvailable) {
        var storedRawProjects = localStorage.getItem(this.storageKey);

        // Check if there's any frequent projects list set
        if (!storedRawProjects) {
          // No frequent projects list set, set one up.
          storedFrequentProjects = [];
          storedFrequentProjects.push(_extends({}, project, { frequency: 1 }));
        } else {
          // Check if project is already present in frequents list
          // When found, update metadata of it.
          storedFrequentProjects = JSON.parse(storedRawProjects).map(function (projectItem) {
            if (projectItem.id === project.id) {
              matchFound = true;
              var diff = Math.abs(project.lastAccessedOn - projectItem.lastAccessedOn) / HOUR_IN_MS;
              var updatedProject = _extends({}, project, {
                frequency: projectItem.frequency,
                lastAccessedOn: projectItem.lastAccessedOn
              });

              // Check if duration since last access of this project
              // is over an hour
              if (diff > 1) {
                return _extends({}, updatedProject, {
                  frequency: updatedProject.frequency + 1,
                  lastAccessedOn: Date.now()
                });
              }

              return _extends({}, updatedProject);
            }

            return projectItem;
          });

          // Check whether currently logged project is present in frequents list
          if (!matchFound) {
            // We always keep size of frequents collection to 20 projects
            // out of which only 5 projects with
            // highest value of `frequency` and most recent `lastAccessedOn`
            // are shown in projects dropdown
            if (storedFrequentProjects.length === FREQUENT_PROJECTS.MAX_COUNT) {
              storedFrequentProjects.shift(); // Remove an item from head of array
            }

            storedFrequentProjects.push(_extends({}, project, { frequency: 1 }));
          }
        }

        localStorage.setItem(this.storageKey, JSON.stringify(storedFrequentProjects));
      }
    }
  }, {
    key: 'getTopFrequentProjects',
    value: function getTopFrequentProjects() {
      var storedFrequentProjects = JSON.parse(localStorage.getItem(this.storageKey));
      var frequentProjectsCount = FREQUENT_PROJECTS.LIST_COUNT_DESKTOP;

      if (!storedFrequentProjects) {
        return [];
      }

      if (breakpoints["a" /* default */].getBreakpointSize() === 'sm' || breakpoints["a" /* default */].getBreakpointSize() === 'xs') {
        frequentProjectsCount = FREQUENT_PROJECTS.LIST_COUNT_MOBILE;
      }

      var frequentProjects = storedFrequentProjects.filter(function (project) {
        return project.frequency >= FREQUENT_PROJECTS.ELIGIBLE_FREQUENCY;
      });

      // Sort all frequent projects in decending order of frequency
      // and then by lastAccessedOn with recent most first
      frequentProjects.sort(function (projectA, projectB) {
        if (projectA.frequency < projectB.frequency) {
          return 1;
        } else if (projectA.frequency > projectB.frequency) {
          return -1;
        } else if (projectA.lastAccessedOn < projectB.lastAccessedOn) {
          return 1;
        } else if (projectA.lastAccessedOn > projectB.lastAccessedOn) {
          return -1;
        }

        return 0;
      });

      return _.first(frequentProjects, frequentProjectsCount);
    }
  }]);

  return ProjectsService;
}();

/* harmony default export */ var projects_service = __webpack_exports__["a"] = (projects_service_ProjectsService);

/***/ }),

/***/ "./projects_dropdown/store/projects_store.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProjectsStore = function () {
  function ProjectsStore() {
    _classCallCheck(this, ProjectsStore);

    this.state = {};
    this.state.frequentProjects = [];
    this.state.searchedProjects = [];
  }

  _createClass(ProjectsStore, [{
    key: "setFrequentProjects",
    value: function setFrequentProjects(rawProjects) {
      this.state.frequentProjects = rawProjects;
    }
  }, {
    key: "getFrequentProjects",
    value: function getFrequentProjects() {
      return this.state.frequentProjects;
    }
  }, {
    key: "setSearchedProjects",
    value: function setSearchedProjects(rawProjects) {
      this.state.searchedProjects = rawProjects.map(function (rawProject) {
        return {
          id: rawProject.id,
          name: rawProject.name,
          namespace: rawProject.name_with_namespace,
          webUrl: rawProject.web_url,
          avatarUrl: rawProject.avatar_url
        };
      });
    }
  }, {
    key: "getSearchedProjects",
    value: function getSearchedProjects() {
      return this.state.searchedProjects;
    }
  }, {
    key: "clearSearchedProjects",
    value: function clearSearchedProjects() {
      this.state.searchedProjects = [];
    }
  }]);

  return ProjectsStore;
}();

/* harmony default export */ __webpack_exports__["a"] = (ProjectsStore);

/***/ }),

/***/ "./projects_list.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filterable_list__ = __webpack_require__("./filterable_list.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



/**
 * Makes search request for projects when user types a value in the search input.
 * Updates the html content of the page with the received one.
 */

var ProjectsList = function ProjectsList() {
  _classCallCheck(this, ProjectsList);

  var form = document.querySelector('form#project-filter-form');
  var filter = document.querySelector('.js-projects-list-filter');
  var holder = document.querySelector('.js-projects-list-holder');

  if (form && filter && holder) {
    var list = new __WEBPACK_IMPORTED_MODULE_0__filterable_list__["a" /* default */](form, filter, holder);
    list.initSearch();
  }
};

/* harmony default export */ __webpack_exports__["a"] = (ProjectsList);

/***/ }),

/***/ "./ref_select_dropdown.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RefSelectDropdown = function RefSelectDropdown($dropdownButton, availableRefs) {
  _classCallCheck(this, RefSelectDropdown);

  var availableRefsValue = availableRefs || JSON.parse(document.getElementById('availableRefs').innerHTML);
  $dropdownButton.glDropdown({
    data: availableRefsValue,
    filterable: true,
    filterByText: true,
    remote: false,
    fieldName: $dropdownButton.data('field-name'),
    filterInput: 'input[type="search"]',
    selectable: true,
    isSelectable: function isSelectable(branch, $el) {
      return !$el.hasClass('is-active');
    },
    text: function text(branch) {
      return branch;
    },
    id: function id(branch) {
      return branch;
    },
    toggleLabel: function toggleLabel(branch) {
      return branch;
    }
  });

  var $dropdownContainer = $dropdownButton.closest('.dropdown');
  var $fieldInput = $('input[name="' + $dropdownButton.data('field-name') + '"]', $dropdownContainer);
  var $filterInput = $('input[type="search"]', $dropdownContainer);

  $filterInput.on('keyup', function (e) {
    var keyCode = e.keyCode || e.which;
    if (keyCode !== 13) return;

    var ref = $filterInput.val().trim();
    if (ref === '') {
      return;
    }

    $fieldInput.val(ref);
    $('.dropdown-toggle-text', $dropdownButton).text(ref);

    $dropdownContainer.removeClass('open');
  });
};

/* harmony default export */ __webpack_exports__["a"] = (RefSelectDropdown);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./render_gfm.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, consistent-return, no-var, no-else-return, prefer-arrow-callback, max-len */

// Render Gitlab flavoured Markdown
//
// Delegates to syntax highlight and render math
//
(function () {
  $.fn.renderGFM = function () {
    this.find('.js-syntax-highlight').syntaxHighlight();
    this.find('.js-render-math').renderMath();
    return this;
  };

  $(function () {
    return $('body').renderGFM();
  });
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./render_math.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, consistent-return, no-var, no-else-return, prefer-arrow-callback, max-len, no-console */
/* global katex */

// Renders math using KaTeX in any element with the
// `js-render-math` class
//
// ### Example Markup
//
//   <code class="js-render-math"></div>
//
(function () {
  // Only load once
  var katexLoaded = false;

  // Loop over all math elements and render math
  var renderWithKaTeX = function renderWithKaTeX(elements) {
    elements.each(function () {
      var mathNode = $('<span></span>');
      var $this = $(this);

      var display = $this.attr('data-math-style') === 'display';
      try {
        katex.render($this.text(), mathNode.get(0), { displayMode: display });
        mathNode.insertAfter($this);
        $this.remove();
      } catch (err) {
        // What can we do??
        console.log(err.message);
      }
    });
  };

  $.fn.renderMath = function () {
    var $this = this;
    if ($this.length === 0) return;

    if (katexLoaded) renderWithKaTeX($this);else {
      // Request CSS file so it is in the cache
      $.get(gon.katex_css_url, function () {
        var css = $('<link>', { rel: 'stylesheet',
          type: 'text/css',
          href: gon.katex_css_url
        });
        css.appendTo('head');

        // Load KaTeX js
        $.getScript(gon.katex_js_url, function () {
          katexLoaded = true;
          renderWithKaTeX($this); // Run KaTeX
        });
      });
    }
  };
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./right_sidebar.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, no-unused-vars, consistent-return, one-var, one-var-declaration-per-line, quotes, prefer-template, object-shorthand, comma-dangle, no-else-return, no-param-reassign, max-len */




(function () {
  this.Sidebar = function () {
    function Sidebar(currentUser) {
      this.toggleTodo = this.toggleTodo.bind(this);
      this.sidebar = $('aside');

      this.removeListeners();
      this.addEventListeners();
    }

    Sidebar.prototype.removeListeners = function () {
      this.sidebar.off('click', '.sidebar-collapsed-icon');
      $('.dropdown').off('hidden.gl.dropdown');
      $('.dropdown').off('loading.gl.dropdown');
      $('.dropdown').off('loaded.gl.dropdown');
      $(document).off('click', '.js-sidebar-toggle');
    };

    Sidebar.prototype.addEventListeners = function () {
      var $document = $(document);

      this.sidebar.on('click', '.sidebar-collapsed-icon', this, this.sidebarCollapseClicked);
      $('.dropdown').on('hidden.gl.dropdown', this, this.onSidebarDropdownHidden);
      $('.dropdown').on('loading.gl.dropdown', this.sidebarDropdownLoading);
      $('.dropdown').on('loaded.gl.dropdown', this.sidebarDropdownLoaded);

      $document.on('click', '.js-sidebar-toggle', this.sidebarToggleClicked);
      return $(document).off('click', '.js-issuable-todo').on('click', '.js-issuable-todo', this.toggleTodo);
    };

    Sidebar.prototype.sidebarToggleClicked = function (e, triggered) {
      var $allGutterToggleIcons, $this, $thisIcon;
      e.preventDefault();
      $this = $(this);
      $thisIcon = $this.find('i');
      $allGutterToggleIcons = $('.js-sidebar-toggle i');
      if ($thisIcon.hasClass('fa-angle-double-right')) {
        $allGutterToggleIcons.removeClass('fa-angle-double-right').addClass('fa-angle-double-left');
        $('aside.right-sidebar').removeClass('right-sidebar-expanded').addClass('right-sidebar-collapsed');
        $('.page-with-sidebar').removeClass('right-sidebar-expanded').addClass('right-sidebar-collapsed');
      } else {
        $allGutterToggleIcons.removeClass('fa-angle-double-left').addClass('fa-angle-double-right');
        $('aside.right-sidebar').removeClass('right-sidebar-collapsed').addClass('right-sidebar-expanded');
        $('.page-with-sidebar').removeClass('right-sidebar-collapsed').addClass('right-sidebar-expanded');

        if (gl.lazyLoader) gl.lazyLoader.loadCheck();
      }
      if (!triggered) {
        __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set("collapsed_gutter", $('.right-sidebar').hasClass('right-sidebar-collapsed'));
      }
    };

    Sidebar.prototype.toggleTodo = function (e) {
      var $btnText, $this, $todoLoading, ajaxType, url;
      $this = $(e.currentTarget);
      ajaxType = $this.attr('data-delete-path') ? 'DELETE' : 'POST';
      if ($this.attr('data-delete-path')) {
        url = "" + $this.attr('data-delete-path');
      } else {
        url = "" + $this.data('url');
      }

      $this.tooltip('hide');

      return $.ajax({
        url: url,
        type: ajaxType,
        dataType: 'json',
        data: {
          issuable_id: $this.data('issuable-id'),
          issuable_type: $this.data('issuable-type')
        },
        beforeSend: function (_this) {
          return function () {
            $('.js-issuable-todo').disable().addClass('is-loading');
          };
        }(this)
      }).done(function (_this) {
        return function (data) {
          return _this.todoUpdateDone(data);
        };
      }(this));
    };

    Sidebar.prototype.todoUpdateDone = function (data) {
      var deletePath = data.delete_path ? data.delete_path : null;
      var attrPrefix = deletePath ? 'mark' : 'todo';
      var $todoBtns = $('.js-issuable-todo');

      $(document).trigger('todo:toggle', data.count);

      $todoBtns.each(function (i, el) {
        var $el = $(el);
        var $elText = $el.find('.js-issuable-todo-inner');

        $el.removeClass('is-loading').enable().attr('aria-label', $el.data(attrPrefix + '-text')).attr('data-delete-path', deletePath).attr('title', $el.data(attrPrefix + '-text'));

        if ($el.hasClass('has-tooltip')) {
          $el.tooltip('fixTitle');
        }

        if ($el.data(attrPrefix + '-icon')) {
          $elText.html($el.data(attrPrefix + '-icon'));
        } else {
          $elText.text($el.data(attrPrefix + '-text'));
        }
      });
    };

    Sidebar.prototype.sidebarDropdownLoading = function (e) {
      var $loading, $sidebarCollapsedIcon, i, img;
      $sidebarCollapsedIcon = $(this).closest('.block').find('.sidebar-collapsed-icon');
      img = $sidebarCollapsedIcon.find('img');
      i = $sidebarCollapsedIcon.find('i');
      $loading = $('<i class="fa fa-spinner fa-spin"></i>');
      if (img.length) {
        img.before($loading);
        return img.hide();
      } else if (i.length) {
        i.before($loading);
        return i.hide();
      }
    };

    Sidebar.prototype.sidebarDropdownLoaded = function (e) {
      var $sidebarCollapsedIcon, i, img;
      $sidebarCollapsedIcon = $(this).closest('.block').find('.sidebar-collapsed-icon');
      img = $sidebarCollapsedIcon.find('img');
      $sidebarCollapsedIcon.find('i.fa-spin').remove();
      i = $sidebarCollapsedIcon.find('i');
      if (img.length) {
        return img.show();
      } else {
        return i.show();
      }
    };

    Sidebar.prototype.sidebarCollapseClicked = function (e) {
      var $block, sidebar;
      if ($(e.currentTarget).hasClass('dont-change-state')) {
        return;
      }
      sidebar = e.data;
      e.preventDefault();
      $block = $(this).closest('.block');
      return sidebar.openDropdown($block);
    };

    Sidebar.prototype.openDropdown = function (blockOrName) {
      var $block;
      $block = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.isString(blockOrName) ? this.getBlock(blockOrName) : blockOrName;
      if (!this.isOpen()) {
        this.setCollapseAfterUpdate($block);
        this.toggleSidebar('open');
      }

      // Wait for the sidebar to trigger('click') open
      // so it doesn't cause our dropdown to close preemptively
      setTimeout(function () {
        $block.find('.js-sidebar-dropdown-toggle').trigger('click');
      });
    };

    Sidebar.prototype.setCollapseAfterUpdate = function ($block) {
      $block.addClass('collapse-after-update');
      return $('.page-with-sidebar').addClass('with-overlay');
    };

    Sidebar.prototype.onSidebarDropdownHidden = function (e) {
      var $block, sidebar;
      sidebar = e.data;
      e.preventDefault();
      $block = $(this).closest('.block');
      return sidebar.sidebarDropdownHidden($block);
    };

    Sidebar.prototype.sidebarDropdownHidden = function ($block) {
      if ($block.hasClass('collapse-after-update')) {
        $block.removeClass('collapse-after-update');
        $('.page-with-sidebar').removeClass('with-overlay');
        return this.toggleSidebar('hide');
      }
    };

    Sidebar.prototype.triggerOpenSidebar = function () {
      return this.sidebar.find('.js-sidebar-toggle').trigger('click');
    };

    Sidebar.prototype.toggleSidebar = function (action) {
      if (action == null) {
        action = 'toggle';
      }
      if (action === 'toggle') {
        this.triggerOpenSidebar();
      }
      if (action === 'open') {
        if (!this.isOpen()) {
          this.triggerOpenSidebar();
        }
      }
      if (action === 'hide') {
        if (this.isOpen()) {
          return this.triggerOpenSidebar();
        }
      }
    };

    Sidebar.prototype.isOpen = function () {
      return this.sidebar.is('.right-sidebar-expanded');
    };

    Sidebar.prototype.getBlock = function (name) {
      return this.sidebar.find(".block." + name);
    };

    return Sidebar;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./search.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("./api.js");
/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, one-var, one-var-declaration-per-line, object-shorthand, prefer-arrow-callback, comma-dangle, prefer-template, quotes, no-else-return, max-len */
/* global Flash */


(function () {
  this.Search = function () {
    function Search() {
      var _this2 = this;

      var $groupDropdown, $projectDropdown;
      $groupDropdown = $('.js-search-group-dropdown');
      $projectDropdown = $('.js-search-project-dropdown');
      this.groupId = $groupDropdown.data('group-id');
      this.eventListeners();
      $groupDropdown.glDropdown({
        selectable: true,
        filterable: true,
        fieldName: 'group_id',
        search: {
          fields: ['full_name']
        },
        data: function data(term, callback) {
          return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].groups(term, {}, function (data) {
            data.unshift({
              full_name: 'Any'
            });
            data.splice(1, 0, 'divider');
            return callback(data);
          });
        },
        id: function id(obj) {
          return obj.id;
        },
        text: function text(obj) {
          return obj.full_name;
        },
        toggleLabel: function toggleLabel(obj) {
          return $groupDropdown.data('default-label') + " " + obj.full_name;
        },
        clicked: function (_this) {
          return function () {
            return _this.submitSearch();
          };
        }(this)
      });
      $projectDropdown.glDropdown({
        selectable: true,
        filterable: true,
        fieldName: 'project_id',
        search: {
          fields: ['name']
        },
        data: function data(term, callback) {
          _this2.getProjectsData(term).then(function (data) {
            data.unshift({
              name_with_namespace: 'Any'
            });
            data.splice(1, 0, 'divider');

            return data;
          }).then(function (data) {
            return callback(data);
          }).catch(function () {
            return new Flash('Error fetching projects');
          });
        },
        id: function id(obj) {
          return obj.id;
        },
        text: function text(obj) {
          return obj.name_with_namespace;
        },
        toggleLabel: function toggleLabel(obj) {
          return $projectDropdown.data('default-label') + " " + obj.name_with_namespace;
        },
        clicked: function (_this) {
          return function () {
            return _this.submitSearch();
          };
        }(this)
      });
    }

    Search.prototype.eventListeners = function () {
      $(document).off('keyup', '.js-search-input').on('keyup', '.js-search-input', this.searchKeyUp);
      return $(document).off('click', '.js-search-clear').on('click', '.js-search-clear', this.clearSearchField);
    };

    Search.prototype.submitSearch = function () {
      return $('.js-search-form').submit();
    };

    Search.prototype.searchKeyUp = function () {
      var $input;
      $input = $(this);
      if ($input.val() === '') {
        return $('.js-search-clear').addClass('hidden');
      } else {
        return $('.js-search-clear').removeClass('hidden');
      }
    };

    Search.prototype.clearSearchField = function () {
      return $('.js-search-input').val('').trigger('keyup').focus();
    };

    Search.prototype.getProjectsData = function (term) {
      var _this3 = this;

      return new Promise(function (resolve) {
        if (_this3.groupId) {
          __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].groupProjects(_this3.groupId, term, resolve);
        } else {
          __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].projects(term, {
            order_by: 'id'
          }, resolve);
        }
      });
    };

    return Search;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./search_autocomplete.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable comma-dangle, no-return-assign, one-var, no-var, no-underscore-dangle, one-var-declaration-per-line, no-unused-vars, no-cond-assign, consistent-return, object-shorthand, prefer-arrow-callback, func-names, space-before-function-paren, prefer-template, quotes, class-methods-use-this, no-unused-expressions, no-sequences, wrap-iife, no-lonely-if, no-else-return, no-param-reassign, vars-on-top, max-len */


(function (global) {
  var KEYCODE = {
    ESCAPE: 27,
    BACKSPACE: 8,
    ENTER: 13,
    UP: 38,
    DOWN: 40
  };

  var SearchAutocomplete = function () {
    function SearchAutocomplete() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          wrap = _ref.wrap,
          optsEl = _ref.optsEl,
          autocompletePath = _ref.autocompletePath,
          projectId = _ref.projectId,
          projectRef = _ref.projectRef;

      _classCallCheck(this, SearchAutocomplete);

      this.bindEventContext();
      this.wrap = wrap || $('.search');
      this.optsEl = optsEl || this.wrap.find('.search-autocomplete-opts');
      this.autocompletePath = autocompletePath || this.optsEl.data('autocomplete-path');
      this.projectId = projectId || this.optsEl.data('autocomplete-project-id') || '';
      this.projectRef = projectRef || this.optsEl.data('autocomplete-project-ref') || '';
      this.dropdown = this.wrap.find('.dropdown');
      this.dropdownContent = this.dropdown.find('.dropdown-content');
      this.locationBadgeEl = this.getElement('.location-badge');
      this.scopeInputEl = this.getElement('#scope');
      this.searchInput = this.getElement('.search-input');
      this.projectInputEl = this.getElement('#search_project_id');
      this.groupInputEl = this.getElement('#group_id');
      this.searchCodeInputEl = this.getElement('#search_code');
      this.repositoryInputEl = this.getElement('#repository_ref');
      this.clearInput = this.getElement('.js-clear-input');
      this.saveOriginalState();
      // Only when user is logged in
      if (gon.current_user_id) {
        this.createAutocomplete();
      }
      this.searchInput.addClass('disabled');
      this.saveTextLength();
      this.bindEvents();
    }

    // Finds an element inside wrapper element


    _createClass(SearchAutocomplete, [{
      key: 'bindEventContext',
      value: function bindEventContext() {
        this.onSearchInputBlur = this.onSearchInputBlur.bind(this);
        this.onClearInputClick = this.onClearInputClick.bind(this);
        this.onSearchInputFocus = this.onSearchInputFocus.bind(this);
        this.onSearchInputClick = this.onSearchInputClick.bind(this);
        this.onSearchInputKeyUp = this.onSearchInputKeyUp.bind(this);
        this.onSearchInputKeyDown = this.onSearchInputKeyDown.bind(this);
      }
    }, {
      key: 'getElement',
      value: function getElement(selector) {
        return this.wrap.find(selector);
      }
    }, {
      key: 'saveOriginalState',
      value: function saveOriginalState() {
        return this.originalState = this.serializeState();
      }
    }, {
      key: 'saveTextLength',
      value: function saveTextLength() {
        return this.lastTextLength = this.searchInput.val().length;
      }
    }, {
      key: 'createAutocomplete',
      value: function createAutocomplete() {
        return this.searchInput.glDropdown({
          filterInputBlur: false,
          filterable: true,
          filterRemote: true,
          highlight: true,
          enterCallback: false,
          filterInput: 'input#search',
          search: {
            fields: ['text']
          },
          id: this.getSearchText,
          data: this.getData.bind(this),
          selectable: true,
          clicked: this.onClick.bind(this)
        });
      }
    }, {
      key: 'getSearchText',
      value: function getSearchText(selectedObject, el) {
        return selectedObject.id ? selectedObject.text : '';
      }
    }, {
      key: 'getData',
      value: function getData(term, callback) {
        var _this, contents, jqXHR;
        _this = this;
        if (!term) {
          if (contents = this.getCategoryContents()) {
            this.searchInput.data('glDropdown').filter.options.callback(contents);
            this.enableAutocomplete();
          }
          return;
        }
        // Prevent multiple ajax calls
        if (this.loadingSuggestions) {
          return;
        }
        this.loadingSuggestions = true;
        return jqXHR = $.get(this.autocompletePath, {
          project_id: this.projectId,
          project_ref: this.projectRef,
          term: term
        }, function (response) {
          var data, firstCategory, i, lastCategory, len, suggestion;
          // Hide dropdown menu if no suggestions returns
          if (!response.length) {
            _this.disableAutocomplete();
            return;
          }
          data = [];
          // List results
          firstCategory = true;
          for (i = 0, len = response.length; i < len; i += 1) {
            suggestion = response[i];
            // Add group header before list each group
            if (lastCategory !== suggestion.category) {
              if (!firstCategory) {
                data.push('separator');
              }
              if (firstCategory) {
                firstCategory = false;
              }
              data.push({
                header: suggestion.category
              });
              lastCategory = suggestion.category;
            }
            data.push({
              id: suggestion.category.toLowerCase() + "-" + suggestion.id,
              category: suggestion.category,
              text: suggestion.label,
              url: suggestion.url
            });
          }
          // Add option to proceed with the search
          if (data.length) {
            data.push('separator');
            data.push({
              text: "Result name contains \"" + term + "\"",
              url: "/search?search=" + term + "&project_id=" + _this.projectInputEl.val() + "&group_id=" + _this.groupInputEl.val()
            });
          }
          return callback(data);
        }).always(function () {
          return _this.loadingSuggestions = false;
        });
      }
    }, {
      key: 'getCategoryContents',
      value: function getCategoryContents() {
        var dashboardOptions, groupOptions, issuesPath, items, mrPath, name, options, projectOptions, userId, userName;
        userId = gon.current_user_id;
        userName = gon.current_username;
        projectOptions = gl.projectOptions, groupOptions = gl.groupOptions, dashboardOptions = gl.dashboardOptions;
        if (Object(__WEBPACK_IMPORTED_MODULE_0__lib_utils_common_utils__["l" /* isInGroupsPage */])() && groupOptions) {
          options = groupOptions[Object(__WEBPACK_IMPORTED_MODULE_0__lib_utils_common_utils__["e" /* getGroupSlug */])()];
        } else if (Object(__WEBPACK_IMPORTED_MODULE_0__lib_utils_common_utils__["n" /* isInProjectPage */])() && projectOptions) {
          options = projectOptions[Object(__WEBPACK_IMPORTED_MODULE_0__lib_utils_common_utils__["h" /* getProjectSlug */])()];
        } else if (dashboardOptions) {
          options = dashboardOptions;
        }
        issuesPath = options.issuesPath, mrPath = options.mrPath, name = options.name;
        items = [{
          header: "" + name
        }, {
          text: 'Issues assigned to me',
          url: issuesPath + "/?assignee_username=" + userName
        }, {
          text: "Issues I've created",
          url: issuesPath + "/?author_username=" + userName
        }, 'separator', {
          text: 'Merge requests assigned to me',
          url: mrPath + "/?assignee_username=" + userName
        }, {
          text: "Merge requests I've created",
          url: mrPath + "/?author_username=" + userName
        }];
        if (!name) {
          items.splice(0, 1);
        }
        return items;
      }
    }, {
      key: 'serializeState',
      value: function serializeState() {
        return {
          // Search Criteria
          search_project_id: this.projectInputEl.val(),
          group_id: this.groupInputEl.val(),
          search_code: this.searchCodeInputEl.val(),
          repository_ref: this.repositoryInputEl.val(),
          scope: this.scopeInputEl.val(),
          // Location badge
          _location: this.locationBadgeEl.text()
        };
      }
    }, {
      key: 'bindEvents',
      value: function bindEvents() {
        this.searchInput.on('keydown', this.onSearchInputKeyDown);
        this.searchInput.on('keyup', this.onSearchInputKeyUp);
        this.searchInput.on('click', this.onSearchInputClick);
        this.searchInput.on('focus', this.onSearchInputFocus);
        this.searchInput.on('blur', this.onSearchInputBlur);
        this.clearInput.on('click', this.onClearInputClick);
        return this.locationBadgeEl.on('click', function (_this) {
          return function () {
            return _this.searchInput.focus();
          };
        }(this));
      }
    }, {
      key: 'enableAutocomplete',
      value: function enableAutocomplete() {
        var _this;
        // No need to enable anything if user is not logged in
        if (!gon.current_user_id) {
          return;
        }
        if (!this.dropdown.hasClass('open')) {
          _this = this;
          this.loadingSuggestions = false;
          this.dropdown.addClass('open').trigger('shown.bs.dropdown');
          return this.searchInput.removeClass('disabled');
        }
      }

      // Saves last length of the entered text

    }, {
      key: 'onSearchInputKeyDown',
      value: function onSearchInputKeyDown() {
        return this.saveTextLength();
      }
    }, {
      key: 'onSearchInputKeyUp',
      value: function onSearchInputKeyUp(e) {
        switch (e.keyCode) {
          case KEYCODE.BACKSPACE:
            // when trying to remove the location badge
            if (this.lastTextLength === 0 && this.badgePresent()) {
              this.removeLocationBadge();
            }
            // When removing the last character and no badge is present
            if (this.lastTextLength === 1) {
              this.disableAutocomplete();
            }
            // When removing any character from existin value
            if (this.lastTextLength > 1) {
              this.enableAutocomplete();
            }
            break;
          case KEYCODE.ESCAPE:
            this.restoreOriginalState();
            break;
          case KEYCODE.ENTER:
            this.disableAutocomplete();
            break;
          case KEYCODE.UP:
          case KEYCODE.DOWN:
            return;
          default:
            // Handle the case when deleting the input value other than backspace
            // e.g. Pressing ctrl + backspace or ctrl + x
            if (this.searchInput.val() === '') {
              this.disableAutocomplete();
            } else {
              // We should display the menu only when input is not empty
              if (e.keyCode !== KEYCODE.ENTER) {
                this.enableAutocomplete();
              }
            }
        }
        this.wrap.toggleClass('has-value', !!e.target.value);
      }

      // Avoid falsy value to be returned

    }, {
      key: 'onSearchInputClick',
      value: function onSearchInputClick(e) {
        return e.stopImmediatePropagation();
      }
    }, {
      key: 'onSearchInputFocus',
      value: function onSearchInputFocus() {
        this.isFocused = true;
        this.wrap.addClass('search-active');
        if (this.getValue() === '') {
          return this.getData();
        }
      }
    }, {
      key: 'getValue',
      value: function getValue() {
        return this.searchInput.val();
      }
    }, {
      key: 'onClearInputClick',
      value: function onClearInputClick(e) {
        e.preventDefault();
        this.wrap.toggleClass('has-value', !!e.target.value);
        return this.searchInput.val('').focus();
      }
    }, {
      key: 'onSearchInputBlur',
      value: function onSearchInputBlur(e) {
        this.isFocused = false;
        this.wrap.removeClass('search-active');
        // If input is blank then restore state
        if (this.searchInput.val() === '') {
          return this.restoreOriginalState();
        }
      }
    }, {
      key: 'addLocationBadge',
      value: function addLocationBadge(item) {
        var badgeText, category, value;
        category = item.category != null ? item.category + ": " : '';
        value = item.value != null ? item.value : '';
        badgeText = "" + category + value;
        this.locationBadgeEl.text(badgeText).show();
        return this.wrap.addClass('has-location-badge');
      }
    }, {
      key: 'hasLocationBadge',
      value: function hasLocationBadge() {
        return this.wrap.is('.has-location-badge');
      }
    }, {
      key: 'restoreOriginalState',
      value: function restoreOriginalState() {
        var i, input, inputs, len;
        inputs = Object.keys(this.originalState);
        for (i = 0, len = inputs.length; i < len; i += 1) {
          input = inputs[i];
          this.getElement("#" + input).val(this.originalState[input]);
        }
        if (this.originalState._location === '') {
          return this.locationBadgeEl.hide();
        } else {
          return this.addLocationBadge({
            value: this.originalState._location
          });
        }
      }
    }, {
      key: 'badgePresent',
      value: function badgePresent() {
        return this.locationBadgeEl.length;
      }
    }, {
      key: 'resetSearchState',
      value: function resetSearchState() {
        var i, input, inputs, len, results;
        inputs = Object.keys(this.originalState);
        results = [];
        for (i = 0, len = inputs.length; i < len; i += 1) {
          input = inputs[i];
          // _location isnt a input
          if (input === '_location') {
            break;
          }
          results.push(this.getElement("#" + input).val(''));
        }
        return results;
      }
    }, {
      key: 'removeLocationBadge',
      value: function removeLocationBadge() {
        this.locationBadgeEl.hide();
        this.resetSearchState();
        this.wrap.removeClass('has-location-badge');
        return this.disableAutocomplete();
      }
    }, {
      key: 'disableAutocomplete',
      value: function disableAutocomplete() {
        if (!this.searchInput.hasClass('disabled') && this.dropdown.hasClass('open')) {
          this.searchInput.addClass('disabled');
          this.dropdown.removeClass('open').trigger('hidden.bs.dropdown');
          this.restoreMenu();
        }
      }
    }, {
      key: 'restoreMenu',
      value: function restoreMenu() {
        var html;
        html = '<ul><li class="dropdown-menu-empty-item"><a>Loading...</a></li></ul>';
        return this.dropdownContent.html(html);
      }
    }, {
      key: 'onClick',
      value: function onClick(item, $el, e) {
        if (location.pathname.indexOf(item.url) !== -1) {
          if (!e.metaKey) e.preventDefault();
          if (!this.badgePresent) {
            if (item.category === 'Projects') {
              this.projectInputEl.val(item.id);
              this.addLocationBadge({
                value: 'This project'
              });
            }
            if (item.category === 'Groups') {
              this.groupInputEl.val(item.id);
              this.addLocationBadge({
                value: 'This group'
              });
            }
          }
          $el.removeClass('is-active');
          this.disableAutocomplete();
          return this.searchInput.val('').focus();
        }
      }
    }]);

    return SearchAutocomplete;
  }();

  global.SearchAutocomplete = SearchAutocomplete;

  $(function () {
    var $projectOptionsDataEl = $('.js-search-project-options');
    var $groupOptionsDataEl = $('.js-search-group-options');
    var $dashboardOptionsDataEl = $('.js-search-dashboard-options');

    if ($projectOptionsDataEl.length) {
      gl.projectOptions = gl.projectOptions || {};

      var projectPath = $projectOptionsDataEl.data('project-path');

      gl.projectOptions[projectPath] = {
        name: $projectOptionsDataEl.data('name'),
        issuesPath: $projectOptionsDataEl.data('issues-path'),
        mrPath: $projectOptionsDataEl.data('mr-path')
      };
    }

    if ($groupOptionsDataEl.length) {
      gl.groupOptions = gl.groupOptions || {};

      var groupPath = $groupOptionsDataEl.data('group-path');

      gl.groupOptions[groupPath] = {
        name: $groupOptionsDataEl.data('name'),
        issuesPath: $groupOptionsDataEl.data('issues-path'),
        mrPath: $groupOptionsDataEl.data('mr-path')
      };
    }

    if ($dashboardOptionsDataEl.length) {
      gl.dashboardOptions = {
        issuesPath: $dashboardOptionsDataEl.data('issues-path'),
        mrPath: $dashboardOptionsDataEl.data('mr-path')
      };
    }
  });
})(window.gl || (window.gl = {}));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./settings_panels.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (immutable) */ __webpack_exports__["a"] = initSettingsPanels;
function expandSection($section) {
  $section.find('.js-settings-toggle').text('Collapse');
  $section.find('.settings-content').off('scroll.expandSection').scrollTop(0);
  $section.addClass('expanded');
  if (!$section.hasClass('no-animate')) {
    $section.addClass('animating').one('animationend.animateSection', function () {
      return $section.removeClass('animating');
    });
  }
}

function closeSection($section) {
  $section.find('.js-settings-toggle').text('Expand');
  $section.find('.settings-content').on('scroll.expandSection', function () {
    return expandSection($section);
  });
  $section.removeClass('expanded');
  if (!$section.hasClass('no-animate')) {
    $section.addClass('animating').one('animationend.animateSection', function () {
      return $section.removeClass('animating');
    });
  }
}

function toggleSection($section) {
  $section.removeClass('no-animate');
  if ($section.hasClass('expanded')) {
    closeSection($section);
  } else {
    expandSection($section);
  }
}

function initSettingsPanels() {
  $('.settings').each(function (i, elm) {
    var $section = $(elm);
    $section.on('click.toggleSection', '.js-settings-toggle', function () {
      return toggleSection($section);
    });

    if (!$section.hasClass('expanded')) {
      $section.find('.settings-content').on('scroll.expandSection', function () {
        $section.removeClass('no-animate');
        expandSection($section);
      });
    }
  });

  if (location.hash) {
    var $target = $(location.hash);
    if ($target.length && $target.hasClass('.settings')) {
      expandSection($target);
    }
  }
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./shortcuts.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mousetrap__ = __webpack_require__("../../../node_modules/mousetrap/mousetrap.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mousetrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mousetrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shortcuts_dashboard_navigation__ = __webpack_require__("./shortcuts_dashboard_navigation.js");
/* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, quotes, prefer-arrow-callback, consistent-return, object-shorthand, no-unused-vars, one-var, one-var-declaration-per-line, no-else-return, comma-dangle, max-len */
/* global Mousetrap */





(function () {
  this.Shortcuts = function () {
    function Shortcuts(skipResetBindings) {
      var _this = this;

      this.onToggleHelp = this.onToggleHelp.bind(this);
      this.enabledHelp = [];
      if (!skipResetBindings) {
        __WEBPACK_IMPORTED_MODULE_1_mousetrap___default.a.reset();
      }
      __WEBPACK_IMPORTED_MODULE_1_mousetrap___default.a.bind('?', this.onToggleHelp);
      __WEBPACK_IMPORTED_MODULE_1_mousetrap___default.a.bind('s', Shortcuts.focusSearch);
      __WEBPACK_IMPORTED_MODULE_1_mousetrap___default.a.bind('f', function (e) {
        return _this.focusFilter(e);
      });
      __WEBPACK_IMPORTED_MODULE_1_mousetrap___default.a.bind('p b', this.onTogglePerfBar);

      var findFileURL = document.body.dataset.findFile;

      __WEBPACK_IMPORTED_MODULE_1_mousetrap___default.a.bind('shift+t', function () {
        return Object(__WEBPACK_IMPORTED_MODULE_2__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-todos');
      });
      __WEBPACK_IMPORTED_MODULE_1_mousetrap___default.a.bind('shift+a', function () {
        return Object(__WEBPACK_IMPORTED_MODULE_2__shortcuts_dashboard_navigation__["a" /* default */])('.dashboard-shortcuts-activity');
      });
      __WEBPACK_IMPORTED_MODULE_1_mousetrap___default.a.bind('shift+i', function () {
        return Object(__WEBPACK_IMPORTED_MODULE_2__shortcuts_dashboard_navigation__["a" /* default */])('.dashboard-shortcuts-issues');
      });
      __WEBPACK_IMPORTED_MODULE_1_mousetrap___default.a.bind('shift+m', function () {
        return Object(__WEBPACK_IMPORTED_MODULE_2__shortcuts_dashboard_navigation__["a" /* default */])('.dashboard-shortcuts-merge_requests');
      });
      __WEBPACK_IMPORTED_MODULE_1_mousetrap___default.a.bind('shift+p', function () {
        return Object(__WEBPACK_IMPORTED_MODULE_2__shortcuts_dashboard_navigation__["a" /* default */])('.dashboard-shortcuts-projects');
      });
      __WEBPACK_IMPORTED_MODULE_1_mousetrap___default.a.bind('shift+g', function () {
        return Object(__WEBPACK_IMPORTED_MODULE_2__shortcuts_dashboard_navigation__["a" /* default */])('.dashboard-shortcuts-groups');
      });
      __WEBPACK_IMPORTED_MODULE_1_mousetrap___default.a.bind('shift+l', function () {
        return Object(__WEBPACK_IMPORTED_MODULE_2__shortcuts_dashboard_navigation__["a" /* default */])('.dashboard-shortcuts-milestones');
      });
      __WEBPACK_IMPORTED_MODULE_1_mousetrap___default.a.bind('shift+s', function () {
        return Object(__WEBPACK_IMPORTED_MODULE_2__shortcuts_dashboard_navigation__["a" /* default */])('.dashboard-shortcuts-snippets');
      });

      __WEBPACK_IMPORTED_MODULE_1_mousetrap___default.a.bind(['ctrl+shift+p', 'command+shift+p'], this.toggleMarkdownPreview);
      if (typeof findFileURL !== "undefined" && findFileURL !== null) {
        __WEBPACK_IMPORTED_MODULE_1_mousetrap___default.a.bind('t', function () {
          return gl.utils.visitUrl(findFileURL);
        });
      }
    }

    Shortcuts.prototype.onToggleHelp = function (e) {
      e.preventDefault();
      return Shortcuts.toggleHelp(this.enabledHelp);
    };

    Shortcuts.prototype.onTogglePerfBar = function (e) {
      e.preventDefault();
      var performanceBarCookieName = 'perf_bar_enabled';
      if (__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(performanceBarCookieName) === 'true') {
        __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove(performanceBarCookieName, { path: '/' });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(performanceBarCookieName, 'true', { path: '/' });
      }
      gl.utils.refreshCurrentPage();
    };

    Shortcuts.prototype.toggleMarkdownPreview = function (e) {
      // Check if short-cut was triggered while in Write Mode
      var $target = $(e.target);
      var $form = $target.closest('form');

      if ($target.hasClass('js-note-text')) {
        $('.js-md-preview-button', $form).focus();
      }
      return $(document).triggerHandler('markdown-preview:toggle', [e]);
    };

    Shortcuts.toggleHelp = function (location) {
      var $modal;
      $modal = $('#modal-shortcuts');
      if ($modal.length) {
        $modal.modal('toggle');
        return;
      }
      return $.ajax({
        url: gon.shortcuts_path,
        dataType: 'script',
        success: function success(e) {
          var i, l, len, results;
          if (location && location.length > 0) {
            results = [];
            for (i = 0, len = location.length; i < len; i += 1) {
              l = location[i];
              results.push($(l).show());
            }
            return results;
          } else {
            $('.hidden-shortcut').show();
            return $('.js-more-help-button').remove();
          }
        }
      });
    };

    Shortcuts.prototype.focusFilter = function (e) {
      if (this.filterInput == null) {
        this.filterInput = $('input[type=search]', '.nav-controls');
      }
      this.filterInput.focus();
      return e.preventDefault();
    };

    Shortcuts.focusSearch = function (e) {
      $('#search').focus();
      return e.preventDefault();
    };

    return Shortcuts;
  }();

  $(document).on('click.more_help', '.js-more-help-button', function (e) {
    $(this).remove();
    $('.hidden-shortcut').show();
    return e.preventDefault();
  });

  __WEBPACK_IMPORTED_MODULE_1_mousetrap___default.a.stopCallback = function () {
    var defaultStopCallback;
    defaultStopCallback = __WEBPACK_IMPORTED_MODULE_1_mousetrap___default.a.stopCallback;
    return function (e, element, combo) {
      // allowed shortcuts if textarea, input, contenteditable are focused
      if (['ctrl+shift+p', 'command+shift+p'].indexOf(combo) !== -1) {
        return false;
      } else {
        return defaultStopCallback.apply(this, arguments);
      }
    };
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./shortcuts_blob.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shortcuts__ = __webpack_require__("./shortcuts.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* global Mousetrap */
/* global Shortcuts */



var defaults = {
  skipResetBindings: false,
  fileBlobPermalinkUrl: null
};

var ShortcutsBlob = function (_Shortcuts) {
  _inherits(ShortcutsBlob, _Shortcuts);

  function ShortcutsBlob(opts) {
    _classCallCheck(this, ShortcutsBlob);

    var options = Object.assign({}, defaults, opts);

    var _this = _possibleConstructorReturn(this, (ShortcutsBlob.__proto__ || Object.getPrototypeOf(ShortcutsBlob)).call(this, options.skipResetBindings));

    _this.options = options;

    Mousetrap.bind('y', _this.moveToFilePermalink.bind(_this));
    return _this;
  }

  _createClass(ShortcutsBlob, [{
    key: 'moveToFilePermalink',
    value: function moveToFilePermalink() {
      if (this.options.fileBlobPermalinkUrl) {
        var hash = gl.utils.getLocationHash();
        var hashUrlString = hash ? '#' + hash : '';
        gl.utils.visitUrl('' + this.options.fileBlobPermalinkUrl + hashUrlString);
      }
    }
  }]);

  return ShortcutsBlob;
}(Shortcuts);

/* harmony default export */ __webpack_exports__["a"] = (ShortcutsBlob);

/***/ }),

/***/ "./shortcuts_dashboard_navigation.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Helper function that finds the href of the fiven selector and updates the location.
 *
 * @param  {String} selector
 */
/* harmony default export */ __webpack_exports__["a"] = (function (selector) {
  var link = document.querySelector(selector).getAttribute('href');

  if (link) {
    window.location = link;
  }
});

/***/ }),

/***/ "./shortcuts_find_file.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shortcuts_navigation__ = __webpack_require__("./shortcuts_navigation.js");
/* eslint-disable func-names, space-before-function-paren, max-len, one-var, no-var, no-restricted-syntax, vars-on-top, no-use-before-define, no-param-reassign, new-cap, no-underscore-dangle, wrap-iife */
/* global Mousetrap */
/* global ShortcutsNavigation */



(function () {
  var extend = function extend(child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }function ctor() {
      this.constructor = child;
    }ctor.prototype = parent.prototype;child.prototype = new ctor();child.__super__ = parent.prototype;return child;
  },
      hasProp = {}.hasOwnProperty;

  this.ShortcutsFindFile = function (superClass) {
    extend(ShortcutsFindFile, superClass);

    function ShortcutsFindFile(projectFindFile) {
      var _oldStopCallback;
      this.projectFindFile = projectFindFile;
      ShortcutsFindFile.__super__.constructor.call(this);
      _oldStopCallback = Mousetrap.stopCallback;
      Mousetrap.stopCallback = function (_this) {
        // override to fire shortcuts action when focus in textbox
        return function (event, element, combo) {
          if (element === _this.projectFindFile.inputElement[0] && (combo === 'up' || combo === 'down' || combo === 'esc' || combo === 'enter')) {
            // when press up/down key in textbox, cusor prevent to move to home/end
            event.preventDefault();
            return false;
          }
          return _oldStopCallback(event, element, combo);
        };
      }(this);
      Mousetrap.bind('up', this.projectFindFile.selectRowUp);
      Mousetrap.bind('down', this.projectFindFile.selectRowDown);
      Mousetrap.bind('esc', this.projectFindFile.goToTree);
      Mousetrap.bind('enter', this.projectFindFile.goToBlob);
    }

    return ShortcutsFindFile;
  }(ShortcutsNavigation);
}).call(window);

/***/ }),

/***/ "./shortcuts_issuable.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mousetrap__ = __webpack_require__("../../../node_modules/mousetrap/mousetrap.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mousetrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mousetrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shortcuts_navigation__ = __webpack_require__("./shortcuts_navigation.js");
/* eslint-disable func-names, space-before-function-paren, max-len, no-var, one-var, no-restricted-syntax, vars-on-top, no-use-before-define, no-param-reassign, new-cap, no-underscore-dangle, wrap-iife, one-var-declaration-per-line, quotes, prefer-arrow-callback, consistent-return, prefer-template, no-mixed-operators */
/* global Mousetrap */
/* global ShortcutsNavigation */
/* global sidebar */





(function () {
  var extend = function extend(child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }function ctor() {
      this.constructor = child;
    }ctor.prototype = parent.prototype;child.prototype = new ctor();child.__super__ = parent.prototype;return child;
  },
      hasProp = {}.hasOwnProperty;

  this.ShortcutsIssuable = function (superClass) {
    extend(ShortcutsIssuable, superClass);

    function ShortcutsIssuable(isMergeRequest) {
      ShortcutsIssuable.__super__.constructor.call(this);
      Mousetrap.bind('a', this.openSidebarDropdown.bind(this, 'assignee'));
      Mousetrap.bind('m', this.openSidebarDropdown.bind(this, 'milestone'));
      Mousetrap.bind('r', function (_this) {
        return function () {
          _this.replyWithSelectedText(isMergeRequest);
          return false;
        };
      }(this));
      Mousetrap.bind('e', function (_this) {
        return function () {
          _this.editIssue();
          return false;
        };
      }(this));
      Mousetrap.bind('l', this.openSidebarDropdown.bind(this, 'labels'));
      if (isMergeRequest) {
        this.enabledHelp.push('.hidden-shortcut.merge_requests');
      } else {
        this.enabledHelp.push('.hidden-shortcut.issues');
      }
    }

    ShortcutsIssuable.prototype.replyWithSelectedText = function (isMergeRequest) {
      var quote, documentFragment, el, selected, separator;
      var replyField = void 0;

      if (isMergeRequest) {
        replyField = $('.js-main-target-form #note_note');
      } else {
        replyField = $('.js-main-target-form .js-vue-comment-form');
      }

      documentFragment = window.gl.utils.getSelectedFragment();
      if (!documentFragment) {
        replyField.focus();
        return;
      }

      el = window.gl.CopyAsGFM.transformGFMSelection(documentFragment.cloneNode(true));
      selected = window.gl.CopyAsGFM.nodeToGFM(el);

      if (selected.trim() === "") {
        return;
      }
      quote = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.map(selected.split("\n"), function (val) {
        return ("> " + val).trim() + "\n";
      });

      // If replyField already has some content, add a newline before our quote
      separator = replyField.val().trim() !== "" && "\n\n" || '';
      replyField.val(function (a, current) {
        return current + separator + quote.join('') + "\n";
      });

      // Trigger autosave
      replyField.trigger('input').trigger('change');

      // Trigger autosize
      var event = document.createEvent('Event');
      event.initEvent('autosize:update', true, false);
      replyField.get(0).dispatchEvent(event);

      // Focus the input field
      return replyField.focus();
    };

    ShortcutsIssuable.prototype.editIssue = function () {
      var $editBtn;
      $editBtn = $('.issuable-edit');
      // Need to click the element as on issues, editing is inline
      // on merge request, editing is on a different page
      $editBtn.get(0).click();
    };

    ShortcutsIssuable.prototype.openSidebarDropdown = function (name) {
      sidebar.openDropdown(name);
      return false;
    };

    return ShortcutsIssuable;
  }(ShortcutsNavigation);
}).call(window);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./shortcuts_navigation.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__ = __webpack_require__("./shortcuts_dashboard_navigation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shortcuts__ = __webpack_require__("./shortcuts.js");
/* eslint-disable func-names, space-before-function-paren, max-len, no-var, one-var, no-restricted-syntax, vars-on-top, no-use-before-define, no-param-reassign, new-cap, no-underscore-dangle, wrap-iife, prefer-arrow-callback, consistent-return, no-return-assign */
/* global Mousetrap */
/* global Shortcuts */




(function () {
  var extend = function extend(child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }function ctor() {
      this.constructor = child;
    }ctor.prototype = parent.prototype;child.prototype = new ctor();child.__super__ = parent.prototype;return child;
  },
      hasProp = {}.hasOwnProperty;

  this.ShortcutsNavigation = function (superClass) {
    extend(ShortcutsNavigation, superClass);

    function ShortcutsNavigation() {
      ShortcutsNavigation.__super__.constructor.call(this);
      Mousetrap.bind('g p', function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-project');
      });
      Mousetrap.bind('g e', function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-project-activity');
      });
      Mousetrap.bind('g f', function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-tree');
      });
      Mousetrap.bind('g c', function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-commits');
      });
      Mousetrap.bind('g j', function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-builds');
      });
      Mousetrap.bind('g n', function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-network');
      });
      Mousetrap.bind('g d', function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-repository-charts');
      });
      Mousetrap.bind('g i', function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-issues');
      });
      Mousetrap.bind('g b', function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-issue-boards');
      });
      Mousetrap.bind('g m', function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-merge_requests');
      });
      Mousetrap.bind('g t', function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-todos');
      });
      Mousetrap.bind('g w', function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-wiki');
      });
      Mousetrap.bind('g s', function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-snippets');
      });
      Mousetrap.bind('i', function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-new-issue');
      });
      this.enabledHelp.push('.hidden-shortcut.project');
    }

    return ShortcutsNavigation;
  }(Shortcuts);
}).call(window);

/***/ }),

/***/ "./shortcuts_network.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shortcuts_navigation__ = __webpack_require__("./shortcuts_navigation.js");
/* eslint-disable func-names, space-before-function-paren, max-len, no-var, one-var, no-restricted-syntax, vars-on-top, no-use-before-define, no-param-reassign, new-cap, no-underscore-dangle, wrap-iife, max-len */
/* global Mousetrap */
/* global ShortcutsNavigation */



(function () {
  var extend = function extend(child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }function ctor() {
      this.constructor = child;
    }ctor.prototype = parent.prototype;child.prototype = new ctor();child.__super__ = parent.prototype;return child;
  },
      hasProp = {}.hasOwnProperty;

  this.ShortcutsNetwork = function (superClass) {
    extend(ShortcutsNetwork, superClass);

    function ShortcutsNetwork(graph) {
      this.graph = graph;
      ShortcutsNetwork.__super__.constructor.call(this);
      Mousetrap.bind(['left', 'h'], this.graph.scrollLeft);
      Mousetrap.bind(['right', 'l'], this.graph.scrollRight);
      Mousetrap.bind(['up', 'k'], this.graph.scrollUp);
      Mousetrap.bind(['down', 'j'], this.graph.scrollDown);
      Mousetrap.bind(['shift+up', 'shift+k'], this.graph.scrollTop);
      Mousetrap.bind(['shift+down', 'shift+j'], this.graph.scrollBottom);
      this.enabledHelp.push('.hidden-shortcut.network');
    }

    return ShortcutsNetwork;
  }(ShortcutsNavigation);
}).call(window);

/***/ }),

/***/ "./shortcuts_wiki.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__ = __webpack_require__("./shortcuts_dashboard_navigation.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable class-methods-use-this */
/* global Mousetrap */
/* global ShortcutsNavigation */



var ShortcutsWiki = function (_ShortcutsNavigation) {
  _inherits(ShortcutsWiki, _ShortcutsNavigation);

  function ShortcutsWiki() {
    _classCallCheck(this, ShortcutsWiki);

    var _this = _possibleConstructorReturn(this, (ShortcutsWiki.__proto__ || Object.getPrototypeOf(ShortcutsWiki)).call(this));

    Mousetrap.bind('e', _this.editWiki);
    return _this;
  }

  _createClass(ShortcutsWiki, [{
    key: 'editWiki',
    value: function editWiki() {
      Object(__WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__["a" /* default */])('.js-wiki-edit');
    }
  }]);

  return ShortcutsWiki;
}(ShortcutsNavigation);

/* harmony default export */ __webpack_exports__["a"] = (ShortcutsWiki);

/***/ }),

/***/ "./signin_tabs_memoizer.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_accessor__ = __webpack_require__("./lib/utils/accessor.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint no-param-reassign: ["error", { "props": false }]*/
/* eslint no-new: "off" */


/**
 * Memorize the last selected tab after reloading a page.
 * Does that setting the current selected tab in the localStorage
 */

var SigninTabsMemoizer = function () {
  function SigninTabsMemoizer() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$currentTabKey = _ref.currentTabKey,
        currentTabKey = _ref$currentTabKey === undefined ? 'current_signin_tab' : _ref$currentTabKey,
        _ref$tabSelector = _ref.tabSelector,
        tabSelector = _ref$tabSelector === undefined ? 'ul.nav-tabs' : _ref$tabSelector;

    _classCallCheck(this, SigninTabsMemoizer);

    this.currentTabKey = currentTabKey;
    this.tabSelector = tabSelector;
    this.isLocalStorageAvailable = __WEBPACK_IMPORTED_MODULE_0__lib_utils_accessor__["a" /* default */].isLocalStorageAccessSafe();

    this.bootstrap();
  }

  _createClass(SigninTabsMemoizer, [{
    key: 'bootstrap',
    value: function bootstrap() {
      var _this = this;

      var tabs = document.querySelectorAll(this.tabSelector);
      if (tabs.length > 0) {
        tabs[0].addEventListener('click', function (e) {
          if (e.target && e.target.nodeName === 'A') {
            var anchorName = e.target.getAttribute('href');
            _this.saveData(anchorName);
          }
        });
      }

      this.showTab();
    }
  }, {
    key: 'showTab',
    value: function showTab() {
      var anchorName = this.readData();
      if (anchorName) {
        var tab = document.querySelector(this.tabSelector + ' a[href="' + anchorName + '"]');
        if (tab) {
          tab.click();
        }
      }
    }
  }, {
    key: 'saveData',
    value: function saveData(val) {
      if (!this.isLocalStorageAvailable) return undefined;

      return window.localStorage.setItem(this.currentTabKey, val);
    }
  }, {
    key: 'readData',
    value: function readData() {
      if (!this.isLocalStorageAvailable) return null;

      return window.localStorage.getItem(this.currentTabKey);
    }
  }]);

  return SigninTabsMemoizer;
}();

/* harmony default export */ __webpack_exports__["a"] = (SigninTabsMemoizer);

/***/ }),

/***/ "./single_file_diff.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__files_comment_button__ = __webpack_require__("./files_comment_button.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__image_diff_helpers_index__ = __webpack_require__("./image_diff/helpers/index.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable func-names, prefer-arrow-callback, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, one-var, one-var-declaration-per-line, consistent-return, no-param-reassign, max-len */




var WRAPPER = '<div class="diff-content"></div>';
var LOADING_HTML = '<i class="fa fa-spinner fa-spin"></i>';
var ERROR_HTML = '<div class="nothing-here-block"><i class="fa fa-warning"></i> Could not load diff</div>';
var COLLAPSED_HTML = '<div class="nothing-here-block diff-collapsed">This diff is collapsed. <a class="click-to-expand">Click to expand it.</a></div>';

var SingleFileDiff = function () {
  function SingleFileDiff(file) {
    _classCallCheck(this, SingleFileDiff);

    this.file = file;
    this.toggleDiff = this.toggleDiff.bind(this);
    this.content = $('.diff-content', this.file);
    this.$toggleIcon = $('.diff-toggle-caret', this.file);
    this.diffForPath = this.content.find('[data-diff-for-path]').data('diff-for-path');
    this.isOpen = !this.diffForPath;
    if (this.diffForPath) {
      this.collapsedContent = this.content;
      this.loadingContent = $(WRAPPER).addClass('loading').html(LOADING_HTML).hide();
      this.content = null;
      this.collapsedContent.after(this.loadingContent);
      this.$toggleIcon.addClass('fa-caret-right');
    } else {
      this.collapsedContent = $(WRAPPER).html(COLLAPSED_HTML).hide();
      this.content.after(this.collapsedContent);
      this.$toggleIcon.addClass('fa-caret-down');
    }

    $('.js-file-title, .click-to-expand', this.file).on('click', function (e) {
      this.toggleDiff($(e.target));
    }.bind(this));
  }

  _createClass(SingleFileDiff, [{
    key: 'toggleDiff',
    value: function toggleDiff($target, cb) {
      if (!$target.hasClass('js-file-title') && !$target.hasClass('click-to-expand') && !$target.hasClass('diff-toggle-caret')) return;
      this.isOpen = !this.isOpen;
      if (!this.isOpen && !this.hasError) {
        this.content.hide();
        this.$toggleIcon.addClass('fa-caret-right').removeClass('fa-caret-down');
        this.collapsedContent.show();
        if (typeof gl.diffNotesCompileComponents !== 'undefined') {
          gl.diffNotesCompileComponents();
        }
      } else if (this.content) {
        this.collapsedContent.hide();
        this.content.show();
        this.$toggleIcon.addClass('fa-caret-down').removeClass('fa-caret-right');
        if (typeof gl.diffNotesCompileComponents !== 'undefined') {
          gl.diffNotesCompileComponents();
        }
      } else {
        this.$toggleIcon.addClass('fa-caret-down').removeClass('fa-caret-right');
        return this.getContentHTML(cb);
      }
    }
  }, {
    key: 'getContentHTML',
    value: function getContentHTML(cb) {
      this.collapsedContent.hide();
      this.loadingContent.show();
      $.get(this.diffForPath, function (_this) {
        return function (data) {
          _this.loadingContent.hide();
          if (data.html) {
            _this.content = $(data.html);
            _this.content.syntaxHighlight();
          } else {
            _this.hasError = true;
            _this.content = $(ERROR_HTML);
          }
          _this.collapsedContent.after(_this.content);

          if (typeof gl.diffNotesCompileComponents !== 'undefined') {
            gl.diffNotesCompileComponents();
          }

          var $file = $(_this.file);
          __WEBPACK_IMPORTED_MODULE_0__files_comment_button__["a" /* default */].init($file);

          var canCreateNote = $file.closest('.files').is('[data-can-create-note]');
          __WEBPACK_IMPORTED_MODULE_1__image_diff_helpers_index__["a" /* default */].initImageDiff($file[0], canCreateNote);

          if (cb) cb();
        };
      }(this));
    }
  }]);

  return SingleFileDiff;
}();

/* harmony default export */ __webpack_exports__["a"] = (SingleFileDiff);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./smart_interval.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Instances of SmartInterval extend the functionality of `setInterval`, make it configurable
 * and controllable by a public API.
 */

var SmartInterval = function () {
  /**
   * @param { function } opts.callback Function to be called on each iteration (required)
   * @param { milliseconds } opts.startingInterval `currentInterval` is set to this initially
   * @param { milliseconds } opts.maxInterval `currentInterval` will be incremented to this
   * @param { milliseconds } opts.hiddenInterval `currentInterval` is set to this
   *                         when the page is hidden
   * @param { integer } opts.incrementByFactorOf `currentInterval` is incremented by this factor
   * @param { boolean } opts.lazyStart Configure if timer is initialized on
   *                    instantiation or lazily
   * @param { boolean } opts.immediateExecution Configure if callback should
   *                    be executed before the first interval.
   */
  function SmartInterval() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, SmartInterval);

    this.cfg = {
      callback: opts.callback,
      startingInterval: opts.startingInterval,
      maxInterval: opts.maxInterval,
      hiddenInterval: opts.hiddenInterval,
      incrementByFactorOf: opts.incrementByFactorOf,
      lazyStart: opts.lazyStart,
      immediateExecution: opts.immediateExecution
    };

    this.state = {
      intervalId: null,
      currentInterval: this.cfg.startingInterval,
      pageVisibility: 'visible'
    };

    this.initInterval();
  }

  /* public */

  _createClass(SmartInterval, [{
    key: 'start',
    value: function start() {
      var _this = this;

      var cfg = this.cfg;
      var state = this.state;

      if (cfg.immediateExecution) {
        cfg.immediateExecution = false;
        cfg.callback();
      }

      state.intervalId = window.setInterval(function () {
        cfg.callback();

        if (_this.getCurrentInterval() === cfg.maxInterval) {
          return;
        }

        _this.incrementInterval();
        _this.resume();
      }, this.getCurrentInterval());
    }

    // cancel the existing timer, setting the currentInterval back to startingInterval

  }, {
    key: 'cancel',
    value: function cancel() {
      this.setCurrentInterval(this.cfg.startingInterval);
      this.stopTimer();
    }
  }, {
    key: 'onVisibilityHidden',
    value: function onVisibilityHidden() {
      if (this.cfg.hiddenInterval) {
        this.setCurrentInterval(this.cfg.hiddenInterval);
        this.resume();
      } else {
        this.cancel();
      }
    }

    // start a timer, using the existing interval

  }, {
    key: 'resume',
    value: function resume() {
      this.stopTimer(); // stop exsiting timer, in case timer was not previously stopped
      this.start();
    }
  }, {
    key: 'onVisibilityVisible',
    value: function onVisibilityVisible() {
      this.cancel();
      this.start();
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.cancel();
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      $(document).off('visibilitychange').off('beforeunload');
    }

    /* private */

  }, {
    key: 'initInterval',
    value: function initInterval() {
      var cfg = this.cfg;

      if (!cfg.lazyStart) {
        this.start();
      }

      this.initVisibilityChangeHandling();
      this.initPageUnloadHandling();
    }
  }, {
    key: 'initVisibilityChangeHandling',
    value: function initVisibilityChangeHandling() {
      // cancel interval when tab no longer shown (prevents cached pages from polling)
      document.addEventListener('visibilitychange', this.handleVisibilityChange.bind(this));
    }
  }, {
    key: 'initPageUnloadHandling',
    value: function initPageUnloadHandling() {
      var _this2 = this;

      // TODO: Consider refactoring in light of turbolinks removal.
      // prevent interval continuing after page change, when kept in cache by Turbolinks
      $(document).on('beforeunload', function () {
        return _this2.cancel();
      });
    }
  }, {
    key: 'handleVisibilityChange',
    value: function handleVisibilityChange(e) {
      this.state.pageVisibility = e.target.visibilityState;
      var intervalAction = this.isPageVisible() ? this.onVisibilityVisible : this.onVisibilityHidden;

      intervalAction.apply(this);
    }
  }, {
    key: 'getCurrentInterval',
    value: function getCurrentInterval() {
      return this.state.currentInterval;
    }
  }, {
    key: 'setCurrentInterval',
    value: function setCurrentInterval(newInterval) {
      this.state.currentInterval = newInterval;
    }
  }, {
    key: 'incrementInterval',
    value: function incrementInterval() {
      var cfg = this.cfg;
      var currentInterval = this.getCurrentInterval();
      if (cfg.hiddenInterval && !this.isPageVisible()) return;
      var nextInterval = currentInterval * cfg.incrementByFactorOf;

      if (nextInterval > cfg.maxInterval) {
        nextInterval = cfg.maxInterval;
      }

      this.setCurrentInterval(nextInterval);
    }
  }, {
    key: 'isPageVisible',
    value: function isPageVisible() {
      return this.state.pageVisibility === 'visible';
    }
  }, {
    key: 'stopTimer',
    value: function stopTimer() {
      var state = this.state;

      state.intervalId = window.clearInterval(state.intervalId);
    }
  }]);

  return SmartInterval;
}();

window.gl.SmartInterval = SmartInterval;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./star.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__("./locale/index.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-unused-vars, one-var, no-var, one-var-declaration-per-line, prefer-arrow-callback, no-new, max-len */
/* global Flash */



var Star = function Star() {
  _classCallCheck(this, Star);

  $('.project-home-panel .toggle-star').on('ajax:success', function (e, data, status, xhr) {
    var $starIcon, $starSpan, $this, toggleStar;
    $this = $(this);
    $starSpan = $this.find('span');
    $starIcon = $this.find('i');
    toggleStar = function toggleStar(isStarred) {
      $this.parent().find('.star-count').text(data.star_count);
      if (isStarred) {
        $starSpan.removeClass('starred').text(Object(__WEBPACK_IMPORTED_MODULE_0__locale__["s__"])('StarProject|Star'));
        $starIcon.removeClass('fa-star').addClass('fa-star-o');
      } else {
        $starSpan.addClass('starred').text(Object(__WEBPACK_IMPORTED_MODULE_0__locale__["__"])('Unstar'));
        $starIcon.removeClass('fa-star-o').addClass('fa-star');
      }
    };
    toggleStar($starSpan.hasClass('starred'));
  }).on('ajax:error', function (e, xhr, status, error) {
    new Flash('Star toggle failed. Try again later.', 'alert');
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Star);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./subscription.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Subscription = function () {
  function Subscription(containerElm) {
    _classCallCheck(this, Subscription);

    this.containerElm = containerElm;

    var subscribeButton = containerElm.querySelector('.js-subscribe-button');
    if (subscribeButton) {
      // remove class so we don't bind twice
      subscribeButton.classList.remove('js-subscribe-button');
      subscribeButton.addEventListener('click', this.toggleSubscription.bind(this));
    }
  }

  _createClass(Subscription, [{
    key: 'toggleSubscription',
    value: function toggleSubscription(event) {
      var button = event.currentTarget;
      var buttonSpan = button.querySelector('span');
      if (!buttonSpan || button.classList.contains('disabled')) {
        return;
      }
      button.classList.add('disabled');

      // hack to allow this to work with the issue boards Vue object
      var isBoardsPage = document.querySelector('html').classList.contains('issue-boards-page');

      var isSubscribed = buttonSpan.innerHTML.trim().toLowerCase() !== 'subscribe';
      var toggleActionUrl = this.containerElm.dataset.url;

      if (isBoardsPage) {
        toggleActionUrl = toggleActionUrl.replace(':project_path', gl.issueBoards.BoardsStore.detail.issue.project.path);
      }

      $.post(toggleActionUrl, function () {
        button.classList.remove('disabled');

        if (isBoardsPage) {
          gl.issueBoards.boardStoreIssueSet('subscribed', !gl.issueBoards.BoardsStore.detail.issue.subscribed);
        } else {
          buttonSpan.innerHTML = isSubscribed ? 'Subscribe' : 'Unsubscribe';
        }
      });
    }
  }], [{
    key: 'bindAll',
    value: function bindAll(selector) {
      [].forEach.call(document.querySelectorAll(selector), function (elm) {
        return new Subscription(elm);
      });
    }
  }]);

  return Subscription;
}();

window.gl = window.gl || {};
window.gl.Subscription = Subscription;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./subscription_select.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, quotes, object-shorthand, no-unused-vars, no-shadow, one-var, one-var-declaration-per-line, comma-dangle, max-len */

var SubscriptionSelect = function SubscriptionSelect() {
  _classCallCheck(this, SubscriptionSelect);

  $('.js-subscription-event').each(function (i, el) {
    var fieldName;
    fieldName = $(el).data("field-name");
    return $(el).glDropdown({
      selectable: true,
      fieldName: fieldName,
      toggleLabel: function (_this) {
        return function (selected, el, instance) {
          var $item, label;
          label = 'Subscription';
          $item = instance.dropdown.find('.is-active');
          if ($item.length) {
            label = $item.text();
          }
          return label;
        };
      }(this),
      clicked: function clicked(options) {
        return options.e.preventDefault();
      },
      id: function id(obj, el) {
        return $(el).data("id");
      }
    });
  });
};

window.SubscriptionSelect = SubscriptionSelect;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./syntax_highlight.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, consistent-return, no-var, no-else-return, prefer-arrow-callback, max-len */

// Syntax Highlighter
//
// Applies a syntax highlighting color scheme CSS class to any element with the
// `js-syntax-highlight` class
//
// ### Example Markup
//
//   <div class="js-syntax-highlight"></div>
//

$.fn.syntaxHighlight = function () {
  var $children;

  if ($(this).hasClass('js-syntax-highlight')) {
    // Given the element itself, apply highlighting
    return $(this).addClass(gon.user_color_scheme);
  } else {
    // Given a parent element, recurse to any of its applicable children
    $children = $(this).find('.js-syntax-highlight');
    if ($children.length) {
      return $children.syntaxHighlight();
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./task_list.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_deckar01_task_list__ = __webpack_require__("../../../node_modules/deckar01-task_list/dist/task_list.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_deckar01_task_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_deckar01_task_list__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global Flash */



var TaskList = function () {
  function TaskList() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, TaskList);

    this.selector = options.selector;
    this.dataType = options.dataType;
    this.fieldName = options.fieldName;
    this.onSuccess = options.onSuccess || function () {};
    this.onError = function showFlash(response) {
      var errorMessages = '';

      if (response.responseJSON) {
        errorMessages = response.responseJSON.errors.join(' ');
      }

      return new Flash(errorMessages || 'Update failed', 'alert');
    };

    this.init();
  }

  _createClass(TaskList, [{
    key: 'init',
    value: function init() {
      // Prevent duplicate event bindings
      this.disable();
      $(this.selector + ' .js-task-list-container').taskList('enable');
      $(document).on('tasklist:changed', this.selector + ' .js-task-list-container', this.update.bind(this));
    }
  }, {
    key: 'disable',
    value: function disable() {
      $(this.selector + ' .js-task-list-container').taskList('disable');
      $(document).off('tasklist:changed', this.selector + ' .js-task-list-container');
    }
  }, {
    key: 'update',
    value: function update(e) {
      var $target = $(e.target);
      var patchData = {};
      patchData[this.dataType] = _defineProperty({}, this.fieldName, $target.val());
      return $.ajax({
        type: 'PATCH',
        url: $target.data('update-url') || $('form.js-issuable-update').attr('action'),
        data: patchData,
        success: this.onSuccess,
        error: this.onError
      });
    }
  }]);

  return TaskList;
}();

/* harmony default export */ __webpack_exports__["a"] = (TaskList);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./templates/issuable_template_selector.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("./api.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__blob_template_selector__ = __webpack_require__("./blob/template_selector.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable comma-dangle, max-len, no-useless-return, no-param-reassign, max-len */




(function (global) {
  var IssuableTemplateSelector = function (_TemplateSelector) {
    _inherits(IssuableTemplateSelector, _TemplateSelector);

    function IssuableTemplateSelector() {
      var _ref;

      _classCallCheck(this, IssuableTemplateSelector);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var _this = _possibleConstructorReturn(this, (_ref = IssuableTemplateSelector.__proto__ || Object.getPrototypeOf(IssuableTemplateSelector)).call.apply(_ref, [this].concat(args)));

      _this.projectPath = _this.dropdown.data('project-path');
      _this.namespacePath = _this.dropdown.data('namespace-path');
      _this.issuableType = _this.$dropdownContainer.data('issuable-type');
      _this.titleInput = $('#' + _this.issuableType + '_title');

      var initialQuery = {
        name: _this.dropdown.data('selected')
      };

      if (initialQuery.name) _this.requestFile(initialQuery);

      $('.reset-template', _this.dropdown.parent()).on('click', function () {
        _this.setInputValueToTemplateContent();
      });

      $('.no-template', _this.dropdown.parent()).on('click', function () {
        _this.currentTemplate.content = '';
        _this.setInputValueToTemplateContent();
        $('.dropdown-toggle-text', _this.dropdown).text('Choose a template');
      });
      return _this;
    }

    _createClass(IssuableTemplateSelector, [{
      key: 'requestFile',
      value: function requestFile(query) {
        var _this2 = this;

        this.startLoadingSpinner();
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].issueTemplate(this.namespacePath, this.projectPath, query.name, this.issuableType, function (err, currentTemplate) {
          _this2.currentTemplate = currentTemplate;
          if (err) return; // Error handled by global AJAX error handler
          _this2.stopLoadingSpinner();
          _this2.setInputValueToTemplateContent();
        });
        return;
      }
    }, {
      key: 'setInputValueToTemplateContent',
      value: function setInputValueToTemplateContent() {
        // `this.setEditorContent` sets the value of the description input field
        // to the content of the template selected.
        if (this.titleInput.val() === '') {
          // If the title has not yet been set, focus the title input and
          // skip focusing the description input by setting `true` as the
          // `skipFocus` option to `setEditorContent`.
          this.setEditorContent(this.currentTemplate, { skipFocus: true });
          this.titleInput.focus();
        } else {
          this.setEditorContent(this.currentTemplate, { skipFocus: false });
        }
        return;
      }
    }]);

    return IssuableTemplateSelector;
  }(__WEBPACK_IMPORTED_MODULE_1__blob_template_selector__["a" /* default */]);

  global.IssuableTemplateSelector = IssuableTemplateSelector;
})(window.gl || (window.gl = {}));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./templates/issuable_template_selectors.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-new, comma-dangle, class-methods-use-this, no-param-reassign */

(function (global) {
  var IssuableTemplateSelectors = function () {
    function IssuableTemplateSelectors() {
      var _this = this;

      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          $dropdowns = _ref.$dropdowns,
          editor = _ref.editor;

      _classCallCheck(this, IssuableTemplateSelectors);

      this.$dropdowns = $dropdowns || $('.js-issuable-selector');
      this.editor = editor || this.initEditor();

      this.$dropdowns.each(function (i, dropdown) {
        var $dropdown = $(dropdown);
        new gl.IssuableTemplateSelector({
          pattern: /(\.md)/,
          data: $dropdown.data('data'),
          wrapper: $dropdown.closest('.js-issuable-selector-wrap'),
          dropdown: $dropdown,
          editor: _this.editor
        });
      });
    }

    _createClass(IssuableTemplateSelectors, [{
      key: 'initEditor',
      value: function initEditor() {
        var editor = $('.markdown-area');
        // Proxy ace-editor's .setValue to jQuery's .val
        editor.setValue = editor.val;
        editor.getValue = editor.val;
        return editor;
      }
    }]);

    return IssuableTemplateSelectors;
  }();

  global.IssuableTemplateSelectors = IssuableTemplateSelectors;
})(window.gl || (window.gl = {}));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./todos.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__users_select__ = __webpack_require__("./users_select.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this, no-unneeded-ternary, quote-props */




var Todos = function () {
  function Todos() {
    _classCallCheck(this, Todos);

    this.initFilters();
    this.bindEvents();
    this.todo_ids = [];

    this.cleanupWrapper = this.cleanup.bind(this);
    document.addEventListener('beforeunload', this.cleanupWrapper);
  }

  _createClass(Todos, [{
    key: 'cleanup',
    value: function cleanup() {
      this.unbindEvents();
      document.removeEventListener('beforeunload', this.cleanupWrapper);
    }
  }, {
    key: 'unbindEvents',
    value: function unbindEvents() {
      $('.js-done-todo, .js-undo-todo, .js-add-todo').off('click', this.updateRowStateClickedWrapper);
      $('.js-todos-mark-all', '.js-todos-undo-all').off('click', this.updateallStateClickedWrapper);
      $('.todo').off('click', this.goToTodoUrl);
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      this.updateRowStateClickedWrapper = this.updateRowStateClicked.bind(this);
      this.updateAllStateClickedWrapper = this.updateAllStateClicked.bind(this);

      $('.js-done-todo, .js-undo-todo, .js-add-todo').on('click', this.updateRowStateClickedWrapper);
      $('.js-todos-mark-all, .js-todos-undo-all').on('click', this.updateAllStateClickedWrapper);
      $('.todo').on('click', this.goToTodoUrl);
    }
  }, {
    key: 'initFilters',
    value: function initFilters() {
      this.initFilterDropdown($('.js-project-search'), 'project_id', ['text']);
      this.initFilterDropdown($('.js-type-search'), 'type');
      this.initFilterDropdown($('.js-action-search'), 'action_id');

      return new __WEBPACK_IMPORTED_MODULE_0__users_select__["a" /* default */]();
    }
  }, {
    key: 'initFilterDropdown',
    value: function initFilterDropdown($dropdown, fieldName, searchFields) {
      $dropdown.glDropdown({
        fieldName: fieldName,
        selectable: true,
        filterable: searchFields ? true : false,
        search: { fields: searchFields },
        data: $dropdown.data('data'),
        clicked: function clicked() {
          return $dropdown.closest('form.filter-form').submit();
        }
      });
    }
  }, {
    key: 'updateRowStateClicked',
    value: function updateRowStateClicked(e) {
      var _this = this;

      e.stopPropagation();
      e.preventDefault();

      var target = e.target;
      target.setAttribute('disabled', true);
      target.classList.add('disabled');
      $.ajax({
        type: 'POST',
        url: target.dataset.href,
        dataType: 'json',
        data: {
          '_method': target.dataset.method
        },
        success: function success(data) {
          _this.updateRowState(target);
          return _this.updateBadges(data);
        }
      });
    }
  }, {
    key: 'updateRowState',
    value: function updateRowState(target) {
      var row = target.closest('li');
      var restoreBtn = row.querySelector('.js-undo-todo');
      var doneBtn = row.querySelector('.js-done-todo');

      target.classList.add('hidden');
      target.removeAttribute('disabled');
      target.classList.remove('disabled');

      if (target === doneBtn) {
        row.classList.add('done-reversible');
        restoreBtn.classList.remove('hidden');
      } else if (target === restoreBtn) {
        row.classList.remove('done-reversible');
        doneBtn.classList.remove('hidden');
      } else {
        row.parentNode.removeChild(row);
      }
    }
  }, {
    key: 'updateAllStateClicked',
    value: function updateAllStateClicked(e) {
      var _this2 = this;

      e.stopPropagation();
      e.preventDefault();

      var target = e.currentTarget;
      var requestData = { '_method': target.dataset.method, ids: this.todo_ids };
      target.setAttribute('disabled', true);
      target.classList.add('disabled');
      $.ajax({
        type: 'POST',
        url: target.dataset.href,
        dataType: 'json',
        data: requestData,
        success: function success(data) {
          _this2.updateAllState(target, data);
          return _this2.updateBadges(data);
        }
      });
    }
  }, {
    key: 'updateAllState',
    value: function updateAllState(target, data) {
      var markAllDoneBtn = document.querySelector('.js-todos-mark-all');
      var undoAllBtn = document.querySelector('.js-todos-undo-all');
      var todoListContainer = document.querySelector('.js-todos-list-container');
      var nothingHereContainer = document.querySelector('.js-nothing-here-container');

      target.removeAttribute('disabled');
      target.classList.remove('disabled');

      this.todo_ids = target === markAllDoneBtn ? data.updated_ids : [];
      undoAllBtn.classList.toggle('hidden');
      markAllDoneBtn.classList.toggle('hidden');
      todoListContainer.classList.toggle('hidden');
      nothingHereContainer.classList.toggle('hidden');
    }
  }, {
    key: 'updateBadges',
    value: function updateBadges(data) {
      $(document).trigger('todo:toggle', data.count);
      document.querySelector('.todos-pending .badge').innerHTML = data.count;
      document.querySelector('.todos-done .badge').innerHTML = data.done_count;
    }
  }, {
    key: 'goToTodoUrl',
    value: function goToTodoUrl(e) {
      var todoLink = this.dataset.url;

      if (!todoLink || e.target.tagName === 'A' || e.target.tagName === 'IMG') {
        return;
      }

      e.stopPropagation();
      e.preventDefault();

      if (Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils_common_utils__["p" /* isMetaClick */])(e)) {
        var windowTarget = '_blank';

        window.open(todoLink, windowTarget);
      } else {
        gl.utils.visitUrl(todoLink);
      }
    }
  }]);

  return Todos;
}();

/* harmony default export */ __webpack_exports__["a"] = (Todos);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./tree.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable func-names, space-before-function-paren, wrap-iife, max-len, quotes, consistent-return, no-var, one-var, one-var-declaration-per-line, no-else-return, prefer-arrow-callback, class-methods-use-this */

var TreeView = function () {
  function TreeView() {
    _classCallCheck(this, TreeView);

    this.initKeyNav();
    // Code browser tree slider
    // Make the entire tree-item row clickable, but not if clicking another link (like a commit message)
    $(".tree-content-holder .tree-item").on('click', function (e) {
      var $clickedEl, path;
      $clickedEl = $(e.target);
      path = $('.tree-item-file-name a', this).attr('href');
      if (!$clickedEl.is('a') && !$clickedEl.is('.str-truncated')) {
        if (e.metaKey || e.which === 2) {
          e.preventDefault();
          return window.open(path, '_blank');
        } else {
          return gl.utils.visitUrl(path);
        }
      }
    });
    // Show the "Loading commit data" for only the first element
    $('span.log_loading:first').removeClass('hide');
  }

  _createClass(TreeView, [{
    key: 'initKeyNav',
    value: function initKeyNav() {
      var li, liSelected;
      li = $("tr.tree-item");
      liSelected = null;
      return $('body').keydown(function (e) {
        var next, path;
        if ($("input:focus").length > 0 && (e.which === 38 || e.which === 40)) {
          return false;
        }
        if (e.which === 40) {
          if (liSelected) {
            next = liSelected.next();
            if (next.length > 0) {
              liSelected.removeClass("selected");
              liSelected = next.addClass("selected");
            }
          } else {
            liSelected = li.eq(0).addClass("selected");
          }
          return $(liSelected).focus();
        } else if (e.which === 38) {
          if (liSelected) {
            next = liSelected.prev();
            if (next.length > 0) {
              liSelected.removeClass("selected");
              liSelected = next.addClass("selected");
            }
          } else {
            liSelected = li.last().addClass("selected");
          }
          return $(liSelected).focus();
        } else if (e.which === 13) {
          path = $('.tree-item.selected .tree-item-file-name a').attr('href');
          if (path) {
            return gl.utils.visitUrl(path);
          }
        }
      });
    }
  }]);

  return TreeView;
}();

/* harmony default export */ __webpack_exports__["a"] = (TreeView);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./u2f/authenticate.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, prefer-arrow-callback, no-else-return, quotes, quote-props, comma-dangle, one-var, one-var-declaration-per-line, max-len */
/* global u2f */
/* global U2FError */
/* global U2FUtil */



// Authenticate U2F (universal 2nd factor) devices for users to authenticate with.
//
// State Flow #1: setup -> in_progress -> authenticated -> POST to server
// State Flow #2: setup -> in_progress -> error -> setup
(function () {
  var global = window.gl || (window.gl = {});

  global.U2FAuthenticate = function () {
    function U2FAuthenticate(container, form, u2fParams, fallbackButton, fallbackUI) {
      this.container = container;
      this.renderNotSupported = this.renderNotSupported.bind(this);
      this.renderAuthenticated = this.renderAuthenticated.bind(this);
      this.renderError = this.renderError.bind(this);
      this.renderInProgress = this.renderInProgress.bind(this);
      this.renderTemplate = this.renderTemplate.bind(this);
      this.authenticate = this.authenticate.bind(this);
      this.start = this.start.bind(this);
      this.appId = u2fParams.app_id;
      this.challenge = u2fParams.challenge;
      this.form = form;
      this.fallbackButton = fallbackButton;
      this.fallbackUI = fallbackUI;
      if (this.fallbackButton) this.fallbackButton.addEventListener('click', this.switchToFallbackUI.bind(this));
      this.signRequests = u2fParams.sign_requests.map(function (request) {
        // The U2F Javascript API v1.1 requires a single challenge, with
        // _no challenges per-request_. The U2F Javascript API v1.0 requires a
        // challenge per-request, which is done by copying the single challenge
        // into every request.
        //
        // In either case, we don't need the per-request challenges that the server
        // has generated, so we can remove them.
        //
        // Note: The server library fixes this behaviour in (unreleased) version 1.0.0.
        // This can be removed once we upgrade.
        // https://github.com/castle/ruby-u2f/commit/103f428071a81cd3d5f80c2e77d522d5029946a4
        return __WEBPACK_IMPORTED_MODULE_0_underscore___default()(request).omit('challenge');
      });
    }

    U2FAuthenticate.prototype.start = function () {
      if (U2FUtil.isU2FSupported()) {
        return this.renderInProgress();
      } else {
        return this.renderNotSupported();
      }
    };

    U2FAuthenticate.prototype.authenticate = function () {
      return u2f.sign(this.appId, this.challenge, this.signRequests, function (_this) {
        return function (response) {
          var error;
          if (response.errorCode) {
            error = new U2FError(response.errorCode, 'authenticate');
            return _this.renderError(error);
          } else {
            return _this.renderAuthenticated(JSON.stringify(response));
          }
        };
      }(this), 10);
    };

    // Rendering #
    U2FAuthenticate.prototype.templates = {
      "notSupported": "#js-authenticate-u2f-not-supported",
      "setup": '#js-authenticate-u2f-setup',
      "inProgress": '#js-authenticate-u2f-in-progress',
      "error": '#js-authenticate-u2f-error',
      "authenticated": '#js-authenticate-u2f-authenticated'
    };

    U2FAuthenticate.prototype.renderTemplate = function (name, params) {
      var template, templateString;
      templateString = $(this.templates[name]).html();
      template = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.template(templateString);
      return this.container.html(template(params));
    };

    U2FAuthenticate.prototype.renderInProgress = function () {
      this.renderTemplate('inProgress');
      return this.authenticate();
    };

    U2FAuthenticate.prototype.renderError = function (error) {
      this.renderTemplate('error', {
        error_message: error.message(),
        error_code: error.errorCode
      });
      return this.container.find('#js-u2f-try-again').on('click', this.renderInProgress);
    };

    U2FAuthenticate.prototype.renderAuthenticated = function (deviceResponse) {
      this.renderTemplate('authenticated');
      var container = this.container[0];
      container.querySelector('#js-device-response').value = deviceResponse;
      container.querySelector(this.form).submit();
      this.fallbackButton.classList.add('hidden');
    };

    U2FAuthenticate.prototype.renderNotSupported = function () {
      return this.renderTemplate('notSupported');
    };

    U2FAuthenticate.prototype.switchToFallbackUI = function () {
      this.fallbackButton.classList.add('hidden');
      this.container[0].classList.add('hidden');
      this.fallbackUI.classList.remove('hidden');
    };

    return U2FAuthenticate;
  }();
})();
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./u2f/error.js":
/***/ (function(module, exports) {

/* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, no-console, quotes, prefer-template, max-len */
/* global u2f */

(function () {
  this.U2FError = function () {
    function U2FError(errorCode, u2fFlowType) {
      this.errorCode = errorCode;
      this.message = this.message.bind(this);
      this.httpsDisabled = window.location.protocol !== 'https:';
      this.u2fFlowType = u2fFlowType;
    }

    U2FError.prototype.message = function () {
      if (this.errorCode === u2f.ErrorCodes.BAD_REQUEST && this.httpsDisabled) {
        return 'U2F only works with HTTPS-enabled websites. Contact your administrator for more details.';
      } else if (this.errorCode === u2f.ErrorCodes.DEVICE_INELIGIBLE) {
        if (this.u2fFlowType === 'authenticate') return 'This device has not been registered with us.';
        if (this.u2fFlowType === 'register') return 'This device has already been registered with us.';
      }
      return "There was a problem communicating with your device.";
    };

    return U2FError;
  }();
}).call(window);

/***/ }),

/***/ "./u2f/register.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, no-else-return, quotes, quote-props, comma-dangle, one-var, one-var-declaration-per-line, max-len */
/* global u2f */
/* global U2FError */
/* global U2FUtil */



// Register U2F (universal 2nd factor) devices for users to authenticate with.
//
// State Flow #1: setup -> in_progress -> registered -> POST to server
// State Flow #2: setup -> in_progress -> error -> setup
(function () {
  this.U2FRegister = function () {
    function U2FRegister(container, u2fParams) {
      this.container = container;
      this.renderNotSupported = this.renderNotSupported.bind(this);
      this.renderRegistered = this.renderRegistered.bind(this);
      this.renderError = this.renderError.bind(this);
      this.renderInProgress = this.renderInProgress.bind(this);
      this.renderSetup = this.renderSetup.bind(this);
      this.renderTemplate = this.renderTemplate.bind(this);
      this.register = this.register.bind(this);
      this.start = this.start.bind(this);
      this.appId = u2fParams.app_id;
      this.registerRequests = u2fParams.register_requests;
      this.signRequests = u2fParams.sign_requests;
    }

    U2FRegister.prototype.start = function () {
      if (U2FUtil.isU2FSupported()) {
        return this.renderSetup();
      } else {
        return this.renderNotSupported();
      }
    };

    U2FRegister.prototype.register = function () {
      return u2f.register(this.appId, this.registerRequests, this.signRequests, function (_this) {
        return function (response) {
          var error;
          if (response.errorCode) {
            error = new U2FError(response.errorCode, 'register');
            return _this.renderError(error);
          } else {
            return _this.renderRegistered(JSON.stringify(response));
          }
        };
      }(this), 10);
    };

    // Rendering #
    U2FRegister.prototype.templates = {
      "notSupported": "#js-register-u2f-not-supported",
      "setup": '#js-register-u2f-setup',
      "inProgress": '#js-register-u2f-in-progress',
      "error": '#js-register-u2f-error',
      "registered": '#js-register-u2f-registered'
    };

    U2FRegister.prototype.renderTemplate = function (name, params) {
      var template, templateString;
      templateString = $(this.templates[name]).html();
      template = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.template(templateString);
      return this.container.html(template(params));
    };

    U2FRegister.prototype.renderSetup = function () {
      this.renderTemplate('setup');
      return this.container.find('#js-setup-u2f-device').on('click', this.renderInProgress);
    };

    U2FRegister.prototype.renderInProgress = function () {
      this.renderTemplate('inProgress');
      return this.register();
    };

    U2FRegister.prototype.renderError = function (error) {
      this.renderTemplate('error', {
        error_message: error.message(),
        error_code: error.errorCode
      });
      return this.container.find('#js-u2f-try-again').on('click', this.renderSetup);
    };

    U2FRegister.prototype.renderRegistered = function (deviceResponse) {
      this.renderTemplate('registered');
      // Prefer to do this instead of interpolating using Underscore templates
      // because of JSON escaping issues.
      return this.container.find("#js-device-response").val(deviceResponse);
    };

    U2FRegister.prototype.renderNotSupported = function () {
      return this.renderTemplate('notSupported');
    };

    return U2FRegister;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./u2f/util.js":
/***/ (function(module, exports) {

/* eslint-disable func-names, space-before-function-paren, wrap-iife */
(function () {
  this.U2FUtil = function () {
    function U2FUtil() {}

    U2FUtil.isU2FSupported = function () {
      return window.u2f;
    };

    return U2FUtil;
  }();
}).call(window);

/***/ }),

/***/ "./usage_ping.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (immutable) */ __webpack_exports__["a"] = UsagePing;
function UsagePing() {
  var usageDataUrl = $('.usage-data').data('endpoint');

  $.ajax({
    type: 'GET',
    url: usageDataUrl,
    dataType: 'html',
    success: function success(html) {
      $('.usage-data').html(html);
    }
  });
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./user_callout.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var UserCallout = function () {
  function UserCallout() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, UserCallout);

    this.options = options;

    var className = this.options.className || 'user-callout';

    this.userCalloutBody = $('.' + className);
    this.cookieName = this.userCalloutBody.data('uid');
    this.isCalloutDismissed = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(this.cookieName);
    this.init();
  }

  _createClass(UserCallout, [{
    key: 'init',
    value: function init() {
      var _this = this;

      if (!this.isCalloutDismissed || this.isCalloutDismissed === 'false') {
        this.userCalloutBody.find('.js-close-callout').on('click', function (e) {
          return _this.dismissCallout(e);
        });
      }
    }
  }, {
    key: 'dismissCallout',
    value: function dismissCallout(e) {
      var $currentTarget = $(e.currentTarget);

      if (this.options.setCalloutPerProject) {
        __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(this.cookieName, 'true', { expires: 365, path: this.userCalloutBody.data('project-path') });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(this.cookieName, 'true', { expires: 365 });
      }

      if ($currentTarget.hasClass('close')) {
        this.userCalloutBody.remove();
      }
    }
  }]);

  return UserCallout;
}();

/* harmony default export */ __webpack_exports__["a"] = (UserCallout);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./username_validator.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable comma-dangle, consistent-return, class-methods-use-this, arrow-parens, no-param-reassign, max-len */



var debounceTimeoutDuration = 1000;
var invalidInputClass = 'gl-field-error-outline';
var successInputClass = 'gl-field-success-outline';
var unavailableMessageSelector = '.username .validation-error';
var successMessageSelector = '.username .validation-success';
var pendingMessageSelector = '.username .validation-pending';
var invalidMessageSelector = '.username .gl-field-error';

var UsernameValidator = function () {
  function UsernameValidator() {
    var _this = this;

    _classCallCheck(this, UsernameValidator);

    this.inputElement = $('#new_user_username');
    this.inputDomElement = this.inputElement.get(0);
    this.state = {
      available: false,
      valid: false,
      pending: false,
      empty: true
    };

    var debounceTimeout = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.debounce(function (username) {
      _this.validateUsername(username);
    }, debounceTimeoutDuration);

    this.inputElement.on('keyup.username_check', function () {
      var username = _this.inputElement.val();

      _this.state.valid = _this.inputDomElement.validity.valid;
      _this.state.empty = !username.length;

      if (_this.state.valid) {
        return debounceTimeout(username);
      }

      _this.renderState();
    });

    // Override generic field validation
    this.inputElement.on('invalid', this.interceptInvalid.bind(this));
  }

  _createClass(UsernameValidator, [{
    key: 'renderState',
    value: function renderState() {
      // Clear all state
      this.clearFieldValidationState();

      if (this.state.valid && this.state.available) {
        return this.setSuccessState();
      }

      if (this.state.empty) {
        return this.clearFieldValidationState();
      }

      if (this.state.pending) {
        return this.setPendingState();
      }

      if (!this.state.available) {
        return this.setUnavailableState();
      }

      if (!this.state.valid) {
        return this.setInvalidState();
      }
    }
  }, {
    key: 'interceptInvalid',
    value: function interceptInvalid(event) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, {
    key: 'validateUsername',
    value: function validateUsername(username) {
      var _this2 = this;

      if (this.state.valid) {
        this.state.pending = true;
        this.state.available = false;
        this.renderState();
        return $.ajax({
          type: 'GET',
          url: gon.relative_url_root + '/users/' + username + '/exists',
          dataType: 'json',
          success: function success(res) {
            return _this2.setAvailabilityState(res.exists);
          }
        });
      }
    }
  }, {
    key: 'setAvailabilityState',
    value: function setAvailabilityState(usernameTaken) {
      if (usernameTaken) {
        this.state.valid = false;
        this.state.available = false;
      } else {
        this.state.available = true;
      }
      this.state.pending = false;
      this.renderState();
    }
  }, {
    key: 'clearFieldValidationState',
    value: function clearFieldValidationState() {
      this.inputElement.siblings('p').hide();

      this.inputElement.removeClass(invalidInputClass).removeClass(successInputClass);
    }
  }, {
    key: 'setUnavailableState',
    value: function setUnavailableState() {
      var $usernameUnavailableMessage = this.inputElement.siblings(unavailableMessageSelector);
      this.inputElement.addClass(invalidInputClass).removeClass(successInputClass);
      $usernameUnavailableMessage.show();
    }
  }, {
    key: 'setSuccessState',
    value: function setSuccessState() {
      var $usernameSuccessMessage = this.inputElement.siblings(successMessageSelector);
      this.inputElement.addClass(successInputClass).removeClass(invalidInputClass);
      $usernameSuccessMessage.show();
    }
  }, {
    key: 'setPendingState',
    value: function setPendingState() {
      var $usernamePendingMessage = $(pendingMessageSelector);
      if (this.state.pending) {
        $usernamePendingMessage.show();
      } else {
        $usernamePendingMessage.hide();
      }
    }
  }, {
    key: 'setInvalidState',
    value: function setInvalidState() {
      var $inputErrorMessage = $(invalidMessageSelector);
      this.inputElement.addClass(invalidInputClass).removeClass(successInputClass);
      $inputErrorMessage.show();
    }
  }]);

  return UsernameValidator;
}();

/* harmony default export */ __webpack_exports__["a"] = (UsernameValidator);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./users_select.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* eslint-disable func-names, space-before-function-paren, one-var, no-var, prefer-rest-params, wrap-iife, quotes, max-len, one-var-declaration-per-line, vars-on-top, prefer-arrow-callback, consistent-return, comma-dangle, object-shorthand, no-shadow, no-unused-vars, no-else-return, no-self-compare, prefer-template, no-unused-expressions, no-lonely-if, yoda, prefer-spread, no-void, camelcase, no-param-reassign */
/* global Issuable */
/* global emitSidebarEvent */


// TODO: remove eventHub hack after code splitting refactor
window.emitSidebarEvent = window.emitSidebarEvent || $.noop;

function UsersSelect(currentUser, els) {
  var $els;
  this.users = this.users.bind(this);
  this.user = this.user.bind(this);
  this.usersPath = "/autocomplete/users.json";
  this.userPath = "/autocomplete/users/:id.json";
  if (currentUser != null) {
    if ((typeof currentUser === "undefined" ? "undefined" : _typeof(currentUser)) === 'object') {
      this.currentUser = currentUser;
    } else {
      this.currentUser = JSON.parse(currentUser);
    }
  }

  $els = $(els);

  if (!els) {
    $els = $('.js-user-search');
  }

  $els.each(function (_this) {
    return function (i, dropdown) {
      var options = {};
      var $block, $collapsedSidebar, $dropdown, $loading, $selectbox, $value, abilityName, assignTo, assigneeTemplate, collapsedAssigneeTemplate, defaultLabel, defaultNullUser, firstUser, issueURL, selectedId, selectedIdDefault, showAnyUser, showNullUser, showMenuAbove;
      $dropdown = $(dropdown);
      options.projectId = $dropdown.data('project-id');
      options.groupId = $dropdown.data('group-id');
      options.showCurrentUser = $dropdown.data('current-user');
      options.todoFilter = $dropdown.data('todo-filter');
      options.todoStateFilter = $dropdown.data('todo-state-filter');
      options.perPage = $dropdown.data('per-page');
      showNullUser = $dropdown.data('null-user');
      defaultNullUser = $dropdown.data('null-user-default');
      showMenuAbove = $dropdown.data('showMenuAbove');
      showAnyUser = $dropdown.data('any-user');
      firstUser = $dropdown.data('first-user');
      options.authorId = $dropdown.data('author-id');
      defaultLabel = $dropdown.data('default-label');
      issueURL = $dropdown.data('issueUpdate');
      $selectbox = $dropdown.closest('.selectbox');
      $block = $selectbox.closest('.block');
      abilityName = $dropdown.data('ability-name');
      $value = $block.find('.value');
      $collapsedSidebar = $block.find('.sidebar-collapsed-user');
      $loading = $block.find('.block-loading').fadeOut();
      selectedIdDefault = defaultNullUser && showNullUser ? 0 : null;
      selectedId = $dropdown.data('selected');

      if (selectedId === undefined) {
        selectedId = selectedIdDefault;
      }

      var assignYourself = function assignYourself() {
        var unassignedSelected = $dropdown.closest('.selectbox').find("input[name='" + $dropdown.data('field-name') + "'][value=0]");

        if (unassignedSelected) {
          unassignedSelected.remove();
        }

        // Save current selected user to the DOM
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = $dropdown.data('field-name');

        var currentUserInfo = $dropdown.data('currentUserInfo');

        if (currentUserInfo) {
          input.value = currentUserInfo.id;
          input.dataset.meta = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(currentUserInfo.name);
        } else if (_this.currentUser) {
          input.value = _this.currentUser.id;
        }

        if ($selectbox) {
          $dropdown.parent().before(input);
        } else {
          $dropdown.after(input);
        }
      };

      if ($block[0]) {
        $block[0].addEventListener('assignYourself', assignYourself);
      }

      var getSelectedUserInputs = function getSelectedUserInputs() {
        return $selectbox.find("input[name=\"" + $dropdown.data('field-name') + "\"]");
      };

      var getSelected = function getSelected() {
        return getSelectedUserInputs().map(function (index, input) {
          return parseInt(input.value, 10);
        }).get();
      };

      var checkMaxSelect = function checkMaxSelect() {
        var maxSelect = $dropdown.data('max-select');
        if (maxSelect) {
          var selected = getSelected();

          if (selected.length > maxSelect) {
            var firstSelectedId = selected[0];
            var firstSelected = $dropdown.closest('.selectbox').find("input[name='" + $dropdown.data('field-name') + "'][value=" + firstSelectedId + "]");

            firstSelected.remove();
            emitSidebarEvent('sidebar.removeAssignee', {
              id: firstSelectedId
            });
          }
        }
      };

      var getMultiSelectDropdownTitle = function getMultiSelectDropdownTitle(selectedUser, isSelected) {
        var selectedUsers = getSelected().filter(function (u) {
          return u !== 0;
        });

        var firstUser = getSelectedUserInputs().map(function (index, input) {
          return {
            name: input.dataset.meta,
            value: parseInt(input.value, 10)
          };
        }).filter(function (u) {
          return u.id !== 0;
        }).get(0);

        if (selectedUsers.length === 0) {
          return 'Unassigned';
        } else if (selectedUsers.length === 1) {
          return firstUser.name;
        } else if (isSelected) {
          var otherSelected = selectedUsers.filter(function (s) {
            return s !== selectedUser.id;
          });
          return selectedUser.name + " + " + otherSelected.length + " more";
        } else {
          return firstUser.name + " + " + (selectedUsers.length - 1) + " more";
        }
      };

      $('.assign-to-me-link').on('click', function (e) {
        e.preventDefault();
        $(e.currentTarget).hide();

        if ($dropdown.data('multiSelect')) {
          assignYourself();
          checkMaxSelect();

          var currentUserInfo = $dropdown.data('currentUserInfo');
          $dropdown.find('.dropdown-toggle-text').text(getMultiSelectDropdownTitle(currentUserInfo)).removeClass('is-default');
        } else {
          var $input = $("input[name=\"" + $dropdown.data('field-name') + "\"]");
          $input.val(gon.current_user_id);
          selectedId = $input.val();
          $dropdown.find('.dropdown-toggle-text').text(gon.current_user_fullname).removeClass('is-default');
        }
      });

      $block.on('click', '.js-assign-yourself', function (e) {
        e.preventDefault();
        return assignTo(_this.currentUser.id);
      });

      assignTo = function assignTo(selected) {
        var data;
        data = {};
        data[abilityName] = {};
        data[abilityName].assignee_id = selected != null ? selected : null;
        $loading.removeClass('hidden').fadeIn();
        $dropdown.trigger('loading.gl.dropdown');

        return $.ajax({
          type: 'PUT',
          dataType: 'json',
          url: issueURL,
          data: data
        }).done(function (data) {
          var user;
          $dropdown.trigger('loaded.gl.dropdown');
          $loading.fadeOut();
          if (data.assignee) {
            user = {
              name: data.assignee.name,
              username: data.assignee.username,
              avatar: data.assignee.avatar_url
            };
          } else {
            user = {
              name: 'Unassigned',
              username: '',
              avatar: ''
            };
          }
          $value.html(assigneeTemplate(user));
          $collapsedSidebar.attr('title', __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(user.name)).tooltip('fixTitle');
          return $collapsedSidebar.html(collapsedAssigneeTemplate(user));
        });
      };
      collapsedAssigneeTemplate = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.template('<% if( avatar ) { %> <a class="author_link" href="/<%- username %>"> <img width="24" class="avatar avatar-inline s24" alt="" src="<%- avatar %>"> </a> <% } else { %> <i class="fa fa-user"></i> <% } %>');
      assigneeTemplate = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.template('<% if (username) { %> <a class="author_link bold" href="/<%- username %>"> <% if( avatar ) { %> <img width="32" class="avatar avatar-inline s32" alt="" src="<%- avatar %>"> <% } %> <span class="author"><%- name %></span> <span class="username"> @<%- username %> </span> </a> <% } else { %> <span class="no-value assign-yourself"> No assignee - <a href="#" class="js-assign-yourself"> assign yourself </a> </span> <% } %>');
      return $dropdown.glDropdown({
        showMenuAbove: showMenuAbove,
        data: function data(term, callback) {
          return _this.users(term, options, function (users) {
            // GitLabDropdownFilter returns this.instance
            // GitLabDropdownRemote returns this.options.instance
            var glDropdown = this.instance || this.options.instance;
            glDropdown.options.processData(term, users, callback);
          }.bind(this));
        },
        processData: function processData(term, data, callback) {
          var users = data;

          // Only show assigned user list when there is no search term
          if ($dropdown.hasClass('js-multiselect') && term.length === 0) {
            var selectedInputs = getSelectedUserInputs();

            // Potential duplicate entries when dealing with issue board
            // because issue board is also managed by vue
            var selectedUsers = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.uniq(selectedInputs, false, function (a) {
              return a.value;
            }).filter(function (input) {
              var userId = parseInt(input.value, 10);
              var inUsersArray = users.find(function (u) {
                return u.id === userId;
              });

              return !inUsersArray && userId !== 0;
            }).map(function (input) {
              var userId = parseInt(input.value, 10);
              var _input$dataset = input.dataset,
                  avatarUrl = _input$dataset.avatarUrl,
                  avatar_url = _input$dataset.avatar_url,
                  name = _input$dataset.name,
                  username = _input$dataset.username;

              return {
                avatar_url: avatarUrl || avatar_url,
                id: userId,
                name: name,
                username: username
              };
            });

            users = data.concat(selectedUsers);
          }

          var anyUser = void 0;
          var index = void 0;
          var j = void 0;
          var len = void 0;
          var name = void 0;
          var obj = void 0;
          var showDivider = void 0;
          if (term.length === 0) {
            showDivider = 0;
            if (firstUser) {
              // Move current user to the front of the list
              for (index = j = 0, len = users.length; j < len; index = j += 1) {
                obj = users[index];
                if (obj.username === firstUser) {
                  users.splice(index, 1);
                  users.unshift(obj);
                  break;
                }
              }
            }
            if (showNullUser) {
              showDivider += 1;
              users.unshift({
                beforeDivider: true,
                name: 'Unassigned',
                id: 0
              });
            }
            if (showAnyUser) {
              showDivider += 1;
              name = showAnyUser;
              if (name === true) {
                name = 'Any User';
              }
              anyUser = {
                beforeDivider: true,
                name: name,
                id: null
              };
              users.unshift(anyUser);
            }

            if (showDivider) {
              users.splice(showDivider, 0, 'divider');
            }

            if ($dropdown.hasClass('js-multiselect')) {
              var selected = getSelected().filter(function (i) {
                return i !== 0;
              });

              if (selected.length > 0) {
                if ($dropdown.data('dropdown-header')) {
                  showDivider += 1;
                  users.splice(showDivider, 0, {
                    header: $dropdown.data('dropdown-header')
                  });
                }

                var _selectedUsers = users.filter(function (u) {
                  return selected.indexOf(u.id) !== -1;
                }).sort(function (a, b) {
                  return a.name > b.name;
                });

                users = users.filter(function (u) {
                  return selected.indexOf(u.id) === -1;
                });

                _selectedUsers.forEach(function (selectedUser) {
                  showDivider += 1;
                  users.splice(showDivider, 0, selectedUser);
                });

                users.splice(showDivider + 1, 0, 'divider');
              }
            }
          }

          callback(users);
          if (showMenuAbove) {
            $dropdown.data('glDropdown').positionMenuAbove();
          }
        },
        filterable: true,
        filterRemote: true,
        search: {
          fields: ['name', 'username']
        },
        selectable: true,
        fieldName: $dropdown.data('field-name'),
        toggleLabel: function toggleLabel(selected, el, glDropdown) {
          var inputValue = glDropdown.filterInput.val();

          if (this.multiSelect && inputValue === '') {
            // Remove non-users from the fullData array
            var users = glDropdown.filteredFullData();
            var callback = glDropdown.parseData.bind(glDropdown);

            // Update the data model
            this.processData(inputValue, users, callback);
          }

          if (this.multiSelect) {
            return getMultiSelectDropdownTitle(selected, $(el).hasClass('is-active'));
          }

          if (selected && 'id' in selected && $(el).hasClass('is-active')) {
            $dropdown.find('.dropdown-toggle-text').removeClass('is-default');
            if (selected.text) {
              return selected.text;
            } else {
              return selected.name;
            }
          } else {
            $dropdown.find('.dropdown-toggle-text').addClass('is-default');
            return defaultLabel;
          }
        },
        defaultLabel: defaultLabel,
        hidden: function hidden(e) {
          if ($dropdown.hasClass('js-multiselect')) {
            emitSidebarEvent('sidebar.saveAssignees');
          }

          if (!$dropdown.data('always-show-selectbox')) {
            $selectbox.hide();

            // Recalculate where .value is because vue might have changed it
            $block = $selectbox.closest('.block');
            $value = $block.find('.value');
            // display:block overrides the hide-collapse rule
            $value.css('display', '');
          }
        },
        multiSelect: $dropdown.hasClass('js-multiselect'),
        inputMeta: $dropdown.data('input-meta'),
        clicked: function clicked(options) {
          var $el = options.$el,
              e = options.e,
              isMarking = options.isMarking;

          var user = options.selectedObj;

          if ($dropdown.hasClass('js-multiselect')) {
            var isActive = $el.hasClass('is-active');
            var previouslySelected = $dropdown.closest('.selectbox').find("input[name='" + $dropdown.data('field-name') + "'][value!=0]");

            // Enables support for limiting the number of users selected
            // Automatically removes the first on the list if more users are selected
            checkMaxSelect();

            if (user.beforeDivider && user.name.toLowerCase() === 'unassigned') {
              // Unassigned selected
              previouslySelected.each(function (index, element) {
                var id = parseInt(element.value, 10);
                element.remove();
              });
              emitSidebarEvent('sidebar.removeAllAssignees');
            } else if (isActive) {
              // user selected
              emitSidebarEvent('sidebar.addAssignee', user);

              // Remove unassigned selection (if it was previously selected)
              var unassignedSelected = $dropdown.closest('.selectbox').find("input[name='" + $dropdown.data('field-name') + "'][value=0]");

              if (unassignedSelected) {
                unassignedSelected.remove();
              }
            } else {
              if (previouslySelected.length === 0) {
                // Select unassigned because there is no more selected users
                this.addInput($dropdown.data('field-name'), 0, {});
              }

              // User unselected
              emitSidebarEvent('sidebar.removeAssignee', user);
            }

            if (getSelected().find(function (u) {
              return u === gon.current_user_id;
            })) {
              $('.assign-to-me-link').hide();
            } else {
              $('.assign-to-me-link').show();
            }
          }

          var isIssueIndex, isMRIndex, page, selected;
          page = $('body').data('page');
          isIssueIndex = page === 'projects:issues:index';
          isMRIndex = page === page && page === 'projects:merge_requests:index';
          if ($dropdown.hasClass('js-filter-bulk-update') || $dropdown.hasClass('js-issuable-form-dropdown')) {
            e.preventDefault();

            var isSelecting = user.id !== selectedId;
            selectedId = isSelecting ? user.id : selectedIdDefault;

            if (selectedId === gon.current_user_id) {
              $('.assign-to-me-link').hide();
            } else {
              $('.assign-to-me-link').show();
            }
            return;
          }
          if ($el.closest('.add-issues-modal').length) {
            gl.issueBoards.ModalStore.store.filter[$dropdown.data('field-name')] = user.id;
          } else if ($dropdown.hasClass('js-filter-submit') && (isIssueIndex || isMRIndex)) {
            return Issuable.filterResults($dropdown.closest('form'));
          } else if ($dropdown.hasClass('js-filter-submit')) {
            return $dropdown.closest('form').submit();
          } else if (!$dropdown.hasClass('js-multiselect')) {
            selected = $dropdown.closest('.selectbox').find("input[name='" + $dropdown.data('field-name') + "']").val();
            return assignTo(selected);
          }

          // Automatically close dropdown after assignee is selected
          // since CE has no multiple assignees
          // EE does not have a max-select
          if ($dropdown.data('max-select') && getSelected().length === $dropdown.data('max-select')) {
            // Close the dropdown
            $dropdown.dropdown('toggle');
          }
        },
        id: function id(user) {
          return user.id;
        },
        opened: function opened(e) {
          var $el = $(e.currentTarget);
          var selected = getSelected();
          if ($dropdown.hasClass('js-issue-board-sidebar') && selected.length === 0) {
            this.addInput($dropdown.data('field-name'), 0, {});
          }
          $el.find('.is-active').removeClass('is-active');

          function highlightSelected(id) {
            $el.find("li[data-user-id=\"" + id + "\"] .dropdown-menu-user-link").addClass('is-active');
          }

          if (selected.length > 0) {
            getSelected().forEach(function (selectedId) {
              return highlightSelected(selectedId);
            });
          } else if ($dropdown.hasClass('js-issue-board-sidebar')) {
            highlightSelected(0);
          } else {
            highlightSelected(selectedId);
          }
        },
        updateLabel: $dropdown.data('dropdown-title'),
        renderRow: function renderRow(user) {
          var avatar, img, listClosingTags, listWithName, listWithUserName, username;
          username = user.username ? "@" + user.username : "";
          avatar = user.avatar_url ? user.avatar_url : false;

          var selected = false;

          if (this.multiSelect) {
            selected = getSelected().find(function (u) {
              return user.id === u;
            });

            var fieldName = this.fieldName;
            var field = $dropdown.closest('.selectbox').find("input[name='" + fieldName + "'][value='" + user.id + "']");

            if (field.length) {
              selected = true;
            }
          } else {
            selected = user.id === selectedId;
          }

          img = "";
          if (user.beforeDivider != null) {
            "<li><a href='#' class='" + (selected === true ? 'is-active' : '') + "'>" + __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(user.name) + "</a></li>";
          } else {
            if (avatar) {
              img = "<img src='" + avatar + "' class='avatar avatar-inline' width='32' />";
            }
          }

          return "\n            <li data-user-id=" + user.id + ">\n              <a href='#' class='dropdown-menu-user-link " + (selected === true ? 'is-active' : '') + "'>\n                " + img + "\n                <strong class='dropdown-menu-user-full-name'>\n                  " + __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(user.name) + "\n                </strong>\n                " + (username ? "<span class='dropdown-menu-user-username'>" + username + "</span>" : '') + "\n              </a>\n            </li>\n          ";
        }
      });
    };
  }(this));
  $('.ajax-users-select').each(function (_this) {
    return function (i, select) {
      var firstUser, showAnyUser, showEmailUser, showNullUser;
      var options = {};
      options.skipLdap = $(select).hasClass('skip_ldap');
      options.projectId = $(select).data('project-id');
      options.groupId = $(select).data('group-id');
      options.showCurrentUser = $(select).data('current-user');
      options.pushCodeToProtectedBranches = $(select).data('push-code-to-protected-branches');
      options.authorId = $(select).data('author-id');
      options.skipUsers = $(select).data('skip-users');
      showNullUser = $(select).data('null-user');
      showAnyUser = $(select).data('any-user');
      showEmailUser = $(select).data('email-user');
      firstUser = $(select).data('first-user');
      return $(select).select2({
        placeholder: "Search for a user",
        multiple: $(select).hasClass('multiselect'),
        minimumInputLength: 0,
        query: function query(_query) {
          return _this.users(_query.term, options, function (users) {
            var anyUser, data, emailUser, index, j, len, name, nullUser, obj, ref;
            data = {
              results: users
            };
            if (_query.term.length === 0) {
              if (firstUser) {
                // Move current user to the front of the list
                ref = data.results;
                for (index = j = 0, len = ref.length; j < len; index = j += 1) {
                  obj = ref[index];
                  if (obj.username === firstUser) {
                    data.results.splice(index, 1);
                    data.results.unshift(obj);
                    break;
                  }
                }
              }
              if (showNullUser) {
                nullUser = {
                  name: 'Unassigned',
                  id: 0
                };
                data.results.unshift(nullUser);
              }
              if (showAnyUser) {
                name = showAnyUser;
                if (name === true) {
                  name = 'Any User';
                }
                anyUser = {
                  name: name,
                  id: null
                };
                data.results.unshift(anyUser);
              }
            }
            if (showEmailUser && data.results.length === 0 && _query.term.match(/^[^@]+@[^@]+$/)) {
              var trimmed = _query.term.trim();
              emailUser = {
                name: "Invite \"" + _query.term + "\" by email",
                username: trimmed,
                id: trimmed,
                invite: true
              };
              data.results.unshift(emailUser);
            }
            return _query.callback(data);
          });
        },
        initSelection: function initSelection() {
          var args;
          args = 1 <= arguments.length ? [].slice.call(arguments, 0) : [];
          return _this.initSelection.apply(_this, args);
        },
        formatResult: function formatResult() {
          var args;
          args = 1 <= arguments.length ? [].slice.call(arguments, 0) : [];
          return _this.formatResult.apply(_this, args);
        },
        formatSelection: function formatSelection() {
          var args;
          args = 1 <= arguments.length ? [].slice.call(arguments, 0) : [];
          return _this.formatSelection.apply(_this, args);
        },
        dropdownCssClass: "ajax-users-dropdown",
        // we do not want to escape markup since we are displaying html in results
        escapeMarkup: function escapeMarkup(m) {
          return m;
        }
      });
    };
  }(this));
}

UsersSelect.prototype.initSelection = function (element, callback) {
  var id, nullUser;
  id = $(element).val();
  if (id === "0") {
    nullUser = {
      name: 'Unassigned'
    };
    return callback(nullUser);
  } else if (id !== "") {
    return this.user(id, callback);
  }
};

UsersSelect.prototype.formatResult = function (user) {
  var avatar;
  if (user.avatar_url) {
    avatar = user.avatar_url;
  } else {
    avatar = gon.default_avatar_url;
  }
  return "<div class='user-result " + (!user.username ? 'no-username' : void 0) + "'> <div class='user-image'><img class='avatar avatar-inline s32' src='" + avatar + "'></div> <div class='user-name dropdown-menu-user-full-name'>" + __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(user.name) + "</div> <div class='user-username dropdown-menu-user-username'>" + (!user.invite ? "@" + __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(user.username) : "") + "</div> </div>";
};

UsersSelect.prototype.formatSelection = function (user) {
  return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(user.name);
};

UsersSelect.prototype.user = function (user_id, callback) {
  if (!/^\d+$/.test(user_id)) {
    return false;
  }

  var url;
  url = this.buildUrl(this.userPath);
  url = url.replace(':id', user_id);
  return $.ajax({
    url: url,
    dataType: "json"
  }).done(function (user) {
    return callback(user);
  });
};

// Return users list. Filtered by query
// Only active users retrieved
UsersSelect.prototype.users = function (query, options, callback) {
  var url;
  url = this.buildUrl(this.usersPath);
  return $.ajax({
    url: url,
    data: {
      search: query,
      per_page: options.perPage || 20,
      active: true,
      project_id: options.projectId || null,
      group_id: options.groupId || null,
      skip_ldap: options.skipLdap || null,
      todo_filter: options.todoFilter || null,
      todo_state_filter: options.todoStateFilter || null,
      current_user: options.showCurrentUser || null,
      push_code_to_protected_branches: options.pushCodeToProtectedBranches || null,
      author_id: options.authorId || null,
      skip_users: options.skipUsers || null
    },
    dataType: "json"
  }).done(function (users) {
    return callback(users);
  });
};

UsersSelect.prototype.buildUrl = function (url) {
  if (gon.relative_url_root != null) {
    url = gon.relative_url_root.replace(/\/$/, '') + url;
  }
  return url;
};

/* harmony default export */ __webpack_exports__["a"] = (UsersSelect);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./version_check_image.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VersionCheckImage = function () {
  function VersionCheckImage() {
    _classCallCheck(this, VersionCheckImage);
  }

  _createClass(VersionCheckImage, null, [{
    key: 'bindErrorEvent',
    value: function bindErrorEvent(imageElement) {
      imageElement.off('error').on('error', function () {
        return imageElement.hide();
      });
    }
  }]);

  return VersionCheckImage;
}();

/* harmony default export */ __webpack_exports__["a"] = (VersionCheckImage);

/***/ }),

/***/ "./visibility_select.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VisibilitySelect = function () {
  function VisibilitySelect(container) {
    _classCallCheck(this, VisibilitySelect);

    if (!container) throw new Error('VisibilitySelect requires a container element as argument 1');
    this.container = container;
    this.helpBlock = this.container.querySelector('.help-block');
    this.select = this.container.querySelector('select');
  }

  _createClass(VisibilitySelect, [{
    key: 'init',
    value: function init() {
      if (this.select) {
        this.updateHelpText();
        this.select.addEventListener('change', this.updateHelpText.bind(this));
      } else {
        this.helpBlock.textContent = this.container.querySelector('.js-locked').dataset.helpBlock;
      }
    }
  }, {
    key: 'updateHelpText',
    value: function updateHelpText() {
      this.helpBlock.textContent = this.select.querySelector('option:checked').dataset.description;
    }
  }]);

  return VisibilitySelect;
}();

/* harmony default export */ __webpack_exports__["a"] = (VisibilitySelect);

/***/ }),

/***/ "./vue_shared/components/identicon.vue":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")(
  /* script */
  __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/identicon.vue"),
  /* template */
  __webpack_require__("../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-cda97d4c\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/identicon.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "./vue_shared/components/loading_icon.vue":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")(
  /* script */
  __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/loading_icon.vue"),
  /* template */
  __webpack_require__("../../../node_modules/vue-loader/lib/template-compiler/index.js?{\"id\":\"data-v-19c49ebb\"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/loading_icon.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "./vue_shared/translate.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__("./locale/index.js");


/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
  Vue.mixin({
    methods: {
      /**
        Translates `text`
         @param text The text to be translated
        @returns {String} The translated text
      **/
      __: __WEBPACK_IMPORTED_MODULE_0__locale__["__"],
      /**
        Translate the text with a number
        if the number is more than 1 it will use the `pluralText` translation.
        This method allows for contexts, see below re. contexts
         @param text Singular text to translate (eg. '%d day')
        @param pluralText Plural text to translate (eg. '%d days')
        @param count Number to decide which translation to use (eg. 2)
        @returns {String} Translated text with the number replaced (eg. '2 days')
      **/
      n__: __WEBPACK_IMPORTED_MODULE_0__locale__["n__"],
      /**
        Translate context based text
        Either pass in the context translation like `Context|Text to translate`
        or allow for dynamic text by doing passing in the context first & then the text to translate
         @param keyOrContext Can be either the key to translate including the context
                            (eg. 'Context|Text') or just the context for the translation
                            (eg. 'Context')
        @param key Is the dynamic variable you want to be translated
        @returns {String} Translated context based text
      **/
      s__: __WEBPACK_IMPORTED_MODULE_0__locale__["s__"],
      sprintf: __WEBPACK_IMPORTED_MODULE_0__locale__["sprintf"]
    }
  });
});

/***/ }),

/***/ "./weight_select.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable space-before-function-paren, wrap-iife, prefer-arrow-callback, max-len, one-var, no-var, one-var-declaration-per-line, object-shorthand, comma-dangle, no-shadow, quotes, no-unused-vars, no-else-return, consistent-return, no-param-reassign, prefer-template, padded-blocks, func-names */

(function () {
  this.WeightSelect = function () {
    function WeightSelect() {
      $('.js-weight-select').each(function (i, dropdown) {
        var $block, $dropdown, $loading, $selectbox, $sidebarCollapsedValue, $value, abilityName, updateUrl, updateWeight;
        $dropdown = $(dropdown);
        updateUrl = $dropdown.data('issueUpdate');
        $selectbox = $dropdown.closest('.selectbox');
        $block = $selectbox.closest('.block');
        $sidebarCollapsedValue = $block.find('.sidebar-collapsed-icon span');
        $value = $block.find('.value');
        abilityName = $dropdown.data('ability-name');
        $loading = $block.find('.block-loading').fadeOut();
        updateWeight = function updateWeight(selected) {
          var data;
          data = {};
          data[abilityName] = {};
          data[abilityName].weight = selected != null ? selected : null;
          $loading.fadeIn();
          $dropdown.trigger('loading.gl.dropdown');
          return $.ajax({
            type: 'PUT',
            dataType: 'json',
            url: updateUrl,
            data: data
          }).done(function (data) {
            $dropdown.trigger('loaded.gl.dropdown');
            $loading.fadeOut();
            $selectbox.hide();
            if (data.weight != null) {
              $value.html('<strong>' + data.weight + '</strong>');
            } else {
              $value.html('<span class="no-value">None</span>');
            }
            return $sidebarCollapsedValue.html(data.weight);
          });
        };
        return $dropdown.glDropdown({
          selectable: true,
          fieldName: $dropdown.data("field-name"),
          toggleLabel: function toggleLabel(selected, el) {
            return $(el).data("id");
          },
          hidden: function hidden(e) {
            $selectbox.hide();
            return $value.css('display', '');
          },
          id: function id(obj, el) {
            if ($(el).data("none") == null) {
              return $(el).data("id");
            } else {
              return '';
            }
          },
          clicked: function clicked(options) {
            var e = options.e;
            var selected = options.selectedObj;

            if ($(dropdown).is(".js-filter-submit")) {
              return $(dropdown).parents('form').submit();
            } else if ($dropdown.is('.js-issuable-form-weight')) {
              e.preventDefault();
            } else {
              selected = $dropdown.closest('.selectbox').find("input[name='" + $dropdown.data('field-name') + "']").val();
              return updateWeight(selected);
            }
          }
        });
      });
    }

    return WeightSelect;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./wikis.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__breakpoints__ = __webpack_require__("./breakpoints.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var Wikis = function () {
  function Wikis() {
    var _this = this;

    _classCallCheck(this, Wikis);

    this.sidebarEl = document.querySelector('.js-wiki-sidebar');
    this.sidebarExpanded = false;

    var sidebarToggles = document.querySelectorAll('.js-sidebar-wiki-toggle');
    for (var i = 0; i < sidebarToggles.length; i += 1) {
      sidebarToggles[i].addEventListener('click', function (e) {
        return _this.handleToggleSidebar(e);
      });
    }

    this.newWikiForm = document.querySelector('form.new-wiki-page');
    if (this.newWikiForm) {
      this.newWikiForm.addEventListener('submit', function (e) {
        return _this.handleNewWikiSubmit(e);
      });
    }

    window.addEventListener('resize', function () {
      return _this.renderSidebar();
    });
    this.renderSidebar();
  }

  _createClass(Wikis, [{
    key: 'handleNewWikiSubmit',
    value: function handleNewWikiSubmit(e) {
      if (!this.newWikiForm) return;

      var slugInput = this.newWikiForm.querySelector('#new_wiki_path');
      var slug = gl.text.slugify(slugInput.value);

      if (slug.length > 0) {
        var wikisPath = slugInput.getAttribute('data-wikis-path');
        window.location.href = wikisPath + '/' + slug;
        e.preventDefault();
      }
    }
  }, {
    key: 'handleToggleSidebar',
    value: function handleToggleSidebar(e) {
      e.preventDefault();
      this.sidebarExpanded = !this.sidebarExpanded;
      this.renderSidebar();
    }
  }, {
    key: 'renderSidebar',
    value: function renderSidebar() {
      if (!this.sidebarEl) return;
      var classList = this.sidebarEl.classList;

      if (this.sidebarExpanded || !Wikis.sidebarCanCollapse()) {
        if (!classList.contains('right-sidebar-expanded')) {
          classList.remove('right-sidebar-collapsed');
          classList.add('right-sidebar-expanded');
        }
      } else if (classList.contains('right-sidebar-expanded')) {
        classList.add('right-sidebar-collapsed');
        classList.remove('right-sidebar-expanded');
      }
    }
  }], [{
    key: 'sidebarCanCollapse',
    value: function sidebarCanCollapse() {
      var bootstrapBreakpoint = __WEBPACK_IMPORTED_MODULE_0__breakpoints__["a" /* default */].getBreakpointSize();
      return bootstrapBreakpoint === 'xs' || bootstrapBreakpoint === 'sm';
    }
  }]);

  return Wikis;
}();

/* harmony default export */ __webpack_exports__["a"] = (Wikis);

/***/ }),

/***/ "./zen_mode.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vendor_jquery_scrollTo__ = __webpack_require__("../../../vendor/assets/javascripts/jquery.scrollTo.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vendor_jquery_scrollTo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vendor_jquery_scrollTo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dropzone__ = __webpack_require__("../../../node_modules/dropzone/dist/dropzone.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mousetrap__ = __webpack_require__("../../../node_modules/mousetrap/mousetrap.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mousetrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mousetrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mousetrap_plugins_pause_mousetrap_pause__ = __webpack_require__("../../../node_modules/mousetrap/plugins/pause/mousetrap-pause.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mousetrap_plugins_pause_mousetrap_pause___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mousetrap_plugins_pause_mousetrap_pause__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable func-names, space-before-function-paren, wrap-iife, prefer-arrow-callback, no-unused-vars, consistent-return, camelcase, comma-dangle, max-len, class-methods-use-this */
/* global Mousetrap */

// Zen Mode (full screen) textarea
//
/*= provides zen_mode:enter */
/*= provides zen_mode:leave */






window.Dropzone = __WEBPACK_IMPORTED_MODULE_1_dropzone___default.a;

//
// ### Events
//
// `zen_mode:enter`
//
// Fired when the "Edit in fullscreen" link is clicked.
//
// **Synchronicity** Sync
// **Bubbles** Yes
// **Cancelable** No
// **Target** a.js-zen-enter
//
// `zen_mode:leave`
//
// Fired when the "Leave Fullscreen" link is clicked.
//
// **Synchronicity** Sync
// **Bubbles** Yes
// **Cancelable** No
// **Target** a.js-zen-leave
//

var ZenMode = function () {
  function ZenMode() {
    _classCallCheck(this, ZenMode);

    this.active_backdrop = null;
    this.active_textarea = null;
    $(document).on('click', '.js-zen-enter', function (e) {
      e.preventDefault();
      return $(e.currentTarget).trigger('zen_mode:enter');
    });
    $(document).on('click', '.js-zen-leave', function (e) {
      e.preventDefault();
      return $(e.currentTarget).trigger('zen_mode:leave');
    });
    $(document).on('zen_mode:enter', function (_this) {
      return function (e) {
        return _this.enter($(e.target).closest('.md-area').find('.zen-backdrop'));
      };
    }(this));
    $(document).on('zen_mode:leave', function (_this) {
      return function (e) {
        return _this.exit();
      };
    }(this));
    $(document).on('keydown', function (e) {
      // Esc
      if (e.keyCode === 27) {
        e.preventDefault();
        return $(document).trigger('zen_mode:leave');
      }
    });
  }

  _createClass(ZenMode, [{
    key: 'enter',
    value: function enter(backdrop) {
      Mousetrap.pause();
      this.active_backdrop = $(backdrop);
      this.active_backdrop.addClass('fullscreen');
      this.active_textarea = this.active_backdrop.find('textarea');
      // Prevent a user-resized textarea from persisting to fullscreen
      this.active_textarea.removeAttr('style');
      return this.active_textarea.focus();
    }
  }, {
    key: 'exit',
    value: function exit() {
      if (this.active_textarea) {
        Mousetrap.unpause();
        this.active_textarea.closest('.zen-backdrop').removeClass('fullscreen');
        this.scrollTo(this.active_textarea);
        this.active_textarea = null;
        this.active_backdrop = null;
        return __WEBPACK_IMPORTED_MODULE_1_dropzone___default.a.forElement('.div-dropzone').enable();
      }
    }
  }, {
    key: 'scrollTo',
    value: function scrollTo(zen_area) {
      return $.scrollTo(zen_area, 0, {
        offset: -150
      });
    }
  }]);

  return ZenMode;
}();

/* harmony default export */ __webpack_exports__["a"] = (ZenMode);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "ignored /var/cache/omnibus/src/gitlab-rails/node_modules/vue-resource/dist got":
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},["./main.js"]);


// WEBPACK FOOTER //
// main.9fd437d01962b50403f7.bundle.js